// US States -> Cities -> Zip Codes - hierarchical location data
// 51 states, 29648 cities, 41727 zip codes
export const US_LOCATIONS = {
  "AK": {
    "Adak": ["99546"],
    "Akiachak": ["99551"],
    "Akiak": ["99552"],
    "Akutan": ["99553"],
    "Alakanuk": ["99554"],
    "Aleknagik": ["99555"],
    "Allakaket": ["99720"],
    "Ambler": ["99786"],
    "Anaktuvuk Pass": ["99721"],
    "Anchor Point": ["99556"],
    "Anchorage": ["99501", "99502", "99503", "99504", "99507", "99508", "99509", "99510", "99511", "99513", "99514", "99515", "99516", "99517", "99518", "99519", "99520", "99521", "99522", "99523", "99524", "99529", "99530", "99599", "99695"],
    "Anderson": ["99744"],
    "Angoon": ["99820"],
    "Aniak": ["99557"],
    "Anvik": ["99558"],
    "Arctic Village": ["99722"],
    "Atka": ["99547"],
    "Atqasuk": ["99791"],
    "Auke Bay": ["99821"],
    "Barrow": ["99723"],
    "Beaver": ["99724"],
    "Bethel": ["99559"],
    "Bettles Field": ["99726"],
    "Big Lake": ["99652"],
    "Brevig Mission": ["99785"],
    "Buckland": ["99727"],
    "Cantwell": ["99729"],
    "Central": ["99730"],
    "Chalkyitsik": ["99788"],
    "Chefornak": ["99561"],
    "Chevak": ["99563"],
    "Chicken": ["99732"],
    "Chignik": ["99564"],
    "Chignik Lagoon": ["99565"],
    "Chignik Lake": ["99548"],
    "Chitina": ["99566"],
    "Chugiak": ["99567"],
    "Circle": ["99733"],
    "Clam Gulch": ["99568"],
    "Clarks Point": ["99569"],
    "Clear": ["99704"],
    "Coffman Cove": ["99918"],
    "Cold Bay": ["99571"],
    "Cooper Landing": ["99572"],
    "Copper Center": ["99573"],
    "Cordova": ["99574"],
    "Craig": ["99921"],
    "Crooked Creek": ["99575"],
    "Deering": ["99736"],
    "Delta Junction": ["99737"],
    "Denali National Park": ["99755"],
    "Dillingham": ["99576"],
    "Douglas": ["99824"],
    "Dutch Harbor": ["99692"],
    "Eagle": ["99738"],
    "Eagle River": ["99577"],
    "Eek": ["99578"],
    "Egegik": ["99579"],
    "Eielson AFB": ["99702"],
    "Ekwok": ["99580"],
    "Elfin Cove": ["99825"],
    "Elim": ["99739"],
    "Emmonak": ["99581"],
    "Ester": ["99725"],
    "Fairbanks": ["99701", "99706", "99707", "99708", "99709", "99710", "99711", "99712", "99775", "99790"],
    "False Pass": ["99583"],
    "Fort Greely": ["99731"],
    "Fort Wainwright": ["99703"],
    "Fort Yukon": ["99740"],
    "Gakona": ["99586"],
    "Galena": ["99741"],
    "Gambell": ["99742"],
    "Girdwood": ["99587"],
    "Glennallen": ["99588"],
    "Goodnews Bay": ["99589"],
    "Grayling": ["99590"],
    "Gustavus": ["99826"],
    "Haines": ["99827"],
    "Healy": ["99743"],
    "Holy Cross": ["99602"],
    "Homer": ["99603"],
    "Hoonah": ["99829"],
    "Hooper Bay": ["99604"],
    "Hope": ["99605"],
    "Houston": ["99694"],
    "Hughes": ["99745"],
    "Huslia": ["99746"],
    "Hydaburg": ["99922"],
    "Hyder": ["99923"],
    "Iliamna": ["99606"],
    "Indian": ["99540"],
    "Jber": ["99505", "99506"],
    "Juneau": ["99801", "99802", "99803", "99811", "99812", "99850"],
    "Kake": ["99830"],
    "Kaktovik": ["99747"],
    "Kalskag": ["99607"],
    "Kaltag": ["99748"],
    "Karluk": ["99608"],
    "Kasigluk": ["99609"],
    "Kasilof": ["99610"],
    "Kenai": ["99611"],
    "Ketchikan": ["99901", "99950"],
    "Kiana": ["99749"],
    "King Cove": ["99612"],
    "King Salmon": ["99613"],
    "Kipnuk": ["99614"],
    "Kivalina": ["99750"],
    "Klawock": ["99925"],
    "Kobuk": ["99751"],
    "Kodiak": ["99615", "99619", "99697"],
    "Kongiganak": ["99545"],
    "Kotlik": ["99620"],
    "Kotzebue": ["99752"],
    "Koyuk": ["99753"],
    "Koyukuk": ["99754"],
    "Kwethluk": ["99621"],
    "Kwigillingok": ["99622"],
    "Lake Minchumina": ["99757"],
    "Larsen Bay": ["99624"],
    "Levelock": ["99625"],
    "Lower Kalskag": ["99626"],
    "Manley Hot Springs": ["99756"],
    "Manokotak": ["99628"],
    "Marshall": ["99585"],
    "Mc Grath": ["99627"],
    "Mekoryuk": ["99630"],
    "Metlakatla": ["99926"],
    "Meyers Chuck": ["99903"],
    "Minto": ["99758"],
    "Moose Pass": ["99631"],
    "Mountain Village": ["99632"],
    "Naknek": ["99633"],
    "Napakiak": ["99634"],
    "Nenana": ["99760"],
    "New Stuyahok": ["99636"],
    "Nightmute": ["99690"],
    "Nikiski": ["99635"],
    "Nikolai": ["99691"],
    "Nikolski": ["99638"],
    "Ninilchik": ["99639"],
    "Noatak": ["99761"],
    "Nome": ["99762"],
    "Nondalton": ["99640"],
    "Noorvik": ["99763"],
    "North Pole": ["99705"],
    "Northway": ["99764"],
    "Nuiqsut": ["99789"],
    "Nulato": ["99765"],
    "Nunam Iqua": ["99666"],
    "Nunapitchuk": ["99641"],
    "Old Harbor": ["99643"],
    "Ouzinkie": ["99644"],
    "Palmer": ["99645"],
    "Pedro Bay": ["99647"],
    "Pelican": ["99832"],
    "Perryville": ["99648"],
    "Petersburg": ["99833"],
    "Pilot Point": ["99649"],
    "Pilot Station": ["99650"],
    "Platinum": ["99651"],
    "Point Baker": ["99927"],
    "Point Hope": ["99766"],
    "Point Lay": ["99759"],
    "Port Alexander": ["99836"],
    "Port Alsworth": ["99653"],
    "Port Heiden": ["99549"],
    "Port Lions": ["99550"],
    "Prudhoe Bay": ["99734"],
    "Quinhagak": ["99655"],
    "Rampart": ["99767"],
    "Red Devil": ["99656"],
    "Ruby": ["99768"],
    "Russian Mission": ["99657"],
    "Saint George Island": ["99591"],
    "Saint Marys": ["99658"],
    "Saint Michael": ["99659"],
    "Saint Paul Island": ["99660"],
    "Salcha": ["99714"],
    "Sand Point": ["99661"],
    "Savoonga": ["99769"],
    "Scammon Bay": ["99662"],
    "Selawik": ["99770"],
    "Seldovia": ["99663"],
    "Seward": ["99664"],
    "Shageluk": ["99665"],
    "Shaktoolik": ["99771"],
    "Shishmaref": ["99772"],
    "Shungnak": ["99773"],
    "Sitka": ["99835"],
    "Skagway": ["99840"],
    "Skwentna": ["99667"],
    "Sleetmute": ["99668"],
    "Soldotna": ["99669"],
    "South Naknek": ["99670"],
    "Stebbins": ["99671"],
    "Sterling": ["99672"],
    "Stevens Village": ["99774"],
    "Sutton": ["99674"],
    "Takotna": ["99675"],
    "Talkeetna": ["99676"],
    "Tanacross": ["99776"],
    "Tanana": ["99777"],
    "Tatitlek": ["99677"],
    "Teller": ["99778"],
    "Tenakee Springs": ["99841"],
    "Thorne Bay": ["99919"],
    "Togiak": ["99678"],
    "Tok": ["99779", "99780"],
    "Toksook Bay": ["99637"],
    "Trapper Creek": ["99683"],
    "Tuluksak": ["99679"],
    "Tuntutuliak": ["99680"],
    "Tununak": ["99681"],
    "Two Rivers": ["99716"],
    "Tyonek": ["99682"],
    "Unalakleet": ["99684"],
    "Unalaska": ["99685"],
    "Valdez": ["99686"],
    "Venetie": ["99781"],
    "Wainwright": ["99782"],
    "Wales": ["99783"],
    "Ward Cove": ["99928"],
    "Wasilla": ["99623", "99629", "99654", "99687"],
    "White Mountain": ["99784"],
    "Whittier": ["99693"],
    "Willow": ["99688"],
    "Wrangell": ["99929"],
    "Yakutat": ["99689"]
  },
  "AL": {
    "Abbeville": ["36310"],
    "Abernant": ["35440"],
    "Adamsville": ["35005"],
    "Addison": ["35540"],
    "Adger": ["35006"],
    "Akron": ["35441"],
    "Alabaster": ["35007", "35114"],
    "Alberta": ["36720"],
    "Albertville": ["35950", "35951"],
    "Alexander City": ["35010", "35011"],
    "Alexandria": ["36250"],
    "Aliceville": ["35442"],
    "Allgood": ["35013"],
    "Alpine": ["35014"],
    "Alton": ["35015"],
    "Altoona": ["35952"],
    "Andalusia": ["36420", "36421"],
    "Anderson": ["35610"],
    "Annemanie": ["36721"],
    "Anniston": ["36201", "36202", "36204", "36205", "36206", "36207", "36210"],
    "Arab": ["35016"],
    "Ardmore": ["35739"],
    "Ariton": ["36311"],
    "Arley": ["35541"],
    "Arlington": ["36722"],
    "Ashford": ["36312"],
    "Ashland": ["36251"],
    "Ashville": ["35953"],
    "Athens": ["35611", "35612", "35613", "35614"],
    "Atmore": ["36502", "36503", "36504"],
    "Attalla": ["35954"],
    "Auburn": ["36830", "36831", "36832"],
    "Auburn University": ["36849"],
    "Autaugaville": ["36003"],
    "Axis": ["36505"],
    "Baileyton": ["35019"],
    "Banks": ["36005"],
    "Bankston": ["35542"],
    "Bay Minette": ["36507"],
    "Bayou La Batre": ["36509"],
    "Bear Creek": ["35543"],
    "Beatrice": ["36425"],
    "Beaverton": ["35544"],
    "Belk": ["35545"],
    "Bellamy": ["36901"],
    "Belle Mina": ["35615"],
    "Bellwood": ["36313"],
    "Berry": ["35546"],
    "Bessemer": ["35020", "35021", "35022", "35023"],
    "Billingsley": ["36006"],
    "Birmingham": ["35201", "35202", "35203", "35204", "35205", "35206", "35207", "35208", "35209", "35210", "35211", "35212", "35213", "35214", "35215", "35216", "35217", "35218", "35219", "35220", "35221", "35222", "35223", "35224", "35225", "35226", "35228", "35229", "35230", "35231", "35232", "35233", "35234", "35235", "35236", "35237", "35238", "35240", "35242", "35243", "35244", "35245", "35246", "35249", "35253", "35254", "35255", "35259", "35260", "35261", "35263", "35266", "35270", "35277", "35278", "35279", "35280", "35281", "35282", "35283", "35285", "35286", "35287", "35288", "35289", "35290", "35291", "35292", "35293", "35294", "35295", "35296", "35297", "35298", "35299"],
    "Black": ["36314"],
    "Blountsville": ["35031"],
    "Boaz": ["35956", "35957"],
    "Boligee": ["35443"],
    "Bon Air": ["35032"],
    "Bon Secour": ["36511"],
    "Booth": ["36008"],
    "Boykin": ["36723"],
    "Brantley": ["36009"],
    "Bremen": ["35033"],
    "Brent": ["35034"],
    "Brewton": ["36426", "36427"],
    "Bridgeport": ["35740"],
    "Brierfield": ["35035"],
    "Brilliant": ["35548"],
    "Brooklyn": ["36429"],
    "Brookside": ["35036"],
    "Brookwood": ["35444"],
    "Brownsboro": ["35741"],
    "Brundidge": ["36010"],
    "Bryant": ["35958"],
    "Bucks": ["36512"],
    "Buhl": ["35446"],
    "Burnwell": ["35038"],
    "Butler": ["36904"],
    "Bynum": ["36253"],
    "Calera": ["35040"],
    "Calvert": ["36513"],
    "Camden": ["36726"],
    "Camp Hill": ["36850"],
    "Campbell": ["36727"],
    "Capshaw": ["35742"],
    "Carbon Hill": ["35549"],
    "Cardiff": ["35041"],
    "Carlton": ["36515"],
    "Carrollton": ["35447"],
    "Castleberry": ["36432"],
    "Catherine": ["36728"],
    "Cecil": ["36013"],
    "Cedar Bluff": ["35959"],
    "Centre": ["35960"],
    "Centreville": ["35042"],
    "Chancellor": ["36316"],
    "Chapman": ["36015"],
    "Chatom": ["36518"],
    "Chelsea": ["35043"],
    "Cherokee": ["35616"],
    "Childersburg": ["35044"],
    "Choccolocco": ["36254"],
    "Chunchula": ["36521"],
    "Citronelle": ["36522"],
    "Clanton": ["35045", "35046"],
    "Clay": ["35048"],
    "Clayton": ["36016"],
    "Cleveland": ["35049"],
    "Clinton": ["35448"],
    "Clio": ["36017"],
    "Clopton": ["36317"],
    "Cloverdale": ["35617"],
    "Coaling": ["35449"],
    "Coden": ["36523"],
    "Coffee Springs": ["36318"],
    "Coffeeville": ["36524"],
    "Coker": ["35452"],
    "Collinsville": ["35961"],
    "Columbia": ["36319"],
    "Columbiana": ["35051"],
    "Cook Springs": ["35052"],
    "Coosada": ["36020"],
    "Cordova": ["35550"],
    "Cottondale": ["35453"],
    "Cottonton": ["36851"],
    "Cottonwood": ["36320"],
    "Courtland": ["35618"],
    "Cowarts": ["36321"],
    "Coy": ["36435"],
    "Cragford": ["36255"],
    "Crane Hill": ["35053"],
    "Creola": ["36525"],
    "Cropwell": ["35054"],
    "Crossville": ["35962"],
    "Cuba": ["36907"],
    "Cullman": ["35055", "35056", "35057", "35058"],
    "Cusseta": ["36852"],
    "Dadeville": ["36853"],
    "Daleville": ["36322"],
    "Danville": ["35619"],
    "Daphne": ["36526", "36527"],
    "Dauphin Island": ["36528"],
    "Daviston": ["36256"],
    "Dawson": ["35963"],
    "De Armanville": ["36257"],
    "Deatsville": ["36022"],
    "Decatur": ["35601", "35602", "35603", "35609", "35699"],
    "Deer Park": ["36529"],
    "Delmar": ["35551"],
    "Delta": ["36258"],
    "Demopolis": ["36732"],
    "Detroit": ["35552"],
    "Dickinson": ["36436"],
    "Dixons Mills": ["36736"],
    "Docena": ["35060"],
    "Dolomite": ["35061"],
    "Dora": ["35062"],
    "Dothan": ["36301", "36302", "36303", "36304", "36305"],
    "Double Springs": ["35553"],
    "Douglas": ["35964"],
    "Dozier": ["36028"],
    "Duncanville": ["35456"],
    "Dutton": ["35744"],
    "East Tallassee": ["36023"],
    "Eastaboga": ["36260"],
    "Echola": ["35457"],
    "Eclectic": ["36024"],
    "Edwardsville": ["36261"],
    "Eight Mile": ["36613"],
    "Elba": ["36323"],
    "Elberta": ["36530"],
    "Eldridge": ["35554"],
    "Elkmont": ["35620"],
    "Elmore": ["36025"],
    "Elrod": ["35458"],
    "Emelle": ["35459"],
    "Empire": ["35063"],
    "Enterprise": ["36330", "36331"],
    "Epes": ["35460"],
    "Equality": ["36026"],
    "Estillfork": ["35745"],
    "Ethelsville": ["35461"],
    "Eufaula": ["36027", "36072"],
    "Eutaw": ["35462"],
    "Eva": ["35621"],
    "Evergreen": ["36401"],
    "Excel": ["36439"],
    "Fackler": ["35746"],
    "Fairfield": ["35064"],
    "Fairhope": ["36532", "36533"],
    "Falkville": ["35622"],
    "Faunsdale": ["36738"],
    "Fayette": ["35555"],
    "Fitzpatrick": ["36029"],
    "Five Points": ["36855"],
    "Flat Rock": ["35966"],
    "Flomaton": ["36441"],
    "Florala": ["36442"],
    "Florence": ["35630", "35631", "35632", "35633", "35634"],
    "Foley": ["36535", "36536"],
    "Forest Home": ["36030"],
    "Forkland": ["36740"],
    "Fort Davis": ["36031"],
    "Fort Deposit": ["36032"],
    "Fort Mitchell": ["36856"],
    "Fort Payne": ["35967", "35968"],
    "Fort Rucker": ["36362"],
    "Fosters": ["35463"],
    "Franklin": ["36444"],
    "Frankville": ["36538"],
    "Frisco City": ["36445"],
    "Fruitdale": ["36539"],
    "Fruithurst": ["36262"],
    "Fulton": ["36446"],
    "Fultondale": ["35068"],
    "Furman": ["36741"],
    "Fyffe": ["35971"],
    "Gadsden": ["35901", "35902", "35903", "35904", "35905", "35907"],
    "Gainestown": ["36540"],
    "Gainesville": ["35464"],
    "Gallant": ["35972"],
    "Gallion": ["36742"],
    "Gantt": ["36038"],
    "Garden City": ["35070"],
    "Gardendale": ["35071"],
    "Gaylesville": ["35973"],
    "Geneva": ["36340"],
    "Georgiana": ["36033"],
    "Geraldine": ["35974"],
    "Gilbertown": ["36908"],
    "Glen Allen": ["35559"],
    "Glenwood": ["36034"],
    "Goodsprings": ["35560"],
    "Goodwater": ["35072"],
    "Gordo": ["35466"],
    "Gordon": ["36343"],
    "Goshen": ["36035"],
    "Grady": ["36036"],
    "Graham": ["36263"],
    "Grand Bay": ["36541"],
    "Grant": ["35747"],
    "Graysville": ["35073"],
    "Green Pond": ["35074"],
    "Greensboro": ["36744"],
    "Greenville": ["36037"],
    "Grove Hill": ["36451"],
    "Groveoak": ["35975"],
    "Guin": ["35563"],
    "Gulf Shores": ["36542", "36547"],
    "Guntersville": ["35976"],
    "Gurley": ["35748"],
    "Hackleburg": ["35564"],
    "Haleyville": ["35565"],
    "Hamilton": ["35570"],
    "Hanceville": ["35077"],
    "Hardaway": ["36039"],
    "Harpersville": ["35078"],
    "Hartford": ["36344"],
    "Hartselle": ["35640"],
    "Harvest": ["35749"],
    "Hatchechubbee": ["36858"],
    "Hayden": ["35079"],
    "Hayneville": ["36040"],
    "Hazel Green": ["35750"],
    "Headland": ["36345"],
    "Heflin": ["36264"],
    "Helena": ["35080"],
    "Henagar": ["35978"],
    "Higdon": ["35979"],
    "Highland Home": ["36041"],
    "Hillsboro": ["35643"],
    "Hodges": ["35571"],
    "Hollins": ["35082"],
    "Holly Pond": ["35083"],
    "Hollytree": ["35751"],
    "Hollywood": ["35752"],
    "Holy Trinity": ["36859"],
    "Honoraville": ["36042"],
    "Hope Hull": ["36043"],
    "Horton": ["35980"],
    "Houston": ["35572"],
    "Huntsville": ["35801", "35802", "35803", "35804", "35805", "35806", "35807", "35808", "35809", "35810", "35811", "35812", "35813", "35814", "35815", "35816", "35824", "35893", "35894", "35895", "35896", "35897", "35898", "35899"],
    "Hurtsboro": ["36860"],
    "Huxford": ["36543"],
    "Ider": ["35981"],
    "Irvington": ["36544"],
    "Jachin": ["36910"],
    "Jack": ["36346"],
    "Jackson": ["36501", "36545"],
    "Jacksons Gap": ["36861"],
    "Jacksonville": ["36265"],
    "Jasper": ["35501", "35502", "35503", "35504"],
    "Jefferson": ["36745"],
    "Jemison": ["35085"],
    "Jones": ["36749"],
    "Joppa": ["35087"],
    "Kansas": ["35573"],
    "Kellerman": ["35468"],
    "Kellyton": ["35089"],
    "Kennedy": ["35574"],
    "Kent": ["36045"],
    "Killen": ["35645"],
    "Kimberly": ["35091"],
    "Kinston": ["36453"],
    "Knoxville": ["35469"],
    "Laceys Spring": ["35754"],
    "Lafayette": ["36862"],
    "Lanett": ["36863"],
    "Langston": ["35755"],
    "Lapine": ["36046"],
    "Lawley": ["36793"],
    "Leeds": ["35094"],
    "Leesburg": ["35983"],
    "Leighton": ["35646"],
    "Lenox": ["36454"],
    "Leroy": ["36548"],
    "Lester": ["35647"],
    "Letohatchee": ["36047"],
    "Lexington": ["35648"],
    "Lillian": ["36549"],
    "Lincoln": ["35096"],
    "Linden": ["36748"],
    "Lineville": ["36266"],
    "Lisman": ["36912"],
    "Little River": ["36550"],
    "Livingston": ["35470"],
    "Loachapoka": ["36865"],
    "Lockhart": ["36455"],
    "Locust Fork": ["35097"],
    "Logan": ["35098"],
    "Louisville": ["36048"],
    "Lower Peach Tree": ["36751"],
    "Lowndesboro": ["36752"],
    "Loxley": ["36551"],
    "Luverne": ["36049"],
    "Lynn": ["35575"],
    "Madison": ["35756", "35757", "35758"],
    "Magnolia": ["36754"],
    "Magnolia Springs": ["36555"],
    "Malcolm": ["36556"],
    "Malvern": ["36349"],
    "Maplesville": ["36750"],
    "Marbury": ["36051"],
    "Margaret": ["35112"],
    "Marion": ["36756"],
    "Marion Junction": ["36759"],
    "Mathews": ["36052"],
    "Mc Calla": ["35111"],
    "Mc Intosh": ["36553"],
    "Mc Kenzie": ["36456"],
    "Mc Shan": ["35471"],
    "Mc Williams": ["36753"],
    "Megargel": ["36457"],
    "Melvin": ["36913"],
    "Mentone": ["35984"],
    "Meridianville": ["35759"],
    "Mexia": ["36458"],
    "Midland City": ["36350"],
    "Midway": ["36053"],
    "Millbrook": ["36054"],
    "Millerville": ["36267"],
    "Millport": ["35576"],
    "Millry": ["36558"],
    "Minter": ["36761"],
    "Mobile": ["36601", "36602", "36603", "36604", "36605", "36606", "36607", "36608", "36609", "36610", "36611", "36612", "36615", "36616", "36617", "36618", "36619", "36621", "36622", "36625", "36628", "36630", "36633", "36640", "36641", "36644", "36652", "36660", "36663", "36670", "36671", "36675", "36685", "36688", "36689", "36690", "36691", "36693", "36695"],
    "Monroeville": ["36460", "36461", "36462"],
    "Montevallo": ["35115"],
    "Montgomery": ["36101", "36102", "36103", "36104", "36105", "36106", "36107", "36108", "36109", "36110", "36111", "36112", "36113", "36114", "36115", "36116", "36117", "36118", "36119", "36120", "36121", "36123", "36124", "36125", "36130", "36131", "36132", "36133", "36134", "36135", "36140", "36141", "36142", "36177", "36191"],
    "Montrose": ["36559"],
    "Moody": ["35004"],
    "Mooresville": ["35649"],
    "Morris": ["35116"],
    "Morvin": ["36762"],
    "Moulton": ["35650"],
    "Moundville": ["35474"],
    "Mount Hope": ["35651"],
    "Mount Meigs": ["36057"],
    "Mount Olive": ["35117"],
    "Mount Vernon": ["36560"],
    "Mulga": ["35118"],
    "Munford": ["36268"],
    "Muscadine": ["36269"],
    "Muscle Shoals": ["35661", "35662"],
    "Myrtlewood": ["36763"],
    "Nanafalia": ["36764"],
    "Natural Bridge": ["35577"],
    "Nauvoo": ["35578"],
    "Needham": ["36915"],
    "New Brockton": ["36351"],
    "New Castle": ["35119"],
    "New Hope": ["35760"],
    "New Market": ["35761"],
    "Newbern": ["36765"],
    "Newton": ["36352"],
    "Newville": ["36353"],
    "Normal": ["35762"],
    "Northport": ["35473", "35475", "35476"],
    "Notasulga": ["36866"],
    "Oak Hill": ["36766"],
    "Oakman": ["35579"],
    "Odenville": ["35120"],
    "Ohatchee": ["36271"],
    "Oneonta": ["35121"],
    "Opelika": ["36801", "36802", "36803", "36804"],
    "Opp": ["36467"],
    "Orange Beach": ["36561"],
    "Orrville": ["36767"],
    "Owens Cross Roads": ["35763"],
    "Oxford": ["36203"],
    "Ozark": ["36360", "36361"],
    "Paint Rock": ["35764"],
    "Palmerdale": ["35123"],
    "Panola": ["35477"],
    "Pansey": ["36370"],
    "Parrish": ["35580"],
    "Pelham": ["35124"],
    "Pell City": ["35125", "35128"],
    "Pennington": ["36916"],
    "Perdido": ["36562"],
    "Perdue Hill": ["36470"],
    "Perote": ["36061"],
    "Peterman": ["36471"],
    "Peterson": ["35478"],
    "Petrey": ["36062"],
    "Phenix City": ["36867", "36868", "36869", "36870"],
    "Phil Campbell": ["35581"],
    "Piedmont": ["36272"],
    "Pike Road": ["36064"],
    "Pinckard": ["36371"],
    "Pine Apple": ["36768"],
    "Pine Hill": ["36769"],
    "Pine Level": ["36065"],
    "Pinson": ["35126"],
    "Pisgah": ["35765"],
    "Pittsview": ["36871"],
    "Plantersville": ["36758"],
    "Pleasant Grove": ["35127"],
    "Point Clear": ["36564"],
    "Prattville": ["36066", "36067", "36068"],
    "Princeton": ["35766"],
    "Quinton": ["35130"],
    "Ragland": ["35131"],
    "Rainbow City": ["35906"],
    "Rainsville": ["35986"],
    "Ralph": ["35480"],
    "Ramer": ["36069"],
    "Ranburne": ["36273"],
    "Randolph": ["36792"],
    "Range": ["36473"],
    "Red Bay": ["35582"],
    "Red Level": ["36474"],
    "Reform": ["35481"],
    "Remlap": ["35133"],
    "Repton": ["36475"],
    "River Falls": ["36476"],
    "Riverside": ["35135"],
    "Roanoke": ["36274"],
    "Robertsdale": ["36567"],
    "Rockford": ["35136"],
    "Rogersville": ["35652"],
    "Russellville": ["35653", "35654"],
    "Rutledge": ["36071"],
    "Ryland": ["35767"],
    "Safford": ["36773"],
    "Saginaw": ["35137"],
    "Saint Elmo": ["36568"],
    "Saint Stephens": ["36569"],
    "Salem": ["36874"],
    "Samantha": ["35482"],
    "Samson": ["36477"],
    "Saraland": ["36571"],
    "Sardis": ["36775"],
    "Satsuma": ["36572"],
    "Sawyerville": ["36776"],
    "Sayre": ["35139"],
    "Scottsboro": ["35768", "35769"],
    "Seale": ["36875"],
    "Section": ["35771"],
    "Selma": ["36701", "36702", "36703"],
    "Seminole": ["36574"],
    "Semmes": ["36575"],
    "Shannon": ["35142"],
    "Sheffield": ["35660"],
    "Shelby": ["35143"],
    "Shorter": ["36075"],
    "Shorterville": ["36373"],
    "Silas": ["36919"],
    "Siluria": ["35144"],
    "Silverhill": ["36576"],
    "Sipsey": ["35584"],
    "Skipperville": ["36374"],
    "Slocomb": ["36375"],
    "Smiths Station": ["36877"],
    "Somerville": ["35670"],
    "Spanish Fort": ["36577"],
    "Spring Garden": ["36275"],
    "Springville": ["35146"],
    "Spruce Pine": ["35585"],
    "Stanton": ["36790"],
    "Stapleton": ["36578"],
    "Steele": ["35987"],
    "Sterrett": ["35147"],
    "Stevenson": ["35772"],
    "Stockton": ["36579"],
    "Sulligent": ["35586"],
    "Sumiton": ["35148"],
    "Summerdale": ["36580"],
    "Sunflower": ["36581"],
    "Sweet Water": ["36782"],
    "Sycamore": ["35149"],
    "Sylacauga": ["35150", "35151"],
    "Sylvania": ["35988"],
    "Talladega": ["35160", "35161"],
    "Tallassee": ["36078"],
    "Tanner": ["35671"],
    "Theodore": ["36582", "36590"],
    "Thomaston": ["36783"],
    "Thomasville": ["36784"],
    "Thorsby": ["35171"],
    "Tibbie": ["36583"],
    "Titus": ["36080"],
    "Toney": ["35773"],
    "Town Creek": ["35672"],
    "Townley": ["35587"],
    "Toxey": ["36921"],
    "Trafford": ["35172"],
    "Trenton": ["35774"],
    "Trinity": ["35673"],
    "Troy": ["36079", "36081", "36082"],
    "Trussville": ["35173"],
    "Tuscaloosa": ["35401", "35402", "35403", "35404", "35405", "35406", "35407", "35485", "35486", "35487"],
    "Tuscumbia": ["35674"],
    "Tuskegee": ["36083"],
    "Tuskegee Institute": ["36087", "36088"],
    "Tyler": ["36785"],
    "Union Grove": ["35175"],
    "Union Springs": ["36089"],
    "Uniontown": ["36786"],
    "Uriah": ["36449", "36480"],
    "Valhermoso Springs": ["35775"],
    "Valley": ["36854", "36872"],
    "Valley Head": ["35989"],
    "Vance": ["35490"],
    "Vandiver": ["35176"],
    "Verbena": ["36091"],
    "Vernon": ["35592"],
    "Vina": ["35593"],
    "Vincent": ["35178"],
    "Vinegar Bend": ["36584"],
    "Vinemont": ["35179"],
    "Vredenburgh": ["36481"],
    "Wadley": ["36276"],
    "Wagarville": ["36585"],
    "Walnut Grove": ["35990"],
    "Ward": ["36922"],
    "Warrior": ["35180"],
    "Waterloo": ["35677"],
    "Watson": ["35181"],
    "Wattsville": ["35182"],
    "Waverly": ["36879"],
    "Weaver": ["36277"],
    "Webb": ["36376"],
    "Wedowee": ["36278"],
    "Wellington": ["36279"],
    "Weogufka": ["35183"],
    "West Blocton": ["35184"],
    "West Greene": ["35491"],
    "Westover": ["35185"],
    "Wetumpka": ["36092", "36093"],
    "Whatley": ["36482"],
    "Wilmer": ["36587"],
    "Wilsonville": ["35186"],
    "Wilton": ["35187"],
    "Winfield": ["35594"],
    "Wing": ["36483"],
    "Woodland": ["36280"],
    "Woodstock": ["35188"],
    "Woodville": ["35776"],
    "York": ["36925"]
  },
  "AR": {
    "Adona": ["72001"],
    "Alexander": ["72002"],
    "Alicia": ["72410"],
    "Alix": ["72820"],
    "Alleene": ["71820"],
    "Alma": ["72921"],
    "Almyra": ["72003"],
    "Alpena": ["72611"],
    "Alpine": ["71920"],
    "Altheimer": ["72004"],
    "Altus": ["72821"],
    "Amagon": ["72005"],
    "Amity": ["71921"],
    "Antoine": ["71922"],
    "Arkadelphia": ["71923", "71998", "71999"],
    "Arkansas City": ["71630"],
    "Armorel": ["72310"],
    "Ash Flat": ["72513"],
    "Ashdown": ["71822"],
    "Atkins": ["72823"],
    "Aubrey": ["72311"],
    "Augusta": ["72006"],
    "Austin": ["72007"],
    "Avoca": ["72711"],
    "Bald Knob": ["72010"],
    "Banks": ["71631"],
    "Barling": ["72923"],
    "Barton": ["72312"],
    "Bassett": ["72313"],
    "Batesville": ["72501", "72503"],
    "Bauxite": ["72011"],
    "Bay": ["72411"],
    "Bearden": ["71720"],
    "Beaver": ["72613"],
    "Bee Branch": ["72013"],
    "Beebe": ["72012"],
    "Beech Grove": ["72412"],
    "Beedeville": ["72014"],
    "Beirne": ["71721"],
    "Bella Vista": ["72714", "72715"],
    "Belleville": ["72824"],
    "Ben Lomond": ["71823"],
    "Benton": ["72015", "72018", "72019", "72158"],
    "Bentonville": ["72712", "72713", "72716"],
    "Bergman": ["72615"],
    "Berryville": ["72616"],
    "Bexar": ["72515"],
    "Big Flat": ["72617"],
    "Bigelow": ["72016"],
    "Biggers": ["72413"],
    "Biscoe": ["72017"],
    "Bismarck": ["71929"],
    "Black Oak": ["72414"],
    "Black Rock": ["72415"],
    "Blevins": ["71825"],
    "Blue Mountain": ["72826"],
    "Bluff City": ["71722"],
    "Bluffton": ["72827"],
    "Blytheville": ["72315", "72316"],
    "Board Camp": ["71932"],
    "Boles": ["72926"],
    "Bonnerdale": ["71933"],
    "Bono": ["72416"],
    "Booneville": ["72927"],
    "Bradford": ["72020"],
    "Bradley": ["71826"],
    "Branch": ["72928"],
    "Brickeys": ["72320"],
    "Briggsville": ["72828"],
    "Brinkley": ["72021"],
    "Brockwell": ["72517"],
    "Brookland": ["72417"],
    "Bryant": ["72022", "72089"],
    "Buckner": ["71827"],
    "Bull Shoals": ["72619"],
    "Burdette": ["72321"],
    "Cabot": ["72023"],
    "Caddo Gap": ["71935"],
    "Caldwell": ["72322"],
    "Cale": ["71828"],
    "Calico Rock": ["72519"],
    "Calion": ["71724"],
    "Camden": ["71701", "71711"],
    "Camp": ["72520"],
    "Canehill": ["72717"],
    "Caraway": ["72419"],
    "Carlisle": ["72024"],
    "Carthage": ["71725"],
    "Casa": ["72025"],
    "Cash": ["72421"],
    "Casscoe": ["72026"],
    "Cave City": ["72521"],
    "Cave Springs": ["72718"],
    "Cecil": ["72930"],
    "Cedarville": ["72932"],
    "Center Ridge": ["72027"],
    "Centerton": ["72719"],
    "Centerville": ["72829"],
    "Charleston": ["72933"],
    "Charlotte": ["72522"],
    "Cherokee Village": ["72525", "72529"],
    "Cherry Valley": ["72324"],
    "Chester": ["72934"],
    "Chidester": ["71726"],
    "Choctaw": ["72028"],
    "Clarendon": ["72029"],
    "Clarkedale": ["72325"],
    "Clarkridge": ["72623"],
    "Clarksville": ["72830"],
    "Cleveland": ["72030"],
    "Clinton": ["72031"],
    "Coal Hill": ["72832"],
    "College Station": ["72053"],
    "Colt": ["72326"],
    "Columbus": ["71831"],
    "Combs": ["72721"],
    "Compton": ["72624"],
    "Concord": ["72523"],
    "Conway": ["72032", "72033", "72034", "72035"],
    "Cord": ["72524"],
    "Corning": ["72422"],
    "Cotter": ["72626"],
    "Cotton Plant": ["72036"],
    "Cove": ["71937"],
    "Coy": ["72037"],
    "Crawfordsville": ["72327"],
    "Crocketts Bluff": ["72038"],
    "Crossett": ["71635"],
    "Crumrod": ["72328"],
    "Curtis": ["71728"],
    "Cushman": ["72526"],
    "Damascus": ["72039"],
    "Danville": ["72833"],
    "Dardanelle": ["72834"],
    "Datto": ["72424"],
    "De Queen": ["71832"],
    "De Valls Bluff": ["72041"],
    "De Witt": ["72042"],
    "Decatur": ["72722"],
    "Deer": ["72628"],
    "Delaplaine": ["72425"],
    "Delaware": ["72835"],
    "Delight": ["71940"],
    "Dell": ["72426"],
    "Dennard": ["72629"],
    "Dermott": ["71638"],
    "Des Arc": ["72040"],
    "Desha": ["72527"],
    "Diamond City": ["72630"],
    "Diaz": ["72043"],
    "Dierks": ["71833"],
    "Doddridge": ["71834"],
    "Dolph": ["72528"],
    "Donaldson": ["71941"],
    "Dover": ["72837"],
    "Drasco": ["72530"],
    "Driver": ["72329"],
    "Dumas": ["71639"],
    "Dyer": ["72935"],
    "Dyess": ["72330"],
    "Earle": ["72331"],
    "Edgemont": ["72044"],
    "Edmondson": ["72332"],
    "Egypt": ["72427"],
    "El Dorado": ["71730", "71731", "71768"],
    "El Paso": ["72045"],
    "Elaine": ["72333"],
    "Elizabeth": ["72531"],
    "Elkins": ["72727"],
    "Elm Springs": ["72728"],
    "Emerson": ["71740"],
    "Emmet": ["71835"],
    "England": ["72046"],
    "Enola": ["72047"],
    "Ethel": ["72048"],
    "Etowah": ["72428"],
    "Eudora": ["71640"],
    "Eureka Springs": ["72631", "72632"],
    "Evansville": ["72729"],
    "Evening Shade": ["72532"],
    "Everton": ["72633"],
    "Fairfield Bay": ["72088"],
    "Farmington": ["72730"],
    "Fayetteville": ["72701", "72702", "72703", "72704"],
    "Fifty Six": ["72533"],
    "Fisher": ["72429"],
    "Flippin": ["72634"],
    "Floral": ["72534"],
    "Fordyce": ["71742"],
    "Foreman": ["71836"],
    "Forrest City": ["72335", "72336"],
    "Fort Smith": ["72901", "72902", "72903", "72904", "72905", "72906", "72908", "72913", "72914", "72916", "72917", "72918", "72919"],
    "Fouke": ["71837"],
    "Fountain Hill": ["71642"],
    "Fox": ["72051"],
    "Franklin": ["72536"],
    "Frenchmans Bayou": ["72338"],
    "Friendship": ["71942"],
    "Fulton": ["71838"],
    "Gamaliel": ["72537"],
    "Garfield": ["72732"],
    "Garland City": ["71839"],
    "Garner": ["72052"],
    "Gassville": ["72635"],
    "Gateway": ["72733"],
    "Genoa": ["71840"],
    "Gentry": ["72734"],
    "Gepp": ["72538"],
    "Gilbert": ["72636"],
    "Gillett": ["72055"],
    "Gillham": ["71841"],
    "Gilmore": ["72339"],
    "Glencoe": ["72539"],
    "Glenwood": ["71943"],
    "Goodwin": ["72340"],
    "Goshen": ["72735"],
    "Gosnell": ["72319"],
    "Gould": ["71643"],
    "Grady": ["71644"],
    "Grannis": ["71944"],
    "Grapevine": ["72057"],
    "Gravelly": ["72838"],
    "Gravette": ["72736"],
    "Green Forest": ["72638"],
    "Greenbrier": ["72058"],
    "Greenland": ["72737"],
    "Greenway": ["72430"],
    "Greenwood": ["72936"],
    "Gregory": ["72059"],
    "Griffithville": ["72060"],
    "Grubbs": ["72431"],
    "Guion": ["72540"],
    "Gurdon": ["71743"],
    "Guy": ["72061"],
    "Hackett": ["72937"],
    "Hagarville": ["72839"],
    "Hamburg": ["71646"],
    "Hampton": ["71744"],
    "Hardy": ["72542"],
    "Harrell": ["71745"],
    "Harriet": ["72639"],
    "Harrisburg": ["72432"],
    "Harrison": ["72601", "72602"],
    "Hartford": ["72938"],
    "Hartman": ["72840"],
    "Harvey": ["72841"],
    "Hasty": ["72640"],
    "Hatfield": ["71945"],
    "Hattieville": ["72063"],
    "Havana": ["72842"],
    "Haynes": ["72341"],
    "Hazen": ["72064"],
    "Heber Springs": ["72543", "72545"],
    "Hector": ["72843"],
    "Helena": ["72342"],
    "Henderson": ["72544"],
    "Hensley": ["72065"],
    "Hermitage": ["71647"],
    "Heth": ["72346"],
    "Hickory Plains": ["72066"],
    "Hickory Ridge": ["72347"],
    "Higden": ["72067"],
    "Higginson": ["72068"],
    "Hindsville": ["72738"],
    "Hiwasse": ["72739"],
    "Holly Grove": ["72069"],
    "Hope": ["71801", "71802"],
    "Horatio": ["71842"],
    "Horseshoe Bend": ["72512"],
    "Hot Springs National Park": ["71901", "71902", "71903", "71913", "71914", "71951"],
    "Hot Springs Village": ["71909", "71910"],
    "Houston": ["72070"],
    "Hoxie": ["72433"],
    "Hughes": ["72348"],
    "Humnoke": ["72072"],
    "Humphrey": ["72073"],
    "Hunter": ["72074"],
    "Huntington": ["72940"],
    "Huntsville": ["72740"],
    "Huttig": ["71747"],
    "Ida": ["72546"],
    "Imboden": ["72434"],
    "Ivan": ["71748"],
    "Jacksonport": ["72075"],
    "Jacksonville": ["72076", "72078"],
    "Jasper": ["72641"],
    "Jefferson": ["72079"],
    "Jersey": ["71651"],
    "Jerusalem": ["72080"],
    "Jessieville": ["71949"],
    "Johnson": ["72741"],
    "Joiner": ["72350"],
    "Jones Mill": ["72105"],
    "Jonesboro": ["72401", "72402", "72403", "72404", "72405"],
    "Judsonia": ["72081"],
    "Junction City": ["71749"],
    "Keiser": ["72351"],
    "Kensett": ["72082"],
    "Keo": ["72083"],
    "Kingsland": ["71652"],
    "Kingston": ["72742"],
    "Kirby": ["71950"],
    "Knobel": ["72435"],
    "Knoxville": ["72845"],
    "La Grange": ["72352"],
    "Lafe": ["72436"],
    "Lake City": ["72437"],
    "Lake Village": ["71653"],
    "Lakeview": ["72642"],
    "Lamar": ["72846"],
    "Lambrook": ["72353"],
    "Laneburg": ["71844"],
    "Langley": ["71952"],
    "Lavaca": ["72941"],
    "Lawson": ["71750"],
    "Leachville": ["72438"],
    "Lead Hill": ["72644"],
    "Leola": ["72084"],
    "Lepanto": ["72354"],
    "Leslie": ["72645"],
    "Letona": ["72085"],
    "Lewisville": ["71845"],
    "Lexa": ["72355"],
    "Light": ["72439"],
    "Lincoln": ["72744"],
    "Little Rock": ["72201", "72202", "72203", "72204", "72205", "72206", "72207", "72209", "72210", "72211", "72212", "72214", "72215", "72216", "72217", "72219", "72221", "72222", "72223", "72225", "72227", "72231", "72255", "72260", "72295"],
    "Little Rock Air Force Base": ["72099"],
    "Lockesburg": ["71846"],
    "Locust Grove": ["72550"],
    "London": ["72847"],
    "Lonoke": ["72086"],
    "Lonsdale": ["72087"],
    "Louann": ["71751"],
    "Lowell": ["72745"],
    "Luxora": ["72358"],
    "Lynn": ["72440"],
    "Mabelvale": ["72103"],
    "Madison": ["72359"],
    "Magazine": ["72943"],
    "Magness": ["72553"],
    "Magnolia": ["71753", "71754"],
    "Malvern": ["72104"],
    "Mammoth Spring": ["72554"],
    "Manila": ["72442"],
    "Mansfield": ["72944"],
    "Marble Falls": ["72648"],
    "Marcella": ["72555"],
    "Marianna": ["72360"],
    "Marion": ["72364"],
    "Marked Tree": ["72365"],
    "Marmaduke": ["72443"],
    "Marshall": ["72650"],
    "Marvell": ["72366"],
    "Maumelle": ["72113"],
    "Mayflower": ["72106"],
    "Maynard": ["72444"],
    "Maysville": ["72747"],
    "Mc Caskill": ["71847"],
    "Mc Crory": ["72101", "72189"],
    "Mc Dougal": ["72441"],
    "Mc Gehee": ["71654"],
    "Mc Neil": ["71752"],
    "Mc Rae": ["72102"],
    "Melbourne": ["72556"],
    "Mellwood": ["72367"],
    "Mena": ["71953"],
    "Menifee": ["72107"],
    "Midland": ["72945"],
    "Midway": ["72651"],
    "Mineral Springs": ["71851"],
    "Minturn": ["72445"],
    "Monette": ["72447"],
    "Monroe": ["72108"],
    "Monticello": ["71655", "71656", "71657"],
    "Montrose": ["71658"],
    "Moro": ["72368"],
    "Morrilton": ["72110"],
    "Morrow": ["72749"],
    "Moscow": ["71659"],
    "Mount Holly": ["71758"],
    "Mount Ida": ["71957"],
    "Mount Judea": ["72655"],
    "Mount Pleasant": ["72561"],
    "Mount Vernon": ["72111"],
    "Mountain Home": ["72653", "72654"],
    "Mountain Pine": ["71956"],
    "Mountain View": ["72560"],
    "Mountainburg": ["72946"],
    "Mulberry": ["72947"],
    "Murfreesboro": ["71958"],
    "Nashville": ["71852"],
    "Natural Dam": ["72948"],
    "New Blaine": ["72851"],
    "New Edinburg": ["71660"],
    "Newark": ["72562"],
    "Newhope": ["71959"],
    "Newport": ["72112"],
    "Norfork": ["72658", "72659"],
    "Norman": ["71960"],
    "Norphlet": ["71759"],
    "North Little Rock": ["72114", "72115", "72116", "72117", "72118", "72119", "72124", "72190", "72198", "72199"],
    "O Kean": ["72449"],
    "Oak Grove": ["72660"],
    "Oakland": ["72661"],
    "Oark": ["72852"],
    "Oden": ["71961", "71966"],
    "Ogden": ["71853"],
    "Oil Trough": ["72564"],
    "Okolona": ["71962"],
    "Ola": ["72853"],
    "Omaha": ["72662"],
    "Oneida": ["72369"],
    "Onia": ["72663"],
    "Osceola": ["72370"],
    "Oxford": ["72565"],
    "Ozan": ["71855"],
    "Ozark": ["72949"],
    "Ozone": ["72854"],
    "Palestine": ["72372"],
    "Pangburn": ["72121"],
    "Paragould": ["72450", "72451"],
    "Paris": ["72855"],
    "Parkdale": ["71661"],
    "Parkin": ["72373"],
    "Parks": ["72950"],
    "Paron": ["72122"],
    "Parthenon": ["72666"],
    "Patterson": ["72123"],
    "Pea Ridge": ["72751"],
    "Peach Orchard": ["72453"],
    "Pearcy": ["71964"],
    "Peel": ["72668"],
    "Pelsor": ["72856"],
    "Pencil Bluff": ["71965"],
    "Perry": ["72125"],
    "Perryville": ["72126"],
    "Pettigrew": ["72752"],
    "Pickens": ["71662"],
    "Piggott": ["72454"],
    "Pindall": ["72669"],
    "Pine Bluff": ["71601", "71603", "71611", "71613"],
    "Pineville": ["72566"],
    "Plainview": ["72857"],
    "Pleasant Grove": ["72567"],
    "Pleasant Plains": ["72568"],
    "Plumerville": ["72127"],
    "Pocahontas": ["72455"],
    "Pollard": ["72456"],
    "Ponca": ["72670"],
    "Poplar Grove": ["72374"],
    "Portia": ["72457"],
    "Portland": ["71663"],
    "Pottsville": ["72858"],
    "Poughkeepsie": ["72569"],
    "Powhatan": ["72458"],
    "Poyen": ["72128"],
    "Prairie Grove": ["72753"],
    "Prattsville": ["72129"],
    "Prescott": ["71857"],
    "Prim": ["72130"],
    "Proctor": ["72376"],
    "Pyatt": ["72672"],
    "Quitman": ["72131"],
    "Ratcliff": ["72951"],
    "Ravenden": ["72459"],
    "Ravenden Springs": ["72460"],
    "Rector": ["72461"],
    "Redfield": ["72132"],
    "Reydell": ["72133"],
    "Reyno": ["72462"],
    "Rison": ["71665"],
    "Rivervale": ["72377"],
    "Roe": ["72134"],
    "Rogers": ["72756", "72757", "72758"],
    "Rohwer": ["71666"],
    "Roland": ["72135"],
    "Romance": ["72136"],
    "Rose Bud": ["72137"],
    "Rosie": ["72571"],
    "Rosston": ["71858"],
    "Rover": ["72860"],
    "Royal": ["71968"],
    "Rudy": ["72952"],
    "Russell": ["72139"],
    "Russellville": ["72801", "72802", "72811", "72812"],
    "Saffell": ["72572"],
    "Sage": ["72573"],
    "Saint Charles": ["72140"],
    "Saint Francis": ["72464"],
    "Saint Joe": ["72675"],
    "Saint Paul": ["72760"],
    "Salado": ["72575"],
    "Salem": ["72576"],
    "Saratoga": ["71859"],
    "Scotland": ["72141"],
    "Scott": ["72142"],
    "Scranton": ["72863"],
    "Searcy": ["72143", "72145", "72149"],
    "Sedgwick": ["72465"],
    "Sheridan": ["72150"],
    "Sherrill": ["72152"],
    "Sherwood": ["72120"],
    "Shirley": ["72153"],
    "Sidney": ["72577"],
    "Siloam Springs": ["72761"],
    "Sims": ["71969"],
    "Smackover": ["71762"],
    "Smithville": ["72466"],
    "Snow Lake": ["72379"],
    "Solgohachia": ["72156"],
    "Sparkman": ["71763"],
    "Springdale": ["72762", "72764", "72765", "72766"],
    "Springfield": ["72157"],
    "Stamps": ["71860"],
    "Star City": ["71667"],
    "State University": ["72467"],
    "Stephens": ["71764"],
    "Story": ["71970"],
    "Strawberry": ["72469"],
    "Strong": ["71765"],
    "Sturkie": ["72578"],
    "Stuttgart": ["72160"],
    "Subiaco": ["72865"],
    "Success": ["72470"],
    "Sulphur Rock": ["72579"],
    "Sulphur Springs": ["72768"],
    "Summers": ["72769"],
    "Summit": ["72677"],
    "Sweet Home": ["72164"],
    "Swifton": ["72471"],
    "Taylor": ["71861"],
    "Texarkana": ["71854"],
    "Thida": ["72165"],
    "Thornton": ["71766"],
    "Tichnor": ["72166"],
    "Tillar": ["71670"],
    "Tilly": ["72679"],
    "Timbo": ["72657", "72680"],
    "Tontitown": ["72770"],
    "Traskwood": ["72167"],
    "Trumann": ["72472"],
    "Tucker": ["72168"],
    "Tuckerman": ["72473"],
    "Tumbling Shoals": ["72581"],
    "Tupelo": ["72169"],
    "Turner": ["72383"],
    "Turrell": ["72384"],
    "Tyronza": ["72386"],
    "Ulm": ["72170"],
    "Umpire": ["71971"],
    "Uniontown": ["72955"],
    "Valley Springs": ["72682"],
    "Van Buren": ["72956", "72957"],
    "Vandervoort": ["71972"],
    "Vanndale": ["72387"],
    "Vendor": ["72683"],
    "Vilonia": ["72173"],
    "Viola": ["72583"],
    "Violet Hill": ["72584"],
    "Wabash": ["72389"],
    "Wabbaseka": ["72175"],
    "Walcott": ["72474"],
    "Waldenburg": ["72475"],
    "Waldo": ["71770"],
    "Waldron": ["72958"],
    "Walnut Ridge": ["72476"],
    "Ward": ["72176"],
    "Warm Springs": ["72478"],
    "Warren": ["71671"],
    "Washington": ["71862"],
    "Watson": ["71674"],
    "Weiner": ["72479"],
    "Wesley": ["72773"],
    "West Fork": ["72774"],
    "West Helena": ["72390"],
    "West Memphis": ["72301", "72303"],
    "West Point": ["72178"],
    "West Ridge": ["72391"],
    "Western Grove": ["72685"],
    "Wheatley": ["72392"],
    "Whelen Springs": ["71772"],
    "White Hall": ["71602", "71612"],
    "Wickes": ["71973"],
    "Wideman": ["72585"],
    "Widener": ["72394"],
    "Wilburn": ["72179"],
    "Williford": ["72482"],
    "Willisville": ["71864"],
    "Wilmar": ["71675"],
    "Wilmot": ["71676"],
    "Wilson": ["72395"],
    "Wilton": ["71865"],
    "Winchester": ["71677"],
    "Winslow": ["72959"],
    "Winthrop": ["71866"],
    "Wiseman": ["72587"],
    "Witter": ["72776"],
    "Witts Springs": ["72686"],
    "Woodson": ["72180"],
    "Wooster": ["72181"],
    "Wright": ["72182"],
    "Wrightsville": ["72183"],
    "Wynne": ["72396"],
    "Yellville": ["72687"],
    "Yorktown": ["71678"]
  },
  "AZ": {
    "Aguila": ["85320"],
    "Ajo": ["85321"],
    "Alpine": ["85920"],
    "Amado": ["85645"],
    "Apache Junction": ["85117", "85119", "85120", "85178", "85217", "85218", "85219", "85220", "85278", "85290"],
    "Arivaca": ["85601"],
    "Arizona City": ["85123", "85223"],
    "Arlington": ["85322"],
    "Ash Fork": ["86320"],
    "Avondale": ["85323", "85392"],
    "Bagdad": ["86321"],
    "Bapchule": ["85121", "85221"],
    "Bellemont": ["86015"],
    "Benson": ["85602"],
    "Bisbee": ["85603"],
    "Black Canyon City": ["85324"],
    "Blue": ["85922"],
    "Blue Gap": ["86520"],
    "Bouse": ["85325"],
    "Bowie": ["85605"],
    "Buckeye": ["85326", "85396"],
    "Bullhead City": ["86429", "86430", "86439", "86442"],
    "Bylas": ["85530"],
    "Cameron": ["86020"],
    "Camp Verde": ["86322"],
    "Carefree": ["85377"],
    "Casa Grande": ["85122", "85130", "85193", "85194", "85222", "85230", "85293", "85294"],
    "Cashion": ["85329"],
    "Catalina": ["85738"],
    "Cave Creek": ["85327", "85331"],
    "Central": ["85531"],
    "Chambers": ["86502"],
    "Chandler": ["85224", "85225", "85226", "85244", "85246", "85248", "85249", "85286"],
    "Chandler Heights": ["85127", "85227"],
    "Chinle": ["86503"],
    "Chino Valley": ["86323"],
    "Chloride": ["86431"],
    "Cibecue": ["85911"],
    "Cibola": ["85328"],
    "Clarkdale": ["86324"],
    "Clay Springs": ["85923"],
    "Claypool": ["85532"],
    "Clifton": ["85533"],
    "Cochise": ["85606"],
    "Colorado City": ["86021"],
    "Concho": ["85924"],
    "Congress": ["85332"],
    "Coolidge": ["85128", "85228"],
    "Cornville": ["86325"],
    "Cortaro": ["85652"],
    "Cottonwood": ["86326"],
    "Crown King": ["86343"],
    "Dateland": ["85333"],
    "Dennehotso": ["86535"],
    "Dewey": ["86327"],
    "Dolan Springs": ["86441"],
    "Douglas": ["85607", "85608", "85655", "86555"],
    "Dragoon": ["85609"],
    "Duncan": ["85534"],
    "Eagar": ["85925"],
    "Eden": ["85535"],
    "Ehrenberg": ["85334"],
    "El Mirage": ["85335"],
    "Elfrida": ["85610"],
    "Elgin": ["85611"],
    "Eloy": ["85131", "85231"],
    "Flagstaff": ["86001", "86002", "86003", "86004", "86005", "86011"],
    "Florence": ["85132", "85232", "85279"],
    "Forest Lakes": ["85931"],
    "Fort Apache": ["85926"],
    "Fort Defiance": ["86504"],
    "Fort Huachuca": ["85613", "85670"],
    "Fort Mcdowell": ["85264"],
    "Fort Mohave": ["86426", "86427"],
    "Fort Thomas": ["85536"],
    "Fountain Hills": ["85268", "85269"],
    "Fredonia": ["86022"],
    "Ganado": ["86505"],
    "Gila Bend": ["85337"],
    "Gilbert": ["85233", "85234", "85295", "85296", "85297", "85298", "85299"],
    "Glendale": ["85301", "85302", "85303", "85304", "85305", "85306", "85307", "85308", "85310", "85311", "85312", "85313", "85318"],
    "Globe": ["85501", "85502"],
    "Gold Canyon": ["85118"],
    "Golden Valley": ["86413"],
    "Goodyear": ["85338", "85395"],
    "Grand Canyon": ["86023"],
    "Gray Mountain": ["86016"],
    "Green Valley": ["85614", "85622"],
    "Greer": ["85927"],
    "Hackberry": ["86411"],
    "Happy Jack": ["86024"],
    "Hayden": ["85135", "85235"],
    "Heber": ["85928"],
    "Hereford": ["85615"],
    "Higley": ["85236"],
    "Holbrook": ["86025"],
    "Hotevilla": ["86030"],
    "Houck": ["86506"],
    "Huachuca City": ["85616"],
    "Hualapai": ["86412"],
    "Humboldt": ["86329"],
    "Indian Wells": ["86031"],
    "Jerome": ["86331"],
    "Joseph City": ["86032"],
    "Kaibeto": ["86053"],
    "Kayenta": ["86033"],
    "Keams Canyon": ["86034"],
    "Kearny": ["85137", "85237"],
    "Kingman": ["86401", "86402", "86409"],
    "Kirkland": ["86332"],
    "Kykotsmovi Village": ["86039"],
    "Lake Havasu City": ["86403", "86404", "86405", "86406"],
    "Lake Montezuma": ["86342"],
    "Lakeside": ["85929"],
    "Laveen": ["85339"],
    "Leupp": ["86035"],
    "Litchfield Park": ["85340"],
    "Littlefield": ["86432"],
    "Lukachukai": ["86507"],
    "Luke Air Force Base": ["85309"],
    "Lukeville": ["85341"],
    "Lupton": ["86508"],
    "Mammoth": ["85618"],
    "Many Farms": ["86538"],
    "Marana": ["85653", "85658"],
    "Marble Canyon": ["86036"],
    "Maricopa": ["85138", "85139", "85238", "85239"],
    "Mayer": ["86333"],
    "Mc Neal": ["85617"],
    "Mcnary": ["85930"],
    "Meadview": ["86444"],
    "Mesa": ["85201", "85202", "85203", "85204", "85205", "85206", "85207", "85208", "85209", "85210", "85211", "85212", "85213", "85214", "85215", "85216", "85274", "85275", "85277"],
    "Miami": ["85539"],
    "Mohave Valley": ["86440", "86446"],
    "Morenci": ["85540"],
    "Mormon Lake": ["86038"],
    "Morristown": ["85342"],
    "Mount Lemmon": ["85619"],
    "Munds Park": ["86017"],
    "Naco": ["85620"],
    "Nazlini": ["86540"],
    "New River": ["85087"],
    "Nogales": ["85621", "85628", "85662"],
    "North Rim": ["86052"],
    "Nutrioso": ["85932"],
    "Oatman": ["86433"],
    "Oracle": ["85623"],
    "Overgaard": ["85933"],
    "Page": ["86040"],
    "Palo Verde": ["85343"],
    "Paradise Valley": ["85253"],
    "Parker": ["85344"],
    "Parks": ["86018"],
    "Patagonia": ["85624"],
    "Paulden": ["86334"],
    "Payson": ["85541", "85547"],
    "Peach Springs": ["86434"],
    "Pearce": ["85625"],
    "Peoria": ["85345", "85380", "85381", "85382", "85383", "85385"],
    "Peridot": ["85542"],
    "Petrified Forest Natl Pk": ["86028"],
    "Phoenix": ["85001", "85002", "85003", "85004", "85005", "85006", "85007", "85008", "85009", "85010", "85011", "85012", "85013", "85014", "85015", "85016", "85017", "85018", "85019", "85020", "85021", "85022", "85023", "85024", "85025", "85026", "85027", "85028", "85029", "85030", "85031", "85032", "85033", "85034", "85035", "85036", "85037", "85038", "85039", "85040", "85041", "85042", "85043", "85044", "85045", "85046", "85048", "85050", "85051", "85053", "85054", "85055", "85060", "85061", "85062", "85063", "85064", "85065", "85066", "85067", "85068", "85069", "85070", "85071", "85072", "85073", "85074", "85075", "85076", "85077", "85078", "85079", "85080", "85082", "85083", "85085", "85086", "85096", "85097", "85098", "85099"],
    "Picacho": ["85141", "85241"],
    "Pima": ["85543"],
    "Pine": ["85544"],
    "Pinedale": ["85934"],
    "Pinetop": ["85935"],
    "Pinon": ["86510"],
    "Pirtleville": ["85626"],
    "Polacca": ["86042"],
    "Pomerene": ["85627"],
    "Poston": ["85371"],
    "Prescott": ["86301", "86302", "86303", "86304", "86305", "86313", "86330"],
    "Prescott Valley": ["86312", "86314", "86315"],
    "Quartzsite": ["85346", "85359"],
    "Queen Creek": ["85142", "85240", "85242", "85243"],
    "Red Rock": ["85145", "85245"],
    "Red Valley": ["86544"],
    "Rillito": ["85654"],
    "Rimrock": ["86335"],
    "Rio Rico": ["85648"],
    "Rio Verde": ["85263"],
    "Rock Point": ["86545"],
    "Roll": ["85347"],
    "Roosevelt": ["85545"],
    "Round Rock": ["86547"],
    "Sacaton": ["85147", "85247"],
    "Safford": ["85546", "85548"],
    "Sahuarita": ["85629"],
    "Saint David": ["85630"],
    "Saint Johns": ["85936"],
    "Saint Michaels": ["86511"],
    "Salome": ["85348"],
    "San Carlos": ["85550"],
    "San Luis": ["85336", "85349"],
    "San Manuel": ["85631"],
    "San Simon": ["85632"],
    "San Tan Valley": ["85140", "85143"],
    "Sanders": ["86512"],
    "Sasabe": ["85633"],
    "Scottsdale": ["85250", "85251", "85252", "85254", "85255", "85256", "85257", "85258", "85259", "85260", "85261", "85262", "85266", "85267", "85271"],
    "Second Mesa": ["86043"],
    "Sedona": ["86336", "86339", "86340", "86341", "86351"],
    "Seligman": ["86337"],
    "Sells": ["85634"],
    "Shonto": ["86054"],
    "Show Low": ["85901", "85902"],
    "Sierra Vista": ["85635", "85636", "85650", "85671"],
    "Skull Valley": ["86338"],
    "Snowflake": ["85937"],
    "Solomon": ["85551"],
    "Somerton": ["85350"],
    "Sonoita": ["85637"],
    "Springerville": ["85938"],
    "Stanfield": ["85172", "85272"],
    "Sun City": ["85351", "85372", "85373"],
    "Sun City West": ["85375", "85376"],
    "Sun Valley": ["86029"],
    "Supai": ["86435"],
    "Superior": ["85173", "85273"],
    "Surprise": ["85374", "85378", "85379", "85387", "85388"],
    "Tacna": ["85352"],
    "Taylor": ["85939"],
    "Teec Nos Pos": ["86514"],
    "Tempe": ["85280", "85281", "85282", "85283", "85284", "85285", "85287", "85288", "85289"],
    "Temple Bar Marina": ["86443"],
    "Thatcher": ["85552"],
    "Tolleson": ["85353"],
    "Tombstone": ["85638"],
    "Tonalea": ["86044"],
    "Tonopah": ["85354"],
    "Tonto Basin": ["85553"],
    "Topawa": ["85639"],
    "Topock": ["86436"],
    "Tortilla Flat": ["85190"],
    "Tsaile": ["86556"],
    "Tuba City": ["86045"],
    "Tubac": ["85646"],
    "Tucson": ["85701", "85702", "85703", "85704", "85705", "85706", "85707", "85708", "85709", "85710", "85711", "85712", "85713", "85714", "85715", "85716", "85717", "85718", "85719", "85720", "85721", "85722", "85723", "85724", "85725", "85726", "85728", "85730", "85731", "85732", "85733", "85734", "85735", "85736", "85737", "85739", "85740", "85741", "85742", "85743", "85744", "85745", "85746", "85747", "85748", "85749", "85750", "85751", "85752", "85754", "85755", "85756", "85757", "85775", "85777"],
    "Tumacacori": ["85640"],
    "Vail": ["85641"],
    "Valentine": ["86437"],
    "Valley Farms": ["85191", "85291"],
    "Vernon": ["85940"],
    "Waddell": ["85355"],
    "Wellton": ["85356"],
    "Wenden": ["85357"],
    "White Mountain Lake": ["85912"],
    "Whiteriver": ["85941"],
    "Wickenburg": ["85358", "85390"],
    "Wikieup": ["85360"],
    "Willcox": ["85643", "85644"],
    "Williams": ["86046"],
    "Willow Beach": ["86445"],
    "Window Rock": ["86515"],
    "Winkelman": ["85192", "85292"],
    "Winslow": ["86047"],
    "Wittmann": ["85361"],
    "Woodruff": ["85942"],
    "Yarnell": ["85362"],
    "Young": ["85554"],
    "Youngtown": ["85363"],
    "Yucca": ["86438"],
    "Yuma": ["85364", "85365", "85366", "85367", "85369"]
  },
  "CA": {
    "Acampo": ["95220"],
    "Acton": ["93510"],
    "Adelanto": ["92301"],
    "Adin": ["96006"],
    "Agoura Hills": ["91301", "91376"],
    "Aguanga": ["92536"],
    "Ahwahnee": ["93601"],
    "Alameda": ["94501", "94502"],
    "Alamo": ["94507"],
    "Albany": ["94706"],
    "Albion": ["95410"],
    "Alderpoint": ["95511"],
    "Alhambra": ["91801", "91802", "91803", "91804", "91841", "91896", "91899"],
    "Aliso Viejo": ["92656", "92698"],
    "Alleghany": ["95910"],
    "Alpaugh": ["93201"],
    "Alpine": ["91901", "91903"],
    "Alta": ["95701"],
    "Altadena": ["91001", "91003"],
    "Altaville": ["95221"],
    "Alturas": ["96101"],
    "Alviso": ["95002"],
    "Amador City": ["95601"],
    "Amboy": ["92304"],
    "American Canyon": ["94503"],
    "Anaheim": ["92801", "92802", "92803", "92804", "92805", "92806", "92807", "92808", "92809", "92812", "92814", "92815", "92816", "92817", "92825", "92850", "92899"],
    "Anderson": ["96007"],
    "Angels Camp": ["95222"],
    "Angelus Oaks": ["92305"],
    "Angwin": ["94508"],
    "Annapolis": ["95412"],
    "Antelope": ["95843"],
    "Antioch": ["94509", "94531"],
    "Anza": ["92539"],
    "Apple Valley": ["92307", "92308"],
    "Applegate": ["95703"],
    "Aptos": ["95001", "95003"],
    "Arbuckle": ["95912"],
    "Arcadia": ["91006", "91007", "91066", "91077"],
    "Arcata": ["95518", "95521"],
    "Armona": ["93202"],
    "Arnold": ["95223"],
    "Aromas": ["95004"],
    "Arroyo Grande": ["93420", "93421"],
    "Artesia": ["90701", "90702"],
    "Artois": ["95913"],
    "Arvin": ["93203"],
    "Atascadero": ["93422", "93423"],
    "Atherton": ["94027"],
    "Atwater": ["95301"],
    "Atwood": ["92811"],
    "Auberry": ["93602"],
    "Auburn": ["95602", "95603", "95604"],
    "Avalon": ["90704"],
    "Avenal": ["93204"],
    "Avery": ["95224"],
    "Avila Beach": ["93424"],
    "Azusa": ["91702"],
    "Badger": ["93603"],
    "Baker": ["92309"],
    "Bakersfield": ["93301", "93302", "93303", "93304", "93305", "93306", "93307", "93308", "93309", "93311", "93312", "93313", "93314", "93380", "93381", "93382", "93383", "93384", "93385", "93386", "93387", "93388", "93389", "93390"],
    "Baldwin Park": ["91706"],
    "Ballico": ["95303"],
    "Bangor": ["95914"],
    "Banning": ["92220"],
    "Bard": ["92222"],
    "Barstow": ["92311", "92312"],
    "Bass Lake": ["93604"],
    "Bayside": ["95524"],
    "Beale AFB": ["95903"],
    "Beaumont": ["92223"],
    "Beckwourth": ["96129"],
    "Belden": ["95915"],
    "Bell": ["90202"],
    "Bell Gardens": ["90201"],
    "Bella Vista": ["96008"],
    "Bellflower": ["90706", "90707"],
    "Belmont": ["94002"],
    "Belvedere Tiburon": ["94920"],
    "Ben Lomond": ["95005"],
    "Benicia": ["94510"],
    "Benton": ["93512"],
    "Berkeley": ["94701", "94702", "94703", "94704", "94705", "94707", "94708", "94709", "94710", "94712", "94720"],
    "Berry Creek": ["95916"],
    "Bethel Island": ["94511"],
    "Beverly Hills": ["90209", "90210", "90211", "90212", "90213"],
    "Bieber": ["96009"],
    "Big Bar": ["96010"],
    "Big Bear City": ["92314"],
    "Big Bear Lake": ["92315"],
    "Big Bend": ["96011"],
    "Big Creek": ["93605"],
    "Big Oak Flat": ["95305"],
    "Big Pine": ["93513"],
    "Big Sur": ["93920"],
    "Biggs": ["95917"],
    "Biola": ["93606"],
    "Birds Landing": ["94512"],
    "Bishop": ["93514", "93515"],
    "Blairsden Graeagle": ["96103"],
    "Blocksburg": ["95514"],
    "Bloomington": ["92316"],
    "Blue Jay": ["92317"],
    "Blue Lake": ["95525"],
    "Blythe": ["92225", "92226"],
    "Bodega": ["94922"],
    "Bodega Bay": ["94923"],
    "Bodfish": ["93205"],
    "Bolinas": ["94924"],
    "Bonita": ["91902", "91908"],
    "Bonsall": ["92003"],
    "Boonville": ["95415"],
    "Boron": ["93516", "93596"],
    "Borrego Springs": ["92004"],
    "Boulder Creek": ["95006"],
    "Boulevard": ["91905"],
    "Boyes Hot Springs": ["95416"],
    "Bradley": ["93426"],
    "Brandeis": ["93064"],
    "Branscomb": ["95417"],
    "Brawley": ["92227"],
    "Brea": ["92821", "92822", "92823"],
    "Brentwood": ["94513"],
    "Bridgeport": ["93517"],
    "Bridgeville": ["95526"],
    "Brisbane": ["94005"],
    "Brookdale": ["95007"],
    "Brooks": ["95606"],
    "Browns Valley": ["95918"],
    "Brownsville": ["95919"],
    "Bryn Mawr": ["92318"],
    "Buellton": ["93427"],
    "Buena Park": ["90620", "90621", "90622", "90624"],
    "Burbank": ["91501", "91502", "91503", "91504", "91505", "91506", "91507", "91508", "91510", "91521", "91522", "91523", "91526"],
    "Burlingame": ["94010", "94011"],
    "Burney": ["96013"],
    "Burnt Ranch": ["95527"],
    "Burrel": ["93607"],
    "Burson": ["95225"],
    "Butte City": ["95920"],
    "Buttonwillow": ["93206"],
    "Byron": ["94514"],
    "Cabazon": ["92230"],
    "Calabasas": ["91302", "91372"],
    "Calexico": ["92231", "92232"],
    "Caliente": ["93518"],
    "California City": ["93504", "93505"],
    "California Hot Springs": ["93207"],
    "Calimesa": ["92320"],
    "Calipatria": ["92233"],
    "Calistoga": ["94515"],
    "Callahan": ["96014"],
    "Calpella": ["95418"],
    "Calpine": ["96124"],
    "Camarillo": ["93010", "93011", "93012"],
    "Cambria": ["93428"],
    "Camino": ["95709"],
    "Camp Meeker": ["95419"],
    "Camp Nelson": ["93208"],
    "Camp Pendleton": ["92055"],
    "Campbell": ["95008", "95009", "95011"],
    "Campo": ["91906"],
    "Campo Seco": ["95226"],
    "Camptonville": ["95922"],
    "Canby": ["96015"],
    "Canoga Park": ["91303", "91304", "91305", "91309"],
    "Cantil": ["93519"],
    "Cantua Creek": ["93608"],
    "Canyon": ["94516"],
    "Canyon Country": ["91351", "91386", "91387"],
    "Canyon Dam": ["95923"],
    "Capay": ["95607"],
    "Capistrano Beach": ["92624"],
    "Capitola": ["95010"],
    "Cardiff By The Sea": ["92007"],
    "Carlotta": ["95528"],
    "Carlsbad": ["92008", "92009", "92010", "92011", "92013", "92018"],
    "Carmel": ["93922", "93923"],
    "Carmel By The Sea": ["93921"],
    "Carmel Valley": ["93924"],
    "Carmichael": ["95608", "95609"],
    "Carnelian Bay": ["96140"],
    "Carpinteria": ["93013", "93014"],
    "Carson": ["90745", "90746", "90747", "90749", "90895"],
    "Caruthers": ["93609"],
    "Casmalia": ["93429"],
    "Caspar": ["95420"],
    "Cassel": ["96016"],
    "Castaic": ["91310", "91384"],
    "Castella": ["96017"],
    "Castro Valley": ["94546", "94552"],
    "Castroville": ["95012"],
    "Cathedral City": ["92234", "92235"],
    "Catheys Valley": ["95306"],
    "Cayucos": ["93430"],
    "Cazadero": ["95421"],
    "Cedar Glen": ["92321"],
    "Cedar Ridge": ["95924"],
    "Cedarpines Park": ["92322"],
    "Cedarville": ["96104"],
    "Ceres": ["95307"],
    "Cerritos": ["90703"],
    "Challenge": ["95925"],
    "Chatsworth": ["91311", "91313"],
    "Chester": ["96020"],
    "Chicago Park": ["95712"],
    "Chico": ["95926", "95927", "95928", "95929", "95973", "95976"],
    "Chilcoot": ["96105"],
    "Chinese Camp": ["95309"],
    "Chino": ["91708", "91710"],
    "Chino Hills": ["91709"],
    "Chowchilla": ["93610"],
    "Chualar": ["93925"],
    "Chula Vista": ["91909", "91910", "91911", "91912", "91913", "91914", "91915", "91921"],
    "Cima": ["92323"],
    "Citrus Heights": ["95610", "95611", "95621"],
    "City Of Industry": ["91714", "91715", "91716"],
    "Claremont": ["91711"],
    "Clarksburg": ["95612"],
    "Clayton": ["94517"],
    "Clearlake": ["95422"],
    "Clearlake Oaks": ["95423"],
    "Clearlake Park": ["95424"],
    "Clements": ["95227"],
    "Clio": ["96106"],
    "Clipper Mills": ["95930"],
    "Cloverdale": ["95425"],
    "Clovis": ["93611", "93612", "93613", "93619"],
    "Coachella": ["92236"],
    "Coalinga": ["93210"],
    "Coarsegold": ["93614"],
    "Cobb": ["95426"],
    "Coleville": ["96107"],
    "Colfax": ["95713"],
    "Coloma": ["95613"],
    "Colton": ["92324"],
    "Columbia": ["95310"],
    "Colusa": ["95932"],
    "Comptche": ["95427"],
    "Compton": ["90220", "90221", "90222", "90223", "90224"],
    "Concord": ["94518", "94519", "94520", "94521", "94522", "94524", "94527", "94529"],
    "Cool": ["95614"],
    "Copperopolis": ["95228"],
    "Corcoran": ["93212"],
    "Corning": ["96021"],
    "Corona": ["92877", "92878", "92879", "92880", "92881", "92882", "92883"],
    "Corona Del Mar": ["92625"],
    "Coronado": ["92118", "92178"],
    "Corte Madera": ["94925", "94976"],
    "Costa Mesa": ["92626", "92627", "92628"],
    "Cotati": ["94931"],
    "Cottonwood": ["96022"],
    "Coulterville": ["95311"],
    "Courtland": ["95615"],
    "Covelo": ["95428"],
    "Covina": ["91722", "91723", "91724"],
    "Coyote": ["95013"],
    "Crescent City": ["95531", "95532"],
    "Crescent Mills": ["95934"],
    "Cressey": ["95312"],
    "Crest Park": ["92326"],
    "Crestline": ["92325"],
    "Creston": ["93432"],
    "Crockett": ["94525"],
    "Crows Landing": ["95313"],
    "Culver City": ["90230", "90231", "90232", "90233"],
    "Cupertino": ["95014", "95015"],
    "Cutler": ["93615"],
    "Cutten": ["95534"],
    "Cypress": ["90630"],
    "Daggett": ["92327"],
    "Daly City": ["94013", "94014", "94015", "94016", "94017"],
    "Dana Point": ["92629"],
    "Danville": ["94506", "94526"],
    "Darwin": ["93522"],
    "Davenport": ["95017"],
    "Davis": ["95616", "95617", "95618"],
    "Davis Creek": ["96108"],
    "Death Valley": ["92328"],
    "Deer Park": ["94576"],
    "Del Mar": ["92014"],
    "Del Rey": ["93616"],
    "Delano": ["93215", "93216"],
    "Delhi": ["95315"],
    "Denair": ["95316"],
    "Descanso": ["91916"],
    "Desert Center": ["92239"],
    "Desert Hot Springs": ["92240", "92241"],
    "Diablo": ["94528"],
    "Diamond Bar": ["91765"],
    "Diamond Springs": ["95619"],
    "Dillon Beach": ["94929"],
    "Dinuba": ["93618"],
    "Discovery Bay": ["94505"],
    "Dixon": ["95620"],
    "Dobbins": ["95935"],
    "Dodgertown": ["90090"],
    "Dorris": ["96023"],
    "Dos Palos": ["93620"],
    "Dos Rios": ["95429"],
    "Douglas City": ["96024"],
    "Douglas Flat": ["95229"],
    "Downey": ["90239", "90240", "90241", "90242"],
    "Downieville": ["95936"],
    "Doyle": ["96109"],
    "Drytown": ["95699"],
    "Duarte": ["91008", "91009", "91010"],
    "Dublin": ["94568"],
    "Ducor": ["93218"],
    "Dulzura": ["91917"],
    "Duncans Mills": ["95430"],
    "Dunlap": ["93621"],
    "Dunnigan": ["95937"],
    "Dunsmuir": ["96025"],
    "Durham": ["95938"],
    "Dutch Flat": ["95714"],
    "Eagleville": ["96110"],
    "Earlimart": ["93219"],
    "Earp": ["92242"],
    "East Irvine": ["92650"],
    "Echo Lake": ["95721"],
    "Edison": ["93220"],
    "Edwards": ["93523", "93524"],
    "El Cajon": ["92019", "92020", "92021", "92022", "92090"],
    "El Centro": ["92243", "92244"],
    "El Cerrito": ["94530"],
    "El Dorado": ["95623"],
    "El Dorado Hills": ["95762"],
    "El Granada": ["94018"],
    "El Monte": ["91731", "91732", "91734", "91735"],
    "El Nido": ["95317"],
    "El Portal": ["95318"],
    "El Segundo": ["90245"],
    "El Sobrante": ["94803", "94820"],
    "El Toro": ["92609"],
    "El Verano": ["95433"],
    "Eldridge": ["95431"],
    "Elk": ["95432"],
    "Elk Creek": ["95939"],
    "Elk Grove": ["95624", "95757", "95758", "95759"],
    "Elmira": ["95625"],
    "Elverta": ["95626"],
    "Emeryville": ["94608", "94662"],
    "Emigrant Gap": ["95715"],
    "Empire": ["95319"],
    "Encinitas": ["92023", "92024"],
    "Encino": ["91316", "91416", "91426", "91436"],
    "Escalon": ["95320"],
    "Escondido": ["92025", "92026", "92027", "92029", "92030", "92033", "92046"],
    "Esparto": ["95627"],
    "Essex": ["92332"],
    "Etna": ["96027"],
    "Eureka": ["95501", "95502", "95503"],
    "Exeter": ["93221"],
    "Fair Oaks": ["95628"],
    "Fairfax": ["94930", "94978"],
    "Fairfield": ["94533", "94534"],
    "Fall River Mills": ["96028"],
    "Fallbrook": ["92028", "92088"],
    "Farmersville": ["93223"],
    "Farmington": ["95230"],
    "Fawnskin": ["92333"],
    "Feather Falls": ["95940"],
    "Fellows": ["93224"],
    "Felton": ["95018"],
    "Ferndale": ["95536"],
    "Fiddletown": ["95629"],
    "Fields Landing": ["95537"],
    "Fillmore": ["93015", "93016"],
    "Finley": ["95435"],
    "Firebaugh": ["93622"],
    "Fish Camp": ["93623"],
    "Five Points": ["93624"],
    "Floriston": ["96111"],
    "Flournoy": ["96029"],
    "Folsom": ["95630", "95763"],
    "Fontana": ["92331", "92334", "92335", "92336", "92337"],
    "Foothill Ranch": ["92610"],
    "Forbestown": ["95941"],
    "Forest Falls": ["92339"],
    "Forest Knolls": ["94933"],
    "Forest Ranch": ["95942"],
    "Foresthill": ["95631"],
    "Forestville": ["95436"],
    "Forks Of Salmon": ["96031"],
    "Fort Bidwell": ["96112"],
    "Fort Bragg": ["95437"],
    "Fort Dick": ["95538"],
    "Fort Irwin": ["92310"],
    "Fort Jones": ["96032"],
    "Fortuna": ["95540"],
    "Fountain Valley": ["92708", "92728"],
    "Fowler": ["93625"],
    "Frazier Park": ["93225"],
    "Freedom": ["95019"],
    "Fremont": ["94536", "94537", "94538", "94539", "94555"],
    "French Camp": ["95231"],
    "French Gulch": ["96033"],
    "Fresno": ["93650", "93701", "93702", "93703", "93704", "93705", "93706", "93707", "93708", "93709", "93710", "93711", "93712", "93714", "93715", "93716", "93717", "93718", "93720", "93721", "93722", "93723", "93724", "93725", "93726", "93727", "93728", "93729", "93730", "93737", "93740", "93741", "93744", "93745", "93747", "93750", "93755", "93760", "93761", "93764", "93765", "93771", "93772", "93773", "93774", "93775", "93776", "93777", "93778", "93779", "93780", "93784", "93786", "93790", "93791", "93792", "93793", "93794", "93844", "93888"],
    "Friant": ["93626"],
    "Fullerton": ["92831", "92832", "92833", "92834", "92835", "92836", "92837", "92838"],
    "Fulton": ["95439"],
    "Galt": ["95632"],
    "Garberville": ["95542"],
    "Garden Grove": ["92840", "92841", "92842", "92843", "92844", "92845", "92846"],
    "Garden Valley": ["95633"],
    "Gardena": ["90247", "90248", "90249"],
    "Gasquet": ["95543"],
    "Gazelle": ["96034"],
    "Georgetown": ["95634"],
    "Gerber": ["96035"],
    "Geyserville": ["95441"],
    "Gilroy": ["95020", "95021"],
    "Glen Ellen": ["95442"],
    "Glencoe": ["95232"],
    "Glendale": ["91201", "91202", "91203", "91204", "91205", "91206", "91207", "91208", "91209", "91210", "91221", "91222", "91225", "91226"],
    "Glendora": ["91740", "91741"],
    "Glenhaven": ["95443"],
    "Glenn": ["95943"],
    "Glennville": ["93226"],
    "Gold Run": ["95717"],
    "Goleta": ["93116", "93117", "93118", "93199"],
    "Gonzales": ["93926"],
    "Goodyears Bar": ["95944"],
    "Goshen": ["93227"],
    "Granada Hills": ["91344", "91394"],
    "Grand Terrace": ["92313"],
    "Granite Bay": ["95746"],
    "Grass Valley": ["95945", "95949"],
    "Graton": ["95444"],
    "Green Valley Lake": ["92341"],
    "Greenbrae": ["94904"],
    "Greenfield": ["93927"],
    "Greenview": ["96037"],
    "Greenville": ["95947"],
    "Greenwood": ["95635"],
    "Grenada": ["96038"],
    "Gridley": ["95948"],
    "Grimes": ["95950"],
    "Grizzly Flats": ["95636"],
    "Groveland": ["95321"],
    "Grover Beach": ["93433", "93483"],
    "Guadalupe": ["93434"],
    "Gualala": ["95445"],
    "Guasti": ["91743"],
    "Guatay": ["91931"],
    "Guerneville": ["95446"],
    "Guinda": ["95637"],
    "Gustine": ["95322"],
    "Hacienda Heights": ["91745"],
    "Half Moon Bay": ["94019"],
    "Hamilton City": ["95951"],
    "Hanford": ["93230", "93232"],
    "Happy Camp": ["96039"],
    "Harbor City": ["90710"],
    "Harmony": ["93435"],
    "Hat Creek": ["96040"],
    "Hathaway Pines": ["95233"],
    "Hawaiian Gardens": ["90716"],
    "Hawthorne": ["90250", "90251"],
    "Hayfork": ["96041"],
    "Hayward": ["94540", "94541", "94542", "94543", "94544", "94545", "94557"],
    "Healdsburg": ["95448"],
    "Heber": ["92249"],
    "Helendale": ["92342"],
    "Helm": ["93627"],
    "Hemet": ["92543", "92544", "92545", "92546"],
    "Herald": ["95638"],
    "Hercules": ["94547"],
    "Herlong": ["96113"],
    "Hermosa Beach": ["90254"],
    "Hesperia": ["92340", "92344", "92345"],
    "Hickman": ["95323"],
    "Hidden Valley Lake": ["95467"],
    "Highland": ["92346"],
    "Hilmar": ["95324"],
    "Hinkley": ["92347"],
    "Hollister": ["95023", "95024"],
    "Holt": ["95234"],
    "Holtville": ["92250"],
    "Holy City": ["95026"],
    "Homeland": ["92548"],
    "Homewood": ["96141"],
    "Honeydew": ["95545"],
    "Hood": ["95639"],
    "Hoopa": ["95546"],
    "Hopland": ["95449"],
    "Hornbrook": ["96044"],
    "Hornitos": ["95325"],
    "Hughson": ["95326"],
    "Hume": ["93628"],
    "Huntington Beach": ["92605", "92615", "92646", "92647", "92648", "92649"],
    "Huntington Park": ["90255"],
    "Huron": ["93234"],
    "Hyampom": ["96046"],
    "Hydesville": ["95547"],
    "Idyllwild": ["92549"],
    "Igo": ["96047"],
    "Imperial": ["92251"],
    "Imperial Beach": ["91932", "91933"],
    "Independence": ["93526"],
    "Indian Wells": ["92210"],
    "Indio": ["92201", "92202", "92203"],
    "Inglewood": ["90301", "90302", "90303", "90304", "90305", "90306", "90307", "90308", "90309", "90310", "90311", "90312", "90313", "90397", "90398"],
    "Inverness": ["94937"],
    "Inyokern": ["93527"],
    "Ione": ["95640"],
    "Irvine": ["92602", "92603", "92604", "92606", "92612", "92614", "92616", "92617", "92618", "92619", "92620", "92623", "92697", "92709", "92710"],
    "Isleton": ["95641"],
    "Ivanhoe": ["93235"],
    "Jackson": ["95642"],
    "Jacumba": ["91934"],
    "Jamestown": ["95327"],
    "Jamul": ["91935"],
    "Janesville": ["96114"],
    "Jenner": ["95450"],
    "Johannesburg": ["93528"],
    "Jolon": ["93928"],
    "Joshua Tree": ["92252"],
    "Julian": ["92036"],
    "Junction City": ["96048"],
    "June Lake": ["93529"],
    "Jurupa Valley": ["92509"],
    "Kaweah": ["93237"],
    "Keeler": ["93530"],
    "Keene": ["93531"],
    "Kelseyville": ["95451"],
    "Kentfield": ["94914"],
    "Kenwood": ["95452"],
    "Kerman": ["93630"],
    "Kernville": ["93238"],
    "Kettleman City": ["93239"],
    "Keyes": ["95328"],
    "King City": ["93930"],
    "Kings Beach": ["96143"],
    "Kings Canyon National Pk": ["93633"],
    "Kingsburg": ["93631"],
    "Kirkwood": ["95646"],
    "Kit Carson": ["95644"],
    "Klamath": ["95548"],
    "Klamath River": ["96050"],
    "Kneeland": ["95549"],
    "Knights Landing": ["95645"],
    "Knightsen": ["94548"],
    "Korbel": ["95550"],
    "Kyburz": ["95720"],
    "La Canada Flintridge": ["91011", "91012"],
    "La Crescenta": ["91214", "91224"],
    "La Grange": ["95329"],
    "La Habra": ["90631", "90632", "90633"],
    "La Honda": ["94020"],
    "La Jolla": ["92037", "92038", "92039", "92092", "92093"],
    "La Mesa": ["91941", "91942", "91943", "91944"],
    "La Mirada": ["90637", "90638", "90639"],
    "La Palma": ["90623"],
    "La Puente": ["91744", "91746", "91747", "91749"],
    "La Quinta": ["92247", "92248", "92253"],
    "La Verne": ["91750"],
    "Ladera Ranch": ["92694"],
    "Lafayette": ["94549"],
    "Laguna Beach": ["92651", "92652"],
    "Laguna Hills": ["92653", "92654"],
    "Laguna Niguel": ["92607", "92677"],
    "Laguna Woods": ["92637"],
    "Lagunitas": ["94938"],
    "Lake Arrowhead": ["92352"],
    "Lake City": ["96115"],
    "Lake Elsinore": ["92530", "92531", "92532"],
    "Lake Forest": ["92630"],
    "Lake Hughes": ["93532"],
    "Lake Isabella": ["93240"],
    "Lakehead": ["96051"],
    "Lakeport": ["95453"],
    "Lakeshore": ["93634"],
    "Lakeside": ["92040"],
    "Lakewood": ["90711", "90712", "90713", "90714", "90715"],
    "Lamont": ["93241"],
    "Lancaster": ["93534", "93535", "93536", "93539", "93584", "93586"],
    "Landers": ["92285"],
    "Larkspur": ["94939", "94977"],
    "Lathrop": ["95330"],
    "Laton": ["93242"],
    "Lawndale": ["90260", "90261"],
    "Laytonville": ["95454"],
    "Le Grand": ["95333"],
    "Lebec": ["93243"],
    "Lee Vining": ["93541"],
    "Leggett": ["95585"],
    "Lemon Cove": ["93244"],
    "Lemon Grove": ["91945", "91946"],
    "Lemoore": ["93245", "93246"],
    "Lewiston": ["96052"],
    "Likely": ["96116"],
    "Lincoln": ["95648"],
    "Lincoln Acres": ["91947"],
    "Linden": ["95236"],
    "Lindsay": ["93247"],
    "Litchfield": ["96117"],
    "Little Lake": ["93542"],
    "Little River": ["95456"],
    "Littlerock": ["93543"],
    "Live Oak": ["95953"],
    "Livermore": ["94550", "94551"],
    "Livingston": ["95334"],
    "Llano": ["93544"],
    "Lockeford": ["95237"],
    "Lockwood": ["93932"],
    "Lodi": ["95240", "95241", "95242"],
    "Loleta": ["95551"],
    "Loma Linda": ["92350", "92354", "92357"],
    "Loma Mar": ["94021"],
    "Lomita": ["90717"],
    "Lompoc": ["93436", "93437", "93438"],
    "Lone Pine": ["93545"],
    "Long Barn": ["95335"],
    "Long Beach": ["90801", "90802", "90803", "90804", "90805", "90806", "90807", "90808", "90809", "90810", "90813", "90814", "90815", "90822", "90831", "90832", "90833", "90834", "90835", "90840", "90842", "90844", "90845", "90846", "90847", "90848", "90853", "90888", "90899"],
    "Lookout": ["96054"],
    "Loomis": ["95650"],
    "Los Alamitos": ["90720", "90721"],
    "Los Alamos": ["93440"],
    "Los Altos": ["94022", "94023", "94024"],
    "Los Angeles": ["90001", "90002", "90003", "90004", "90005", "90006", "90007", "90008", "90009", "90010", "90011", "90012", "90013", "90014", "90015", "90016", "90017", "90018", "90019", "90020", "90021", "90022", "90023", "90024", "90025", "90026", "90027", "90028", "90029", "90030", "90031", "90032", "90033", "90034", "90035", "90036", "90037", "90038", "90039", "90040", "90041", "90042", "90043", "90044", "90045", "90046", "90047", "90048", "90049", "90050", "90051", "90052", "90053", "90054", "90055", "90056", "90057", "90058", "90059", "90060", "90061", "90062", "90063", "90064", "90065", "90066", "90067", "90068", "90070", "90071", "90072", "90073", "90074", "90075", "90076", "90077", "90078", "90079", "90080", "90081", "90082", "90083", "90084", "90086", "90087", "90088", "90089", "90091", "90093", "90095", "90096", "90099", "90101", "90102", "90103", "90134", "90189"],
    "Los Banos": ["93635"],
    "Los Gatos": ["95030", "95031", "95032", "95033"],
    "Los Molinos": ["96055"],
    "Los Olivos": ["93441"],
    "Los Osos": ["93402", "93412"],
    "Lost Hills": ["93249"],
    "Lotus": ["95651"],
    "Lower Lake": ["95457"],
    "Loyalton": ["96118"],
    "Lucerne": ["95458"],
    "Lucerne Valley": ["92356"],
    "Ludlow": ["92338"],
    "Lynwood": ["90262"],
    "Lytle Creek": ["92358"],
    "Macdoel": ["96058"],
    "Mad River": ["95552"],
    "Madeline": ["96119"],
    "Madera": ["93636", "93637", "93638", "93639"],
    "Madison": ["95653"],
    "Magalia": ["95954"],
    "Malibu": ["90263", "90264", "90265"],
    "Mammoth Lakes": ["93546"],
    "Manchester": ["95459"],
    "Manhattan Beach": ["90266", "90267"],
    "Manteca": ["95336", "95337"],
    "Manton": ["96059"],
    "March Air Reserve Base": ["92518"],
    "Maricopa": ["93252"],
    "Marina": ["93933"],
    "Marina Del Rey": ["90292", "90295"],
    "Mariposa": ["95338"],
    "Markleeville": ["96120"],
    "Marshall": ["94940"],
    "Martell": ["95654"],
    "Martinez": ["94553"],
    "Marysville": ["95901"],
    "Mather": ["95655"],
    "Maxwell": ["95955"],
    "Maywood": ["90270"],
    "Mc Farland": ["93250"],
    "Mc Kittrick": ["93251"],
    "Mcarthur": ["96056"],
    "Mcclellan": ["95652"],
    "Mccloud": ["96057"],
    "Mckinleyville": ["95519"],
    "Meadow Valley": ["95956"],
    "Meadow Vista": ["95722"],
    "Mecca": ["92254"],
    "Mendocino": ["95460"],
    "Mendota": ["93640"],
    "Menifee": ["92584", "92585", "92586", "92587"],
    "Menlo Park": ["94025", "94026"],
    "Mentone": ["92359"],
    "Merced": ["95340", "95341", "95343", "95344", "95348"],
    "Meridian": ["95957"],
    "Mi Wuk Village": ["95346"],
    "Middletown": ["95461"],
    "Midpines": ["95345"],
    "Midway City": ["92655"],
    "Milford": ["96121"],
    "Mill Creek": ["96061"],
    "Mill Valley": ["94941", "94942"],
    "Millbrae": ["94030"],
    "Millville": ["96062"],
    "Milpitas": ["95035", "95036"],
    "Mineral": ["96063"],
    "Mira Loma": ["91752"],
    "Miramonte": ["93641"],
    "Miranda": ["95553"],
    "Mission Hills": ["91345", "91346", "91395"],
    "Mission Viejo": ["92690", "92691", "92692"],
    "Moccasin": ["95347"],
    "Modesto": ["95350", "95351", "95352", "95353", "95354", "95355", "95356", "95357", "95358", "95397"],
    "Mojave": ["93501", "93502"],
    "Mokelumne Hill": ["95245"],
    "Mono Hot Springs": ["93642"],
    "Monrovia": ["91016", "91017"],
    "Montague": ["96064"],
    "Montara": ["94037"],
    "Montclair": ["91763"],
    "Monte Rio": ["95462"],
    "Montebello": ["90640"],
    "Monterey": ["93940", "93942", "93943", "93944"],
    "Monterey Park": ["91754", "91755", "91756"],
    "Montgomery Creek": ["96065"],
    "Montrose": ["91020", "91021"],
    "Moorpark": ["93020", "93021"],
    "Moraga": ["94556", "94570", "94575"],
    "Moreno Valley": ["92551", "92552", "92553", "92554", "92555", "92556", "92557"],
    "Morgan Hill": ["95037", "95038"],
    "Morongo Valley": ["92256"],
    "Morro Bay": ["93442", "93443"],
    "Moss Beach": ["94038"],
    "Moss Landing": ["95039"],
    "Mount Aukum": ["95656"],
    "Mount Hamilton": ["95140"],
    "Mount Hermon": ["95041"],
    "Mount Laguna": ["91948"],
    "Mount Shasta": ["96067"],
    "Mount Wilson": ["91023"],
    "Mountain Center": ["92561"],
    "Mountain Pass": ["92366"],
    "Mountain Ranch": ["95246"],
    "Mountain View": ["94035", "94039", "94040", "94041", "94042", "94043"],
    "Mt Baldy": ["91759"],
    "Murphys": ["95247"],
    "Murrieta": ["92562", "92563", "92564"],
    "Myers Flat": ["95554"],
    "Napa": ["94558", "94559", "94581"],
    "National City": ["91950", "91951"],
    "Navarro": ["95463"],
    "Needles": ["92363"],
    "Nelson": ["95958"],
    "Nevada City": ["95959"],
    "New Almaden": ["95042"],
    "New Cuyama": ["93254"],
    "Newark": ["94560"],
    "Newberry Springs": ["92365"],
    "Newbury Park": ["91319", "91320"],
    "Newcastle": ["95658"],
    "Newhall": ["91321", "91322"],
    "Newman": ["95360"],
    "Newport Beach": ["92658", "92659", "92660", "92661", "92662", "92663"],
    "Newport Coast": ["92657"],
    "Nicasio": ["94946"],
    "Nice": ["95464"],
    "Nicolaus": ["95659"],
    "Niland": ["92257"],
    "Nipomo": ["93444"],
    "Nipton": ["92364"],
    "Norco": ["92860"],
    "Norden": ["95724"],
    "North Fork": ["93643"],
    "North Highlands": ["95660"],
    "North Hills": ["91343", "91393"],
    "North Hollywood": ["91601", "91602", "91603", "91605", "91606", "91609", "91611", "91612", "91615", "91616", "91618"],
    "North Palm Springs": ["92258"],
    "North San Juan": ["95960"],
    "Northridge": ["91324", "91325", "91327", "91328", "91329", "91330"],
    "Norwalk": ["90650", "90651", "90652", "90659"],
    "Novato": ["94945", "94947", "94948", "94949", "94998"],
    "Nubieber": ["96068"],
    "Nuevo": ["92567"],
    "O Neals": ["93645"],
    "Oak Park": ["91377"],
    "Oak Run": ["96069"],
    "Oak View": ["93022"],
    "Oakdale": ["95361"],
    "Oakhurst": ["93644"],
    "Oakland": ["94601", "94602", "94603", "94604", "94605", "94606", "94607", "94609", "94610", "94611", "94612", "94613", "94614", "94615", "94617", "94618", "94619", "94621", "94622", "94623", "94624", "94625", "94649", "94659", "94660", "94661", "94666"],
    "Oakley": ["94561"],
    "Oakville": ["94562"],
    "Obrien": ["96070"],
    "Occidental": ["95465"],
    "Oceano": ["93445", "93475"],
    "Oceanside": ["92049", "92051", "92052", "92054", "92056", "92057", "92058"],
    "Ocotillo": ["92259"],
    "Ojai": ["93023", "93024"],
    "Olancha": ["93549"],
    "Old Station": ["96071"],
    "Olema": ["94950"],
    "Olivehurst": ["95961"],
    "Olympic Valley": ["96146"],
    "Ontario": ["91758", "91761", "91762", "91764", "91798"],
    "Onyx": ["93255"],
    "Orange": ["92856", "92857", "92859", "92862", "92863", "92864", "92865", "92866", "92867", "92868", "92869"],
    "Orange Cove": ["93646"],
    "Orangevale": ["95662"],
    "Oregon House": ["95962"],
    "Orick": ["95555"],
    "Orinda": ["94563"],
    "Orland": ["95963"],
    "Orleans": ["95556"],
    "Oro Grande": ["92368"],
    "Orosi": ["93647"],
    "Oroville": ["95965", "95966"],
    "Oxnard": ["93030", "93031", "93032", "93033", "93034", "93035", "93036"],
    "Pacific Grove": ["93950"],
    "Pacific Palisades": ["90272"],
    "Pacifica": ["94044"],
    "Pacoima": ["91331", "91333", "91334"],
    "Paicines": ["95043"],
    "Pala": ["92059"],
    "Palermo": ["95968"],
    "Palm Desert": ["92211", "92255", "92260", "92261"],
    "Palm Springs": ["92262", "92263", "92264", "92292"],
    "Palmdale": ["93550", "93551", "93552", "93590", "93591", "93599"],
    "Palo Alto": ["94301", "94302", "94303", "94304", "94306", "94309"],
    "Palo Cedro": ["96073"],
    "Palo Verde": ["92266"],
    "Palomar Mountain": ["92060"],
    "Palos Verdes Peninsula": ["90274"],
    "Panorama City": ["91402", "91412"],
    "Paradise": ["95967", "95969"],
    "Paramount": ["90723"],
    "Parker Dam": ["92267"],
    "Parlier": ["93648"],
    "Pasadena": ["91101", "91102", "91103", "91104", "91105", "91106", "91107", "91109", "91110", "91114", "91115", "91116", "91117", "91121", "91123", "91124", "91125", "91126", "91129", "91131", "91182", "91184", "91185", "91188", "91189", "91191", "91199"],
    "Paskenta": ["96074"],
    "Paso Robles": ["93446", "93447"],
    "Patterson": ["95363"],
    "Patton": ["92369"],
    "Pauma Valley": ["92061"],
    "Paynes Creek": ["96075"],
    "Pearblossom": ["93553"],
    "Pebble Beach": ["93953"],
    "Penn Valley": ["95946"],
    "Penngrove": ["94951"],
    "Penryn": ["95663"],
    "Perris": ["92570", "92571", "92572", "92599"],
    "Pescadero": ["94060"],
    "Petaluma": ["94952", "94953", "94954", "94955", "94975", "94999"],
    "Petrolia": ["95558"],
    "Phelan": ["92329", "92371"],
    "Phillipsville": ["95559"],
    "Philo": ["95466"],
    "Pico Rivera": ["90660", "90661", "90662"],
    "Piedmont": ["94620"],
    "Piedra": ["93649"],
    "Piercy": ["95587"],
    "Pilot Hill": ["95664"],
    "Pine Grove": ["95665"],
    "Pine Mountain Club": ["93222"],
    "Pine Valley": ["91962"],
    "Pinecrest": ["95314", "95364"],
    "Pinole": ["94564"],
    "Pinon Hills": ["92372"],
    "Pioneer": ["95666"],
    "Pioneertown": ["92268"],
    "Piru": ["93040"],
    "Pismo Beach": ["93448", "93449"],
    "Pittsburg": ["94565"],
    "Pixley": ["93256"],
    "Placentia": ["92870", "92871"],
    "Placerville": ["95667"],
    "Planada": ["95365"],
    "Platina": ["96076"],
    "Playa Del Rey": ["90293", "90296"],
    "Playa Vista": ["90094"],
    "Pleasant Grove": ["95668"],
    "Pleasant Hill": ["94523"],
    "Pleasanton": ["94566", "94588"],
    "Plymouth": ["95669"],
    "Point Arena": ["95468"],
    "Point Mugu Nawc": ["93042"],
    "Point Reyes Station": ["94956"],
    "Pollock Pines": ["95726"],
    "Pomona": ["91766", "91767", "91768", "91769", "91797", "91799"],
    "Pope Valley": ["94567"],
    "Port Costa": ["94569"],
    "Port Hueneme": ["93041", "93044"],
    "Port Hueneme Cbc Base": ["93043"],
    "Porter Ranch": ["91326"],
    "Porterville": ["93257", "93258"],
    "Portola": ["96122"],
    "Portola Valley": ["94028"],
    "Posey": ["93260"],
    "Potrero": ["91963", "91990"],
    "Potter Valley": ["95469"],
    "Poway": ["92064", "92074"],
    "Prather": ["93651"],
    "Princeton": ["95970"],
    "Proberta": ["96078"],
    "Quincy": ["95971"],
    "Rackerby": ["95972"],
    "Rail Road Flat": ["95248"],
    "Raisin City": ["93652"],
    "Ramona": ["92065"],
    "Ranchita": ["92066"],
    "Rancho Cordova": ["95670", "95741", "95742"],
    "Rancho Cucamonga": ["91701", "91729", "91730", "91737", "91739"],
    "Rancho Mirage": ["92270"],
    "Rancho Palos Verdes": ["90275"],
    "Rancho Santa Fe": ["92067", "92091"],
    "Rancho Santa Margarita": ["92688"],
    "Randsburg": ["93554"],
    "Ravendale": ["96123"],
    "Raymond": ["93653"],
    "Red Bluff": ["96080"],
    "Red Mountain": ["93558"],
    "Redcrest": ["95569"],
    "Redding": ["96001", "96002", "96003", "96049", "96099"],
    "Redlands": ["92373", "92374", "92375"],
    "Redondo Beach": ["90277", "90278"],
    "Redway": ["95560"],
    "Redwood City": ["94061", "94062", "94063", "94064", "94065"],
    "Redwood Estates": ["95044"],
    "Redwood Valley": ["95470"],
    "Reedley": ["93654"],
    "Represa": ["95671"],
    "Rescue": ["95672"],
    "Reseda": ["91335", "91337"],
    "Rialto": ["92376", "92377"],
    "Richgrove": ["93261"],
    "Richmond": ["94801", "94802", "94804", "94805", "94807", "94808", "94850"],
    "Richvale": ["95974"],
    "Ridgecrest": ["93555", "93556"],
    "Rimforest": ["92378"],
    "Rio Dell": ["95562"],
    "Rio Linda": ["95673"],
    "Rio Nido": ["95471"],
    "Rio Oso": ["95674"],
    "Rio Vista": ["94571"],
    "Ripon": ["95366"],
    "River Pines": ["95675"],
    "Riverbank": ["95367"],
    "Riverdale": ["93656"],
    "Riverside": ["92501", "92502", "92503", "92504", "92505", "92506", "92507", "92508", "92513", "92514", "92515", "92516", "92517", "92519", "92521", "92522"],
    "Robbins": ["95676"],
    "Rocklin": ["95677", "95765"],
    "Rodeo": ["94572"],
    "Rohnert Park": ["94926", "94927", "94928"],
    "Rosamond": ["93560"],
    "Rosemead": ["91770", "91771", "91772"],
    "Roseville": ["95661", "95678", "95747"],
    "Ross": ["94957"],
    "Rough And Ready": ["95975"],
    "Round Mountain": ["96084"],
    "Rowland Heights": ["91748"],
    "Rumsey": ["95679"],
    "Running Springs": ["92382"],
    "Rutherford": ["94573"],
    "Ryde": ["95680"],
    "Sacramento": ["94203", "94204", "94205", "94206", "94207", "94208", "94209", "94211", "94229", "94230", "94232", "94234", "94235", "94236", "94237", "94239", "94240", "94244", "94245", "94246", "94247", "94248", "94249", "94250", "94252", "94254", "94256", "94257", "94258", "94259", "94261", "94262", "94263", "94267", "94268", "94269", "94271", "94273", "94274", "94277", "94278", "94279", "94280", "94282", "94283", "94284", "94285", "94286", "94287", "94288", "94289", "94290", "94291", "94293", "94294", "94295", "94296", "94297", "94298", "94299", "95811", "95812", "95813", "95814", "95815", "95816", "95817", "95818", "95819", "95820", "95821", "95822", "95823", "95824", "95825", "95826", "95827", "95828", "95829", "95830", "95831", "95832", "95833", "95834", "95835", "95836", "95837", "95838", "95840", "95841", "95842", "95851", "95852", "95853", "95860", "95864", "95865", "95866", "95867", "95887", "95894", "95899"],
    "Saint Helena": ["94574"],
    "Salida": ["95368"],
    "Salinas": ["93901", "93902", "93905", "93906", "93907", "93908", "93912", "93915"],
    "Salton City": ["92275"],
    "Salyer": ["95563"],
    "Samoa": ["95564"],
    "San Andreas": ["95249", "95250"],
    "San Anselmo": ["94960", "94979"],
    "San Ardo": ["93450"],
    "San Bernardino": ["92401", "92402", "92403", "92404", "92405", "92406", "92407", "92408", "92410", "92411", "92412", "92413", "92414", "92415", "92418", "92423", "92424", "92427"],
    "San Bruno": ["94066"],
    "San Carlos": ["94070"],
    "San Clemente": ["92672", "92673", "92674"],
    "San Diego": ["92101", "92102", "92103", "92104", "92105", "92106", "92107", "92108", "92109", "92110", "92111", "92112", "92113", "92114", "92115", "92116", "92117", "92119", "92120", "92121", "92122", "92123", "92124", "92126", "92127", "92128", "92129", "92130", "92131", "92132", "92133", "92134", "92135", "92136", "92137", "92138", "92139", "92140", "92142", "92145", "92147", "92149", "92150", "92152", "92153", "92154", "92155", "92158", "92159", "92160", "92161", "92162", "92163", "92164", "92165", "92166", "92167", "92168", "92169", "92170", "92171", "92172", "92174", "92175", "92176", "92177", "92179", "92182", "92184", "92186", "92187", "92190", "92191", "92192", "92193", "92194", "92195", "92196", "92197", "92198", "92199"],
    "San Dimas": ["91773"],
    "San Fernando": ["91340", "91341"],
    "San Francisco": ["94101", "94102", "94103", "94104", "94105", "94106", "94107", "94108", "94109", "94110", "94111", "94112", "94114", "94115", "94116", "94117", "94118", "94119", "94120", "94121", "94122", "94123", "94124", "94125", "94126", "94127", "94128", "94129", "94130", "94131", "94132", "94133", "94134", "94135", "94136", "94137", "94138", "94139", "94140", "94141", "94142", "94143", "94144", "94145", "94146", "94147", "94150", "94151", "94152", "94153", "94154", "94155", "94156", "94158", "94159", "94160", "94161", "94162", "94163", "94164", "94171", "94172", "94175", "94177", "94188", "94199"],
    "San Gabriel": ["91775", "91776", "91778"],
    "San Geronimo": ["94963"],
    "San Gregorio": ["94074"],
    "San Jacinto": ["92581", "92582", "92583"],
    "San Joaquin": ["93660"],
    "San Jose": ["95101", "95103", "95106", "95108", "95109", "95110", "95111", "95112", "95113", "95115", "95116", "95117", "95118", "95119", "95120", "95121", "95122", "95123", "95124", "95125", "95126", "95127", "95128", "95129", "95130", "95131", "95132", "95133", "95134", "95135", "95136", "95138", "95139", "95141", "95148", "95150", "95151", "95152", "95153", "95154", "95155", "95156", "95157", "95158", "95159", "95160", "95161", "95164", "95170", "95172", "95173", "95190", "95191", "95192", "95193", "95194", "95196"],
    "San Juan Bautista": ["95045"],
    "San Juan Capistrano": ["92675", "92693"],
    "San Leandro": ["94577", "94578", "94579"],
    "San Lorenzo": ["94580"],
    "San Lucas": ["93954"],
    "San Luis Obispo": ["93401", "93403", "93405", "93406", "93407", "93408", "93409", "93410"],
    "San Luis Rey": ["92068"],
    "San Marcos": ["92069", "92078", "92079", "92096"],
    "San Marino": ["91108", "91118"],
    "San Martin": ["95046"],
    "San Mateo": ["94401", "94402", "94403", "94404", "94497"],
    "San Miguel": ["93451"],
    "San Pablo": ["94806"],
    "San Pedro": ["90731", "90732", "90733", "90734"],
    "San Quentin": ["94964", "94974"],
    "San Rafael": ["94901", "94903", "94912", "94913", "94915"],
    "San Ramon": ["94582", "94583"],
    "San Simeon": ["93452"],
    "San Ysidro": ["92143", "92173"],
    "Sanger": ["93657"],
    "Santa Ana": ["92701", "92702", "92703", "92704", "92705", "92706", "92707", "92711", "92712", "92725", "92735", "92799"],
    "Santa Barbara": ["93101", "93102", "93103", "93105", "93106", "93107", "93108", "93109", "93110", "93111", "93120", "93121", "93130", "93140", "93150", "93160", "93190"],
    "Santa Clara": ["95050", "95051", "95052", "95053", "95054", "95055", "95056"],
    "Santa Clarita": ["91350", "91380", "91382", "91383", "91390"],
    "Santa Cruz": ["95060", "95061", "95062", "95063", "95064", "95065"],
    "Santa Fe Springs": ["90670", "90671"],
    "Santa Margarita": ["93453"],
    "Santa Maria": ["93454", "93455", "93456", "93457", "93458"],
    "Santa Monica": ["90401", "90402", "90403", "90404", "90405", "90406", "90407", "90408", "90409", "90410", "90411"],
    "Santa Paula": ["93060", "93061"],
    "Santa Rita Park": ["93661"],
    "Santa Rosa": ["95401", "95402", "95403", "95404", "95405", "95406", "95407", "95409"],
    "Santa Ynez": ["93460"],
    "Santa Ysabel": ["92070"],
    "Santee": ["92071", "92072"],
    "Saratoga": ["95070", "95071"],
    "Sausalito": ["94965", "94966"],
    "Scotia": ["95565"],
    "Scott Bar": ["96085"],
    "Scotts Valley": ["95066", "95067"],
    "Seal Beach": ["90740"],
    "Seaside": ["93955"],
    "Sebastopol": ["95472", "95473"],
    "Seeley": ["92273"],
    "Seiad Valley": ["96086"],
    "Selma": ["93662"],
    "Sequoia National Park": ["93262"],
    "Shafter": ["93263"],
    "Shandon": ["93461"],
    "Shasta": ["96087"],
    "Shasta Lake": ["96019", "96079", "96089"],
    "Shaver Lake": ["93664"],
    "Sheridan": ["95681"],
    "Sherman Oaks": ["91403", "91413", "91423", "91495"],
    "Shingle Springs": ["95682"],
    "Shingletown": ["96088"],
    "Shoshone": ["92384"],
    "Sierra City": ["96125"],
    "Sierra Madre": ["91024", "91025"],
    "Sierraville": ["96126"],
    "Signal Hill": ["90755"],
    "Silverado": ["92676"],
    "Simi Valley": ["93062", "93063", "93065", "93093", "93094", "93099"],
    "Skyforest": ["92385"],
    "Sloughhouse": ["95683"],
    "Smartsville": ["95977"],
    "Smith River": ["95567"],
    "Snelling": ["95369"],
    "Soda Springs": ["95728"],
    "Solana Beach": ["92075"],
    "Soledad": ["93960"],
    "Solvang": ["93463", "93464"],
    "Somerset": ["95684"],
    "Somes Bar": ["95568"],
    "Somis": ["93066"],
    "Sonoma": ["95476"],
    "Sonora": ["95370"],
    "Soquel": ["95073"],
    "Soulsbyville": ["95372"],
    "South Dos Palos": ["93665"],
    "South El Monte": ["91733"],
    "South Gate": ["90280"],
    "South Lake Tahoe": ["96150", "96151", "96152", "96154", "96155", "96156", "96157", "96158"],
    "South Pasadena": ["91030", "91031"],
    "South San Francisco": ["94080", "94083"],
    "Spreckels": ["93962"],
    "Spring Valley": ["91976", "91977", "91978", "91979"],
    "Springville": ["93265"],
    "Squaw Valley": ["93675"],
    "Standard": ["95373"],
    "Standish": ["96128"],
    "Stanford": ["94305"],
    "Stanton": ["90680"],
    "Stevenson Ranch": ["91381"],
    "Stevinson": ["95374"],
    "Stewarts Point": ["95480"],
    "Stinson Beach": ["94970"],
    "Stirling City": ["95978"],
    "Stockton": ["95201", "95202", "95203", "95204", "95205", "95206", "95207", "95208", "95209", "95210", "95211", "95212", "95213", "95214", "95215", "95219", "95267", "95269", "95296", "95297"],
    "Stonyford": ["95979"],
    "Storrie": ["95980"],
    "Stratford": ["93266"],
    "Strathmore": ["93267"],
    "Strawberry": ["95375"],
    "Strawberry Valley": ["95981"],
    "Studio City": ["91604", "91614"],
    "Sugarloaf": ["92386"],
    "Suisun City": ["94585"],
    "Sultana": ["93666"],
    "Summerland": ["93067"],
    "Sun Valley": ["91352", "91353"],
    "Sunland": ["91040", "91041"],
    "Sunnyvale": ["94085", "94086", "94087", "94088", "94089"],
    "Sunol": ["94586"],
    "Sunset Beach": ["90742"],
    "Surfside": ["90743"],
    "Susanville": ["96127", "96130"],
    "Sutter": ["95982"],
    "Sutter Creek": ["95685"],
    "Sylmar": ["91342", "91392"],
    "Taft": ["93268"],
    "Tahoe City": ["96145"],
    "Tahoe Vista": ["96148"],
    "Tahoma": ["96142"],
    "Talmage": ["95481"],
    "Tarzana": ["91356", "91357"],
    "Taylorsville": ["95983"],
    "Tecate": ["91980", "91987"],
    "Tecopa": ["92389"],
    "Tehachapi": ["93561", "93581"],
    "Tehama": ["96090"],
    "Temecula": ["92589", "92590", "92591", "92592", "92593"],
    "Temple City": ["91780"],
    "Templeton": ["93465"],
    "Termo": ["96132"],
    "Terra Bella": ["93270"],
    "The Sea Ranch": ["95497"],
    "Thermal": ["92274"],
    "Thornton": ["95686"],
    "Thousand Oaks": ["91358", "91360", "91362", "91363"],
    "Thousand Palms": ["92276"],
    "Three Rivers": ["93271"],
    "Tipton": ["93272"],
    "Tollhouse": ["93667"],
    "Toluca Lake": ["91610"],
    "Tomales": ["94971"],
    "Topanga": ["90290"],
    "Topaz": ["96133"],
    "Torrance": ["90501", "90502", "90503", "90504", "90505", "90506", "90507", "90508", "90509", "90510"],
    "Trabuco Canyon": ["92678", "92679"],
    "Tracy": ["95304", "95376", "95377", "95378", "95391"],
    "Tranquillity": ["93668"],
    "Traver": ["93673"],
    "Travis AFB": ["94535"],
    "Tres Pinos": ["95075"],
    "Trinidad": ["95570"],
    "Trinity Center": ["96091"],
    "Trona": ["93562", "93592"],
    "Truckee": ["96160", "96161", "96162"],
    "Tujunga": ["91042", "91043"],
    "Tulare": ["93274", "93275"],
    "Tulelake": ["96134"],
    "Tuolumne": ["95379"],
    "Tupman": ["93276"],
    "Turlock": ["95380", "95381", "95382"],
    "Tustin": ["92780", "92781", "92782"],
    "Twain": ["95984"],
    "Twain Harte": ["95383"],
    "Twentynine Palms": ["92277", "92278"],
    "Twin Bridges": ["95735"],
    "Twin Peaks": ["92391"],
    "Ukiah": ["95482"],
    "Union City": ["94587"],
    "Universal City": ["91608"],
    "Upland": ["91784", "91785", "91786"],
    "Upper Lake": ["95485"],
    "Vacaville": ["95687", "95688", "95696"],
    "Valencia": ["91354", "91355", "91385"],
    "Vallecito": ["95251"],
    "Vallejo": ["94589", "94590", "94591", "94592"],
    "Valley Center": ["92082"],
    "Valley Ford": ["94972"],
    "Valley Springs": ["95252"],
    "Valley Village": ["91607", "91617"],
    "Valyermo": ["93563"],
    "Van Nuys": ["91388", "91401", "91404", "91405", "91406", "91407", "91408", "91409", "91410", "91411", "91470", "91482", "91496", "91497", "91499"],
    "Venice": ["90291", "90294"],
    "Ventura": ["93001", "93002", "93003", "93004", "93005", "93006", "93007", "93009"],
    "Verdugo City": ["91046"],
    "Vernalis": ["95385"],
    "Victor": ["95253"],
    "Victorville": ["92392", "92393", "92394", "92395"],
    "Vidal": ["92280"],
    "Villa Grande": ["95486"],
    "Villa Park": ["92861"],
    "Vina": ["96092"],
    "Vineburg": ["95487"],
    "Vinton": ["96135"],
    "Visalia": ["93277", "93278", "93279", "93290", "93291", "93292"],
    "Vista": ["92081", "92083", "92084", "92085"],
    "Volcano": ["95689"],
    "Wallace": ["95254"],
    "Walnut": ["91788", "91789", "91795"],
    "Walnut Creek": ["94595", "94596", "94597", "94598"],
    "Walnut Grove": ["95690"],
    "Warner Springs": ["92086"],
    "Wasco": ["93280"],
    "Washington": ["95986"],
    "Waterford": ["95386"],
    "Watsonville": ["95076", "95077"],
    "Waukena": ["93282"],
    "Weaverville": ["96093"],
    "Weed": ["96094"],
    "Weimar": ["95736"],
    "Weldon": ["93283"],
    "Wendel": ["96136"],
    "Weott": ["95571"],
    "West Covina": ["91790", "91791", "91792", "91793"],
    "West Hills": ["91307", "91308"],
    "West Hollywood": ["90069"],
    "West Point": ["95255"],
    "West Sacramento": ["95605", "95691", "95798", "95799"],
    "Westlake Village": ["91359", "91361"],
    "Westley": ["95387"],
    "Westminster": ["92683", "92684", "92685"],
    "Westmorland": ["92281"],
    "Westport": ["95488"],
    "Westwood": ["96137"],
    "Wheatland": ["95692"],
    "Whiskeytown": ["96095"],
    "Whitethorn": ["95589"],
    "Whitewater": ["92282"],
    "Whitmore": ["96096"],
    "Whittier": ["90601", "90602", "90603", "90604", "90605", "90606", "90607", "90608", "90609", "90610", "90612"],
    "Wildomar": ["92595"],
    "Williams": ["95987"],
    "Willits": ["95490"],
    "Willow Creek": ["95573"],
    "Willows": ["95988"],
    "Wilmington": ["90744", "90748"],
    "Wilseyville": ["95257"],
    "Wilton": ["95693"],
    "Winchester": ["92596"],
    "Windsor": ["95492"],
    "Winnetka": ["91306", "91396"],
    "Winterhaven": ["92283"],
    "Winters": ["95694"],
    "Winton": ["95388"],
    "Wishon": ["93669"],
    "Witter Springs": ["95493"],
    "Wofford Heights": ["93285"],
    "Woodacre": ["94973"],
    "Woodbridge": ["95258"],
    "Woodlake": ["93286"],
    "Woodland": ["95695", "95776"],
    "Woodland Hills": ["91364", "91365", "91367", "91371", "91399"],
    "Woody": ["93287"],
    "Wrightwood": ["92397"],
    "Yermo": ["92398"],
    "Yettem": ["93670"],
    "Yolo": ["95697"],
    "Yorba Linda": ["92885", "92886", "92887"],
    "Yorkville": ["95494"],
    "Yosemite National Park": ["95389"],
    "Yountville": ["94599"],
    "Yreka": ["96097"],
    "Yuba City": ["95991", "95992", "95993"],
    "Yucaipa": ["92399"],
    "Yucca Valley": ["92284", "92286"],
    "Zamora": ["95698"],
    "Zenia": ["95595"]
  },
  "CO": {
    "Agate": ["80101"],
    "Aguilar": ["81020"],
    "Akron": ["80720"],
    "Alamosa": ["81101", "81102"],
    "Allenspark": ["80510"],
    "Alma": ["80420"],
    "Almont": ["81210"],
    "Amherst": ["80721"],
    "Anton": ["80801"],
    "Antonito": ["81120"],
    "Arapahoe": ["80802"],
    "Arboles": ["81121"],
    "Arlington": ["81021"],
    "Arriba": ["80804"],
    "Arvada": ["80001", "80002", "80003", "80004", "80005", "80006", "80007"],
    "Aspen": ["81611", "81612"],
    "Atwood": ["80722"],
    "Ault": ["80610"],
    "Aurora": ["80010", "80011", "80012", "80013", "80014", "80015", "80016", "80017", "80018", "80019", "80040", "80041", "80042", "80044", "80045", "80046", "80047"],
    "Austin": ["81410"],
    "Avon": ["81620"],
    "Avondale": ["81022"],
    "Bailey": ["80421"],
    "Basalt": ["81621"],
    "Battlement Mesa": ["81636"],
    "Bayfield": ["81122"],
    "Bedrock": ["81411"],
    "Bellvue": ["80512"],
    "Bennett": ["80102"],
    "Berthoud": ["80513"],
    "Bethune": ["80805"],
    "Beulah": ["81023"],
    "Black Hawk": ["80422"],
    "Blanca": ["81123"],
    "Boncarbo": ["81024"],
    "Bond": ["80423"],
    "Boone": ["81025"],
    "Boulder": ["80301", "80302", "80303", "80304", "80305", "80306", "80307", "80308", "80309", "80310", "80314", "80321", "80322", "80323", "80328", "80329"],
    "Branson": ["81027"],
    "Breckenridge": ["80424"],
    "Briggsdale": ["80611"],
    "Brighton": ["80601", "80602", "80603"],
    "Broomfield": ["80020", "80021", "80023", "80038"],
    "Brush": ["80723"],
    "Buena Vista": ["81211"],
    "Buffalo Creek": ["80425"],
    "Burlington": ["80807"],
    "Burns": ["80426"],
    "Byers": ["80103"],
    "Cahone": ["81320"],
    "Calhan": ["80808"],
    "Campo": ["81029"],
    "Canon City": ["81212", "81215"],
    "Capulin": ["81124"],
    "Carbondale": ["81623"],
    "Carr": ["80612"],
    "Cascade": ["80809"],
    "Castle Rock": ["80104", "80108", "80109"],
    "Cedaredge": ["81413"],
    "Center": ["81125"],
    "Central City": ["80427"],
    "Chama": ["81126"],
    "Cheraw": ["81030"],
    "Cheyenne Wells": ["80810"],
    "Chimney Rock": ["81127"],
    "Chromo": ["81128"],
    "Cimarron": ["81220"],
    "Clark": ["80428"],
    "Clifton": ["81520"],
    "Climax": ["80429"],
    "Coal Creek": ["81221"],
    "Coaldale": ["81222"],
    "Coalmont": ["80430"],
    "Collbran": ["81624"],
    "Colorado City": ["81019"],
    "Colorado Springs": ["80901", "80902", "80903", "80904", "80905", "80906", "80907", "80908", "80909", "80910", "80911", "80912", "80913", "80914", "80915", "80916", "80917", "80918", "80919", "80920", "80921", "80922", "80923", "80924", "80925", "80926", "80927", "80928", "80929", "80930", "80931", "80932", "80933", "80934", "80935", "80936", "80937", "80938", "80939", "80940", "80941", "80942", "80943", "80944", "80945", "80946", "80947", "80949", "80950", "80951", "80960", "80962", "80970", "80977", "80995", "80997"],
    "Commerce City": ["80022", "80037"],
    "Como": ["80432"],
    "Conejos": ["81129"],
    "Conifer": ["80433"],
    "Cope": ["80812"],
    "Cortez": ["81321"],
    "Cory": ["81414"],
    "Cotopaxi": ["81223"],
    "Cowdrey": ["80434"],
    "Craig": ["81625", "81626"],
    "Crawford": ["81415"],
    "Creede": ["81130"],
    "Crested Butte": ["81224", "81225"],
    "Crestone": ["81131"],
    "Cripple Creek": ["80813"],
    "Crook": ["80726"],
    "Crowley": ["81033"],
    "Dacono": ["80514"],
    "De Beque": ["81630"],
    "Deer Trail": ["80105"],
    "Del Norte": ["81132"],
    "Delta": ["81416"],
    "Denver": ["80201", "80202", "80203", "80204", "80205", "80206", "80207", "80208", "80209", "80210", "80211", "80212", "80214", "80215", "80216", "80217", "80218", "80219", "80220", "80221", "80222", "80223", "80224", "80225", "80226", "80227", "80228", "80229", "80230", "80231", "80232", "80233", "80234", "80235", "80236", "80237", "80238", "80239", "80243", "80244", "80246", "80247", "80248", "80249", "80250", "80251", "80252", "80256", "80257", "80259", "80260", "80261", "80262", "80263", "80264", "80265", "80266", "80271", "80273", "80274", "80279", "80280", "80281", "80290", "80291", "80293", "80294", "80295", "80299"],
    "Dillon": ["80435"],
    "Dinosaur": ["81610", "81633"],
    "Divide": ["80814"],
    "Dolores": ["81323"],
    "Dove Creek": ["81324"],
    "Drake": ["80515"],
    "Dumont": ["80436"],
    "Dupont": ["80024"],
    "Durango": ["81301", "81302", "81303"],
    "Eads": ["81036"],
    "Eagle": ["81631"],
    "Eastlake": ["80614"],
    "Eaton": ["80615"],
    "Eckert": ["81418"],
    "Eckley": ["80727"],
    "Edwards": ["81632"],
    "Egnar": ["81325"],
    "Elbert": ["80106"],
    "Eldorado Springs": ["80025"],
    "Elizabeth": ["80107"],
    "Empire": ["80438"],
    "Englewood": ["80110", "80111", "80112", "80113", "80150", "80151", "80155"],
    "Erie": ["80516"],
    "Estes Park": ["80511", "80517"],
    "Evans": ["80620"],
    "Evergreen": ["80437", "80439"],
    "Fairplay": ["80440"],
    "Firestone": ["80520"],
    "Flagler": ["80815"],
    "Fleming": ["80728"],
    "Florence": ["81226", "81290"],
    "Florissant": ["80816"],
    "Fort Collins": ["80521", "80522", "80523", "80524", "80525", "80526", "80527", "80528", "80553"],
    "Fort Garland": ["81133"],
    "Fort Lupton": ["80621"],
    "Fort Lyon": ["81038"],
    "Fort Morgan": ["80701"],
    "Fountain": ["80817"],
    "Fowler": ["81039"],
    "Franktown": ["80116"],
    "Fraser": ["80442"],
    "Frederick": ["80530"],
    "Frisco": ["80443"],
    "Fruita": ["81521"],
    "Galeton": ["80622"],
    "Gardner": ["81040"],
    "Gateway": ["81522"],
    "Genoa": ["80818"],
    "Georgetown": ["80444"],
    "Gilcrest": ["80623"],
    "Gill": ["80624"],
    "Glade Park": ["81523"],
    "Glen Haven": ["80532"],
    "Glenwood Springs": ["81601", "81602"],
    "Golden": ["80401", "80402", "80403", "80419"],
    "Granada": ["81041"],
    "Granby": ["80446"],
    "Grand Junction": ["81501", "81502", "81503", "81504", "81505", "81506", "81507"],
    "Grand Lake": ["80447"],
    "Granite": ["81228"],
    "Grant": ["80448"],
    "Greeley": ["80631", "80632", "80633", "80634", "80638", "80639"],
    "Green Mountain Falls": ["80819"],
    "Grover": ["80729"],
    "Guffey": ["80820"],
    "Gunnison": ["81230", "81231", "81247"],
    "Gypsum": ["81637"],
    "Hamilton": ["81638"],
    "Hartman": ["81043"],
    "Hartsel": ["80449"],
    "Hasty": ["81044"],
    "Haswell": ["81045"],
    "Haxtun": ["80731"],
    "Hayden": ["81639"],
    "Henderson": ["80640"],
    "Hereford": ["80732"],
    "Hesperus": ["81326"],
    "Hillrose": ["80733"],
    "Hillside": ["81232"],
    "Hoehne": ["81046"],
    "Holly": ["81047"],
    "Holyoke": ["80734"],
    "Homelake": ["81135"],
    "Hooper": ["81136"],
    "Hot Sulphur Springs": ["80451"],
    "Hotchkiss": ["81419"],
    "Howard": ["81233"],
    "Hudson": ["80642"],
    "Hugo": ["80821"],
    "Hygiene": ["80533"],
    "Idaho Springs": ["80452"],
    "Idalia": ["80735"],
    "Idledale": ["80453"],
    "Ignacio": ["81137"],
    "Iliff": ["80736"],
    "Indian Hills": ["80454"],
    "Jamestown": ["80455"],
    "Jaroso": ["81138"],
    "Jefferson": ["80456"],
    "Joes": ["80822"],
    "Johnstown": ["80534"],
    "Julesburg": ["80737"],
    "Karval": ["80823"],
    "Keenesburg": ["80643"],
    "Kersey": ["80644"],
    "Kim": ["81049"],
    "Kiowa": ["80117"],
    "Kirk": ["80824"],
    "Kit Carson": ["80825"],
    "Kittredge": ["80457"],
    "Kremmling": ["80459"],
    "La Jara": ["81140"],
    "La Junta": ["81050"],
    "La Salle": ["80645"],
    "La Veta": ["81055"],
    "Lafayette": ["80026"],
    "Lake City": ["81235"],
    "Lake George": ["80827"],
    "Lamar": ["81052"],
    "Laporte": ["80535"],
    "Larkspur": ["80118"],
    "Las Animas": ["81054"],
    "Lazear": ["81420"],
    "Leadville": ["80461"],
    "Lewis": ["81327"],
    "Limon": ["80826", "80828"],
    "Lindon": ["80740"],
    "Littleton": ["80120", "80121", "80122", "80123", "80125", "80126", "80127", "80128", "80129", "80130", "80160", "80161", "80162", "80163", "80165", "80166"],
    "Livermore": ["80536"],
    "Log Lane Village": ["80705"],
    "Loma": ["81524"],
    "Lone Tree": ["80124"],
    "Longmont": ["80501", "80502", "80503", "80504"],
    "Louisville": ["80027", "80028"],
    "Louviers": ["80131"],
    "Loveland": ["80537", "80538", "80539"],
    "Lucerne": ["80646"],
    "Lyons": ["80540"],
    "Mack": ["81525"],
    "Manassa": ["81141"],
    "Mancos": ["81328"],
    "Manitou Springs": ["80829"],
    "Manzanola": ["81058"],
    "Marvel": ["81329"],
    "Masonville": ["80541"],
    "Matheson": ["80830"],
    "Maybell": ["81640"],
    "Mc Clave": ["81057"],
    "Mc Coy": ["80463"],
    "Mead": ["80542"],
    "Meeker": ["81641"],
    "Meredith": ["81642"],
    "Merino": ["80741"],
    "Mesa": ["81643"],
    "Mesa Verde National Park": ["81330"],
    "Milliken": ["80543"],
    "Minturn": ["81645"],
    "Model": ["81059"],
    "Moffat": ["81143"],
    "Molina": ["81646"],
    "Monarch": ["81227"],
    "Monte Vista": ["81144"],
    "Montrose": ["81401", "81402", "81403"],
    "Monument": ["80132"],
    "Morrison": ["80465"],
    "Mosca": ["81146"],
    "Nathrop": ["81236"],
    "Naturita": ["81422"],
    "Nederland": ["80466"],
    "New Castle": ["81647"],
    "New Raymer": ["80742"],
    "Niwot": ["80544"],
    "Norwood": ["81423"],
    "Nucla": ["81424"],
    "Nunn": ["80648"],
    "Oak Creek": ["80467"],
    "Ohio City": ["81237"],
    "Olathe": ["81425"],
    "Olney Springs": ["81062"],
    "Ophir": ["81426"],
    "Orchard": ["80649"],
    "Ordway": ["81034", "81063"],
    "Otis": ["80743"],
    "Ouray": ["81427"],
    "Ovid": ["80744"],
    "Padroni": ["80745"],
    "Pagosa Springs": ["81147", "81157"],
    "Palisade": ["81526"],
    "Palmer Lake": ["80133"],
    "Paoli": ["80746"],
    "Paonia": ["81428"],
    "Parachute": ["81635"],
    "Paradox": ["81429"],
    "Parker": ["80134", "80138"],
    "Parlin": ["81239"],
    "Parshall": ["80468"],
    "Peetz": ["80747"],
    "Penrose": ["81240"],
    "Peyton": ["80831"],
    "Phippsburg": ["80469"],
    "Pierce": ["80650"],
    "Pine": ["80470"],
    "Pinecliffe": ["80471"],
    "Pitkin": ["81241"],
    "Placerville": ["81430"],
    "Platteville": ["80651"],
    "Pleasant View": ["81331"],
    "Poncha Springs": ["81242"],
    "Powderhorn": ["81243"],
    "Pritchett": ["81064"],
    "Pueblo": ["81001", "81002", "81003", "81004", "81005", "81006", "81007", "81008", "81009", "81010", "81011", "81012"],
    "Ramah": ["80832"],
    "Rand": ["80473"],
    "Rangely": ["81648"],
    "Red Cliff": ["81649"],
    "Red Feather Lakes": ["80545"],
    "Redvale": ["81431"],
    "Rico": ["81332"],
    "Ridgway": ["81432"],
    "Rifle": ["81650"],
    "Rockvale": ["81244"],
    "Rocky Ford": ["81067"],
    "Roggen": ["80652"],
    "Rollinsville": ["80474"],
    "Romeo": ["81148"],
    "Rush": ["80833"],
    "Rye": ["81069"],
    "Saguache": ["81149"],
    "Salida": ["81201"],
    "San Luis": ["81134", "81152"],
    "San Pablo": ["81153"],
    "Sanford": ["81151"],
    "Sargents": ["81248"],
    "Sedalia": ["80135"],
    "Sedgwick": ["80749"],
    "Seibert": ["80834"],
    "Severance": ["80546"],
    "Shawnee": ["80475"],
    "Sheridan Lake": ["81071"],
    "Silt": ["81652"],
    "Silver Plume": ["80476"],
    "Silverthorne": ["80497", "80498"],
    "Silverton": ["81433"],
    "Simla": ["80835"],
    "Slater": ["81653"],
    "Snowmass": ["81654"],
    "Snowmass Village": ["81615"],
    "Snyder": ["80750"],
    "Somerset": ["81434"],
    "South Fork": ["81154"],
    "Springfield": ["81073"],
    "Steamboat Springs": ["80477", "80487", "80488"],
    "Sterling": ["80751"],
    "Stoneham": ["80754"],
    "Stonington": ["81075"],
    "Strasburg": ["80136"],
    "Stratton": ["80836"],
    "Sugar City": ["81076"],
    "Swink": ["81077"],
    "Tabernash": ["80478"],
    "Telluride": ["81435"],
    "Thornton": ["80241"],
    "Timnath": ["80547"],
    "Toponas": ["80479"],
    "Towaoc": ["81334"],
    "Trinchera": ["81081"],
    "Trinidad": ["81082"],
    "Twin Lakes": ["81251"],
    "Two Buttes": ["81084"],
    "Usaf Academy": ["80840", "80841"],
    "Vail": ["81657", "81658"],
    "Vernon": ["80755"],
    "Victor": ["80860"],
    "Vilas": ["81087"],
    "Villa Grove": ["81155"],
    "Vona": ["80861"],
    "Walden": ["80480"],
    "Walsenburg": ["81089"],
    "Walsh": ["81090"],
    "Ward": ["80481"],
    "Watkins": ["80137"],
    "Weldona": ["80653"],
    "Wellington": ["80549"],
    "Westcliffe": ["81252"],
    "Westminster": ["80030", "80031", "80035", "80036"],
    "Weston": ["81091"],
    "Wetmore": ["81253"],
    "Wheat Ridge": ["80033", "80034"],
    "Whitewater": ["81527"],
    "Wiggins": ["80654"],
    "Wild Horse": ["80862"],
    "Wiley": ["81092"],
    "Windsor": ["80550", "80551"],
    "Winter Park": ["80482"],
    "Wolcott": ["81655"],
    "Woodland Park": ["80863", "80866"],
    "Woodrow": ["80757"],
    "Woody Creek": ["81656"],
    "Wray": ["80758"],
    "Yampa": ["80483"],
    "Yellow Jacket": ["81335"],
    "Yoder": ["80864"],
    "Yuma": ["80759"]
  },
  "CT": {
    "Abington": ["06230"],
    "Amston": ["06231"],
    "Andover": ["06232"],
    "Ansonia": ["06401"],
    "Ashford": ["06278"],
    "Avon": ["06001"],
    "Ballouville": ["06233"],
    "Baltic": ["06330"],
    "Bantam": ["06750"],
    "Barkhamsted": ["06063"],
    "Beacon Falls": ["06403"],
    "Berlin": ["06037"],
    "Bethany": ["06524"],
    "Bethel": ["06801"],
    "Bethlehem": ["06751"],
    "Bloomfield": ["06002"],
    "Bolton": ["06043"],
    "Botsford": ["06404"],
    "Bozrah": ["06334"],
    "Branford": ["06405"],
    "Bridgeport": ["06601", "06602", "06604", "06605", "06606", "06607", "06608", "06610", "06650", "06673", "06699"],
    "Bridgewater": ["06752"],
    "Bristol": ["06010", "06011"],
    "Broad Brook": ["06016"],
    "Brookfield": ["06804"],
    "Brooklyn": ["06234"],
    "Burlington": ["06013"],
    "Canaan": ["06018"],
    "Canterbury": ["06331"],
    "Canton": ["06019"],
    "Canton Center": ["06020"],
    "Centerbrook": ["06409"],
    "Central Village": ["06332"],
    "Chaplin": ["06235"],
    "Cheshire": ["06408", "06410", "06411"],
    "Chester": ["06412"],
    "Clinton": ["06413"],
    "Cobalt": ["06414"],
    "Colchester": ["06415"],
    "Colebrook": ["06021"],
    "Collinsville": ["06022"],
    "Columbia": ["06237"],
    "Cornwall": ["06753"],
    "Cornwall Bridge": ["06754"],
    "Cos Cob": ["06807"],
    "Coventry": ["06238"],
    "Cromwell": ["06416"],
    "Danbury": ["06810", "06811", "06813", "06814", "06816", "06817"],
    "Danielson": ["06239"],
    "Darien": ["06820"],
    "Dayville": ["06241"],
    "Deep River": ["06417"],
    "Derby": ["06418"],
    "Durham": ["06422"],
    "East Berlin": ["06023"],
    "East Canaan": ["06024"],
    "East Glastonbury": ["06025"],
    "East Granby": ["06026"],
    "East Haddam": ["06423"],
    "East Hampton": ["06424"],
    "East Hartford": ["06108", "06118", "06128", "06138"],
    "East Hartland": ["06027"],
    "East Haven": ["06512"],
    "East Killingly": ["06243"],
    "East Lyme": ["06333"],
    "East Windsor": ["06088"],
    "East Windsor Hill": ["06028"],
    "East Woodstock": ["06244"],
    "Eastford": ["06242"],
    "Easton": ["06612"],
    "Ellington": ["06029"],
    "Enfield": ["06082", "06083"],
    "Essex": ["06426"],
    "Fabyan": ["06245"],
    "Fairfield": ["06824", "06825", "06828"],
    "Falls Village": ["06031"],
    "Farmington": ["06030", "06032", "06034"],
    "Gales Ferry": ["06335"],
    "Gaylordsville": ["06755"],
    "Georgetown": ["06829"],
    "Gilman": ["06336"],
    "Glastonbury": ["06033"],
    "Goshen": ["06756"],
    "Granby": ["06035"],
    "Greens Farms": ["06838"],
    "Greenwich": ["06830", "06831", "06832", "06836"],
    "Grosvenor Dale": ["06246"],
    "Groton": ["06340", "06349"],
    "Guilford": ["06437"],
    "Haddam": ["06438"],
    "Hadlyme": ["06439"],
    "Hamden": ["06514", "06517", "06518"],
    "Hampton": ["06247"],
    "Hanover": ["06350"],
    "Hartford": ["06101", "06102", "06103", "06104", "06105", "06106", "06112", "06114", "06115", "06120", "06123", "06126", "06132", "06134", "06140", "06141", "06142", "06143", "06144", "06145", "06146", "06147", "06150", "06151", "06152", "06153", "06154", "06155", "06156", "06160", "06161", "06167", "06176", "06180", "06183", "06199"],
    "Harwinton": ["06791"],
    "Hawleyville": ["06440"],
    "Hebron": ["06248"],
    "Higganum": ["06441"],
    "Ivoryton": ["06442"],
    "Jewett City": ["06351"],
    "Kent": ["06757"],
    "Killingworth": ["06419"],
    "Lakeside": ["06758"],
    "Lakeville": ["06039"],
    "Lebanon": ["06249"],
    "Ledyard": ["06339"],
    "Litchfield": ["06759"],
    "Madison": ["06443"],
    "Manchester": ["06040", "06041", "06042", "06045"],
    "Mansfield Center": ["06250"],
    "Mansfield Depot": ["06251"],
    "Marion": ["06444"],
    "Marlborough": ["06447"],
    "Mashantucket": ["06338"],
    "Meriden": ["06450", "06451", "06454"],
    "Middle Haddam": ["06456"],
    "Middlebury": ["06762"],
    "Middlefield": ["06455"],
    "Middletown": ["06457", "06459"],
    "Milford": ["06460", "06461"],
    "Milldale": ["06467"],
    "Monroe": ["06468"],
    "Montville": ["06353"],
    "Moodus": ["06469"],
    "Moosup": ["06354"],
    "Morris": ["06763"],
    "Mystic": ["06355"],
    "Naugatuck": ["06770"],
    "New Britain": ["06050", "06051", "06052", "06053"],
    "New Canaan": ["06840", "06842"],
    "New Fairfield": ["06812"],
    "New Hartford": ["06057"],
    "New Haven": ["06501", "06502", "06503", "06504", "06505", "06506", "06507", "06508", "06509", "06510", "06511", "06513", "06515", "06519", "06520", "06521", "06530", "06531", "06532", "06533", "06534", "06535", "06536", "06537", "06538", "06540"],
    "New London": ["06320"],
    "New Milford": ["06776"],
    "New Preston Marble Dale": ["06777"],
    "Newington": ["06111", "06131"],
    "Newtown": ["06470"],
    "Niantic": ["06357"],
    "Norfolk": ["06058"],
    "North Branford": ["06471"],
    "North Canton": ["06059"],
    "North Franklin": ["06254"],
    "North Granby": ["06060"],
    "North Grosvenordale": ["06255"],
    "North Haven": ["06473"],
    "North Stonington": ["06359"],
    "North Westchester": ["06474"],
    "North Windham": ["06256"],
    "Northfield": ["06778"],
    "Northford": ["06472"],
    "Norwalk": ["06850", "06851", "06852", "06853", "06854", "06855", "06856", "06857", "06858", "06859", "06860"],
    "Norwich": ["06360"],
    "Oakdale": ["06370"],
    "Oakville": ["06779"],
    "Old Greenwich": ["06870"],
    "Old Lyme": ["06371"],
    "Old Mystic": ["06372"],
    "Old Saybrook": ["06475"],
    "Oneco": ["06373"],
    "Orange": ["06477"],
    "Oxford": ["06478"],
    "Pawcatuck": ["06379"],
    "Pequabuck": ["06781"],
    "Pine Meadow": ["06061"],
    "Plainfield": ["06374"],
    "Plainville": ["06062"],
    "Plantsville": ["06479"],
    "Plymouth": ["06782"],
    "Pomfret": ["06258"],
    "Pomfret Center": ["06259"],
    "Poquonock": ["06064"],
    "Portland": ["06480"],
    "Preston": ["06365"],
    "Prospect": ["06712"],
    "Putnam": ["06260"],
    "Quaker Hill": ["06375"],
    "Quinebaug": ["06262"],
    "Redding": ["06896"],
    "Redding Center": ["06875"],
    "Redding Ridge": ["06876"],
    "Ridgefield": ["06877", "06879"],
    "Riverside": ["06878"],
    "Riverton": ["06065"],
    "Rockfall": ["06481"],
    "Rocky Hill": ["06067"],
    "Rogers": ["06263"],
    "Roxbury": ["06783"],
    "Salem": ["06420"],
    "Salisbury": ["06068"],
    "Sandy Hook": ["06482"],
    "Scotland": ["06264"],
    "Seymour": ["06483"],
    "Sharon": ["06069"],
    "Shelton": ["06484"],
    "Sherman": ["06784"],
    "Simsbury": ["06070"],
    "Somers": ["06071"],
    "Somersville": ["06072"],
    "South Britain": ["06487"],
    "South Glastonbury": ["06073"],
    "South Kent": ["06785"],
    "South Lyme": ["06376"],
    "South Willington": ["06265"],
    "South Windham": ["06266"],
    "South Windsor": ["06074"],
    "South Woodstock": ["06267"],
    "Southbury": ["06488"],
    "Southington": ["06489"],
    "Southport": ["06890"],
    "Stafford": ["06075"],
    "Stafford Springs": ["06076"],
    "Staffordville": ["06077"],
    "Stamford": ["06901", "06902", "06903", "06904", "06905", "06906", "06907", "06910", "06911", "06912", "06913", "06914", "06920", "06921", "06922", "06925", "06926", "06927", "06928"],
    "Sterling": ["06377"],
    "Stevenson": ["06491"],
    "Stonington": ["06378"],
    "Storrs Mansfield": ["06268", "06269"],
    "Stratford": ["06497", "06614", "06615"],
    "Suffield": ["06078", "06080"],
    "Taconic": ["06079"],
    "Taftville": ["06380"],
    "Tariffville": ["06081"],
    "Terryville": ["06786"],
    "Thomaston": ["06787"],
    "Thompson": ["06277"],
    "Tolland": ["06084"],
    "Torrington": ["06790", "06792"],
    "Trumbull": ["06611"],
    "Uncasville": ["06382"],
    "Unionville": ["06085", "06087"],
    "Vernon Rockville": ["06066"],
    "Versailles": ["06383"],
    "Voluntown": ["06384"],
    "Wallingford": ["06492", "06493", "06494", "06495"],
    "Washington": ["06793"],
    "Washington Depot": ["06794"],
    "Waterbury": ["06701", "06702", "06703", "06704", "06705", "06706", "06708", "06710", "06720", "06721", "06722", "06723", "06724", "06725", "06726", "06749"],
    "Waterford": ["06385", "06386"],
    "Watertown": ["06795"],
    "Wauregan": ["06387"],
    "Weatogue": ["06089"],
    "West Cornwall": ["06796"],
    "West Granby": ["06090"],
    "West Hartford": ["06107", "06110", "06117", "06119", "06127", "06133", "06137"],
    "West Hartland": ["06091"],
    "West Haven": ["06516"],
    "West Mystic": ["06388"],
    "West Simsbury": ["06092"],
    "West Suffield": ["06093"],
    "Westbrook": ["06498"],
    "Weston": ["06883"],
    "Westport": ["06880", "06881", "06888", "06889"],
    "Wethersfield": ["06109", "06129"],
    "Willimantic": ["06226"],
    "Willington": ["06279"],
    "Wilton": ["06897"],
    "Winchester Center": ["06094"],
    "Windham": ["06280"],
    "Windsor": ["06006", "06095"],
    "Windsor Locks": ["06096"],
    "Winsted": ["06098"],
    "Wolcott": ["06716"],
    "Woodbridge": ["06525"],
    "Woodbury": ["06798"],
    "Woodstock": ["06281"],
    "Woodstock Valley": ["06282"],
    "Yantic": ["06389"]
  },
  "DC": {
    "Naval Anacost Annex": ["20373"],
    "North Pole": ["88888"],
    "Parcel Return Service": ["56901", "56902", "56904", "56908", "56915", "56920", "56933", "56935", "56944", "56945", "56950", "56964", "56965", "56966", "56967", "56968", "56969", "56970", "56971", "56972", "56973", "56980", "56981", "56982", "56983", "56984", "56985", "56998", "56999"],
    "Washington": ["20001", "20002", "20003", "20004", "20005", "20006", "20007", "20008", "20009", "20010", "20011", "20012", "20013", "20015", "20016", "20017", "20018", "20019", "20020", "20022", "20023", "20024", "20026", "20027", "20029", "20030", "20032", "20033", "20035", "20036", "20037", "20038", "20039", "20040", "20041", "20042", "20043", "20044", "20045", "20046", "20047", "20049", "20050", "20051", "20052", "20053", "20055", "20056", "20057", "20058", "20059", "20060", "20061", "20062", "20063", "20064", "20065", "20066", "20067", "20068", "20069", "20070", "20071", "20073", "20074", "20075", "20076", "20077", "20078", "20080", "20081", "20082", "20088", "20090", "20091", "20097", "20098", "20201", "20202", "20203", "20204", "20206", "20207", "20208", "20210", "20211", "20212", "20213", "20214", "20215", "20216", "20217", "20218", "20219", "20220", "20221", "20222", "20223", "20224", "20226", "20227", "20228", "20229", "20230", "20232", "20233", "20235", "20237", "20238", "20239", "20240", "20241", "20242", "20244", "20245", "20250", "20251", "20252", "20254", "20260", "20261", "20262", "20265", "20266", "20268", "20270", "20277", "20289", "20299", "20301", "20303", "20306", "20307", "20310", "20314", "20317", "20318", "20319", "20330", "20340", "20350", "20355", "20370", "20372", "20375", "20380", "20389", "20390", "20392", "20393", "20394", "20395", "20401", "20402", "20403", "20404", "20405", "20406", "20407", "20408", "20409", "20410", "20411", "20412", "20413", "20414", "20415", "20416", "20417", "20418", "20419", "20420", "20421", "20422", "20423", "20424", "20425", "20426", "20427", "20428", "20429", "20431", "20433", "20434", "20435", "20436", "20437", "20439", "20440", "20441", "20442", "20444", "20447", "20451", "20453", "20456", "20460", "20463", "20468", "20469", "20470", "20472", "20500", "20501", "20502", "20503", "20504", "20505", "20506", "20507", "20508", "20509", "20510", "20511", "20515", "20520", "20521", "20522", "20523", "20524", "20525", "20526", "20527", "20528", "20529", "20530", "20531", "20532", "20533", "20534", "20535", "20536", "20537", "20538", "20539", "20540", "20541", "20542", "20543", "20544", "20546", "20547", "20548", "20549", "20551", "20552", "20553", "20554", "20555", "20557", "20558", "20559", "20560", "20565", "20566", "20570", "20571", "20572", "20573", "20575", "20576", "20577", "20578", "20579", "20580", "20581", "20585", "20586", "20590", "20591", "20593", "20594", "20597", "20599"],
    "Washington Navy Yard": ["20374", "20376", "20388", "20391", "20398"]
  },
  "DE": {
    "Bear": ["19701"],
    "Bethany Beach": ["19930"],
    "Bethel": ["19931"],
    "Bridgeville": ["19933"],
    "Camden Wyoming": ["19934"],
    "Cheswold": ["19936"],
    "Claymont": ["19703"],
    "Clayton": ["19938"],
    "Dagsboro": ["19939"],
    "Delaware City": ["19706"],
    "Delmar": ["19940"],
    "Dover": ["19901", "19903", "19904", "19905", "19906"],
    "Dover AFB": ["19902"],
    "Ellendale": ["19941"],
    "Felton": ["19943"],
    "Fenwick Island": ["19944"],
    "Frankford": ["19945"],
    "Frederica": ["19946"],
    "Georgetown": ["19947"],
    "Greenwood": ["19950"],
    "Harbeson": ["19951"],
    "Harrington": ["19952"],
    "Hartly": ["19953"],
    "Hockessin": ["19707"],
    "Houston": ["19954"],
    "Kenton": ["19955"],
    "Kirkwood": ["19708"],
    "Laurel": ["19956"],
    "Lewes": ["19958"],
    "Lincoln": ["19960"],
    "Little Creek": ["19961"],
    "Magnolia": ["19962"],
    "Marydel": ["19964"],
    "Middletown": ["19709"],
    "Milford": ["19963"],
    "Millsboro": ["19966"],
    "Millville": ["19967"],
    "Milton": ["19968"],
    "Montchanin": ["19710"],
    "Nassau": ["19969"],
    "New Castle": ["19720", "19721", "19726"],
    "Newark": ["19702", "19711", "19712", "19713", "19714", "19715", "19716", "19717", "19718", "19725"],
    "Ocean View": ["19970"],
    "Odessa": ["19730"],
    "Port Penn": ["19731"],
    "Rehoboth Beach": ["19971"],
    "Rockland": ["19732"],
    "Saint Georges": ["19733"],
    "Seaford": ["19973"],
    "Selbyville": ["19975"],
    "Smyrna": ["19977"],
    "Townsend": ["19734"],
    "Viola": ["19979"],
    "Wilmington": ["19801", "19802", "19803", "19804", "19805", "19806", "19807", "19808", "19809", "19810", "19850", "19880", "19884", "19885", "19886", "19887", "19889", "19890", "19891", "19892", "19893", "19894", "19895", "19896", "19897", "19898", "19899"],
    "Winterthur": ["19735"],
    "Woodside": ["19980"],
    "Yorklyn": ["19736"]
  },
  "FL": {
    "Alachua": ["32615", "32616"],
    "Alford": ["32420"],
    "Altamonte Springs": ["32701", "32714", "32715", "32716"],
    "Altha": ["32421"],
    "Altoona": ["32702"],
    "Alturas": ["33820"],
    "Alva": ["33920"],
    "Anna Maria": ["34216"],
    "Anthony": ["32617"],
    "Apalachicola": ["32320", "32329"],
    "Apollo Beach": ["33572"],
    "Apopka": ["32703", "32704", "32712"],
    "Arcadia": ["34265", "34266", "34269"],
    "Archer": ["32618"],
    "Argyle": ["32422"],
    "Aripeka": ["34679"],
    "Astatula": ["34705"],
    "Astor": ["32102"],
    "Atlantic Beach": ["32233"],
    "Auburndale": ["33823"],
    "Avon Park": ["33825", "33826"],
    "Babson Park": ["33827"],
    "Bagdad": ["32530"],
    "Baker": ["32531"],
    "Balm": ["33503"],
    "Barberville": ["32105"],
    "Bartow": ["33830", "33831"],
    "Bascom": ["32423"],
    "Bay Pines": ["33744"],
    "Bell": ["32619"],
    "Belle Glade": ["33430"],
    "Belleair Beach": ["33786"],
    "Belleview": ["34420", "34421"],
    "Beverly Hills": ["34464", "34465"],
    "Big Pine Key": ["33043"],
    "Blountstown": ["32424"],
    "Boca Grande": ["33921"],
    "Boca Raton": ["33427", "33428", "33429", "33431", "33432", "33433", "33434", "33464", "33481", "33486", "33487", "33488", "33496", "33497", "33498", "33499"],
    "Bokeelia": ["33922"],
    "Bonifay": ["32425"],
    "Bonita Springs": ["34133", "34134", "34135", "34136"],
    "Bostwick": ["32007"],
    "Bowling Green": ["33834"],
    "Boynton Beach": ["33424", "33425", "33426", "33435", "33436", "33437", "33472", "33473", "33474"],
    "Bradenton": ["34201", "34202", "34203", "34204", "34205", "34206", "34207", "34208", "34209", "34210", "34211", "34212", "34280", "34281", "34282"],
    "Bradenton Beach": ["34217"],
    "Bradley": ["33835"],
    "Brandon": ["33508", "33509", "33510", "33511"],
    "Branford": ["32008"],
    "Bristol": ["32321"],
    "Bronson": ["32621"],
    "Brooker": ["32622"],
    "Brooksville": ["34601", "34602", "34603", "34604", "34605", "34613", "34614"],
    "Bryceville": ["32009"],
    "Bunnell": ["32110"],
    "Bushnell": ["33513"],
    "Callahan": ["32011"],
    "Campbellton": ["32426"],
    "Canal Point": ["33438", "33439"],
    "Candler": ["32111"],
    "Cantonment": ["32533"],
    "Cape Canaveral": ["32920"],
    "Cape Coral": ["33904", "33909", "33910", "33914", "33915", "33990", "33991", "33993"],
    "Captiva": ["33924"],
    "Carrabelle": ["32322"],
    "Caryville": ["32427"],
    "Cassadaga": ["32706"],
    "Casselberry": ["32707", "32718", "32730"],
    "Cedar Key": ["32625"],
    "Center Hill": ["33514"],
    "Century": ["32535"],
    "Chattahoochee": ["32324"],
    "Chiefland": ["32626", "32644"],
    "Chipley": ["32428"],
    "Chokoloskee": ["34138"],
    "Christmas": ["32709"],
    "Citra": ["32113"],
    "Clarcona": ["32710"],
    "Clarksville": ["32430"],
    "Clearwater": ["33755", "33756", "33757", "33758", "33759", "33760", "33761", "33762", "33763", "33764", "33765", "33766", "33769"],
    "Clearwater Beach": ["33767"],
    "Clermont": ["34711", "34712", "34713", "34714", "34715"],
    "Clewiston": ["33440"],
    "Cocoa": ["32922", "32923", "32924", "32926", "32927"],
    "Cocoa Beach": ["32931", "32932"],
    "Coconut Creek": ["33097"],
    "Coleman": ["33521"],
    "Copeland": ["34137"],
    "Coral Gables": ["33114"],
    "Coral Springs": ["33065", "33071", "33075"],
    "Cortez": ["34215"],
    "Cottondale": ["32431"],
    "Crawfordville": ["32326", "32327"],
    "Crescent City": ["32112"],
    "Crestview": ["32536", "32539"],
    "Cross City": ["32628"],
    "Crystal Beach": ["34681"],
    "Crystal River": ["34423", "34428", "34429"],
    "Crystal Springs": ["33524"],
    "Cypress": ["32432"],
    "Dade City": ["33523", "33525", "33526"],
    "Dania": ["33004"],
    "Davenport": ["33836", "33837", "33896", "33897"],
    "Day": ["32013"],
    "Daytona Beach": ["32114", "32115", "32116", "32117", "32118", "32119", "32120", "32121", "32122", "32124", "32125", "32126", "32198"],
    "De Leon Springs": ["32130"],
    "Debary": ["32713", "32753"],
    "Deerfield Beach": ["33441", "33442", "33443"],
    "Defuniak Springs": ["32433", "32435"],
    "Deland": ["32720", "32721", "32723", "32724"],
    "Delray Beach": ["33444", "33445", "33446", "33447", "33448", "33482", "33483", "33484"],
    "Deltona": ["32725", "32728", "32738", "32739"],
    "Destin": ["32540", "32541"],
    "Doctors Inlet": ["32030"],
    "Dover": ["33527"],
    "Dundee": ["33838"],
    "Dunedin": ["34697", "34698"],
    "Dunnellon": ["34430", "34431", "34432", "34433", "34434"],
    "Durant": ["33530"],
    "Eagle Lake": ["33839"],
    "Earleton": ["32631"],
    "East Palatka": ["32131"],
    "Eastlake Weir": ["32133"],
    "Eastpoint": ["32328"],
    "Eaton Park": ["33840"],
    "Ebro": ["32437"],
    "Edgewater": ["32132", "32141"],
    "Eglin AFB": ["32542"],
    "El Jobean": ["33927"],
    "Elfers": ["34680"],
    "Elkton": ["32033"],
    "Ellenton": ["34222"],
    "Englewood": ["34223", "34224", "34295"],
    "Estero": ["33928", "33929"],
    "Eustis": ["32726", "32727", "32736"],
    "Everglades City": ["34139"],
    "Evinston": ["32633"],
    "Fairfield": ["32634"],
    "Felda": ["33930"],
    "Fellsmere": ["32948"],
    "Fernandina Beach": ["32034", "32035"],
    "Ferndale": ["34729"],
    "Flagler Beach": ["32136"],
    "Fleming Island": ["32003", "32006"],
    "Florahome": ["32140"],
    "Floral City": ["34436"],
    "Fort Lauderdale": ["33301", "33302", "33303", "33304", "33305", "33306", "33307", "33308", "33309", "33310", "33311", "33312", "33313", "33314", "33315", "33316", "33317", "33318", "33319", "33320", "33321", "33322", "33323", "33324", "33325", "33326", "33327", "33328", "33329", "33330", "33331", "33332", "33334", "33335", "33336", "33337", "33338", "33339", "33340", "33345", "33346", "33348", "33349", "33351", "33355", "33359", "33394"],
    "Fort Mc Coy": ["32134"],
    "Fort Meade": ["33841"],
    "Fort Myers": ["33900", "33901", "33902", "33905", "33906", "33907", "33908", "33911", "33912", "33913", "33916", "33919", "33965", "33966", "33967", "33994"],
    "Fort Myers Beach": ["33931", "33932"],
    "Fort Ogden": ["34267"],
    "Fort Pierce": ["34945", "34946", "34947", "34948", "34949", "34950", "34951", "34954", "34979", "34981", "34982"],
    "Fort Walton Beach": ["32547", "32548", "32549"],
    "Fort White": ["32038"],
    "Fountain": ["32438"],
    "Freeport": ["32439"],
    "Frostproof": ["33843"],
    "Fruitland Park": ["34731"],
    "Gainesville": ["32601", "32602", "32603", "32604", "32605", "32606", "32607", "32608", "32609", "32610", "32611", "32612", "32613", "32614", "32627", "32635", "32641", "32653"],
    "Geneva": ["32732"],
    "Georgetown": ["32139"],
    "Gibsonton": ["33534"],
    "Glen Saint Mary": ["32040"],
    "Glenwood": ["32722"],
    "Goldenrod": ["32733"],
    "Gonzalez": ["32560"],
    "Goodland": ["34140"],
    "Gotha": ["34734"],
    "Graceville": ["32440"],
    "Graham": ["32042"],
    "Grand Island": ["32735"],
    "Grand Ridge": ["32442"],
    "Grandin": ["32138"],
    "Grant": ["32949"],
    "Green Cove Springs": ["32043"],
    "Greenacres": ["33454"],
    "Greensboro": ["32330"],
    "Greenville": ["32331"],
    "Greenwood": ["32443"],
    "Gretna": ["32332"],
    "Groveland": ["34736"],
    "Gulf Breeze": ["32561", "32562", "32563"],
    "Gulf Hammock": ["32639"],
    "Haines City": ["33844", "33845"],
    "Hallandale": ["33008", "33009"],
    "Hampton": ["32044"],
    "Hastings": ["32145"],
    "Havana": ["32333"],
    "Hawthorne": ["32640"],
    "Hernando": ["34441", "34442"],
    "Hialeah": ["33002", "33010", "33011", "33012", "33013", "33014", "33015", "33016", "33017", "33018"],
    "High Springs": ["32643", "32655"],
    "Highland City": ["33846"],
    "Hilliard": ["32046"],
    "Hobe Sound": ["33455", "33475"],
    "Holder": ["34445"],
    "Holiday": ["34690", "34691", "34692"],
    "Hollister": ["32147"],
    "Hollywood": ["33019", "33020", "33021", "33022", "33023", "33024", "33025", "33026", "33027", "33029", "33081", "33083", "33084"],
    "Holmes Beach": ["34218"],
    "Holt": ["32564"],
    "Homeland": ["33847"],
    "Homestead": ["33030", "33031", "33032", "33033", "33034", "33035", "33039", "33090", "33092"],
    "Homosassa": ["34446", "34448", "34487"],
    "Homosassa Springs": ["34447"],
    "Horseshoe Beach": ["32648"],
    "Hosford": ["32334"],
    "Howey In The Hills": ["34737"],
    "Hudson": ["34667", "34669", "34674"],
    "Hurlburt Field": ["32544"],
    "Immokalee": ["34142", "34143"],
    "Indialantic": ["32903"],
    "Indian Lake Estates": ["33855"],
    "Indian Rocks Beach": ["33785"],
    "Indiantown": ["34956"],
    "Inglis": ["34449"],
    "Inlet Beach": ["32461"],
    "Intercession City": ["33848"],
    "Interlachen": ["32148", "32149"],
    "Inverness": ["34450", "34451", "34452", "34453"],
    "Islamorada": ["33036"],
    "Island Grove": ["32654"],
    "Istachatta": ["34636"],
    "Jacksonville": ["32099", "32201", "32202", "32203", "32204", "32205", "32206", "32207", "32208", "32209", "32210", "32211", "32212", "32214", "32215", "32216", "32217", "32218", "32219", "32220", "32221", "32222", "32223", "32224", "32225", "32226", "32227", "32228", "32229", "32230", "32231", "32232", "32234", "32235", "32236", "32237", "32238", "32239", "32241", "32244", "32245", "32246", "32247", "32254", "32255", "32256", "32257", "32258", "32260", "32267", "32277", "32290"],
    "Jacksonville Beach": ["32240", "32250"],
    "Jasper": ["32052"],
    "Jay": ["32565"],
    "Jennings": ["32053"],
    "Jensen Beach": ["34957", "34958"],
    "Jupiter": ["33458", "33468", "33469", "33477", "33478"],
    "Kathleen": ["33849"],
    "Kenansville": ["34739"],
    "Key Biscayne": ["33149"],
    "Key Colony Beach": ["33051"],
    "Key Largo": ["33037"],
    "Key West": ["33040", "33041", "33045"],
    "Keystone Heights": ["32656"],
    "Killarney": ["34740"],
    "Kissimmee": ["34741", "34742", "34743", "34744", "34745", "34746", "34747", "34758", "34759"],
    "La Crosse": ["32658"],
    "Labelle": ["33935", "33975"],
    "Lacoochee": ["33537"],
    "Lady Lake": ["32158", "32159"],
    "Lake Alfred": ["33850"],
    "Lake Butler": ["32054"],
    "Lake City": ["32024", "32025", "32055", "32056"],
    "Lake Como": ["32157"],
    "Lake Geneva": ["32160"],
    "Lake Hamilton": ["33851"],
    "Lake Harbor": ["33459"],
    "Lake Helen": ["32744"],
    "Lake Mary": ["32746", "32795"],
    "Lake Monroe": ["32747"],
    "Lake Panasoffkee": ["33538"],
    "Lake Placid": ["33852", "33862"],
    "Lake Wales": ["33853", "33859", "33898"],
    "Lake Worth": ["33449", "33461", "33462", "33463", "33465", "33466", "33467"],
    "Lake Worth Beach": ["33460"],
    "Lakeland": ["33801", "33802", "33803", "33804", "33805", "33806", "33807", "33809", "33810", "33811", "33812", "33813", "33815"],
    "Lakeshore": ["33854"],
    "Lamont": ["32336"],
    "Lanark Village": ["32323"],
    "Land O Lakes": ["34637", "34638", "34639"],
    "Largo": ["33770", "33771", "33773", "33774", "33778", "33779"],
    "Laurel": ["34272"],
    "Laurel Hill": ["32567"],
    "Lawtey": ["32058"],
    "Lecanto": ["34460", "34461"],
    "Lee": ["32059"],
    "Leesburg": ["34748", "34749", "34788", "34789"],
    "Lehigh Acres": ["33936", "33970", "33971", "33972", "33973", "33974", "33976"],
    "Lithia": ["33547"],
    "Live Oak": ["32060", "32064"],
    "Lloyd": ["32337"],
    "Lochloosa": ["32662"],
    "Long Key": ["33001"],
    "Longboat Key": ["34228"],
    "Longwood": ["32750", "32752", "32779", "32791"],
    "Lorida": ["33857"],
    "Loughman": ["33858"],
    "Lowell": ["32663"],
    "Loxahatchee": ["33470"],
    "Lulu": ["32061"],
    "Lutz": ["33548", "33549", "33558", "33559"],
    "Lynn Haven": ["32444"],
    "Macclenny": ["32063"],
    "Madison": ["32340", "32341"],
    "Maitland": ["32751", "32794"],
    "Malabar": ["32950"],
    "Malone": ["32445"],
    "Mango": ["33550"],
    "Marathon": ["33050"],
    "Marathon Shores": ["33052"],
    "Marco Island": ["34145", "34146"],
    "Margate": ["33093"],
    "Marianna": ["32446", "32447", "32448"],
    "Mary Esther": ["32569"],
    "Mascotte": ["34753"],
    "Mayo": ["32066"],
    "Mc Alpin": ["32062"],
    "Mc David": ["32568"],
    "Mc Intosh": ["32664"],
    "Melbourne": ["32901", "32902", "32904", "32912", "32919", "32934", "32935", "32936", "32940", "32941"],
    "Melbourne Beach": ["32951"],
    "Melrose": ["32666"],
    "Merritt Island": ["32952", "32953", "32954"],
    "Mexico Beach": ["32410"],
    "Miami": ["33101", "33102", "33106", "33107", "33110", "33111", "33112", "33116", "33121", "33122", "33124", "33125", "33126", "33127", "33128", "33129", "33130", "33131", "33132", "33133", "33134", "33135", "33136", "33137", "33138", "33142", "33143", "33144", "33145", "33146", "33147", "33148", "33150", "33151", "33152", "33153", "33155", "33156", "33157", "33158", "33159", "33161", "33162", "33163", "33164", "33165", "33166", "33167", "33168", "33169", "33170", "33172", "33173", "33174", "33175", "33176", "33177", "33178", "33179", "33180", "33181", "33182", "33183", "33184", "33185", "33186", "33187", "33188", "33189", "33190", "33191", "33192", "33193", "33194", "33195", "33196", "33197", "33198", "33199", "33206", "33222", "33231", "33233", "33234", "33238", "33242", "33243", "33245", "33247", "33255", "33256", "33257", "33261", "33265", "33266", "33269", "33280", "33283", "33296", "33299"],
    "Miami Beach": ["33109", "33119", "33139", "33140", "33141", "33154", "33239"],
    "Miami Gardens": ["33056"],
    "Micanopy": ["32667"],
    "Mid Florida": ["32745", "32799"],
    "Middleburg": ["32050", "32068"],
    "Midway": ["32343"],
    "Milligan": ["32537"],
    "Milton": ["32570", "32571", "32572", "32583"],
    "Mims": ["32754"],
    "Minneola": ["34755"],
    "Miramar Beach": ["32550"],
    "Molino": ["32577"],
    "Monticello": ["32344", "32345"],
    "Montverde": ["34756"],
    "Moore Haven": ["33471"],
    "Morriston": ["32668"],
    "Mossy Head": ["32434"],
    "Mount Dora": ["32756", "32757"],
    "Mulberry": ["33860"],
    "Murdock": ["33938"],
    "Myakka City": ["34251"],
    "Nalcrest": ["33856"],
    "Naples": ["34101", "34102", "34103", "34104", "34105", "34106", "34107", "34108", "34109", "34110", "34112", "34113", "34114", "34116", "34117", "34119", "34120"],
    "Navarre": ["32566"],
    "Neptune Beach": ["32266"],
    "New Port Richey": ["34652", "34653", "34654", "34655", "34656"],
    "New Smyrna Beach": ["32168", "32169", "32170"],
    "Newberry": ["32669"],
    "Niceville": ["32578", "32588"],
    "Nichols": ["33863"],
    "Nobleton": ["34661"],
    "Nocatee": ["34268"],
    "Nokomis": ["34274", "34275"],
    "Noma": ["32452"],
    "North Fort Myers": ["33903", "33917", "33918"],
    "North Miami Beach": ["33160"],
    "North Palm Beach": ["33408"],
    "North Port": ["34286", "34287", "34288", "34289", "34290", "34291"],
    "O Brien": ["32071"],
    "Oak Hill": ["32759"],
    "Oakland": ["34760"],
    "Ocala": ["34470", "34471", "34472", "34473", "34474", "34475", "34476", "34477", "34478", "34479", "34480", "34481", "34482", "34483"],
    "Ochopee": ["34141"],
    "Ocklawaha": ["32179", "32183"],
    "Ocoee": ["34761"],
    "Odessa": ["33556"],
    "Okahumpka": ["34762"],
    "Okeechobee": ["34972", "34973", "34974"],
    "Old Town": ["32680"],
    "Oldsmar": ["34677"],
    "Olustee": ["32072"],
    "Ona": ["33865"],
    "Oneco": ["34264"],
    "Opa Locka": ["33054", "33055"],
    "Orange City": ["32763", "32774"],
    "Orange Lake": ["32681"],
    "Orange Park": ["32065", "32067", "32073"],
    "Orange Springs": ["32182"],
    "Orlando": ["32801", "32802", "32803", "32804", "32805", "32806", "32807", "32808", "32809", "32810", "32811", "32812", "32814", "32815", "32816", "32817", "32818", "32819", "32820", "32821", "32822", "32824", "32825", "32826", "32827", "32828", "32829", "32830", "32831", "32832", "32833", "32834", "32835", "32836", "32837", "32839", "32853", "32854", "32855", "32856", "32857", "32858", "32859", "32860", "32861", "32862", "32867", "32868", "32869", "32872", "32877", "32878", "32885", "32886", "32887", "32890", "32891", "32893", "32896", "32897", "32898", "32899"],
    "Ormond Beach": ["32173", "32174", "32175", "32176"],
    "Osprey": ["34229"],
    "Osteen": ["32764"],
    "Otter Creek": ["32683"],
    "Oviedo": ["32762", "32765", "32766"],
    "Oxford": ["34484"],
    "Ozona": ["34660"],
    "Pahokee": ["33476"],
    "Paisley": ["32767"],
    "Palatka": ["32177", "32178"],
    "Palm Bay": ["32905", "32906", "32907", "32908", "32909", "32910", "32911"],
    "Palm Beach": ["33480"],
    "Palm Beach Gardens": ["33410", "33418"],
    "Palm City": ["34990", "34991"],
    "Palm Coast": ["32135", "32137", "32142", "32143", "32164"],
    "Palm Harbor": ["34682", "34683", "34684", "34685"],
    "Palmdale": ["33944"],
    "Palmetto": ["34220", "34221"],
    "Panacea": ["32346"],
    "Panama City": ["32401", "32402", "32403", "32404", "32405", "32406", "32408", "32409", "32411", "32412", "32417"],
    "Panama City Beach": ["32407", "32413"],
    "Parrish": ["34219"],
    "Patrick AFB": ["32925"],
    "Paxton": ["32538"],
    "Pembroke Pines": ["33028", "33082"],
    "Penney Farms": ["32079"],
    "Pensacola": ["32501", "32502", "32503", "32504", "32505", "32506", "32507", "32508", "32509", "32511", "32512", "32513", "32514", "32516", "32520", "32521", "32522", "32523", "32524", "32526", "32534", "32559", "32590", "32591", "32592"],
    "Perry": ["32347", "32348"],
    "Pierson": ["32180"],
    "Pineland": ["33945"],
    "Pinellas Park": ["33780", "33781", "33782"],
    "Pinetta": ["32350"],
    "Placida": ["33946"],
    "Plant City": ["33563", "33564", "33565", "33566", "33567"],
    "Plantation": ["33388"],
    "Plymouth": ["32768"],
    "Point Washington": ["32454"],
    "Polk City": ["33868"],
    "Pomona Park": ["32181"],
    "Pompano Beach": ["33060", "33061", "33062", "33063", "33064", "33066", "33067", "33068", "33069", "33072", "33073", "33074", "33076", "33077"],
    "Ponce De Leon": ["32455"],
    "Ponte Vedra": ["32081"],
    "Ponte Vedra Beach": ["32004", "32082"],
    "Port Charlotte": ["33948", "33949", "33952", "33953", "33954", "33981"],
    "Port Orange": ["32123", "32127", "32128", "32129"],
    "Port Richey": ["34668", "34673"],
    "Port Saint Joe": ["32456", "32457"],
    "Port Saint Lucie": ["34952", "34953", "34983", "34984", "34985", "34986", "34987", "34988"],
    "Port Salerno": ["34992"],
    "Punta Gorda": ["33950", "33951", "33955", "33980", "33982", "33983"],
    "Putnam Hall": ["32185"],
    "Quincy": ["32351", "32352", "32353"],
    "Raiford": ["32026", "32083"],
    "Reddick": ["32686"],
    "River Ranch": ["33867"],
    "Riverview": ["33568", "33569", "33578", "33579"],
    "Rockledge": ["32955", "32956"],
    "Roseland": ["32957"],
    "Rotonda West": ["33947"],
    "Royal Palm Beach": ["33421"],
    "Ruskin": ["33570", "33575"],
    "Safety Harbor": ["34695"],
    "Saint Augustine": ["32080", "32084", "32085", "32086", "32092", "32095"],
    "Saint Cloud": ["34769", "34770", "34771", "34772", "34773"],
    "Saint James City": ["33956"],
    "Saint Johns": ["32259"],
    "Saint Leo": ["33574"],
    "Saint Marks": ["32355"],
    "Saint Petersburg": ["33701", "33702", "33703", "33704", "33705", "33706", "33707", "33708", "33709", "33710", "33711", "33712", "33713", "33714", "33715", "33716", "33729", "33730", "33731", "33732", "33733", "33734", "33736", "33737", "33738", "33740", "33741", "33742", "33743", "33747", "33784"],
    "Salem": ["32356"],
    "San Antonio": ["33576"],
    "San Mateo": ["32187"],
    "Sanderson": ["32087"],
    "Sanford": ["32771", "32772", "32773"],
    "Sanibel": ["33957"],
    "Santa Rosa Beach": ["32459"],
    "Sarasota": ["34230", "34231", "34232", "34233", "34234", "34235", "34236", "34237", "34238", "34239", "34240", "34241", "34242", "34243", "34249", "34260", "34276", "34277", "34278"],
    "Satellite Beach": ["32937"],
    "Satsuma": ["32189"],
    "Scottsmoor": ["32775"],
    "Sebastian": ["32958", "32976", "32978"],
    "Sebring": ["33870", "33871", "33872", "33875", "33876"],
    "Seffner": ["33583", "33584"],
    "Seminole": ["33772", "33775", "33776", "33777"],
    "Seville": ["32190"],
    "Shady Grove": ["32357"],
    "Shalimar": ["32579"],
    "Sharpes": ["32959"],
    "Silver Springs": ["34488", "34489"],
    "Sneads": ["32460"],
    "Sopchoppy": ["32358"],
    "Sorrento": ["32776"],
    "South Bay": ["33493"],
    "Sparr": ["32192"],
    "Spring Hill": ["34606", "34607", "34608", "34609", "34610", "34611"],
    "Starke": ["32091"],
    "Steinhatchee": ["32359"],
    "Stuart": ["34994", "34995", "34996", "34997"],
    "Sumatra": ["32335"],
    "Summerfield": ["34491", "34492"],
    "Summerland Key": ["33042"],
    "Sumterville": ["33585"],
    "Sun City": ["33586"],
    "Sun City Center": ["33571", "33573"],
    "Suwannee": ["32692"],
    "Sydney": ["33587"],
    "Tallahassee": ["32301", "32302", "32303", "32304", "32305", "32306", "32307", "32308", "32309", "32310", "32311", "32312", "32313", "32314", "32315", "32316", "32317", "32318", "32395", "32399"],
    "Tallevast": ["34270"],
    "Tampa": ["33601", "33602", "33603", "33604", "33605", "33606", "33607", "33608", "33609", "33610", "33611", "33612", "33613", "33614", "33615", "33616", "33617", "33618", "33619", "33620", "33621", "33622", "33623", "33624", "33625", "33626", "33629", "33630", "33631", "33633", "33634", "33635", "33637", "33646", "33647", "33650", "33651", "33655", "33660", "33661", "33662", "33663", "33664", "33672", "33673", "33674", "33675", "33677", "33679", "33680", "33681", "33682", "33684", "33685", "33686", "33687", "33688", "33689", "33690", "33694"],
    "Tangerine": ["32777"],
    "Tarpon Springs": ["34688", "34689"],
    "Tavares": ["32778"],
    "Tavernier": ["33070"],
    "Telogia": ["32360"],
    "Terra Ceia": ["34250"],
    "The Villages": ["32162", "32163"],
    "Thonotosassa": ["33592"],
    "Titusville": ["32780", "32781", "32782", "32783", "32796"],
    "Trenton": ["32693"],
    "Trilby": ["33593"],
    "Umatilla": ["32784"],
    "Valparaiso": ["32580"],
    "Valrico": ["33594", "33595", "33596"],
    "Venice": ["34284", "34285", "34292", "34293"],
    "Venus": ["33960"],
    "Vernon": ["32462"],
    "Vero Beach": ["32960", "32961", "32962", "32963", "32964", "32965", "32966", "32967", "32968", "32969"],
    "Wabasso": ["32970"],
    "Wacissa": ["32361"],
    "Waldo": ["32694"],
    "Wauchula": ["33873"],
    "Wausau": ["32463"],
    "Waverly": ["33877"],
    "Webster": ["33597"],
    "Weirsdale": ["32195"],
    "Welaka": ["32193"],
    "Wellborn": ["32094"],
    "Wellington": ["33414"],
    "Wesley Chapel": ["33543", "33544", "33545"],
    "West Palm Beach": ["33401", "33402", "33403", "33404", "33405", "33406", "33407", "33409", "33411", "33412", "33413", "33415", "33416", "33417", "33419", "33420", "33422"],
    "Westville": ["32464"],
    "Wewahitchka": ["32449", "32465"],
    "White Springs": ["32096"],
    "Wildwood": ["34785"],
    "Williston": ["32696"],
    "Wimauma": ["33598"],
    "Windermere": ["34786"],
    "Winter Beach": ["32971"],
    "Winter Garden": ["34777", "34778", "34787"],
    "Winter Haven": ["33880", "33881", "33882", "33883", "33884", "33885", "33888"],
    "Winter Park": ["32789", "32790", "32792", "32793"],
    "Winter Springs": ["32708", "32719"],
    "Woodville": ["32362"],
    "Worthington Springs": ["32697"],
    "Yalaha": ["34797"],
    "Yankeetown": ["34498"],
    "Youngstown": ["32466"],
    "Yulee": ["32041", "32097"],
    "Zellwood": ["32798"],
    "Zephyrhills": ["33539", "33540", "33541", "33542"],
    "Zolfo Springs": ["33890"]
  },
  "GA": {
    "Abbeville": ["31001"],
    "Acworth": ["30101", "30102"],
    "Adairsville": ["30103"],
    "Adel": ["31620"],
    "Adrian": ["31002"],
    "Ailey": ["30410"],
    "Alamo": ["30411"],
    "Alapaha": ["31622"],
    "Albany": ["31701", "31702", "31703", "31704", "31705", "31706", "31707", "31708", "31721"],
    "Allenhurst": ["31301"],
    "Allentown": ["31003"],
    "Alma": ["31510"],
    "Alpharetta": ["30004", "30005", "30009", "30022", "30023"],
    "Alston": ["30412"],
    "Alto": ["30510", "30596"],
    "Ambrose": ["31512"],
    "Americus": ["31709", "31719"],
    "Andersonville": ["31711"],
    "Appling": ["30802"],
    "Arabi": ["31712"],
    "Aragon": ["30104"],
    "Argyle": ["31623"],
    "Arlington": ["39813"],
    "Armuchee": ["30105"],
    "Arnoldsville": ["30619"],
    "Ashburn": ["31714"],
    "Athens": ["30601", "30602", "30603", "30604", "30605", "30606", "30607", "30608", "30609", "30612"],
    "Atlanta": ["30301", "30302", "30303", "30304", "30305", "30306", "30307", "30308", "30309", "30310", "30311", "30312", "30313", "30314", "30315", "30316", "30317", "30318", "30319", "30320", "30321", "30322", "30324", "30325", "30326", "30327", "30328", "30329", "30330", "30331", "30332", "30333", "30334", "30336", "30337", "30338", "30339", "30340", "30341", "30342", "30343", "30344", "30345", "30346", "30347", "30348", "30349", "30350", "30353", "30354", "30355", "30356", "30357", "30358", "30359", "30360", "30361", "30362", "30363", "30364", "30366", "30368", "30369", "30370", "30371", "30374", "30375", "30376", "30377", "30378", "30379", "30380", "30384", "30385", "30386", "30387", "30388", "30389", "30390", "30392", "30394", "30396", "30398", "30399", "31106", "31107", "31119", "31120", "31126", "31131", "31136", "31139", "31141", "31145", "31146", "31150", "31156", "31191", "31192", "31193", "31195", "31196", "31197", "31198", "31199", "39901"],
    "Attapulgus": ["39815"],
    "Auburn": ["30011"],
    "Augusta": ["30901", "30903", "30904", "30905", "30906", "30907", "30909", "30911", "30912", "30913", "30914", "30916", "30917", "30919", "30999"],
    "Austell": ["30106", "30168"],
    "Avera": ["30803"],
    "Avondale Estates": ["30002"],
    "Axson": ["31624"],
    "Baconton": ["31716"],
    "Bainbridge": ["39817", "39818", "39819"],
    "Baldwin": ["30511"],
    "Ball Ground": ["30107"],
    "Barnesville": ["30204"],
    "Barney": ["31625"],
    "Bartow": ["30413"],
    "Barwick": ["31720"],
    "Baxley": ["31513", "31515"],
    "Bellville": ["30414"],
    "Berlin": ["31722"],
    "Bethlehem": ["30620"],
    "Bishop": ["30621"],
    "Blackshear": ["31516"],
    "Blairsville": ["30512", "30514"],
    "Blakely": ["39823"],
    "Bloomingdale": ["31302"],
    "Blue Ridge": ["30513"],
    "Bluffton": ["39824"],
    "Blythe": ["30805"],
    "Bogart": ["30622"],
    "Bolingbroke": ["31004"],
    "Bonaire": ["31005"],
    "Boneville": ["30806"],
    "Boston": ["31626"],
    "Bostwick": ["30623"],
    "Bowdon": ["30108"],
    "Bowdon Junction": ["30109"],
    "Bowersville": ["30516"],
    "Bowman": ["30624"],
    "Box Springs": ["31801"],
    "Braselton": ["30517"],
    "Bremen": ["30110"],
    "Brinson": ["39825"],
    "Bristol": ["31518"],
    "Bronwood": ["39826"],
    "Brookfield": ["31727"],
    "Brooklet": ["30415"],
    "Brooks": ["30205"],
    "Broxton": ["31519"],
    "Brunswick": ["31520", "31521", "31523", "31524", "31525"],
    "Buchanan": ["30113"],
    "Buckhead": ["30625"],
    "Buena Vista": ["31803"],
    "Buford": ["30515", "30518", "30519"],
    "Butler": ["31006"],
    "Byromville": ["31007"],
    "Byron": ["31008"],
    "Cadwell": ["31009"],
    "Cairo": ["39827", "39828"],
    "Calhoun": ["30701", "30703"],
    "Calvary": ["39829"],
    "Camak": ["30807"],
    "Camilla": ["31730"],
    "Canon": ["30520"],
    "Canton": ["30114", "30115", "30169"],
    "Carlton": ["30627"],
    "Carnesville": ["30521"],
    "Carrollton": ["30112", "30116", "30117", "30118", "30119"],
    "Cartersville": ["30120", "30121"],
    "Cassville": ["30123"],
    "Cataula": ["31804"],
    "Cave Spring": ["30124"],
    "Cecil": ["31627"],
    "Cedar Springs": ["39832"],
    "Cedartown": ["30125"],
    "Centerville": ["31028"],
    "Chatsworth": ["30705"],
    "Chauncey": ["31011"],
    "Cherry Log": ["30522"],
    "Chester": ["31012"],
    "Chestnut Mountain": ["30502"],
    "Chickamauga": ["30707"],
    "Chula": ["31733"],
    "Cisco": ["30708"],
    "Clarkdale": ["30111"],
    "Clarkesville": ["30523"],
    "Clarkston": ["30021"],
    "Claxton": ["30417"],
    "Clayton": ["30525"],
    "Clermont": ["30527"],
    "Cleveland": ["30528"],
    "Climax": ["39834"],
    "Clinchfield": ["31013"],
    "Clyo": ["31303"],
    "Cobb": ["31735"],
    "Cobbtown": ["30420"],
    "Cochran": ["31014"],
    "Cohutta": ["30710"],
    "Colbert": ["30628"],
    "Coleman": ["39836"],
    "Collins": ["30421"],
    "Colquitt": ["39837"],
    "Columbus": ["31901", "31902", "31903", "31904", "31906", "31907", "31908", "31909", "31914", "31917", "31993", "31997", "31998", "31999"],
    "Comer": ["30629"],
    "Commerce": ["30529", "30530", "30599"],
    "Concord": ["30206"],
    "Conley": ["30288"],
    "Conyers": ["30012", "30013", "30094"],
    "Coolidge": ["31738"],
    "Coosa": ["30129"],
    "Cordele": ["31010", "31015"],
    "Cornelia": ["30531"],
    "Cotton": ["31739"],
    "Covington": ["30014", "30015", "30016"],
    "Crandall": ["30711"],
    "Crawford": ["30630"],
    "Crawfordville": ["30631"],
    "Crescent": ["31304"],
    "Culloden": ["31016"],
    "Cumming": ["30028", "30040", "30041"],
    "Cusseta": ["31805"],
    "Cuthbert": ["39840"],
    "Dacula": ["30019"],
    "Dahlonega": ["30533", "30597"],
    "Daisy": ["30423"],
    "Dallas": ["30132", "30157"],
    "Dalton": ["30719", "30720", "30721", "30722"],
    "Damascus": ["39841"],
    "Danielsville": ["30633"],
    "Danville": ["31017"],
    "Darien": ["31305"],
    "Davisboro": ["31018"],
    "Dawson": ["39842"],
    "Dawsonville": ["30534"],
    "De Soto": ["31743"],
    "Dearing": ["30808"],
    "Decatur": ["30030", "30031", "30032", "30033", "30034", "30035", "30036", "30037", "30073"],
    "Demorest": ["30535"],
    "Denton": ["31532"],
    "Dewy Rose": ["30634"],
    "Dexter": ["31019"],
    "Dillard": ["30537"],
    "Dixie": ["31629"],
    "Doerun": ["31744"],
    "Donalsonville": ["39845"],
    "Douglas": ["31533", "31534", "31535"],
    "Douglasville": ["30133", "30134", "30135", "30154"],
    "Dover": ["30424"],
    "Dry Branch": ["31020"],
    "Du Pont": ["31630"],
    "Dublin": ["31021", "31040"],
    "Dudley": ["31022"],
    "Duluth": ["30095", "30096", "30097", "30098", "30099"],
    "East Dublin": ["31027"],
    "East Ellijay": ["30539"],
    "Eastanollee": ["30538"],
    "Eastman": ["31023"],
    "Eatonton": ["31024", "31026"],
    "Eden": ["31307"],
    "Edison": ["39846"],
    "Elberton": ["30635"],
    "Elko": ["31025"],
    "Ellabell": ["31308"],
    "Ellaville": ["31806"],
    "Ellenton": ["31747"],
    "Ellenwood": ["30294"],
    "Ellerslie": ["31807"],
    "Ellijay": ["30536", "30540"],
    "Emerson": ["30137"],
    "Enigma": ["31749"],
    "Epworth": ["30541"],
    "Esom Hill": ["30138"],
    "Eton": ["30724"],
    "Evans": ["30809"],
    "Experiment": ["30212"],
    "Fairburn": ["30213"],
    "Fairmount": ["30139"],
    "Fargo": ["31631"],
    "Farmington": ["30638"],
    "Fayetteville": ["30214", "30215"],
    "Felton": ["30140"],
    "Fitzgerald": ["31750"],
    "Fleming": ["31309"],
    "Flintstone": ["30725"],
    "Flovilla": ["30216"],
    "Flowery Branch": ["30542"],
    "Folkston": ["31537"],
    "Forest Park": ["30297", "30298"],
    "Forsyth": ["31029"],
    "Fort Benning": ["31905", "31995"],
    "Fort Gaines": ["39851"],
    "Fort Oglethorpe": ["30742"],
    "Fort Stewart": ["31314", "31315"],
    "Fort Valley": ["31030"],
    "Fortson": ["31808"],
    "Fowlstown": ["39852"],
    "Franklin": ["30217"],
    "Franklin Springs": ["30639"],
    "Funston": ["31753"],
    "Gainesville": ["30501", "30503", "30504", "30506", "30507"],
    "Garfield": ["30425"],
    "Gay": ["30218"],
    "Geneva": ["31810"],
    "Georgetown": ["39854"],
    "Gibson": ["30810"],
    "Gillsville": ["30543"],
    "Girard": ["30426"],
    "Glenn": ["30219"],
    "Glennville": ["30427"],
    "Glenwood": ["30428"],
    "Good Hope": ["30641"],
    "Gordon": ["31031"],
    "Gough": ["30811"],
    "Gracewood": ["30812"],
    "Grantville": ["30220"],
    "Gray": ["31032"],
    "Grayson": ["30017"],
    "Graysville": ["30726"],
    "Greensboro": ["30642"],
    "Greenville": ["30222"],
    "Griffin": ["30223", "30224"],
    "Grovetown": ["30813"],
    "Guyton": ["31312"],
    "Habersham": ["30544"],
    "Haddock": ["31033"],
    "Hagan": ["30429"],
    "Hahira": ["31632"],
    "Hamilton": ["31811"],
    "Hampton": ["30228"],
    "Haralson": ["30229"],
    "Hardwick": ["31034"],
    "Harlem": ["30814"],
    "Harrison": ["31035"],
    "Hartsfield": ["31756"],
    "Hartwell": ["30643"],
    "Hawkinsville": ["31036"],
    "Hazlehurst": ["31539"],
    "Helen": ["30545"],
    "Hephzibah": ["30815"],
    "Hiawassee": ["30546"],
    "High Shoals": ["30645"],
    "Hillsboro": ["31038"],
    "Hinesville": ["31310", "31313"],
    "Hiram": ["30141"],
    "Hoboken": ["31542"],
    "Hogansville": ["30230"],
    "Holly Springs": ["30142"],
    "Homer": ["30547"],
    "Homerville": ["31634"],
    "Hortense": ["31543"],
    "Hoschton": ["30548"],
    "Howard": ["31039"],
    "Hull": ["30646"],
    "Ideal": ["31041"],
    "Ila": ["30647"],
    "Iron City": ["39859"],
    "Irwinton": ["31042"],
    "Irwinville": ["31760"],
    "Jackson": ["30233"],
    "Jacksonville": ["31544"],
    "Jakin": ["39861"],
    "Jasper": ["30143"],
    "Jefferson": ["30549"],
    "Jeffersonville": ["31044"],
    "Jekyll Island": ["31527"],
    "Jenkinsburg": ["30234"],
    "Jersey": ["30018"],
    "Jesup": ["31545", "31546", "31598", "31599"],
    "Jewell": ["31045"],
    "Jonesboro": ["30236", "30237", "30238"],
    "Juliette": ["31046"],
    "Junction City": ["31812"],
    "Kathleen": ["31047"],
    "Kennesaw": ["30144", "30152", "30156", "30160", "31144"],
    "Keysville": ["30816"],
    "Kings Bay": ["31547"],
    "Kingsland": ["31548"],
    "Kingston": ["30145"],
    "Kite": ["31049"],
    "Knoxville": ["31050"],
    "La Fayette": ["30728"],
    "Lagrange": ["30240", "30241", "30261"],
    "Lake Park": ["31636"],
    "Lakeland": ["31635"],
    "Lakemont": ["30552"],
    "Lavonia": ["30553"],
    "Lawrenceville": ["30042", "30043", "30044", "30045", "30046", "30049"],
    "Leary": ["39862"],
    "Lebanon": ["30146"],
    "Leesburg": ["31763"],
    "Lenox": ["31637"],
    "Leslie": ["31764"],
    "Lexington": ["30648"],
    "Lilburn": ["30047", "30048"],
    "Lilly": ["31051"],
    "Lincolnton": ["30817"],
    "Lindale": ["30147"],
    "Lithia Springs": ["30122"],
    "Lithonia": ["30038", "30058"],
    "Lizella": ["31052"],
    "Locust Grove": ["30248"],
    "Loganville": ["30052"],
    "Lookout Mountain": ["30750"],
    "Louisville": ["30434"],
    "Louvale": ["31814"],
    "Lovejoy": ["30250"],
    "Ludowici": ["31316"],
    "Lula": ["30554"],
    "Lumber City": ["31549"],
    "Lumpkin": ["31815"],
    "Luthersville": ["30251"],
    "Lyerly": ["30730"],
    "Lyons": ["30436"],
    "Mableton": ["30126"],
    "Macon": ["31201", "31202", "31203", "31204", "31205", "31206", "31207", "31208", "31209", "31210", "31211", "31212", "31213", "31216", "31217", "31220", "31221", "31294", "31295", "31296", "31297"],
    "Madison": ["30650"],
    "Manassas": ["30438"],
    "Manchester": ["31816"],
    "Manor": ["31550"],
    "Mansfield": ["30055"],
    "Marble Hill": ["30148"],
    "Marietta": ["30006", "30007", "30008", "30060", "30061", "30062", "30063", "30064", "30065", "30066", "30067", "30068", "30069", "30090"],
    "Marshallville": ["31057"],
    "Martin": ["30557"],
    "Matthews": ["30818"],
    "Mauk": ["31058"],
    "Maxeys": ["30671"],
    "Maysville": ["30558"],
    "Mc Caysville": ["30555"],
    "Mc Intyre": ["31054"],
    "Mc Rae Helena": ["31037", "31055"],
    "Mcdonough": ["30252", "30253"],
    "Meansville": ["30256"],
    "Meigs": ["31765"],
    "Meldrim": ["31318"],
    "Menlo": ["30731"],
    "Meridian": ["31319"],
    "Mershon": ["31551"],
    "Mesena": ["30819"],
    "Metter": ["30439"],
    "Midland": ["31820"],
    "Midville": ["30441"],
    "Midway": ["31320"],
    "Milan": ["31060"],
    "Milledgeville": ["31059", "31061", "31062"],
    "Millen": ["30442"],
    "Millwood": ["31552"],
    "Milner": ["30257"],
    "Mineral Bluff": ["30559"],
    "Mitchell": ["30820"],
    "Molena": ["30258"],
    "Monroe": ["30655", "30656"],
    "Montezuma": ["31063"],
    "Monticello": ["31064"],
    "Montrose": ["31065"],
    "Moody AFB": ["31699"],
    "Moreland": ["30259"],
    "Morgan": ["39866"],
    "Morganton": ["30560"],
    "Morris": ["39867"],
    "Morrow": ["30260", "30287"],
    "Morven": ["31638"],
    "Moultrie": ["31768", "31776", "31788"],
    "Mount Airy": ["30563"],
    "Mount Berry": ["30149"],
    "Mount Vernon": ["30445"],
    "Mount Zion": ["30150"],
    "Mountain City": ["30562"],
    "Murrayville": ["30564"],
    "Musella": ["31066"],
    "Mystic": ["31769"],
    "Nahunta": ["31553"],
    "Nashville": ["31639"],
    "Naylor": ["31641"],
    "Nelson": ["30151"],
    "Newborn": ["30056"],
    "Newington": ["30446"],
    "Newnan": ["30263", "30264", "30265", "30271"],
    "Newton": ["39870"],
    "Nicholls": ["31554"],
    "Nicholson": ["30565"],
    "Norcross": ["30003", "30010", "30071", "30091", "30093"],
    "Norman Park": ["31771"],
    "Norristown": ["30447"],
    "North Metro": ["30026", "30029"],
    "Norwood": ["30821"],
    "Nunez": ["30448"],
    "Oakfield": ["31772"],
    "Oakman": ["30732"],
    "Oakwood": ["30566"],
    "Ochlocknee": ["31773"],
    "Ocilla": ["31774"],
    "Oconee": ["31067"],
    "Odum": ["31555"],
    "Offerman": ["31556"],
    "Oglethorpe": ["31068"],
    "Oliver": ["30449"],
    "Omaha": ["31821"],
    "Omega": ["31775"],
    "Orchard Hill": ["30266"],
    "Oxford": ["30054"],
    "Palmetto": ["30268"],
    "Parrott": ["39877"],
    "Patterson": ["31557"],
    "Pavo": ["31778"],
    "Peachtree City": ["30269", "30270", "31169"],
    "Peachtree Corners": ["30092"],
    "Pearson": ["31642"],
    "Pelham": ["31779"],
    "Pembroke": ["31321"],
    "Pendergrass": ["30567"],
    "Perkins": ["30822"],
    "Perry": ["31069"],
    "Pine Lake": ["30072"],
    "Pine Mountain": ["31822"],
    "Pine Mountain Valley": ["31823"],
    "Pinehurst": ["31070"],
    "Pineview": ["31071"],
    "Pitts": ["31072"],
    "Plains": ["31780"],
    "Plainville": ["30733"],
    "Pooler": ["31322"],
    "Port Wentworth": ["31407"],
    "Portal": ["30450"],
    "Porterdale": ["30070"],
    "Poulan": ["31781"],
    "Powder Springs": ["30127"],
    "Preston": ["31824"],
    "Pulaski": ["30451"],
    "Putney": ["31782"],
    "Quitman": ["31643"],
    "Rabun Gap": ["30568"],
    "Ranger": ["30734"],
    "Ray City": ["31645"],
    "Rayle": ["30660"],
    "Rebecca": ["31783"],
    "Red Oak": ["30272"],
    "Redan": ["30074"],
    "Register": ["30452"],
    "Reidsville": ["30453", "30499"],
    "Rentz": ["31075"],
    "Resaca": ["30735"],
    "Rex": ["30273"],
    "Reynolds": ["31076"],
    "Rhine": ["31077"],
    "Riceboro": ["31323"],
    "Richland": ["31825"],
    "Richmond Hill": ["31324"],
    "Rincon": ["31326"],
    "Ringgold": ["30736"],
    "Rising Fawn": ["30738"],
    "Riverdale": ["30274", "30296"],
    "Roberta": ["31078"],
    "Rochelle": ["31079"],
    "Rock Spring": ["30739"],
    "Rockledge": ["30454"],
    "Rockmart": ["30153"],
    "Rocky Face": ["30740"],
    "Rocky Ford": ["30455"],
    "Rome": ["30161", "30162", "30163", "30164", "30165"],
    "Roopville": ["30170"],
    "Rossville": ["30741"],
    "Roswell": ["30075", "30076", "30077"],
    "Royston": ["30662"],
    "Rupert": ["31081"],
    "Rutledge": ["30663"],
    "Rydal": ["30171"],
    "Saint George": ["31562"],
    "Saint Marys": ["31558"],
    "Saint Simons Island": ["31522"],
    "Sale City": ["31784"],
    "Sandersville": ["31082"],
    "Sapelo Island": ["31327"],
    "Sardis": ["30456"],
    "Sargent": ["30275"],
    "Sasser": ["39885"],
    "Sautee Nacoochee": ["30571"],
    "Savannah": ["31401", "31402", "31403", "31404", "31405", "31406", "31408", "31409", "31410", "31411", "31412", "31414", "31415", "31416", "31418", "31419", "31420", "31421"],
    "Scotland": ["31083"],
    "Scottdale": ["30079"],
    "Screven": ["31560"],
    "Sea Island": ["31561"],
    "Senoia": ["30276"],
    "Seville": ["31084"],
    "Shady Dale": ["31085"],
    "Shannon": ["30172"],
    "Sharon": ["30664"],
    "Sharpsburg": ["30277"],
    "Shellman": ["39886"],
    "Shiloh": ["31826"],
    "Siloam": ["30665"],
    "Silver Creek": ["30173"],
    "Smarr": ["31086"],
    "Smithville": ["31787"],
    "Smyrna": ["30080", "30081", "30082"],
    "Snellville": ["30039", "30078"],
    "Social Circle": ["30025"],
    "Soperton": ["30457"],
    "Sparks": ["31647"],
    "Sparta": ["31087"],
    "Springfield": ["31329"],
    "Stapleton": ["30823"],
    "Statenville": ["31648"],
    "Statesboro": ["30458", "30459", "30460", "30461"],
    "Statham": ["30666"],
    "Stephens": ["30667"],
    "Stillmore": ["30464"],
    "Stockbridge": ["30281"],
    "Stockton": ["31649"],
    "Stone Mountain": ["30083", "30086", "30087", "30088"],
    "Suches": ["30572"],
    "Sugar Valley": ["30746"],
    "Summerville": ["30747"],
    "Sumner": ["31789"],
    "Sunny Side": ["30284"],
    "Surrency": ["31563"],
    "Suwanee": ["30024"],
    "Swainsboro": ["30401"],
    "Sycamore": ["31790"],
    "Sylvania": ["30467"],
    "Sylvester": ["31791"],
    "TY TY": ["31795"],
    "Talbotton": ["31827"],
    "Talking Rock": ["30175"],
    "Tallapoosa": ["30176"],
    "Tallulah Falls": ["30573"],
    "Talmo": ["30575"],
    "Tarrytown": ["30470"],
    "Tate": ["30177"],
    "Taylorsville": ["30178"],
    "Temple": ["30179"],
    "Tennga": ["30751"],
    "Tennille": ["31089"],
    "The Rock": ["30285"],
    "Thomaston": ["30286"],
    "Thomasville": ["31757", "31758", "31792", "31799"],
    "Thomson": ["30824"],
    "Tifton": ["31793", "31794"],
    "Tiger": ["30576"],
    "Tignall": ["30668"],
    "Toccoa": ["30577"],
    "Toccoa Falls": ["30598"],
    "Toomsboro": ["31090"],
    "Townsend": ["31331"],
    "Trenton": ["30752"],
    "Trion": ["30753"],
    "Tucker": ["30084", "30085"],
    "Tunnel Hill": ["30755"],
    "Turin": ["30289"],
    "Turnerville": ["30580"],
    "Twin City": ["30471"],
    "Tybee Island": ["31328"],
    "Tyrone": ["30290"],
    "Unadilla": ["31091"],
    "Union City": ["30291"],
    "Union Point": ["30669"],
    "Upatoi": ["31829"],
    "Uvalda": ["30473"],
    "Valdosta": ["31601", "31602", "31603", "31604", "31605", "31606", "31698"],
    "Varnell": ["30756"],
    "Vidalia": ["30474", "30475"],
    "Vienna": ["31092"],
    "Villa Rica": ["30180"],
    "Waco": ["30182"],
    "Wadley": ["30477"],
    "Waleska": ["30183"],
    "Walthourville": ["31333"],
    "Waresboro": ["31564"],
    "Warm Springs": ["31830"],
    "Warner Robins": ["31088", "31093", "31095", "31098", "31099"],
    "Warrenton": ["30828"],
    "Warthen": ["31094"],
    "Warwick": ["31796"],
    "Washington": ["30673"],
    "Watkinsville": ["30677"],
    "Waverly": ["31565"],
    "Waverly Hall": ["31831"],
    "Waycross": ["31501", "31502", "31503"],
    "Waynesboro": ["30830"],
    "Waynesville": ["31566"],
    "West Green": ["31567"],
    "West Point": ["31833"],
    "Weston": ["31832"],
    "Whigham": ["39897"],
    "White": ["30184"],
    "White Oak": ["31568"],
    "White Plains": ["30678"],
    "Whitesburg": ["30185"],
    "Wildwood": ["30757"],
    "Wiley": ["30581"],
    "Willacoochee": ["31650"],
    "Williamson": ["30292"],
    "Winder": ["30680"],
    "Winston": ["30187"],
    "Winterville": ["30683"],
    "Woodbine": ["31569"],
    "Woodbury": ["30293"],
    "Woodland": ["31836"],
    "Woodstock": ["30188", "30189"],
    "Wray": ["31798"],
    "Wrens": ["30833"],
    "Wrightsville": ["31096"],
    "Yatesville": ["31097"],
    "Young Harris": ["30582"],
    "Zebulon": ["30295"]
  },
  "HI": {
    "Aiea": ["96701"],
    "Anahola": ["96703"],
    "Camp H M Smith": ["96861"],
    "Captain Cook": ["96704"],
    "Eleele": ["96705"],
    "Ewa Beach": ["96706"],
    "Fort Shafter": ["96858"],
    "Haiku": ["96708"],
    "Hakalau": ["96710"],
    "Haleiwa": ["96712"],
    "Hana": ["96713"],
    "Hanalei": ["96714"],
    "Hanamaulu": ["96715"],
    "Hanapepe": ["96716"],
    "Hauula": ["96717"],
    "Hawaii National Park": ["96718"],
    "Hawi": ["96719"],
    "Hilo": ["96720", "96721"],
    "Holualoa": ["96725"],
    "Honaunau": ["96726"],
    "Honokaa": ["96727"],
    "Honolulu": ["96801", "96802", "96803", "96804", "96805", "96806", "96807", "96808", "96809", "96810", "96811", "96812", "96813", "96814", "96815", "96816", "96817", "96818", "96819", "96820", "96821", "96822", "96823", "96824", "96825", "96826", "96827", "96828", "96830", "96835", "96836", "96837", "96838", "96839", "96840", "96841", "96843", "96844", "96846", "96847", "96848", "96849", "96850"],
    "Honomu": ["96728"],
    "Hoolehua": ["96729"],
    "Jbphh": ["96853", "96860"],
    "Kaaawa": ["96730"],
    "Kahuku": ["96731"],
    "Kahului": ["96732", "96733"],
    "Kailua": ["96734"],
    "Kailua Kona": ["96740", "96745"],
    "Kalaheo": ["96741"],
    "Kalaupapa": ["96742"],
    "Kamuela": ["96743"],
    "Kaneohe": ["96744"],
    "Kapaa": ["96746"],
    "Kapaau": ["96755"],
    "Kapolei": ["96707", "96709"],
    "Kaumakani": ["96747"],
    "Kaunakakai": ["96748"],
    "Keaau": ["96749"],
    "Kealakekua": ["96750"],
    "Kealia": ["96751"],
    "Keauhou": ["96739"],
    "Kekaha": ["96752"],
    "Kihei": ["96753"],
    "Kilauea": ["96754"],
    "Koloa": ["96756"],
    "Kualapuu": ["96757"],
    "Kula": ["96790"],
    "Kunia": ["96759"],
    "Kurtistown": ["96760"],
    "Lahaina": ["96761", "96767"],
    "Laie": ["96762"],
    "Lanai City": ["96763"],
    "Laupahoehoe": ["96764"],
    "Lawai": ["96765"],
    "Lihue": ["96766"],
    "Makawao": ["96768"],
    "Makaweli": ["96769"],
    "Maunaloa": ["96770"],
    "Mcbh Kaneohe Bay": ["96863"],
    "Mililani": ["96789"],
    "Mountain View": ["96771"],
    "Naalehu": ["96772"],
    "Ninole": ["96773"],
    "Ocean View": ["96737"],
    "Ookala": ["96774"],
    "Paauilo": ["96776"],
    "Pahala": ["96777"],
    "Pahoa": ["96778"],
    "Paia": ["96779"],
    "Papaaloa": ["96780"],
    "Papaikou": ["96781"],
    "Pearl City": ["96782"],
    "Pepeekeo": ["96783"],
    "Princeville": ["96722"],
    "Pukalani": ["96788"],
    "Puunene": ["96784"],
    "Schofield Barracks": ["96857"],
    "Tripler Army Medical Center": ["96859"],
    "Volcano": ["96785"],
    "Wahiawa": ["96786"],
    "Waialua": ["96791"],
    "Waianae": ["96792"],
    "Waikoloa": ["96738"],
    "Wailuku": ["96793"],
    "Waimanalo": ["96795"],
    "Waimea": ["96796"],
    "Waipahu": ["96797"],
    "Wake Island": ["96898"],
    "Wheeler Army Airfield": ["96854"]
  },
  "IA": {
    "Ackley": ["50601"],
    "Ackworth": ["50001"],
    "Adair": ["50002"],
    "Adel": ["50003"],
    "Afton": ["50830"],
    "Agency": ["52530"],
    "Ainsworth": ["52201"],
    "Akron": ["51001"],
    "Albert City": ["50510"],
    "Albia": ["52531"],
    "Albion": ["50005"],
    "Alburnett": ["52202"],
    "Alden": ["50006"],
    "Alexander": ["50420"],
    "Algona": ["50511"],
    "Alleman": ["50007"],
    "Allerton": ["50008"],
    "Allison": ["50602"],
    "Alta": ["51002"],
    "Alta Vista": ["50603"],
    "Alton": ["51003"],
    "Altoona": ["50009"],
    "Alvord": ["51230"],
    "Amana": ["52203", "52204"],
    "Ames": ["50010", "50011", "50012", "50013", "50014"],
    "Anamosa": ["52205"],
    "Andover": ["52701"],
    "Andrew": ["52030"],
    "Anita": ["50020"],
    "Ankeny": ["50021", "50023"],
    "Anthon": ["51004"],
    "Aplington": ["50604"],
    "Arcadia": ["51430"],
    "Archer": ["51231"],
    "Aredale": ["50605"],
    "Argyle": ["52619"],
    "Arion": ["51520"],
    "Arispe": ["50831"],
    "Arlington": ["50606"],
    "Armstrong": ["50514"],
    "Arnolds Park": ["51331"],
    "Arthur": ["51431"],
    "Ashton": ["51232"],
    "Aspinwall": ["51432"],
    "Atalissa": ["52720"],
    "Atkins": ["52206"],
    "Atlantic": ["50022"],
    "Auburn": ["51433"],
    "Audubon": ["50025"],
    "Aurelia": ["51005"],
    "Aurora": ["50607"],
    "Austinville": ["50608"],
    "Avoca": ["51521"],
    "Ayrshire": ["50515"],
    "Badger": ["50516"],
    "Bagley": ["50026"],
    "Baldwin": ["52207"],
    "Bancroft": ["50517"],
    "Barnes City": ["50027"],
    "Barnum": ["50518"],
    "Batavia": ["52533"],
    "Battle Creek": ["51006"],
    "Baxter": ["50028"],
    "Bayard": ["50029"],
    "Beacon": ["52534"],
    "Beaman": ["50609"],
    "Beaver": ["50031"],
    "Bedford": ["50833"],
    "Belle Plaine": ["52208"],
    "Bellevue": ["52031"],
    "Belmond": ["50421"],
    "Bennett": ["52721"],
    "Benton": ["50835"],
    "Bernard": ["52032"],
    "Berwick": ["50032"],
    "Bettendorf": ["52722"],
    "Bevington": ["50033"],
    "Birmingham": ["52535"],
    "Blairsburg": ["50034"],
    "Blairstown": ["52209"],
    "Blakesburg": ["52536"],
    "Blanchard": ["51630"],
    "Blencoe": ["51523"],
    "Blockton": ["50836"],
    "Bloomfield": ["52537"],
    "Blue Grass": ["52726"],
    "Bode": ["50519"],
    "Bonaparte": ["52620"],
    "Bondurant": ["50035"],
    "Boone": ["50036", "50037", "50099", "50950"],
    "Booneville": ["50038"],
    "Bouton": ["50039"],
    "Boxholm": ["50040"],
    "Boyden": ["51234"],
    "Braddyville": ["51631"],
    "Bradford": ["50041"],
    "Bradgate": ["50520"],
    "Brandon": ["52210"],
    "Brayton": ["50042"],
    "Breda": ["51436"],
    "Bridgewater": ["50837"],
    "Brighton": ["52540"],
    "Bristow": ["50611"],
    "Britt": ["50423"],
    "Bronson": ["51007"],
    "Brooklyn": ["52211"],
    "Brunsville": ["51008"],
    "Bryant": ["52727"],
    "Buckeye": ["50043"],
    "Buckingham": ["50612"],
    "Buffalo": ["52728"],
    "Buffalo Center": ["50424"],
    "Burlington": ["52601"],
    "Burnside": ["50521"],
    "Burt": ["50522"],
    "Bussey": ["50044"],
    "Calamus": ["52729"],
    "Callender": ["50523"],
    "Calmar": ["52132"],
    "Calumet": ["51009"],
    "Camanche": ["52730"],
    "Cambridge": ["50046"],
    "Cantril": ["52542"],
    "Carbon": ["50839"],
    "Carlisle": ["50047"],
    "Carpenter": ["50426"],
    "Carroll": ["51401"],
    "Carson": ["51525"],
    "Carter Lake": ["51510"],
    "Cascade": ["52033"],
    "Casey": ["50048"],
    "Castalia": ["52133"],
    "Castana": ["51010"],
    "Cedar": ["52543"],
    "Cedar Falls": ["50613", "50614"],
    "Cedar Rapids": ["52401", "52402", "52403", "52404", "52405", "52406", "52407", "52408", "52409", "52410", "52411", "52497", "52498", "52499"],
    "Center Junction": ["52212"],
    "Center Point": ["52213"],
    "Centerville": ["52544"],
    "Central City": ["52214"],
    "Chapin": ["50427"],
    "Chariton": ["50049"],
    "Charles City": ["50616"],
    "Charlotte": ["52731"],
    "Charter Oak": ["51439"],
    "Chatsworth": ["51011"],
    "Chelsea": ["52215"],
    "Cherokee": ["51012"],
    "Chester": ["52134"],
    "Chillicothe": ["52548"],
    "Churdan": ["50050"],
    "Cincinnati": ["52549"],
    "Clare": ["50524"],
    "Clarence": ["52216"],
    "Clarinda": ["51632"],
    "Clarion": ["50525", "50526"],
    "Clarksville": ["50619"],
    "Clear Lake": ["50428"],
    "Clearfield": ["50840"],
    "Cleghorn": ["51014"],
    "Clemons": ["50051"],
    "Clermont": ["52135"],
    "Climbing Hill": ["51015"],
    "Clinton": ["52732", "52733", "52734", "52736"],
    "Clio": ["50052"],
    "Clive": ["50325"],
    "Clutier": ["52217"],
    "Coggon": ["52218"],
    "Coin": ["51636"],
    "Colesburg": ["52035"],
    "Colfax": ["50054"],
    "College Springs": ["51637"],
    "Collins": ["50055"],
    "Colo": ["50056"],
    "Columbia": ["50057"],
    "Columbus City": ["52737"],
    "Columbus Junction": ["52738"],
    "Colwell": ["50620"],
    "Conesville": ["52739"],
    "Conrad": ["50621"],
    "Conroy": ["52220"],
    "Coon Rapids": ["50058"],
    "Cooper": ["50059"],
    "Coralville": ["52241"],
    "Corning": ["50841"],
    "Correctionville": ["51016"],
    "Corwith": ["50430"],
    "Corydon": ["50060"],
    "Coulter": ["50431"],
    "Council Bluffs": ["51501", "51502", "51503"],
    "Crawfordsville": ["52621"],
    "Crescent": ["51526"],
    "Cresco": ["52136"],
    "Creston": ["50801"],
    "Cromwell": ["50842"],
    "Crystal Lake": ["50432"],
    "Cumberland": ["50843"],
    "Cumming": ["50061"],
    "Curlew": ["50527"],
    "Cushing": ["51018"],
    "Cylinder": ["50528"],
    "Dakota City": ["50529"],
    "Dallas Center": ["50063"],
    "Dana": ["50064"],
    "Danbury": ["51019"],
    "Danville": ["52623"],
    "Davenport": ["52801", "52802", "52803", "52804", "52805", "52806", "52807", "52808", "52809"],
    "Davis City": ["50065"],
    "Dawson": ["50066"],
    "Dayton": ["50530"],
    "De Soto": ["50069"],
    "De Witt": ["52742"],
    "Decatur": ["50067"],
    "Decorah": ["52101"],
    "Dedham": ["51440"],
    "Deep River": ["52222"],
    "Defiance": ["51527"],
    "Delaware": ["52036"],
    "Delhi": ["52223"],
    "Delmar": ["52037"],
    "Deloit": ["51441"],
    "Delta": ["52550"],
    "Denison": ["51442"],
    "Denmark": ["52624"],
    "Denver": ["50622"],
    "Derby": ["50068"],
    "Des Moines": ["50301", "50302", "50303", "50304", "50305", "50306", "50307", "50308", "50309", "50310", "50311", "50312", "50313", "50314", "50315", "50316", "50317", "50318", "50319", "50320", "50321", "50328", "50329", "50330", "50331", "50332", "50333", "50334", "50335", "50336", "50339", "50340", "50347", "50359", "50360", "50361", "50362", "50363", "50364", "50367", "50368", "50369", "50380", "50381", "50391", "50392", "50393", "50394", "50395", "50396", "50397", "50936", "50940", "50947", "50980", "50981", "50982", "50983"],
    "Dewar": ["50623"],
    "Dexter": ["50070"],
    "Diagonal": ["50845"],
    "Dickens": ["51333"],
    "Dike": ["50624"],
    "Dixon": ["52745"],
    "Dolliver": ["50531"],
    "Donahue": ["52746"],
    "Donnellson": ["52625"],
    "Doon": ["51235"],
    "Dorchester": ["52140"],
    "Douds": ["52551"],
    "Dougherty": ["50433"],
    "Dow City": ["51528"],
    "Dows": ["50071"],
    "Drakesville": ["52552"],
    "Dubuque": ["52001", "52002", "52003", "52004", "52099"],
    "Dumont": ["50625"],
    "Duncombe": ["50532"],
    "Dundee": ["52038"],
    "Dunkerton": ["50626"],
    "Dunlap": ["51529"],
    "Durango": ["52039"],
    "Durant": ["52747"],
    "Dyersville": ["52040"],
    "Dysart": ["52224"],
    "Eagle Grove": ["50533"],
    "Earlham": ["50072"],
    "Earling": ["51530"],
    "Earlville": ["52041"],
    "Early": ["50535"],
    "Eddyville": ["52553"],
    "Edgewood": ["52042"],
    "Elberon": ["52225"],
    "Eldon": ["52554"],
    "Eldora": ["50627"],
    "Eldridge": ["52748"],
    "Elgin": ["52141"],
    "Elk Horn": ["51531"],
    "Elkader": ["52043"],
    "Elkhart": ["50073"],
    "Elkport": ["52044"],
    "Elliott": ["51532"],
    "Ellston": ["50074"],
    "Ellsworth": ["50075"],
    "Elma": ["50628"],
    "Ely": ["52227"],
    "Emerson": ["51533"],
    "Emmetsburg": ["50536"],
    "Epworth": ["52045"],
    "Essex": ["51638"],
    "Estherville": ["51334"],
    "Evansdale": ["50707"],
    "Everly": ["51338"],
    "Exira": ["50076"],
    "Exline": ["52555"],
    "Fairbank": ["50629"],
    "Fairfax": ["52228"],
    "Fairfield": ["52556", "52557"],
    "Farley": ["52046"],
    "Farmersburg": ["52047"],
    "Farmington": ["52626"],
    "Farnhamville": ["50538"],
    "Farragut": ["51639"],
    "Fayette": ["52142"],
    "Fenton": ["50539"],
    "Ferguson": ["50078"],
    "Fertile": ["50434"],
    "Floris": ["52560"],
    "Floyd": ["50435"],
    "Fonda": ["50540"],
    "Fontanelle": ["50846"],
    "Forest City": ["50436"],
    "Fort Atkinson": ["52144"],
    "Fort Dodge": ["50501"],
    "Fort Madison": ["52627"],
    "Fostoria": ["51340"],
    "Fredericksburg": ["50630"],
    "Frederika": ["50631"],
    "Fremont": ["52561"],
    "Fruitland": ["52749"],
    "Galt": ["50101"],
    "Galva": ["51020"],
    "Garber": ["52048"],
    "Garden City": ["50102"],
    "Garden Grove": ["50103"],
    "Garnavillo": ["52049"],
    "Garner": ["50438"],
    "Garrison": ["52229"],
    "Garwin": ["50632"],
    "Geneva": ["50633"],
    "George": ["51237"],
    "Gibson": ["50104"],
    "Gifford": ["50259"],
    "Gilbert": ["50105"],
    "Gilbertville": ["50634"],
    "Gillett Grove": ["51341"],
    "Gilman": ["50106"],
    "Gilmore City": ["50541"],
    "Gladbrook": ["50635"],
    "Glenwood": ["51534"],
    "Glidden": ["51443"],
    "Goldfield": ["50542"],
    "Goodell": ["50439"],
    "Goose Lake": ["52750"],
    "Gowrie": ["50543"],
    "Graettinger": ["51342"],
    "Grafton": ["50440"],
    "Grand Junction": ["50107"],
    "Grand Mound": ["52751"],
    "Grand River": ["50108"],
    "Grandview": ["52752"],
    "Granger": ["50109"],
    "Grant": ["50847"],
    "Granville": ["51022"],
    "Gravity": ["50848"],
    "Gray": ["50110"],
    "Greeley": ["52050"],
    "Greene": ["50636"],
    "Greenfield": ["50849"],
    "Greenville": ["51343"],
    "Grimes": ["50111"],
    "Grinnell": ["50112"],
    "Griswold": ["51535"],
    "Grundy Center": ["50638"],
    "Gruver": ["51344"],
    "Guernsey": ["52221"],
    "Guthrie Center": ["50115"],
    "Guttenberg": ["52052"],
    "Halbur": ["51444"],
    "Hamburg": ["51640"],
    "Hamilton": ["50116"],
    "Hamlin": ["50117"],
    "Hampton": ["50441"],
    "Hancock": ["51536"],
    "Hanlontown": ["50444"],
    "Harcourt": ["50544"],
    "Hardy": ["50545"],
    "Harlan": ["51537", "51593"],
    "Harper": ["52231"],
    "Harpers Ferry": ["52146"],
    "Harris": ["51345"],
    "Hartford": ["50118"],
    "Hartley": ["51346"],
    "Hartwick": ["52232"],
    "Harvey": ["50119"],
    "Hastings": ["51540"],
    "Havelock": ["50546"],
    "Haverhill": ["50120"],
    "Hawarden": ["51023"],
    "Hawkeye": ["52147"],
    "Hayesville": ["52562"],
    "Hazleton": ["50641"],
    "Hedrick": ["52563"],
    "Henderson": ["51541"],
    "Hiawatha": ["52233"],
    "Highlandville": ["52149"],
    "Hills": ["52235"],
    "Hillsboro": ["52630"],
    "Hinton": ["51024"],
    "Holland": ["50642"],
    "Holstein": ["51025"],
    "Holy Cross": ["52053"],
    "Homestead": ["52236"],
    "Honey Creek": ["51542"],
    "Hopkinton": ["52237"],
    "Hornick": ["51026"],
    "Hospers": ["51238"],
    "Houghton": ["52631"],
    "Hubbard": ["50122"],
    "Hudson": ["50643"],
    "Hull": ["51239"],
    "Humboldt": ["50548"],
    "Humeston": ["50123"],
    "Huxley": ["50124"],
    "Ida Grove": ["51445"],
    "Imogene": ["51645"],
    "Independence": ["50644"],
    "Indianola": ["50125"],
    "Inwood": ["51240"],
    "Ionia": ["50645"],
    "Iowa City": ["52240", "52242", "52243", "52244", "52245", "52246"],
    "Iowa Falls": ["50126"],
    "Ira": ["50127"],
    "Ireton": ["51027"],
    "Irwin": ["51446"],
    "Jamaica": ["50128"],
    "Janesville": ["50647"],
    "Jefferson": ["50129"],
    "Jesup": ["50648"],
    "Jewell": ["50130"],
    "Johnston": ["50131"],
    "Joice": ["50446"],
    "Jolley": ["50551"],
    "Kalona": ["52247"],
    "Kamrar": ["50132"],
    "Kanawha": ["50447"],
    "Kellerton": ["50133"],
    "Kelley": ["50134"],
    "Kellogg": ["50135"],
    "Kensett": ["50448"],
    "Keokuk": ["52632"],
    "Keosauqua": ["52565"],
    "Keota": ["52248"],
    "Kesley": ["50649"],
    "Keswick": ["50136"],
    "Keystone": ["52249"],
    "Killduff": ["50137"],
    "Kimballton": ["51543"],
    "Kingsley": ["51028"],
    "Kirkman": ["51447"],
    "Kirkville": ["52566"],
    "Kiron": ["51448"],
    "Klemme": ["50449"],
    "Knierim": ["50552"],
    "Knoxville": ["50138"],
    "La Motte": ["52054"],
    "La Porte City": ["50651"],
    "Lacona": ["50139"],
    "Ladora": ["52251"],
    "Lake City": ["51449"],
    "Lake Mills": ["50450"],
    "Lake Park": ["51347"],
    "Lake View": ["51450"],
    "Lakota": ["50451"],
    "Lamoni": ["50140"],
    "Lamont": ["50650"],
    "Lanesboro": ["51451"],
    "Langworthy": ["52252"],
    "Lansing": ["52151"],
    "Larchwood": ["51241"],
    "Larrabee": ["51029"],
    "Latimer": ["50452"],
    "Laurel": ["50141"],
    "Laurens": ["50554"],
    "Lawler": ["52154"],
    "Lawton": ["51030"],
    "Le Claire": ["52753"],
    "Le Grand": ["50142"],
    "Le Mars": ["51031"],
    "Ledyard": ["50556"],
    "Lehigh": ["50557"],
    "Leighton": ["50143"],
    "Leland": ["50453"],
    "Lenox": ["50851"],
    "Leon": ["50144"],
    "Lester": ["51242"],
    "Letts": ["52754"],
    "Lewis": ["51544"],
    "Liberty Center": ["50145"],
    "Libertyville": ["52567"],
    "Lidderdale": ["51452"],
    "Lime Springs": ["52155"],
    "Lincoln": ["50652"],
    "Linden": ["50146"],
    "Lineville": ["50147"],
    "Linn Grove": ["51033"],
    "Lisbon": ["52253"],
    "Liscomb": ["50148"],
    "Little Cedar": ["50454"],
    "Little Rock": ["51243"],
    "Little Sioux": ["51545"],
    "Livermore": ["50558"],
    "Lockridge": ["52635"],
    "Logan": ["51546"],
    "Lohrville": ["51453"],
    "Lone Rock": ["50559"],
    "Lone Tree": ["52755"],
    "Long Grove": ["52756"],
    "Lorimor": ["50149"],
    "Lost Nation": ["52254"],
    "Lovilia": ["50150"],
    "Low Moor": ["52757"],
    "Lowden": ["52255"],
    "Lu Verne": ["50560"],
    "Luana": ["52156"],
    "Lucas": ["50151"],
    "Luther": ["50152"],
    "Luxemburg": ["52056"],
    "Luzerne": ["52257"],
    "Lynnville": ["50153"],
    "Lytton": ["50561"],
    "Macedonia": ["51549"],
    "Macksburg": ["50155"],
    "Madrid": ["50156"],
    "Magnolia": ["51550"],
    "Malcom": ["50157"],
    "Mallard": ["50562"],
    "Malvern": ["51551"],
    "Manchester": ["52057"],
    "Manilla": ["51454"],
    "Manly": ["50456"],
    "Manning": ["51455"],
    "Manson": ["50563"],
    "Mapleton": ["51034"],
    "Maquoketa": ["52060"],
    "Marathon": ["50565"],
    "Marble Rock": ["50653"],
    "Marcus": ["51035"],
    "Marengo": ["52301"],
    "Marion": ["52302"],
    "Marne": ["51552"],
    "Marquette": ["52158"],
    "Marshalltown": ["50158"],
    "Martelle": ["52305"],
    "Martensdale": ["50160"],
    "Martinsburg": ["52568"],
    "Mason City": ["50401", "50402"],
    "Masonville": ["50654"],
    "Massena": ["50853"],
    "Matlock": ["51244"],
    "Maurice": ["51036"],
    "Maxwell": ["50161"],
    "Maynard": ["50655"],
    "Mc Callsburg": ["50154"],
    "Mc Causland": ["52758"],
    "Mc Clelland": ["51548"],
    "Mc Gregor": ["52157"],
    "Mc Intire": ["50455"],
    "Mechanicsville": ["52306"],
    "Mediapolis": ["52637"],
    "Melbourne": ["50162"],
    "Melcher Dallas": ["50062", "50163"],
    "Melrose": ["52569"],
    "Melvin": ["51350"],
    "Menlo": ["50164"],
    "Meriden": ["51037"],
    "Merrill": ["51038"],
    "Meservey": ["50457"],
    "Middle Amana": ["52307"],
    "Middletown": ["52638"],
    "Miles": ["52064"],
    "Milford": ["51351"],
    "Millersburg": ["52308"],
    "Millerton": ["50165"],
    "Milo": ["50166"],
    "Milton": ["52570"],
    "Minburn": ["50167"],
    "Minden": ["51553"],
    "Mineola": ["51554"],
    "Mingo": ["50168"],
    "Missouri Valley": ["51555"],
    "Mitchellville": ["50169"],
    "Modale": ["51556"],
    "Mondamin": ["51557"],
    "Monmouth": ["52309"],
    "Monona": ["52159"],
    "Monroe": ["50170"],
    "Montezuma": ["50171"],
    "Monticello": ["52310"],
    "Montour": ["50173"],
    "Montpelier": ["52759"],
    "Montrose": ["52639"],
    "Moorhead": ["51558"],
    "Moorland": ["50566"],
    "Moravia": ["52571"],
    "Morley": ["52312"],
    "Morning Sun": ["52640"],
    "Morrison": ["50657"],
    "Moscow": ["52760"],
    "Moulton": ["52572"],
    "Mount Auburn": ["52313"],
    "Mount Ayr": ["50854"],
    "Mount Pleasant": ["52641"],
    "Mount Sterling": ["52573"],
    "Mount Union": ["52644"],
    "Mount Vernon": ["52314"],
    "Moville": ["51039"],
    "Murray": ["50174"],
    "Muscatine": ["52761"],
    "Mystic": ["52574"],
    "Nashua": ["50658"],
    "Nemaha": ["50567"],
    "Neola": ["51559"],
    "Nevada": ["50201"],
    "New Albin": ["52160"],
    "New Hampton": ["50659"],
    "New Hartford": ["50660"],
    "New Liberty": ["52765"],
    "New London": ["52645"],
    "New Market": ["51646"],
    "New Providence": ["50206"],
    "New Sharon": ["50207"],
    "New Vienna": ["52065"],
    "New Virginia": ["50210"],
    "Newell": ["50568"],
    "Newhall": ["52315"],
    "Newton": ["50208"],
    "Nichols": ["52766"],
    "Nodaway": ["50857"],
    "Nora Springs": ["50458"],
    "North Buena Vista": ["52066"],
    "North English": ["52316"],
    "North Liberty": ["52317"],
    "North Washington": ["50661"],
    "Northboro": ["51647"],
    "Northwood": ["50459"],
    "Norwalk": ["50211"],
    "Norway": ["52318"],
    "Oakdale": ["52319"],
    "Oakland": ["51560"],
    "Oakville": ["52646"],
    "Ocheyedan": ["51354"],
    "Odebolt": ["51458"],
    "Oelwein": ["50662"],
    "Ogden": ["50212"],
    "Okoboji": ["51355"],
    "Olds": ["52647"],
    "Olin": ["52320"],
    "Ollie": ["52576"],
    "Onawa": ["51040"],
    "Onslow": ["52321"],
    "Oran": ["50664"],
    "Orange City": ["51041"],
    "Orchard": ["50460"],
    "Orient": ["50858"],
    "Osage": ["50461"],
    "Osceola": ["50213"],
    "Oskaloosa": ["52577"],
    "Ossian": ["52161"],
    "Otho": ["50569"],
    "Otley": ["50214"],
    "Oto": ["51044"],
    "Ottosen": ["50570"],
    "Ottumwa": ["52501"],
    "Oxford": ["52322"],
    "Oxford Junction": ["52323"],
    "Oyens": ["51045"],
    "Pacific Junction": ["51561"],
    "Packwood": ["52580"],
    "Palmer": ["50571"],
    "Palo": ["52324"],
    "Panama": ["51562"],
    "Panora": ["50216"],
    "Parkersburg": ["50665"],
    "Parnell": ["52325"],
    "Paton": ["50217"],
    "Patterson": ["50218"],
    "Paullina": ["51046"],
    "Pella": ["50219"],
    "Peosta": ["52068"],
    "Percival": ["51648"],
    "Perry": ["50220"],
    "Persia": ["51563"],
    "Peru": ["50222"],
    "Peterson": ["51047"],
    "Pierson": ["51048"],
    "Pilot Grove": ["52648"],
    "Pilot Mound": ["50223"],
    "Pisgah": ["51564"],
    "Plainfield": ["50666"],
    "Plano": ["52581"],
    "Pleasant Hill": ["50327"],
    "Pleasant Valley": ["52767"],
    "Pleasantville": ["50225"],
    "Plover": ["50573"],
    "Plymouth": ["50464"],
    "Pocahontas": ["50574"],
    "Polk City": ["50226"],
    "Pomeroy": ["50575"],
    "Popejoy": ["50227"],
    "Portsmouth": ["51565"],
    "Postville": ["52162"],
    "Prairie City": ["50228"],
    "Prairieburg": ["52219"],
    "Prescott": ["50859"],
    "Preston": ["52069"],
    "Primghar": ["51245"],
    "Princeton": ["52768"],
    "Prole": ["50229"],
    "Promise City": ["52583"],
    "Protivin": ["52163"],
    "Pulaski": ["52584"],
    "Quasqueton": ["52326"],
    "Quimby": ["51049"],
    "Radcliffe": ["50230"],
    "Rake": ["50465"],
    "Ralston": ["51459"],
    "Randalia": ["52164"],
    "Randall": ["50231"],
    "Randolph": ["51649"],
    "Raymond": ["50667"],
    "Readlyn": ["50668"],
    "Reasnor": ["50232"],
    "Red Oak": ["51566", "51591"],
    "Redding": ["50860"],
    "Redfield": ["50233"],
    "Reinbeck": ["50669"],
    "Rembrandt": ["50576"],
    "Remsen": ["51050"],
    "Renwick": ["50577"],
    "Rhodes": ["50234"],
    "Riceville": ["50466"],
    "Richland": ["52585"],
    "Ricketts": ["51460"],
    "Ridgeway": ["52165"],
    "Ringsted": ["50578"],
    "Rippey": ["50235"],
    "Riverside": ["52327"],
    "Riverton": ["51650"],
    "Robins": ["52328"],
    "Rock Falls": ["50467"],
    "Rock Rapids": ["51246"],
    "Rock Valley": ["51247"],
    "Rockford": ["50468"],
    "Rockwell": ["50469"],
    "Rockwell City": ["50579"],
    "Rodney": ["51051"],
    "Roland": ["50236"],
    "Rolfe": ["50581"],
    "Rome": ["52642"],
    "Rose Hill": ["52586"],
    "Rowan": ["50470"],
    "Rowley": ["52329"],
    "Royal": ["51357"],
    "Rudd": ["50471"],
    "Runnells": ["50237"],
    "Russell": ["50238"],
    "Ruthven": ["51358"],
    "Rutland": ["50582"],
    "Ryan": ["52330"],
    "Sabula": ["52070"],
    "Sac City": ["50583"],
    "Saint Ansgar": ["50472"],
    "Saint Anthony": ["50239"],
    "Saint Charles": ["50240"],
    "Saint Donatus": ["52071"],
    "Saint Lucas": ["52166"],
    "Saint Marys": ["50241"],
    "Saint Olaf": ["52072"],
    "Saint Paul": ["52657"],
    "Salem": ["52649"],
    "Salix": ["51052"],
    "Sanborn": ["51248"],
    "Scarville": ["50473"],
    "Schaller": ["51053"],
    "Schleswig": ["51461"],
    "Scranton": ["51462"],
    "Searsboro": ["50242"],
    "Selma": ["52588"],
    "Sergeant Bluff": ["51054"],
    "Seymour": ["52590"],
    "Shambaugh": ["51651"],
    "Shannon City": ["50861"],
    "Sharpsburg": ["50862"],
    "Sheffield": ["50475"],
    "Shelby": ["51570"],
    "Sheldahl": ["50243"],
    "Sheldon": ["51201"],
    "Shell Rock": ["50670"],
    "Shellsburg": ["52332"],
    "Shenandoah": ["51601", "51602", "51603"],
    "Sherrill": ["52073"],
    "Sibley": ["51249"],
    "Sidney": ["51652"],
    "Sigourney": ["52591"],
    "Silver City": ["51571"],
    "Sioux Center": ["51250"],
    "Sioux City": ["51101", "51102", "51103", "51104", "51105", "51106", "51108", "51109", "51111"],
    "Sioux Rapids": ["50585"],
    "Slater": ["50244"],
    "Sloan": ["51055"],
    "Smithland": ["51056"],
    "Soldier": ["51572"],
    "Solon": ["52333"],
    "Somers": ["50586"],
    "South Amana": ["52334"],
    "South English": ["52335"],
    "Spencer": ["51301"],
    "Sperry": ["52650"],
    "Spillville": ["52168"],
    "Spirit Lake": ["51360"],
    "Spragueville": ["52074"],
    "Springbrook": ["52075"],
    "Springville": ["52336"],
    "Stacyville": ["50476"],
    "Stanhope": ["50246"],
    "Stanley": ["50671"],
    "Stanton": ["51573"],
    "Stanwood": ["52337"],
    "State Center": ["50247"],
    "Steamboat Rock": ["50672"],
    "Stockport": ["52651"],
    "Stockton": ["52769"],
    "Storm Lake": ["50588"],
    "Story City": ["50248"],
    "Stout": ["50673"],
    "Stratford": ["50249"],
    "Strawberry Point": ["52076"],
    "Stuart": ["50250"],
    "Sully": ["50251"],
    "Sumner": ["50674"],
    "Superior": ["51363"],
    "Sutherland": ["51058"],
    "Swaledale": ["50477"],
    "Swan": ["50252"],
    "Swea City": ["50590"],
    "Swedesburg": ["52652"],
    "Swisher": ["52338"],
    "Tabor": ["51653"],
    "Tama": ["52339"],
    "Teeds Grove": ["52771"],
    "Templeton": ["51463"],
    "Terril": ["51364"],
    "Thayer": ["50254"],
    "Thompson": ["50478"],
    "Thor": ["50591"],
    "Thornburg": ["50255"],
    "Thornton": ["50479"],
    "Thurman": ["51654"],
    "Tiffin": ["52340"],
    "Tingley": ["50863"],
    "Tipton": ["52772"],
    "Titonka": ["50480"],
    "Toddville": ["52341"],
    "Toeterville": ["50481"],
    "Toledo": ["52342"],
    "Tracy": ["50256"],
    "Traer": ["50675"],
    "Treynor": ["51575"],
    "Tripoli": ["50676"],
    "Troy Mills": ["52344"],
    "Truesdale": ["50592"],
    "Truro": ["50257"],
    "Udell": ["52593"],
    "Underwood": ["51576"],
    "Union": ["50258"],
    "Unionville": ["52594"],
    "University Park": ["52595"],
    "Urbana": ["52345"],
    "Urbandale": ["50322", "50323", "50398"],
    "Ute": ["51060"],
    "Vail": ["51465"],
    "Van Horne": ["52346"],
    "Van Meter": ["50261"],
    "Van Wert": ["50262"],
    "Varina": ["50593"],
    "Ventura": ["50482"],
    "Victor": ["52347"],
    "Villisca": ["50864"],
    "Vincent": ["50594"],
    "Vining": ["52348"],
    "Vinton": ["52349"],
    "Viola": ["52350"],
    "Volga": ["52077"],
    "Wadena": ["52169"],
    "Walcott": ["52773"],
    "Walford": ["52351"],
    "Walker": ["52352"],
    "Wall Lake": ["51466"],
    "Wallingford": ["51365"],
    "Walnut": ["51577"],
    "Wapello": ["52653"],
    "Washington": ["52353"],
    "Washta": ["51061"],
    "Waterloo": ["50701", "50702", "50703", "50704", "50706"],
    "Waterville": ["52170"],
    "Watkins": ["52354"],
    "Waucoma": ["52171"],
    "Waukee": ["50263"],
    "Waukon": ["52172"],
    "Waverly": ["50677"],
    "Wayland": ["52654"],
    "Webb": ["51366"],
    "Webster": ["52355"],
    "Webster City": ["50595"],
    "Weldon": ["50264"],
    "Wellman": ["52356"],
    "Wellsburg": ["50680"],
    "Welton": ["52774"],
    "Wesley": ["50483"],
    "West Bend": ["50597"],
    "West Branch": ["52358"],
    "West Burlington": ["52655"],
    "West Chester": ["52359"],
    "West Des Moines": ["50265", "50266"],
    "West Grove": ["52538"],
    "West Liberty": ["52776"],
    "West Point": ["52656"],
    "West Union": ["52175"],
    "Westfield": ["51062"],
    "Westgate": ["50681"],
    "Westphalia": ["51578"],
    "Westside": ["51467"],
    "Wever": ["52658"],
    "What Cheer": ["50268"],
    "Wheatland": ["52777"],
    "Whiting": ["51063"],
    "Whittemore": ["50598"],
    "Whitten": ["50269"],
    "Williams": ["50271"],
    "Williamsburg": ["52361"],
    "Williamson": ["50272"],
    "Wilton": ["52778"],
    "Windsor Heights": ["50324"],
    "Winfield": ["52659"],
    "Winterset": ["50273"],
    "Winthrop": ["50682"],
    "Wiota": ["50274"],
    "Woden": ["50484"],
    "Woodbine": ["51579"],
    "Woodburn": ["50275"],
    "Woodward": ["50276"],
    "Woolstock": ["50599"],
    "Worthington": ["52078"],
    "Wyoming": ["52362"],
    "Yale": ["50277"],
    "Yarmouth": ["52660"],
    "Yorktown": ["51656"],
    "Zearing": ["50278"],
    "Zwingle": ["52079"]
  },
  "ID": {
    "Aberdeen": ["83210"],
    "Ahsahka": ["83520"],
    "Albion": ["83311"],
    "Almo": ["83312"],
    "American Falls": ["83211"],
    "Arbon": ["83212"],
    "Arco": ["83213"],
    "Arimo": ["83214"],
    "Ashton": ["83420"],
    "Athol": ["83801"],
    "Atlanta": ["83601"],
    "Atomic City": ["83215"],
    "Avery": ["83802"],
    "Bancroft": ["83217"],
    "Banks": ["83602"],
    "Basalt": ["83218"],
    "Bayview": ["83803"],
    "Bellevue": ["83313"],
    "Bern": ["83220"],
    "Blackfoot": ["83221"],
    "Blanchard": ["83804"],
    "Bliss": ["83314"],
    "Bloomington": ["83223"],
    "Boise": ["83701", "83702", "83703", "83704", "83705", "83706", "83707", "83708", "83709", "83711", "83712", "83713", "83715", "83716", "83717", "83719", "83720", "83721", "83722", "83724", "83725", "83726", "83727", "83728", "83729", "83730", "83731", "83732", "83733", "83735", "83756", "83757", "83799"],
    "Bonners Ferry": ["83805"],
    "Bovill": ["83806"],
    "Bruneau": ["83604"],
    "Buhl": ["83316"],
    "Burley": ["83318"],
    "Calder": ["83808"],
    "Caldwell": ["83605", "83606", "83607"],
    "Cambridge": ["83610"],
    "Carey": ["83320"],
    "Careywood": ["83809"],
    "Carmen": ["83462"],
    "Cascade": ["83611"],
    "Castleford": ["83321"],
    "Cataldo": ["83810"],
    "Challis": ["83226"],
    "Chester": ["83421"],
    "Clark Fork": ["83811"],
    "Clarkia": ["83812"],
    "Clayton": ["83227"],
    "Clifton": ["83228"],
    "Cobalt": ["83229"],
    "Cocolalla": ["83813"],
    "Coeur D Alene": ["83814", "83815", "83816"],
    "Colburn": ["83865"],
    "Conda": ["83230"],
    "Coolin": ["83821"],
    "Corral": ["83322"],
    "Cottonwood": ["83522"],
    "Council": ["83612"],
    "Craigmont": ["83523"],
    "Culdesac": ["83524"],
    "Dayton": ["83232"],
    "Deary": ["83823"],
    "Declo": ["83323"],
    "Desmet": ["83824"],
    "Dietrich": ["83324"],
    "Dingle": ["83233"],
    "Donnelly": ["83615"],
    "Dover": ["83825"],
    "Downey": ["83234"],
    "Driggs": ["83422"],
    "Dubois": ["83423"],
    "Eagle": ["83616"],
    "Eastport": ["83826"],
    "Eden": ["83325"],
    "Elk City": ["83525"],
    "Elk River": ["83827"],
    "Ellis": ["83235"],
    "Emmett": ["83617"],
    "Fairfield": ["83327"],
    "Felt": ["83424"],
    "Fenn": ["83531"],
    "Ferdinand": ["83526"],
    "Fernwood": ["83830"],
    "Filer": ["83328"],
    "Firth": ["83236"],
    "Fish Haven": ["83287"],
    "Fort Hall": ["83203"],
    "Franklin": ["83237"],
    "Fruitland": ["83619"],
    "Garden City": ["83714"],
    "Garden Valley": ["83622"],
    "Genesee": ["83832"],
    "Geneva": ["83238"],
    "Georgetown": ["83239"],
    "Gibbonsville": ["83463"],
    "Glenns Ferry": ["83623"],
    "Gooding": ["83330"],
    "Grace": ["83241"],
    "Grand View": ["83624"],
    "Grangeville": ["83530"],
    "Greencreek": ["83533"],
    "Greenleaf": ["83626"],
    "Hagerman": ["83332"],
    "Hailey": ["83333"],
    "Hamer": ["83425"],
    "Hammett": ["83627"],
    "Hansen": ["83334"],
    "Harrison": ["83833"],
    "Harvard": ["83834"],
    "Hayden": ["83835"],
    "Hazelton": ["83335"],
    "Heyburn": ["83336"],
    "Hill City": ["83337"],
    "Holbrook": ["83243"],
    "Homedale": ["83628"],
    "Hope": ["83836"],
    "Horseshoe Bend": ["83629"],
    "Howe": ["83244"],
    "Huston": ["83630"],
    "Idaho City": ["83631"],
    "Idaho Falls": ["83401", "83402", "83403", "83404", "83405", "83406", "83415"],
    "Indian Valley": ["83632"],
    "Inkom": ["83245"],
    "Iona": ["83427"],
    "Irwin": ["83428"],
    "Island Park": ["83429"],
    "Jerome": ["83338"],
    "Juliaetta": ["83535"],
    "Kamiah": ["83536"],
    "Kellogg": ["83837"],
    "Kendrick": ["83537"],
    "Ketchum": ["83340"],
    "Kimberly": ["83341"],
    "King Hill": ["83633"],
    "Kingston": ["83839"],
    "Kooskia": ["83539"],
    "Kootenai": ["83840"],
    "Kuna": ["83634"],
    "Laclede": ["83841"],
    "Lake Fork": ["83635"],
    "Lapwai": ["83540"],
    "Lava Hot Springs": ["83246"],
    "Leadore": ["83464"],
    "Lemhi": ["83465"],
    "Lenore": ["83541"],
    "Letha": ["83636"],
    "Lewiston": ["83501"],
    "Lewisville": ["83431"],
    "Lowman": ["83637"],
    "Lucile": ["83542"],
    "Mackay": ["83251"],
    "Macks Inn": ["83433"],
    "Malad City": ["83252"],
    "Malta": ["83342"],
    "Marsing": ["83639"],
    "May": ["83253"],
    "Mccall": ["83638"],
    "Mccammon": ["83250"],
    "Medimont": ["83842"],
    "Melba": ["83641"],
    "Menan": ["83434"],
    "Meridian": ["83642", "83646", "83680"],
    "Mesa": ["83643"],
    "Middleton": ["83644"],
    "Midvale": ["83645"],
    "Minidoka": ["83343"],
    "Monteview": ["83435"],
    "Montpelier": ["83254"],
    "Moore": ["83255"],
    "Moreland": ["83256"],
    "Moscow": ["83843", "83844"],
    "Mountain Home": ["83647"],
    "Mountain Home AFB": ["83648"],
    "Moyie Springs": ["83845"],
    "Mullan": ["83846"],
    "Murphy": ["83650"],
    "Murray": ["83874"],
    "Murtaugh": ["83344"],
    "Nampa": ["83651", "83652", "83653", "83686", "83687"],
    "Naples": ["83847"],
    "New Meadows": ["83654"],
    "New Plymouth": ["83655"],
    "Newdale": ["83436"],
    "Nezperce": ["83543"],
    "Nordman": ["83848"],
    "North Fork": ["83466"],
    "Notus": ["83656"],
    "Oakley": ["83346"],
    "Ola": ["83657"],
    "Oldtown": ["83822"],
    "Orofino": ["83544"],
    "Osburn": ["83849"],
    "Paris": ["83261"],
    "Parker": ["83438"],
    "Parma": ["83660"],
    "Paul": ["83347"],
    "Payette": ["83661"],
    "Peck": ["83545"],
    "Picabo": ["83348"],
    "Pierce": ["83546"],
    "Pinehurst": ["83850"],
    "Pingree": ["83262"],
    "Placerville": ["83666"],
    "Plummer": ["83851"],
    "Pocatello": ["83201", "83202", "83204", "83205", "83206", "83209"],
    "Pollock": ["83547"],
    "Ponderay": ["83852"],
    "Porthill": ["83853"],
    "Post Falls": ["83854", "83877"],
    "Potlatch": ["83855"],
    "Preston": ["83263"],
    "Priest River": ["83856"],
    "Princeton": ["83857"],
    "Rathdrum": ["83858"],
    "Reubens": ["83548"],
    "Rexburg": ["83440", "83441", "83460"],
    "Richfield": ["83349"],
    "Rigby": ["83442"],
    "Riggins": ["83549"],
    "Ririe": ["83443"],
    "Roberts": ["83444"],
    "Rockland": ["83271"],
    "Rogerson": ["83302"],
    "Rupert": ["83350"],
    "Sagle": ["83860"],
    "Saint Anthony": ["83445"],
    "Saint Charles": ["83272"],
    "Saint Maries": ["83861"],
    "Salmon": ["83467"],
    "Sandpoint": ["83864"],
    "Santa": ["83866"],
    "Shelley": ["83274"],
    "Shoshone": ["83352"],
    "Shoup": ["83469"],
    "Silverton": ["83867"],
    "Smelterville": ["83868"],
    "Soda Springs": ["83276"],
    "Spencer": ["83446"],
    "Spirit Lake": ["83869"],
    "Springfield": ["83277"],
    "Stanley": ["83278"],
    "Star": ["83669"],
    "Stites": ["83552"],
    "Sugar City": ["83448"],
    "Sun Valley": ["83353", "83354"],
    "Swan Valley": ["83449"],
    "Swanlake": ["83281"],
    "Sweet": ["83670"],
    "Tendoy": ["83468"],
    "Tensed": ["83870"],
    "Terreton": ["83450"],
    "Teton": ["83451"],
    "Tetonia": ["83452"],
    "Thatcher": ["83283"],
    "Troy": ["83871"],
    "Twin Falls": ["83301", "83303"],
    "Ucon": ["83454"],
    "Victor": ["83455"],
    "Viola": ["83872"],
    "Wallace": ["83873"],
    "Warren": ["83671"],
    "Wayan": ["83285"],
    "Weippe": ["83553"],
    "Weiser": ["83672"],
    "Wendell": ["83355"],
    "Weston": ["83286"],
    "White Bird": ["83554"],
    "Wilder": ["83676"],
    "Winchester": ["83555"],
    "Worley": ["83876"],
    "Yellow Pine": ["83677"]
  },
  "IL": {
    "Abingdon": ["61410"],
    "Adair": ["61411"],
    "Addieville": ["62214"],
    "Addison": ["60101"],
    "Akin": ["62805"],
    "Albany": ["61230"],
    "Albers": ["62215"],
    "Albion": ["62806"],
    "Alden": ["60001"],
    "Aledo": ["61231"],
    "Alexander": ["62601"],
    "Alexis": ["61412"],
    "Algonquin": ["60102"],
    "Alhambra": ["62001"],
    "Allendale": ["62410"],
    "Allerton": ["61810"],
    "Alma": ["62807"],
    "Alpha": ["61413"],
    "Alsey": ["62610"],
    "Alsip": ["60803"],
    "Altamont": ["62411"],
    "Alto Pass": ["62905"],
    "Alton": ["62002"],
    "Altona": ["61414"],
    "Alvin": ["61811"],
    "Amboy": ["61310"],
    "Anchor": ["61720"],
    "Ancona": ["61311"],
    "Andalusia": ["61232"],
    "Andover": ["61233"],
    "Anna": ["62906"],
    "Annapolis": ["62413"],
    "Annawan": ["61234"],
    "Antioch": ["60002"],
    "Apple River": ["61001"],
    "Arcola": ["61910"],
    "Arenzville": ["62611"],
    "Argenta": ["62501"],
    "Arlington": ["61312"],
    "Arlington Heights": ["60004", "60005", "60006"],
    "Armington": ["61721"],
    "Armstrong": ["61812"],
    "Aroma Park": ["60910"],
    "Arrowsmith": ["61722"],
    "Arthur": ["61911"],
    "Ashkum": ["60911"],
    "Ashland": ["62612"],
    "Ashley": ["62808"],
    "Ashmore": ["61912"],
    "Ashton": ["61006"],
    "Assumption": ["62510"],
    "Astoria": ["61501"],
    "Athens": ["62613"],
    "Atkinson": ["61235"],
    "Atlanta": ["61723"],
    "Atwood": ["61913"],
    "Auburn": ["62615"],
    "Augusta": ["62311"],
    "Aurora": ["60502", "60503", "60504", "60505", "60506", "60507", "60568", "60569", "60572", "60598"],
    "Ava": ["62907"],
    "Aviston": ["62216"],
    "Avon": ["61415"],
    "Baileyville": ["61007"],
    "Baldwin": ["62217"],
    "Bardolph": ["61416"],
    "Barnhill": ["62809"],
    "Barrington": ["60010", "60011"],
    "Barry": ["62312"],
    "Barstow": ["61236"],
    "Bartelso": ["62218"],
    "Bartlett": ["60103"],
    "Basco": ["62313"],
    "Batavia": ["60510"],
    "Batchtown": ["62006"],
    "Bath": ["62617"],
    "Baylis": ["62314"],
    "Beardstown": ["62618"],
    "Beason": ["62512"],
    "Beaverville": ["60912"],
    "Beckemeyer": ["62219"],
    "Bedford Park": ["60499"],
    "Beecher": ["60401"],
    "Beecher City": ["62414"],
    "Belknap": ["62908"],
    "Belle Rive": ["62810"],
    "Belleville": ["62220", "62221", "62222", "62223", "62226"],
    "Bellflower": ["61724"],
    "Bellmont": ["62811"],
    "Bellwood": ["60104"],
    "Belvidere": ["61008"],
    "Bement": ["61813"],
    "Benld": ["62009"],
    "Bensenville": ["60105", "60106"],
    "Benson": ["61516"],
    "Benton": ["62812"],
    "Berkeley": ["60163"],
    "Berwick": ["61417"],
    "Berwyn": ["60402"],
    "Bethalto": ["62010"],
    "Bethany": ["61914"],
    "Big Rock": ["60511"],
    "Biggsville": ["61418"],
    "Bingham": ["62011"],
    "Bishop Hill": ["61419"],
    "Bismarck": ["61814"],
    "Blackstone": ["61313"],
    "Blandinsville": ["61420"],
    "Bloomingdale": ["60108", "60117"],
    "Bloomington": ["61701", "61702", "61704", "61705", "61709", "61710", "61791", "61799"],
    "Blue Island": ["60406"],
    "Blue Mound": ["62513"],
    "Bluff Springs": ["62622"],
    "Bluffs": ["62621"],
    "Bluford": ["62814"],
    "Boles": ["62909"],
    "Bolingbrook": ["60440", "60490"],
    "Bondville": ["61815"],
    "Bone Gap": ["62815"],
    "Bonfield": ["60913"],
    "Bonnie": ["62816"],
    "Boody": ["62514"],
    "Bourbonnais": ["60914"],
    "Bowen": ["62316"],
    "Braceville": ["60407"],
    "Bradford": ["61421"],
    "Bradley": ["60915"],
    "Braidwood": ["60408"],
    "Breese": ["62230"],
    "Bridgeport": ["62417"],
    "Bridgeview": ["60455"],
    "Brighton": ["62012"],
    "Brimfield": ["61517"],
    "Bristol": ["60512"],
    "Broadlands": ["61816"],
    "Broadview": ["60155"],
    "Brocton": ["61917"],
    "Brookfield": ["60513"],
    "Brookport": ["62910"],
    "Broughton": ["62817"],
    "Browning": ["62624"],
    "Browns": ["62818"],
    "Brownstown": ["62418"],
    "Brussels": ["62013"],
    "Bryant": ["61519"],
    "Buckingham": ["60917"],
    "Buckley": ["60918"],
    "Buckner": ["62819"],
    "Buda": ["61314"],
    "Buffalo": ["62515"],
    "Buffalo Grove": ["60089"],
    "Buffalo Prairie": ["61237"],
    "Bulpitt": ["62517"],
    "Buncombe": ["62912"],
    "Bunker Hill": ["62014"],
    "Burbank": ["60459"],
    "Bureau": ["61315"],
    "Burlington": ["60109"],
    "Burnt Prairie": ["62820"],
    "Bushnell": ["61422"],
    "Butler": ["62015"],
    "Byron": ["61010"],
    "Cabery": ["60919"],
    "Cairo": ["62914"],
    "Caledonia": ["61011"],
    "Calhoun": ["62419"],
    "Calumet City": ["60409"],
    "Camargo": ["61919"],
    "Cambria": ["62915"],
    "Cambridge": ["61238"],
    "Camden": ["62319"],
    "Cameron": ["61423"],
    "Camp Grove": ["61424"],
    "Camp Point": ["62320"],
    "Campbell Hill": ["62916"],
    "Campus": ["60920"],
    "Canton": ["61520"],
    "Cantrall": ["62625"],
    "Capron": ["61012"],
    "Carbon Cliff": ["61239"],
    "Carbondale": ["62901", "62902", "62903"],
    "Carlinville": ["62626"],
    "Carlock": ["61725"],
    "Carlyle": ["62231"],
    "Carman": ["61425"],
    "Carmi": ["62821"],
    "Carol Stream": ["60116", "60122", "60125", "60128", "60132", "60188", "60197", "60199"],
    "Carpentersville": ["60110"],
    "Carrier Mills": ["62917"],
    "Carrollton": ["62016"],
    "Carterville": ["62918"],
    "Carthage": ["62321"],
    "Cary": ["60013"],
    "Casey": ["62420"],
    "Caseyville": ["62232"],
    "Castleton": ["61426"],
    "Catlin": ["61817"],
    "Cave In Rock": ["62919"],
    "Cedar Point": ["61316"],
    "Cedarville": ["61013"],
    "Centralia": ["62801"],
    "Cerro Gordo": ["61818"],
    "Chadwick": ["61014"],
    "Chambersburg": ["62323"],
    "Champaign": ["61820", "61821", "61822", "61824", "61825", "61826"],
    "Chana": ["61015"],
    "Chandlerville": ["62627"],
    "Channahon": ["60410"],
    "Chapin": ["62628"],
    "Charleston": ["61920"],
    "Chatham": ["62629"],
    "Chatsworth": ["60921"],
    "Chebanse": ["60922"],
    "Chenoa": ["61726"],
    "Cherry": ["61317"],
    "Cherry Valley": ["61016"],
    "Chester": ["62233"],
    "Chesterfield": ["62630"],
    "Chestnut": ["62518"],
    "Chicago": ["60290", "60601", "60602", "60603", "60604", "60605", "60606", "60607", "60608", "60609", "60610", "60611", "60612", "60613", "60614", "60615", "60616", "60617", "60618", "60619", "60620", "60621", "60622", "60623", "60624", "60625", "60626", "60628", "60629", "60630", "60631", "60632", "60633", "60634", "60636", "60637", "60638", "60639", "60640", "60641", "60642", "60643", "60644", "60645", "60646", "60647", "60649", "60651", "60652", "60653", "60654", "60655", "60656", "60657", "60659", "60660", "60661", "60663", "60664", "60666", "60668", "60669", "60670", "60673", "60674", "60675", "60677", "60678", "60679", "60680", "60681", "60682", "60684", "60685", "60686", "60687", "60688", "60689", "60690", "60691", "60693", "60694", "60695", "60696", "60697", "60699", "60701"],
    "Chicago Heights": ["60411", "60412"],
    "Chicago Ridge": ["60415"],
    "Chillicothe": ["61523"],
    "Chrisman": ["61924"],
    "Christopher": ["62822"],
    "Cicero": ["60804"],
    "Cisco": ["61830"],
    "Cisne": ["62823"],
    "Cissna Park": ["60924"],
    "Clare": ["60111"],
    "Claremont": ["62421"],
    "Clarendon Hills": ["60514"],
    "Clay City": ["62824"],
    "Clayton": ["62324"],
    "Claytonville": ["60926"],
    "Clifton": ["60927"],
    "Clinton": ["61727"],
    "Coal City": ["60416"],
    "Coal Valley": ["61240"],
    "Coatsburg": ["62325"],
    "Cobden": ["62920"],
    "Coello": ["62825"],
    "Coffeen": ["62017"],
    "Colchester": ["62326"],
    "Colfax": ["61728"],
    "Collinsville": ["62234"],
    "Collison": ["61831"],
    "Colona": ["61241"],
    "Colp": ["62921"],
    "Columbia": ["62236"],
    "Colusa": ["62329"],
    "Compton": ["61318"],
    "Concord": ["62631"],
    "Congerville": ["61729"],
    "Cooksville": ["61730"],
    "Cordova": ["61242"],
    "Cornell": ["61319"],
    "Cornland": ["62519"],
    "Cortland": ["60112"],
    "Cottage Hills": ["62018"],
    "Coulterville": ["62237"],
    "Country Club Hills": ["60478"],
    "Cowden": ["62422"],
    "Creal Springs": ["62922"],
    "Crescent City": ["60928"],
    "Crest Hill": ["60403"],
    "Creston": ["60113"],
    "Crestwood": ["60418"],
    "Crete": ["60417"],
    "Creve Coeur": ["61610"],
    "Cropsey": ["61731"],
    "Crossville": ["62827"],
    "Crystal Lake": ["60012", "60014", "60039"],
    "Cuba": ["61427"],
    "Cullom": ["60929"],
    "Cutler": ["62238"],
    "Cypress": ["62923"],
    "Dahinda": ["61428"],
    "Dahlgren": ["62828"],
    "Dakota": ["61018"],
    "Dale": ["62829"],
    "Dallas City": ["62330"],
    "Dalton City": ["61925"],
    "Dalzell": ["61320"],
    "Dana": ["61321"],
    "Danforth": ["60930"],
    "Danvers": ["61732"],
    "Danville": ["61832", "61834"],
    "Darien": ["60561"],
    "Davis": ["61019"],
    "Davis Junction": ["61020"],
    "Dawson": ["62520"],
    "De Land": ["61839"],
    "De Soto": ["62924"],
    "Decatur": ["62521", "62522", "62523", "62524", "62525", "62526"],
    "Deer Creek": ["61733"],
    "Deer Grove": ["61243"],
    "Deerfield": ["60015"],
    "Dekalb": ["60115"],
    "Delavan": ["61734"],
    "Dennison": ["62423"],
    "Depue": ["61322"],
    "Des Plaines": ["60016", "60017", "60018", "60019"],
    "Dewey": ["61840"],
    "Dewitt": ["61735"],
    "Dieterich": ["62424"],
    "Divernon": ["62530"],
    "Dix": ["62830"],
    "Dixon": ["61021"],
    "Dolton": ["60419"],
    "Dongola": ["62926"],
    "Donnellson": ["62019"],
    "Donovan": ["60931"],
    "Dorsey": ["62021"],
    "Dover": ["61323"],
    "Dow": ["62022"],
    "Dowell": ["62927"],
    "Downers Grove": ["60515", "60516"],
    "Downs": ["61736"],
    "Du Bois": ["62831"],
    "Du Quoin": ["62832"],
    "Dundas": ["62425"],
    "Dundee": ["60118"],
    "Dunfermline": ["61524"],
    "Dunlap": ["61525"],
    "Dupo": ["62239"],
    "Durand": ["61024"],
    "Dwight": ["60420"],
    "Eagarville": ["62023"],
    "Earlville": ["60518"],
    "East Alton": ["62024"],
    "East Carondelet": ["62240"],
    "East Dubuque": ["61025"],
    "East Galesburg": ["61430"],
    "East Lynn": ["60932"],
    "East Moline": ["61244"],
    "East Peoria": ["61611", "61635"],
    "East Saint Louis": ["62201", "62202", "62203", "62204", "62205", "62206", "62207"],
    "Easton": ["62633"],
    "Eddyville": ["62928"],
    "Edelstein": ["61526"],
    "Edgewood": ["62426"],
    "Edinburg": ["62531"],
    "Edwards": ["61528"],
    "Edwardsville": ["62025", "62026"],
    "Effingham": ["62401"],
    "El Paso": ["61738"],
    "Elburn": ["60119"],
    "Eldena": ["61324"],
    "Eldorado": ["62930"],
    "Eldred": ["62027"],
    "Eleroy": ["61027"],
    "Elgin": ["60120", "60121", "60123", "60124"],
    "Elizabeth": ["61028"],
    "Elizabethtown": ["62931"],
    "Elk Grove Village": ["60007", "60009"],
    "Elkhart": ["62634"],
    "Elkville": ["62932"],
    "Ellery": ["62833"],
    "Elliott": ["60933"],
    "Ellis Grove": ["62241"],
    "Ellisville": ["61431"],
    "Ellsworth": ["61737"],
    "Elmhurst": ["60126"],
    "Elmwood": ["61529"],
    "Elmwood Park": ["60707"],
    "Elsah": ["62028"],
    "Elvaston": ["62334"],
    "Elwin": ["62532"],
    "Elwood": ["60421"],
    "Emden": ["62635"],
    "Emington": ["60934"],
    "Emma": ["62834"],
    "Energy": ["62933"],
    "Enfield": ["62835"],
    "Eola": ["60519"],
    "Equality": ["62934"],
    "Erie": ["61250"],
    "Esmond": ["60129"],
    "Essex": ["60935"],
    "Eureka": ["61530"],
    "Evanston": ["60201", "60202", "60203", "60204", "60208", "60209"],
    "Evansville": ["62242"],
    "Evergreen Park": ["60805"],
    "Ewing": ["62836"],
    "Fairbury": ["61739"],
    "Fairfield": ["62837"],
    "Fairmount": ["61841"],
    "Fairview": ["61432"],
    "Fairview Heights": ["62208"],
    "Farina": ["62838"],
    "Farmer City": ["61842"],
    "Farmersville": ["62533"],
    "Farmington": ["61531"],
    "Fenton": ["61251"],
    "Ferris": ["62336"],
    "Fiatt": ["61433"],
    "Fidelity": ["62030"],
    "Fieldon": ["62031"],
    "Fillmore": ["62032"],
    "Findlay": ["62534"],
    "Fisher": ["61843"],
    "Fithian": ["61844"],
    "Flanagan": ["61740"],
    "Flat Rock": ["62427"],
    "Flora": ["62839"],
    "Flossmoor": ["60422"],
    "Foosland": ["61845"],
    "Forest City": ["61532"],
    "Forest Park": ["60130"],
    "Forrest": ["61741"],
    "Forreston": ["61030"],
    "Forsyth": ["62535"],
    "Fort Sheridan": ["60037"],
    "Fowler": ["62338"],
    "Fox Lake": ["60020"],
    "Fox River Grove": ["60021"],
    "Fox Valley": ["60597", "60599"],
    "Frankfort": ["60423"],
    "Frankfort Heights": ["62840"],
    "Franklin": ["62638"],
    "Franklin Grove": ["61031"],
    "Franklin Park": ["60131"],
    "Frederick": ["62639"],
    "Freeburg": ["62243"],
    "Freeman Spur": ["62841"],
    "Freeport": ["61032"],
    "Fulton": ["61252"],
    "Fults": ["62244"],
    "Galatia": ["62935"],
    "Galena": ["61036"],
    "Galesburg": ["61401", "61402"],
    "Galt": ["61037"],
    "Galva": ["61434"],
    "Garden Prairie": ["61038"],
    "Gardner": ["60424"],
    "Gays": ["61928"],
    "Geff": ["62842"],
    "Geneseo": ["61254"],
    "Geneva": ["60134"],
    "Genoa": ["60135"],
    "Georgetown": ["61846"],
    "Gerlaw": ["61435"],
    "German Valley": ["61039"],
    "Germantown": ["62245"],
    "Gibson City": ["60936"],
    "Gifford": ["61847"],
    "Gilberts": ["60136"],
    "Gillespie": ["62033"],
    "Gilman": ["60938"],
    "Gilson": ["61436"],
    "Girard": ["62640"],
    "Gladstone": ["61437"],
    "Glasford": ["61533"],
    "Glen Carbon": ["62034"],
    "Glen Ellyn": ["60137", "60138"],
    "Glenarm": ["62536"],
    "Glencoe": ["60022"],
    "Glendale Heights": ["60139"],
    "Glenview": ["60025", "60026"],
    "Glenwood": ["60425"],
    "Godfrey": ["62035"],
    "Golconda": ["62938"],
    "Golden": ["62339"],
    "Golden Eagle": ["62036"],
    "Golden Gate": ["62843"],
    "Golf": ["60029"],
    "Good Hope": ["61438"],
    "Goodfield": ["61742"],
    "Goodwine": ["60939"],
    "Goreville": ["62939"],
    "Gorham": ["62940"],
    "Grafton": ["62037"],
    "Grand Chain": ["62941"],
    "Grand Ridge": ["61325"],
    "Grand Tower": ["62942"],
    "Granite City": ["62040"],
    "Grant Park": ["60940"],
    "Grantsburg": ["62943"],
    "Granville": ["61326"],
    "Graymont": ["61743"],
    "Grayslake": ["60030"],
    "Grayville": ["62844"],
    "Great Lakes": ["60088"],
    "Green Valley": ["61534"],
    "Greenfield": ["62044"],
    "Greenup": ["62428"],
    "Greenview": ["62642"],
    "Greenville": ["62246"],
    "Gridley": ["61744"],
    "Griggsville": ["62340"],
    "Groveland": ["61535"],
    "Gurnee": ["60031"],
    "Hagarstown": ["62247"],
    "Hamburg": ["62045"],
    "Hamel": ["62046"],
    "Hamilton": ["62341"],
    "Hammond": ["61929"],
    "Hampshire": ["60140"],
    "Hampton": ["61256"],
    "Hanna City": ["61536"],
    "Hanover": ["61041"],
    "Hanover Park": ["60133"],
    "Hardin": ["62047"],
    "Harmon": ["61042"],
    "Harrisburg": ["62946"],
    "Harristown": ["62537"],
    "Hartford": ["62048"],
    "Hartsburg": ["62643"],
    "Harvard": ["60033"],
    "Harvel": ["62538"],
    "Harvey": ["60426"],
    "Harwood Heights": ["60706"],
    "Havana": ["62644"],
    "Hazel Crest": ["60429"],
    "Hebron": ["60034"],
    "Hecker": ["62248"],
    "Henderson": ["61439"],
    "Hennepin": ["61327"],
    "Henning": ["61848"],
    "Henry": ["61537"],
    "Herod": ["62947"],
    "Herrick": ["62431"],
    "Herrin": ["62948"],
    "Herscher": ["60941"],
    "Hettick": ["62649"],
    "Heyworth": ["61745"],
    "Hickory Hills": ["60457"],
    "Hidalgo": ["62432"],
    "Highland": ["62249"],
    "Highland Park": ["60035"],
    "Highwood": ["60040"],
    "Hillsboro": ["62049"],
    "Hillsdale": ["61257"],
    "Hillside": ["60162"],
    "Hillview": ["62050"],
    "Hinckley": ["60520"],
    "Hindsboro": ["61930"],
    "Hines": ["60141"],
    "Hinsdale": ["60521", "60522", "60570"],
    "Hoffman": ["62250"],
    "Hoffman Estates": ["60169", "60179", "60192"],
    "Holcomb": ["61043"],
    "Homer": ["61849"],
    "Homer Glen": ["60491"],
    "Hometown": ["60456"],
    "Homewood": ["60430"],
    "Hoopeston": ["60942"],
    "Hooppole": ["61258"],
    "Hopedale": ["61747"],
    "Hopkins Park": ["60944"],
    "Hoyleton": ["62803"],
    "Hudson": ["61748"],
    "Huey": ["62252"],
    "Hull": ["62343"],
    "Humboldt": ["61931"],
    "Hume": ["61932"],
    "Huntley": ["60142"],
    "Huntsville": ["62344"],
    "Hurst": ["62949"],
    "Hutsonville": ["62433"],
    "Illinois City": ["61259"],
    "Illiopolis": ["62539"],
    "Ina": ["62846"],
    "Indianola": ["61850"],
    "Industry": ["61440"],
    "Ingleside": ["60041"],
    "Ingraham": ["62434"],
    "Ipava": ["61441"],
    "Iroquois": ["60945"],
    "Irving": ["62051"],
    "Irvington": ["62848"],
    "Island Lake": ["60042"],
    "Itasca": ["60143"],
    "Iuka": ["62849"],
    "Ivesdale": ["61851"],
    "Jacksonville": ["62650", "62651"],
    "Jacob": ["62950"],
    "Janesville": ["62435"],
    "Jerseyville": ["62052"],
    "Jewett": ["62436"],
    "Johnsonville": ["62850"],
    "Johnston City": ["62951"],
    "Joliet": ["60431", "60432", "60433", "60434", "60435", "60436"],
    "Jonesboro": ["62952"],
    "Joppa": ["62953"],
    "Joy": ["61260"],
    "Junction": ["62954"],
    "Justice": ["60458"],
    "Kampsville": ["62053"],
    "Kane": ["62054"],
    "Kaneville": ["60144"],
    "Kankakee": ["60901"],
    "Kansas": ["61933"],
    "Karbers Ridge": ["62955"],
    "Karnak": ["62956"],
    "Kasbeer": ["61328"],
    "Keenes": ["62851"],
    "Keensburg": ["62852"],
    "Keithsburg": ["61442"],
    "Kell": ["62853"],
    "Kempton": ["60946"],
    "Kenilworth": ["60043"],
    "Kenney": ["61749"],
    "Kent": ["61044"],
    "Kewanee": ["61443"],
    "Keyesport": ["62253"],
    "Kilbourne": ["62655"],
    "Kincaid": ["62540"],
    "Kinderhook": ["62345"],
    "Kingston": ["60145"],
    "Kingston Mines": ["61539"],
    "Kinmundy": ["62854"],
    "Kinsman": ["60437"],
    "Kirkland": ["60146"],
    "Kirkwood": ["61447"],
    "Knoxville": ["61448"],
    "La Fayette": ["61449"],
    "La Grange": ["60525"],
    "La Grange Park": ["60526"],
    "La Harpe": ["61450"],
    "La Moille": ["61330"],
    "La Place": ["61936"],
    "La Prairie": ["62346"],
    "La Rose": ["61541"],
    "La Salle": ["61301"],
    "Lacon": ["61540"],
    "Ladd": ["61329"],
    "Lafox": ["60147"],
    "Lake Bluff": ["60044"],
    "Lake Forest": ["60045"],
    "Lake Fork": ["62541"],
    "Lake In The Hills": ["60156"],
    "Lake Villa": ["60046"],
    "Lake Zurich": ["60047", "60049"],
    "Lakewood": ["62438"],
    "Lanark": ["61046"],
    "Lancaster": ["62855"],
    "Lane": ["61750"],
    "Lansing": ["60438"],
    "Latham": ["62543"],
    "Laura": ["61451"],
    "Lawndale": ["61751"],
    "Lawrenceville": ["62439"],
    "Le Roy": ["61752"],
    "Leaf River": ["61047"],
    "Lebanon": ["62254"],
    "Lee": ["60530"],
    "Lee Center": ["61331"],
    "Leland": ["60531"],
    "Lemont": ["60439"],
    "Lena": ["61048"],
    "Lenzburg": ["62255"],
    "Leonore": ["61332"],
    "Lerna": ["62440"],
    "Lewistown": ["61542"],
    "Lexington": ["61753"],
    "Liberty": ["62347"],
    "Libertyville": ["60048", "60092"],
    "Lima": ["62348"],
    "Lincoln": ["62656"],
    "Lincolns New Salem": ["62659"],
    "Lincolnshire": ["60069"],
    "Lincolnwood": ["60712"],
    "Lindenwood": ["61049"],
    "Lisle": ["60532"],
    "Litchfield": ["62056"],
    "Literberry": ["62660"],
    "Little York": ["61453"],
    "Littleton": ["61452"],
    "Liverpool": ["61543"],
    "Livingston": ["62058"],
    "Loami": ["62661"],
    "Lockport": ["60441"],
    "Loda": ["60948"],
    "Logan": ["62856"],
    "Lomax": ["61454"],
    "Lombard": ["60148"],
    "London Mills": ["61544"],
    "Long Point": ["61333"],
    "Longview": ["61852"],
    "Loogootee": ["62857"],
    "Loraine": ["62349"],
    "Lostant": ["61334"],
    "Louisville": ["62858"],
    "Lovejoy": ["62059"],
    "Loves Park": ["61111", "61130", "61131", "61132"],
    "Lovington": ["61937"],
    "Lowder": ["62662"],
    "Lowpoint": ["61545"],
    "Ludlow": ["60949"],
    "Lyndon": ["61261"],
    "Lynn Center": ["61262"],
    "Lyons": ["60534"],
    "Macedonia": ["62860"],
    "Machesney Park": ["61115"],
    "Mackinaw": ["61755"],
    "Macomb": ["61455"],
    "Macon": ["62544"],
    "Madison": ["62060"],
    "Maeystown": ["62256"],
    "Magnolia": ["61336"],
    "Mahomet": ["61853"],
    "Makanda": ["62958"],
    "Malden": ["61337"],
    "Malta": ["60150"],
    "Manchester": ["62663"],
    "Manhattan": ["60442"],
    "Manito": ["61546"],
    "Manlius": ["61338"],
    "Mansfield": ["61854"],
    "Manteno": ["60950"],
    "Maple Park": ["60151"],
    "Mapleton": ["61547"],
    "Maquon": ["61458"],
    "Marengo": ["60152"],
    "Marietta": ["61459"],
    "Marine": ["62061"],
    "Marion": ["62959"],
    "Marissa": ["62257"],
    "Mark": ["61340"],
    "Markham": ["60428"],
    "Maroa": ["61756"],
    "Marseilles": ["61341"],
    "Marshall": ["62441"],
    "Martinsville": ["62442"],
    "Martinton": ["60951"],
    "Maryville": ["62062"],
    "Mascoutah": ["62224", "62258"],
    "Mason": ["62443"],
    "Mason City": ["62664"],
    "Matherville": ["61263"],
    "Matteson": ["60443"],
    "Mattoon": ["61938"],
    "Maunie": ["62861"],
    "Maywood": ["60153"],
    "Mazon": ["60444"],
    "Mc Clure": ["62957"],
    "Mc Connell": ["61050"],
    "Mc Lean": ["61754"],
    "Mc Leansboro": ["62859"],
    "Mc Nabb": ["61335"],
    "Mchenry": ["60050", "60051"],
    "Mechanicsburg": ["62545"],
    "Media": ["61460"],
    "Medinah": ["60157"],
    "Medora": ["62063"],
    "Melrose Park": ["60160", "60161", "60164"],
    "Melvin": ["60952"],
    "Menard": ["62259"],
    "Mendon": ["62351"],
    "Mendota": ["61342"],
    "Meredosia": ["62665"],
    "Merna": ["61758"],
    "Metamora": ["61548"],
    "Metcalf": ["61940"],
    "Metropolis": ["62960"],
    "Michael": ["62065"],
    "Middletown": ["62666"],
    "Midlothian": ["60445"],
    "Milan": ["61264"],
    "Milford": ["60953"],
    "Mill Shoals": ["62862"],
    "Millbrook": ["60536"],
    "Millcreek": ["62961"],
    "Milledgeville": ["61051"],
    "Miller City": ["62962"],
    "Millington": ["60537"],
    "Millstadt": ["62260"],
    "Milmine": ["61855"],
    "Milton": ["62352"],
    "Mineral": ["61344"],
    "Minier": ["61759"],
    "Minonk": ["61760"],
    "Minooka": ["60447"],
    "Mode": ["62444"],
    "Modesto": ["62667"],
    "Modoc": ["62261"],
    "Mokena": ["60448"],
    "Moline": ["61265", "61266"],
    "Momence": ["60954"],
    "Monee": ["60449"],
    "Monmouth": ["61462"],
    "Monroe Center": ["61052"],
    "Montgomery": ["60538"],
    "Monticello": ["61856"],
    "Montrose": ["62445"],
    "Mooseheart": ["60539"],
    "Moro": ["62067"],
    "Morris": ["60450"],
    "Morrison": ["61270"],
    "Morrisonville": ["62546"],
    "Morton": ["61550"],
    "Morton Grove": ["60053"],
    "Mossville": ["61552"],
    "Mound City": ["62963"],
    "Mounds": ["62964"],
    "Mount Auburn": ["62547"],
    "Mount Carmel": ["62863"],
    "Mount Carroll": ["61053"],
    "Mount Erie": ["62446"],
    "Mount Morris": ["61054"],
    "Mount Olive": ["62069"],
    "Mount Prospect": ["60056"],
    "Mount Pulaski": ["62548"],
    "Mount Sterling": ["62353"],
    "Mount Vernon": ["62864"],
    "Moweaqua": ["62550"],
    "Mozier": ["62070"],
    "Mt Zion": ["62549"],
    "Muddy": ["62965"],
    "Mulberry Grove": ["62262"],
    "Mulkeytown": ["62865"],
    "Muncie": ["61857"],
    "Mundelein": ["60060"],
    "Murdock": ["61941"],
    "Murphysboro": ["62966"],
    "Murrayville": ["62668"],
    "Nachusa": ["61057"],
    "Naperville": ["60540", "60563", "60564", "60565", "60566", "60567"],
    "Nashville": ["62263"],
    "Nason": ["62866"],
    "National Stock Yards": ["62071"],
    "Nauvoo": ["62354"],
    "Nebo": ["62355"],
    "Neoga": ["62447"],
    "Neponset": ["61345"],
    "New Athens": ["62264"],
    "New Baden": ["62265"],
    "New Bedford": ["61346"],
    "New Berlin": ["62670"],
    "New Boston": ["61272"],
    "New Burnside": ["62967"],
    "New Canton": ["62356"],
    "New Douglas": ["62074"],
    "New Haven": ["62867"],
    "New Holland": ["62671"],
    "New Lenox": ["60451"],
    "New Memphis": ["62266"],
    "New Salem": ["62357"],
    "New Windsor": ["61465"],
    "Newark": ["60541"],
    "Newman": ["61942"],
    "Newton": ["62448"],
    "Niantic": ["62551"],
    "Niles": ["60714"],
    "Nilwood": ["62672"],
    "Niota": ["62358"],
    "Noble": ["62868"],
    "Nokomis": ["62075"],
    "Nora": ["61059"],
    "Normal": ["61761", "61790"],
    "Norris": ["61553"],
    "Norris City": ["62869"],
    "North Aurora": ["60542"],
    "North Chicago": ["60064", "60086"],
    "North Henderson": ["61466"],
    "Northbrook": ["60062", "60065"],
    "O Fallon": ["62269"],
    "Oak Brook": ["60523"],
    "Oak Forest": ["60452"],
    "Oak Lawn": ["60453", "60454"],
    "Oak Park": ["60301", "60302", "60303", "60304"],
    "Oakdale": ["62268"],
    "Oakford": ["62673"],
    "Oakland": ["61943"],
    "Oakwood": ["61858"],
    "Oblong": ["62449"],
    "Oconee": ["62553"],
    "Odell": ["60460"],
    "Odin": ["62870"],
    "Ogden": ["61859"],
    "Oglesby": ["61348"],
    "Ohio": ["61349"],
    "Ohlman": ["62076"],
    "Okawville": ["62271"],
    "Olive Branch": ["62969"],
    "Olmsted": ["62970"],
    "Olney": ["62450"],
    "Olympia Fields": ["60461"],
    "Omaha": ["62871"],
    "Onarga": ["60955"],
    "Oneida": ["61467"],
    "Opdyke": ["62872"],
    "Ophiem": ["61468"],
    "Oquawka": ["61469"],
    "Orangeville": ["61060"],
    "Oraville": ["62971"],
    "Oreana": ["62554"],
    "Oregon": ["61061"],
    "Orient": ["62874"],
    "Orion": ["61273"],
    "Orland Park": ["60462", "60467"],
    "Osco": ["61274"],
    "Oswego": ["60543"],
    "Ottawa": ["61350"],
    "Owaneco": ["62555"],
    "Ozark": ["62972"],
    "Palatine": ["60038", "60055", "60067", "60074", "60078", "60094", "60095"],
    "Palestine": ["62451"],
    "Palmer": ["62556"],
    "Palmyra": ["62674"],
    "Paloma": ["62359"],
    "Palos Heights": ["60463"],
    "Palos Hills": ["60465"],
    "Palos Park": ["60464"],
    "Pana": ["62557"],
    "Panama": ["62077"],
    "Papineau": ["60956"],
    "Paris": ["61944"],
    "Park Forest": ["60466"],
    "Park Ridge": ["60068"],
    "Parkersburg": ["62452"],
    "Patoka": ["62875"],
    "Patterson": ["62078"],
    "Paw Paw": ["61353"],
    "Pawnee": ["62558"],
    "Paxton": ["60957"],
    "Payson": ["62360"],
    "Pearl": ["62361"],
    "Pearl City": ["61062"],
    "Pecatonica": ["61063"],
    "Pekin": ["61554", "61555", "61558"],
    "Pembroke Township": ["60958"],
    "Penfield": ["61862"],
    "Peoria": ["61601", "61602", "61603", "61604", "61605", "61606", "61607", "61612", "61613", "61614", "61615", "61625", "61629", "61630", "61633", "61634", "61636", "61637", "61638", "61639", "61641", "61643", "61650", "61651", "61652", "61653", "61654", "61655", "61656"],
    "Peoria Heights": ["61616"],
    "Peotone": ["60468"],
    "Percy": ["62272"],
    "Perks": ["62973"],
    "Perry": ["62362"],
    "Peru": ["61354"],
    "Pesotum": ["61863"],
    "Petersburg": ["62675"],
    "Philo": ["61864"],
    "Piasa": ["62079"],
    "Pierron": ["62273"],
    "Pinckneyville": ["62274"],
    "Piper City": ["60959"],
    "Pittsburg": ["62974"],
    "Pittsfield": ["62363"],
    "Plainfield": ["60544", "60585", "60586"],
    "Plainville": ["62365"],
    "Plano": ["60545"],
    "Plato Center": ["60170"],
    "Pleasant Hill": ["62366"],
    "Pleasant Plains": ["62677"],
    "Plymouth": ["62367"],
    "Pocahontas": ["62275"],
    "Polo": ["61064"],
    "Pomona": ["62975"],
    "Pontiac": ["61764"],
    "Poplar Grove": ["61065"],
    "Port Byron": ["61275"],
    "Posen": ["60469"],
    "Potomac": ["61865"],
    "Prairie City": ["61470"],
    "Prairie Du Rocher": ["62277"],
    "Preemption": ["61276"],
    "Princeton": ["61356"],
    "Princeville": ["61559"],
    "Prophetstown": ["61277"],
    "Prospect Heights": ["60070"],
    "Pulaski": ["62976"],
    "Putnam": ["61560"],
    "Quincy": ["62301", "62305", "62306"],
    "Radom": ["62876"],
    "Raleigh": ["62977"],
    "Ramsey": ["62080"],
    "Rankin": ["60960"],
    "Ransom": ["60470"],
    "Rantoul": ["61866"],
    "Rapids City": ["61278"],
    "Raritan": ["61471"],
    "Raymond": ["62560"],
    "Red Bud": ["62278"],
    "Reddick": ["60961"],
    "Redmon": ["61949"],
    "Renault": ["62279"],
    "Reynolds": ["61279"],
    "Richmond": ["60071"],
    "Richton Park": ["60471"],
    "Richview": ["62877"],
    "Ridge Farm": ["61870"],
    "Ridgway": ["62979"],
    "Ridott": ["61067"],
    "Rinard": ["62878"],
    "Ringwood": ["60072"],
    "Rio": ["61472"],
    "River Forest": ["60305"],
    "River Grove": ["60171"],
    "Riverdale": ["60827"],
    "Riverside": ["60546"],
    "Riverton": ["62561"],
    "Roanoke": ["61561"],
    "Robbins": ["60472"],
    "Roberts": ["60962"],
    "Robinson": ["62454"],
    "Rochelle": ["61068"],
    "Rochester": ["62563"],
    "Rock City": ["61070"],
    "Rock Falls": ["61071"],
    "Rock Island": ["61201", "61204", "61299"],
    "Rockbridge": ["62081"],
    "Rockford": ["61101", "61102", "61103", "61104", "61105", "61106", "61107", "61108", "61109", "61110", "61112", "61114", "61125", "61126"],
    "Rockport": ["62370"],
    "Rockton": ["61072"],
    "Rockwood": ["62280"],
    "Rolling Meadows": ["60008"],
    "Rome": ["61562"],
    "Romeoville": ["60446"],
    "Roodhouse": ["62082"],
    "Rosamond": ["62083"],
    "Roscoe": ["61073"],
    "Roselle": ["60172"],
    "Roseville": ["61473"],
    "Rosiclare": ["62982"],
    "Rossville": ["60963"],
    "Round Lake": ["60073"],
    "Roxana": ["62084"],
    "Royal": ["61871"],
    "Royalton": ["62983"],
    "Rushville": ["62681"],
    "Russell": ["60075"],
    "Rutland": ["61358"],
    "Sadorus": ["61872"],
    "Sailor Springs": ["62879"],
    "Saint Anne": ["60964"],
    "Saint Augustine": ["61474"],
    "Saint Charles": ["60174", "60175"],
    "Saint David": ["61563"],
    "Saint Elmo": ["62458"],
    "Saint Francisville": ["62460"],
    "Saint Jacob": ["62281"],
    "Saint Joseph": ["61873"],
    "Saint Libory": ["62282"],
    "Saint Peter": ["62880"],
    "Sainte Marie": ["62459"],
    "Salem": ["62881"],
    "San Jose": ["62682"],
    "Sandoval": ["62882"],
    "Sandwich": ["60548"],
    "Saunemin": ["61769"],
    "Savanna": ["61074"],
    "Savoy": ["61874"],
    "Sawyerville": ["62085"],
    "Saybrook": ["61770"],
    "Scales Mound": ["61075"],
    "Schaumburg": ["60159", "60168", "60173", "60193", "60194", "60195", "60196"],
    "Scheller": ["62883"],
    "Schiller Park": ["60176"],
    "Sciota": ["61475"],
    "Scott Air Force Base": ["62225"],
    "Scottville": ["62683"],
    "Seaton": ["61476"],
    "Seatonville": ["61359"],
    "Secor": ["61771"],
    "Seneca": ["61360"],
    "Serena": ["60549"],
    "Sesser": ["62884"],
    "Seward": ["61077"],
    "Seymour": ["61875"],
    "Shabbona": ["60550"],
    "Shannon": ["61078"],
    "Shawneetown": ["62984"],
    "Sheffield": ["61361"],
    "Shelbyville": ["62565"],
    "Sheldon": ["60966"],
    "Sheridan": ["60551"],
    "Sherman": ["62684"],
    "Sherrard": ["61281"],
    "Shipman": ["62685"],
    "Shirland": ["61079"],
    "Shirley": ["61772"],
    "Shobonier": ["62885"],
    "Shorewood": ["60404"],
    "Shumway": ["62461"],
    "Sibley": ["61773"],
    "Sidell": ["61876"],
    "Sidney": ["61877"],
    "Sigel": ["62462"],
    "Silvis": ["61282"],
    "Simpson": ["62985"],
    "Sims": ["62886"],
    "Skokie": ["60076", "60077"],
    "Smithboro": ["62284"],
    "Smithfield": ["61477"],
    "Smithshire": ["61478"],
    "Smithton": ["62285"],
    "Somonauk": ["60552"],
    "Sorento": ["62086"],
    "South Beloit": ["61080"],
    "South Elgin": ["60177"],
    "South Holland": ["60473"],
    "South Pekin": ["61564"],
    "South Roxana": ["62087"],
    "South Wilmington": ["60474"],
    "Sparland": ["61565"],
    "Sparta": ["62286"],
    "Speer": ["61479"],
    "Spring Grove": ["60081"],
    "Spring Valley": ["61362"],
    "Springerton": ["62887"],
    "Springfield": ["62701", "62702", "62703", "62704", "62705", "62706", "62707", "62708", "62711", "62712", "62713", "62715", "62716", "62719", "62721", "62722", "62723", "62726", "62736", "62739", "62746", "62756", "62757", "62761", "62762", "62763", "62764", "62765", "62766", "62767", "62769", "62776", "62777", "62781", "62786", "62791", "62794", "62796"],
    "Standard": ["61363"],
    "Stanford": ["61774"],
    "Staunton": ["62088"],
    "Steeleville": ["62288"],
    "Steger": ["60475"],
    "Sterling": ["61081"],
    "Steward": ["60553"],
    "Stewardson": ["62463"],
    "Stillman Valley": ["61084"],
    "Stockland": ["60967"],
    "Stockton": ["61085"],
    "Stone Park": ["60165"],
    "Stonefort": ["62987"],
    "Stonington": ["62567"],
    "Stoy": ["62464"],
    "Strasburg": ["62465"],
    "Strawn": ["61775"],
    "Streamwood": ["60107"],
    "Streator": ["61364"],
    "Stronghurst": ["61480"],
    "Sublette": ["61367"],
    "Sugar Grove": ["60554"],
    "Sullivan": ["61951"],
    "Summerfield": ["62289"],
    "Summit Argo": ["60501"],
    "Sumner": ["62466"],
    "Sutter": ["62373"],
    "Sycamore": ["60178"],
    "Table Grove": ["61482"],
    "Tallula": ["62688"],
    "Tamaroa": ["62888"],
    "Tamms": ["62988"],
    "Tampico": ["61283"],
    "Taylor Ridge": ["61284"],
    "Taylor Springs": ["62089"],
    "Taylorville": ["62568"],
    "Techny": ["60082"],
    "Tennessee": ["62374"],
    "Teutopolis": ["62467"],
    "Texico": ["62889"],
    "Thawville": ["60968"],
    "Thayer": ["62689"],
    "Thebes": ["62990"],
    "Thomasboro": ["61878"],
    "Thompsonville": ["62890"],
    "Thomson": ["61285"],
    "Thornton": ["60476"],
    "Tilden": ["62292"],
    "Tilton": ["61833"],
    "Timewell": ["62375"],
    "Tinley Park": ["60477", "60487"],
    "Tiskilwa": ["61368"],
    "Toledo": ["62468"],
    "Tolono": ["61880"],
    "Toluca": ["61369"],
    "Tonica": ["61370"],
    "Topeka": ["61567"],
    "Toulon": ["61483"],
    "Tovey": ["62570"],
    "Towanda": ["61776"],
    "Tower Hill": ["62571"],
    "Tremont": ["61568"],
    "Trenton": ["62293"],
    "Trilla": ["62469"],
    "Triumph": ["61371"],
    "Trivoli": ["61569"],
    "Troy": ["62294"],
    "Troy Grove": ["61372"],
    "Tuscola": ["61953"],
    "Ullin": ["62992"],
    "Union": ["60180"],
    "Union Hill": ["60969"],
    "Unity": ["62993"],
    "University Park": ["60484"],
    "Urbana": ["61801", "61802", "61803"],
    "Ursa": ["62376"],
    "Utica": ["61373"],
    "Valier": ["62891"],
    "Valmeyer": ["62295"],
    "Van Orin": ["61374"],
    "Vandalia": ["62471"],
    "Varna": ["61375"],
    "Venice": ["62090"],
    "Vergennes": ["62994"],
    "Vermilion": ["61955"],
    "Vermont": ["61484"],
    "Vernon": ["62892"],
    "Vernon Hills": ["60061"],
    "Verona": ["60479"],
    "Versailles": ["62378"],
    "Victoria": ["61485"],
    "Vienna": ["62995"],
    "Villa Grove": ["61956"],
    "Villa Park": ["60181"],
    "Villa Ridge": ["62996"],
    "Viola": ["61486"],
    "Virden": ["62690"],
    "Virginia": ["62691"],
    "Wadsworth": ["60083"],
    "Waggoner": ["62572"],
    "Walnut": ["61376"],
    "Walnut Hill": ["62893"],
    "Walsh": ["62297"],
    "Walshville": ["62091"],
    "Waltonville": ["62894"],
    "Wapella": ["61777"],
    "Warren": ["61087"],
    "Warrensburg": ["62573"],
    "Warrenville": ["60555"],
    "Warsaw": ["62379"],
    "Wasco": ["60183"],
    "Washburn": ["61570"],
    "Washington": ["61571"],
    "Wataga": ["61488"],
    "Waterloo": ["62298"],
    "Waterman": ["60556"],
    "Watseka": ["60970"],
    "Watson": ["62473"],
    "Wauconda": ["60084"],
    "Waukegan": ["60079", "60085", "60087"],
    "Waverly": ["62692"],
    "Wayne": ["60184"],
    "Wayne City": ["62895"],
    "Waynesville": ["61778"],
    "Wedron": ["60557"],
    "Weldon": ["61882"],
    "Wellington": ["60973"],
    "Wenona": ["61377"],
    "West Brooklyn": ["61378"],
    "West Chicago": ["60185", "60186"],
    "West Frankfort": ["62896"],
    "West Liberty": ["62475"],
    "West Point": ["62380"],
    "West Salem": ["62476"],
    "West Union": ["62477"],
    "West York": ["62478"],
    "Westchester": ["60154"],
    "Western Springs": ["60558"],
    "Westfield": ["62474"],
    "Westmont": ["60559"],
    "Westville": ["61883"],
    "Wheaton": ["60187", "60189"],
    "Wheeler": ["62479"],
    "Wheeling": ["60090"],
    "White Hall": ["62092"],
    "White Heath": ["61884"],
    "Whittington": ["62897"],
    "Williamsfield": ["61489"],
    "Williamsville": ["62693"],
    "Willisville": ["62997"],
    "Willow Hill": ["62480"],
    "Willow Springs": ["60480"],
    "Willowbrook": ["60527"],
    "Wilmette": ["60091"],
    "Wilmington": ["60481"],
    "Wilsonville": ["62093"],
    "Winchester": ["62694"],
    "Windsor": ["61957"],
    "Winfield": ["60190"],
    "Winnebago": ["61088"],
    "Winnetka": ["60093"],
    "Winslow": ["61089"],
    "Winthrop Harbor": ["60096"],
    "Witt": ["62094"],
    "Wolf Lake": ["62998"],
    "Wonder Lake": ["60097"],
    "Wood Dale": ["60191", "60399"],
    "Wood River": ["62095"],
    "Woodhull": ["61490"],
    "Woodland": ["60974"],
    "Woodlawn": ["62898"],
    "Woodridge": ["60517"],
    "Woodson": ["62695"],
    "Woodstock": ["60098"],
    "Woosung": ["61091"],
    "Worden": ["62097"],
    "Worth": ["60482"],
    "Wrights": ["62098"],
    "Wyanet": ["61379"],
    "Wyoming": ["61491"],
    "Xenia": ["62899"],
    "Yale": ["62481"],
    "Yates City": ["61572"],
    "Yorkville": ["60560"],
    "Zeigler": ["62999"],
    "Zion": ["60099"]
  },
  "IN": {
    "Advance": ["46102"],
    "Akron": ["46910"],
    "Alamo": ["47916"],
    "Albany": ["47320"],
    "Albion": ["46701"],
    "Alexandria": ["46001"],
    "Ambia": ["47917"],
    "Amboy": ["46911"],
    "Amo": ["46103"],
    "Anderson": ["46011", "46012", "46013", "46014", "46015", "46016", "46017", "46018"],
    "Andrews": ["46702"],
    "Angola": ["46703"],
    "Arcadia": ["46030"],
    "Arcola": ["46704"],
    "Argos": ["46501"],
    "Arlington": ["46104"],
    "Ashley": ["46705"],
    "Athens": ["46912"],
    "Atlanta": ["46031"],
    "Attica": ["47918"],
    "Atwood": ["46502"],
    "Auburn": ["46706"],
    "Aurora": ["47001"],
    "Austin": ["47102"],
    "Avilla": ["46710"],
    "Avoca": ["47420"],
    "Avon": ["46123"],
    "Bainbridge": ["46105"],
    "Bargersville": ["46106"],
    "Batesville": ["47006"],
    "Bath": ["47010"],
    "Battle Ground": ["47920"],
    "Bedford": ["47421"],
    "Beech Grove": ["46107"],
    "Bellmore": ["47830"],
    "Bennington": ["47011"],
    "Bentonville": ["47322"],
    "Berne": ["46711"],
    "Bethlehem": ["47104"],
    "Beverly Shores": ["46301"],
    "Bicknell": ["47512"],
    "Bippus": ["46713"],
    "Birdseye": ["47513"],
    "Blanford": ["47831"],
    "Bloomfield": ["47424"],
    "Bloomingdale": ["47832"],
    "Bloomington": ["47401", "47402", "47403", "47404", "47405", "47406", "47407", "47408", "47490"],
    "Bluffton": ["46714"],
    "Boggstown": ["46110"],
    "Boone Grove": ["46302"],
    "Boonville": ["47601"],
    "Borden": ["47106"],
    "Boston": ["47324"],
    "Boswell": ["47921"],
    "Bourbon": ["46504"],
    "Bowling Green": ["47833"],
    "Bradford": ["47107"],
    "Branchville": ["47514"],
    "Brazil": ["47834"],
    "Bremen": ["46506"],
    "Bridgeton": ["47836"],
    "Bringhurst": ["46913"],
    "Bristol": ["46507"],
    "Bristow": ["47515"],
    "Brook": ["47922"],
    "Brooklyn": ["46111"],
    "Brookston": ["47923"],
    "Brookville": ["47012"],
    "Brownsburg": ["46112"],
    "Brownstown": ["47220"],
    "Brownsville": ["47325"],
    "Bruceville": ["47516"],
    "Bryant": ["47326"],
    "Buck Creek": ["47924"],
    "Buckskin": ["47647"],
    "Buffalo": ["47925"],
    "Bunker Hill": ["46914"],
    "Burket": ["46508"],
    "Burlington": ["46915"],
    "Burnettsville": ["47926"],
    "Burrows": ["46916"],
    "Butler": ["46721"],
    "Butlerville": ["47223"],
    "Cambridge City": ["47327"],
    "Camby": ["46113"],
    "Camden": ["46917"],
    "Campbellsburg": ["47108"],
    "Canaan": ["47224"],
    "Cannelburg": ["47519"],
    "Cannelton": ["47520"],
    "Carbon": ["47837"],
    "Carlisle": ["47838"],
    "Carmel": ["46032", "46033", "46082"],
    "Carthage": ["46115"],
    "Cayuga": ["47928"],
    "Cedar Grove": ["47016"],
    "Cedar Lake": ["46303"],
    "Celestine": ["47521"],
    "Centerpoint": ["47840"],
    "Centerville": ["47330"],
    "Central": ["47110"],
    "Chalmers": ["47929"],
    "Chandler": ["47610"],
    "Charlestown": ["47111"],
    "Charlottesville": ["46117"],
    "Chesterton": ["46304"],
    "Chrisney": ["47611"],
    "Churubusco": ["46723"],
    "Cicero": ["46034"],
    "Clarks Hill": ["47930"],
    "Clarksburg": ["47225"],
    "Clarksville": ["47129"],
    "Clay City": ["47841"],
    "Claypool": ["46510"],
    "Clayton": ["46118"],
    "Clear Creek": ["47426"],
    "Clifford": ["47226"],
    "Clinton": ["47842"],
    "Cloverdale": ["46120"],
    "Coal City": ["47427"],
    "Coalmont": ["47845"],
    "Coatesville": ["46121"],
    "Colfax": ["46035"],
    "Columbia City": ["46725"],
    "Columbus": ["47201", "47202", "47203"],
    "Commiskey": ["47227"],
    "Connersville": ["47331"],
    "Converse": ["46919"],
    "Cortland": ["47228"],
    "Corunna": ["46730"],
    "Cory": ["47846"],
    "Corydon": ["47112"],
    "Covington": ["47932"],
    "Craigville": ["46731"],
    "Crandall": ["47114"],
    "Crane": ["47522"],
    "Crawfordsville": ["47933", "47934", "47935", "47936", "47937", "47938", "47939"],
    "Cromwell": ["46732"],
    "Cross Plains": ["47017"],
    "Crothersville": ["47229"],
    "Crown Point": ["46307", "46308"],
    "Culver": ["46511"],
    "Cutler": ["46920"],
    "Cynthiana": ["47612"],
    "Dale": ["47523"],
    "Daleville": ["47334"],
    "Dana": ["47847"],
    "Danville": ["46122"],
    "Darlington": ["47940"],
    "Dayton": ["47941"],
    "Decatur": ["46733"],
    "Decker": ["47524"],
    "Deedsville": ["46921"],
    "Delong": ["46922"],
    "Delphi": ["46923"],
    "Demotte": ["46310"],
    "Denver": ["46926"],
    "Depauw": ["47115"],
    "Deputy": ["47230"],
    "Derby": ["47525"],
    "Dillsboro": ["47018"],
    "Donaldson": ["46513"],
    "Dublin": ["47335"],
    "Dubois": ["47527"],
    "Dugger": ["47848"],
    "Dunkirk": ["47336"],
    "Dunreith": ["47337"],
    "Dupont": ["47231"],
    "Dyer": ["46311"],
    "Earl Park": ["47942"],
    "East Chicago": ["46312"],
    "East Enterprise": ["47019"],
    "Eaton": ["47338"],
    "Eckerty": ["47116"],
    "Economy": ["47339"],
    "Edinburgh": ["46124"],
    "Edwardsport": ["47528"],
    "Elberfeld": ["47613"],
    "Elizabeth": ["47117"],
    "Elizabethtown": ["47232"],
    "Elkhart": ["46514", "46515", "46516", "46517"],
    "Ellettsville": ["47429"],
    "Elnora": ["47529"],
    "Elwood": ["46036"],
    "Eminence": ["46125"],
    "English": ["47118"],
    "Etna Green": ["46524"],
    "Evanston": ["47531"],
    "Evansville": ["47701", "47702", "47703", "47704", "47705", "47706", "47708", "47710", "47711", "47712", "47713", "47714", "47715", "47716", "47719", "47720", "47721", "47722", "47724", "47725", "47727", "47728", "47730", "47731", "47732", "47733", "47734", "47735", "47736", "47737", "47739", "47740", "47741", "47744", "47747", "47750"],
    "Fair Oaks": ["47943"],
    "Fairbanks": ["47849"],
    "Fairland": ["46126"],
    "Fairmount": ["46928"],
    "Falmouth": ["46127"],
    "Farmersburg": ["47850"],
    "Farmland": ["47340"],
    "Ferdinand": ["47532"],
    "Fillmore": ["46128"],
    "Finly": ["46129"],
    "Fishers": ["46037", "46038", "46085"],
    "Flat Rock": ["47234"],
    "Flora": ["46929"],
    "Florence": ["47020"],
    "Floyds Knobs": ["47119"],
    "Folsomville": ["47614"],
    "Fontanet": ["47851"],
    "Forest": ["46039"],
    "Fort Branch": ["47648"],
    "Fort Ritner": ["47430"],
    "Fort Wayne": ["46801", "46802", "46803", "46804", "46805", "46806", "46807", "46808", "46809", "46814", "46815", "46816", "46818", "46819", "46825", "46835", "46845", "46850", "46851", "46852", "46853", "46854", "46855", "46856", "46857", "46858", "46859", "46860", "46861", "46862", "46863", "46864", "46865", "46866", "46867", "46868", "46869", "46885", "46895", "46896", "46897", "46898", "46899"],
    "Fortville": ["46040"],
    "Fountain City": ["47341"],
    "Fountaintown": ["46130"],
    "Fowler": ["47944"],
    "Fowlerton": ["46930"],
    "Francesville": ["47946"],
    "Francisco": ["47649"],
    "Frankfort": ["46041"],
    "Franklin": ["46131"],
    "Frankton": ["46044"],
    "Fredericksburg": ["47120"],
    "Freedom": ["47431"],
    "Freelandville": ["47535"],
    "Freetown": ["47235"],
    "Fremont": ["46737"],
    "French Lick": ["47432"],
    "Friendship": ["47021"],
    "Fulda": ["47536"],
    "Fulton": ["46931"],
    "Galveston": ["46932"],
    "Garrett": ["46738"],
    "Gary": ["46401", "46402", "46403", "46404", "46406", "46407", "46408", "46409"],
    "Gas City": ["46933"],
    "Gaston": ["47342"],
    "Geneva": ["46740"],
    "Gentryville": ["47537"],
    "Georgetown": ["47122"],
    "Glenwood": ["46133"],
    "Goldsmith": ["46045"],
    "Goodland": ["47948"],
    "Goshen": ["46526", "46527", "46528"],
    "Gosport": ["47433"],
    "Grabill": ["46741"],
    "Grammer": ["47236"],
    "Grandview": ["47615"],
    "Granger": ["46530"],
    "Grantsburg": ["47123"],
    "Grass Creek": ["46935"],
    "Graysville": ["47852"],
    "Greencastle": ["46135"],
    "Greenfield": ["46140"],
    "Greens Fork": ["47345"],
    "Greensboro": ["47344"],
    "Greensburg": ["47240"],
    "Greentown": ["46936"],
    "Greenville": ["47124"],
    "Greenwood": ["46142", "46143"],
    "Griffin": ["47616"],
    "Griffith": ["46319"],
    "Grissom Arb": ["46971"],
    "Grovertown": ["46531"],
    "Guilford": ["47022"],
    "Gwynneville": ["46144"],
    "Hagerstown": ["47346"],
    "Hamilton": ["46742"],
    "Hamlet": ["46532"],
    "Hammond": ["46320", "46323", "46324", "46325", "46327"],
    "Hanna": ["46340"],
    "Hanover": ["47243"],
    "Hardinsburg": ["47125"],
    "Harlan": ["46743"],
    "Harmony": ["47853"],
    "Harrodsburg": ["47434"],
    "Hartford City": ["47348"],
    "Hartsville": ["47244"],
    "Hatfield": ["47617"],
    "Haubstadt": ["47639"],
    "Hayden": ["47245"],
    "Hazleton": ["47640"],
    "Hebron": ["46341"],
    "Helmsburg": ["47435"],
    "Heltonville": ["47436"],
    "Hemlock": ["46937"],
    "Henryville": ["47126"],
    "Highland": ["46322"],
    "Hillsboro": ["47949"],
    "Hillsdale": ["47854"],
    "Hoagland": ["46745"],
    "Hobart": ["46342"],
    "Hobbs": ["46047"],
    "Holland": ["47541"],
    "Holton": ["47023"],
    "Homer": ["46146"],
    "Hope": ["47246"],
    "Howe": ["46746"],
    "Hudson": ["46747"],
    "Huntertown": ["46748"],
    "Huntingburg": ["47542"],
    "Huntington": ["46750"],
    "Huron": ["47437"],
    "Hymera": ["47855"],
    "Idaville": ["47950"],
    "Indianapolis": ["46201", "46202", "46203", "46204", "46205", "46206", "46207", "46208", "46209", "46210", "46211", "46213", "46214", "46216", "46217", "46218", "46219", "46220", "46221", "46222", "46223", "46224", "46225", "46226", "46227", "46228", "46229", "46230", "46231", "46234", "46235", "46236", "46237", "46239", "46240", "46241", "46242", "46244", "46247", "46249", "46250", "46251", "46253", "46254", "46255", "46256", "46259", "46260", "46262", "46266", "46268", "46274", "46275", "46277", "46278", "46280", "46282", "46283", "46285", "46288", "46290", "46291", "46295", "46296", "46298"],
    "Ingalls": ["46048"],
    "Inglefield": ["47618"],
    "Ireland": ["47545"],
    "Jamestown": ["46147"],
    "Jasonville": ["47438"],
    "Jasper": ["47546", "47547", "47549"],
    "Jeffersonville": ["47130", "47131", "47132", "47133", "47134", "47144", "47190", "47199"],
    "Jonesboro": ["46938"],
    "Jonesville": ["47247"],
    "Judson": ["47856"],
    "Kempton": ["46049"],
    "Kendallville": ["46755"],
    "Kennard": ["47351"],
    "Kentland": ["47951"],
    "Kewanna": ["46939"],
    "Keystone": ["46759"],
    "Kimmell": ["46760"],
    "Kingman": ["47952"],
    "Kingsbury": ["46345"],
    "Kingsford Heights": ["46346"],
    "Kirklin": ["46050"],
    "Knightstown": ["46148"],
    "Knightsville": ["47857"],
    "Knox": ["46534"],
    "Kokomo": ["46901", "46902", "46903", "46904"],
    "Koleen": ["47439"],
    "Kouts": ["46347"],
    "Kurtz": ["47249"],
    "La Crosse": ["46348"],
    "La Fontaine": ["46940"],
    "La Porte": ["46350", "46352"],
    "Laconia": ["47135"],
    "Ladoga": ["47954"],
    "Lafayette": ["47901", "47902", "47903", "47904", "47905", "47909"],
    "Lagrange": ["46761"],
    "Lagro": ["46941"],
    "Lake Cicott": ["46942"],
    "Lake Station": ["46405"],
    "Lake Village": ["46349"],
    "Laketon": ["46943"],
    "Lakeville": ["46536"],
    "Lamar": ["47550"],
    "Lanesville": ["47136"],
    "Laotto": ["46763"],
    "Lapaz": ["46537"],
    "Lapel": ["46051"],
    "Larwill": ["46764"],
    "Laurel": ["47024"],
    "Lawrenceburg": ["47025"],
    "Leavenworth": ["47137"],
    "Lebanon": ["46052"],
    "Leesburg": ["46538"],
    "Leiters Ford": ["46945"],
    "Leo": ["46765"],
    "Leopold": ["47551"],
    "Leroy": ["46355"],
    "Lewis": ["47858"],
    "Lewisville": ["47352"],
    "Lexington": ["47138"],
    "Liberty": ["47353"],
    "Liberty Center": ["46766"],
    "Liberty Mills": ["46946"],
    "Ligonier": ["46767"],
    "Lincoln City": ["47552"],
    "Linden": ["47955"],
    "Linn Grove": ["46769"],
    "Linton": ["47441"],
    "Little York": ["47139"],
    "Lizton": ["46149"],
    "Logansport": ["46947"],
    "Loogootee": ["47553"],
    "Losantville": ["47354"],
    "Lowell": ["46356"],
    "Lucerne": ["46950"],
    "Lynn": ["47355"],
    "Lynnville": ["47619"],
    "Lyons": ["47443"],
    "Mackey": ["47654"],
    "Macy": ["46951"],
    "Madison": ["47250"],
    "Manilla": ["46150"],
    "Marengo": ["47140"],
    "Mariah Hill": ["47556"],
    "Marion": ["46952", "46953"],
    "Markle": ["46770"],
    "Markleville": ["46056"],
    "Marshall": ["47859"],
    "Martinsville": ["46151"],
    "Marysville": ["47141"],
    "Matthews": ["46957"],
    "Mauckport": ["47142"],
    "Maxwell": ["46154"],
    "Mays": ["46155"],
    "Mccordsville": ["46055"],
    "Mecca": ["47860"],
    "Medaryville": ["47957"],
    "Medora": ["47260"],
    "Mellott": ["47958"],
    "Memphis": ["47143"],
    "Mentone": ["46539"],
    "Merom": ["47861"],
    "Merrillville": ["46410", "46411"],
    "Metamora": ["47030"],
    "Mexico": ["46958"],
    "Miami": ["46959"],
    "Michigan City": ["46360", "46361"],
    "Michigantown": ["46057"],
    "Middlebury": ["46540"],
    "Middletown": ["47356"],
    "Midland": ["47445"],
    "Milan": ["47031"],
    "Milford": ["46542"],
    "Mill Creek": ["46365"],
    "Millersburg": ["46543"],
    "Millhousen": ["47261"],
    "Milltown": ["47145"],
    "Milroy": ["46156"],
    "Milton": ["47357"],
    "Mishawaka": ["46544", "46545", "46546"],
    "Mitchell": ["47446"],
    "Modoc": ["47358"],
    "Mongo": ["46771"],
    "Monon": ["47959"],
    "Monroe": ["46772"],
    "Monroe City": ["47557"],
    "Monroeville": ["46773"],
    "Monrovia": ["46157"],
    "Monterey": ["46960"],
    "Montezuma": ["47862"],
    "Montgomery": ["47558"],
    "Monticello": ["47960"],
    "Montmorenci": ["47962"],
    "Montpelier": ["47359"],
    "Mooreland": ["47360"],
    "Moores Hill": ["47032"],
    "Mooresville": ["46158"],
    "Morgantown": ["46160"],
    "Morocco": ["47963"],
    "Morris": ["47033"],
    "Morristown": ["46161"],
    "Mount Ayr": ["47964"],
    "Mount Saint Francis": ["47146"],
    "Mount Summit": ["47361"],
    "Mount Vernon": ["47620"],
    "Mulberry": ["46058"],
    "Muncie": ["47302", "47303", "47304", "47305", "47306", "47307", "47308"],
    "Munster": ["46321"],
    "Nabb": ["47147"],
    "Napoleon": ["47034"],
    "Nappanee": ["46550"],
    "Nashville": ["47448"],
    "Needham": ["46162"],
    "New Albany": ["47150", "47151"],
    "New Carlisle": ["46552"],
    "New Castle": ["47362"],
    "New Goshen": ["47863"],
    "New Harmony": ["47631"],
    "New Haven": ["46774"],
    "New Lisbon": ["47366"],
    "New Market": ["47965"],
    "New Middletown": ["47160"],
    "New Palestine": ["46163"],
    "New Paris": ["46553"],
    "New Point": ["47263"],
    "New Richmond": ["47967"],
    "New Ross": ["47968"],
    "New Salisbury": ["47161"],
    "New Trenton": ["47035"],
    "New Washington": ["47162"],
    "New Waverly": ["46961"],
    "Newberry": ["47449"],
    "Newburgh": ["47629", "47630"],
    "Newport": ["47966"],
    "Newtown": ["47969"],
    "Nineveh": ["46164"],
    "Noblesville": ["46060", "46061", "46062"],
    "Norman": ["47264"],
    "North Judson": ["46366"],
    "North Liberty": ["46554"],
    "North Manchester": ["46962"],
    "North Salem": ["46165"],
    "North Vernon": ["47265"],
    "North Webster": ["46555"],
    "Notre Dame": ["46556"],
    "Oakford": ["46965"],
    "Oakland City": ["47660"],
    "Oaktown": ["47561"],
    "Oakville": ["47367"],
    "Odon": ["47562"],
    "Oldenburg": ["47036"],
    "Onward": ["46967"],
    "Oolitic": ["47451"],
    "Ora": ["46968"],
    "Orestes": ["46063"],
    "Orland": ["46776"],
    "Orleans": ["47452"],
    "Osceola": ["46561"],
    "Osgood": ["47037"],
    "Ossian": ["46777"],
    "Otisco": ["47163"],
    "Otterbein": ["47970"],
    "Otwell": ["47564"],
    "Owensburg": ["47453"],
    "Owensville": ["47665"],
    "Oxford": ["47971"],
    "Palmyra": ["47164"],
    "Paoli": ["47454"],
    "Paragon": ["46166"],
    "Paris Crossing": ["47270"],
    "Parker City": ["47368"],
    "Patoka": ["47666"],
    "Patricksburg": ["47455"],
    "Patriot": ["47038"],
    "Paxton": ["47865"],
    "Pekin": ["47165"],
    "Pendleton": ["46064"],
    "Pennville": ["47369"],
    "Perrysville": ["47974"],
    "Pershing": ["47370"],
    "Peru": ["46970"],
    "Petersburg": ["47567"],
    "Petroleum": ["46778"],
    "Pierceton": ["46562"],
    "Pierceville": ["47039"],
    "Pimento": ["47866"],
    "Pine Village": ["47975"],
    "Pittsboro": ["46167"],
    "Plainfield": ["46168", "46197"],
    "Plainville": ["47568"],
    "Pleasant Lake": ["46779"],
    "Pleasant Mills": ["46780"],
    "Plymouth": ["46563"],
    "Poland": ["47868"],
    "Poneto": ["46781"],
    "Portage": ["46368"],
    "Portland": ["47371"],
    "Poseyville": ["47633"],
    "Prairie Creek": ["47869"],
    "Prairieton": ["47870"],
    "Preble": ["46782"],
    "Princeton": ["47670"],
    "Putnamville": ["46170"],
    "Quincy": ["47456"],
    "Ragsdale": ["47573"],
    "Ramsey": ["47166"],
    "Redkey": ["47373"],
    "Reelsville": ["46171"],
    "Remington": ["47977"],
    "Rensselaer": ["47978"],
    "Reynolds": ["47980"],
    "Richland": ["47634"],
    "Richmond": ["47374", "47375"],
    "Ridgeville": ["47380"],
    "Riley": ["47871"],
    "Rising Sun": ["47040"],
    "Roachdale": ["46172"],
    "Roann": ["46974"],
    "Roanoke": ["46783"],
    "Rochester": ["46975"],
    "Rockfield": ["46977"],
    "Rockport": ["47635"],
    "Rockville": ["47872"],
    "Rolling Prairie": ["46371"],
    "Rome": ["47574"],
    "Rome City": ["46784"],
    "Romney": ["47981"],
    "Rosedale": ["47874"],
    "Roselawn": ["46372"],
    "Rossville": ["46065"],
    "Royal Center": ["46978"],
    "Rushville": ["46173"],
    "Russellville": ["46175"],
    "Russiaville": ["46979"],
    "Saint Anthony": ["47575"],
    "Saint Bernice": ["47875"],
    "Saint Croix": ["47576"],
    "Saint Joe": ["46785"],
    "Saint John": ["46373"],
    "Saint Mary Of The Woods": ["47876"],
    "Saint Meinrad": ["47577"],
    "Saint Paul": ["47272"],
    "Salamonia": ["47381"],
    "Salem": ["47167"],
    "San Pierre": ["46374"],
    "Sandborn": ["47578"],
    "Santa Claus": ["47579"],
    "Saratoga": ["47382"],
    "Schererville": ["46375"],
    "Schneider": ["46376"],
    "Schnellville": ["47580"],
    "Scipio": ["47273"],
    "Scotland": ["47457"],
    "Scottsburg": ["47170"],
    "Sedalia": ["46067"],
    "Seelyville": ["47878"],
    "Sellersburg": ["47172"],
    "Selma": ["47383"],
    "Servia": ["46980"],
    "Seymour": ["47274"],
    "Sharpsville": ["46068"],
    "Shelburn": ["47879"],
    "Shelby": ["46377"],
    "Shelbyville": ["46176"],
    "Shepardsville": ["47880"],
    "Sheridan": ["46069"],
    "Shipshewana": ["46565"],
    "Shirley": ["47384"],
    "Shoals": ["47581"],
    "Silver Lake": ["46982"],
    "Smithville": ["47458"],
    "Solsberry": ["47459"],
    "Somerset": ["46984"],
    "Somerville": ["47683"],
    "South Bend": ["46601", "46604", "46613", "46614", "46615", "46616", "46617", "46619", "46620", "46624", "46626", "46628", "46634", "46635", "46637", "46660", "46680", "46699"],
    "South Milford": ["46786"],
    "South Whitley": ["46787"],
    "Spencer": ["47460"],
    "Spencerville": ["46788"],
    "Spiceland": ["47385"],
    "Springport": ["47386"],
    "Springville": ["47462"],
    "Spurgeon": ["47584"],
    "Stanford": ["47463"],
    "Star City": ["46985"],
    "State Line": ["47982"],
    "Staunton": ["47881"],
    "Stendal": ["47585"],
    "Stilesville": ["46180"],
    "Stinesville": ["47464"],
    "Stockwell": ["47983"],
    "Straughn": ["47387"],
    "Stroh": ["46789"],
    "Sullivan": ["47864", "47882"],
    "Sulphur": ["47174"],
    "Sulphur Springs": ["47388"],
    "Sumava Resorts": ["46379"],
    "Summitville": ["46070"],
    "Sunman": ["47041"],
    "Swayzee": ["46986"],
    "Sweetser": ["46987"],
    "Switz City": ["47465"],
    "Syracuse": ["46567"],
    "Talbot": ["47984"],
    "Taswell": ["47175"],
    "Taylorsville": ["47280"],
    "Tefft": ["46380"],
    "Tell City": ["47586"],
    "Templeton": ["47986"],
    "Tennyson": ["47637"],
    "Terre Haute": ["47801", "47802", "47803", "47804", "47805", "47807", "47808", "47809", "47811", "47812"],
    "Thayer": ["46381"],
    "Thorntown": ["46071"],
    "Tippecanoe": ["46570"],
    "Tipton": ["46072"],
    "Topeka": ["46571"],
    "Trafalgar": ["46181"],
    "Troy": ["47588"],
    "Tunnelton": ["47467"],
    "Twelve Mile": ["46988"],
    "Tyner": ["46572"],
    "Underwood": ["47177"],
    "Union City": ["47390"],
    "Union Mills": ["46382"],
    "Uniondale": ["46791"],
    "Unionville": ["47468"],
    "Universal": ["47884"],
    "Upland": ["46989"],
    "Urbana": ["46990"],
    "Vallonia": ["47281"],
    "Valparaiso": ["46383", "46384", "46385"],
    "Van Buren": ["46991"],
    "Veedersburg": ["47987"],
    "Velpen": ["47590"],
    "Vernon": ["47282"],
    "Versailles": ["47042"],
    "Vevay": ["47043"],
    "Vincennes": ["47591"],
    "Wabash": ["46992"],
    "Wadesville": ["47638"],
    "Wakarusa": ["46573"],
    "Waldron": ["46182"],
    "Walkerton": ["46574"],
    "Wallace": ["47988"],
    "Walton": ["46994"],
    "Wanatah": ["46390"],
    "Warren": ["46792"],
    "Warsaw": ["46580", "46581", "46582"],
    "Washington": ["47501"],
    "Waterloo": ["46793"],
    "Waveland": ["47989"],
    "Wawaka": ["46794"],
    "Waynetown": ["47990"],
    "Webster": ["47392"],
    "West Baden Springs": ["47469"],
    "West College Corner": ["47003"],
    "West Harrison": ["47060"],
    "West Lafayette": ["47906", "47907", "47996"],
    "West Lebanon": ["47991"],
    "West Middleton": ["46995"],
    "West Newton": ["46183"],
    "West Terre Haute": ["47885"],
    "Westfield": ["46074"],
    "Westphalia": ["47596"],
    "Westpoint": ["47992"],
    "Westport": ["47283"],
    "Westville": ["46391"],
    "Wheatfield": ["46392"],
    "Wheatland": ["47597"],
    "Wheeler": ["46393"],
    "Whiteland": ["46184"],
    "Whitestown": ["46075"],
    "Whiting": ["46394"],
    "Wilkinson": ["46186"],
    "Williams": ["47470"],
    "Williamsburg": ["47393"],
    "Williamsport": ["47993"],
    "Winamac": ["46996"],
    "Winchester": ["47394"],
    "Windfall": ["46076"],
    "Wingate": ["47994"],
    "Winona Lake": ["46590"],
    "Winslow": ["47598"],
    "Wolcott": ["47995"],
    "Wolcottville": ["46795"],
    "Wolflake": ["46796"],
    "Woodburn": ["46797"],
    "Worthington": ["47471"],
    "Wyatt": ["46595"],
    "Yeoman": ["47997"],
    "Yoder": ["46798"],
    "Yorktown": ["47396"],
    "Young America": ["46998"],
    "Zanesville": ["46799"],
    "Zionsville": ["46077"]
  },
  "KS": {
    "Abbyville": ["67510"],
    "Abilene": ["67410"],
    "Admire": ["66830"],
    "Agenda": ["66930"],
    "Agra": ["67621"],
    "Albert": ["67511"],
    "Alden": ["67512"],
    "Alexander": ["67513"],
    "Allen": ["66833"],
    "Alma": ["66401"],
    "Almena": ["67622"],
    "Alta Vista": ["66834"],
    "Altamont": ["67330"],
    "Alton": ["67623"],
    "Altoona": ["66710"],
    "Americus": ["66835"],
    "Andale": ["67001"],
    "Andover": ["67002"],
    "Anthony": ["67003"],
    "Arcadia": ["66711"],
    "Argonia": ["67004"],
    "Arkansas City": ["67005"],
    "Arlington": ["67514"],
    "Arma": ["66712"],
    "Arnold": ["67515"],
    "Ashland": ["67831"],
    "Assaria": ["67416"],
    "Atchison": ["66002"],
    "Athol": ["66932"],
    "Atlanta": ["67008"],
    "Attica": ["67009"],
    "Atwood": ["67730"],
    "Auburn": ["66402"],
    "Augusta": ["67010"],
    "Aurora": ["67417"],
    "Axtell": ["66403"],
    "Baileyville": ["66404"],
    "Baldwin City": ["66006"],
    "Barnard": ["67418"],
    "Barnes": ["66933"],
    "Bartlett": ["67332"],
    "Basehor": ["66007"],
    "Baxter Springs": ["66713"],
    "Bazine": ["67516"],
    "Beattie": ["66406"],
    "Beaumont": ["67012"],
    "Beeler": ["67518"],
    "Belle Plaine": ["67013"],
    "Belleville": ["66935"],
    "Beloit": ["67420"],
    "Belpre": ["67519"],
    "Belvue": ["66407"],
    "Bendena": ["66008"],
    "Benedict": ["66714"],
    "Bennington": ["67422"],
    "Bentley": ["67016"],
    "Benton": ["67017"],
    "Bern": ["66408"],
    "Berryton": ["66409"],
    "Beverly": ["67423"],
    "Bird City": ["67731"],
    "Bison": ["67520"],
    "Blue Mound": ["66010"],
    "Blue Rapids": ["66411"],
    "Bluff City": ["67018"],
    "Bogue": ["67625"],
    "Bonner Springs": ["66012"],
    "Bremen": ["66412"],
    "Brewster": ["67732"],
    "Bronson": ["66716"],
    "Brookville": ["67425"],
    "Brownell": ["67521"],
    "Bucklin": ["67834"],
    "Bucyrus": ["66013"],
    "Buffalo": ["66717"],
    "Buhler": ["67522"],
    "Bunker Hill": ["67626"],
    "Burden": ["67019"],
    "Burdett": ["67523"],
    "Burdick": ["66838"],
    "Burlingame": ["66413"],
    "Burlington": ["66839"],
    "Burns": ["66840"],
    "Burr Oak": ["66936"],
    "Burrton": ["67020"],
    "Bushton": ["67427"],
    "Byers": ["67021"],
    "Caldwell": ["67022"],
    "Cambridge": ["67023"],
    "Caney": ["67333"],
    "Canton": ["67428"],
    "Carbondale": ["66414"],
    "Cassoday": ["66842"],
    "Catharine": ["67627"],
    "Cawker City": ["67430"],
    "Cedar": ["67628"],
    "Cedar Point": ["66843"],
    "Cedar Vale": ["67024"],
    "Centerville": ["66014"],
    "Centralia": ["66415"],
    "Chanute": ["66720"],
    "Chapman": ["67431"],
    "Chase": ["67524"],
    "Chautauqua": ["67334"],
    "Cheney": ["67025"],
    "Cherokee": ["66724"],
    "Cherryvale": ["67335"],
    "Chetopa": ["67336"],
    "Cimarron": ["67835"],
    "Circleville": ["66416"],
    "Claflin": ["67525"],
    "Clay Center": ["67432"],
    "Clayton": ["67629"],
    "Clearview City": ["66019"],
    "Clearwater": ["67026"],
    "Clifton": ["66937"],
    "Clyde": ["66938"],
    "Coats": ["67028"],
    "Coffeyville": ["67337"],
    "Colby": ["67701"],
    "Coldwater": ["67029"],
    "Collyer": ["67631"],
    "Colony": ["66015"],
    "Columbus": ["66725"],
    "Colwich": ["67030"],
    "Concordia": ["66901"],
    "Conway Springs": ["67031"],
    "Coolidge": ["67836"],
    "Copeland": ["67837"],
    "Corning": ["66417"],
    "Cottonwood Falls": ["66845"],
    "Council Grove": ["66846"],
    "Courtland": ["66939"],
    "Crestline": ["66728"],
    "Cuba": ["66940"],
    "Cummings": ["66016"],
    "Cunningham": ["67035"],
    "Damar": ["67632"],
    "Danville": ["67036"],
    "De Soto": ["66018"],
    "Dearing": ["67340"],
    "Deerfield": ["67838"],
    "Delia": ["66418"],
    "Delphos": ["67436"],
    "Denison": ["66419"],
    "Dennis": ["67341"],
    "Denton": ["66017"],
    "Derby": ["67037"],
    "Dexter": ["67038"],
    "Dighton": ["67839"],
    "Dodge City": ["67801"],
    "Dorrance": ["67634"],
    "Douglass": ["67039"],
    "Dover": ["66420"],
    "Downs": ["67437"],
    "Dresden": ["67635"],
    "Durham": ["67438"],
    "Dwight": ["66849"],
    "Easton": ["66020"],
    "Edgerton": ["66021"],
    "Edna": ["67342"],
    "Edson": ["67733"],
    "Edwardsville": ["66113"],
    "Effingham": ["66023"],
    "El Dorado": ["67042"],
    "Elbing": ["67041"],
    "Elk City": ["67344"],
    "Elk Falls": ["67345"],
    "Elkhart": ["67950"],
    "Ellinwood": ["67526"],
    "Ellis": ["67637"],
    "Ellsworth": ["67439"],
    "Elmdale": ["66850"],
    "Elsmore": ["66732"],
    "Elwood": ["66024"],
    "Emmett": ["66422"],
    "Emporia": ["66801"],
    "Englewood": ["67840"],
    "Ensign": ["67841"],
    "Enterprise": ["67441"],
    "Erie": ["66733"],
    "Esbon": ["66941"],
    "Eskridge": ["66423"],
    "Eudora": ["66025"],
    "Eureka": ["67045"],
    "Everest": ["66424"],
    "Fairview": ["66425"],
    "Fall River": ["67047"],
    "Falun": ["67442"],
    "Farlington": ["66734"],
    "Florence": ["66851"],
    "Fontana": ["66026"],
    "Ford": ["67842"],
    "Formoso": ["66942"],
    "Fort Dodge": ["67843"],
    "Fort Leavenworth": ["66027"],
    "Fort Riley": ["66442"],
    "Fort Scott": ["66701"],
    "Fostoria": ["66426"],
    "Fowler": ["67844"],
    "Frankfort": ["66427"],
    "Franklin": ["66735"],
    "Fredonia": ["66736"],
    "Freeport": ["67049"],
    "Frontenac": ["66763"],
    "Fulton": ["66738"],
    "Galena": ["66739"],
    "Galesburg": ["66740"],
    "Galva": ["67443"],
    "Garden City": ["67846"],
    "Garden Plain": ["67050"],
    "Gardner": ["66030"],
    "Garfield": ["67529"],
    "Garland": ["66741"],
    "Garnett": ["66032"],
    "Gas": ["66742"],
    "Gaylord": ["67638"],
    "Gem": ["67734"],
    "Geneseo": ["67444"],
    "Geuda Springs": ["67051"],
    "Girard": ["66743"],
    "Glade": ["67639"],
    "Glasco": ["67445"],
    "Glen Elder": ["67446"],
    "Goddard": ["67052"],
    "Goessel": ["67053"],
    "Goff": ["66428"],
    "Goodland": ["67735"],
    "Gorham": ["67640"],
    "Gove": ["67736"],
    "Grainfield": ["67737"],
    "Grantville": ["66429"],
    "Great Bend": ["67530"],
    "Greeley": ["66033"],
    "Green": ["67447"],
    "Greenleaf": ["66943"],
    "Greensburg": ["67054"],
    "Greenwich": ["67055"],
    "Grenola": ["67346"],
    "Gridley": ["66852"],
    "Grinnell": ["67738"],
    "Gypsum": ["67448"],
    "Haddam": ["66944"],
    "Halstead": ["67056"],
    "Hamilton": ["66853"],
    "Hanover": ["66945"],
    "Hanston": ["67849"],
    "Hardtner": ["67057"],
    "Harper": ["67058"],
    "Hartford": ["66854"],
    "Harveyville": ["66431"],
    "Havana": ["67347"],
    "Haven": ["67543"],
    "Havensville": ["66432"],
    "Haviland": ["67059"],
    "Hays": ["67601"],
    "Haysville": ["67060"],
    "Hazelton": ["67061"],
    "Healy": ["67850"],
    "Hepler": ["66746"],
    "Herington": ["67449"],
    "Herndon": ["67739"],
    "Hesston": ["67062"],
    "Hiawatha": ["66434"],
    "Highland": ["66035"],
    "Hill City": ["67642"],
    "Hillsboro": ["67063"],
    "Hillsdale": ["66036"],
    "Hoisington": ["67544"],
    "Holcomb": ["67851"],
    "Hollenberg": ["66946"],
    "Holton": ["66436"],
    "Holyrood": ["67450"],
    "Home": ["66438"],
    "Hope": ["67451"],
    "Horton": ["66439"],
    "Howard": ["67349"],
    "Hoxie": ["67740"],
    "Hoyt": ["66440"],
    "Hudson": ["67545"],
    "Hugoton": ["67951"],
    "Humboldt": ["66748"],
    "Hunter": ["67452"],
    "Hutchinson": ["67501", "67502", "67504"],
    "Independence": ["67301"],
    "Ingalls": ["67853"],
    "Inman": ["67546"],
    "Iola": ["66749"],
    "Isabel": ["67065"],
    "Iuka": ["67066"],
    "Jamestown": ["66948"],
    "Jennings": ["67643"],
    "Jetmore": ["67854"],
    "Jewell": ["66949"],
    "Johnson": ["67855"],
    "Junction City": ["66441"],
    "Kanopolis": ["67454"],
    "Kanorado": ["67741"],
    "Kansas City": ["66101", "66102", "66103", "66104", "66105", "66106", "66109", "66110", "66111", "66112", "66115", "66117", "66118", "66119", "66160"],
    "Kechi": ["67067"],
    "Kendall": ["67857"],
    "Kensington": ["66951"],
    "Kincaid": ["66039"],
    "Kingman": ["67068"],
    "Kinsley": ["67547"],
    "Kiowa": ["67070"],
    "Kirwin": ["67644"],
    "Kismet": ["67859"],
    "La Crosse": ["67548"],
    "La Cygne": ["66040"],
    "La Harpe": ["66751"],
    "Lake City": ["67071"],
    "Lakin": ["67860"],
    "Lamont": ["66855"],
    "Lancaster": ["66041"],
    "Lane": ["66042"],
    "Lansing": ["66043"],
    "Larned": ["67550"],
    "Latham": ["67072"],
    "Lawrence": ["66044", "66045", "66046", "66047", "66049"],
    "Le Roy": ["66857"],
    "Leavenworth": ["66048"],
    "Leawood": ["66206", "66209", "66211"],
    "Lebanon": ["66952"],
    "Lebo": ["66856"],
    "Lecompton": ["66050"],
    "Lehigh": ["67073"],
    "Lenexa": ["66215", "66219", "66220", "66227", "66250", "66276", "66285"],
    "Lenora": ["67645"],
    "Leon": ["67074"],
    "Leonardville": ["66449"],
    "Leoti": ["67861"],
    "Levant": ["67743"],
    "Lewis": ["67552"],
    "Liberal": ["67901", "67905"],
    "Liberty": ["67351"],
    "Liebenthal": ["67553"],
    "Lincoln": ["67455"],
    "Lincolnville": ["66858"],
    "Lindsborg": ["67456"],
    "Linn": ["66953"],
    "Linwood": ["66052"],
    "Little River": ["67457"],
    "Logan": ["67646"],
    "Long Island": ["67647"],
    "Longford": ["67458"],
    "Longton": ["67352"],
    "Lorraine": ["67459"],
    "Lost Springs": ["66859"],
    "Louisburg": ["66053"],
    "Lucas": ["67648"],
    "Ludell": ["67744"],
    "Luray": ["67649"],
    "Lyndon": ["66451"],
    "Lyons": ["67554"],
    "Macksville": ["67557"],
    "Madison": ["66860"],
    "Mahaska": ["66955"],
    "Maize": ["67101"],
    "Manhattan": ["66502", "66503", "66505", "66506"],
    "Mankato": ["66956"],
    "Manter": ["67862"],
    "Maple City": ["67102"],
    "Maple Hill": ["66507"],
    "Mapleton": ["66754"],
    "Marienthal": ["67863"],
    "Marion": ["66861"],
    "Marquette": ["67464"],
    "Marysville": ["66508"],
    "Matfield Green": ["66862"],
    "Mayetta": ["66509"],
    "Mayfield": ["67103"],
    "Mc Cracken": ["67556"],
    "Mc Cune": ["66753"],
    "Mc Donald": ["67745"],
    "Mc Farland": ["66501"],
    "Mc Louth": ["66054"],
    "Mcconnell AFB": ["67221"],
    "Mcpherson": ["67460"],
    "Meade": ["67864"],
    "Medicine Lodge": ["67104"],
    "Melvern": ["66510"],
    "Meriden": ["66512"],
    "Milan": ["67105"],
    "Milford": ["66514"],
    "Milton": ["67106"],
    "Miltonvale": ["67466"],
    "Minneapolis": ["67467"],
    "Minneola": ["67865"],
    "Mission": ["66201", "66202", "66205", "66222"],
    "Moline": ["67353"],
    "Montezuma": ["67867"],
    "Monument": ["67747"],
    "Moran": ["66755"],
    "Morganville": ["67468"],
    "Morland": ["67650"],
    "Morrill": ["66515"],
    "Morrowville": ["66958"],
    "Moscow": ["67952"],
    "Mound City": ["66056"],
    "Mound Valley": ["67354"],
    "Moundridge": ["67107"],
    "Mount Hope": ["67108"],
    "Mulberry": ["66756"],
    "Mullinville": ["67109"],
    "Mulvane": ["67110"],
    "Munden": ["66959"],
    "Murdock": ["67111"],
    "Muscotah": ["66058"],
    "Narka": ["66960"],
    "Nashville": ["67112"],
    "Natoma": ["67651"],
    "Neal": ["66863"],
    "Nekoma": ["67559"],
    "Neodesha": ["66757"],
    "Neosho Falls": ["66758"],
    "Neosho Rapids": ["66864"],
    "Ness City": ["67560"],
    "Netawaka": ["66516"],
    "New Albany": ["66759"],
    "New Cambria": ["67470"],
    "New Century": ["66031"],
    "Newton": ["67114"],
    "Nickerson": ["67561"],
    "Niotaze": ["67355"],
    "Norcatur": ["67653"],
    "North Newton": ["67117"],
    "Norton": ["67654"],
    "Nortonville": ["66060"],
    "Norway": ["66961"],
    "Norwich": ["67118"],
    "Oakley": ["67748"],
    "Oberlin": ["67749"],
    "Offerle": ["67563"],
    "Ogallah": ["67656"],
    "Ogden": ["66517"],
    "Oketo": ["66518"],
    "Olathe": ["66051", "66061", "66062", "66063"],
    "Olmitz": ["67564"],
    "Olpe": ["66865"],
    "Olsburg": ["66520"],
    "Onaga": ["66521"],
    "Oneida": ["66522"],
    "Opolis": ["66760"],
    "Osage City": ["66523"],
    "Osawatomie": ["66064"],
    "Osborne": ["67473"],
    "Oskaloosa": ["66066"],
    "Oswego": ["67356"],
    "Otis": ["67565"],
    "Ottawa": ["66067"],
    "Overbrook": ["66524"],
    "Overland Park": ["66204", "66207", "66210", "66212", "66213", "66214", "66221", "66223", "66224", "66225", "66251", "66282", "66283"],
    "Oxford": ["67119"],
    "Ozawkie": ["66070"],
    "Palco": ["67657"],
    "Palmer": ["66962"],
    "Paola": ["66071"],
    "Paradise": ["67658"],
    "Park": ["67751"],
    "Parker": ["66072"],
    "Parsons": ["67357"],
    "Partridge": ["67566"],
    "Pawnee Rock": ["67567"],
    "Paxico": ["66526"],
    "Peabody": ["66866"],
    "Peck": ["67120"],
    "Penokee": ["67659"],
    "Perry": ["66073"],
    "Peru": ["67360"],
    "Pfeifer": ["67660"],
    "Phillipsburg": ["67661"],
    "Piedmont": ["67122"],
    "Pierceville": ["67868"],
    "Piqua": ["66761"],
    "Pittsburg": ["66762"],
    "Plains": ["67869"],
    "Plainville": ["67663"],
    "Pleasanton": ["66075"],
    "Plevna": ["67568"],
    "Pomona": ["66076"],
    "Portis": ["67474"],
    "Potter": ["66077"],
    "Potwin": ["67123"],
    "Powhattan": ["66527"],
    "Prairie View": ["67664"],
    "Prairie Village": ["66208"],
    "Pratt": ["67124"],
    "Prescott": ["66767"],
    "Pretty Prairie": ["67570"],
    "Princeton": ["66078"],
    "Protection": ["67127"],
    "Quenemo": ["66528"],
    "Quinter": ["67752"],
    "Ramona": ["67475"],
    "Randall": ["66963"],
    "Randolph": ["66554"],
    "Ransom": ["67572"],
    "Rantoul": ["66079"],
    "Raymond": ["67573"],
    "Reading": ["66868"],
    "Redfield": ["66769"],
    "Republic": ["66964"],
    "Rexford": ["67753"],
    "Richfield": ["67953"],
    "Richmond": ["66080"],
    "Riley": ["66531"],
    "Riverton": ["66770"],
    "Robinson": ["66532"],
    "Rock": ["67131"],
    "Rolla": ["67954"],
    "Rosalia": ["67132"],
    "Rose Hill": ["67133"],
    "Rossville": ["66533"],
    "Roxbury": ["67476"],
    "Rozel": ["67574"],
    "Rush Center": ["67575"],
    "Russell": ["67665"],
    "Sabetha": ["66534"],
    "Saint Francis": ["67756"],
    "Saint George": ["66535"],
    "Saint Marys": ["66536"],
    "Saint Paul": ["66771"],
    "Salina": ["67401", "67402"],
    "Satanta": ["67870"],
    "Savonburg": ["66772"],
    "Sawyer": ["67134"],
    "Scammon": ["66773"],
    "Scandia": ["66966"],
    "Schoenchen": ["67667"],
    "Scott City": ["67871"],
    "Scranton": ["66537"],
    "Sedan": ["67361"],
    "Sedgwick": ["67135"],
    "Selden": ["67757"],
    "Seneca": ["66538"],
    "Severy": ["67137"],
    "Sharon": ["67138"],
    "Sharon Springs": ["67758"],
    "Shawnee": ["66203", "66216", "66217", "66218", "66226", "66286"],
    "Shawnee Mission": ["66279"],
    "Silver Lake": ["66539"],
    "Simpson": ["67478"],
    "Smith Center": ["66967"],
    "Soldier": ["66540"],
    "Solomon": ["67480"],
    "South Haven": ["67140"],
    "South Hutchinson": ["67505"],
    "Spearville": ["67876"],
    "Spivey": ["67142"],
    "Spring Hill": ["66083"],
    "St John": ["67576"],
    "Stafford": ["67578"],
    "Stark": ["66775"],
    "Sterling": ["67579"],
    "Stilwell": ["66085"],
    "Stockton": ["67669"],
    "Strong City": ["66869"],
    "Sublette": ["67877"],
    "Summerfield": ["66541"],
    "Sun City": ["67143"],
    "Sycamore": ["67363"],
    "Sylvan Grove": ["67481"],
    "Sylvia": ["67581"],
    "Syracuse": ["67878"],
    "Talmage": ["67482"],
    "Tampa": ["67483"],
    "Tecumseh": ["66542"],
    "Tescott": ["67484"],
    "Thayer": ["66776"],
    "Tipton": ["67485"],
    "Tonganoxie": ["66086"],
    "Topeka": ["66601", "66603", "66604", "66605", "66606", "66607", "66608", "66609", "66610", "66611", "66612", "66614", "66615", "66616", "66617", "66618", "66619", "66620", "66621", "66622", "66624", "66625", "66626", "66628", "66629", "66630", "66636", "66637", "66642", "66647", "66652", "66653", "66667", "66675", "66683", "66692", "66699"],
    "Toronto": ["66777"],
    "Towanda": ["67144"],
    "Treece": ["66778"],
    "Tribune": ["67879"],
    "Troy": ["66087"],
    "Turon": ["67583"],
    "Tyro": ["67364"],
    "Udall": ["67146"],
    "Ulysses": ["67880"],
    "Uniontown": ["66779"],
    "Utica": ["67584"],
    "Valley Center": ["67147"],
    "Valley Falls": ["66088"],
    "Vassar": ["66543"],
    "Vermillion": ["66544"],
    "Victoria": ["67671"],
    "Viola": ["67149"],
    "Virgil": ["66870"],
    "Wakarusa": ["66546"],
    "Wakeeney": ["67672"],
    "Wakefield": ["67487"],
    "Waldo": ["67673"],
    "Waldron": ["67150"],
    "Walker": ["67674"],
    "Wallace": ["67761"],
    "Walnut": ["66780"],
    "Walton": ["67151"],
    "Wamego": ["66547"],
    "Washington": ["66968"],
    "Waterville": ["66548"],
    "Wathena": ["66090"],
    "Waverly": ["66871"],
    "Webber": ["66970"],
    "Weir": ["66781"],
    "Welda": ["66091"],
    "Wellington": ["67152"],
    "Wellsville": ["66092"],
    "Weskan": ["67762"],
    "West Mineral": ["66782"],
    "Westmoreland": ["66549"],
    "Westphalia": ["66093"],
    "Wetmore": ["66550"],
    "White City": ["66872"],
    "White Cloud": ["66094"],
    "Whitewater": ["67154"],
    "Whiting": ["66552"],
    "Wichita": ["67201", "67202", "67203", "67204", "67205", "67206", "67207", "67208", "67209", "67210", "67211", "67212", "67213", "67214", "67215", "67216", "67217", "67218", "67219", "67220", "67223", "67226", "67227", "67228", "67230", "67232", "67235", "67260", "67275", "67276", "67277", "67278"],
    "Williamsburg": ["66095"],
    "Wilmore": ["67155"],
    "Wilsey": ["66873"],
    "Wilson": ["67490"],
    "Winchester": ["66097"],
    "Windom": ["67491"],
    "Winfield": ["67156"],
    "Winona": ["67764"],
    "Woodbine": ["67492"],
    "Woodston": ["67675"],
    "Wright": ["67882"],
    "Yates Center": ["66783"],
    "Yoder": ["67585"],
    "Zenda": ["67159"]
  },
  "KY": {
    "Aberdeen": ["42201"],
    "Adairville": ["42202"],
    "Adams": ["41201"],
    "Adolphus": ["42120"],
    "Ages Brookside": ["40801"],
    "Albany": ["42602"],
    "Alexandria": ["41001"],
    "Allen": ["41601"],
    "Allensville": ["42204"],
    "Almo": ["42020"],
    "Alpha": ["42603"],
    "Alvaton": ["42122"],
    "Annville": ["40402"],
    "Argillite": ["41121"],
    "Arjay": ["40902"],
    "Arlington": ["42021"],
    "Artemus": ["40903"],
    "Ary": ["41712"],
    "Ashcamp": ["41512"],
    "Asher": ["40803"],
    "Ashland": ["41101", "41102", "41105", "41114"],
    "Athol": ["41307"],
    "Auburn": ["42206"],
    "Augusta": ["41002"],
    "Austin": ["42123"],
    "Auxier": ["41602"],
    "Avawam": ["41713"],
    "Bagdad": ["40003"],
    "Bandana": ["42022"],
    "Banner": ["41603"],
    "Barbourville": ["40906"],
    "Bardstown": ["40004"],
    "Bardwell": ["42023"],
    "Barlow": ["42024"],
    "Baskett": ["42402"],
    "Battletown": ["40104"],
    "Baxter": ["40806"],
    "Bays": ["41310"],
    "Bear Branch": ["41714"],
    "Beattyville": ["41311"],
    "Beaumont": ["42124"],
    "Beauty": ["41203"],
    "Beaver": ["41604"],
    "Beaver Dam": ["42320"],
    "Bedford": ["40006"],
    "Bee Spring": ["42207"],
    "Beech Creek": ["42321"],
    "Beech Grove": ["42322"],
    "Beechmont": ["42323"],
    "Belcher": ["41513"],
    "Belfry": ["41514"],
    "Bellevue": ["41073"],
    "Belton": ["42324"],
    "Benham": ["40807"],
    "Benton": ["42025"],
    "Berea": ["40403", "40404"],
    "Berry": ["41003"],
    "Bethany": ["41313"],
    "Bethelridge": ["42516"],
    "Bethlehem": ["40007"],
    "Betsy Layne": ["41605"],
    "Beverly": ["40913"],
    "Bevinsville": ["41606"],
    "Big Clifty": ["42712"],
    "Big Creek": ["40914"],
    "Big Laurel": ["40808"],
    "Bighill": ["40405"],
    "Bimble": ["40915"],
    "Blackey": ["41804"],
    "Blackford": ["42403"],
    "Blaine": ["41124"],
    "Bledsoe": ["40810"],
    "Bloomfield": ["40008"],
    "Blue River": ["41607"],
    "Boaz": ["42027"],
    "Bonnieville": ["42713"],
    "Bonnyman": ["41719"],
    "Booneville": ["41314"],
    "Boons Camp": ["41204"],
    "Boston": ["40107"],
    "Bowling Green": ["42101", "42102", "42103", "42104", "42128"],
    "Bradfordsville": ["40009"],
    "Brandenburg": ["40108"],
    "Breeding": ["42715"],
    "Bremen": ["42325"],
    "Brodhead": ["40409"],
    "Bronston": ["42518"],
    "Brooks": ["40109"],
    "Brooksville": ["41004"],
    "Browder": ["42326"],
    "Brownsville": ["42210"],
    "Bryants Store": ["40921"],
    "Bryantsville": ["40410"],
    "Buckhorn": ["41721"],
    "Buckner": ["40010"],
    "Buffalo": ["42716"],
    "Bulan": ["41722"],
    "Burdine": ["41517"],
    "Burgin": ["40310"],
    "Burkesville": ["42717"],
    "Burlington": ["41005"],
    "Burna": ["42028"],
    "Burnside": ["42519"],
    "Bush": ["40724"],
    "Busy": ["41723"],
    "Butler": ["41006"],
    "Bypro": ["41612"],
    "Cadiz": ["42211"],
    "Calhoun": ["42327"],
    "California": ["41007"],
    "Calvert City": ["42029"],
    "Calvin": ["40813"],
    "Campbellsburg": ["40011"],
    "Campbellsville": ["42718", "42719"],
    "Campton": ["41301"],
    "Canada": ["41519"],
    "Cane Valley": ["42720"],
    "Caneyville": ["42721"],
    "Canmer": ["42722"],
    "Cannel City": ["41408"],
    "Cannon": ["40923"],
    "Carlisle": ["40311"],
    "Carrie": ["41725"],
    "Carrollton": ["41008"],
    "Carter": ["41128"],
    "Catlettsburg": ["41129"],
    "Cave City": ["42127"],
    "Cawood": ["40815"],
    "Cecilia": ["42724"],
    "Center": ["42214"],
    "Centertown": ["42328"],
    "Central City": ["42330"],
    "Cerulean": ["42215"],
    "Chaplin": ["40012"],
    "Chappell": ["40816"],
    "Chavies": ["41727"],
    "Clarkson": ["42726"],
    "Clay": ["42404"],
    "Clay City": ["40312"],
    "Clayhole": ["41317"],
    "Clearfield": ["40313"],
    "Cleaton": ["42332"],
    "Clermont": ["40110"],
    "Clifty": ["42216"],
    "Clinton": ["42031"],
    "Closplint": ["40927"],
    "Cloverport": ["40111"],
    "Coalgood": ["40818"],
    "Coldiron": ["40819"],
    "Columbia": ["42728"],
    "Columbus": ["42032"],
    "Combs": ["41729"],
    "Corbin": ["40701", "40702"],
    "Corinth": ["41010"],
    "Cornettsville": ["41731"],
    "Corydon": ["42406"],
    "Covington": ["41011", "41012", "41014", "41016", "41019"],
    "Coxs Creek": ["40013"],
    "Crab Orchard": ["40419"],
    "Cranks": ["40820"],
    "Crayne": ["42033"],
    "Crestwood": ["40014"],
    "Crittenden": ["41030"],
    "Crockett": ["41413"],
    "Crofton": ["42217"],
    "Cromona": ["41810"],
    "Cromwell": ["42333"],
    "Cub Run": ["42729"],
    "Cumberland": ["40823"],
    "Cunningham": ["42035"],
    "Curdsville": ["42334"],
    "Custer": ["40115"],
    "Cynthiana": ["41031"],
    "Dana": ["41615"],
    "Danville": ["40422", "40423"],
    "David": ["41616"],
    "Dawson Springs": ["42408"],
    "Dayhoit": ["40824"],
    "Dayton": ["41074"],
    "De Mossville": ["41033"],
    "Deane": ["41812"],
    "Debord": ["41214"],
    "Delphia": ["41735"],
    "Dema": ["41859"],
    "Denniston": ["40316"],
    "Denton": ["41132"],
    "Dewitt": ["40930"],
    "Dexter": ["42036"],
    "Dice": ["41736"],
    "Dixon": ["42409"],
    "Dorton": ["41520"],
    "Dover": ["41034"],
    "Drakesboro": ["42337"],
    "Drift": ["41619"],
    "Dry Ridge": ["41035"],
    "Dubre": ["42731"],
    "Dunbar": ["42219"],
    "Dundee": ["42338"],
    "Dunmor": ["42339"],
    "Dunnville": ["42528"],
    "Dwale": ["41621"],
    "Dwarf": ["41739"],
    "Dycusburg": ["42037"],
    "Earlington": ["42410"],
    "East Bernstadt": ["40729"],
    "East Point": ["41216"],
    "Eastern": ["41622"],
    "Eastview": ["42732"],
    "Eastwood": ["40018"],
    "Eddyville": ["42038"],
    "Edmonton": ["42129"],
    "Eighty Eight": ["42130"],
    "Ekron": ["40117"],
    "Elizabethtown": ["42701", "42702"],
    "Elizaville": ["41037"],
    "Elk Horn": ["42733"],
    "Elkfork": ["41421"],
    "Elkhorn City": ["41522"],
    "Elkton": ["42220"],
    "Elliottville": ["40317"],
    "Emerson": ["41135"],
    "Eminence": ["40019"],
    "Emlyn": ["40730"],
    "Emmalena": ["41740"],
    "Eolia": ["40826"],
    "Eriline": ["40931"],
    "Erlanger": ["41018", "41025"],
    "Ermine": ["41815"],
    "Essie": ["40827"],
    "Etoile": ["42131"],
    "Eubank": ["42567"],
    "Evarts": ["40828"],
    "Ewing": ["41039"],
    "Ezel": ["41425"],
    "Fairdale": ["40118"],
    "Fairfield": ["40020"],
    "Fairview": ["42221"],
    "Falcon": ["41426"],
    "Fall Rock": ["40932"],
    "Falls Of Rough": ["40119"],
    "Falmouth": ["41040"],
    "Fancy Farm": ["42039"],
    "Farmers": ["40319"],
    "Farmington": ["42040"],
    "Fedscreek": ["41524"],
    "Ferguson": ["42533"],
    "Finchville": ["40022"],
    "Fisherville": ["40023"],
    "Fisty": ["41743"],
    "Flat Lick": ["40935"],
    "Flatgap": ["41219"],
    "Flatwoods": ["41139"],
    "Flemingsburg": ["41041"],
    "Florence": ["41022", "41042"],
    "Fords Branch": ["41526"],
    "Fordsville": ["42343"],
    "Forest Hills": ["41527"],
    "Fort Campbell": ["42223"],
    "Fort Knox": ["40121", "40122"],
    "Fort Thomas": ["41075"],
    "Foster": ["41043"],
    "Fountain Run": ["42133"],
    "Fourmile": ["40939"],
    "Frakes": ["40940"],
    "Frankfort": ["40601", "40602", "40603", "40604", "40618", "40619", "40620", "40621", "40622"],
    "Franklin": ["42134", "42135"],
    "Fredonia": ["42411"],
    "Freeburn": ["41528"],
    "Frenchburg": ["40322"],
    "Ft Mitchell": ["41017"],
    "Fulton": ["42041"],
    "Gamaliel": ["42140"],
    "Gapville": ["41433"],
    "Garfield": ["40140"],
    "Garner": ["41817"],
    "Garrard": ["40941"],
    "Garrett": ["41630"],
    "Garrison": ["41141"],
    "Gays Creek": ["41745"],
    "Georgetown": ["40324"],
    "Germantown": ["41044"],
    "Ghent": ["41045"],
    "Gilbertsville": ["42044"],
    "Girdler": ["40943"],
    "Glasgow": ["42141", "42142"],
    "Glencoe": ["41046"],
    "Glendale": ["42740"],
    "Glens Fork": ["42741"],
    "Glenview": ["40025"],
    "Goose Rock": ["40944"],
    "Gordon": ["41819"],
    "Goshen": ["40026"],
    "Gracey": ["42232"],
    "Gradyville": ["42742"],
    "Graham": ["42344"],
    "Grahn": ["41142"],
    "Grand Rivers": ["42045"],
    "Gravel Switch": ["40328"],
    "Gray": ["40734"],
    "Gray Hawk": ["40434"],
    "Grays Knob": ["40829"],
    "Grayson": ["41143"],
    "Green Road": ["40946"],
    "Greensburg": ["42743"],
    "Greenup": ["41144"],
    "Greenville": ["42345"],
    "Grethel": ["41631"],
    "Gulston": ["40830"],
    "Gunlock": ["41632"],
    "Guston": ["40142"],
    "Guthrie": ["42234"],
    "Hagerhill": ["41222"],
    "Hallie": ["41821"],
    "Hampton": ["42047"],
    "Hanson": ["42413"],
    "Happy": ["41746"],
    "Hardburly": ["41747"],
    "Hardin": ["42048"],
    "Hardinsburg": ["40143"],
    "Hardy": ["41531"],
    "Hardyville": ["42746"],
    "Harlan": ["40831"],
    "Harned": ["40144"],
    "Harold": ["41635"],
    "Harrods Creek": ["40027"],
    "Harrodsburg": ["40330"],
    "Hartford": ["42347"],
    "Hawesville": ["42348", "42364"],
    "Hazard": ["41701", "41702"],
    "Hazel": ["42049"],
    "Hazel Green": ["41332"],
    "Hebron": ["41021", "41048"],
    "Heidelberg": ["41333"],
    "Heidrick": ["40949"],
    "Hellier": ["41534"],
    "Helton": ["40840"],
    "Henderson": ["42419", "42420"],
    "Herndon": ["42236"],
    "Hestand": ["42151"],
    "Hi Hat": ["41636"],
    "Hickman": ["42050"],
    "Hickory": ["42051"],
    "Hillsboro": ["41049"],
    "Hillview": ["40129"],
    "Hima": ["40951"],
    "Hindman": ["41822"],
    "Hinkle": ["40953"],
    "Hiseville": ["42152"],
    "Hitchins": ["41146"],
    "Hodgenville": ["42748"],
    "Holland": ["42153"],
    "Holmes Mill": ["40843"],
    "Hope": ["40334"],
    "Hopkinsville": ["42240", "42241"],
    "Horse Branch": ["42349"],
    "Horse Cave": ["42749"],
    "Hoskinston": ["40844"],
    "Huddy": ["41535"],
    "Hudson": ["40145"],
    "Hueysville": ["41640"],
    "Hulen": ["40845"],
    "Hustonville": ["40437"],
    "Hyden": ["41749"],
    "Independence": ["41051"],
    "Inez": ["41224"],
    "Ingram": ["40955"],
    "Irvine": ["40336"],
    "Irvington": ["40146"],
    "Island": ["42350"],
    "Island City": ["41338"],
    "Isom": ["41824"],
    "Isonville": ["41149"],
    "Ivel": ["41642"],
    "Jackhorn": ["41825"],
    "Jackson": ["41339"],
    "Jamestown": ["42629"],
    "Jeff": ["41751"],
    "Jeffersonville": ["40337"],
    "Jenkins": ["41537"],
    "Jeremiah": ["41826"],
    "Jetson": ["42252"],
    "Jonancy": ["41538"],
    "Jonesville": ["41052"],
    "Junction City": ["40440"],
    "Keaton": ["41226"],
    "Keavy": ["40737"],
    "Keene": ["40339"],
    "Kenton": ["41053"],
    "Kenvir": ["40847"],
    "Kettle Island": ["40958"],
    "Kevil": ["42053"],
    "Kimper": ["41539"],
    "Kings Mountain": ["40442"],
    "Kirksey": ["42054"],
    "Kite": ["41828"],
    "Knifley": ["42753"],
    "Knob Lick": ["42154"],
    "Krypton": ["41754"],
    "Kuttawa": ["42055"],
    "La Center": ["42056"],
    "La Fayette": ["42254"],
    "La Grange": ["40031", "40032"],
    "Lackey": ["41643"],
    "Lancaster": ["40444", "40446"],
    "Langley": ["41645"],
    "Latonia": ["41015"],
    "Lawrenceburg": ["40342"],
    "Lebanon": ["40033"],
    "Lebanon Junction": ["40150"],
    "Leburn": ["41831"],
    "Ledbetter": ["42058"],
    "Leitchfield": ["42754", "42755"],
    "Lejunior": ["40849"],
    "Letcher": ["41832"],
    "Lewisburg": ["42256"],
    "Lewisport": ["42351"],
    "Lexington": ["40502", "40503", "40504", "40505", "40506", "40507", "40508", "40509", "40510", "40511", "40512", "40513", "40514", "40515", "40516", "40517", "40522", "40523", "40524", "40526", "40533", "40536", "40544", "40546", "40550", "40555", "40574", "40575", "40576", "40577", "40578", "40579", "40580", "40581", "40582", "40583", "40588", "40591", "40598"],
    "Liberty": ["42539"],
    "Lick Creek": ["41540"],
    "Lily": ["40740"],
    "Linefork": ["41833"],
    "Littcarr": ["41834"],
    "Livermore": ["42352"],
    "Livingston": ["40445"],
    "Lockport": ["40036"],
    "London": ["40741", "40742", "40743", "40744", "40745", "40750"],
    "Lone": ["41347"],
    "Lookout": ["41542"],
    "Loretto": ["40037"],
    "Lost Creek": ["41348"],
    "Louisa": ["41230"],
    "Louisville": ["40201", "40202", "40203", "40204", "40205", "40206", "40207", "40208", "40209", "40210", "40211", "40212", "40213", "40214", "40215", "40216", "40217", "40218", "40219", "40220", "40221", "40222", "40223", "40224", "40225", "40228", "40229", "40231", "40232", "40233", "40241", "40242", "40243", "40245", "40250", "40251", "40252", "40253", "40255", "40256", "40257", "40258", "40259", "40261", "40266", "40268", "40269", "40270", "40272", "40280", "40281", "40282", "40283", "40285", "40287", "40289", "40290", "40291", "40292", "40293", "40294", "40295", "40296", "40297", "40298", "40299"],
    "Lovelaceville": ["42060"],
    "Lovely": ["41231"],
    "Lowes": ["42061"],
    "Lowmansville": ["41232"],
    "Loyall": ["40854"],
    "Lucas": ["42156"],
    "Lynch": ["40855"],
    "Lynnville": ["42063"],
    "Maceo": ["42355"],
    "Mackville": ["40040"],
    "Madisonville": ["42431"],
    "Magnolia": ["42757"],
    "Majestic": ["41547"],
    "Mallie": ["41836"],
    "Malone": ["41451"],
    "Mammoth Cave": ["42259"],
    "Manchester": ["40962"],
    "Manitou": ["42436"],
    "Mannsville": ["42758"],
    "Maple Mount": ["42356"],
    "Marion": ["42064"],
    "Marrowbone": ["42759"],
    "Marshes Siding": ["42631"],
    "Martha": ["41159"],
    "Martin": ["41649"],
    "Mary Alice": ["40964"],
    "Mason": ["41054"],
    "Masonic Home": ["40041"],
    "Mayfield": ["42066"],
    "Mayking": ["41837"],
    "Mayslick": ["41055"],
    "Maysville": ["41056"],
    "Mazie": ["41160"],
    "Mc Andrews": ["41543"],
    "Mc Carr": ["41544"],
    "Mc Daniels": ["40152"],
    "Mc Dowell": ["41647"],
    "Mc Henry": ["42354"],
    "Mc Kee": ["40447"],
    "Mc Kinney": ["40448"],
    "Mc Quady": ["40153"],
    "Mc Roberts": ["41835"],
    "Meally": ["41234"],
    "Means": ["40346"],
    "Melber": ["42069"],
    "Melbourne": ["41059"],
    "Melvin": ["41650"],
    "Middleburg": ["42541"],
    "Middlesboro": ["40965"],
    "Midway": ["40347"],
    "Milburn": ["42070"],
    "Milford": ["41061"],
    "Millersburg": ["40348"],
    "Millstone": ["41838"],
    "Millwood": ["42762"],
    "Milton": ["40045"],
    "Minerva": ["41062"],
    "Minnie": ["41651"],
    "Miracle": ["40856"],
    "Mistletoe": ["41351"],
    "Mitchellsburg": ["40452"],
    "Mize": ["41352"],
    "Monticello": ["42633"],
    "Moorefield": ["40350"],
    "Morehead": ["40351"],
    "Morganfield": ["42437"],
    "Morgantown": ["42261"],
    "Morning View": ["41063"],
    "Mortons Gap": ["42440"],
    "Mount Eden": ["40046"],
    "Mount Hermon": ["42157"],
    "Mount Olivet": ["41064"],
    "Mount Sherman": ["42764"],
    "Mount Sterling": ["40353"],
    "Mount Vernon": ["40456"],
    "Mount Washington": ["40047"],
    "Mousie": ["41839"],
    "Mouthcard": ["41548"],
    "Mozelle": ["40858"],
    "Muldraugh": ["40155"],
    "Munfordville": ["42765"],
    "Murray": ["42071"],
    "Muses Mills": ["41065"],
    "Myra": ["41549"],
    "Nancy": ["42544"],
    "Nazareth": ["40048"],
    "Nebo": ["42441"],
    "Neon": ["41840"],
    "Nerinx": ["40049"],
    "Nevisdale": ["40754"],
    "New Castle": ["40050"],
    "New Concord": ["42076"],
    "New Haven": ["40051"],
    "New Hope": ["40052"],
    "New Liberty": ["40355"],
    "Newport": ["41071", "41072", "41076", "41099"],
    "Nicholasville": ["40340", "40356"],
    "North Middletown": ["40357"],
    "Nortonville": ["42442"],
    "Oak Grove": ["42262"],
    "Oakland": ["42159"],
    "Oil Springs": ["41238"],
    "Olaton": ["42361"],
    "Olive Hill": ["41164"],
    "Olmstead": ["42265"],
    "Olympia": ["40358"],
    "Oneida": ["40972"],
    "Ophir": ["41459"],
    "Orlando": ["40460"],
    "Owensboro": ["42301", "42302", "42303", "42304"],
    "Owenton": ["40359"],
    "Owingsville": ["40360"],
    "Paducah": ["42001", "42002", "42003"],
    "Paint Lick": ["40461"],
    "Paintsville": ["41240"],
    "Paris": ["40361", "40362"],
    "Park City": ["42160"],
    "Parkers Lake": ["42634"],
    "Parksville": ["40464"],
    "Partridge": ["40862"],
    "Pathfork": ["40863"],
    "Payneville": ["40157"],
    "Pembroke": ["42266"],
    "Pendleton": ["40055"],
    "Perry Park": ["40363"],
    "Perryville": ["40468"],
    "Petersburg": ["41080"],
    "Pewee Valley": ["40056"],
    "Phelps": ["41553"],
    "Philpot": ["42366"],
    "Phyllis": ["41554"],
    "Pikeville": ["41501", "41502"],
    "Pilgrim": ["41250"],
    "Pine Knot": ["42635"],
    "Pine Ridge": ["41360"],
    "Pine Top": ["41843"],
    "Pineville": ["40977"],
    "Pinsonfork": ["41555"],
    "Pippa Passes": ["41844"],
    "Pittsburg": ["40755"],
    "Pleasureville": ["40057"],
    "Plummers Landing": ["41081"],
    "Poole": ["42444"],
    "Port Royal": ["40058"],
    "Powderly": ["42367"],
    "Premium": ["41845"],
    "Preston": ["40366"],
    "Prestonsburg": ["41653"],
    "Primrose": ["41362"],
    "Princeton": ["42445"],
    "Printer": ["41655"],
    "Prospect": ["40059"],
    "Providence": ["42450"],
    "Putney": ["40865"],
    "Quincy": ["41166"],
    "Raccoon": ["41557"],
    "Radcliff": ["40159", "40160"],
    "Ransom": ["41558"],
    "Raven": ["41861"],
    "Ravenna": ["40472"],
    "Raywick": ["40060"],
    "Redfox": ["41847"],
    "Reed": ["42451"],
    "Regina": ["41559"],
    "Renfro Valley": ["40473"],
    "Revelo": ["42638"],
    "Reynolds Station": ["42368"],
    "Rhodelia": ["40161"],
    "Ricetown": ["41364"],
    "Richmond": ["40475", "40476"],
    "Rineyville": ["40162"],
    "River": ["41254"],
    "Roark": ["40979"],
    "Robards": ["42452"],
    "Robinson Creek": ["41560"],
    "Rochester": ["42273"],
    "Rockfield": ["42274"],
    "Rockholds": ["40759"],
    "Rockhouse": ["41561"],
    "Rockport": ["42369"],
    "Rocky Hill": ["42163"],
    "Rogers": ["41365"],
    "Rosine": ["42370"],
    "Roundhill": ["42275"],
    "Rousseau": ["41366"],
    "Rowdy": ["41367"],
    "Roxana": ["41848"],
    "Royalton": ["41464"],
    "Rumsey": ["42371"],
    "Rush": ["41168"],
    "Russell": ["41169"],
    "Russell Springs": ["42642"],
    "Russellville": ["42276"],
    "Sacramento": ["42372"],
    "Sadieville": ["40370"],
    "Saint Catharine": ["40061"],
    "Saint Charles": ["42453"],
    "Saint Francis": ["40062"],
    "Saint Helens": ["41368"],
    "Saint Mary": ["40063"],
    "Salem": ["42078"],
    "Salt Lick": ["40371"],
    "Salvisa": ["40372"],
    "Salyersville": ["41465"],
    "Sanders": ["41083"],
    "Sandgap": ["40481"],
    "Sandy Hook": ["41171"],
    "Sassafras": ["41759"],
    "Saul": ["40981"],
    "Scalf": ["40982"],
    "Science Hill": ["42553"],
    "Scottsville": ["42164"],
    "Scuddy": ["41760"],
    "Sebree": ["42455"],
    "Seco": ["41849"],
    "Sedalia": ["42079"],
    "Sextons Creek": ["40983"],
    "Sharon Grove": ["42280"],
    "Sharpsburg": ["40374"],
    "Shelbiana": ["41562"],
    "Shelby Gap": ["41563"],
    "Shelbyville": ["40065", "40066"],
    "Shepherdsville": ["40165", "40166"],
    "Sidney": ["41564"],
    "Siler": ["40763"],
    "Silver Grove": ["41085"],
    "Simpsonville": ["40067"],
    "Sitka": ["41255"],
    "Sizerock": ["41762"],
    "Slade": ["40376"],
    "Slaughters": ["42456"],
    "Slemp": ["41763"],
    "Smilax": ["41764"],
    "Smith Mills": ["42457"],
    "Smithfield": ["40068"],
    "Smithland": ["42081"],
    "Smiths Grove": ["42171"],
    "Soldier": ["41173"],
    "Somerset": ["42501", "42502", "42503"],
    "Sonora": ["42776"],
    "South Carrollton": ["42374"],
    "South Portsmouth": ["41174"],
    "South Shore": ["41175"],
    "South Union": ["42283"],
    "South Williamson": ["41503"],
    "Sparta": ["41086"],
    "Spottsville": ["42458"],
    "Springfield": ["40069"],
    "Staffordsville": ["41256"],
    "Stambaugh": ["41257"],
    "Stamping Ground": ["40379"],
    "Stanford": ["40484"],
    "Stanley": ["42375"],
    "Stanton": ["40380"],
    "Stanville": ["41659"],
    "Stearns": ["42647"],
    "Steele": ["41566"],
    "Stephensport": ["40170"],
    "Stinnett": ["40868"],
    "Stone": ["41567"],
    "Stoney Fork": ["40988"],
    "Stopover": ["41568"],
    "Strunk": ["42649"],
    "Sturgis": ["42459"],
    "Sullivan": ["42460"],
    "Sulphur": ["40070"],
    "Summer Shade": ["42166"],
    "Summersville": ["42782"],
    "Sweeden": ["42285"],
    "Symsonia": ["42082"],
    "Tateville": ["42558"],
    "Taylorsville": ["40071"],
    "Teaberry": ["41660"],
    "Thelma": ["41260"],
    "Thornton": ["41855"],
    "Thousandsticks": ["41766"],
    "Tiline": ["42083"],
    "Tollesboro": ["41189"],
    "Tolu": ["42084"],
    "Tomahawk": ["41262"],
    "Tompkinsville": ["42167"],
    "Topmost": ["41862"],
    "Totz": ["40870"],
    "Tram": ["41663"],
    "Trenton": ["42286"],
    "Trosper": ["40995"],
    "Turners Station": ["40075"],
    "Tutor Key": ["41263"],
    "Tyner": ["40486"],
    "Ulysses": ["41264"],
    "Union": ["41091"],
    "Union Star": ["40171"],
    "Uniontown": ["42461"],
    "Upton": ["42784"],
    "Utica": ["42376"],
    "Van Lear": ["41265"],
    "Vanceburg": ["41179"],
    "Vancleve": ["41385"],
    "Varney": ["41571"],
    "Verona": ["41092"],
    "Versailles": ["40383", "40384", "40386"],
    "Vest": ["41772"],
    "Vicco": ["41773"],
    "Vincent": ["41386"],
    "Vine Grove": ["40175"],
    "Viper": ["41774"],
    "Virgie": ["41572"],
    "Waco": ["40385"],
    "Waddy": ["40076"],
    "Walker": ["40997"],
    "Wallingford": ["41093"],
    "Wallins Creek": ["40873"],
    "Walton": ["41094"],
    "Waneta": ["40488"],
    "Warbranch": ["40874"],
    "Warfield": ["41267"],
    "Warsaw": ["41095"],
    "Washington": ["41096"],
    "Water Valley": ["42085"],
    "Waverly": ["42462"],
    "Wayland": ["41666"],
    "Waynesburg": ["40489"],
    "Webbville": ["41180"],
    "Webster": ["40176"],
    "Weeksbury": ["41667"],
    "Welchs Creek": ["42287"],
    "Wellington": ["40387"],
    "Wendover": ["41775"],
    "West Liberty": ["41472"],
    "West Louisville": ["42377"],
    "West Paducah": ["42086"],
    "West Point": ["40177"],
    "West Somerset": ["42564"],
    "West Van Lear": ["41268"],
    "Westport": ["40077"],
    "Westview": ["40178"],
    "Wheatcroft": ["42463"],
    "Wheelwright": ["41669"],
    "Whick": ["41390"],
    "White Mills": ["42788"],
    "White Plains": ["42464"],
    "Whitesburg": ["41858"],
    "Whitesville": ["42378"],
    "Whitley City": ["42653"],
    "Wickliffe": ["42087"],
    "Wildie": ["40492"],
    "Willard": ["41181"],
    "Williamsburg": ["40769"],
    "Williamsport": ["41271"],
    "Williamstown": ["41097"],
    "Willisburg": ["40078"],
    "Wilmore": ["40390"],
    "Winchester": ["40391", "40392"],
    "Windsor": ["42565"],
    "Wingo": ["42088"],
    "Winston": ["40495"],
    "Wittensville": ["41274"],
    "Woodbine": ["40771"],
    "Woodburn": ["42170"],
    "Woodbury": ["42288"],
    "Woollum": ["40999"],
    "Wooton": ["41776"],
    "Worthington": ["41183"],
    "Worthville": ["41098"],
    "Wrigley": ["41477"],
    "Yeaddiss": ["41777"],
    "Yerkes": ["41778"],
    "Yosemite": ["42566"],
    "Zoe": ["41397"]
  },
  "LA": {
    "Abbeville": ["70510", "70511"],
    "Abita Springs": ["70420"],
    "Acme": ["71316"],
    "Addis": ["70710"],
    "Aimwell": ["71401"],
    "Akers": ["70421"],
    "Albany": ["70711"],
    "Alexandria": ["71301", "71302", "71303", "71306", "71307", "71309", "71315"],
    "Ama": ["70031"],
    "Amelia": ["70340"],
    "Amite": ["70422"],
    "Anacoco": ["71403"],
    "Angie": ["70426"],
    "Angola": ["70712"],
    "Arabi": ["70032"],
    "Arcadia": ["71001"],
    "Archibald": ["71218"],
    "Arnaudville": ["70512"],
    "Ashland": ["71002"],
    "Athens": ["71003"],
    "Atlanta": ["71404"],
    "Avery Island": ["70513"],
    "Baker": ["70704", "70714"],
    "Baldwin": ["70514"],
    "Ball": ["71405"],
    "Barataria": ["70036"],
    "Barksdale AFB": ["71110"],
    "Basile": ["70515"],
    "Baskin": ["71219"],
    "Bastrop": ["71220", "71221"],
    "Batchelor": ["70715"],
    "Baton Rouge": ["70801", "70802", "70803", "70804", "70805", "70806", "70807", "70808", "70809", "70810", "70811", "70812", "70813", "70814", "70815", "70816", "70817", "70818", "70819", "70820", "70821", "70822", "70823", "70825", "70826", "70827", "70831", "70833", "70835", "70836", "70837", "70873", "70874", "70879", "70883", "70884", "70891", "70892", "70893", "70894", "70895", "70896", "70898"],
    "Belcher": ["71004"],
    "Bell City": ["70630"],
    "Belle Chasse": ["70037", "70093"],
    "Belle Rose": ["70341"],
    "Belmont": ["71406"],
    "Bentley": ["71407"],
    "Benton": ["71006"],
    "Bernice": ["71222"],
    "Berwick": ["70342"],
    "Bethany": ["71007"],
    "Bienville": ["71008"],
    "Blanchard": ["71009"],
    "Bogalusa": ["70427", "70429"],
    "Bonita": ["71223"],
    "Boothville": ["70038"],
    "Bordelonville": ["71320"],
    "Bossier City": ["71111", "71112", "71113", "71171", "71172"],
    "Bourg": ["70343"],
    "Boutte": ["70039"],
    "Boyce": ["71409"],
    "Braithwaite": ["70040"],
    "Branch": ["70516"],
    "Breaux Bridge": ["70517"],
    "Brittany": ["70718"],
    "Broussard": ["70518"],
    "Brusly": ["70719"],
    "Bunkie": ["71322"],
    "Buras": ["70041"],
    "Burnside": ["70738"],
    "Bush": ["70431"],
    "Cade": ["70519"],
    "Calhoun": ["71225"],
    "Calvin": ["71410"],
    "Cameron": ["70631"],
    "Campti": ["71411"],
    "Carencro": ["70520"],
    "Carville": ["70721"],
    "Castor": ["71016"],
    "Cecilia": ["70521"],
    "Center Point": ["71323"],
    "Centerville": ["70522"],
    "Chalmette": ["70043", "70044"],
    "Charenton": ["70523"],
    "Chase": ["71324"],
    "Chataignier": ["70524"],
    "Chatham": ["71226"],
    "Chauvin": ["70344"],
    "Cheneyville": ["71325"],
    "Choudrant": ["71227"],
    "Church Point": ["70525"],
    "Clarence": ["71414"],
    "Clarks": ["71415"],
    "Clayton": ["71326"],
    "Clinton": ["70722"],
    "Cloutierville": ["71416"],
    "Colfax": ["71417"],
    "Collinston": ["71229"],
    "Columbia": ["71418"],
    "Convent": ["70723"],
    "Converse": ["71419"],
    "Cotton Valley": ["71018"],
    "Cottonport": ["71327"],
    "Coushatta": ["71019"],
    "Covington": ["70433", "70434", "70435"],
    "Creole": ["70632"],
    "Crowley": ["70526", "70527"],
    "Crowville": ["71230"],
    "Cullen": ["71021"],
    "Cut Off": ["70345"],
    "Darrow": ["70725"],
    "Delcambre": ["70528"],
    "Delhi": ["71232"],
    "Delta": ["71233"],
    "Denham Springs": ["70706", "70726", "70727"],
    "Dequincy": ["70633"],
    "Deridder": ["70634"],
    "Des Allemands": ["70030"],
    "Destrehan": ["70047"],
    "Deville": ["71328"],
    "Dodson": ["71422"],
    "Donaldsonville": ["70346"],
    "Donner": ["70352"],
    "Downsville": ["71234"],
    "Doyline": ["71023"],
    "Dry Creek": ["70637"],
    "Dry Prong": ["71423"],
    "Dubach": ["71235"],
    "Dubberly": ["71024"],
    "Dulac": ["70353"],
    "Duplessis": ["70728"],
    "Dupont": ["71329"],
    "Duson": ["70529"],
    "Echo": ["71330"],
    "Edgard": ["70049"],
    "Effie": ["71331"],
    "Egan": ["70531"],
    "Elizabeth": ["70638"],
    "Elm Grove": ["71051"],
    "Elmer": ["71424"],
    "Elton": ["70532"],
    "Empire": ["70050"],
    "Enterprise": ["71425"],
    "Epps": ["71237"],
    "Erath": ["70533"],
    "Eros": ["71238"],
    "Erwinville": ["70729"],
    "Estherwood": ["70534"],
    "Ethel": ["70730"],
    "Eunice": ["70535"],
    "Evangeline": ["70537"],
    "Evans": ["70639"],
    "Evergreen": ["71333"],
    "Fairbanks": ["71240"],
    "Farmerville": ["71241"],
    "Fenton": ["70640"],
    "Ferriday": ["71334"],
    "Fisher": ["71426"],
    "Flatwoods": ["71427"],
    "Flora": ["71428"],
    "Florien": ["71429"],
    "Fluker": ["70436"],
    "Folsom": ["70437"],
    "Fordoche": ["70732"],
    "Forest": ["71242"],
    "Forest Hill": ["71430"],
    "Fort Necessity": ["71243"],
    "Fort Polk": ["71459"],
    "Franklin": ["70538"],
    "Franklinton": ["70438"],
    "French Settlement": ["70733"],
    "Frierson": ["71027"],
    "Galliano": ["70354"],
    "Garden City": ["70540"],
    "Gardner": ["71431"],
    "Garyville": ["70051"],
    "Geismar": ["70734"],
    "Georgetown": ["71432"],
    "Gheens": ["70355"],
    "Gibsland": ["71028"],
    "Gibson": ["70356"],
    "Gilbert": ["71336"],
    "Gilliam": ["71029"],
    "Glenmora": ["71433"],
    "Gloster": ["71030"],
    "Glynn": ["70736"],
    "Golden Meadow": ["70357"],
    "Goldonna": ["71031"],
    "Gonzales": ["70707", "70737"],
    "Gorum": ["71434"],
    "Grambling": ["71245"],
    "Gramercy": ["70052"],
    "Grand Cane": ["71032"],
    "Grand Chenier": ["70643"],
    "Grand Coteau": ["70541"],
    "Grand Isle": ["70358"],
    "Grant": ["70644"],
    "Gray": ["70359"],
    "Grayson": ["71435"],
    "Greensburg": ["70441"],
    "Greenwell Springs": ["70739"],
    "Greenwood": ["71033"],
    "Gretna": ["70053", "70054", "70056"],
    "Grosse Tete": ["70740"],
    "Gueydan": ["70542"],
    "Hackberry": ["70645"],
    "Hahnville": ["70057"],
    "Hall Summit": ["71034"],
    "Hamburg": ["71339"],
    "Hammond": ["70401", "70402", "70403", "70404"],
    "Harrisonburg": ["71340"],
    "Harvey": ["70058", "70059"],
    "Haughton": ["71037"],
    "Hayes": ["70646"],
    "Haynesville": ["71038"],
    "Heflin": ["71039"],
    "Hessmer": ["71341"],
    "Hester": ["70743"],
    "Hineston": ["71438"],
    "Hodge": ["71247"],
    "Holden": ["70744"],
    "Homer": ["71040"],
    "Hornbeck": ["71439"],
    "Hosston": ["71043"],
    "Houma": ["70360", "70361", "70363", "70364"],
    "Husser": ["70442"],
    "Ida": ["71044"],
    "Independence": ["70443"],
    "Innis": ["70747"],
    "Iota": ["70543"],
    "Iowa": ["70647"],
    "Jackson": ["70748"],
    "Jamestown": ["71045"],
    "Jarreau": ["70749"],
    "Jeanerette": ["70544"],
    "Jena": ["71342"],
    "Jennings": ["70546"],
    "Jigger": ["71249"],
    "Jones": ["71250"],
    "Jonesboro": ["71251"],
    "Jonesville": ["71343"],
    "Joyce": ["71440"],
    "Kaplan": ["70548"],
    "Keatchie": ["71046"],
    "Keithville": ["71047"],
    "Kelly": ["71441"],
    "Kenner": ["70062", "70063", "70064", "70065", "70097"],
    "Kentwood": ["70444"],
    "Kilbourne": ["71253"],
    "Kinder": ["70648"],
    "Kraemer": ["70371"],
    "Krotz Springs": ["70750"],
    "Kurthwood": ["71443"],
    "La Place": ["70068", "70069"],
    "Labadieville": ["70372"],
    "Lacassine": ["70650"],
    "Lacombe": ["70445"],
    "Lafayette": ["70500", "70501", "70502", "70503", "70504", "70505", "70506", "70507", "70508", "70509", "70593", "70595", "70596", "70598"],
    "Lafitte": ["70067"],
    "Lake Arthur": ["70549"],
    "Lake Charles": ["70601", "70602", "70605", "70606", "70607", "70609", "70611", "70612", "70615", "70616", "70629"],
    "Lake Providence": ["71254"],
    "Lakeland": ["70752"],
    "Larose": ["70373"],
    "Lawtell": ["70550"],
    "Lebeau": ["71345"],
    "Leblanc": ["70651"],
    "Lecompte": ["71346"],
    "Leesville": ["71446", "71496"],
    "Lena": ["71447"],
    "Leonville": ["70551"],
    "Lettsworth": ["70753"],
    "Libuse": ["71348"],
    "Lillie": ["71256"],
    "Lisbon": ["71048"],
    "Livingston": ["70754"],
    "Livonia": ["70755"],
    "Lockport": ["70374"],
    "Logansport": ["71049"],
    "Longleaf": ["71448"],
    "Longstreet": ["71050"],
    "Longville": ["70652"],
    "Loranger": ["70446"],
    "Loreauville": ["70552"],
    "Lottie": ["70756"],
    "Luling": ["70070"],
    "Lutcher": ["70071"],
    "Lydia": ["70569"],
    "Madisonville": ["70447"],
    "Mamou": ["70554"],
    "Mandeville": ["70448", "70470", "70471"],
    "Mangham": ["71259"],
    "Mansfield": ["71052"],
    "Mansura": ["71350"],
    "Many": ["71449"],
    "Maringouin": ["70757"],
    "Marion": ["71260"],
    "Marksville": ["71351"],
    "Marrero": ["70072", "70073"],
    "Marthaville": ["71450"],
    "Mathews": ["70375"],
    "Maurepas": ["70449"],
    "Maurice": ["70555"],
    "Melrose": ["71452"],
    "Melville": ["71353"],
    "Mer Rouge": ["71261"],
    "Meraux": ["70075"],
    "Mermentau": ["70556"],
    "Merryville": ["70653"],
    "Metairie": ["70001", "70002", "70003", "70004", "70005", "70006", "70009", "70010", "70011", "70033", "70055", "70060"],
    "Milton": ["70558"],
    "Minden": ["71055", "71058"],
    "Mittie": ["70654"],
    "Monroe": ["71201", "71202", "71203", "71207", "71208", "71209", "71210", "71211", "71212", "71213", "71217"],
    "Montegut": ["70377"],
    "Monterey": ["71354"],
    "Montgomery": ["71454"],
    "Mooringsport": ["71060"],
    "Mora": ["71455"],
    "Moreauville": ["71355"],
    "Morgan City": ["70380", "70381"],
    "Morganza": ["70759"],
    "Morrow": ["71356"],
    "Morse": ["70559"],
    "Mount Airy": ["70076"],
    "Mount Hermon": ["70450"],
    "Napoleonville": ["70390"],
    "Natalbany": ["70451"],
    "Natchez": ["71456"],
    "Natchitoches": ["71457", "71458", "71497"],
    "Negreet": ["71460"],
    "New Iberia": ["70560", "70562", "70563"],
    "New Llano": ["71461"],
    "New Orleans": ["70112", "70113", "70114", "70115", "70116", "70117", "70118", "70119", "70121", "70122", "70123", "70124", "70125", "70126", "70127", "70128", "70129", "70130", "70131", "70139", "70140", "70141", "70142", "70143", "70145", "70146", "70148", "70149", "70150", "70151", "70152", "70153", "70154", "70156", "70157", "70158", "70159", "70160", "70161", "70162", "70163", "70164", "70165", "70166", "70167", "70170", "70172", "70174", "70175", "70176", "70177", "70178", "70179", "70181", "70182", "70183", "70184", "70185", "70186", "70187", "70189", "70190", "70195"],
    "New Roads": ["70760"],
    "New Sarpy": ["70078"],
    "Newellton": ["71357"],
    "Noble": ["71462"],
    "Norco": ["70079"],
    "Norwood": ["70761"],
    "Oak Grove": ["71263"],
    "Oak Ridge": ["71264"],
    "Oakdale": ["71463"],
    "Oberlin": ["70655"],
    "Oil City": ["71061"],
    "Olla": ["71465"],
    "Opelousas": ["70570", "70571"],
    "Oscar": ["70762"],
    "Otis": ["71466"],
    "Paincourtville": ["70391"],
    "Palmetto": ["71358"],
    "Paradis": ["70080"],
    "Patterson": ["70392"],
    "Paulina": ["70763"],
    "Pearl River": ["70452"],
    "Pelican": ["71063"],
    "Perry": ["70575"],
    "Pierre Part": ["70339"],
    "Pilottown": ["70081"],
    "Pine Grove": ["70453"],
    "Pine Prairie": ["70576"],
    "Pineville": ["71359", "71360", "71361"],
    "Pioneer": ["71266"],
    "Pitkin": ["70656"],
    "Plain Dealing": ["71064"],
    "Plaquemine": ["70764", "70765"],
    "Plattenville": ["70393"],
    "Plaucheville": ["71362"],
    "Pleasant Hill": ["71065"],
    "Pointe A La Hache": ["70082"],
    "Pollock": ["71467"],
    "Ponchatoula": ["70454"],
    "Port Allen": ["70767"],
    "Port Barre": ["70577"],
    "Port Sulphur": ["70083"],
    "Powhatan": ["71066"],
    "Prairieville": ["70769"],
    "Pride": ["70770"],
    "Princeton": ["71067"],
    "Provencal": ["71468"],
    "Quitman": ["71268"],
    "Raceland": ["70394"],
    "Ragley": ["70657"],
    "Rayne": ["70578"],
    "Rayville": ["71269"],
    "Reddell": ["70580"],
    "Reeves": ["70658"],
    "Reserve": ["70084"],
    "Rhinehart": ["71363"],
    "Ringgold": ["71068"],
    "Roanoke": ["70581"],
    "Robeline": ["71469"],
    "Robert": ["70455"],
    "Rodessa": ["71069"],
    "Rosedale": ["70772"],
    "Roseland": ["70456"],
    "Rosepine": ["70659"],
    "Rougon": ["70773"],
    "Ruby": ["71365"],
    "Ruston": ["71270", "71272", "71273"],
    "Saint Amant": ["70774"],
    "Saint Benedict": ["70457"],
    "Saint Bernard": ["70085"],
    "Saint Francisville": ["70775"],
    "Saint Gabriel": ["70776"],
    "Saint James": ["70086"],
    "Saint Joseph": ["71366"],
    "Saint Landry": ["71367"],
    "Saint Martinville": ["70582"],
    "Saint Maurice": ["71471"],
    "Saint Rose": ["70087"],
    "Saline": ["71070"],
    "Sarepta": ["71071"],
    "Schriever": ["70395"],
    "Scott": ["70583"],
    "Shongaloo": ["71072"],
    "Shreveport": ["71101", "71102", "71103", "71104", "71105", "71106", "71107", "71108", "71109", "71115", "71118", "71119", "71120", "71129", "71130", "71133", "71134", "71135", "71136", "71137", "71138", "71148", "71149", "71150", "71151", "71152", "71153", "71154", "71156", "71161", "71162", "71163", "71164", "71165", "71166"],
    "Sibley": ["71073"],
    "Sicily Island": ["71368"],
    "Sieper": ["71472"],
    "Sikes": ["71473"],
    "Simmesport": ["71369"],
    "Simpson": ["71474"],
    "Simsboro": ["71275"],
    "Singer": ["70660"],
    "Slagle": ["71475"],
    "Slaughter": ["70777"],
    "Slidell": ["70458", "70459", "70460", "70461", "70469"],
    "Sondheimer": ["71276"],
    "Sorrento": ["70778"],
    "Spearsville": ["71277"],
    "Springfield": ["70462"],
    "Springhill": ["71075"],
    "Starks": ["70661"],
    "Start": ["71279"],
    "Sterlington": ["71280"],
    "Stonewall": ["71078"],
    "Sugartown": ["70662"],
    "Sulphur": ["70663", "70664", "70665"],
    "Summerfield": ["71079"],
    "Sun": ["70463"],
    "Sunset": ["70584"],
    "Sunshine": ["70780"],
    "Swartz": ["71281"],
    "Talisheek": ["70464"],
    "Tallulah": ["71282", "71284"],
    "Tangipahoa": ["70465"],
    "Taylor": ["71080"],
    "Theriot": ["70397"],
    "Thibodaux": ["70301", "70302", "70310"],
    "Tickfaw": ["70466"],
    "Tioga": ["71477"],
    "Transylvania": ["71286"],
    "Trout": ["71371"],
    "Tullos": ["71479"],
    "Tunica": ["70782"],
    "Turkey Creek": ["70585"],
    "Uncle Sam": ["70792"],
    "Urania": ["71480"],
    "Vacherie": ["70090"],
    "Varnado": ["70467"],
    "Venice": ["70091"],
    "Ventress": ["70783"],
    "Vidalia": ["71373"],
    "Ville Platte": ["70586"],
    "Vinton": ["70668"],
    "Violet": ["70092"],
    "Vivian": ["71082"],
    "Wakefield": ["70784"],
    "Walker": ["70785"],
    "Washington": ["70589"],
    "Waterproof": ["71375"],
    "Watson": ["70786"],
    "Welsh": ["70591"],
    "West Monroe": ["71291", "71292", "71294"],
    "Westlake": ["70669"],
    "Westwego": ["70094", "70096"],
    "Weyanoke": ["70787"],
    "White Castle": ["70788"],
    "Wildsville": ["71377"],
    "Wilson": ["70789"],
    "Winnfield": ["71483"],
    "Winnsboro": ["71295"],
    "Wisner": ["71378"],
    "Woodworth": ["71485"],
    "Youngsville": ["70592"],
    "Zachary": ["70791"],
    "Zwolle": ["71486"]
  },
  "MA": {
    "Abington": ["02351"],
    "Accord": ["02018"],
    "Acton": ["01718", "01720"],
    "Acushnet": ["02743"],
    "Adams": ["01220"],
    "Agawam": ["01001"],
    "Allston": ["02134"],
    "Amesbury": ["01913"],
    "Amherst": ["01002", "01003", "01004"],
    "Andover": ["01810", "01812", "01899", "05501", "05544"],
    "Arlington": ["02474", "02476"],
    "Arlington Heights": ["02475"],
    "Ashburnham": ["01430"],
    "Ashby": ["01431"],
    "Ashfield": ["01330"],
    "Ashland": ["01721"],
    "Ashley Falls": ["01222"],
    "Assonet": ["02702"],
    "Athol": ["01331"],
    "Attleboro": ["02703"],
    "Attleboro Falls": ["02763"],
    "Auburn": ["01501"],
    "Auburndale": ["02466"],
    "Avon": ["02322"],
    "Ayer": ["01432"],
    "Babson Park": ["02457"],
    "Baldwinville": ["01436"],
    "Barnstable": ["02630"],
    "Barre": ["01005"],
    "Becket": ["01223"],
    "Bedford": ["01730"],
    "Belchertown": ["01007"],
    "Bellingham": ["02019"],
    "Belmont": ["02478"],
    "Berkley": ["02779"],
    "Berkshire": ["01224"],
    "Berlin": ["01503"],
    "Bernardston": ["01337"],
    "Beverly": ["01915"],
    "Billerica": ["01821", "01822"],
    "Blackstone": ["01504"],
    "Blandford": ["01008"],
    "Bolton": ["01740"],
    "Bondsville": ["01009"],
    "Boston": ["02108", "02109", "02110", "02111", "02112", "02113", "02114", "02115", "02116", "02117", "02118", "02123", "02133", "02163", "02196", "02199", "02201", "02203", "02204", "02205", "02206", "02207", "02210", "02211", "02212", "02215", "02216", "02217", "02222", "02241", "02266", "02283", "02284", "02293", "02295", "02297", "02298"],
    "Boxborough": ["01719"],
    "Boxford": ["01921"],
    "Boylston": ["01505"],
    "Braintree": ["02184", "02185"],
    "Brant Rock": ["02020"],
    "Brewster": ["02631"],
    "Bridgewater": ["02324", "02325"],
    "Brighton": ["02135"],
    "Brimfield": ["01010"],
    "Brockton": ["02301", "02302", "02303", "02304", "02305"],
    "Brookfield": ["01506"],
    "Brookline": ["02445", "02446"],
    "Brookline Village": ["02447"],
    "Bryantville": ["02327"],
    "Buckland": ["01338"],
    "Burlington": ["01803", "01805"],
    "Buzzards Bay": ["02532", "02542"],
    "Byfield": ["01922"],
    "Cambridge": ["02138", "02139", "02140", "02141", "02142", "02238", "02239"],
    "Canton": ["02021"],
    "Carlisle": ["01741"],
    "Carver": ["02330"],
    "Cataumet": ["02534"],
    "Centerville": ["02632", "02634", "02636"],
    "Charlemont": ["01339"],
    "Charlestown": ["02129"],
    "Charlton": ["01507"],
    "Charlton City": ["01508"],
    "Charlton Depot": ["01509"],
    "Chartley": ["02712"],
    "Chatham": ["02633"],
    "Chelmsford": ["01824"],
    "Chelsea": ["02150"],
    "Cherry Valley": ["01611"],
    "Cheshire": ["01225"],
    "Chester": ["01011"],
    "Chesterfield": ["01012"],
    "Chestnut Hill": ["02467"],
    "Chicopee": ["01013", "01014", "01020", "01021", "01022"],
    "Chilmark": ["02535"],
    "Clinton": ["01510"],
    "Cohasset": ["02025"],
    "Colrain": ["01340"],
    "Concord": ["01742"],
    "Conway": ["01341"],
    "Cotuit": ["02635"],
    "Cummaquid": ["02637"],
    "Cummington": ["01026"],
    "Cuttyhunk": ["02713"],
    "Dalton": ["01226", "01227"],
    "Danvers": ["01923"],
    "Dartmouth": ["02714"],
    "Dedham": ["02026", "02027"],
    "Deerfield": ["01342"],
    "Dennis": ["02638"],
    "Dennis Port": ["02639"],
    "Devens": ["01434"],
    "Dighton": ["02715"],
    "Dorchester": ["02121", "02122", "02125"],
    "Dorchester Center": ["02124"],
    "Douglas": ["01516"],
    "Dover": ["02030"],
    "Dracut": ["01826"],
    "Drury": ["01343"],
    "Dudley": ["01571"],
    "Dunstable": ["01827"],
    "Duxbury": ["02331", "02332"],
    "East Boston": ["02128", "02228"],
    "East Bridgewater": ["02333"],
    "East Brookfield": ["01515"],
    "East Dennis": ["02641"],
    "East Falmouth": ["02536"],
    "East Freetown": ["02717"],
    "East Longmeadow": ["01028"],
    "East Mansfield": ["02031"],
    "East Orleans": ["02643"],
    "East Otis": ["01029"],
    "East Princeton": ["01517"],
    "East Sandwich": ["02537"],
    "East Taunton": ["02718"],
    "East Templeton": ["01438"],
    "East Walpole": ["02032"],
    "East Wareham": ["02538"],
    "East Weymouth": ["02189"],
    "Eastham": ["02642"],
    "Easthampton": ["01027"],
    "Easton": ["02334"],
    "Edgartown": ["02539"],
    "Elmwood": ["02337"],
    "Erving": ["01344"],
    "Essex": ["01929"],
    "Everett": ["02149"],
    "Fairhaven": ["02719"],
    "Fall River": ["02720", "02721", "02722", "02723", "02724"],
    "Falmouth": ["02540", "02541"],
    "Fayville": ["01745"],
    "Feeding Hills": ["01030"],
    "Fiskdale": ["01518"],
    "Fitchburg": ["01420"],
    "Florence": ["01062"],
    "Forestdale": ["02644"],
    "Foxboro": ["02035"],
    "Framingham": ["01701", "01702", "01703", "01704", "01705"],
    "Franklin": ["02038"],
    "Gardner": ["01440"],
    "Georgetown": ["01833"],
    "Gilbertville": ["01031"],
    "Gill": ["01354"],
    "Glendale": ["01229"],
    "Gloucester": ["01930", "01931"],
    "Goshen": ["01032"],
    "Grafton": ["01519"],
    "Granby": ["01033"],
    "Granville": ["01034"],
    "Great Barrington": ["01230"],
    "Green Harbor": ["02041"],
    "Greenbush": ["02040"],
    "Greenfield": ["01301", "01302"],
    "Groton": ["01450", "01470", "01471"],
    "Groveland": ["01834"],
    "Hadley": ["01035"],
    "Halifax": ["02338"],
    "Hamilton": ["01936"],
    "Hampden": ["01036"],
    "Hanover": ["02339", "02340"],
    "Hanscom AFB": ["01731"],
    "Hanson": ["02341"],
    "Hardwick": ["01037"],
    "Harvard": ["01451"],
    "Harwich": ["02645"],
    "Harwich Port": ["02646"],
    "Hatfield": ["01038"],
    "Hathorne": ["01937"],
    "Haverhill": ["01830", "01831", "01832", "01835"],
    "Haydenville": ["01039"],
    "Heath": ["01346"],
    "Hingham": ["02043", "02044"],
    "Hinsdale": ["01235"],
    "Holbrook": ["02343"],
    "Holden": ["01520"],
    "Holland": ["01521"],
    "Holliston": ["01746"],
    "Holyoke": ["01040", "01041"],
    "Hopedale": ["01747"],
    "Hopkinton": ["01748"],
    "Housatonic": ["01236"],
    "Hubbardston": ["01452"],
    "Hudson": ["01749"],
    "Hull": ["02045"],
    "Humarock": ["02047"],
    "Huntington": ["01050"],
    "Hyannis": ["02601"],
    "Hyannis Port": ["02647"],
    "Hyde Park": ["02136"],
    "Indian Orchard": ["01151"],
    "Ipswich": ["01938"],
    "Jamaica Plain": ["02130"],
    "Jefferson": ["01522"],
    "Kingston": ["02364"],
    "Lake Pleasant": ["01347"],
    "Lakeville": ["02347", "02348"],
    "Lancaster": ["01523"],
    "Lanesborough": ["01237"],
    "Lawrence": ["01840", "01841", "01842", "01843"],
    "Lee": ["01238"],
    "Leeds": ["01053"],
    "Leicester": ["01524"],
    "Lenox": ["01240"],
    "Lenox Dale": ["01242"],
    "Leominster": ["01453"],
    "Leverett": ["01054"],
    "Lexington": ["02420", "02421"],
    "Lincoln": ["01773"],
    "Linwood": ["01525"],
    "Littleton": ["01460"],
    "Longmeadow": ["01106", "01116"],
    "Lowell": ["01850", "01851", "01852", "01853", "01854"],
    "Ludlow": ["01056"],
    "Lunenburg": ["01462"],
    "Lynn": ["01901", "01902", "01903", "01904", "01905", "01910"],
    "Lynnfield": ["01940"],
    "Malden": ["02148"],
    "Manchaug": ["01526"],
    "Manchester": ["01944"],
    "Manomet": ["02345"],
    "Mansfield": ["02048"],
    "Marblehead": ["01945"],
    "Marion": ["02738"],
    "Marlborough": ["01752"],
    "Marshfield": ["02050"],
    "Marshfield Hills": ["02051"],
    "Marstons Mills": ["02648"],
    "Mashpee": ["02649"],
    "Mattapan": ["02126"],
    "Mattapoisett": ["02739"],
    "Maynard": ["01754"],
    "Medfield": ["02052"],
    "Medford": ["02153", "02155"],
    "Medway": ["02053"],
    "Melrose": ["02176"],
    "Mendon": ["01756"],
    "Menemsha": ["02552"],
    "Merrimac": ["01860"],
    "Methuen": ["01844"],
    "Middleboro": ["02344", "02346", "02349"],
    "Middlefield": ["01243"],
    "Middleton": ["01949"],
    "Milford": ["01757"],
    "Mill River": ["01244"],
    "Millbury": ["01527"],
    "Millers Falls": ["01349"],
    "Millis": ["02054"],
    "Millville": ["01529"],
    "Milton": ["02186"],
    "Milton Village": ["02187"],
    "Minot": ["02055"],
    "Monponsett": ["02350"],
    "Monroe Bridge": ["01350"],
    "Monson": ["01057"],
    "Montague": ["01351"],
    "Monterey": ["01245"],
    "Monument Beach": ["02553"],
    "Nahant": ["01908"],
    "Nantucket": ["02554", "02584"],
    "Natick": ["01760"],
    "Needham": ["02492"],
    "Needham Heights": ["02494"],
    "New Bedford": ["02740", "02741", "02742", "02744", "02745", "02746"],
    "New Braintree": ["01531"],
    "New Salem": ["01355"],
    "New Town": ["02456"],
    "Newbury": ["01951"],
    "Newburyport": ["01950"],
    "Newton": ["02458"],
    "Newton Center": ["02459"],
    "Newton Highlands": ["02461"],
    "Newton Lower Falls": ["02462"],
    "Newton Upper Falls": ["02464"],
    "Newtonville": ["02460"],
    "Nonantum": ["02495"],
    "Norfolk": ["02056"],
    "North Adams": ["01247"],
    "North Amherst": ["01059"],
    "North Andover": ["01845"],
    "North Attleboro": ["02760", "02761"],
    "North Billerica": ["01862"],
    "North Brookfield": ["01535"],
    "North Carver": ["02355"],
    "North Chatham": ["02650"],
    "North Chelmsford": ["01863"],
    "North Dartmouth": ["02747"],
    "North Dighton": ["02764"],
    "North Eastham": ["02651"],
    "North Easton": ["02356", "02357"],
    "North Egremont": ["01252"],
    "North Falmouth": ["02556"],
    "North Grafton": ["01536"],
    "North Hatfield": ["01066"],
    "North Marshfield": ["02059"],
    "North Oxford": ["01537"],
    "North Pembroke": ["02358"],
    "North Reading": ["01864", "01889"],
    "North Scituate": ["02060"],
    "North Truro": ["02652"],
    "North Uxbridge": ["01538"],
    "North Waltham": ["02455"],
    "North Weymouth": ["02191"],
    "Northampton": ["01060", "01061", "01063"],
    "Northborough": ["01532"],
    "Northbridge": ["01534"],
    "Northfield": ["01360"],
    "Norton": ["02766"],
    "Norwell": ["02061"],
    "Norwood": ["02062"],
    "Nutting Lake": ["01865"],
    "Oak Bluffs": ["02557"],
    "Oakham": ["01068"],
    "Ocean Bluff": ["02065"],
    "Onset": ["02558"],
    "Orange": ["01364"],
    "Orleans": ["02653"],
    "Osterville": ["02655"],
    "Otis": ["01253"],
    "Oxford": ["01540"],
    "Palmer": ["01069"],
    "Paxton": ["01612"],
    "Peabody": ["01960", "01961"],
    "Pembroke": ["02359"],
    "Pepperell": ["01463"],
    "Petersham": ["01366"],
    "Pinehurst": ["01866"],
    "Pittsfield": ["01201", "01202", "01203"],
    "Plainfield": ["01070"],
    "Plainville": ["02762"],
    "Plymouth": ["02360", "02361", "02362"],
    "Plympton": ["02367"],
    "Pocasset": ["02559"],
    "Prides Crossing": ["01965"],
    "Princeton": ["01541"],
    "Provincetown": ["02657"],
    "Quincy": ["02169", "02170", "02171", "02269"],
    "Randolph": ["02368"],
    "Raynham": ["02767"],
    "Raynham Center": ["02768"],
    "Reading": ["01867"],
    "Readville": ["02137"],
    "Rehoboth": ["02769"],
    "Revere": ["02151"],
    "Richmond": ["01254"],
    "Rochdale": ["01542"],
    "Rochester": ["02770"],
    "Rockland": ["02370"],
    "Rockport": ["01966"],
    "Roslindale": ["02131"],
    "Rowe": ["01367"],
    "Rowley": ["01969"],
    "Roxbury": ["02119"],
    "Roxbury Crossing": ["02120"],
    "Royalston": ["01368"],
    "Russell": ["01071"],
    "Rutland": ["01543"],
    "Sagamore": ["02561"],
    "Sagamore Beach": ["02562"],
    "Salem": ["01970", "01971"],
    "Salisbury": ["01952"],
    "Sandisfield": ["01255"],
    "Sandwich": ["02563"],
    "Saugus": ["01906"],
    "Savoy": ["01256"],
    "Scituate": ["02066"],
    "Seekonk": ["02771"],
    "Sharon": ["02067"],
    "Sheffield": ["01257"],
    "Shelburne Falls": ["01370"],
    "Sheldonville": ["02070"],
    "Sherborn": ["01770"],
    "Shirley": ["01464"],
    "Shrewsbury": ["01545", "01546"],
    "Shutesbury": ["01072"],
    "Siasconset": ["02564"],
    "Silver Beach": ["02565"],
    "Somerset": ["02725", "02726"],
    "Somerville": ["02143", "02144", "02145"],
    "South Barre": ["01074"],
    "South Boston": ["02127"],
    "South Carver": ["02366"],
    "South Chatham": ["02659"],
    "South Dartmouth": ["02748"],
    "South Deerfield": ["01373"],
    "South Dennis": ["02660"],
    "South Easton": ["02375"],
    "South Egremont": ["01258"],
    "South Grafton": ["01560"],
    "South Hadley": ["01075"],
    "South Hamilton": ["01982"],
    "South Harwich": ["02661"],
    "South Lancaster": ["01561"],
    "South Lee": ["01260"],
    "South Orleans": ["02662"],
    "South Walpole": ["02071"],
    "South Wellfleet": ["02663"],
    "South Weymouth": ["02190"],
    "South Yarmouth": ["02664"],
    "Southampton": ["01073"],
    "Southborough": ["01772"],
    "Southbridge": ["01550"],
    "Southfield": ["01259"],
    "Southwick": ["01077"],
    "Spencer": ["01562"],
    "Springfield": ["01101", "01102", "01103", "01104", "01105", "01107", "01108", "01109", "01111", "01115", "01118", "01119", "01128", "01129", "01133", "01138", "01139", "01144", "01152", "01195", "01199"],
    "Sterling": ["01564"],
    "Still River": ["01467"],
    "Stockbridge": ["01262", "01263"],
    "Stoneham": ["02180"],
    "Stoughton": ["02072"],
    "Stow": ["01775"],
    "Sturbridge": ["01566"],
    "Sudbury": ["01776"],
    "Sunderland": ["01375"],
    "Sutton": ["01590"],
    "Swampscott": ["01907"],
    "Swansea": ["02777"],
    "Taunton": ["02780", "02783"],
    "Templeton": ["01468"],
    "Tewksbury": ["01876"],
    "Thorndike": ["01079"],
    "Three Rivers": ["01080"],
    "Topsfield": ["01983"],
    "Townsend": ["01469"],
    "Truro": ["02666"],
    "Turners Falls": ["01376"],
    "Tyngsboro": ["01879"],
    "Tyringham": ["01264"],
    "Upton": ["01568"],
    "Uxbridge": ["01569"],
    "Vineyard Haven": ["02568"],
    "Waban": ["02468"],
    "Wakefield": ["01880"],
    "Wales": ["01081"],
    "Walpole": ["02081"],
    "Waltham": ["02451", "02452", "02453", "02454"],
    "Ware": ["01082"],
    "Wareham": ["02571"],
    "Warren": ["01083"],
    "Warwick": ["01378"],
    "Watertown": ["02471", "02472", "02477"],
    "Waverley": ["02479"],
    "Wayland": ["01778"],
    "Webster": ["01570"],
    "Wellesley": ["02482"],
    "Wellesley Hills": ["02481"],
    "Wellfleet": ["02667"],
    "Wendell": ["01379"],
    "Wendell Depot": ["01380"],
    "Wenham": ["01984"],
    "West Barnstable": ["02668"],
    "West Boxford": ["01885"],
    "West Boylston": ["01583"],
    "West Bridgewater": ["02379"],
    "West Brookfield": ["01585"],
    "West Chatham": ["02669"],
    "West Chesterfield": ["01084"],
    "West Chop": ["02573"],
    "West Dennis": ["02670"],
    "West Falmouth": ["02574"],
    "West Groton": ["01472"],
    "West Harwich": ["02671"],
    "West Hatfield": ["01088"],
    "West Hyannisport": ["02672"],
    "West Medford": ["02156"],
    "West Millbury": ["01586"],
    "West Newbury": ["01985"],
    "West Newton": ["02465"],
    "West Roxbury": ["02132"],
    "West Springfield": ["01089", "01090"],
    "West Stockbridge": ["01266"],
    "West Tisbury": ["02575"],
    "West Townsend": ["01474"],
    "West Wareham": ["02576"],
    "West Warren": ["01092"],
    "West Yarmouth": ["02673"],
    "Westborough": ["01580", "01581", "01582"],
    "Westfield": ["01085", "01086"],
    "Westford": ["01886"],
    "Westminster": ["01441", "01473"],
    "Weston": ["02493"],
    "Westport": ["02790"],
    "Westport Point": ["02791"],
    "Westwood": ["02090"],
    "Weymouth": ["02188"],
    "Whately": ["01093"],
    "Wheelwright": ["01094"],
    "White Horse Beach": ["02381"],
    "Whitinsville": ["01588"],
    "Whitman": ["02382"],
    "Wilbraham": ["01095"],
    "Williamsburg": ["01096"],
    "Williamstown": ["01267"],
    "Wilmington": ["01887"],
    "Winchendon": ["01475"],
    "Winchendon Springs": ["01477"],
    "Winchester": ["01890"],
    "Windsor": ["01270"],
    "Winthrop": ["02152"],
    "Woburn": ["01801", "01806", "01807", "01808", "01813", "01815", "01888"],
    "Woods Hole": ["02543"],
    "Woodville": ["01784"],
    "Worcester": ["01601", "01602", "01603", "01604", "01605", "01606", "01607", "01608", "01609", "01610", "01613", "01614", "01615", "01653", "01654", "01655"],
    "Woronoco": ["01097"],
    "Worthington": ["01098"],
    "Wrentham": ["02093"],
    "Yarmouth Port": ["02675"]
  },
  "MD": {
    "Abell": ["20606"],
    "Aberdeen": ["21001"],
    "Aberdeen Proving Ground": ["21005"],
    "Abingdon": ["21009"],
    "Accident": ["21520"],
    "Accokeek": ["20607"],
    "Adamstown": ["21710"],
    "Allen": ["21810"],
    "Andrews Air Force Base": ["20762"],
    "Annapolis": ["21401", "21402", "21403", "21404", "21405", "21409", "21411", "21412"],
    "Annapolis Junction": ["20701"],
    "Aquasco": ["20608"],
    "Arnold": ["21012"],
    "Ashton": ["20861"],
    "Avenue": ["20609"],
    "Baldwin": ["21013"],
    "Baltimore": ["21201", "21202", "21203", "21205", "21206", "21209", "21210", "21211", "21212", "21213", "21214", "21215", "21216", "21217", "21218", "21223", "21224", "21229", "21230", "21231", "21233", "21235", "21239", "21240", "21241", "21250", "21251", "21260", "21261", "21263", "21264", "21265", "21268", "21270", "21273", "21274", "21275", "21278", "21279", "21280", "21281", "21283", "21287", "21288", "21289", "21290", "21297", "21298"],
    "Barclay": ["21607"],
    "Barnesville": ["20838"],
    "Barstow": ["20610"],
    "Barton": ["21521"],
    "Beallsville": ["20839"],
    "Bel Air": ["21014", "21015"],
    "Bel Alton": ["20611"],
    "Belcamp": ["21017"],
    "Beltsville": ["20704", "20705"],
    "Benedict": ["20612"],
    "Benson": ["21018"],
    "Berlin": ["21811"],
    "Bethesda": ["20810", "20811", "20813", "20814", "20816", "20817", "20824", "20827", "20889", "20892", "20894"],
    "Bethlehem": ["21609"],
    "Betterton": ["21610"],
    "Big Pool": ["21711"],
    "Bishopville": ["21813"],
    "Bittinger": ["21522"],
    "Bivalve": ["21814"],
    "Bladensburg": ["20710"],
    "Bloomington": ["21523"],
    "Boonsboro": ["21713"],
    "Boring": ["21020"],
    "Bowie": ["20715", "20716", "20717", "20718", "20719", "20720", "20721"],
    "Boyds": ["20841"],
    "Bozman": ["21612"],
    "Braddock Heights": ["21714"],
    "Brandywine": ["20613"],
    "Brentwood": ["20722"],
    "Brinklow": ["20862"],
    "Brookeville": ["20833"],
    "Brooklandville": ["21022"],
    "Brooklyn": ["21225"],
    "Broomes Island": ["20615"],
    "Brownsville": ["21715"],
    "Brunswick": ["21716"],
    "Bryans Road": ["20616"],
    "Bryantown": ["20617"],
    "Buckeystown": ["21717"],
    "Burkittsville": ["21718"],
    "Burtonsville": ["20866"],
    "Bushwood": ["20618"],
    "Butler": ["21023"],
    "Cabin John": ["20818"],
    "California": ["20619"],
    "Callaway": ["20620"],
    "Cambridge": ["21613"],
    "Capitol Heights": ["20731", "20743", "20790", "20791", "20799"],
    "Cascade": ["21719"],
    "Catonsville": ["21228"],
    "Cavetown": ["21720"],
    "Cecilton": ["21913"],
    "Centreville": ["21617"],
    "Chaptico": ["20621"],
    "Charlestown": ["21914"],
    "Charlotte Hall": ["20622"],
    "Chase": ["21027"],
    "Cheltenham": ["20623"],
    "Chesapeake Beach": ["20732"],
    "Chesapeake City": ["21915"],
    "Chester": ["21619"],
    "Chestertown": ["21620", "21690"],
    "Chevy Chase": ["20815", "20825"],
    "Chewsville": ["21721"],
    "Childs": ["21916"],
    "Church Creek": ["21622"],
    "Church Hill": ["21623"],
    "Churchton": ["20733"],
    "Churchville": ["21028"],
    "Claiborne": ["21624"],
    "Clarksburg": ["20871"],
    "Clarksville": ["21029"],
    "Clear Spring": ["21722"],
    "Clements": ["20624"],
    "Clinton": ["20735"],
    "Cobb Island": ["20625"],
    "Cockeysville": ["21030"],
    "College Park": ["20740", "20741", "20742"],
    "Colora": ["21917"],
    "Coltons Point": ["20626"],
    "Columbia": ["21044", "21045", "21046"],
    "Compton": ["20627"],
    "Conowingo": ["21918"],
    "Cooksville": ["21723"],
    "Cordova": ["21625"],
    "Corriganville": ["21524"],
    "Crapo": ["21626"],
    "Crisfield": ["21817"],
    "Crocheron": ["21627"],
    "Crofton": ["21114"],
    "Crownsville": ["21032"],
    "Crumpton": ["21628"],
    "Cumberland": ["21501", "21502", "21503", "21504", "21505"],
    "Curtis Bay": ["21226"],
    "Damascus": ["20872"],
    "Dameron": ["20628"],
    "Darlington": ["21034"],
    "Davidsonville": ["21035"],
    "Dayton": ["21036"],
    "Deal Island": ["21821"],
    "Deale": ["20751"],
    "Delmar": ["21875"],
    "Denton": ["21629"],
    "Derwood": ["20855"],
    "Dhs": ["20588"],
    "Dickerson": ["20842"],
    "District Heights": ["20747", "20753"],
    "Dowell": ["20629"],
    "Drayden": ["20630"],
    "Dundalk": ["21222"],
    "Dunkirk": ["20754"],
    "Earleville": ["21919"],
    "East New Market": ["21631"],
    "Easton": ["21601", "21606"],
    "Eckhart Mines": ["21528"],
    "Eden": ["21822"],
    "Edgewater": ["21037"],
    "Edgewood": ["21040"],
    "Elk Mills": ["21920"],
    "Elkridge": ["21075"],
    "Elkton": ["21921", "21922"],
    "Ellerslie": ["21529"],
    "Ellicott City": ["21041", "21042", "21043"],
    "Emmitsburg": ["21727"],
    "Essex": ["21221"],
    "Ewell": ["21824"],
    "Fairplay": ["21733"],
    "Fallston": ["21047"],
    "Faulkner": ["20632"],
    "Federalsburg": ["21632"],
    "Finksburg": ["21048"],
    "Fishing Creek": ["21634"],
    "Flintstone": ["21530"],
    "Forest Hill": ["21050"],
    "Fork": ["21051"],
    "Fort George G Meade": ["20755"],
    "Fort Howard": ["21052"],
    "Fort Washington": ["20744", "20749"],
    "Frederick": ["21701", "21702", "21703", "21704", "21705", "21709"],
    "Freeland": ["21053"],
    "Friendship": ["20758"],
    "Friendsville": ["21531"],
    "Frostburg": ["21532"],
    "Fruitland": ["21826"],
    "Fulton": ["20759"],
    "Funkstown": ["21734"],
    "Gaithersburg": ["20877", "20878", "20879", "20882", "20883", "20884", "20885", "20898", "20899"],
    "Galena": ["21635"],
    "Galesville": ["20765"],
    "Gambrills": ["21054"],
    "Garrett Park": ["20896"],
    "Georgetown": ["21930"],
    "Germantown": ["20874", "20875", "20876"],
    "Gibson Island": ["21056"],
    "Girdletree": ["21829"],
    "Glen Arm": ["21057"],
    "Glen Burnie": ["21060", "21061", "21062"],
    "Glen Echo": ["20812"],
    "Glenelg": ["21737"],
    "Glenn Dale": ["20769"],
    "Glenwood": ["21738"],
    "Glyndon": ["21071"],
    "Goldsboro": ["21636"],
    "Grantsville": ["21536"],
    "Grasonville": ["21638"],
    "Great Mills": ["20634"],
    "Greenbelt": ["20768", "20770", "20771"],
    "Greensboro": ["21639"],
    "Gunpowder": ["21010"],
    "Gwynn Oak": ["21207"],
    "Hagerstown": ["21740", "21741", "21742", "21746", "21747", "21748", "21749"],
    "Halethorpe": ["21227"],
    "Hampstead": ["21074"],
    "Hancock": ["21750"],
    "Hanover": ["21076", "21098"],
    "Harmans": ["21077"],
    "Harwood": ["20776"],
    "Havre De Grace": ["21078"],
    "Hebron": ["21830"],
    "Helen": ["20635"],
    "Henderson": ["21640"],
    "Highland": ["20777"],
    "Hillsboro": ["21641"],
    "Hollywood": ["20636"],
    "Hughesville": ["20637"],
    "Hunt Valley": ["21031", "21065"],
    "Huntingtown": ["20639"],
    "Hurlock": ["21643"],
    "Hyattsville": ["20781", "20782", "20783", "20784", "20785", "20787", "20788"],
    "Hydes": ["21082"],
    "Ijamsville": ["21754"],
    "Indian Head": ["20640"],
    "Ingleside": ["21644"],
    "Ironsides": ["20643"],
    "Issue": ["20645"],
    "Jarrettsville": ["21084"],
    "Jefferson": ["21755"],
    "Jessup": ["20794"],
    "Joppa": ["21085"],
    "Keedysville": ["21756"],
    "Kennedyville": ["21645"],
    "Kensington": ["20891", "20895"],
    "Keymar": ["21757"],
    "Kingsville": ["21087"],
    "Kitzmiller": ["21538"],
    "Knoxville": ["21758"],
    "La Plata": ["20646"],
    "Ladiesburg": ["21759"],
    "Lanham": ["20703", "20706"],
    "Laurel": ["20707", "20708", "20709", "20723", "20724", "20725", "20726"],
    "Leonardtown": ["20650"],
    "Lexington Park": ["20653"],
    "Libertytown": ["21762"],
    "Lineboro": ["21088"],
    "Linkwood": ["21835"],
    "Linthicum Heights": ["21090"],
    "Lisbon": ["21765"],
    "Little Orleans": ["21766"],
    "Lonaconing": ["21539"],
    "Long Green": ["21092"],
    "Lothian": ["20711"],
    "Loveville": ["20656"],
    "Luke": ["21540"],
    "Lusby": ["20657"],
    "Lutherville Timonium": ["21093", "21094"],
    "Madison": ["21648"],
    "Manchester": ["21102"],
    "Manokin": ["21836"],
    "Marbury": ["20658"],
    "Mardela Springs": ["21837"],
    "Marion Station": ["21838"],
    "Marriottsville": ["21104"],
    "Marydel": ["21649"],
    "Maryland Line": ["21105"],
    "Massey": ["21650"],
    "Maugansville": ["21767"],
    "Mayo": ["21106"],
    "Mc Henry": ["21541"],
    "Mcdaniel": ["21647"],
    "Mechanicsville": ["20659"],
    "Middle River": ["21220"],
    "Middletown": ["21769"],
    "Midland": ["21542"],
    "Midlothian": ["21543"],
    "Millersville": ["21108"],
    "Millington": ["21651"],
    "Monkton": ["21111"],
    "Monrovia": ["21770"],
    "Montgomery Village": ["20886"],
    "Morganza": ["20660"],
    "Mount Airy": ["21771"],
    "Mount Rainier": ["20712"],
    "Mount Savage": ["21545"],
    "Mount Victoria": ["20661"],
    "Myersville": ["21773"],
    "Nanjemoy": ["20662"],
    "Nanticoke": ["21840"],
    "Neavitt": ["21652"],
    "New Market": ["21774"],
    "New Midway": ["21775"],
    "New Windsor": ["21776"],
    "Newark": ["21841"],
    "Newburg": ["20664"],
    "Newcomb": ["21653"],
    "North Beach": ["20714"],
    "North East": ["21901"],
    "Nottingham": ["21236"],
    "Oakland": ["21550"],
    "Ocean City": ["21842", "21843"],
    "Odenton": ["21113"],
    "Oldtown": ["21555"],
    "Olney": ["20830", "20832"],
    "Owings": ["20736"],
    "Owings Mills": ["21117"],
    "Oxford": ["21654"],
    "Oxon Hill": ["20745", "20750"],
    "Park Hall": ["20667"],
    "Parkton": ["21120"],
    "Parkville": ["21234"],
    "Parsonsburg": ["21849"],
    "Pasadena": ["21122", "21123"],
    "Patuxent River": ["20670"],
    "Perry Hall": ["21128"],
    "Perry Point": ["21902"],
    "Perryman": ["21130"],
    "Perryville": ["21903"],
    "Phoenix": ["21131"],
    "Pikesville": ["21208", "21282"],
    "Piney Point": ["20674"],
    "Pinto": ["21556"],
    "Pittsville": ["21850"],
    "Pocomoke City": ["21851"],
    "Point Of Rocks": ["21777"],
    "Pomfret": ["20675"],
    "Poolesville": ["20837"],
    "Port Deposit": ["21904"],
    "Port Republic": ["20676"],
    "Port Tobacco": ["20677"],
    "Potomac": ["20854", "20859"],
    "Powellville": ["21852"],
    "Preston": ["21655"],
    "Price": ["21656"],
    "Prince Frederick": ["20678"],
    "Princess Anne": ["21853"],
    "Pylesville": ["21132"],
    "Quantico": ["21856"],
    "Queen Anne": ["21657"],
    "Queenstown": ["21658"],
    "Randallstown": ["21133"],
    "Rawlings": ["21557"],
    "Rehobeth": ["21857"],
    "Reisterstown": ["21136"],
    "Rhodesdale": ["21659"],
    "Riderwood": ["21139"],
    "Ridge": ["20680"],
    "Ridgely": ["21660", "21681", "21682", "21683", "21684", "21685", "21686", "21687", "21688"],
    "Rising Sun": ["21911"],
    "Riva": ["21140"],
    "Riverdale": ["20737", "20738"],
    "Rock Hall": ["21661"],
    "Rock Point": ["20682"],
    "Rockville": ["20847", "20848", "20849", "20850", "20851", "20852", "20853", "20857"],
    "Rocky Ridge": ["21778"],
    "Rohrersville": ["21779"],
    "Rosedale": ["21237"],
    "Royal Oak": ["21662"],
    "Sabillasville": ["21780"],
    "Saint Inigoes": ["20684"],
    "Saint James": ["21781"],
    "Saint Leonard": ["20685"],
    "Saint Marys City": ["20686"],
    "Saint Michaels": ["21663"],
    "Salisbury": ["21801", "21802", "21803", "21804"],
    "Sandy Spring": ["20860"],
    "Savage": ["20763"],
    "Scotland": ["20687"],
    "Secretary": ["21664"],
    "Severn": ["21144"],
    "Severna Park": ["21146"],
    "Shady Side": ["20764"],
    "Sharpsburg": ["21782"],
    "Sharptown": ["21861"],
    "Sherwood": ["21665"],
    "Showell": ["21862"],
    "Silver Spring": ["20901", "20902", "20903", "20904", "20905", "20906", "20907", "20908", "20910", "20911", "20914", "20915", "20916", "20918", "20993", "20997"],
    "Simpsonville": ["21150"],
    "Smithsburg": ["21783"],
    "Snow Hill": ["21863"],
    "Solomons": ["20688"],
    "Southern Md Facility": ["20697", "20797"],
    "Sparks Glencoe": ["21152"],
    "Sparrows Point": ["21219"],
    "Spencerville": ["20868"],
    "Spring Gap": ["21560"],
    "Stevenson": ["21153"],
    "Stevensville": ["21666"],
    "Still Pond": ["21667"],
    "Stockton": ["21864"],
    "Street": ["21154"],
    "Suburb Maryland Fac": ["20897"],
    "Sudlersville": ["21668"],
    "Suitland": ["20746", "20752"],
    "Sunderland": ["20689"],
    "Swanton": ["21561"],
    "Sykesville": ["21784"],
    "Takoma Park": ["20912", "20913"],
    "Tall Timbers": ["20690"],
    "Taneytown": ["21787"],
    "Taylors Island": ["21669"],
    "Temple Hills": ["20748", "20757"],
    "Templeville": ["21670"],
    "Thurmont": ["21788"],
    "Tilghman": ["21671"],
    "Toddville": ["21672"],
    "Towson": ["21204", "21252", "21284", "21285", "21286"],
    "Tracys Landing": ["20779"],
    "Trappe": ["21673"],
    "Tuscarora": ["21790"],
    "Tyaskin": ["21865"],
    "Tylerton": ["21866"],
    "Union Bridge": ["21791"],
    "Unionville": ["21792"],
    "Upper Fairmount": ["21867"],
    "Upper Falls": ["21156"],
    "Upper Marlboro": ["20772", "20773", "20774", "20775", "20792"],
    "Upperco": ["21155"],
    "Valley Lee": ["20692"],
    "Vienna": ["21869"],
    "Waldorf": ["20601", "20602", "20603", "20604"],
    "Walkersville": ["21793"],
    "Warwick": ["21912"],
    "Washington Grove": ["20880"],
    "Welcome": ["20693"],
    "West Friendship": ["21794"],
    "West River": ["20778"],
    "Westernport": ["21562"],
    "Westminster": ["21157", "21158"],
    "Westover": ["21871", "21890"],
    "Whaleyville": ["21872"],
    "White Hall": ["21161"],
    "White Marsh": ["21162"],
    "White Plains": ["20695"],
    "Whiteford": ["21160"],
    "Willards": ["21874"],
    "Williamsport": ["21795"],
    "Windsor Mill": ["21244"],
    "Wingate": ["21675"],
    "Wittman": ["21676"],
    "Woodbine": ["21797"],
    "Woodsboro": ["21798"],
    "Woodstock": ["21163"],
    "Woolford": ["21677"],
    "Worton": ["21678"],
    "Wye Mills": ["21679"]
  },
  "ME": {
    "Abbot": ["04406"],
    "Acton": ["04001"],
    "Addison": ["04606"],
    "Albion": ["04910"],
    "Alfred": ["04002"],
    "Alna": ["04535"],
    "Andover": ["04216"],
    "Anson": ["04911"],
    "Ashland": ["04732"],
    "Athens": ["04912"],
    "Auburn": ["04210", "04211", "04212"],
    "Augusta": ["04330", "04332", "04333", "04336", "04338"],
    "Aurora": ["04408"],
    "Bailey Island": ["04003"],
    "Baileyville": ["04694"],
    "Bangor": ["04401", "04402"],
    "Bar Harbor": ["04609"],
    "Bar Mills": ["04004"],
    "Bass Harbor": ["04653"],
    "Bath": ["04530"],
    "Beals": ["04611"],
    "Belfast": ["04915"],
    "Belgrade": ["04917"],
    "Belgrade Lakes": ["04918"],
    "Benedicta": ["04733"],
    "Bernard": ["04612"],
    "Berwick": ["03901"],
    "Bethel": ["04217"],
    "Biddeford": ["04005", "04007"],
    "Biddeford Pool": ["04006"],
    "Bingham": ["04920"],
    "Birch Harbor": ["04613"],
    "Blaine": ["04734"],
    "Blue Hill": ["04614"],
    "Boothbay": ["04537"],
    "Boothbay Harbor": ["04538"],
    "Bowdoin": ["04287"],
    "Bowdoinham": ["04008"],
    "Bradford": ["04410"],
    "Bradley": ["04411"],
    "Bremen": ["04551"],
    "Brewer": ["04412"],
    "Bridgewater": ["04735"],
    "Bridgton": ["04009"],
    "Bristol": ["04539"],
    "Brooklin": ["04616"],
    "Brooks": ["04921"],
    "Brooksville": ["04617"],
    "Brookton": ["04413"],
    "Brownfield": ["04010"],
    "Brownville": ["04414"],
    "Brownville Junction": ["04415"],
    "Brunswick": ["04011"],
    "Bryant Pond": ["04219"],
    "Buckfield": ["04220"],
    "Bucksport": ["04416"],
    "Burlington": ["04417"],
    "Burnham": ["04922"],
    "Bustins Island": ["04013"],
    "Buxton": ["04093"],
    "Calais": ["04619"],
    "Cambridge": ["04923"],
    "Camden": ["04843"],
    "Canaan": ["04924"],
    "Canton": ["04221"],
    "Cape Elizabeth": ["04107"],
    "Cape Neddick": ["03902"],
    "Cape Porpoise": ["04014"],
    "Caratunk": ["04925"],
    "Caribou": ["04736"],
    "Carmel": ["04419"],
    "Casco": ["04015"],
    "Castine": ["04420", "04421"],
    "Center Lovell": ["04016"],
    "Chamberlain": ["04541"],
    "Charleston": ["04422"],
    "Chebeague Island": ["04017"],
    "Cherryfield": ["04622"],
    "China Village": ["04926"],
    "Clayton Lake": ["04737"],
    "Cliff Island": ["04019"],
    "Clinton": ["04927"],
    "Columbia Falls": ["04623"],
    "Coopers Mills": ["04341"],
    "Corea": ["04624"],
    "Corinna": ["04928"],
    "Corinth": ["04427"],
    "Cornish": ["04020"],
    "Cranberry Isles": ["04625"],
    "Crouseville": ["04738"],
    "Cumberland Center": ["04021"],
    "Cumberland Foreside": ["04110"],
    "Cushing": ["04563"],
    "Cutler": ["04626"],
    "Damariscotta": ["04543"],
    "Danforth": ["04424"],
    "Danville": ["04223"],
    "Deer Isle": ["04627"],
    "Denmark": ["04022"],
    "Dennysville": ["04628"],
    "Detroit": ["04929"],
    "Dexter": ["04930"],
    "Dixfield": ["04224"],
    "Dixmont": ["04932"],
    "Dover Foxcroft": ["04426"],
    "Dresden": ["04342"],
    "Dryden": ["04225"],
    "Durham": ["04222"],
    "Eagle Lake": ["04739"],
    "East Andover": ["04226"],
    "East Baldwin": ["04024"],
    "East Blue Hill": ["04629"],
    "East Boothbay": ["04544"],
    "East Dixfield": ["04227"],
    "East Livermore": ["04228"],
    "East Machias": ["04630"],
    "East Millinocket": ["04430"],
    "East Newport": ["04933"],
    "East Orland": ["04431"],
    "East Parsonsfield": ["04028"],
    "East Poland": ["04230"],
    "East Vassalboro": ["04935"],
    "East Waterboro": ["04030"],
    "East Wilton": ["04234"],
    "East Winthrop": ["04343"],
    "Easton": ["04740"],
    "Eastport": ["04631"],
    "Eddington": ["04428"],
    "Edgecomb": ["04556"],
    "Eliot": ["03903"],
    "Ellsworth": ["04605"],
    "Estcourt Station": ["04741"],
    "Etna": ["04434"],
    "Eustis": ["04936"],
    "Exeter": ["04435"],
    "Fairfield": ["04937"],
    "Falmouth": ["04105"],
    "Farmingdale": ["04344"],
    "Farmington": ["04938"],
    "Farmington Falls": ["04940"],
    "Fort Fairfield": ["04742"],
    "Fort Kent": ["04743"],
    "Fort Kent Mills": ["04744"],
    "Frankfort": ["04438"],
    "Franklin": ["04634"],
    "Freedom": ["04941"],
    "Freeport": ["04032", "04033", "04034"],
    "Frenchboro": ["04635"],
    "Frenchville": ["04745"],
    "Friendship": ["04547"],
    "Fryeburg": ["04037"],
    "Gardiner": ["04345"],
    "Garland": ["04939"],
    "Georgetown": ["04548"],
    "Glen Cove": ["04846"],
    "Gorham": ["04038"],
    "Gouldsboro": ["04607"],
    "Grand Isle": ["04746"],
    "Grand Lake Stream": ["04637"],
    "Gray": ["04039"],
    "Greenbush": ["04418"],
    "Greene": ["04236"],
    "Greenville": ["04441"],
    "Greenville Junction": ["04442"],
    "Greenwood": ["04255"],
    "Guilford": ["04443"],
    "Hallowell": ["04347"],
    "Hampden": ["04444"],
    "Hancock": ["04640"],
    "Hanover": ["04237"],
    "Harborside": ["04642"],
    "Harmony": ["04942"],
    "Harpswell": ["04079"],
    "Harrington": ["04643"],
    "Harrison": ["04040"],
    "Hartland": ["04943"],
    "Hebron": ["04238"],
    "Hinckley": ["04944"],
    "Hiram": ["04041"],
    "Holden": ["04429"],
    "Hollis Center": ["04042"],
    "Hope": ["04847"],
    "Houlton": ["04730"],
    "Howland": ["04448"],
    "Hudson": ["04449"],
    "Hulls Cove": ["04644"],
    "Island Falls": ["04747"],
    "Isle Au Haut": ["04645"],
    "Isle Of Springs": ["04549"],
    "Islesboro": ["04848"],
    "Islesford": ["04646"],
    "Jackman": ["04945"],
    "Jay": ["04239"],
    "Jefferson": ["04348"],
    "Jonesboro": ["04648"],
    "Jonesport": ["04649"],
    "Kenduskeag": ["04450"],
    "Kennebunk": ["04043"],
    "Kennebunkport": ["04046"],
    "Kents Hill": ["04349"],
    "Kingfield": ["04947"],
    "Kingman": ["04451"],
    "Kittery": ["03904"],
    "Kittery Point": ["03905"],
    "Lagrange": ["04453"],
    "Lambert Lake": ["04454"],
    "Lebanon": ["04027"],
    "Lee": ["04455"],
    "Leeds": ["04263"],
    "Levant": ["04456"],
    "Lewiston": ["04240", "04241", "04243"],
    "Liberty": ["04949"],
    "Limerick": ["04048"],
    "Limestone": ["04750", "04751"],
    "Limington": ["04049"],
    "Lincoln": ["04457"],
    "Lincolnville": ["04849"],
    "Lincolnville Center": ["04850"],
    "Lisbon": ["04250"],
    "Lisbon Falls": ["04252"],
    "Litchfield": ["04350"],
    "Little Deer Isle": ["04650"],
    "Livermore": ["04253"],
    "Livermore Falls": ["04254"],
    "Long Island": ["04050"],
    "Lovell": ["04051"],
    "Lubec": ["04652"],
    "Machias": ["04654"],
    "Machiasport": ["04655"],
    "Madawaska": ["04756"],
    "Madison": ["04950"],
    "Manchester": ["04351"],
    "Mapleton": ["04757"],
    "Mars Hill": ["04758"],
    "Matinicus": ["04851"],
    "Mattawamkeag": ["04459"],
    "Mechanic Falls": ["04256"],
    "Meddybemps": ["04657"],
    "Medway": ["04460"],
    "Mexico": ["04257"],
    "Milbridge": ["04658"],
    "Milford": ["04461"],
    "Millinocket": ["04462"],
    "Milo": ["04463"],
    "Minot": ["04258"],
    "Monhegan": ["04852"],
    "Monmouth": ["04259"],
    "Monroe": ["04951"],
    "Monson": ["04464"],
    "Monticello": ["04760"],
    "Moody": ["04054"],
    "Morrill": ["04952"],
    "Mount Desert": ["04660"],
    "Mount Vernon": ["04352"],
    "Naples": ["04055"],
    "New Gloucester": ["04260"],
    "New Harbor": ["04554"],
    "New Limerick": ["04761"],
    "New Portland": ["04954", "04961"],
    "New Sharon": ["04955"],
    "New Sweden": ["04762"],
    "New Vineyard": ["04956"],
    "Newcastle": ["04553"],
    "Newfield": ["04056"],
    "Newport": ["04953"],
    "Newry": ["04261"],
    "Nobleboro": ["04555"],
    "Norridgewock": ["04957"],
    "North Anson": ["04958"],
    "North Berwick": ["03906"],
    "North Bridgton": ["04057"],
    "North Haven": ["04853"],
    "North Jay": ["04262"],
    "North Monmouth": ["04265"],
    "North Turner": ["04266"],
    "North Vassalboro": ["04962"],
    "North Waterboro": ["04061"],
    "North Waterford": ["04267"],
    "North Yarmouth": ["04097"],
    "Northeast Harbor": ["04662"],
    "Norway": ["04268"],
    "Oakfield": ["04763"],
    "Oakland": ["04963"],
    "Ocean Park": ["04063"],
    "Ogunquit": ["03907"],
    "Olamon": ["04467"],
    "Old Orchard Beach": ["04064"],
    "Old Town": ["04468"],
    "Oquossoc": ["04964"],
    "Orient": ["04471"],
    "Orland": ["04472"],
    "Orono": ["04469", "04473"],
    "Orrington": ["04474"],
    "Orrs Island": ["04066"],
    "Owls Head": ["04854"],
    "Oxbow": ["04764"],
    "Oxford": ["04270"],
    "Palermo": ["04354"],
    "Palmyra": ["04965"],
    "Paris": ["04271"],
    "Parsonsfield": ["04047"],
    "Passadumkeag": ["04475"],
    "Patten": ["04765"],
    "Peaks Island": ["04108"],
    "Pemaquid": ["04558"],
    "Pembroke": ["04666"],
    "Penobscot": ["04476"],
    "Perham": ["04766"],
    "Perry": ["04667"],
    "Peru": ["04290"],
    "Phillips": ["04966"],
    "Phippsburg": ["04562"],
    "Pittsfield": ["04967"],
    "Plymouth": ["04969"],
    "Poland": ["04274"],
    "Port Clyde": ["04855"],
    "Portage": ["04768"],
    "Porter": ["04068"],
    "Portland": ["04101", "04102", "04103", "04104", "04109", "04112", "04122", "04123", "04124"],
    "Pownal": ["04069"],
    "Presque Isle": ["04769"],
    "Princeton": ["04668"],
    "Prospect Harbor": ["04669"],
    "Randolph": ["04346"],
    "Rangeley": ["04970"],
    "Raymond": ["04071"],
    "Readfield": ["04355"],
    "Richmond": ["04357"],
    "Robbinston": ["04671"],
    "Rockland": ["04841"],
    "Rockport": ["04856"],
    "Rockwood": ["04478"],
    "Round Pond": ["04564"],
    "Roxbury": ["04275"],
    "Rumford": ["04276"],
    "Sabattus": ["04280"],
    "Saco": ["04072"],
    "Saint Agatha": ["04772"],
    "Saint Albans": ["04971"],
    "Saint David": ["04773"],
    "Saint Francis": ["04774"],
    "Salsbury Cove": ["04672"],
    "Sandy Point": ["04972"],
    "Sanford": ["04073"],
    "Sangerville": ["04479"],
    "Sargentville": ["04673"],
    "Scarborough": ["04070", "04074"],
    "Seal Cove": ["04674"],
    "Seal Harbor": ["04675"],
    "Searsmont": ["04973"],
    "Searsport": ["04974"],
    "Sebago": ["04029"],
    "Sebago Lake": ["04075"],
    "Sebasco Estates": ["04565"],
    "Sebec": ["04481"],
    "Sedgwick": ["04676"],
    "Shapleigh": ["04076"],
    "Shawmut": ["04975"],
    "Sheridan": ["04775"],
    "Sherman": ["04776"],
    "Shirley Mills": ["04485"],
    "Sinclair": ["04779"],
    "Skowhegan": ["04976"],
    "Smithfield": ["04978"],
    "Smyrna Mills": ["04780"],
    "Solon": ["04979"],
    "Sorrento": ["04677"],
    "South Berwick": ["03908"],
    "South Bristol": ["04568"],
    "South Casco": ["04077"],
    "South China": ["04358"],
    "South Freeport": ["04078"],
    "South Gardiner": ["04359"],
    "South Paris": ["04281"],
    "South Portland": ["04106", "04116"],
    "South Thomaston": ["04858"],
    "South Windham": ["04082"],
    "Southport": ["04576"],
    "Southwest Harbor": ["04679"],
    "Springfield": ["04487"],
    "Springvale": ["04083"],
    "Spruce Head": ["04859"],
    "Squirrel Island": ["04570"],
    "Stacyville": ["04777"],
    "Standish": ["04084"],
    "Steep Falls": ["04085"],
    "Stetson": ["04488"],
    "Steuben": ["04680"],
    "Stillwater": ["04489"],
    "Stockholm": ["04783"],
    "Stockton Springs": ["04981"],
    "Stoneham": ["04231"],
    "Stonington": ["04681"],
    "Stratton": ["04982"],
    "Strong": ["04983"],
    "Sullivan": ["04664"],
    "Sumner": ["04292"],
    "Sunset": ["04683"],
    "Surry": ["04684"],
    "Swans Island": ["04685"],
    "Temple": ["04984"],
    "Tenants Harbor": ["04860"],
    "Thomaston": ["04861"],
    "Thorndike": ["04986"],
    "Topsfield": ["04490"],
    "Topsham": ["04086"],
    "Trevett": ["04571"],
    "Troy": ["04987"],
    "Turner": ["04282"],
    "Union": ["04862"],
    "Unity": ["04988"],
    "Van Buren": ["04785"],
    "Vanceboro": ["04491"],
    "Vassalboro": ["04989"],
    "Vienna": ["04360"],
    "Vinalhaven": ["04863"],
    "Waite": ["04492"],
    "Waldoboro": ["04572"],
    "Wallagrass": ["04781"],
    "Walpole": ["04573"],
    "Warren": ["04864"],
    "Washburn": ["04786"],
    "Washington": ["04574"],
    "Waterboro": ["04087"],
    "Waterford": ["04088"],
    "Waterville": ["04901", "04903"],
    "Wayne": ["04284"],
    "Weld": ["04285"],
    "Wells": ["04090"],
    "Wesley": ["04686"],
    "West Baldwin": ["04091"],
    "West Bethel": ["04286"],
    "West Boothbay Harbor": ["04575"],
    "West Enfield": ["04493"],
    "West Farmington": ["04992"],
    "West Forks": ["04985"],
    "West Kennebunk": ["04094"],
    "West Minot": ["04288"],
    "West Newfield": ["04095"],
    "West Paris": ["04289"],
    "West Poland": ["04291"],
    "West Rockport": ["04865"],
    "Westbrook": ["04092", "04098"],
    "Westfield": ["04787"],
    "Whitefield": ["04353"],
    "Whiting": ["04691"],
    "Wilton": ["04294"],
    "Windham": ["04062"],
    "Windsor": ["04363"],
    "Winn": ["04495"],
    "Winter Harbor": ["04693"],
    "Winterport": ["04496"],
    "Winthrop": ["04364"],
    "Wiscasset": ["04578"],
    "Woolwich": ["04579"],
    "Wytopitlock": ["04497"],
    "Yarmouth": ["04096"],
    "York": ["03909"],
    "York Beach": ["03910"],
    "York Harbor": ["03911"]
  },
  "MI": {
    "Acme": ["49610"],
    "Ada": ["49301", "49355", "49356", "49357"],
    "Addison": ["49220"],
    "Adrian": ["49221"],
    "Afton": ["49705"],
    "Ahmeek": ["49901"],
    "Akron": ["48701"],
    "Alanson": ["49706"],
    "Alba": ["49611"],
    "Albion": ["49224"],
    "Alden": ["49612"],
    "Alger": ["48610"],
    "Algonac": ["48001"],
    "Allegan": ["49010"],
    "Allen": ["49227"],
    "Allen Park": ["48101"],
    "Allendale": ["49401"],
    "Allenton": ["48002"],
    "Allouez": ["49805"],
    "Alma": ["48801", "48802"],
    "Almont": ["48003"],
    "Alpena": ["49707"],
    "Alpha": ["49902"],
    "Alto": ["49302"],
    "Amasa": ["49903"],
    "Anchorville": ["48004"],
    "Ann Arbor": ["48103", "48104", "48105", "48106", "48107", "48108", "48109", "48113"],
    "Applegate": ["48401"],
    "Arcadia": ["49613"],
    "Argyle": ["48410"],
    "Armada": ["48005"],
    "Arnold": ["49819"],
    "Ashley": ["48806"],
    "Athens": ["49011"],
    "Atlanta": ["49709"],
    "Atlantic Mine": ["49905"],
    "Atlas": ["48411"],
    "Attica": ["48412"],
    "Au Gres": ["48703"],
    "Au Train": ["49806"],
    "Auburn": ["48611"],
    "Auburn Hills": ["48321", "48326"],
    "Augusta": ["49012"],
    "Avoca": ["48006"],
    "Azalia": ["48110"],
    "Bad Axe": ["48413"],
    "Bailey": ["49303"],
    "Baldwin": ["49304"],
    "Bancroft": ["48414"],
    "Bangor": ["49013"],
    "Bannister": ["48807"],
    "Baraga": ["49908"],
    "Barbeau": ["49710"],
    "Bark River": ["49807"],
    "Baroda": ["49101"],
    "Barryton": ["49305"],
    "Barton City": ["48705"],
    "Bath": ["48808"],
    "Battle Creek": ["49014", "49015", "49016", "49017", "49018", "49037"],
    "Bay City": ["48706", "48707", "48708"],
    "Bay Port": ["48720"],
    "Bay Shore": ["49711"],
    "Bear Lake": ["49614"],
    "Beaver Island": ["49782"],
    "Beaverton": ["48612"],
    "Bedford": ["49020"],
    "Belding": ["48809"],
    "Bellaire": ["49615"],
    "Belleville": ["48111", "48112"],
    "Bellevue": ["49021"],
    "Belmont": ["49306"],
    "Bentley": ["48613"],
    "Benton Harbor": ["49022", "49023"],
    "Benzonia": ["49616"],
    "Bergland": ["49910"],
    "Berkley": ["48072"],
    "Berrien Center": ["49102"],
    "Berrien Springs": ["49103", "49104"],
    "Bessemer": ["49911"],
    "Beulah": ["49617"],
    "Big Bay": ["49808"],
    "Big Rapids": ["49307"],
    "Birch Run": ["48415"],
    "Birmingham": ["48009", "48012"],
    "Bitely": ["49309"],
    "Black River": ["48721"],
    "Blanchard": ["49310"],
    "Blissfield": ["49228"],
    "Bloomfield Hills": ["48301", "48302", "48303", "48304"],
    "Bloomingdale": ["49026"],
    "Boon": ["49618"],
    "Boyne City": ["49712"],
    "Boyne Falls": ["49713"],
    "Bradley": ["49311"],
    "Branch": ["49402"],
    "Brant": ["48614"],
    "Breckenridge": ["48615"],
    "Breedsville": ["49027"],
    "Brethren": ["49619"],
    "Bridgeport": ["48722"],
    "Bridgewater": ["48115"],
    "Bridgman": ["49106"],
    "Brighton": ["48114", "48116"],
    "Brimley": ["49715"],
    "Britton": ["49229"],
    "Brohman": ["49312"],
    "Bronson": ["49028"],
    "Brooklyn": ["49230"],
    "Brown City": ["48416"],
    "Bruce Crossing": ["49912"],
    "Brutus": ["49716"],
    "Buchanan": ["49107"],
    "Buckley": ["49620"],
    "Burlington": ["49029"],
    "Burnips": ["49314"],
    "Burr Oak": ["49030"],
    "Burt": ["48417"],
    "Burt Lake": ["49717"],
    "Burton": ["48509", "48519", "48529"],
    "Byron": ["48418"],
    "Byron Center": ["49315"],
    "Cadillac": ["49601"],
    "Caledonia": ["49316"],
    "Calumet": ["49913"],
    "Camden": ["49232"],
    "Cannonsburg": ["49317"],
    "Canton": ["48187", "48188"],
    "Capac": ["48014"],
    "Carleton": ["48117"],
    "Carney": ["49812"],
    "Caro": ["48723"],
    "Carp Lake": ["49718"],
    "Carrollton": ["48724"],
    "Carson City": ["48811"],
    "Carsonville": ["48419"],
    "Casco": ["48064"],
    "Caseville": ["48725"],
    "Casnovia": ["49318"],
    "Caspian": ["49915"],
    "Cass City": ["48726"],
    "Cassopolis": ["49031"],
    "Cedar": ["49621"],
    "Cedar Lake": ["48812"],
    "Cedar Springs": ["49319"],
    "Cedarville": ["49719"],
    "Cement City": ["49233"],
    "Center Line": ["48015"],
    "Central Lake": ["49622"],
    "Centreville": ["49032"],
    "Ceresco": ["49033"],
    "Champion": ["49814"],
    "Channing": ["49815"],
    "Charlevoix": ["49720"],
    "Charlotte": ["48813"],
    "Chase": ["49623"],
    "Chassell": ["49916"],
    "Chatham": ["49816"],
    "Cheboygan": ["49721"],
    "Chelsea": ["48118"],
    "Chesaning": ["48616"],
    "Chippewa Lake": ["49320"],
    "Clare": ["48617"],
    "Clarklake": ["49234"],
    "Clarkston": ["48346", "48347", "48348"],
    "Clarksville": ["48815"],
    "Clawson": ["48017"],
    "Clayton": ["49235"],
    "Clifford": ["48727"],
    "Climax": ["49034"],
    "Clinton": ["49236"],
    "Clinton Township": ["48035", "48036", "48038"],
    "Clio": ["48420"],
    "Cloverdale": ["49035"],
    "Cohoctah": ["48816"],
    "Coldwater": ["49036"],
    "Coleman": ["48618"],
    "Coloma": ["49038"],
    "Colon": ["49040"],
    "Columbiaville": ["48421"],
    "Columbus": ["48063"],
    "Comins": ["48619"],
    "Commerce Township": ["48382"],
    "Comstock": ["49041"],
    "Comstock Park": ["49321"],
    "Concord": ["49237"],
    "Conklin": ["49403"],
    "Constantine": ["49042"],
    "Conway": ["49722"],
    "Cooks": ["49817"],
    "Coopersville": ["49404"],
    "Copemish": ["49625"],
    "Copper City": ["49917"],
    "Copper Harbor": ["49918"],
    "Coral": ["49322"],
    "Cornell": ["49818"],
    "Corunna": ["48817"],
    "Covert": ["49043"],
    "Covington": ["49919"],
    "Cross Village": ["49723"],
    "Croswell": ["48422"],
    "Crystal": ["48818"],
    "Crystal Falls": ["49920"],
    "Curran": ["48728"],
    "Curtis": ["49820"],
    "Custer": ["49405"],
    "Dafter": ["49724"],
    "Daggett": ["49821"],
    "Dansville": ["48819"],
    "Davisburg": ["48350"],
    "Davison": ["48423"],
    "De Tour Village": ["49725"],
    "Dearborn": ["48120", "48121", "48123", "48124", "48126", "48128"],
    "Dearborn Heights": ["48125", "48127"],
    "Decatur": ["49045"],
    "Decker": ["48426"],
    "Deckerville": ["48427"],
    "Deerfield": ["49238"],
    "Deerton": ["49822"],
    "Deford": ["48729"],
    "Delton": ["49046"],
    "Detroit": ["48201", "48202", "48204", "48205", "48206", "48207", "48208", "48209", "48210", "48211", "48213", "48214", "48215", "48216", "48217", "48219", "48221", "48222", "48223", "48224", "48226", "48227", "48228", "48231", "48232", "48233", "48234", "48235", "48238", "48242", "48243", "48244", "48255", "48260", "48264", "48265", "48266", "48267", "48268", "48269", "48272", "48275", "48277", "48278", "48279", "48288"],
    "Dewitt": ["48820"],
    "Dexter": ["48130"],
    "Dimondale": ["48821"],
    "Dodgeville": ["49921"],
    "Dollar Bay": ["49922"],
    "Dorr": ["49323"],
    "Douglas": ["49406"],
    "Dowagiac": ["49047"],
    "Dowling": ["49050"],
    "Drayton Plains": ["48330"],
    "Drummond Island": ["49726"],
    "Dryden": ["48428"],
    "Dundee": ["48131"],
    "Durand": ["48429"],
    "Eagle": ["48822"],
    "East China": ["48054"],
    "East Jordan": ["49727"],
    "East Lansing": ["48823", "48824", "48825", "48826"],
    "East Leroy": ["49051"],
    "East Tawas": ["48730"],
    "Eastlake": ["49626"],
    "Eastpointe": ["48021"],
    "Eastport": ["49627"],
    "Eaton Rapids": ["48827"],
    "Eau Claire": ["49111"],
    "Eben Junction": ["49825"],
    "Eckerman": ["49728", "49790"],
    "Ecorse": ["48229"],
    "Edenville": ["48620"],
    "Edmore": ["48829"],
    "Edwardsburg": ["49112"],
    "Elberta": ["49628"],
    "Elk Rapids": ["49629"],
    "Elkton": ["48731"],
    "Ellsworth": ["49729"],
    "Elm Hall": ["48830"],
    "Elmira": ["49730"],
    "Elsie": ["48831"],
    "Elwell": ["48832"],
    "Emmett": ["48022"],
    "Empire": ["49630"],
    "Engadine": ["49827"],
    "Erie": ["48133"],
    "Escanaba": ["49829"],
    "Essexville": ["48732"],
    "Eureka": ["48833"],
    "Evart": ["49631"],
    "Ewen": ["49925"],
    "Fair Haven": ["48023"],
    "Fairgrove": ["48733"],
    "Fairview": ["48621"],
    "Falmouth": ["49632"],
    "Farmington": ["48331", "48332", "48333", "48334", "48335", "48336"],
    "Farwell": ["48622"],
    "Felch": ["49831"],
    "Fennville": ["49408"],
    "Fenton": ["48430"],
    "Fenwick": ["48834"],
    "Ferndale": ["48220"],
    "Ferrysburg": ["49409"],
    "Fife Lake": ["49633"],
    "Filer City": ["49634"],
    "Filion": ["48432"],
    "Flat Rock": ["48134"],
    "Flint": ["48501", "48502", "48503", "48504", "48505", "48506", "48507", "48531", "48532", "48550", "48551", "48552", "48553", "48554", "48555", "48556", "48557", "48559"],
    "Flushing": ["48433"],
    "Forestville": ["48434"],
    "Fort Gratiot": ["48059"],
    "Foster City": ["49834"],
    "Fostoria": ["48435"],
    "Fountain": ["49410"],
    "Fowler": ["48835"],
    "Fowlerville": ["48836"],
    "Frankenmuth": ["48734", "48787"],
    "Frankfort": ["49635"],
    "Franklin": ["48025"],
    "Fraser": ["48026"],
    "Frederic": ["49733"],
    "Free Soil": ["49411"],
    "Freeland": ["48623"],
    "Freeport": ["49325"],
    "Fremont": ["49412", "49413"],
    "Frontier": ["49239"],
    "Fruitport": ["49415"],
    "Fulton": ["49052"],
    "Gaastra": ["49927"],
    "Gagetown": ["48735"],
    "Gaines": ["48436"],
    "Galesburg": ["49053"],
    "Galien": ["49113"],
    "Garden": ["49835"],
    "Garden City": ["48135", "48136"],
    "Gaylord": ["49734", "49735"],
    "Genesee": ["48437"],
    "Germfask": ["49836"],
    "Gilford": ["48736"],
    "Gladstone": ["49837"],
    "Gladwin": ["48624"],
    "Glen Arbor": ["49636"],
    "Glenn": ["49416"],
    "Glennie": ["48737"],
    "Gobles": ["49055"],
    "Goetzville": ["49736"],
    "Good Hart": ["49737"],
    "Goodells": ["48027"],
    "Goodrich": ["48438"],
    "Gould City": ["49838"],
    "Gowen": ["49326"],
    "Grand Blanc": ["48439", "48480"],
    "Grand Haven": ["49417"],
    "Grand Junction": ["49056"],
    "Grand Ledge": ["48837"],
    "Grand Marais": ["49839"],
    "Grand Rapids": ["49501", "49502", "49503", "49504", "49505", "49506", "49507", "49508", "49510", "49512", "49514", "49515", "49516", "49518", "49523", "49525", "49528", "49530", "49534", "49544", "49546", "49548", "49550", "49555", "49560", "49588", "49599"],
    "Grandville": ["49418", "49468"],
    "Grant": ["49327"],
    "Grass Lake": ["49240"],
    "Grawn": ["49637"],
    "Grayling": ["49738", "49739"],
    "Greenbush": ["48738"],
    "Greenland": ["49929"],
    "Greenville": ["48838"],
    "Gregory": ["48137"],
    "Grosse Ile": ["48138"],
    "Grosse Pointe": ["48230", "48236"],
    "Gulliver": ["49840"],
    "Gwinn": ["49841"],
    "Hadley": ["48440"],
    "Hagar Shores": ["49039"],
    "Hale": ["48739"],
    "Hamburg": ["48139"],
    "Hamilton": ["49419"],
    "Hamtramck": ["48212"],
    "Hancock": ["49930"],
    "Hanover": ["49241"],
    "Harbert": ["49115"],
    "Harbor Beach": ["48441"],
    "Harbor Springs": ["49740"],
    "Harper Woods": ["48225"],
    "Harrietta": ["49638"],
    "Harris": ["49845"],
    "Harrison": ["48625"],
    "Harrison Township": ["48045"],
    "Harrisville": ["48740"],
    "Harsens Island": ["48028"],
    "Hart": ["49420"],
    "Hartford": ["49057"],
    "Hartland": ["48353"],
    "Haslett": ["48840"],
    "Hastings": ["49058"],
    "Hawks": ["49743"],
    "Hazel Park": ["48030"],
    "Hemlock": ["48626"],
    "Henderson": ["48841"],
    "Hermansville": ["49847"],
    "Herron": ["49744"],
    "Hersey": ["49639"],
    "Hesperia": ["49421"],
    "Hessel": ["49745"],
    "Hickory Corners": ["49060"],
    "Higgins Lake": ["48627"],
    "Highland": ["48356", "48357"],
    "Highland Park": ["48203"],
    "Hillman": ["49746"],
    "Hillsdale": ["49242"],
    "Holland": ["49422", "49423", "49424"],
    "Holly": ["48442"],
    "Holt": ["48842"],
    "Holton": ["49425"],
    "Homer": ["49245"],
    "Honor": ["49640"],
    "Hope": ["48628"],
    "Hopkins": ["49328"],
    "Horton": ["49246"],
    "Houghton": ["49931"],
    "Houghton Lake": ["48629"],
    "Houghton Lake Heights": ["48630"],
    "Howard City": ["49329"],
    "Howell": ["48843", "48844", "48855", "48863"],
    "Hubbard Lake": ["49747"],
    "Hubbardston": ["48845"],
    "Hubbell": ["49934"],
    "Hudson": ["49247"],
    "Hudsonville": ["49426"],
    "Hulbert": ["49748"],
    "Huntington Woods": ["48070"],
    "Ida": ["48140"],
    "Idlewild": ["49642"],
    "Imlay City": ["48444"],
    "Indian River": ["49749"],
    "Ingalls": ["49848"],
    "Inkster": ["48141"],
    "Interlochen": ["49643"],
    "Ionia": ["48846"],
    "Iron Mountain": ["49801"],
    "Iron River": ["49935"],
    "Irons": ["49644"],
    "Ironwood": ["49938"],
    "Ishpeming": ["49849"],
    "Ithaca": ["48847"],
    "Jackson": ["49201", "49202", "49203", "49204"],
    "Jamestown": ["49427"],
    "Jasper": ["49248"],
    "Jeddo": ["48032"],
    "Jenison": ["49428", "49429"],
    "Jerome": ["49249"],
    "Johannesburg": ["49751"],
    "Jones": ["49061"],
    "Jonesville": ["49250"],
    "Kalamazoo": ["49001", "49003", "49004", "49005", "49006", "49007", "49008", "49009", "49019", "49048"],
    "Kaleva": ["49645"],
    "Kalkaska": ["49646"],
    "Kawkawlin": ["48631"],
    "Kearsarge": ["49942"],
    "Keego Harbor": ["48320"],
    "Kendall": ["49062"],
    "Kent City": ["49330"],
    "Kewadin": ["49648"],
    "Kincheloe": ["49784", "49785", "49786", "49788"],
    "Kinde": ["48445"],
    "Kingsford": ["49802"],
    "Kingsley": ["49649"],
    "Kingston": ["48741"],
    "Kinross": ["49752"],
    "La Salle": ["48145"],
    "Lachine": ["49753"],
    "Lacota": ["49063"],
    "Laingsburg": ["48848"],
    "Lake": ["48632"],
    "Lake Ann": ["49650"],
    "Lake City": ["49651"],
    "Lake George": ["48633"],
    "Lake Leelanau": ["49653"],
    "Lake Linden": ["49945"],
    "Lake Odessa": ["48849"],
    "Lake Orion": ["48359", "48360", "48361", "48362"],
    "Lakeland": ["48143"],
    "Lakeside": ["49116"],
    "Lakeview": ["48850"],
    "Lakeville": ["48366"],
    "Lambertville": ["48144"],
    "Lamont": ["49430"],
    "Lanse": ["49946"],
    "Lansing": ["48901", "48906", "48908", "48909", "48910", "48911", "48912", "48913", "48915", "48916", "48917", "48918", "48919", "48921", "48922", "48924", "48929", "48930", "48933", "48937", "48950", "48951", "48956", "48980"],
    "Lapeer": ["48446"],
    "Lawrence": ["49064"],
    "Lawton": ["49065"],
    "Leland": ["49654"],
    "Lennon": ["48449"],
    "Leonard": ["48367"],
    "Leonidas": ["49066"],
    "Leroy": ["49655"],
    "Leslie": ["49251"],
    "Levering": ["49755"],
    "Lewiston": ["49756"],
    "Lexington": ["48450"],
    "Lincoln": ["48742"],
    "Lincoln Park": ["48146"],
    "Linden": ["48451"],
    "Linwood": ["48634"],
    "Litchfield": ["49252"],
    "Little Lake": ["49833"],
    "Livonia": ["48150", "48151", "48152", "48153", "48154"],
    "Long Lake": ["48743"],
    "Loretto": ["49852"],
    "Lowell": ["49331"],
    "Ludington": ["49431"],
    "Luna Pier": ["48157"],
    "Lupton": ["48635"],
    "Luther": ["49656"],
    "Luzerne": ["48636"],
    "Lyons": ["48851"],
    "Macatawa": ["49434"],
    "Mackinac Island": ["49757"],
    "Mackinaw City": ["49701"],
    "Macomb": ["48042", "48044"],
    "Madison Heights": ["48071"],
    "Mancelona": ["49659"],
    "Manchester": ["48158"],
    "Manistee": ["49660"],
    "Manistique": ["49854"],
    "Manitou Beach": ["49253"],
    "Manton": ["49663"],
    "Maple City": ["49664"],
    "Maple Rapids": ["48853"],
    "Marcellus": ["49067"],
    "Marenisco": ["49947"],
    "Marine City": ["48039"],
    "Marion": ["49665"],
    "Marlette": ["48453"],
    "Marne": ["49435"],
    "Marquette": ["49855"],
    "Marshall": ["49068", "49069"],
    "Martin": ["49070"],
    "Marysville": ["48040"],
    "Mason": ["48854"],
    "Mass City": ["49948"],
    "Mattawan": ["49071"],
    "Maybee": ["48159"],
    "Mayfield": ["49666"],
    "Mayville": ["48744"],
    "Mc Bain": ["49657"],
    "Mc Millan": ["49853"],
    "Mcbrides": ["48852"],
    "Mears": ["49436"],
    "Mecosta": ["49332"],
    "Melvin": ["48454"],
    "Melvindale": ["48122"],
    "Memphis": ["48041"],
    "Mendon": ["49072"],
    "Menominee": ["49858"],
    "Merrill": ["48637"],
    "Merritt": ["49667"],
    "Mesick": ["49668"],
    "Metamora": ["48455"],
    "Michigamme": ["49861"],
    "Michigan Center": ["49254"],
    "Middleton": ["48856"],
    "Middleville": ["49333"],
    "Midland": ["48640", "48641", "48642", "48667", "48670", "48674", "48686"],
    "Mikado": ["48745"],
    "Milan": ["48160"],
    "Milford": ["48380", "48381"],
    "Millersburg": ["49759"],
    "Millington": ["48746"],
    "Minden City": ["48456"],
    "Mio": ["48647"],
    "Mohawk": ["49950"],
    "Moline": ["49335"],
    "Monroe": ["48161", "48162"],
    "Montague": ["49437"],
    "Montgomery": ["49255"],
    "Montrose": ["48457"],
    "Moran": ["49760"],
    "Morenci": ["49256"],
    "Morley": ["49336"],
    "Morrice": ["48857"],
    "Moscow": ["49257"],
    "Mosherville": ["49258"],
    "Mount Clemens": ["48043", "48046"],
    "Mount Morris": ["48458"],
    "Mount Pleasant": ["48804", "48858", "48859"],
    "Muir": ["48860"],
    "Mullett Lake": ["49761"],
    "Mulliken": ["48861"],
    "Munger": ["48747"],
    "Munising": ["49862"],
    "Munith": ["49259"],
    "Muskegon": ["49440", "49441", "49442", "49443", "49444", "49445"],
    "Nadeau": ["49863"],
    "Nahma": ["49864"],
    "Napoleon": ["49261"],
    "Nashville": ["49073"],
    "National City": ["48748"],
    "National Mine": ["49865"],
    "Naubinway": ["49762"],
    "Nazareth": ["49074"],
    "Negaunee": ["49866"],
    "New Baltimore": ["48047", "48051"],
    "New Boston": ["48164"],
    "New Buffalo": ["49117"],
    "New Era": ["49446"],
    "New Haven": ["48048", "48050"],
    "New Hudson": ["48165"],
    "New Lothrop": ["48460"],
    "New Troy": ["49119"],
    "Newaygo": ["49337"],
    "Newberry": ["49868"],
    "Newport": ["48166"],
    "Niles": ["49120", "49121"],
    "Nisula": ["49952"],
    "North Adams": ["49262"],
    "North Branch": ["48461"],
    "North Star": ["48862"],
    "North Street": ["48049"],
    "Northport": ["49670"],
    "Northville": ["48167", "48168"],
    "Norvell": ["49263"],
    "Norway": ["49870"],
    "Nottawa": ["49075"],
    "Novi": ["48374", "48375", "48376", "48377"],
    "Nunica": ["49448"],
    "Oak Park": ["48237"],
    "Oakland": ["48363"],
    "Oakley": ["48649"],
    "Oden": ["49764"],
    "Okemos": ["48805", "48864"],
    "Old Mission": ["49673"],
    "Olivet": ["49076"],
    "Omena": ["49674"],
    "Omer": ["48749"],
    "Onaway": ["49765"],
    "Onekama": ["49675"],
    "Onondaga": ["49264"],
    "Onsted": ["49265"],
    "Ontonagon": ["49953"],
    "Orleans": ["48865"],
    "Ortonville": ["48462"],
    "Oscoda": ["48750"],
    "Oshtemo": ["49077"],
    "Osseo": ["49266"],
    "Ossineke": ["49766"],
    "Otisville": ["48463"],
    "Otsego": ["49078"],
    "Ottawa Lake": ["49267"],
    "Otter Lake": ["48464"],
    "Ovid": ["48866"],
    "Owendale": ["48754"],
    "Owosso": ["48867"],
    "Oxford": ["48370", "48371"],
    "Painesdale": ["49955"],
    "Palmer": ["49871"],
    "Palms": ["48465"],
    "Palmyra": ["49268"],
    "Palo": ["48870"],
    "Paradise": ["49768"],
    "Paris": ["49338"],
    "Parma": ["49269"],
    "Paw Paw": ["49079"],
    "Peck": ["48466"],
    "Pelkie": ["49958"],
    "Pellston": ["49769"],
    "Pentwater": ["49449"],
    "Perkins": ["49872"],
    "Perrinton": ["48871"],
    "Perronville": ["49873"],
    "Perry": ["48872"],
    "Petersburg": ["49270"],
    "Petoskey": ["49770"],
    "Pewamo": ["48873"],
    "Pickford": ["49774"],
    "Pierson": ["49339"],
    "Pigeon": ["48755"],
    "Pinckney": ["48169"],
    "Pinconning": ["48650"],
    "Pittsford": ["49271"],
    "Plainwell": ["49080"],
    "Pleasant Lake": ["49272"],
    "Pleasant Ridge": ["48069"],
    "Plymouth": ["48170"],
    "Pointe Aux Pins": ["49775"],
    "Pompeii": ["48874"],
    "Pontiac": ["48340", "48341", "48342", "48343"],
    "Port Austin": ["48467"],
    "Port Hope": ["48468"],
    "Port Huron": ["48060", "48061"],
    "Port Sanilac": ["48469"],
    "Portage": ["49002", "49024", "49081"],
    "Portland": ["48875"],
    "Posen": ["49776"],
    "Potterville": ["48876"],
    "Powers": ["49874"],
    "Prescott": ["48756"],
    "Presque Isle": ["49777"],
    "Prudenville": ["48651"],
    "Pullman": ["49450"],
    "Quincy": ["49082"],
    "Quinnesec": ["49876"],
    "Ralph": ["49877"],
    "Ramsay": ["49959"],
    "Rapid City": ["49676"],
    "Rapid River": ["49878"],
    "Ravenna": ["49451"],
    "Ray": ["48096"],
    "Reading": ["49274"],
    "Redford": ["48239", "48240"],
    "Reed City": ["49677"],
    "Reese": ["48757"],
    "Remus": ["49340"],
    "Republic": ["49879"],
    "Rhodes": ["48652"],
    "Richland": ["49083"],
    "Richmond": ["48062"],
    "Richville": ["48758"],
    "Riga": ["49276"],
    "River Rouge": ["48218"],
    "Riverdale": ["48877"],
    "Riverside": ["49084"],
    "Riverview": ["48193"],
    "Rives Junction": ["49277"],
    "Rochester": ["48306", "48307", "48308", "48309"],
    "Rock": ["49880"],
    "Rockford": ["49341", "49351"],
    "Rockland": ["49960"],
    "Rockwood": ["48173"],
    "Rodney": ["49342"],
    "Rogers City": ["49779"],
    "Romeo": ["48065"],
    "Romulus": ["48174"],
    "Roscommon": ["48653"],
    "Rose City": ["48654"],
    "Rosebush": ["48878"],
    "Roseville": ["48066"],
    "Rothbury": ["49452"],
    "Royal Oak": ["48067", "48068", "48073"],
    "Rudyard": ["49780"],
    "Rumely": ["49826"],
    "Ruth": ["48470"],
    "Saginaw": ["48601", "48602", "48603", "48604", "48605", "48606", "48607", "48608", "48609", "48638", "48663"],
    "Sagola": ["49881"],
    "Saint Charles": ["48655"],
    "Saint Clair": ["48079"],
    "Saint Clair Shores": ["48080", "48081", "48082"],
    "Saint Helen": ["48656"],
    "Saint Ignace": ["49781"],
    "Saint Johns": ["48879"],
    "Saint Joseph": ["49085"],
    "Saint Louis": ["48880"],
    "Salem": ["48175"],
    "Saline": ["48176"],
    "Samaria": ["48177"],
    "Sand Creek": ["49279"],
    "Sand Lake": ["49343"],
    "Sandusky": ["48471"],
    "Sanford": ["48657"],
    "Saranac": ["48881"],
    "Saugatuck": ["49453"],
    "Sault Sainte Marie": ["49783"],
    "Sawyer": ["49125"],
    "Schoolcraft": ["49087"],
    "Scotts": ["49088"],
    "Scottville": ["49454"],
    "Sears": ["49679"],
    "Sebewaing": ["48759"],
    "Seney": ["49883"],
    "Shaftsburg": ["48882"],
    "Shelby": ["49455"],
    "Shelbyville": ["49344"],
    "Shepherd": ["48883"],
    "Sheridan": ["48884"],
    "Sherwood": ["49089"],
    "Shingleton": ["49884"],
    "Sidnaw": ["49961"],
    "Sidney": ["48885"],
    "Silverwood": ["48760"],
    "Six Lakes": ["48886"],
    "Skandia": ["49885"],
    "Skanee": ["49962"],
    "Smiths Creek": ["48074"],
    "Smyrna": ["48887"],
    "Snover": ["48472"],
    "Sodus": ["49126"],
    "Somerset": ["49281"],
    "Somerset Center": ["49282"],
    "South Boardman": ["49680"],
    "South Branch": ["48761"],
    "South Haven": ["49090"],
    "South Lyon": ["48178"],
    "South Range": ["49963"],
    "South Rockwood": ["48179"],
    "Southfield": ["48033", "48034", "48037", "48075", "48076", "48086"],
    "Southgate": ["48195"],
    "Spalding": ["49886"],
    "Sparta": ["49345"],
    "Spring Arbor": ["49283"],
    "Spring Lake": ["49456"],
    "Springport": ["49284"],
    "Spruce": ["48762"],
    "Stambaugh": ["49964"],
    "Standish": ["48658"],
    "Stanton": ["48888"],
    "Stanwood": ["49346"],
    "Stephenson": ["49887"],
    "Sterling": ["48659"],
    "Sterling Heights": ["48310", "48311", "48312", "48313", "48314"],
    "Stevensville": ["49127"],
    "Stockbridge": ["49285"],
    "Sturgis": ["49091"],
    "Sumner": ["48889"],
    "Sunfield": ["48890"],
    "Suttons Bay": ["49682"],
    "Swartz Creek": ["48473"],
    "Sylvan Beach": ["49463"],
    "Tawas City": ["48763", "48764"],
    "Taylor": ["48180"],
    "Tecumseh": ["49286"],
    "Tekonsha": ["49092"],
    "Temperance": ["48182"],
    "Thompsonville": ["49683"],
    "Three Oaks": ["49128"],
    "Three Rivers": ["49093"],
    "Tipton": ["49287"],
    "Toivola": ["49965"],
    "Topinabee": ["49791"],
    "Tower": ["49792"],
    "Traverse City": ["49684", "49685", "49686", "49696"],
    "Trenary": ["49891"],
    "Trenton": ["48183"],
    "Trout Creek": ["49967"],
    "Trout Lake": ["49793"],
    "Troy": ["48007", "48083", "48084", "48085", "48098", "48099"],
    "Trufant": ["49347"],
    "Turner": ["48765"],
    "Tustin": ["49688"],
    "Twin Lake": ["49457"],
    "Twining": ["48766"],
    "Ubly": ["48475"],
    "Union": ["49130"],
    "Union City": ["49094"],
    "Union Lake": ["48387"],
    "Union Pier": ["49129"],
    "Unionville": ["48767"],
    "University Center": ["48710"],
    "Utica": ["48315", "48316", "48317", "48318"],
    "Vandalia": ["49095"],
    "Vanderbilt": ["49795"],
    "Vassar": ["48768", "48769"],
    "Vermontville": ["49096"],
    "Vernon": ["48476"],
    "Vestaburg": ["48891"],
    "Vicksburg": ["49097"],
    "Vulcan": ["49892"],
    "Wakefield": ["49968"],
    "Waldron": ["49288"],
    "Walhalla": ["49458"],
    "Walkerville": ["49459"],
    "Wallace": ["49893"],
    "Walled Lake": ["48390", "48391"],
    "Walloon Lake": ["49796"],
    "Warren": ["48088", "48089", "48090", "48091", "48092", "48093", "48397"],
    "Washington": ["48094", "48095"],
    "Waterford": ["48327", "48328", "48329"],
    "Waters": ["49797"],
    "Watersmeet": ["49969"],
    "Watervliet": ["49098"],
    "Watton": ["49970"],
    "Wayland": ["49348"],
    "Wayne": ["48184"],
    "Webberville": ["48892"],
    "Weidman": ["48893"],
    "Wells": ["49894"],
    "Wellston": ["49689"],
    "West Bloomfield": ["48322", "48323", "48324", "48325"],
    "West Branch": ["48661"],
    "West Olive": ["49460"],
    "Westland": ["48185", "48186"],
    "Weston": ["49289"],
    "Westphalia": ["48894"],
    "Wetmore": ["49895"],
    "Wheeler": ["48662"],
    "White Cloud": ["49349"],
    "White Lake": ["48383", "48386"],
    "White Pigeon": ["49099"],
    "White Pine": ["49971"],
    "Whitehall": ["49461"],
    "Whitmore Lake": ["48189"],
    "Whittaker": ["48190"],
    "Whittemore": ["48770"],
    "Williamsburg": ["49690"],
    "Williamston": ["48895"],
    "Willis": ["48191"],
    "Wilson": ["49896"],
    "Winn": ["48896"],
    "Wixom": ["48393"],
    "Wolverine": ["49799"],
    "Woodland": ["48897"],
    "Wyandotte": ["48192"],
    "Wyoming": ["49509", "49519"],
    "Yale": ["48097"],
    "Ypsilanti": ["48197", "48198"],
    "Zeeland": ["49464"]
  },
  "MN": {
    "Ada": ["56510"],
    "Adams": ["55909"],
    "Adolph": ["55701"],
    "Adrian": ["56110"],
    "Afton": ["55001"],
    "Ah Gwah Ching": ["56430"],
    "Aitkin": ["56431"],
    "Akeley": ["56433"],
    "Albany": ["56307"],
    "Albert Lea": ["56007"],
    "Alberta": ["56207"],
    "Albertville": ["55301"],
    "Alborn": ["55702"],
    "Alden": ["56009"],
    "Aldrich": ["56434"],
    "Alexandria": ["56308"],
    "Almelund": ["55002"],
    "Alpha": ["56111"],
    "Altura": ["55910"],
    "Alvarado": ["56710"],
    "Amboy": ["56010"],
    "Andover": ["55304"],
    "Angle Inlet": ["56711"],
    "Angora": ["55703"],
    "Annandale": ["55302"],
    "Anoka": ["55303"],
    "Appleton": ["56208"],
    "Arco": ["56113"],
    "Argyle": ["56713"],
    "Arlington": ["55307"],
    "Ashby": ["56309"],
    "Askov": ["55704"],
    "Atwater": ["56209"],
    "Audubon": ["56511"],
    "Aurora": ["55705"],
    "Austin": ["55912"],
    "Avoca": ["56114"],
    "Avon": ["56310"],
    "Babbitt": ["55706"],
    "Backus": ["56435"],
    "Badger": ["56714"],
    "Bagley": ["56621"],
    "Balaton": ["56115"],
    "Barnesville": ["56514"],
    "Barnum": ["55707"],
    "Barrett": ["56311"],
    "Barry": ["56210"],
    "Battle Lake": ["56515"],
    "Baudette": ["56623"],
    "Baxter": ["56425"],
    "Bayport": ["55003"],
    "Beardsley": ["56211"],
    "Beaver Bay": ["55601"],
    "Beaver Creek": ["56116"],
    "Becker": ["55308"],
    "Bejou": ["56516"],
    "Belgrade": ["56312"],
    "Belle Plaine": ["56011"],
    "Bellingham": ["56212"],
    "Beltrami": ["56517"],
    "Belview": ["56214"],
    "Bemidji": ["56601", "56619"],
    "Bena": ["56626"],
    "Benedict": ["56436"],
    "Benson": ["56215"],
    "Bertha": ["56437"],
    "Bethel": ["55005"],
    "Big Falls": ["56627"],
    "Big Lake": ["55309"],
    "Bigelow": ["56117"],
    "Bigfork": ["56628"],
    "Bingham Lake": ["56118"],
    "Birchdale": ["56629"],
    "Bird Island": ["55310"],
    "Biwabik": ["55708"],
    "Blackduck": ["56630"],
    "Blomkest": ["56216"],
    "Blooming Prairie": ["55917"],
    "Blue Earth": ["56013"],
    "Bluffton": ["56518"],
    "Bock": ["56313"],
    "Borup": ["56519"],
    "Bovey": ["55709"],
    "Bowlus": ["56314"],
    "Bowstring": ["56631"],
    "Boyd": ["56218"],
    "Braham": ["55006"],
    "Brainerd": ["56401"],
    "Brandon": ["56315"],
    "Breckenridge": ["56520"],
    "Brewster": ["56119"],
    "Bricelyn": ["56014"],
    "Brimson": ["55602"],
    "Britt": ["55710"],
    "Brook Park": ["55007"],
    "Brooks": ["56715"],
    "Brookston": ["55711"],
    "Brooten": ["56316"],
    "Browerville": ["56438"],
    "Browns Valley": ["56219"],
    "Brownsdale": ["55918"],
    "Brownsville": ["55919"],
    "Brownton": ["55312"],
    "Bruno": ["55712"],
    "Buckman": ["56317"],
    "Buffalo": ["55313"],
    "Buffalo Lake": ["55314"],
    "Buhl": ["55713"],
    "Burnsville": ["55306", "55337"],
    "Burtrum": ["56318"],
    "Butterfield": ["56120"],
    "Byron": ["55920"],
    "Caledonia": ["55921"],
    "Callaway": ["56521"],
    "Calumet": ["55716"],
    "Cambridge": ["55008"],
    "Campbell": ["56522"],
    "Canby": ["56220"],
    "Cannon Falls": ["55009"],
    "Canton": ["55922"],
    "Canyon": ["55717"],
    "Carlos": ["56319"],
    "Carlton": ["55718"],
    "Carver": ["55315"],
    "Cass Lake": ["56633"],
    "Castle Rock": ["55010"],
    "Cedar": ["55011"],
    "Center City": ["55012"],
    "Ceylon": ["56121"],
    "Champlin": ["55316"],
    "Chandler": ["56122"],
    "Chanhassen": ["55317"],
    "Chaska": ["55318"],
    "Chatfield": ["55923"],
    "Chisago City": ["55013"],
    "Chisholm": ["55719"],
    "Chokio": ["56221"],
    "Circle Pines": ["55014"],
    "Clara City": ["56222"],
    "Claremont": ["55924"],
    "Clarissa": ["56440"],
    "Clarkfield": ["56223"],
    "Clarks Grove": ["56016"],
    "Clear Lake": ["55319"],
    "Clearbrook": ["56634"],
    "Clearwater": ["55320"],
    "Clements": ["56224"],
    "Cleveland": ["56017"],
    "Climax": ["56523"],
    "Clinton": ["56225"],
    "Clitherall": ["56524"],
    "Clontarf": ["56226"],
    "Cloquet": ["55720"],
    "Cohasset": ["55721"],
    "Cokato": ["55321"],
    "Cold Spring": ["56320"],
    "Coleraine": ["55722"],
    "Collegeville": ["56321"],
    "Cologne": ["55322"],
    "Comfrey": ["56019"],
    "Comstock": ["56525"],
    "Conger": ["56020"],
    "Cook": ["55723"],
    "Correll": ["56227"],
    "Cosmos": ["56228"],
    "Cottage Grove": ["55016"],
    "Cotton": ["55724"],
    "Cottonwood": ["56229"],
    "Courtland": ["56021"],
    "Crane Lake": ["55725"],
    "Cromwell": ["55726"],
    "Crookston": ["56716"],
    "Crosby": ["56441"],
    "Crosslake": ["56442"],
    "Crystal Bay": ["55323"],
    "Currie": ["56123"],
    "Cushing": ["56443"],
    "Cyrus": ["56323"],
    "Dakota": ["55925"],
    "Dalbo": ["55017"],
    "Dalton": ["56324"],
    "Danube": ["56230"],
    "Danvers": ["56231"],
    "Darfur": ["56022"],
    "Darwin": ["55324"],
    "Dassel": ["55325"],
    "Dawson": ["56232"],
    "Dayton": ["55327"],
    "Deer Creek": ["56527"],
    "Deer River": ["56636"],
    "Deerwood": ["56444"],
    "Delano": ["55328"],
    "Delavan": ["56023"],
    "Dennison": ["55018"],
    "Dent": ["56528"],
    "Detroit Lakes": ["56501", "56502"],
    "Dexter": ["55926"],
    "Dilworth": ["56529"],
    "Dodge Center": ["55927"],
    "Donaldson": ["56720"],
    "Donnelly": ["56235"],
    "Dover": ["55929"],
    "Dovray": ["56125"],
    "Duluth": ["55801", "55802", "55803", "55804", "55805", "55806", "55807", "55808", "55810", "55811", "55812", "55814", "55815", "55816"],
    "Dumont": ["56236"],
    "Dundas": ["55019"],
    "Dunnell": ["56127"],
    "Eagle Bend": ["56446"],
    "Eagle Lake": ["56024"],
    "East Grand Forks": ["56721"],
    "Easton": ["56025"],
    "Echo": ["56237"],
    "Eden Prairie": ["55344", "55346", "55347"],
    "Eden Valley": ["55329"],
    "Edgerton": ["56128"],
    "Effie": ["56639"],
    "Eitzen": ["55931"],
    "Elbow Lake": ["56531"],
    "Elgin": ["55932"],
    "Elizabeth": ["56533"],
    "Elk River": ["55330"],
    "Elko New Market": ["55020", "55054"],
    "Elkton": ["55933"],
    "Ellendale": ["56026"],
    "Ellsworth": ["56129"],
    "Elmore": ["56027"],
    "Elrosa": ["56325"],
    "Ely": ["55731"],
    "Elysian": ["56028"],
    "Embarrass": ["55732"],
    "Emily": ["56447"],
    "Emmons": ["56029"],
    "Erhard": ["56534"],
    "Erskine": ["56535"],
    "Esko": ["55733"],
    "Essig": ["56030"],
    "Euclid": ["56722"],
    "Evansville": ["56326"],
    "Eveleth": ["55734"],
    "Excelsior": ["55331"],
    "Eyota": ["55934"],
    "Fairfax": ["55332"],
    "Fairmont": ["56031"],
    "Faribault": ["55021"],
    "Farmington": ["55024"],
    "Farwell": ["56327"],
    "Federal Dam": ["56641"],
    "Felton": ["56536"],
    "Fergus Falls": ["56537", "56538"],
    "Fertile": ["56540"],
    "Fifty Lakes": ["56448"],
    "Finland": ["55603"],
    "Finlayson": ["55735"],
    "Fisher": ["56723"],
    "Flensburg": ["56328"],
    "Flom": ["56541"],
    "Floodwood": ["55736"],
    "Foley": ["56329"],
    "Forbes": ["55738"],
    "Forest Lake": ["55025"],
    "Foreston": ["56330"],
    "Fort Ripley": ["56449"],
    "Fosston": ["56542"],
    "Fountain": ["55935"],
    "Foxhome": ["56543"],
    "Franklin": ["55333"],
    "Frazee": ["56544"],
    "Freeborn": ["56032"],
    "Freeport": ["56331"],
    "Frontenac": ["55026"],
    "Frost": ["56033"],
    "Fulda": ["56131"],
    "Garden City": ["56034"],
    "Garfield": ["56332"],
    "Garrison": ["56450"],
    "Garvin": ["56132"],
    "Gary": ["56545"],
    "Gatzke": ["56724"],
    "Gaylord": ["55334"],
    "Geneva": ["56035"],
    "Georgetown": ["56546"],
    "Ghent": ["56239"],
    "Gibbon": ["55335"],
    "Gilbert": ["55741"],
    "Gilman": ["56333"],
    "Glencoe": ["55336"],
    "Glenville": ["56036"],
    "Glenwood": ["56334"],
    "Glyndon": ["56547"],
    "Gonvick": ["56644"],
    "Good Thunder": ["56037"],
    "Goodhue": ["55027"],
    "Goodland": ["55742"],
    "Goodridge": ["56725"],
    "Graceville": ["56240"],
    "Granada": ["56039"],
    "Grand Marais": ["55604"],
    "Grand Meadow": ["55936"],
    "Grand Portage": ["55605"],
    "Grand Rapids": ["55730", "55744", "55745"],
    "Grandy": ["55029"],
    "Granite Falls": ["56241"],
    "Grasston": ["55030"],
    "Green Isle": ["55338"],
    "Greenbush": ["56726"],
    "Greenwald": ["56335"],
    "Grey Eagle": ["56336"],
    "Grove City": ["56243"],
    "Grygla": ["56727"],
    "Gully": ["56646"],
    "Hackensack": ["56452"],
    "Hallock": ["56728"],
    "Halma": ["56729"],
    "Halstad": ["56548"],
    "Hamburg": ["55339"],
    "Hamel": ["55340"],
    "Hampton": ["55031"],
    "Hancock": ["56244"],
    "Hanley Falls": ["56245"],
    "Hanover": ["55341"],
    "Hanska": ["56041"],
    "Hardwick": ["56134"],
    "Harmony": ["55939"],
    "Harris": ["55032"],
    "Hartland": ["56042"],
    "Hastings": ["55033"],
    "Hawley": ["56549"],
    "Hayfield": ["55940"],
    "Hayward": ["56043"],
    "Hector": ["55342"],
    "Henderson": ["56044"],
    "Hendricks": ["56136"],
    "Hendrum": ["56550"],
    "Henning": ["56551"],
    "Henriette": ["55036"],
    "Herman": ["56248"],
    "Heron Lake": ["56137"],
    "Hewitt": ["56453"],
    "Hibbing": ["55746", "55747"],
    "Hill City": ["55748"],
    "Hillman": ["56338"],
    "Hills": ["56138"],
    "Hinckley": ["55037"],
    "Hines": ["56647"],
    "Hitterdal": ["56552"],
    "Hoffman": ["56339"],
    "Hokah": ["55941"],
    "Holdingford": ["56340"],
    "Holland": ["56139"],
    "Hollandale": ["56045"],
    "Holloway": ["56249"],
    "Holmes City": ["56341"],
    "Holyoke": ["55749"],
    "Homer": ["55942"],
    "Hope": ["56046"],
    "Hopkins": ["55305", "55343"],
    "Houston": ["55943"],
    "Hovland": ["55606"],
    "Howard Lake": ["55349", "55575"],
    "Hoyt Lakes": ["55750"],
    "Hugo": ["55038"],
    "Humboldt": ["56731"],
    "Huntley": ["56047"],
    "Hutchinson": ["55350"],
    "Ihlen": ["56140"],
    "International Falls": ["56649"],
    "Inver Grove Heights": ["55076", "55077"],
    "Iona": ["56141"],
    "Iron": ["55751"],
    "Ironton": ["56455"],
    "Isabella": ["55607"],
    "Isanti": ["55040"],
    "Isle": ["56342"],
    "Ivanhoe": ["56142"],
    "Jackson": ["56143"],
    "Jacobson": ["55752"],
    "Janesville": ["56048"],
    "Jasper": ["56144"],
    "Jeffers": ["56145"],
    "Jenkins": ["56456"],
    "Jordan": ["55352"],
    "Kabetogama": ["56669"],
    "Kanaranzi": ["56146"],
    "Kandiyohi": ["56251"],
    "Karlstad": ["56732"],
    "Kasota": ["56050"],
    "Kasson": ["55944"],
    "Keewatin": ["55753"],
    "Kelliher": ["56650"],
    "Kellogg": ["55945"],
    "Kennedy": ["56733"],
    "Kenneth": ["56147"],
    "Kensington": ["56343"],
    "Kent": ["56553"],
    "Kenyon": ["55946"],
    "Kerkhoven": ["56252"],
    "Kerrick": ["55756"],
    "Kettle River": ["55757"],
    "Kiester": ["56051"],
    "Kilkenny": ["56052"],
    "Kimball": ["55353"],
    "Kinney": ["55758"],
    "Knife River": ["55609"],
    "La Crescent": ["55947"],
    "La Salle": ["56056"],
    "Lafayette": ["56054"],
    "Lake Benton": ["56149"],
    "Lake Bronson": ["56734"],
    "Lake City": ["55041"],
    "Lake Crystal": ["56055"],
    "Lake Elmo": ["55042"],
    "Lake George": ["56458"],
    "Lake Hubert": ["56459"],
    "Lake Lillian": ["56253"],
    "Lake Park": ["56554"],
    "Lake Wilson": ["56151"],
    "Lakefield": ["56150"],
    "Lakeland": ["55043"],
    "Lakeville": ["55044"],
    "Lamberton": ["56152"],
    "Lancaster": ["56735"],
    "Lanesboro": ["55949"],
    "Lansing": ["55950"],
    "Laporte": ["56461"],
    "Lastrup": ["56344"],
    "Le Center": ["56057"],
    "Le Roy": ["55951"],
    "Le Sueur": ["56058"],
    "Lengby": ["56651"],
    "Leonard": ["56652"],
    "Leota": ["56153"],
    "Lester Prairie": ["55354"],
    "Lewiston": ["55952"],
    "Lewisville": ["56060"],
    "Lindstrom": ["55045"],
    "Lismore": ["56155"],
    "Litchfield": ["55355"],
    "Little Falls": ["56345"],
    "Littlefork": ["56653"],
    "Loman": ["56654"],
    "Long Lake": ["55356"],
    "Long Prairie": ["56347"],
    "Longville": ["56655"],
    "Lonsdale": ["55046"],
    "Loretto": ["55357", "55595", "55596", "55597", "55598", "55599"],
    "Lowry": ["56349"],
    "Lucan": ["56255"],
    "Lutsen": ["55612"],
    "Luverne": ["56156"],
    "Lyle": ["55953"],
    "Lynd": ["56157"],
    "Mabel": ["55954"],
    "Madelia": ["56062"],
    "Madison": ["56256"],
    "Madison Lake": ["56063"],
    "Magnolia": ["56158"],
    "Mahnomen": ["56557"],
    "Makinen": ["55763"],
    "Mankato": ["56001", "56002", "56003", "56006"],
    "Mantorville": ["55955"],
    "Maple Grove": ["55311"],
    "Maple Lake": ["55358"],
    "Maple Plain": ["55348", "55359", "55393", "55570", "55571", "55574", "55576", "55578", "55579", "55592", "55593"],
    "Mapleton": ["56065"],
    "Marble": ["55764"],
    "Marcell": ["56657"],
    "Margie": ["56658"],
    "Marietta": ["56257"],
    "Marine On Saint Croix": ["55047"],
    "Marshall": ["56258"],
    "Max": ["56659"],
    "Mayer": ["55360"],
    "Maynard": ["56260"],
    "Mazeppa": ["55956"],
    "Mc Grath": ["56350"],
    "Mcgregor": ["55760"],
    "Mcintosh": ["56556"],
    "Meadowlands": ["55765"],
    "Medford": ["55049"],
    "Melrose": ["56352"],
    "Melrude": ["55766"],
    "Menahga": ["56464"],
    "Mendota": ["55150"],
    "Mentor": ["56736"],
    "Merrifield": ["56465"],
    "Middle River": ["56737"],
    "Milaca": ["56353"],
    "Milan": ["56262"],
    "Millville": ["55957"],
    "Milroy": ["56263"],
    "Miltona": ["56354"],
    "Minneapolis": ["55401", "55402", "55403", "55404", "55405", "55406", "55407", "55408", "55409", "55410", "55411", "55412", "55413", "55414", "55415", "55416", "55417", "55418", "55419", "55420", "55421", "55422", "55423", "55424", "55425", "55426", "55427", "55428", "55429", "55430", "55431", "55432", "55433", "55434", "55435", "55436", "55437", "55438", "55439", "55440", "55441", "55442", "55443", "55444", "55445", "55446", "55447", "55448", "55449", "55450", "55454", "55455", "55458", "55459", "55460", "55467", "55468", "55470", "55472", "55473", "55474", "55478", "55479", "55480", "55483", "55484", "55485", "55486", "55487", "55488"],
    "Minneota": ["56264"],
    "Minnesota City": ["55959"],
    "Minnesota Lake": ["56068"],
    "Minnetonka": ["55345"],
    "Minnetonka Beach": ["55361"],
    "Mizpah": ["56660"],
    "Montevideo": ["56265"],
    "Montgomery": ["56069"],
    "Monticello": ["55362", "55365", "55561", "55563", "55565", "55580", "55581", "55582", "55584", "55585", "55586", "55587", "55588", "55589", "55590", "55591"],
    "Montrose": ["55363"],
    "Moorhead": ["56560", "56561", "56562", "56563"],
    "Moose Lake": ["55767"],
    "Mora": ["55051"],
    "Morgan": ["56266"],
    "Morris": ["56267"],
    "Morristown": ["55052"],
    "Morton": ["56270"],
    "Motley": ["56466"],
    "Mound": ["55364"],
    "Mountain Iron": ["55768"],
    "Mountain Lake": ["56159"],
    "Murdock": ["56271"],
    "Nashua": ["56565"],
    "Nashwauk": ["55769"],
    "Navarre": ["55392"],
    "Naytahwaush": ["56566"],
    "Nelson": ["56355"],
    "Nerstrand": ["55053"],
    "Nett Lake": ["55772"],
    "Nevis": ["56467"],
    "New Auburn": ["55366"],
    "New Germany": ["55367"],
    "New London": ["56273"],
    "New Munich": ["56356"],
    "New Prague": ["56071"],
    "New Richland": ["56072"],
    "New Ulm": ["56073"],
    "New York Mills": ["56567"],
    "Newfolden": ["56738"],
    "Newport": ["55055"],
    "Nicollet": ["56074"],
    "Nielsville": ["56568"],
    "Nimrod": ["56478"],
    "Nisswa": ["56468"],
    "Norcross": ["56274"],
    "North Branch": ["55056"],
    "Northfield": ["55057"],
    "Northome": ["56661"],
    "Northrop": ["56075"],
    "Norwood": ["55383", "55554", "55583"],
    "Norwood Young America": ["55368"],
    "Noyes": ["56740"],
    "Oak Island": ["56741"],
    "Oak Park": ["56357"],
    "Odessa": ["56276"],
    "Odin": ["56160"],
    "Ogema": ["56569"],
    "Ogilvie": ["56358"],
    "Okabena": ["56161"],
    "Oklee": ["56742"],
    "Olivia": ["56277"],
    "Onamia": ["56359"],
    "Ormsby": ["56162"],
    "Oronoco": ["55960"],
    "Orr": ["55771"],
    "Ortonville": ["56278"],
    "Osage": ["56570"],
    "Osakis": ["56360"],
    "Oslo": ["56744"],
    "Osseo": ["55369", "55569"],
    "Ostrander": ["55961"],
    "Ottertail": ["56571"],
    "Outing": ["56662"],
    "Owatonna": ["55060"],
    "Palisade": ["56469"],
    "Park Rapids": ["56470"],
    "Parkers Prairie": ["56361"],
    "Paynesville": ["56362"],
    "Pease": ["56363"],
    "Pelican Rapids": ["56572"],
    "Pemberton": ["56078"],
    "Pengilly": ["55775"],
    "Pennington": ["56663"],
    "Pennock": ["56279"],
    "Pequot Lakes": ["56472"],
    "Perham": ["56573"],
    "Perley": ["56574"],
    "Peterson": ["55962"],
    "Pierz": ["56364"],
    "Pillager": ["56473"],
    "Pine City": ["55063"],
    "Pine Island": ["55963"],
    "Pine River": ["56474"],
    "Pipestone": ["56164"],
    "Plainview": ["55964"],
    "Plato": ["55370"],
    "Plummer": ["56748"],
    "Ponemah": ["56666"],
    "Ponsford": ["56575"],
    "Porter": ["56280"],
    "Preston": ["55965"],
    "Princeton": ["55371"],
    "Prinsburg": ["56281"],
    "Prior Lake": ["55372"],
    "Puposky": ["56667"],
    "Racine": ["55967"],
    "Randall": ["56475"],
    "Randolph": ["55065"],
    "Ranier": ["56668"],
    "Raymond": ["56282"],
    "Reading": ["56165"],
    "Reads Landing": ["55968"],
    "Red Lake Falls": ["56750"],
    "Red Wing": ["55066"],
    "Redby": ["56670"],
    "Redlake": ["56671"],
    "Redwood Falls": ["56283"],
    "Remer": ["56672"],
    "Renville": ["56284"],
    "Revere": ["56166"],
    "Rice": ["56367"],
    "Richmond": ["56368"],
    "Richville": ["56576"],
    "Richwood": ["56577"],
    "Rochert": ["56578"],
    "Rochester": ["55901", "55902", "55903", "55904", "55905", "55906"],
    "Rock Creek": ["55067"],
    "Rockford": ["55373", "55572", "55577"],
    "Rockville": ["56369"],
    "Rogers": ["55374"],
    "Rollingstone": ["55969"],
    "Roosevelt": ["56673"],
    "Roscoe": ["56371"],
    "Rose Creek": ["55970"],
    "Roseau": ["56751"],
    "Rosemount": ["55068"],
    "Rothsay": ["56579"],
    "Round Lake": ["56167"],
    "Royalton": ["56373"],
    "Rush City": ["55069"],
    "Rushford": ["55971"],
    "Rushmore": ["56168"],
    "Russell": ["56169"],
    "Ruthton": ["56170"],
    "Sabin": ["56580"],
    "Sacred Heart": ["56285"],
    "Saginaw": ["55779"],
    "Saint Bonifacius": ["55375"],
    "Saint Charles": ["55972"],
    "Saint Clair": ["56080"],
    "Saint Cloud": ["56301", "56302", "56303", "56304", "56372", "56388", "56393", "56395", "56396", "56397", "56398", "56399"],
    "Saint Francis": ["55070"],
    "Saint Hilaire": ["56754"],
    "Saint James": ["56081"],
    "Saint Joseph": ["56374"],
    "Saint Martin": ["56376"],
    "Saint Michael": ["55376"],
    "Saint Paul": ["55101", "55102", "55103", "55104", "55105", "55106", "55107", "55108", "55109", "55110", "55111", "55112", "55113", "55114", "55115", "55116", "55117", "55118", "55119", "55120", "55121", "55122", "55123", "55124", "55125", "55126", "55127", "55128", "55129", "55130", "55131", "55133", "55144", "55145", "55146", "55155", "55161", "55164", "55165", "55166", "55168", "55169", "55170", "55171", "55172", "55175", "55177", "55187", "55188", "55191"],
    "Saint Paul Park": ["55071"],
    "Saint Peter": ["56082"],
    "Saint Stephen": ["56375"],
    "Saint Vincent": ["56755"],
    "Salol": ["56756"],
    "Sanborn": ["56083"],
    "Sandstone": ["55072"],
    "Santiago": ["55377"],
    "Sargeant": ["55973"],
    "Sartell": ["56377"],
    "Sauk Centre": ["56378"],
    "Sauk Rapids": ["56379"],
    "Savage": ["55378"],
    "Sawyer": ["55780"],
    "Scandia": ["55073"],
    "Schroeder": ["55613"],
    "Seaforth": ["56287"],
    "Searles": ["56084"],
    "Sebeka": ["56477"],
    "Shafer": ["55074"],
    "Shakopee": ["55379"],
    "Shelly": ["56581"],
    "Sherburn": ["56171"],
    "Shevlin": ["56676"],
    "Side Lake": ["55781"],
    "Silver Bay": ["55614"],
    "Silver Creek": ["55380"],
    "Silver Lake": ["55381"],
    "Slayton": ["56172"],
    "Sleepy Eye": ["56085"],
    "Solway": ["56678"],
    "Soudan": ["55782"],
    "South Haven": ["55382"],
    "South International Falls": ["56679"],
    "South Saint Paul": ["55075"],
    "Spicer": ["56288"],
    "Spring Grove": ["55974"],
    "Spring Lake": ["56680"],
    "Spring Park": ["55384"],
    "Spring Valley": ["55975"],
    "Springfield": ["56087"],
    "Squaw Lake": ["56681"],
    "Stacy": ["55078", "55079"],
    "Stanchfield": ["55080"],
    "Staples": ["56479"],
    "Starbuck": ["56381"],
    "Steen": ["56173"],
    "Stephen": ["56757"],
    "Stewart": ["55385"],
    "Stewartville": ["55976"],
    "Stillwater": ["55082", "55083"],
    "Stockton": ["55988"],
    "Storden": ["56174"],
    "Strandquist": ["56758"],
    "Strathcona": ["56759"],
    "Sturgeon Lake": ["55783"],
    "Sunburg": ["56289"],
    "Swan River": ["55784"],
    "Swanville": ["56382"],
    "Swatara": ["55785"],
    "Swift": ["56682"],
    "Taconite": ["55786"],
    "Talmoon": ["56637"],
    "Tamarack": ["55787"],
    "Taopi": ["55977"],
    "Taunton": ["56291"],
    "Taylors Falls": ["55084"],
    "Tenstrike": ["56683"],
    "Thief River Falls": ["56701"],
    "Tintah": ["56583"],
    "Tofte": ["55615"],
    "Tower": ["55790"],
    "Tracy": ["56175"],
    "Trail": ["56684"],
    "Trimont": ["56176"],
    "Trosky": ["56177"],
    "Truman": ["56088"],
    "Twig": ["55791"],
    "Twin Lakes": ["56089"],
    "Twin Valley": ["56584"],
    "Two Harbors": ["55616"],
    "Tyler": ["56178"],
    "Ulen": ["56585"],
    "Underwood": ["56586"],
    "Upsala": ["56384"],
    "Utica": ["55979"],
    "Vergas": ["56587"],
    "Vermillion": ["55085"],
    "Verndale": ["56481"],
    "Vernon Center": ["56090"],
    "Vesta": ["56292"],
    "Victoria": ["55386"],
    "Viking": ["56760"],
    "Villard": ["56385"],
    "Vining": ["56588"],
    "Virginia": ["55777", "55792"],
    "Wabasha": ["55981"],
    "Wabasso": ["56293"],
    "Waconia": ["55387"],
    "Wadena": ["56482"],
    "Wahkon": ["56386"],
    "Waite Park": ["56387"],
    "Waldorf": ["56091"],
    "Walker": ["56484"],
    "Walnut Grove": ["56180"],
    "Waltham": ["55982"],
    "Wanamingo": ["55983"],
    "Wanda": ["56294"],
    "Wannaska": ["56761"],
    "Warba": ["55793"],
    "Warren": ["56762"],
    "Warroad": ["56763"],
    "Warsaw": ["55087"],
    "Waseca": ["56093"],
    "Waskish": ["56685"],
    "Watertown": ["55388"],
    "Waterville": ["56096"],
    "Watkins": ["55389"],
    "Watson": ["56295"],
    "Waubun": ["56589"],
    "Waverly": ["55390"],
    "Wayzata": ["55391"],
    "Webster": ["55088"],
    "Welch": ["55089"],
    "Welcome": ["56181"],
    "Wells": ["56097"],
    "Wendell": ["56590"],
    "West Concord": ["55985"],
    "West Union": ["56389"],
    "Westbrook": ["56183"],
    "Wheaton": ["56296"],
    "White Earth": ["56591"],
    "Willernie": ["55090"],
    "Williams": ["56686"],
    "Willmar": ["56201"],
    "Willow River": ["55795"],
    "Wilmont": ["56185"],
    "Wilton": ["56687"],
    "Windom": ["56101"],
    "Winger": ["56592"],
    "Winnebago": ["56098"],
    "Winona": ["55987"],
    "Winsted": ["55395"],
    "Winthrop": ["55396"],
    "Winton": ["55796"],
    "Wirt": ["56688"],
    "Wolf Lake": ["56593"],
    "Wolverton": ["56594"],
    "Wood Lake": ["56297"],
    "Woodstock": ["56186"],
    "Worthington": ["56187"],
    "Wrenshall": ["55797"],
    "Wright": ["55798"],
    "Wykoff": ["55990"],
    "Wyoming": ["55092"],
    "Young America": ["55394", "55397", "55399", "55550", "55551", "55552", "55553", "55555", "55556", "55557", "55558", "55559", "55560", "55562", "55564", "55566", "55567", "55568", "55573", "55594"],
    "Zimmerman": ["55398"],
    "Zumbro Falls": ["55991"],
    "Zumbrota": ["55992"]
  },
  "MO": {
    "Adrian": ["64720"],
    "Advance": ["63730"],
    "Agency": ["64401"],
    "Alba": ["64830"],
    "Albany": ["64402"],
    "Aldrich": ["65601"],
    "Alexandria": ["63430"],
    "Allendale": ["64420"],
    "Allenton": ["63001"],
    "Alma": ["64001"],
    "Altamont": ["64620"],
    "Altenburg": ["63732"],
    "Alton": ["65606"],
    "Amazonia": ["64421"],
    "Amity": ["64422"],
    "Amoret": ["64722"],
    "Amsterdam": ["64723"],
    "Anabel": ["63431"],
    "Anderson": ["64831"],
    "Annada": ["63330"],
    "Annapolis": ["63620"],
    "Anniston": ["63820"],
    "Appleton City": ["64724"],
    "Arbela": ["63432"],
    "Arbyrd": ["63821"],
    "Arcadia": ["63621"],
    "Archie": ["64725"],
    "Arcola": ["65603"],
    "Argyle": ["65001"],
    "Armstrong": ["65230"],
    "Arnold": ["63010"],
    "Arrow Rock": ["65320"],
    "Asbury": ["64832"],
    "Ash Grove": ["65604"],
    "Ashburn": ["63433"],
    "Ashland": ["65010"],
    "Atlanta": ["63530"],
    "Augusta": ["63332"],
    "Aurora": ["65605"],
    "Auxvasse": ["65231"],
    "Ava": ["65608"],
    "Avilla": ["64833"],
    "Bakersfield": ["65609"],
    "Ballwin": ["63011", "63021", "63022", "63024"],
    "Baring": ["63531"],
    "Barnard": ["64423"],
    "Barnett": ["65011"],
    "Barnhart": ["63012"],
    "Bates City": ["64011"],
    "Beaufort": ["63013"],
    "Belgrade": ["63622"],
    "Bell City": ["63735"],
    "Belle": ["65013"],
    "Belleview": ["63623"],
    "Bellflower": ["63333"],
    "Belton": ["64012"],
    "Benton": ["63736"],
    "Benton City": ["65232"],
    "Berger": ["63014"],
    "Bernie": ["63822"],
    "Bertrand": ["63823"],
    "Bethany": ["64424"],
    "Bethel": ["63434"],
    "Beulah": ["65436"],
    "Bevier": ["63532"],
    "Billings": ["65610"],
    "Birch Tree": ["65438"],
    "Bismarck": ["63624"],
    "Bixby": ["65439"],
    "Black": ["63625"],
    "Blackburn": ["65321"],
    "Blackwater": ["65322"],
    "Blackwell": ["63626"],
    "Blairstown": ["64726"],
    "Bland": ["65014"],
    "Blodgett": ["63824"],
    "Bloomfield": ["63825"],
    "Bloomsdale": ["63627"],
    "Blue Eye": ["65611"],
    "Blue Springs": ["64013", "64014", "64015"],
    "Blythedale": ["64426"],
    "Bogard": ["64622"],
    "Bois D Arc": ["65612"],
    "Bolckow": ["64427"],
    "Bolivar": ["65613"],
    "Bonne Terre": ["63628"],
    "Bonnots Mill": ["65016"],
    "Boonville": ["65233"],
    "Boss": ["65440"],
    "Bosworth": ["64623"],
    "Bourbon": ["65441"],
    "Bowling Green": ["63334"],
    "Bradleyville": ["65614"],
    "Bragg City": ["63827"],
    "Braggadocio": ["63826"],
    "Brandsville": ["65688"],
    "Branson": ["65615", "65616"],
    "Brashear": ["63533"],
    "Braymer": ["64624"],
    "Brazeau": ["63737"],
    "Breckenridge": ["64625"],
    "Briar": ["63931"],
    "Bridgeton": ["63044"],
    "Brighton": ["65617"],
    "Brinktown": ["65443"],
    "Brixey": ["65618"],
    "Bronaugh": ["64728"],
    "Brookfield": ["64628"],
    "Brookline": ["65619"],
    "Broseley": ["63932"],
    "Browning": ["64630"],
    "Brownwood": ["63738"],
    "Brumley": ["65017"],
    "Bruner": ["65620"],
    "Brunswick": ["65236"],
    "Bucklin": ["64631"],
    "Buckner": ["64016"],
    "Bucyrus": ["65444"],
    "Buffalo": ["65622"],
    "Bunceton": ["65237"],
    "Bunker": ["63629"],
    "Burfordville": ["63739"],
    "Burlington Junction": ["64428"],
    "Butler": ["64730"],
    "Butterfield": ["65623"],
    "Cabool": ["65689"],
    "Cadet": ["63630"],
    "Cainsville": ["64632"],
    "Cairo": ["65239"],
    "Caledonia": ["63631"],
    "Calhoun": ["65323"],
    "California": ["65018"],
    "Callao": ["63534"],
    "Camden": ["64017"],
    "Camden Point": ["64018"],
    "Camdenton": ["65020"],
    "Cameron": ["64429"],
    "Campbell": ["63933"],
    "Canalou": ["63828"],
    "Canton": ["63435"],
    "Cape Fair": ["65624"],
    "Cape Girardeau": ["63701", "63702", "63703"],
    "Caplinger Mills": ["65607"],
    "Cardwell": ["63829"],
    "Carl Junction": ["64834"],
    "Carrollton": ["64633"],
    "Carterville": ["64835"],
    "Carthage": ["64836"],
    "Caruthersville": ["63830"],
    "Cascade": ["63632"],
    "Cassville": ["65625"],
    "Catawissa": ["63015"],
    "Catron": ["63833"],
    "Caulfield": ["65626"],
    "Cedar Hill": ["63016"],
    "Cedarcreek": ["65627"],
    "Center": ["63436"],
    "Centertown": ["65023"],
    "Centerview": ["64019"],
    "Centerville": ["63633"],
    "Centralia": ["65240"],
    "Chadwick": ["65629"],
    "Chaffee": ["63740"],
    "Chamois": ["65024"],
    "Charleston": ["63834"],
    "Cherryville": ["65446"],
    "Chesterfield": ["63005", "63006", "63017"],
    "Chestnutridge": ["65630"],
    "Chilhowee": ["64733"],
    "Chillicothe": ["64601"],
    "Chula": ["64635"],
    "Clarence": ["63437"],
    "Clark": ["65243"],
    "Clarksburg": ["65025"],
    "Clarksdale": ["64430"],
    "Clarksville": ["63336"],
    "Clarkton": ["63837"],
    "Clearmont": ["64431"],
    "Cleveland": ["64734"],
    "Clever": ["65631"],
    "Clifton Hill": ["65244"],
    "Climax Springs": ["65324"],
    "Clinton": ["64735"],
    "Clubb": ["63934"],
    "Clyde": ["64432"],
    "Coatsville": ["63535"],
    "Coffey": ["64636"],
    "Cole Camp": ["65325"],
    "Collins": ["64738"],
    "Columbia": ["65201", "65202", "65203", "65205", "65211", "65212", "65215", "65216", "65217", "65218", "65299"],
    "Commerce": ["63742"],
    "Conception": ["64433"],
    "Conception Junction": ["64434"],
    "Concordia": ["64020"],
    "Conway": ["65632"],
    "Cook Sta": ["65449"],
    "Cooter": ["63839"],
    "Corder": ["64021"],
    "Cosby": ["64436"],
    "Cottleville": ["63338"],
    "Couch": ["65690"],
    "Cowgill": ["64637"],
    "Craig": ["64437"],
    "Crane": ["65633"],
    "Creighton": ["64739"],
    "Crocker": ["65452"],
    "Cross Timbers": ["65634"],
    "Crystal City": ["63019"],
    "Cuba": ["65453"],
    "Curryville": ["63339"],
    "Dadeville": ["65635"],
    "Daisy": ["63743"],
    "Dalton": ["65246"],
    "Darlington": ["64438"],
    "Davisville": ["65456"],
    "Dawn": ["64638"],
    "De Kalb": ["64440"],
    "De Soto": ["63020"],
    "De Witt": ["64639"],
    "Dearborn": ["64439"],
    "Deepwater": ["64740"],
    "Deerfield": ["64741"],
    "Deering": ["63840"],
    "Defiance": ["63341"],
    "Delta": ["63744"],
    "Denver": ["64441"],
    "Des Arc": ["63636"],
    "Devils Elbow": ["65457"],
    "Dexter": ["63841"],
    "Diamond": ["64840"],
    "Diggins": ["65636"],
    "Dittmer": ["63023"],
    "Dixon": ["65459"],
    "Doe Run": ["63637"],
    "Doniphan": ["63935"],
    "Dora": ["65637"],
    "Dover": ["64022"],
    "Downing": ["63536"],
    "Drexel": ["64742"],
    "Drury": ["65638"],
    "Dudley": ["63936"],
    "Duenweg": ["64841"],
    "Duke": ["65461"],
    "Dunnegan": ["65640"],
    "Durham": ["63438"],
    "Dutchtown": ["63745"],
    "Dutzow": ["63342"],
    "Eagle Rock": ["65641"],
    "Eagleville": ["64442"],
    "Earth City": ["63045"],
    "East Lynne": ["64743"],
    "East Prairie": ["63845"],
    "Easton": ["64443"],
    "Edgar Springs": ["65462"],
    "Edgerton": ["64444"],
    "Edina": ["63537"],
    "Edwards": ["65326"],
    "El Dorado Springs": ["64744"],
    "Eldon": ["65026"],
    "Eldridge": ["65463"],
    "Elk Creek": ["65464"],
    "Elkland": ["65644"],
    "Ellington": ["63638"],
    "Ellsinore": ["63937"],
    "Elmer": ["63538"],
    "Elmo": ["64445"],
    "Elsberry": ["63343"],
    "Emden": ["63439"],
    "Eminence": ["65466"],
    "Emma": ["65327"],
    "Eolia": ["63344"],
    "Essex": ["63846"],
    "Ethel": ["63539"],
    "Eugene": ["65032"],
    "Eunice": ["65468"],
    "Eureka": ["63025"],
    "Everton": ["65646"],
    "Ewing": ["63440"],
    "Excello": ["65247"],
    "Excelsior Springs": ["64024"],
    "Exeter": ["65647"],
    "Fagus": ["63938"],
    "Fair Grove": ["65648"],
    "Fair Play": ["65649"],
    "Fairdealing": ["63939"],
    "Fairfax": ["64446"],
    "Fairview": ["64842"],
    "Falcon": ["65470"],
    "Farber": ["63345"],
    "Farley": ["64028"],
    "Farmington": ["63640"],
    "Farrar": ["63746"],
    "Faucett": ["64448"],
    "Fayette": ["65248"],
    "Fenton": ["63026", "63099"],
    "Festus": ["63028"],
    "Fillmore": ["64449"],
    "Fisk": ["63940"],
    "Flemington": ["65650"],
    "Fletcher": ["63030"],
    "Flinthill": ["63346"],
    "Florence": ["65329"],
    "Florissant": ["63031", "63032", "63033", "63034"],
    "Foley": ["63347"],
    "Fordland": ["65652"],
    "Forest City": ["64451"],
    "Foristell": ["63348"],
    "Forsyth": ["65653"],
    "Fort Leonard Wood": ["65473"],
    "Fortuna": ["65034"],
    "Foster": ["64745"],
    "Frankford": ["63441"],
    "Franklin": ["65250"],
    "Fredericktown": ["63645"],
    "Freeburg": ["65035"],
    "Freeman": ["64746"],
    "Freistatt": ["65654"],
    "Fremont": ["63941"],
    "French Village": ["63036"],
    "Friedheim": ["63747"],
    "Frohna": ["63748"],
    "Fulton": ["65251"],
    "Gainesville": ["65655"],
    "Galena": ["65656"],
    "Gallatin": ["64640"],
    "Galt": ["64641"],
    "Garden City": ["64747"],
    "Garrison": ["65657"],
    "Gasconade": ["65036"],
    "Gatewood": ["63942"],
    "Gentry": ["64453"],
    "Gerald": ["63037"],
    "Gibbs": ["63540"],
    "Gibson": ["63847"],
    "Gideon": ["63848"],
    "Gilliam": ["65330"],
    "Gilman City": ["64642"],
    "Gipsy": ["63750"],
    "Glasgow": ["65254"],
    "Glenallen": ["63751"],
    "Glenwood": ["63541"],
    "Gobler": ["63849"],
    "Golden": ["65658"],
    "Golden City": ["64748"],
    "Goodman": ["64843"],
    "Gordonville": ["63752"],
    "Gorin": ["63543"],
    "Gower": ["64454"],
    "Graff": ["65660"],
    "Graham": ["64455"],
    "Grain Valley": ["64029"],
    "Granby": ["64844"],
    "Grandin": ["63943"],
    "Grandview": ["64030"],
    "Granger": ["63442"],
    "Grant City": ["64456"],
    "Gravois Mills": ["65037"],
    "Gray Summit": ["63039"],
    "Grayridge": ["63850"],
    "Green Castle": ["63544"],
    "Green City": ["63545"],
    "Green Ridge": ["65332"],
    "Greenfield": ["65661"],
    "Greentop": ["63546"],
    "Greenville": ["63944"],
    "Greenwood": ["64034"],
    "Grovespring": ["65662"],
    "Grubville": ["63041"],
    "Guilford": ["64457"],
    "Hale": ["64643"],
    "Half Way": ["65663"],
    "Hallsville": ["65255"],
    "Halltown": ["65664"],
    "Hamilton": ["64644"],
    "Hannibal": ["63401"],
    "Hardenville": ["65666"],
    "Hardin": ["64035"],
    "Harris": ["64645"],
    "Harrisburg": ["65256"],
    "Harrisonville": ["64701"],
    "Hartsburg": ["65039"],
    "Hartshorn": ["65479"],
    "Hartville": ["65667"],
    "Harviell": ["63945"],
    "Harwood": ["64750"],
    "Hatfield": ["64458"],
    "Hawk Point": ["63349"],
    "Hayti": ["63851"],
    "Hazelwood": ["63042"],
    "Helena": ["64459"],
    "Hematite": ["63047"],
    "Henley": ["65040"],
    "Henrietta": ["64036"],
    "Herculaneum": ["63048"],
    "Hermann": ["65041"],
    "Hermitage": ["65668"],
    "Higbee": ["65257"],
    "Higginsville": ["64037"],
    "High Hill": ["63350"],
    "High Point": ["65042"],
    "High Ridge": ["63049"],
    "Highlandville": ["65669"],
    "Hillsboro": ["63050"],
    "Holcomb": ["63852"],
    "Holden": ["64040"],
    "Holland": ["63853"],
    "Holliday": ["65258"],
    "Hollister": ["65672", "65673"],
    "Holt": ["64048"],
    "Holts Summit": ["65043"],
    "Hopkins": ["64461"],
    "Hornersville": ["63855"],
    "House Springs": ["63051"],
    "Houston": ["65483"],
    "Houstonia": ["65333"],
    "Huggins": ["65484"],
    "Hughesville": ["65334"],
    "Humansville": ["65674"],
    "Hume": ["64752"],
    "Humphreys": ["64646"],
    "Hunnewell": ["63443"],
    "Huntsville": ["65259"],
    "Hurdland": ["63547"],
    "Hurley": ["65675"],
    "Iberia": ["65486"],
    "Imperial": ["63052"],
    "Independence": ["64050", "64051", "64052", "64053", "64054", "64055", "64056", "64057", "64058"],
    "Ionia": ["65335"],
    "Irondale": ["63648"],
    "Ironton": ["63650"],
    "Isabella": ["65676"],
    "Jackson": ["63755"],
    "Jacksonville": ["65260"],
    "Jadwin": ["65501"],
    "Jameson": ["64647"],
    "Jamesport": ["64648"],
    "Jamestown": ["65046"],
    "Jasper": ["64755"],
    "Jefferson City": ["65101", "65102", "65103", "65104", "65105", "65106", "65107", "65108", "65109", "65110", "65111"],
    "Jerico Springs": ["64756"],
    "Jerome": ["65529"],
    "Jonesburg": ["63351"],
    "Joplin": ["64801", "64802", "64803", "64804"],
    "Kahoka": ["63445"],
    "Kaiser": ["65047"],
    "Kansas City": ["64101", "64102", "64105", "64106", "64108", "64109", "64110", "64111", "64112", "64113", "64114", "64116", "64117", "64118", "64119", "64120", "64121", "64123", "64124", "64125", "64126", "64127", "64128", "64129", "64130", "64131", "64132", "64133", "64134", "64136", "64137", "64138", "64139", "64141", "64144", "64145", "64146", "64147", "64148", "64149", "64151", "64152", "64153", "64154", "64155", "64156", "64157", "64158", "64161", "64162", "64163", "64164", "64165", "64166", "64167", "64168", "64170", "64171", "64172", "64179", "64180", "64183", "64184", "64185", "64187", "64188", "64190", "64191", "64192", "64193", "64194", "64195", "64196", "64197", "64198", "64199", "64944", "64999"],
    "Kearney": ["64060"],
    "Kelso": ["63758"],
    "Kennett": ["63857"],
    "Kewanee": ["63860"],
    "Keytesville": ["65261"],
    "Kidder": ["64649"],
    "Kimberling City": ["65686"],
    "Kimmswick": ["63053"],
    "King City": ["64463"],
    "Kingdom City": ["65262"],
    "Kingston": ["64650"],
    "Kingsville": ["64061"],
    "Kirbyville": ["65679"],
    "Kirksville": ["63501"],
    "Kissee Mills": ["65680"],
    "Knob Lick": ["63651"],
    "Knob Noster": ["65336"],
    "Knox City": ["63446"],
    "Koeltztown": ["65048"],
    "Koshkonong": ["65692"],
    "La Belle": ["63447"],
    "La Grange": ["63448"],
    "La Monte": ["65337"],
    "La Plata": ["63549"],
    "La Russell": ["64848"],
    "Labadie": ["63055"],
    "Laclede": ["64651"],
    "Laddonia": ["63352"],
    "Lake Ozark": ["65049"],
    "Lake Saint Louis": ["63367"],
    "Lake Spring": ["65532"],
    "Lamar": ["64759"],
    "Lampe": ["65681"],
    "Lanagan": ["64847"],
    "Lancaster": ["63548"],
    "Laquey": ["65534"],
    "Laredo": ["64652"],
    "Latham": ["65050"],
    "Lathrop": ["64465"],
    "Laurie": ["65038"],
    "Lawson": ["64062"],
    "Lead Hill": ["72643"],
    "Leadwood": ["63653"],
    "Leasburg": ["65535"],
    "Lebanon": ["65536"],
    "Lees Summit": ["64002", "64063", "64064", "64065", "64081", "64082", "64086"],
    "Leeton": ["64761"],
    "Lenox": ["65541"],
    "Lentner": ["63450"],
    "Leonard": ["63451"],
    "Leopold": ["63760"],
    "Leslie": ["63056"],
    "Lesterville": ["63654"],
    "Levasy": ["64066"],
    "Lewistown": ["63452"],
    "Lexington": ["64067"],
    "Liberal": ["64762"],
    "Liberty": ["64068", "64069"],
    "Licking": ["65542"],
    "Liguori": ["63057"],
    "Lilbourn": ["63862"],
    "Lincoln": ["65338"],
    "Linn": ["65051"],
    "Linn Creek": ["65052"],
    "Linneus": ["64653"],
    "Livonia": ["63551"],
    "Lock Springs": ["64654"],
    "Lockwood": ["65682"],
    "Lodi": ["63950"],
    "Lohman": ["65053"],
    "Lone Jack": ["64070"],
    "Lonedell": ["63060"],
    "Long Lane": ["65590"],
    "Loose Creek": ["65054"],
    "Louisburg": ["65685"],
    "Louisiana": ["63353"],
    "Lowndes": ["63951"],
    "Lowry City": ["64763"],
    "Lucerne": ["64655"],
    "Ludlow": ["64656"],
    "Luebbering": ["63061"],
    "Luray": ["63453"],
    "Lynchburg": ["65543"],
    "Macks Creek": ["65786"],
    "Macomb": ["65702"],
    "Macon": ["63552"],
    "Madison": ["65263"],
    "Maitland": ["64466"],
    "Malden": ["63863"],
    "Malta Bend": ["65339"],
    "Mansfield": ["65704"],
    "Mapaville": ["63065"],
    "Marble Hill": ["63764"],
    "Marceline": ["64658"],
    "Marionville": ["65705"],
    "Marquand": ["63655"],
    "Marshall": ["65340"],
    "Marshfield": ["65706"],
    "Marston": ["63866"],
    "Marthasville": ["63357"],
    "Martinsburg": ["65264"],
    "Martinsville": ["64467"],
    "Maryland Heights": ["63043"],
    "Maryville": ["64468"],
    "Matthews": ["63867"],
    "Maysville": ["64447", "64469"],
    "Mayview": ["64071"],
    "Maywood": ["63454"],
    "Mc Bride": ["63776"],
    "Mc Clurg": ["65701"],
    "Mc Fall": ["64657"],
    "Mc Gee": ["63763"],
    "Mc Girk": ["65055"],
    "Meadville": ["64659"],
    "Memphis": ["63555"],
    "Mendon": ["64660"],
    "Mercer": ["64661"],
    "Meta": ["65058"],
    "Metz": ["64765"],
    "Mexico": ["65265"],
    "Miami": ["65344"],
    "Middle Brook": ["63656"],
    "Middletown": ["63359"],
    "Milan": ["63556"],
    "Milford": ["64766"],
    "Mill Spring": ["63952"],
    "Miller": ["65707"],
    "Millersville": ["63766"],
    "Milo": ["64767"],
    "Mindenmines": ["64769"],
    "Mineral Point": ["63660"],
    "Missouri City": ["64072"],
    "Moberly": ["65270"],
    "Mokane": ["65059"],
    "Monett": ["65708"],
    "Monroe City": ["63456"],
    "Montgomery City": ["63361"],
    "Monticello": ["63457"],
    "Montier": ["65546"],
    "Montreal": ["65591"],
    "Montrose": ["64770"],
    "Moody": ["65777"],
    "Mooresville": ["64664"],
    "Mora": ["65345"],
    "Morehouse": ["63868"],
    "Morley": ["63767"],
    "Morrison": ["65061"],
    "Morrisville": ["65645", "65710"],
    "Morse Mill": ["63066"],
    "Mosby": ["64073"],
    "Moscow Mills": ["63362"],
    "Mound City": ["64470"],
    "Moundville": ["64771"],
    "Mount Sterling": ["65062"],
    "Mount Vernon": ["65712"],
    "Mountain Grove": ["65711"],
    "Mountain View": ["65548"],
    "Myrtle": ["65778"],
    "Napoleon": ["64074"],
    "Naylor": ["63953"],
    "Neck City": ["64849"],
    "Neelyville": ["63954"],
    "Nelson": ["65347"],
    "Neosho": ["64850"],
    "Nevada": ["64772"],
    "New Bloomfield": ["65063"],
    "New Boston": ["63557"],
    "New Cambria": ["63558"],
    "New Florence": ["63363"],
    "New Franklin": ["65274"],
    "New Hampton": ["64471"],
    "New Haven": ["63068"],
    "New London": ["63459"],
    "New Madrid": ["63869"],
    "New Melle": ["63365"],
    "Newark": ["63458"],
    "Newburg": ["65550"],
    "Newtonia": ["64853"],
    "Newtown": ["64667"],
    "Niangua": ["65713"],
    "Nixa": ["65714"],
    "Noble": ["65715"],
    "Noel": ["64854"],
    "Norborne": ["64668"],
    "Norwood": ["65717"],
    "Novelty": ["63460"],
    "Novinger": ["63559"],
    "O Fallon": ["63366", "63368"],
    "Oak Grove": ["64075"],
    "Oak Ridge": ["63769"],
    "Odessa": ["64076"],
    "Old Appleton": ["63770"],
    "Old Monroe": ["63369"],
    "Oldfield": ["65720"],
    "Olean": ["65064"],
    "Olney": ["63370"],
    "Oran": ["63771"],
    "Oregon": ["64473"],
    "Oronogo": ["64855"],
    "Orrick": ["64077"],
    "Osage Beach": ["65065"],
    "Osborn": ["64474"],
    "Osceola": ["64776", "64789"],
    "Otterville": ["65348"],
    "Owensville": ["65066"],
    "Oxly": ["63955"],
    "Ozark": ["65721"],
    "Pacific": ["63069"],
    "Palmyra": ["63461"],
    "Paris": ["65275"],
    "Park Hills": ["63601"],
    "Parma": ["63870"],
    "Parnell": ["64475"],
    "Patterson": ["63956"],
    "Patton": ["63662"],
    "Pattonsburg": ["64670"],
    "Peace Valley": ["65788"],
    "Peculiar": ["64078"],
    "Perkins": ["63774"],
    "Perry": ["63462"],
    "Perryville": ["63775"],
    "Pevely": ["63070"],
    "Philadelphia": ["63463"],
    "Phillipsburg": ["65722"],
    "Pickering": ["64476"],
    "Piedmont": ["63957"],
    "Pierce City": ["65723"],
    "Pilot Grove": ["65276"],
    "Pilot Knob": ["63663"],
    "Pineville": ["64856"],
    "Pittsburg": ["65724"],
    "Plato": ["65552"],
    "Platte City": ["64079"],
    "Plattsburg": ["64477"],
    "Pleasant Hill": ["64080"],
    "Pleasant Hope": ["65725"],
    "Plevna": ["63464"],
    "Pocahontas": ["63779"],
    "Point Lookout": ["65726"],
    "Polk": ["65727"],
    "Pollock": ["63560"],
    "Polo": ["64671"],
    "Pomona": ["65789"],
    "Ponce De Leon": ["65728"],
    "Pontiac": ["65729"],
    "Poplar Bluff": ["63901", "63902"],
    "Portage Des Sioux": ["63373"],
    "Portageville": ["63873"],
    "Portland": ["65067"],
    "Potosi": ["63664"],
    "Pottersville": ["65790"],
    "Powell": ["65730"],
    "Powersite": ["65731"],
    "Powersville": ["64672"],
    "Prairie Home": ["65068"],
    "Preston": ["65732"],
    "Princeton": ["64673"],
    "Protem": ["65733"],
    "Purcell": ["64857"],
    "Purdin": ["64674"],
    "Purdy": ["65734"],
    "Puxico": ["63960"],
    "Queen City": ["63561"],
    "Quincy": ["65735"],
    "Qulin": ["63961"],
    "Racine": ["64858"],
    "Ravenwood": ["64479"],
    "Raymondville": ["65555"],
    "Raymore": ["64083"],
    "Rayville": ["64084"],
    "Rea": ["64480"],
    "Redford": ["63665"],
    "Reeds": ["64859"],
    "Reeds Spring": ["65737"],
    "Renick": ["65278"],
    "Republic": ["65738"],
    "Revere": ["63465"],
    "Reynolds": ["63666"],
    "Rhineland": ["65069"],
    "Rich Hill": ["64779"],
    "Richards": ["64778"],
    "Richland": ["65556"],
    "Richmond": ["64085"],
    "Richwoods": ["63071"],
    "Ridgedale": ["65739"],
    "Ridgeway": ["64481"],
    "Risco": ["63874"],
    "Riverside": ["64150"],
    "Rives": ["63875"],
    "Roach": ["65787"],
    "Robertsville": ["63072"],
    "Roby": ["65557"],
    "Rocheport": ["65279"],
    "Rock Port": ["64482"],
    "Rockaway Beach": ["65740"],
    "Rockbridge": ["65741"],
    "Rockville": ["64780"],
    "Rocky Comfort": ["64861"],
    "Rocky Mount": ["65072"],
    "Rogersville": ["65742"],
    "Rolla": ["65401", "65402", "65409"],
    "Rombauer": ["63962"],
    "Roscoe": ["64781"],
    "Rosebud": ["63091"],
    "Rosendale": ["64483"],
    "Rothville": ["64676"],
    "Rueter": ["65744"],
    "Rush Hill": ["65280"],
    "Rushville": ["64484"],
    "Russellville": ["65074"],
    "Rutledge": ["63563"],
    "Saginaw": ["64864"],
    "Saint Albans": ["63073"],
    "Saint Ann": ["63074"],
    "Saint Charles": ["63301", "63302", "63303", "63304"],
    "Saint Clair": ["63077"],
    "Saint Elizabeth": ["65075"],
    "Saint James": ["65559"],
    "Saint Joseph": ["64501", "64502", "64503", "64504", "64505", "64506", "64507", "64508"],
    "Saint Louis": ["63101", "63102", "63103", "63104", "63105", "63106", "63107", "63108", "63109", "63110", "63111", "63112", "63113", "63114", "63115", "63116", "63117", "63118", "63119", "63120", "63121", "63122", "63123", "63124", "63125", "63126", "63127", "63128", "63129", "63130", "63131", "63132", "63133", "63134", "63135", "63136", "63137", "63138", "63139", "63140", "63141", "63143", "63144", "63145", "63146", "63147", "63150", "63151", "63155", "63156", "63157", "63158", "63160", "63163", "63164", "63166", "63167", "63169", "63171", "63177", "63178", "63179", "63180", "63182", "63188", "63190", "63195", "63196", "63197", "63198", "63199"],
    "Saint Mary": ["63673"],
    "Saint Patrick": ["63466"],
    "Saint Peters": ["63376"],
    "Saint Robert": ["65584"],
    "Saint Thomas": ["65076"],
    "Sainte Genevieve": ["63670"],
    "Salem": ["65560"],
    "Salisbury": ["65281"],
    "Santa Fe": ["65282"],
    "Sarcoxie": ["64862"],
    "Savannah": ["64485"],
    "Saverton": ["63467"],
    "Schell City": ["64783"],
    "Scott City": ["63780"],
    "Sedalia": ["65301", "65302"],
    "Sedgewickville": ["63781"],
    "Seligman": ["65745"],
    "Senath": ["63876"],
    "Seneca": ["64865"],
    "Seymour": ["65746"],
    "Shelbina": ["63468"],
    "Shelbyville": ["63469"],
    "Sheldon": ["64784"],
    "Shell Knob": ["65747"],
    "Sheridan": ["64486"],
    "Shook": ["63963"],
    "Sibley": ["64088"],
    "Sikeston": ["63801"],
    "Silex": ["63377"],
    "Silva": ["63964"],
    "Skidmore": ["64487"],
    "Slater": ["65349"],
    "Smithton": ["65350"],
    "Smithville": ["64089"],
    "Solo": ["65564"],
    "South Fork": ["65776"],
    "South Greenfield": ["65752"],
    "South West City": ["64863"],
    "Sparta": ["65753"],
    "Spickard": ["64679"],
    "Spokane": ["65754"],
    "Springfield": ["65801", "65802", "65803", "65804", "65805", "65806", "65807", "65808", "65809", "65810", "65814", "65817", "65890", "65897", "65898", "65899"],
    "Squires": ["65755"],
    "Stanberry": ["64489"],
    "Stanton": ["63079"],
    "Stark City": ["64866"],
    "Steedman": ["65077"],
    "Steele": ["63877"],
    "Steelville": ["65565"],
    "Stella": ["64867"],
    "Stet": ["64680"],
    "Stewartsville": ["64490"],
    "Stockton": ["65785"],
    "Stotts City": ["65756"],
    "Stoutland": ["65567"],
    "Stoutsville": ["65283"],
    "Stover": ["65078"],
    "Strafford": ["65757"],
    "Strasburg": ["64090"],
    "Sturdivant": ["63782"],
    "Sturgeon": ["65284"],
    "Success": ["65570"],
    "Sullivan": ["63080"],
    "Summersville": ["65571"],
    "Sumner": ["64681"],
    "Sunrise Beach": ["65079"],
    "Sweet Springs": ["65351"],
    "Syracuse": ["65354"],
    "Tallapoosa": ["63878"],
    "Taneyville": ["65759"],
    "Tarkio": ["64491"],
    "Taylor": ["63471"],
    "Tebbetts": ["65080"],
    "Tecumseh": ["65760"],
    "Thayer": ["65791"],
    "Theodosia": ["65761"],
    "Thompson": ["65285"],
    "Thornfield": ["65762"],
    "Tiff": ["63674"],
    "Tiff City": ["64868"],
    "Tina": ["64682"],
    "Tipton": ["65081"],
    "Treloar": ["63378"],
    "Trenton": ["64683"],
    "Trimble": ["64492"],
    "Triplett": ["65286"],
    "Troy": ["63379"],
    "Truesdale": ["63380"],
    "Truxton": ["63381"],
    "Tunas": ["65764"],
    "Turners": ["65765"],
    "Turney": ["64493"],
    "Tuscumbia": ["65082"],
    "Udall": ["65766"],
    "Ulman": ["65083"],
    "Union": ["63084"],
    "Union Star": ["64494"],
    "Uniontown": ["63783"],
    "Unionville": ["63565"],
    "Urbana": ["65767"],
    "Urich": ["64788"],
    "Utica": ["64686"],
    "Valles Mines": ["63087"],
    "Valley Park": ["63088"],
    "Van Buren": ["63965"],
    "Vandalia": ["63382"],
    "Vanduser": ["63784"],
    "Vanzant": ["65768"],
    "Verona": ["65769"],
    "Versailles": ["65084"],
    "Viburnum": ["65566"],
    "Vichy": ["65580"],
    "Vienna": ["65582"],
    "Villa Ridge": ["63089"],
    "Vulcan": ["63675"],
    "Waco": ["64869"],
    "Waldron": ["64092"],
    "Walker": ["64790"],
    "Walnut Grove": ["65770"],
    "Walnut Shade": ["65771"],
    "Wappapello": ["63966"],
    "Wardell": ["63879"],
    "Warrensburg": ["64093"],
    "Warrenton": ["63383"],
    "Warsaw": ["65355"],
    "Washburn": ["65772"],
    "Washington": ["63090"],
    "Wasola": ["65773"],
    "Watson": ["64496"],
    "Waverly": ["64096"],
    "Wayland": ["63472"],
    "Waynesville": ["65583"],
    "Weatherby": ["64497"],
    "Weaubleau": ["65774"],
    "Webb City": ["64870"],
    "Wellington": ["64097"],
    "Wellsville": ["63384"],
    "Wentworth": ["64873"],
    "Wentzville": ["63385"],
    "Wesco": ["65586"],
    "West Alton": ["63386"],
    "West Plains": ["65775"],
    "Westboro": ["64498"],
    "Weston": ["64098"],
    "Westphalia": ["65085"],
    "Wheatland": ["65779"],
    "Wheaton": ["64874"],
    "Wheeling": ["64688"],
    "Whiteman Air Force Base": ["65305"],
    "Whiteoak": ["63880"],
    "Whiteside": ["63387"],
    "Whitewater": ["63785"],
    "Wildwood": ["63038", "63040"],
    "Willard": ["65781"],
    "Williamsburg": ["63388"],
    "Williamstown": ["63473"],
    "Williamsville": ["63967"],
    "Willow Springs": ["65793"],
    "Windsor": ["65360"],
    "Windyville": ["65783"],
    "Winfield": ["63389"],
    "Winigan": ["63566"],
    "Winona": ["65588"],
    "Winston": ["64689"],
    "Wolf Island": ["63881"],
    "Wooldridge": ["65287"],
    "Worth": ["64499"],
    "Worthington": ["63567"],
    "Wright City": ["63390"],
    "Wyaconda": ["63474"],
    "Wyatt": ["63882"],
    "Yukon": ["65589"],
    "Zalma": ["63787"],
    "Zanoni": ["65784"]
  },
  "MS": {
    "Abbeville": ["38601"],
    "Aberdeen": ["39730"],
    "Ackerman": ["39735"],
    "Algoma": ["38820"],
    "Alligator": ["38720"],
    "Amory": ["38821"],
    "Anguilla": ["38721"],
    "Arcola": ["38722"],
    "Arkabutla": ["38602"],
    "Artesia": ["39736"],
    "Ashland": ["38603"],
    "Avon": ["38723"],
    "Bailey": ["39320"],
    "Baldwyn": ["38824"],
    "Banner": ["38913"],
    "Bassfield": ["39421"],
    "Batesville": ["38606"],
    "Bay Saint Louis": ["39520", "39521"],
    "Bay Springs": ["39422"],
    "Beaumont": ["39423"],
    "Becker": ["38825"],
    "Belden": ["38826"],
    "Bellefontaine": ["39737"],
    "Belmont": ["38827"],
    "Belzoni": ["39038"],
    "Benoit": ["38725"],
    "Benton": ["39039"],
    "Bentonia": ["39040"],
    "Beulah": ["38726"],
    "Big Creek": ["38914"],
    "Biloxi": ["39530", "39531", "39532", "39533", "39534", "39535"],
    "Blue Mountain": ["38610"],
    "Blue Springs": ["38828"],
    "Bogue Chitto": ["39629"],
    "Bolton": ["39041"],
    "Booneville": ["38829"],
    "Boyle": ["38730"],
    "Brandon": ["39042", "39043", "39047"],
    "Braxton": ["39044"],
    "Brookhaven": ["39601", "39602", "39603"],
    "Brooklyn": ["39425"],
    "Brooksville": ["39739"],
    "Bruce": ["38915"],
    "Buckatunna": ["39322"],
    "Bude": ["39630"],
    "Burnsville": ["38833"],
    "Byhalia": ["38611"],
    "Byram": ["39272"],
    "Caledonia": ["39740"],
    "Calhoun City": ["38916"],
    "Camden": ["39045"],
    "Canton": ["39046"],
    "Carriere": ["39426"],
    "Carrollton": ["38917"],
    "Carson": ["39427"],
    "Carthage": ["39051"],
    "Cary": ["39054"],
    "Cascilla": ["38920"],
    "Cedarbluff": ["39741"],
    "Centreville": ["39631"],
    "Charleston": ["38921"],
    "Chatawa": ["39632"],
    "Chatham": ["38731"],
    "Chunky": ["39323"],
    "Clara": ["39324"],
    "Clarksdale": ["38614"],
    "Cleveland": ["38732", "38733"],
    "Clinton": ["39056", "39058", "39060"],
    "Coahoma": ["38617"],
    "Coffeeville": ["38922"],
    "Coila": ["38923"],
    "Coldwater": ["38618"],
    "Collins": ["39428"],
    "Collinsville": ["39325"],
    "Columbia": ["39429"],
    "Columbus": ["39701", "39702", "39703", "39704", "39705", "39710"],
    "Como": ["38619"],
    "Conehatta": ["39057"],
    "Corinth": ["38834", "38835"],
    "Courtland": ["38620"],
    "Crawford": ["39743"],
    "Crenshaw": ["38621"],
    "Crosby": ["39633"],
    "Crowder": ["38622"],
    "Cruger": ["38924"],
    "Crystal Springs": ["39059"],
    "D LO": ["39062"],
    "Daleville": ["39326"],
    "Darling": ["38623"],
    "De Kalb": ["39328"],
    "Decatur": ["39327"],
    "Delta City": ["39061"],
    "Dennis": ["38838"],
    "Derma": ["38839"],
    "Diamondhead": ["39525"],
    "Diberville": ["39540"],
    "Doddsville": ["38736"],
    "Drew": ["38737"],
    "Dublin": ["38739"],
    "Duck Hill": ["38925"],
    "Dumas": ["38625"],
    "Duncan": ["38740"],
    "Dundee": ["38626"],
    "Durant": ["39063"],
    "Eastabuchie": ["39436"],
    "Ecru": ["38841"],
    "Edwards": ["39066"],
    "Elliott": ["38926"],
    "Ellisville": ["39437"],
    "Enid": ["38927"],
    "Enterprise": ["39330"],
    "Escatawpa": ["39552"],
    "Ethel": ["39067"],
    "Etta": ["38627"],
    "Eupora": ["39744"],
    "Falkner": ["38629"],
    "Farrell": ["38630"],
    "Fayette": ["39069", "39081"],
    "Fernwood": ["39635"],
    "Flora": ["39071"],
    "Florence": ["39073"],
    "Flowood": ["39232"],
    "Forest": ["39074"],
    "Foxworth": ["39483"],
    "French Camp": ["39745"],
    "Friars Point": ["38631"],
    "Fulton": ["38843"],
    "Gallman": ["39077"],
    "Gattman": ["38844"],
    "Gautier": ["39553"],
    "Georgetown": ["39078"],
    "Glen": ["38846"],
    "Glen Allan": ["38744"],
    "Glendora": ["38928"],
    "Gloster": ["39638"],
    "Golden": ["38847"],
    "Goodman": ["39079"],
    "Gore Springs": ["38929"],
    "Grace": ["38745"],
    "Greenville": ["38701", "38702", "38703", "38704"],
    "Greenwood": ["38930", "38935", "38945"],
    "Greenwood Springs": ["38848"],
    "Grenada": ["38901", "38902"],
    "Gulfport": ["39501", "39502", "39503", "39505", "39506", "39507"],
    "Gunnison": ["38746"],
    "Guntown": ["38849"],
    "Hamilton": ["39746"],
    "Harperville": ["39080"],
    "Harrisville": ["39082"],
    "Hattiesburg": ["39401", "39402", "39403", "39404", "39406", "39407"],
    "Hazlehurst": ["39083"],
    "Heidelberg": ["39439"],
    "Hermanville": ["39086"],
    "Hernando": ["38632"],
    "Hickory": ["39332"],
    "Hickory Flat": ["38633"],
    "Hillsboro": ["39087"],
    "Holcomb": ["38940"],
    "Hollandale": ["38748"],
    "Holly Bluff": ["39088"],
    "Holly Springs": ["38634", "38635"],
    "Horn Lake": ["38637"],
    "Houlka": ["38850"],
    "Houston": ["38851"],
    "Hurley": ["39555"],
    "Independence": ["38638"],
    "Indianola": ["38749", "38751"],
    "Inverness": ["38753"],
    "Isola": ["38754"],
    "Itta Bena": ["38941"],
    "Iuka": ["38852"],
    "Jackson": ["39201", "39202", "39203", "39204", "39205", "39206", "39207", "39209", "39210", "39211", "39212", "39213", "39215", "39216", "39217", "39225", "39235", "39236", "39250", "39269", "39271", "39282", "39283", "39284", "39286", "39289", "39296", "39298"],
    "Jayess": ["39641"],
    "Jonestown": ["38639"],
    "Kilmichael": ["39747"],
    "Kiln": ["39556"],
    "Kokomo": ["39643"],
    "Kosciusko": ["39090"],
    "Lake": ["39092"],
    "Lake Cormorant": ["38641"],
    "Lakeshore": ["39558"],
    "Lamar": ["38642"],
    "Lambert": ["38643"],
    "Lauderdale": ["39335"],
    "Laurel": ["39440", "39441", "39442", "39443"],
    "Lawrence": ["39336"],
    "Leakesville": ["39451"],
    "Leland": ["38756"],
    "Lena": ["39094"],
    "Lexington": ["39095"],
    "Liberty": ["39645"],
    "Little Rock": ["39337"],
    "Long Beach": ["39560"],
    "Lorman": ["39096"],
    "Louin": ["39338"],
    "Louise": ["39097"],
    "Louisville": ["39339"],
    "Lucedale": ["39452"],
    "Ludlow": ["39098"],
    "Lula": ["38644"],
    "Lumberton": ["39455"],
    "Lyon": ["38645"],
    "Maben": ["39750"],
    "Macon": ["39341"],
    "Madden": ["39109"],
    "Madison": ["39110", "39130"],
    "Magee": ["39111"],
    "Magnolia": ["39652"],
    "Mantachie": ["38855"],
    "Mantee": ["39751"],
    "Marietta": ["38856"],
    "Marion": ["39342"],
    "Marks": ["38609", "38646"],
    "Mathiston": ["39752"],
    "Mayersville": ["39113"],
    "Mayhew": ["39753"],
    "Mc Adams": ["39107"],
    "Mc Call Creek": ["39647"],
    "Mc Carley": ["38943"],
    "Mc Cool": ["39108"],
    "Mc Henry": ["39561"],
    "Mc Lain": ["39456"],
    "Mc Neill": ["39457"],
    "Mccomb": ["39648", "39649"],
    "Meadville": ["39653"],
    "Memphis Stc": ["38675"],
    "Mendenhall": ["39114"],
    "Meridian": ["39301", "39302", "39303", "39304", "39305", "39307", "39309"],
    "Merigold": ["38759"],
    "Metcalfe": ["38760"],
    "Michigan City": ["38647"],
    "Midnight": ["39115"],
    "Minter City": ["38944"],
    "Mississippi State": ["39762"],
    "Mize": ["39116"],
    "Monticello": ["39654"],
    "Montpelier": ["39754"],
    "Mooreville": ["38857"],
    "Moorhead": ["38761"],
    "Morgan City": ["38946"],
    "Morton": ["39117"],
    "Moselle": ["39459"],
    "Moss": ["39460"],
    "Moss Point": ["39562", "39563"],
    "Mound Bayou": ["38762"],
    "Mount Olive": ["39119"],
    "Mount Pleasant": ["38649"],
    "Myrtle": ["38650"],
    "Natchez": ["39120", "39121", "39122"],
    "Neely": ["39461"],
    "Nesbit": ["38651"],
    "Nettleton": ["38858"],
    "New Albany": ["38652"],
    "New Augusta": ["39462"],
    "New Site": ["38859"],
    "Newhebron": ["39140"],
    "Newton": ["39345"],
    "Nicholson": ["39463"],
    "North Carrollton": ["38947"],
    "Noxapater": ["39346"],
    "Oak Vale": ["39656"],
    "Oakland": ["38948"],
    "Ocean Springs": ["39564", "39566"],
    "Okolona": ["38860"],
    "Olive Branch": ["38654"],
    "Osyka": ["39657"],
    "Ovett": ["39464"],
    "Oxford": ["38655"],
    "Pace": ["38764"],
    "Pachuta": ["39347"],
    "Panther Burn": ["38765"],
    "Parchman": ["38738"],
    "Paris": ["38949"],
    "Pascagoula": ["39567", "39568", "39569", "39581", "39595"],
    "Pass Christian": ["39571"],
    "Pattison": ["39144"],
    "Paulding": ["39348"],
    "Pearl": ["39208", "39288"],
    "Pearlington": ["39572"],
    "Pelahatchie": ["39145"],
    "Perkinston": ["39573"],
    "Petal": ["39465"],
    "Pheba": ["39755"],
    "Philadelphia": ["39350"],
    "Philipp": ["38950"],
    "Picayune": ["39466"],
    "Pickens": ["39146"],
    "Piney Woods": ["39148"],
    "Pinola": ["39149"],
    "Pittsboro": ["38951"],
    "Plantersville": ["38862"],
    "Pocahontas": ["39072"],
    "Pontotoc": ["38863"],
    "Pope": ["38658"],
    "Poplarville": ["39470"],
    "Port Gibson": ["39150"],
    "Porterville": ["39352"],
    "Potts Camp": ["38659"],
    "Prairie": ["39756"],
    "Prentiss": ["39474"],
    "Preston": ["39354"],
    "Puckett": ["39151"],
    "Pulaski": ["39152"],
    "Purvis": ["39475"],
    "Quitman": ["39355"],
    "Raleigh": ["39153"],
    "Randolph": ["38864"],
    "Raymond": ["39154"],
    "Red Banks": ["38661"],
    "Redwood": ["39156"],
    "Rena Lara": ["38767"],
    "Richland": ["39218"],
    "Richton": ["39476"],
    "Ridgeland": ["39157", "39158"],
    "Rienzi": ["38865"],
    "Ripley": ["38663"],
    "Robinsonville": ["38664"],
    "Rolling Fork": ["39159"],
    "Rome": ["38768"],
    "Rose Hill": ["39356"],
    "Rosedale": ["38769"],
    "Roxie": ["39661"],
    "Ruleville": ["38771"],
    "Ruth": ["39662"],
    "Sallis": ["39160"],
    "Saltillo": ["38866"],
    "Sandersville": ["39477"],
    "Sandhill": ["39161"],
    "Sandy Hook": ["39478"],
    "Sarah": ["38665"],
    "Sardis": ["38666"],
    "Satartia": ["39162"],
    "Saucier": ["39574"],
    "Schlater": ["38952"],
    "Scobey": ["38953"],
    "Scooba": ["39358"],
    "Scott": ["38772"],
    "Sebastopol": ["39359"],
    "Seminary": ["39479"],
    "Senatobia": ["38668"],
    "Shannon": ["38868"],
    "Sharon": ["39163"],
    "Shaw": ["38773"],
    "Shelby": ["38774"],
    "Sherard": ["38669"],
    "Sherman": ["38869"],
    "Shubuta": ["39360"],
    "Shuqualak": ["39361"],
    "Sibley": ["39165"],
    "Sidon": ["38954"],
    "Silver City": ["39166"],
    "Silver Creek": ["39663"],
    "Slate Spring": ["38955"],
    "Sledge": ["38628", "38670"],
    "Smithdale": ["39664"],
    "Smithville": ["38870"],
    "Sontag": ["39665"],
    "Soso": ["39480"],
    "Southaven": ["38671", "38672"],
    "Star": ["39167"],
    "Starkville": ["39759", "39760"],
    "State Line": ["39362"],
    "Steens": ["39766"],
    "Stennis Space Center": ["39522", "39529"],
    "Stewart": ["39767"],
    "Stoneville": ["38776"],
    "Stonewall": ["39363"],
    "Stringer": ["39481"],
    "Sturgis": ["39769"],
    "Summit": ["39666"],
    "Sumner": ["38957"],
    "Sumrall": ["39482"],
    "Sunflower": ["38778"],
    "Swan Lake": ["38958"],
    "Swiftown": ["38959"],
    "Taylor": ["38673"],
    "Taylorsville": ["39168"],
    "Tchula": ["39169"],
    "Terry": ["39170"],
    "Thaxton": ["38871"],
    "Thomastown": ["39171"],
    "Tie Plant": ["38960"],
    "Tillatoba": ["38961"],
    "Tinsley": ["39173"],
    "Tiplersville": ["38674"],
    "Tippo": ["38962"],
    "Tishomingo": ["38873"],
    "Toccopola": ["38874"],
    "Toomsuba": ["39364"],
    "Tougaloo": ["39174"],
    "Trebloc": ["38875"],
    "Tremont": ["38876"],
    "Tunica": ["38676"],
    "Tupelo": ["38801", "38802", "38803", "38804"],
    "Tutwiler": ["38963"],
    "Tylertown": ["39667"],
    "Union": ["39365"],
    "Union Church": ["39668"],
    "University": ["38677"],
    "Utica": ["39175"],
    "Vaiden": ["39176"],
    "Valley Park": ["39177"],
    "Van Vleet": ["38877"],
    "Vance": ["38964"],
    "Vancleave": ["39565"],
    "Vardaman": ["38878"],
    "Vaughan": ["39179"],
    "Verona": ["38879"],
    "Vicksburg": ["39180", "39181", "39182", "39183"],
    "Victoria": ["38679"],
    "Vossburg": ["39366"],
    "Walls": ["38680", "38686"],
    "Walnut": ["38683"],
    "Walnut Grove": ["39189"],
    "Walthall": ["39771"],
    "Washington": ["39190"],
    "Water Valley": ["38965"],
    "Waterford": ["38685"],
    "Waveland": ["39576"],
    "Waynesboro": ["39367"],
    "Wayside": ["38780"],
    "Webb": ["38966"],
    "Weir": ["39772"],
    "Wesson": ["39191"],
    "West": ["39192"],
    "West Point": ["39773"],
    "Wheeler": ["38880"],
    "Whitfield": ["39193"],
    "Wiggins": ["39577"],
    "Winona": ["38967"],
    "Winstonville": ["38781"],
    "Winterville": ["38782"],
    "Woodland": ["39776"],
    "Woodville": ["39669"],
    "Yazoo City": ["39194"]
  },
  "MT": {
    "Absarokee": ["59001"],
    "Acton": ["59002"],
    "Alberton": ["59820"],
    "Alder": ["59710"],
    "Alzada": ["59311"],
    "Anaconda": ["59711"],
    "Angela": ["59312"],
    "Antelope": ["59211"],
    "Arlee": ["59821"],
    "Ashland": ["59003", "59004"],
    "Augusta": ["59410"],
    "Avon": ["59713"],
    "Babb": ["59411"],
    "Bainville": ["59212"],
    "Baker": ["59313"],
    "Ballantine": ["59006"],
    "Basin": ["59631"],
    "Bearcreek": ["59007"],
    "Belfry": ["59008"],
    "Belgrade": ["59714"],
    "Belt": ["59412"],
    "Biddle": ["59314"],
    "Big Arm": ["59910"],
    "Big Sandy": ["59520"],
    "Big Sky": ["59716"],
    "Big Timber": ["59011"],
    "Bigfork": ["59911"],
    "Bighorn": ["59010"],
    "Billings": ["59101", "59102", "59103", "59104", "59105", "59106", "59107", "59108", "59111", "59112", "59114", "59115", "59116", "59117"],
    "Birney": ["59012"],
    "Black Eagle": ["59414"],
    "Bloomfield": ["59315"],
    "Bonner": ["59823"],
    "Boulder": ["59632"],
    "Box Elder": ["59521"],
    "Boyd": ["59013"],
    "Boyes": ["59316"],
    "Bozeman": ["59715", "59717", "59718", "59719", "59771", "59772", "59773"],
    "Brady": ["59416"],
    "Bridger": ["59014"],
    "Broadus": ["59317"],
    "Broadview": ["59015"],
    "Brockton": ["59213"],
    "Brockway": ["59214"],
    "Browning": ["59417"],
    "Brusett": ["59318"],
    "Buffalo": ["59418"],
    "Busby": ["59016"],
    "Butte": ["59701", "59702", "59703", "59707", "59750"],
    "Bynum": ["59419"],
    "Cameron": ["59720"],
    "Canyon Creek": ["59633"],
    "Capitol": ["59319"],
    "Cardwell": ["59721"],
    "Carter": ["59420"],
    "Cascade": ["59421"],
    "Charlo": ["59824"],
    "Chester": ["59522"],
    "Chinook": ["59523"],
    "Choteau": ["59422"],
    "Circle": ["59215"],
    "Clancy": ["59634"],
    "Clinton": ["59825"],
    "Clyde Park": ["59018"],
    "Coffee Creek": ["59424"],
    "Cohagen": ["59322"],
    "Colstrip": ["59323"],
    "Columbia Falls": ["59912"],
    "Columbus": ["59019"],
    "Condon": ["59826"],
    "Conner": ["59827"],
    "Conrad": ["59425"],
    "Cooke City": ["59020"],
    "Coram": ["59913"],
    "Corvallis": ["59828"],
    "Crane": ["59217"],
    "Crow Agency": ["59022"],
    "Culbertson": ["59218"],
    "Custer": ["59024"],
    "Cut Bank": ["59427"],
    "Dagmar": ["59219"],
    "Darby": ["59829"],
    "Dayton": ["59914"],
    "De Borgia": ["59830"],
    "Decker": ["59025"],
    "Deer Lodge": ["59722"],
    "Dell": ["59724"],
    "Denton": ["59430"],
    "Dillon": ["59725"],
    "Divide": ["59727"],
    "Dixon": ["59831"],
    "Dodson": ["59524"],
    "Drummond": ["59832"],
    "Dupuyer": ["59432"],
    "Dutton": ["59433"],
    "East Glacier Park": ["59434"],
    "East Helena": ["59635"],
    "Edgar": ["59026"],
    "Ekalaka": ["59324"],
    "Elliston": ["59728"],
    "Elmo": ["59915"],
    "Emigrant": ["59027"],
    "Ennis": ["59729"],
    "Essex": ["59916"],
    "Ethridge": ["59435"],
    "Eureka": ["59917"],
    "Fairfield": ["59436"],
    "Fairview": ["59221"],
    "Fallon": ["59326"],
    "Fishtail": ["59028"],
    "Flaxville": ["59222"],
    "Florence": ["59833"],
    "Floweree": ["59440"],
    "Forest Grove": ["59441"],
    "Forsyth": ["59327"],
    "Fort Benton": ["59442"],
    "Fort Harrison": ["59636"],
    "Fort Peck": ["59223"],
    "Fort Shaw": ["59443"],
    "Fort Smith": ["59035"],
    "Fortine": ["59918"],
    "Frazer": ["59225"],
    "Frenchtown": ["59834"],
    "Froid": ["59226"],
    "Fromberg": ["59029"],
    "Galata": ["59444"],
    "Gallatin Gateway": ["59730"],
    "Gardiner": ["59030"],
    "Garrison": ["59731"],
    "Garryowen": ["59031"],
    "Geraldine": ["59446"],
    "Geyser": ["59447"],
    "Gildford": ["59525"],
    "Glasgow": ["59230"],
    "Glen": ["59732"],
    "Glendive": ["59330"],
    "Glentana": ["59240"],
    "Gold Creek": ["59733"],
    "Grantsdale": ["59835"],
    "Grass Range": ["59032"],
    "Great Falls": ["59401", "59403", "59404", "59405", "59406"],
    "Greycliff": ["59033"],
    "Hall": ["59837"],
    "Hamilton": ["59840"],
    "Hammond": ["59332"],
    "Hardin": ["59034"],
    "Harlem": ["59526"],
    "Harlowton": ["59036"],
    "Harrison": ["59735"],
    "Hathaway": ["59333"],
    "Haugan": ["59842"],
    "Havre": ["59501"],
    "Hays": ["59527"],
    "Heart Butte": ["59448"],
    "Helena": ["59601", "59602", "59604", "59620", "59623", "59624", "59625", "59626"],
    "Helmville": ["59843"],
    "Heron": ["59844"],
    "Highwood": ["59450"],
    "Hilger": ["59451"],
    "Hingham": ["59528"],
    "Hinsdale": ["59241"],
    "Hobson": ["59452"],
    "Hogeland": ["59529"],
    "Homestead": ["59242"],
    "Hot Springs": ["59845"],
    "Hungry Horse": ["59919"],
    "Huntley": ["59037"],
    "Huson": ["59846"],
    "Hysham": ["59038"],
    "Ingomar": ["59039"],
    "Inverness": ["59530"],
    "Ismay": ["59336"],
    "Jackson": ["59736"],
    "Jefferson City": ["59638"],
    "Joliet": ["59041"],
    "Joplin": ["59531"],
    "Jordan": ["59337"],
    "Judith Gap": ["59453"],
    "Kalispell": ["59901", "59903", "59904"],
    "Kevin": ["59454"],
    "Kila": ["59920"],
    "Kinsey": ["59338"],
    "Kremlin": ["59532"],
    "Lake Mc Donald": ["59921"],
    "Lakeside": ["59922"],
    "Lambert": ["59243"],
    "Lame Deer": ["59043"],
    "Larslan": ["59244"],
    "Laurel": ["59044"],
    "Lavina": ["59046"],
    "Ledger": ["59456"],
    "Lewistown": ["59457"],
    "Libby": ["59923"],
    "Lima": ["59739"],
    "Lincoln": ["59639"],
    "Lindsay": ["59339"],
    "Livingston": ["59047"],
    "Lloyd": ["59535"],
    "Lodge Grass": ["59050"],
    "Lolo": ["59847"],
    "Loma": ["59460"],
    "Lonepine": ["59848"],
    "Loring": ["59537"],
    "Lothair": ["59461"],
    "Malmstrom AFB": ["59402"],
    "Malta": ["59538"],
    "Manhattan": ["59741"],
    "Marion": ["59925"],
    "Martin City": ["59926"],
    "Martinsdale": ["59053"],
    "Marysville": ["59640"],
    "Mc Allister": ["59740"],
    "Mc Leod": ["59052"],
    "Medicine Lake": ["59247"],
    "Melrose": ["59743"],
    "Melstone": ["59054"],
    "Melville": ["59055"],
    "Mildred": ["59341"],
    "Miles City": ["59301"],
    "Milltown": ["59851"],
    "Missoula": ["59801", "59802", "59803", "59804", "59806", "59807", "59808", "59812"],
    "Moccasin": ["59462"],
    "Molt": ["59057"],
    "Monarch": ["59463"],
    "Moore": ["59464"],
    "Mosby": ["59058"],
    "Musselshell": ["59059"],
    "Nashua": ["59248"],
    "Neihart": ["59465"],
    "Norris": ["59745"],
    "Noxon": ["59853"],
    "Nye": ["59061"],
    "Oilmont": ["59466"],
    "Olive": ["59343"],
    "Olney": ["59927"],
    "Opheim": ["59250"],
    "Otter": ["59062"],
    "Outlook": ["59252"],
    "Ovando": ["59854"],
    "Pablo": ["59855"],
    "Paradise": ["59856"],
    "Park City": ["59063"],
    "Peerless": ["59253"],
    "Pendroy": ["59467"],
    "Philipsburg": ["59858"],
    "Pinesdale": ["59841"],
    "Plains": ["59859"],
    "Plentywood": ["59254"],
    "Plevna": ["59344"],
    "Polaris": ["59746"],
    "Polebridge": ["59928"],
    "Polson": ["59860"],
    "Pompeys Pillar": ["59064"],
    "Pony": ["59747"],
    "Poplar": ["59255"],
    "Powderville": ["59345"],
    "Power": ["59468"],
    "Pray": ["59065"],
    "Proctor": ["59929"],
    "Pryor": ["59066"],
    "Radersburg": ["59641"],
    "Ramsay": ["59748"],
    "Rapelje": ["59067"],
    "Ravalli": ["59863"],
    "Raymond": ["59256"],
    "Raynesford": ["59469"],
    "Red Lodge": ["59068"],
    "Redstone": ["59257"],
    "Reed Point": ["59069"],
    "Reserve": ["59258"],
    "Rexford": ["59930"],
    "Richey": ["59259"],
    "Richland": ["59260"],
    "Ringling": ["59642"],
    "Roberts": ["59070"],
    "Rollins": ["59931"],
    "Ronan": ["59864"],
    "Roscoe": ["59071"],
    "Rosebud": ["59347"],
    "Roundup": ["59072", "59073"],
    "Roy": ["59471"],
    "Rudyard": ["59540"],
    "Ryegate": ["59074"],
    "Saco": ["59261"],
    "Saint Ignatius": ["59865"],
    "Saint Marie": ["59231"],
    "Saint Regis": ["59866"],
    "Saint Xavier": ["59075"],
    "Saltese": ["59867"],
    "Sand Coulee": ["59472"],
    "Sand Springs": ["59077"],
    "Sanders": ["59076"],
    "Savage": ["59262"],
    "Scobey": ["59263"],
    "Seeley Lake": ["59868"],
    "Shawmut": ["59078"],
    "Shelby": ["59474"],
    "Shepherd": ["59079"],
    "Sheridan": ["59749"],
    "Sidney": ["59270"],
    "Silver Gate": ["59081"],
    "Silver Star": ["59751"],
    "Simms": ["59477"],
    "Somers": ["59932"],
    "Springdale": ["59082"],
    "Stanford": ["59479"],
    "Stevensville": ["59870"],
    "Stockett": ["59480"],
    "Stryker": ["59933"],
    "Sula": ["59871"],
    "Sumatra": ["59083"],
    "Sun River": ["59483"],
    "Sunburst": ["59482"],
    "Superior": ["59872"],
    "Sweet Grass": ["59484"],
    "Teigen": ["59084"],
    "Terry": ["59349"],
    "Thompson Falls": ["59873"],
    "Three Forks": ["59752"],
    "Toston": ["59643"],
    "Townsend": ["59644"],
    "Trego": ["59934"],
    "Trout Creek": ["59874"],
    "Troy": ["59935"],
    "Turner": ["59542"],
    "Twin Bridges": ["59754"],
    "Two Dot": ["59085"],
    "Ulm": ["59485"],
    "Valier": ["59486"],
    "Vandalia": ["59273"],
    "Vaughn": ["59487"],
    "Victor": ["59875"],
    "Vida": ["59274"],
    "Virginia City": ["59755"],
    "Volborg": ["59351"],
    "Warm Springs": ["59756"],
    "West Glacier": ["59936"],
    "West Yellowstone": ["59758"],
    "Westby": ["59275"],
    "White Sulphur Springs": ["59645"],
    "Whitefish": ["59937"],
    "Whitehall": ["59759"],
    "Whitetail": ["59276"],
    "Whitewater": ["59544"],
    "Whitlash": ["59545"],
    "Wibaux": ["59353"],
    "Willard": ["59354"],
    "Willow Creek": ["59760"],
    "Wilsall": ["59086"],
    "Winifred": ["59489"],
    "Winnett": ["59087"],
    "Winston": ["59647"],
    "Wisdom": ["59761"],
    "Wise River": ["59762"],
    "Wolf Creek": ["59648"],
    "Wolf Point": ["59201"],
    "Worden": ["59088"],
    "Wyola": ["59089"],
    "Zortman": ["59546"],
    "Zurich": ["59547"]
  },
  "NC": {
    "Aberdeen": ["28315"],
    "Advance": ["27006"],
    "Ahoskie": ["27910"],
    "Alamance": ["27201"],
    "Albemarle": ["28001", "28002"],
    "Albertson": ["28508"],
    "Alexander": ["28701"],
    "Alexis": ["28006"],
    "Alliance": ["28509"],
    "Almond": ["28702"],
    "Altamahaw": ["27202"],
    "Andrews": ["28901"],
    "Angier": ["27501"],
    "Ansonville": ["28007"],
    "Apex": ["27502", "27523", "27539"],
    "Arapahoe": ["28510"],
    "Ararat": ["27007"],
    "Arden": ["28704"],
    "Ash": ["28420"],
    "Asheboro": ["27203", "27204", "27205"],
    "Asheville": ["28801", "28802", "28803", "28804", "28805", "28806", "28810", "28813", "28814", "28815", "28816"],
    "Atkinson": ["28421"],
    "Atlantic": ["28511"],
    "Atlantic Beach": ["28512"],
    "Aulander": ["27805"],
    "Aurora": ["27806"],
    "Autryville": ["28318"],
    "Avon": ["27915"],
    "Ayden": ["28513"],
    "Aydlett": ["27916"],
    "Badin": ["28009"],
    "Bahama": ["27503"],
    "Bailey": ["27807"],
    "Bakersville": ["28705"],
    "Balsam": ["28707"],
    "Balsam Grove": ["28708"],
    "Banner Elk": ["28604"],
    "Barco": ["27917"],
    "Barium Springs": ["28010"],
    "Barnardsville": ["28709"],
    "Barnesville": ["28319"],
    "Bat Cave": ["28710"],
    "Bath": ["27808"],
    "Battleboro": ["27809"],
    "Bayboro": ["28515"],
    "Bear Creek": ["27207"],
    "Beaufort": ["28516"],
    "Belews Creek": ["27009"],
    "Belhaven": ["27810"],
    "Bellarthur": ["27811"],
    "Belmont": ["28012"],
    "Belvidere": ["27919"],
    "Bennett": ["27208"],
    "Benson": ["27504"],
    "Bessemer City": ["28016"],
    "Bethania": ["27010"],
    "Bethel": ["27812"],
    "Beulaville": ["28518"],
    "Biscoe": ["27209"],
    "Black Creek": ["27813"],
    "Black Mountain": ["28711"],
    "Bladenboro": ["28320"],
    "Blanch": ["27212"],
    "Blounts Creek": ["27814"],
    "Blowing Rock": ["28605"],
    "Boiling Springs": ["28017"],
    "Bolivia": ["28422"],
    "Bolton": ["28423"],
    "Bonlee": ["27213"],
    "Boomer": ["28606"],
    "Boone": ["28607", "28608"],
    "Boonville": ["27011"],
    "Bostic": ["28018"],
    "Brasstown": ["28902"],
    "Brevard": ["28712"],
    "Bridgeton": ["28519"],
    "Broadway": ["27505"],
    "Browns Summit": ["27214"],
    "Brunswick": ["28424"],
    "Bryson City": ["28713"],
    "Buies Creek": ["27506"],
    "Bullock": ["27507"],
    "Bunn": ["27508"],
    "Bunnlevel": ["28323"],
    "Burgaw": ["28425"],
    "Burlington": ["27215", "27216", "27217", "27220"],
    "Burnsville": ["28714"],
    "Butner": ["27509"],
    "Buxton": ["27920"],
    "Bynum": ["27228"],
    "Calabash": ["28467"],
    "Calypso": ["28325"],
    "Camden": ["27921"],
    "Cameron": ["28326"],
    "Camp Lejeune": ["28542", "28547"],
    "Candler": ["28715"],
    "Candor": ["27229"],
    "Canton": ["28716"],
    "Caroleen": ["28019"],
    "Carolina Beach": ["28428"],
    "Carrboro": ["27510"],
    "Carthage": ["28327"],
    "Cary": ["27511", "27512", "27513", "27518", "27519"],
    "Casar": ["28020"],
    "Cashiers": ["28717"],
    "Castalia": ["27816"],
    "Castle Hayne": ["28429"],
    "Catawba": ["28609"],
    "Cedar Falls": ["27230"],
    "Cedar Grove": ["27231"],
    "Cedar Island": ["28520"],
    "Cedar Mountain": ["28718"],
    "Cerro Gordo": ["28430"],
    "Chadbourn": ["28431"],
    "Chapel Hill": ["27514", "27515", "27516", "27517", "27599"],
    "Charlotte": ["28201", "28202", "28203", "28204", "28205", "28206", "28207", "28208", "28209", "28210", "28211", "28212", "28213", "28214", "28215", "28216", "28217", "28218", "28219", "28220", "28221", "28222", "28223", "28224", "28226", "28227", "28228", "28229", "28230", "28231", "28232", "28233", "28234", "28235", "28236", "28237", "28241", "28242", "28243", "28244", "28246", "28247", "28250", "28253", "28254", "28255", "28256", "28258", "28260", "28262", "28263", "28265", "28266", "28269", "28270", "28271", "28272", "28273", "28274", "28275", "28277", "28278", "28280", "28281", "28282", "28284", "28285", "28287", "28288", "28289", "28290", "28296", "28297", "28299"],
    "Cherokee": ["28719"],
    "Cherry Point": ["28533"],
    "Cherryville": ["28021"],
    "Chimney Rock": ["28720"],
    "China Grove": ["28023"],
    "Chinquapin": ["28521"],
    "Chocowinity": ["27817"],
    "Claremont": ["28610"],
    "Clarendon": ["28432"],
    "Clarkton": ["28433"],
    "Clayton": ["27520", "27527", "27528"],
    "Clemmons": ["27012"],
    "Cleveland": ["27013"],
    "Cliffside": ["28024"],
    "Climax": ["27233"],
    "Clinton": ["28328", "28329"],
    "Clyde": ["28721"],
    "Coats": ["27521"],
    "Cofield": ["27922"],
    "Coinjock": ["27923"],
    "Colerain": ["27924"],
    "Colfax": ["27235"],
    "Collettsville": ["28611"],
    "Columbia": ["27925"],
    "Columbus": ["28722"],
    "Comfort": ["28522"],
    "Como": ["27818"],
    "Concord": ["28025", "28026", "28027"],
    "Conetoe": ["27819"],
    "Connelly Springs": ["28612"],
    "Conover": ["28613"],
    "Conway": ["27820"],
    "Cooleemee": ["27014"],
    "Corapeake": ["27926"],
    "Cordova": ["28330"],
    "Cornelius": ["28031"],
    "Corolla": ["27927"],
    "Council": ["28434"],
    "Cove City": ["28523"],
    "Cramerton": ["28032"],
    "Creedmoor": ["27522", "27564"],
    "Creston": ["28615"],
    "Creswell": ["27928"],
    "Crossnore": ["28616"],
    "Crouse": ["28033"],
    "Crumpler": ["28617"],
    "Culberson": ["28903"],
    "Cullowhee": ["28723"],
    "Cumberland": ["28331"],
    "Cumnock": ["27237"],
    "Currie": ["28435"],
    "Currituck": ["27929"],
    "Dallas": ["28034"],
    "Dana": ["28724"],
    "Danbury": ["27016"],
    "Davidson": ["28035", "28036"],
    "Davis": ["28524"],
    "Deep Gap": ["28618"],
    "Deep Run": ["28525"],
    "Delco": ["28436"],
    "Denton": ["27239"],
    "Denver": ["28037"],
    "Dillsboro": ["28725"],
    "Dobson": ["27017"],
    "Dover": ["28526"],
    "Drexel": ["28619"],
    "Dublin": ["28332"],
    "Dudley": ["28333"],
    "Dunn": ["28334", "28335"],
    "Durham": ["27701", "27702", "27703", "27704", "27705", "27706", "27707", "27708", "27709", "27710", "27711", "27712", "27713", "27715", "27717", "27722"],
    "Eagle Springs": ["27242"],
    "Earl": ["28038"],
    "East Bend": ["27018"],
    "East Flat Rock": ["28726"],
    "East Spencer": ["28039"],
    "Eden": ["27288", "27289"],
    "Edenton": ["27932"],
    "Edneyville": ["28727"],
    "Edward": ["27821"],
    "Efland": ["27243"],
    "Elizabeth City": ["27906", "27907", "27909"],
    "Elizabethtown": ["28337"],
    "Elk Park": ["28622"],
    "Elkin": ["28621"],
    "Ellenboro": ["28040"],
    "Ellerbe": ["28338"],
    "Elm City": ["27822"],
    "Elon": ["27244"],
    "Emerald Isle": ["28594"],
    "Enfield": ["27823"],
    "Engelhard": ["27824"],
    "Enka": ["28728"],
    "Ennice": ["28623"],
    "Ernul": ["28527"],
    "Erwin": ["28339"],
    "Ether": ["27247"],
    "Etowah": ["28729"],
    "Eure": ["27935"],
    "Everetts": ["27825"],
    "Evergreen": ["28438"],
    "Fair Bluff": ["28439"],
    "Fairfield": ["27826"],
    "Fairmont": ["28340"],
    "Fairview": ["28730"],
    "Faison": ["28341"],
    "Faith": ["28041"],
    "Falcon": ["28342"],
    "Falkland": ["27827"],
    "Fallston": ["28042"],
    "Farmville": ["27828"],
    "Fayetteville": ["28301", "28302", "28303", "28304", "28305", "28306", "28309", "28311", "28312", "28314"],
    "Ferguson": ["28624"],
    "Flat Rock": ["28731"],
    "Fleetwood": ["28626"],
    "Fletcher": ["28732"],
    "Fontana Dam": ["28733"],
    "Forest City": ["28043"],
    "Fort Bragg": ["28307", "28310"],
    "Fountain": ["27829"],
    "Four Oaks": ["27524"],
    "Franklin": ["28734", "28744"],
    "Franklinton": ["27525"],
    "Franklinville": ["27248"],
    "Fremont": ["27830"],
    "Frisco": ["27936"],
    "Fuquay Varina": ["27526"],
    "Garland": ["28441"],
    "Garner": ["27529"],
    "Garysburg": ["27831"],
    "Gaston": ["27832"],
    "Gastonia": ["28052", "28053", "28054", "28055", "28056"],
    "Gates": ["27937"],
    "Gatesville": ["27938"],
    "Germanton": ["27019"],
    "Gerton": ["28735"],
    "Gibson": ["28343"],
    "Gibsonville": ["27249"],
    "Glade Valley": ["28627"],
    "Glen Alpine": ["28628"],
    "Glendale Springs": ["28629"],
    "Glenville": ["28736"],
    "Glenwood": ["28737"],
    "Gloucester": ["28528"],
    "Godwin": ["28344"],
    "Gold Hill": ["28071"],
    "Goldsboro": ["27530", "27531", "27532", "27533", "27534"],
    "Goldston": ["27252"],
    "Graham": ["27253"],
    "Grandy": ["27939"],
    "Granite Falls": ["28630"],
    "Granite Quarry": ["28072"],
    "Grantsboro": ["28529"],
    "Grassy Creek": ["28631"],
    "Green Mountain": ["28740"],
    "Greensboro": ["27395", "27401", "27402", "27403", "27404", "27405", "27406", "27407", "27408", "27409", "27410", "27411", "27412", "27413", "27415", "27416", "27417", "27419", "27420", "27425", "27427", "27429", "27435", "27438", "27455", "27480", "27495", "27497", "27498", "27499"],
    "Greenville": ["27833", "27834", "27835", "27836", "27858"],
    "Grifton": ["28530"],
    "Grimesland": ["27837"],
    "Grover": ["28073"],
    "Gulf": ["27256"],
    "Halifax": ["27839"],
    "Hallsboro": ["28442"],
    "Hamilton": ["27840"],
    "Hamlet": ["28345"],
    "Hampstead": ["28443"],
    "Hamptonville": ["27020"],
    "Harbinger": ["27941"],
    "Harkers Island": ["28531"],
    "Harmony": ["28634"],
    "Harrells": ["28444"],
    "Harrellsville": ["27942"],
    "Harris": ["28074"],
    "Harrisburg": ["28075"],
    "Hassell": ["27841"],
    "Hatteras": ["27943"],
    "Havelock": ["28532"],
    "Haw River": ["27258"],
    "Hayesville": ["28904"],
    "Hays": ["28635"],
    "Hazelwood": ["28738"],
    "Henderson": ["27536", "27537"],
    "Hendersonville": ["28739", "28791", "28792", "28793"],
    "Henrico": ["27842"],
    "Henrietta": ["28076"],
    "Hertford": ["27930", "27944"],
    "Hickory": ["28601", "28602", "28603"],
    "Hiddenite": ["28636"],
    "High Point": ["27260", "27261", "27262", "27263", "27264", "27265", "27268"],
    "High Shoals": ["28077"],
    "Highfalls": ["27259"],
    "Highlands": ["28741"],
    "Hildebran": ["28637"],
    "Hillsborough": ["27278"],
    "Hobbsville": ["27946"],
    "Hobgood": ["27843"],
    "Hobucken": ["28537"],
    "Hoffman": ["28347"],
    "Hollister": ["27844"],
    "Holly Ridge": ["28445"],
    "Holly Springs": ["27540"],
    "Hookerton": ["28538"],
    "Hope Mills": ["28348"],
    "Horse Shoe": ["28742"],
    "Hot Springs": ["28743"],
    "Hubert": ["28539"],
    "Hudson": ["28638"],
    "Huntersville": ["28070", "28078"],
    "Hurdle Mills": ["27541"],
    "Icard": ["28666"],
    "Indian Trail": ["28079"],
    "Iron Station": ["28080"],
    "Ivanhoe": ["28447"],
    "Jackson": ["27845"],
    "Jackson Springs": ["27281"],
    "Jacksonville": ["28540", "28541", "28546"],
    "Jamestown": ["27282"],
    "Jamesville": ["27846"],
    "Jarvisburg": ["27947"],
    "Jefferson": ["28640"],
    "Jonas Ridge": ["28641"],
    "Jonesville": ["28642"],
    "Julian": ["27283"],
    "Kannapolis": ["28081", "28082", "28083"],
    "Kelford": ["27847"],
    "Kelly": ["28448"],
    "Kenansville": ["28349"],
    "Kenly": ["27542"],
    "Kernersville": ["27284", "27285"],
    "Kill Devil Hills": ["27948"],
    "King": ["27021"],
    "Kings Mountain": ["28086"],
    "Kinston": ["28501", "28502", "28503", "28504"],
    "Kipling": ["27543"],
    "Kittrell": ["27544"],
    "Kitty Hawk": ["27949"],
    "Knightdale": ["27545"],
    "Knotts Island": ["27950"],
    "Kure Beach": ["28449"],
    "La Grange": ["28551"],
    "Lake Junaluska": ["28745"],
    "Lake Lure": ["28746"],
    "Lake Toxaway": ["28747"],
    "Lake Waccamaw": ["28450"],
    "Lakeview": ["28350"],
    "Landis": ["28088"],
    "Lansing": ["28643"],
    "Lattimore": ["28089"],
    "Laurel Hill": ["28351"],
    "Laurel Springs": ["28644"],
    "Laurinburg": ["28352", "28353"],
    "Lawndale": ["28090"],
    "Lawsonville": ["27022"],
    "Leasburg": ["27291"],
    "Leicester": ["28748"],
    "Leland": ["28451"],
    "Lemon Springs": ["28355"],
    "Lenoir": ["28633", "28645"],
    "Lewiston Woodville": ["27849"],
    "Lewisville": ["27023"],
    "Lexington": ["27292", "27293", "27294", "27295"],
    "Liberty": ["27298"],
    "Lilesville": ["28091"],
    "Lillington": ["27546"],
    "Lincolnton": ["28092", "28093"],
    "Linden": ["28356"],
    "Linville": ["28646"],
    "Linville Falls": ["28647"],
    "Linwood": ["27299"],
    "Little Switzerland": ["28749"],
    "Littleton": ["27850"],
    "Locust": ["28097"],
    "Longwood": ["28452"],
    "Louisburg": ["27549"],
    "Lowell": ["28098"],
    "Lowgap": ["27024"],
    "Lowland": ["28552"],
    "Lucama": ["27851"],
    "Lumber Bridge": ["28357"],
    "Lumberton": ["28358", "28359", "28360"],
    "Lynn": ["28750"],
    "Macclesfield": ["27852"],
    "Macon": ["27551"],
    "Madison": ["27025"],
    "Maggie Valley": ["28751"],
    "Magnolia": ["28453"],
    "Maiden": ["28650"],
    "Mamers": ["27552"],
    "Manns Harbor": ["27953"],
    "Manson": ["27553"],
    "Manteo": ["27954"],
    "Maple": ["27956"],
    "Maple Hill": ["28454"],
    "Marble": ["28905"],
    "Margarettsville": ["27853"],
    "Marietta": ["28362"],
    "Marion": ["28752"],
    "Mars Hill": ["28754"],
    "Marshall": ["28753"],
    "Marshallberg": ["28553"],
    "Marshville": ["28103"],
    "Marston": ["28363"],
    "Matthews": ["28104", "28105", "28106"],
    "Maury": ["28554"],
    "Maxton": ["28364"],
    "Mayodan": ["27027"],
    "Maysville": ["28555"],
    "Mc Adenville": ["28101"],
    "Mc Farlan": ["28102"],
    "Mc Grady": ["28649"],
    "Mc Leansville": ["27301"],
    "Mccutcheon Field": ["28545"],
    "Mebane": ["27302"],
    "Merritt": ["28556"],
    "Merry Hill": ["27957"],
    "Micaville": ["28755"],
    "Micro": ["27555"],
    "Middleburg": ["27556"],
    "Middlesex": ["27557"],
    "Midland": ["28107"],
    "Midway Park": ["28544"],
    "Mill Spring": ["28756"],
    "Millers Creek": ["28651"],
    "Mills River": ["28759"],
    "Milton": ["27305"],
    "Milwaukee": ["27854"],
    "Mineral Springs": ["28108"],
    "Minneapolis": ["28652"],
    "Misenheimer": ["28109"],
    "Mocksville": ["27028"],
    "Moncure": ["27559"],
    "Monroe": ["28110", "28111", "28112"],
    "Montezuma": ["28653"],
    "Montreat": ["28757"],
    "Mooresboro": ["28114"],
    "Mooresville": ["28115", "28117"],
    "Moravian Falls": ["28654"],
    "Morehead City": ["28557"],
    "Morganton": ["28655", "28680"],
    "Morrisville": ["27560"],
    "Morven": ["28119"],
    "Mount Airy": ["27030", "27031"],
    "Mount Gilead": ["27306"],
    "Mount Holly": ["28120"],
    "Mount Mourne": ["28123"],
    "Mount Olive": ["28365"],
    "Mount Pleasant": ["28124"],
    "Mount Ulla": ["28125"],
    "Mountain Home": ["28758"],
    "Moyock": ["27958"],
    "Murfreesboro": ["27855"],
    "Murphy": ["28906"],
    "Nags Head": ["27959"],
    "Nakina": ["28455"],
    "Naples": ["28760"],
    "Nashville": ["27856"],
    "Nebo": ["28761"],
    "New Bern": ["28560", "28561", "28562", "28563", "28564"],
    "New Hill": ["27562"],
    "New London": ["28127"],
    "Newell": ["28126"],
    "Newland": ["28657"],
    "Newport": ["28570"],
    "Newton": ["28658"],
    "Newton Grove": ["28366"],
    "Norlina": ["27563"],
    "Norman": ["28367"],
    "North Wilkesboro": ["28656", "28659", "28674"],
    "Norwood": ["28128"],
    "Oak City": ["27857"],
    "Oak Island": ["28465"],
    "Oak Ridge": ["27310"],
    "Oakboro": ["28129"],
    "Ocean Isle Beach": ["28469"],
    "Ocracoke": ["27960"],
    "Old Fort": ["28762"],
    "Olin": ["28660"],
    "Olivia": ["28368"],
    "Oriental": ["28571"],
    "Orrum": ["28369"],
    "Otto": ["28763"],
    "Oxford": ["27565"],
    "Pantego": ["27860"],
    "Parkton": ["28371"],
    "Parmele": ["27861"],
    "Patterson": ["28661"],
    "Paw Creek": ["28130"],
    "Peachland": ["28133"],
    "Pelham": ["27311"],
    "Pembroke": ["28372"],
    "Pendleton": ["27862"],
    "Penland": ["28765"],
    "Penrose": ["28766"],
    "Pfafftown": ["27040"],
    "Pikeville": ["27863"],
    "Pilot Mountain": ["27041"],
    "Pine Hall": ["27042"],
    "Pine Level": ["27568"],
    "Pinebluff": ["28373"],
    "Pinehurst": ["28370", "28374"],
    "Pineola": ["28662"],
    "Pinetops": ["27864"],
    "Pinetown": ["27865"],
    "Pineville": ["28134"],
    "Piney Creek": ["28663"],
    "Pink Hill": ["28572"],
    "Pinnacle": ["27043"],
    "Pisgah Forest": ["28768"],
    "Pittsboro": ["27312"],
    "Pleasant Garden": ["27313"],
    "Pleasant Hill": ["27866"],
    "Plumtree": ["28664"],
    "Plymouth": ["27962"],
    "Point Harbor": ["27964"],
    "Polkton": ["28135"],
    "Polkville": ["28136"],
    "Pollocksville": ["28573"],
    "Pope Army Airfield": ["28308"],
    "Poplar Branch": ["27965"],
    "Potecasi": ["27867"],
    "Powells Point": ["27966"],
    "Powellsville": ["27967"],
    "Princeton": ["27569"],
    "Proctorville": ["28375"],
    "Prospect Hill": ["27314"],
    "Providence": ["27315"],
    "Purlear": ["28665"],
    "Raeford": ["28376"],
    "Raleigh": ["27601", "27602", "27603", "27604", "27605", "27606", "27607", "27608", "27609", "27610", "27611", "27612", "27613", "27614", "27615", "27616", "27617", "27619", "27620", "27621", "27622", "27623", "27624", "27625", "27626", "27627", "27628", "27629", "27634", "27635", "27636", "27640", "27650", "27656", "27658", "27661", "27668", "27675", "27676", "27690", "27695", "27697", "27698", "27699"],
    "Ramseur": ["27316"],
    "Randleman": ["27317"],
    "Red Oak": ["27868"],
    "Red Springs": ["28377"],
    "Reidsville": ["27320", "27321", "27322", "27323"],
    "Rex": ["28378"],
    "Rhodhiss": ["28667"],
    "Rich Square": ["27869"],
    "Richfield": ["28137"],
    "Richlands": ["28574"],
    "Ridgecrest": ["28770"],
    "Ridgeway": ["27570"],
    "Riegelwood": ["28456"],
    "Roanoke Rapids": ["27870"],
    "Roaring Gap": ["28668"],
    "Roaring River": ["28669"],
    "Robbins": ["27325"],
    "Robbinsville": ["28771"],
    "Robersonville": ["27871"],
    "Rockingham": ["28379", "28380"],
    "Rockwell": ["28138"],
    "Rocky Mount": ["27801", "27802", "27803", "27804", "27815"],
    "Rocky Point": ["28457"],
    "Rodanthe": ["27968"],
    "Roduco": ["27969"],
    "Rolesville": ["27571"],
    "Ronda": ["28670"],
    "Roper": ["27970"],
    "Rose Hill": ["28458"],
    "Roseboro": ["28382"],
    "Rosman": ["28772"],
    "Rougemont": ["27572"],
    "Rowland": ["28383"],
    "Roxboro": ["27573", "27574"],
    "Roxobel": ["27872"],
    "Ruffin": ["27326"],
    "Rural Hall": ["27045", "27094", "27098", "27099"],
    "Rutherford College": ["28671"],
    "Rutherfordton": ["28139"],
    "Saint Pauls": ["28384"],
    "Salemburg": ["28385"],
    "Salisbury": ["28144", "28145", "28146", "28147"],
    "Salter Path": ["28575"],
    "Saluda": ["28773"],
    "Salvo": ["27972"],
    "Sandy Ridge": ["27046"],
    "Sanford": ["27330", "27331", "27332"],
    "Sapphire": ["28774"],
    "Saratoga": ["27873"],
    "Saxapahaw": ["27340"],
    "Scaly Mountain": ["28775"],
    "Scotland Neck": ["27874"],
    "Scotts": ["28699"],
    "Scottville": ["28672"],
    "Scranton": ["27875"],
    "Seaboard": ["27876"],
    "Seagrove": ["27341"],
    "Sealevel": ["28577"],
    "Sedalia": ["27342"],
    "Selma": ["27576"],
    "Semora": ["27343"],
    "Seven Springs": ["28578"],
    "Severn": ["27877"],
    "Shallotte": ["28459", "28470"],
    "Shannon": ["28386"],
    "Sharpsburg": ["27878"],
    "Shawboro": ["27973"],
    "Shelby": ["28150", "28151", "28152"],
    "Sherrills Ford": ["28673"],
    "Shiloh": ["27974"],
    "Siler City": ["27344"],
    "Siloam": ["27047"],
    "Simpson": ["27879"],
    "Sims": ["27880"],
    "Skyland": ["28776"],
    "Smithfield": ["27577"],
    "Smyrna": ["28579"],
    "Sneads Ferry": ["28460"],
    "Snow Camp": ["27349"],
    "Snow Hill": ["28580"],
    "Sophia": ["27350"],
    "South Mills": ["27976"],
    "Southern Pines": ["28387", "28388"],
    "Southmont": ["27351"],
    "Southport": ["28461"],
    "Sparta": ["28675"],
    "Speed": ["27881"],
    "Spencer": ["28159"],
    "Spindale": ["28160"],
    "Spring Hope": ["27882"],
    "Spring Lake": ["28390"],
    "Spruce Pine": ["28777"],
    "Stacy": ["28581"],
    "Staley": ["27355"],
    "Stanfield": ["28163"],
    "Stanley": ["28164"],
    "Stantonsburg": ["27883"],
    "Star": ["27356"],
    "State Road": ["28676"],
    "Statesville": ["28625", "28677", "28687"],
    "Stedman": ["28391"],
    "Stella": ["28582"],
    "Stem": ["27581"],
    "Stokes": ["27884"],
    "Stokesdale": ["27357"],
    "Stoneville": ["27048"],
    "Stonewall": ["28583"],
    "Stony Point": ["28678"],
    "Stovall": ["27582"],
    "Stumpy Point": ["27978"],
    "Sugar Grove": ["28679"],
    "Summerfield": ["27358"],
    "Sunbury": ["27979"],
    "Sunset Beach": ["28468"],
    "Supply": ["28462"],
    "Swannanoa": ["28778"],
    "Swanquarter": ["27885"],
    "Swansboro": ["28584"],
    "Swepsonville": ["27359"],
    "Sylva": ["28779"],
    "Tabor City": ["28463"],
    "Tar Heel": ["28392"],
    "Tarawa Terrace": ["28543"],
    "Tarboro": ["27886"],
    "Taylorsville": ["28681"],
    "Teachey": ["28464"],
    "Terrell": ["28682"],
    "Thomasville": ["27360", "27361"],
    "Thurmond": ["28683"],
    "Tillery": ["27887"],
    "Timberlake": ["27583"],
    "Toast": ["27049"],
    "Tobaccoville": ["27050"],
    "Todd": ["28684"],
    "Topton": ["28781"],
    "Townsville": ["27584"],
    "Traphill": ["28685"],
    "Trenton": ["28585"],
    "Trinity": ["27370"],
    "Troutman": ["28166"],
    "Troy": ["27371"],
    "Tryon": ["28782"],
    "Tuckasegee": ["28783"],
    "Turkey": ["28393"],
    "Turnersburg": ["28688"],
    "Tuxedo": ["28784"],
    "Tyner": ["27980"],
    "Union Grove": ["28689"],
    "Union Mills": ["28167"],
    "Valdese": ["28690"],
    "Vale": ["28168"],
    "Valle Crucis": ["28691"],
    "Vanceboro": ["28586"],
    "Vandemere": ["28587"],
    "Vass": ["28394"],
    "Vaughan": ["27586"],
    "Vilas": ["28692"],
    "Waco": ["28169"],
    "Wade": ["28395"],
    "Wadesboro": ["28170"],
    "Wagram": ["28396"],
    "Wake Forest": ["27587", "27588"],
    "Walkertown": ["27051"],
    "Wallace": ["28466"],
    "Wallburg": ["27373"],
    "Walnut Cove": ["27052"],
    "Walstonburg": ["27888"],
    "Wanchese": ["27981"],
    "Warne": ["28909"],
    "Warrensville": ["28693"],
    "Warrenton": ["27589"],
    "Warsaw": ["28398"],
    "Washington": ["27889"],
    "Waves": ["27982"],
    "Waxhaw": ["28173"],
    "Waynesville": ["28785", "28786"],
    "Weaverville": ["28787"],
    "Webster": ["28788"],
    "Welcome": ["27374"],
    "Weldon": ["27890"],
    "Wendell": ["27591"],
    "Wentworth": ["27375"],
    "West End": ["27376"],
    "West Jefferson": ["28694"],
    "Westfield": ["27053"],
    "Whitakers": ["27891"],
    "White Oak": ["28399"],
    "Whiteville": ["28472"],
    "Whitsett": ["27377"],
    "Whittier": ["28789"],
    "Wilkesboro": ["28697"],
    "Willard": ["28478"],
    "Williamston": ["27892"],
    "Williston": ["28589"],
    "Willow Spring": ["27592"],
    "Wilmington": ["28401", "28402", "28403", "28404", "28405", "28406", "28407", "28408", "28409", "28410", "28411", "28412"],
    "Wilson": ["27893", "27894", "27895", "27896"],
    "Wilsons Mills": ["27593"],
    "Windsor": ["27983"],
    "Winfall": ["27985"],
    "Wingate": ["28174"],
    "Winnabow": ["28479"],
    "Winston Salem": ["27101", "27102", "27103", "27104", "27105", "27106", "27107", "27108", "27109", "27110", "27111", "27113", "27114", "27115", "27116", "27117", "27120", "27127", "27130", "27150", "27152", "27155", "27157", "27198", "27199"],
    "Winston-salem": ["27151", "27156"],
    "Winterville": ["28590"],
    "Winton": ["27986"],
    "Wise": ["27594"],
    "Woodland": ["27897"],
    "Woodleaf": ["27054"],
    "Wrightsville Beach": ["28480"],
    "Yadkinville": ["27055"],
    "Yanceyville": ["27379"],
    "Youngsville": ["27596"],
    "Zebulon": ["27597"],
    "Zionville": ["28698"],
    "Zirconia": ["28790"]
  },
  "ND": {
    "Abercrombie": ["58001"],
    "Absaraka": ["58002"],
    "Adams": ["58210"],
    "Agate": ["58310"],
    "Alamo": ["58830"],
    "Alexander": ["58831"],
    "Almont": ["58520"],
    "Alsen": ["58311"],
    "Ambrose": ["58833"],
    "Amenia": ["58004"],
    "Amidon": ["58620"],
    "Anamoose": ["58710"],
    "Aneta": ["58212"],
    "Antler": ["58711"],
    "Argusville": ["58005"],
    "Arnegard": ["58835"],
    "Arthur": ["58006"],
    "Arvilla": ["58214"],
    "Ashley": ["58413"],
    "Ayr": ["58007"],
    "Baldwin": ["58521"],
    "Balfour": ["58712"],
    "Balta": ["58313"],
    "Bantry": ["58713"],
    "Barney": ["58008"],
    "Bathgate": ["58216"],
    "Beach": ["58621"],
    "Belcourt": ["58316"],
    "Belfield": ["58622"],
    "Benedict": ["58716"],
    "Berlin": ["58415"],
    "Berthold": ["58718"],
    "Beulah": ["58523"],
    "Binford": ["58416"],
    "Bisbee": ["58317"],
    "Bismarck": ["58501", "58502", "58503", "58504", "58505", "58506", "58507"],
    "Blanchard": ["58009"],
    "Bottineau": ["58318"],
    "Bowbells": ["58721"],
    "Bowdon": ["58418"],
    "Bowman": ["58623"],
    "Braddock": ["58524"],
    "Bremen": ["58319"],
    "Brocket": ["58321"],
    "Buchanan": ["58420"],
    "Buffalo": ["58011"],
    "Burlington": ["58722"],
    "Butte": ["58723"],
    "Buxton": ["58218"],
    "Caledonia": ["58219"],
    "Calvin": ["58323"],
    "Cando": ["58324"],
    "Cannon Ball": ["58528"],
    "Carpio": ["58725"],
    "Carrington": ["58421"],
    "Carson": ["58529"],
    "Cartwright": ["58838"],
    "Casselton": ["58012"],
    "Cathay": ["58422"],
    "Cavalier": ["58220"],
    "Cayuga": ["58013"],
    "Center": ["58530"],
    "Chaseley": ["58423"],
    "Christine": ["58015"],
    "Churchs Ferry": ["58325"],
    "Cleveland": ["58424"],
    "Clifford": ["58016"],
    "Cogswell": ["58017"],
    "Coleharbor": ["58531"],
    "Colfax": ["58018"],
    "Columbus": ["58727"],
    "Cooperstown": ["58425"],
    "Courtenay": ["58426"],
    "Crary": ["58327"],
    "Crosby": ["58730"],
    "Crystal": ["58222"],
    "Cummings": ["58223"],
    "Dahlen": ["58224"],
    "Davenport": ["58021"],
    "Dawson": ["58428"],
    "Dazey": ["58429"],
    "Deering": ["58731"],
    "Denhoff": ["58430"],
    "Des Lacs": ["58733"],
    "Devils Lake": ["58301"],
    "Dickey": ["58431"],
    "Dickinson": ["58601", "58602"],
    "Dodge": ["58625"],
    "Donnybrook": ["58734"],
    "Douglas": ["58735"],
    "Drake": ["58736"],
    "Drayton": ["58225"],
    "Driscoll": ["58532"],
    "Dunn Center": ["58626"],
    "Dunseith": ["58329"],
    "Edgeley": ["58433"],
    "Edinburg": ["58227"],
    "Edmore": ["58330"],
    "Egeland": ["58331"],
    "Elgin": ["58533"],
    "Ellendale": ["58436"],
    "Emerado": ["58228"],
    "Enderlin": ["58027"],
    "Epping": ["58843"],
    "Erie": ["58029"],
    "Esmond": ["58332"],
    "Fairdale": ["58229"],
    "Fairfield": ["58627"],
    "Fairmount": ["58030"],
    "Fargo": ["58102", "58103", "58104", "58105", "58106", "58107", "58108", "58109", "58121", "58122", "58124", "58125", "58126"],
    "Fessenden": ["58438"],
    "Fingal": ["58031"],
    "Finley": ["58230"],
    "Flasher": ["58535"],
    "Flaxton": ["58737"],
    "Forbes": ["58439"],
    "Fordville": ["58231"],
    "Forest River": ["58233"],
    "Forman": ["58032"],
    "Fort Ransom": ["58033"],
    "Fort Totten": ["58335"],
    "Fort Yates": ["58538"],
    "Fortuna": ["58844"],
    "Fredonia": ["58440"],
    "Fullerton": ["58441"],
    "Gackle": ["58442"],
    "Galesburg": ["58035"],
    "Gardner": ["58036"],
    "Garrison": ["58540"],
    "Gilby": ["58235"],
    "Gladstone": ["58630"],
    "Glasston": ["58236"],
    "Glen Ullin": ["58631"],
    "Glenburn": ["58740"],
    "Glenfield": ["58443"],
    "Golden Valley": ["58541"],
    "Golva": ["58632"],
    "Goodrich": ["58444"],
    "Grace City": ["58445"],
    "Grafton": ["58237"],
    "Grand Forks": ["58201", "58202", "58203", "58206", "58207", "58208"],
    "Grand Forks AFB": ["58204", "58205"],
    "Grandin": ["58038"],
    "Granville": ["58741"],
    "Grassy Butte": ["58634"],
    "Grenora": ["58845"],
    "Gwinner": ["58040"],
    "Hague": ["58542"],
    "Halliday": ["58636"],
    "Hamilton": ["58238"],
    "Hampden": ["58338"],
    "Hankinson": ["58041"],
    "Hannaford": ["58448"],
    "Hannah": ["58239"],
    "Hansboro": ["58339"],
    "Harvey": ["58341"],
    "Harwood": ["58042"],
    "Hatton": ["58240"],
    "Havana": ["58043"],
    "Hazelton": ["58544"],
    "Hazen": ["58545"],
    "Hebron": ["58638"],
    "Hensel": ["58241"],
    "Hettinger": ["58639"],
    "Hillsboro": ["58045"],
    "Hoople": ["58243"],
    "Hope": ["58046"],
    "Horace": ["58047"],
    "Hunter": ["58048"],
    "Hurdsfield": ["58451"],
    "Inkster": ["58244"],
    "Jamestown": ["58401", "58402", "58405"],
    "Jessie": ["58452"],
    "Jud": ["58454"],
    "Karlsruhe": ["58744"],
    "Kathryn": ["58049"],
    "Keene": ["58847"],
    "Kenmare": ["58746"],
    "Kensal": ["58455"],
    "Killdeer": ["58640"],
    "Kindred": ["58051"],
    "Kintyre": ["58549"],
    "Knox": ["58343"],
    "Kramer": ["58748"],
    "Kulm": ["58456"],
    "Lakota": ["58344"],
    "Lamoure": ["58458"],
    "Langdon": ["58249"],
    "Lankin": ["58250"],
    "Lansford": ["58750"],
    "Larimore": ["58251"],
    "Lawton": ["58345"],
    "Leeds": ["58346"],
    "Lefor": ["58641"],
    "Lehr": ["58460"],
    "Leonard": ["58052"],
    "Lidgerwood": ["58053"],
    "Lignite": ["58752"],
    "Linton": ["58552"],
    "Lisbon": ["58054"],
    "Litchville": ["58461"],
    "Luverne": ["58056"],
    "Maddock": ["58348"],
    "Maida": ["58255"],
    "Makoti": ["58756"],
    "Mandan": ["58554"],
    "Mandaree": ["58757"],
    "Manning": ["58642"],
    "Mantador": ["58058"],
    "Manvel": ["58256"],
    "Mapleton": ["58059"],
    "Marion": ["58466"],
    "Marmarth": ["58643"],
    "Marshall": ["58644"],
    "Martin": ["58758"],
    "Max": ["58759"],
    "Maxbass": ["58760"],
    "Mayville": ["58257"],
    "Mcclusky": ["58463"],
    "Mcgregor": ["58755"],
    "Mchenry": ["58464"],
    "Mcleod": ["58057"],
    "Mcville": ["58254"],
    "Medina": ["58467"],
    "Medora": ["58645"],
    "Mekinock": ["58258"],
    "Menoken": ["58558"],
    "Mercer": ["58559"],
    "Michigan": ["58259"],
    "Milnor": ["58060"],
    "Milton": ["58260"],
    "Minnewaukan": ["58351"],
    "Minot": ["58701", "58702", "58703", "58707"],
    "Minot AFB": ["58704", "58705"],
    "Minto": ["58261"],
    "Moffit": ["58560"],
    "Mohall": ["58761"],
    "Montpelier": ["58472"],
    "Mooreton": ["58061"],
    "Mott": ["58646"],
    "Mountain": ["58262"],
    "Munich": ["58352"],
    "Mylo": ["58353"],
    "Napoleon": ["58561"],
    "Neche": ["58265"],
    "Nekoma": ["58355"],
    "New England": ["58647"],
    "New Leipzig": ["58562"],
    "New Rockford": ["58356"],
    "New Salem": ["58563"],
    "New Town": ["58763"],
    "Newburg": ["58762"],
    "Niagara": ["58266"],
    "Nome": ["58062"],
    "Noonan": ["58765"],
    "Northwood": ["58267"],
    "Norwich": ["58768"],
    "Oakes": ["58474"],
    "Oberon": ["58357"],
    "Oriska": ["58063"],
    "Osnabrock": ["58269"],
    "Page": ["58064"],
    "Palermo": ["58769"],
    "Park River": ["58270"],
    "Parshall": ["58770"],
    "Pekin": ["58361"],
    "Pembina": ["58271"],
    "Penn": ["58362"],
    "Perth": ["58363"],
    "Petersburg": ["58272"],
    "Pettibone": ["58475"],
    "Pillsbury": ["58065"],
    "Pingree": ["58476"],
    "Pisek": ["58273"],
    "Plaza": ["58771"],
    "Portal": ["58772"],
    "Portland": ["58274"],
    "Powers Lake": ["58773"],
    "Raleigh": ["58564"],
    "Ray": ["58849"],
    "Reeder": ["58649"],
    "Regan": ["58477"],
    "Regent": ["58650"],
    "Reynolds": ["58275"],
    "Rhame": ["58651"],
    "Richardton": ["58652"],
    "Riverdale": ["58565"],
    "Robinson": ["58478"],
    "Rocklake": ["58365"],
    "Rogers": ["58479"],
    "Rolette": ["58366"],
    "Rolla": ["58367"],
    "Roseglen": ["58775"],
    "Ross": ["58776"],
    "Rugby": ["58368"],
    "Ruso": ["58778"],
    "Rutland": ["58067"],
    "Ryder": ["58779"],
    "Saint Anthony": ["58566"],
    "Saint John": ["58369"],
    "Saint Michael": ["58370"],
    "Saint Thomas": ["58276"],
    "Sanborn": ["58480"],
    "Sarles": ["58372"],
    "Sawyer": ["58781"],
    "Scranton": ["58653"],
    "Selfridge": ["58568"],
    "Sentinel Butte": ["58654"],
    "Sharon": ["58277"],
    "Sheldon": ["58068"],
    "Sherwood": ["58782"],
    "Sheyenne": ["58374"],
    "Shields": ["58569"],
    "Solen": ["58570"],
    "Souris": ["58783"],
    "South Heart": ["58655"],
    "Spiritwood": ["58481"],
    "Stanley": ["58784"],
    "Stanton": ["58571"],
    "Starkweather": ["58377"],
    "Steele": ["58482"],
    "Sterling": ["58572"],
    "Stirum": ["58069"],
    "Strasburg": ["58573"],
    "Streeter": ["58483"],
    "Surrey": ["58785"],
    "Sutton": ["58484"],
    "Sykeston": ["58486"],
    "Tappen": ["58487"],
    "Taylor": ["58656"],
    "Thompson": ["58278"],
    "Tioga": ["58852"],
    "Tokio": ["58379"],
    "Tolley": ["58787"],
    "Tolna": ["58380"],
    "Tower City": ["58071"],
    "Towner": ["58788"],
    "Trenton": ["58853"],
    "Turtle Lake": ["58575"],
    "Tuttle": ["58488"],
    "Underwood": ["58576"],
    "Upham": ["58789"],
    "Valley City": ["58072"],
    "Velva": ["58790"],
    "Verona": ["58490"],
    "Voltaire": ["58792"],
    "Wahpeton": ["58074", "58075", "58076"],
    "Walcott": ["58077"],
    "Wales": ["58281"],
    "Walhalla": ["58282"],
    "Warwick": ["58381"],
    "Washburn": ["58577"],
    "Watford City": ["58854"],
    "Webster": ["58382"],
    "West Fargo": ["58078"],
    "Westhope": ["58793"],
    "Wheatland": ["58079"],
    "White Earth": ["58794"],
    "Wildrose": ["58795"],
    "Williston": ["58801", "58802", "58803"],
    "Willow City": ["58384"],
    "Wilton": ["58579"],
    "Wimbledon": ["58492"],
    "Wing": ["58494"],
    "Wishek": ["58495"],
    "Wolford": ["58385"],
    "Woodworth": ["58496"],
    "Wyndmere": ["58081"],
    "York": ["58386"],
    "Ypsilanti": ["58497"],
    "Zahl": ["58856"],
    "Zap": ["58580"],
    "Zeeland": ["58581"]
  },
  "NE": {
    "Abie": ["68001"],
    "Adams": ["68301"],
    "Ainsworth": ["69210"],
    "Albion": ["68620"],
    "Alda": ["68810"],
    "Alexandria": ["68303"],
    "Allen": ["68710"],
    "Alliance": ["69301"],
    "Alma": ["68920"],
    "Alvo": ["68304"],
    "Amelia": ["68711"],
    "Ames": ["68621"],
    "Amherst": ["68812"],
    "Angora": ["69331"],
    "Anselmo": ["68813"],
    "Ansley": ["68814"],
    "Arapahoe": ["68922"],
    "Arcadia": ["68815"],
    "Archer": ["68816"],
    "Arlington": ["68002"],
    "Arnold": ["69120"],
    "Arthur": ["69121"],
    "Ashby": ["69333"],
    "Ashland": ["68003"],
    "Ashton": ["68817"],
    "Atkinson": ["68713"],
    "Atlanta": ["68923"],
    "Auburn": ["68305"],
    "Aurora": ["68818"],
    "Avoca": ["68307"],
    "Axtell": ["68924"],
    "Ayr": ["68925"],
    "Bancroft": ["68004"],
    "Barneston": ["68309"],
    "Bartlett": ["68622"],
    "Bartley": ["69020"],
    "Bassett": ["68714"],
    "Battle Creek": ["68715"],
    "Bayard": ["69334"],
    "Beatrice": ["68310"],
    "Beaver City": ["68926"],
    "Beaver Crossing": ["68313"],
    "Bee": ["68314"],
    "Beemer": ["68716"],
    "Belden": ["68717"],
    "Belgrade": ["68623"],
    "Bellevue": ["68005", "68123", "68147"],
    "Bellwood": ["68624"],
    "Belvidere": ["68315"],
    "Benedict": ["68316"],
    "Benkelman": ["69021"],
    "Bennet": ["68317"],
    "Bennington": ["68007"],
    "Bertrand": ["68927"],
    "Big Springs": ["69122"],
    "Bingham": ["69335"],
    "Bladen": ["68928"],
    "Blair": ["68008", "68009"],
    "Bloomfield": ["68718"],
    "Bloomington": ["68929"],
    "Blue Hill": ["68930"],
    "Blue Springs": ["68318"],
    "Boelus": ["68820"],
    "Boys Town": ["68010"],
    "Bradshaw": ["68319"],
    "Brady": ["69123"],
    "Brainard": ["68626"],
    "Brewster": ["68821"],
    "Bridgeport": ["69336"],
    "Bristow": ["68719"],
    "Broadwater": ["69125"],
    "Brock": ["68320"],
    "Broken Bow": ["68822"],
    "Brownville": ["68321"],
    "Brule": ["69127"],
    "Bruning": ["68322"],
    "Bruno": ["68014"],
    "Brunswick": ["68720"],
    "Burchard": ["68323"],
    "Burr": ["68324"],
    "Burwell": ["68823"],
    "Bushnell": ["69128"],
    "Butte": ["68722"],
    "Byron": ["68325"],
    "Cairo": ["68824"],
    "Callaway": ["68825"],
    "Cambridge": ["69022"],
    "Campbell": ["68932"],
    "Carleton": ["68326"],
    "Carroll": ["68723"],
    "Cedar Bluffs": ["68015"],
    "Cedar Creek": ["68016"],
    "Cedar Rapids": ["68627"],
    "Center": ["68724"],
    "Central City": ["68826"],
    "Ceresco": ["68017"],
    "Chadron": ["69337"],
    "Chambers": ["68725"],
    "Champion": ["69023"],
    "Chapman": ["68827"],
    "Chappell": ["69129"],
    "Chester": ["68327"],
    "Clarks": ["68628"],
    "Clarkson": ["68629"],
    "Clatonia": ["68328"],
    "Clay Center": ["68933"],
    "Clearwater": ["68726"],
    "Cody": ["69211"],
    "Coleridge": ["68727"],
    "Colon": ["68018"],
    "Columbus": ["68601", "68602"],
    "Comstock": ["68828"],
    "Concord": ["68728"],
    "Cook": ["68329"],
    "Cordova": ["68330"],
    "Cortland": ["68331"],
    "Cozad": ["69130"],
    "Crab Orchard": ["68332"],
    "Craig": ["68019"],
    "Crawford": ["69339"],
    "Creighton": ["68729"],
    "Creston": ["68631"],
    "Crete": ["68333"],
    "Crofton": ["68730"],
    "Crookston": ["69212"],
    "Culbertson": ["69024"],
    "Curtis": ["69025"],
    "Dakota City": ["68731"],
    "Dalton": ["69131"],
    "Danbury": ["69026"],
    "Dannebrog": ["68831"],
    "Davenport": ["68335"],
    "Davey": ["68336"],
    "David City": ["68632"],
    "Dawson": ["68337"],
    "Daykin": ["68338"],
    "De Witt": ["68341"],
    "Decatur": ["68020"],
    "Denton": ["68339"],
    "Deshler": ["68340"],
    "Deweese": ["68934"],
    "Dickens": ["69132"],
    "Diller": ["68342"],
    "Dix": ["69133"],
    "Dixon": ["68732"],
    "Dodge": ["68633"],
    "Doniphan": ["68832"],
    "Dorchester": ["68343"],
    "Douglas": ["68344"],
    "Du Bois": ["68345"],
    "Dunbar": ["68346"],
    "Duncan": ["68634"],
    "Dunning": ["68833"],
    "Dwight": ["68635"],
    "Eagle": ["68347"],
    "Eddyville": ["68834"],
    "Edgar": ["68935"],
    "Edison": ["68936"],
    "Elba": ["68835"],
    "Elgin": ["68636"],
    "Elk Creek": ["68348"],
    "Elkhorn": ["68022"],
    "Ellsworth": ["69340"],
    "Elm Creek": ["68836"],
    "Elmwood": ["68349"],
    "Elsie": ["69134"],
    "Elsmere": ["69135"],
    "Elwood": ["68937"],
    "Elyria": ["68837"],
    "Emerson": ["68733"],
    "Emmet": ["68734"],
    "Enders": ["69027"],
    "Endicott": ["68350"],
    "Ericson": ["68637"],
    "Eustis": ["69028"],
    "Ewing": ["68735"],
    "Exeter": ["68351"],
    "Fairbury": ["68352"],
    "Fairfield": ["68938"],
    "Fairmont": ["68354"],
    "Falls City": ["68355"],
    "Farnam": ["69029"],
    "Farwell": ["68838"],
    "Filley": ["68357"],
    "Firth": ["68358"],
    "Fordyce": ["68736"],
    "Fort Calhoun": ["68023"],
    "Franklin": ["68939"],
    "Fremont": ["68025", "68026"],
    "Friend": ["68359"],
    "Fullerton": ["68638"],
    "Funk": ["68940"],
    "Garland": ["68360"],
    "Geneva": ["68361"],
    "Genoa": ["68640"],
    "Gering": ["69341"],
    "Gibbon": ["68840"],
    "Gilead": ["68362"],
    "Giltner": ["68841"],
    "Glenvil": ["68941"],
    "Goehner": ["68364"],
    "Gordon": ["69343"],
    "Gothenburg": ["69138"],
    "Grafton": ["68365"],
    "Grand Island": ["68801", "68802", "68803"],
    "Grant": ["69140"],
    "Greeley": ["68842"],
    "Greenwood": ["68366"],
    "Gresham": ["68367"],
    "Gretna": ["68028"],
    "Guide Rock": ["68942"],
    "Gurley": ["69141"],
    "Hadar": ["68738"],
    "Haigler": ["69030"],
    "Hallam": ["68368"],
    "Halsey": ["69142"],
    "Hampton": ["68843"],
    "Hardy": ["68943"],
    "Harrisburg": ["69345"],
    "Harrison": ["69346"],
    "Hartington": ["68739"],
    "Harvard": ["68944"],
    "Hastings": ["68901", "68902"],
    "Hay Springs": ["69347"],
    "Hayes Center": ["69032"],
    "Hazard": ["68844"],
    "Heartwell": ["68945"],
    "Hebron": ["68370"],
    "Hemingford": ["69348"],
    "Henderson": ["68371"],
    "Hendley": ["68946"],
    "Herman": ["68029"],
    "Hershey": ["69143"],
    "Hickman": ["68372"],
    "Hildreth": ["68947"],
    "Holbrook": ["68948"],
    "Holdrege": ["68949"],
    "Holstein": ["68950"],
    "Homer": ["68030"],
    "Hooper": ["68031"],
    "Hordville": ["68846"],
    "Hoskins": ["68740"],
    "Howells": ["68641"],
    "Hubbard": ["68741"],
    "Hubbell": ["68375"],
    "Humboldt": ["68376"],
    "Humphrey": ["68642"],
    "Hyannis": ["69350"],
    "Imperial": ["69033"],
    "Inavale": ["68952"],
    "Indianola": ["69034"],
    "Inland": ["68954"],
    "Inman": ["68742"],
    "Ithaca": ["68033"],
    "Jackson": ["68743"],
    "Jansen": ["68377"],
    "Johnson": ["68378"],
    "Johnstown": ["69214"],
    "Julian": ["68379"],
    "Juniata": ["68955"],
    "Kearney": ["68845", "68847", "68848", "68849"],
    "Kenesaw": ["68956"],
    "Kennard": ["68034"],
    "Keystone": ["69144"],
    "Kilgore": ["69216"],
    "Kimball": ["69145"],
    "La Vista": ["68128"],
    "Lakeside": ["69351"],
    "Laurel": ["68745"],
    "Lawrence": ["68957"],
    "Lebanon": ["69036"],
    "Leigh": ["68643"],
    "Lemoyne": ["69146"],
    "Lewellen": ["69147"],
    "Lewiston": ["68380"],
    "Lexington": ["68850"],
    "Liberty": ["68381"],
    "Lincoln": ["68501", "68502", "68503", "68504", "68505", "68506", "68507", "68508", "68509", "68510", "68512", "68514", "68516", "68517", "68520", "68521", "68522", "68523", "68524", "68526", "68527", "68528", "68529", "68531", "68532", "68542", "68544", "68583", "68588"],
    "Lindsay": ["68644"],
    "Linwood": ["68036"],
    "Lisco": ["69148"],
    "Litchfield": ["68852"],
    "Lodgepole": ["69149"],
    "Long Pine": ["69217"],
    "Loomis": ["68958"],
    "Lorton": ["68382"],
    "Louisville": ["68037"],
    "Loup City": ["68853"],
    "Lyman": ["69352"],
    "Lynch": ["68746"],
    "Lyons": ["68038"],
    "Macy": ["68039"],
    "Madison": ["68748"],
    "Madrid": ["69150"],
    "Magnet": ["68749"],
    "Malcolm": ["68402"],
    "Malmo": ["68040"],
    "Manley": ["68403"],
    "Marquette": ["68854"],
    "Marsland": ["69354"],
    "Martell": ["68404"],
    "Maskell": ["68751"],
    "Mason City": ["68855"],
    "Max": ["69037"],
    "Maxwell": ["69151"],
    "Maywood": ["69038"],
    "Mc Cook": ["69001"],
    "Mc Cool Junction": ["68401"],
    "Mcgrew": ["69353"],
    "Mclean": ["68747"],
    "Mead": ["68041"],
    "Meadow Grove": ["68752"],
    "Melbeta": ["69355"],
    "Memphis": ["68042"],
    "Merna": ["68856"],
    "Merriman": ["69218"],
    "Milford": ["68405"],
    "Miller": ["68858"],
    "Milligan": ["68406"],
    "Mills": ["68753"],
    "Minatare": ["69356"],
    "Minden": ["68959"],
    "Mitchell": ["69357"],
    "Monroe": ["68647"],
    "Moorefield": ["69039"],
    "Morrill": ["69358"],
    "Morse Bluff": ["68648"],
    "Mullen": ["69152"],
    "Murdock": ["68407"],
    "Murray": ["68409"],
    "Naper": ["68755"],
    "Naponee": ["68960"],
    "Nebraska City": ["68410"],
    "Nehawka": ["68413"],
    "Neligh": ["68756"],
    "Nelson": ["68961"],
    "Nemaha": ["68414"],
    "Nenzel": ["69219"],
    "Newcastle": ["68757"],
    "Newman Grove": ["68758"],
    "Newport": ["68759"],
    "Nickerson": ["68044"],
    "Niobrara": ["68760"],
    "Norfolk": ["68701", "68702"],
    "North Bend": ["68649"],
    "North Loup": ["68859"],
    "North Platte": ["69101", "69103"],
    "Oak": ["68964"],
    "Oakdale": ["68761"],
    "Oakland": ["68045"],
    "Oconto": ["68860"],
    "Odell": ["68415"],
    "Odessa": ["68861"],
    "Offutt AFB": ["68113"],
    "Ogallala": ["69153"],
    "Ohiowa": ["68416"],
    "Omaha": ["68101", "68102", "68103", "68104", "68105", "68106", "68107", "68108", "68109", "68110", "68111", "68112", "68114", "68116", "68117", "68118", "68119", "68120", "68122", "68124", "68127", "68130", "68131", "68132", "68134", "68135", "68136", "68137", "68138", "68139", "68142", "68144", "68145", "68152", "68154", "68155", "68157", "68164", "68172", "68175", "68176", "68178", "68179", "68180", "68181", "68182", "68183", "68197", "68198"],
    "Oneill": ["68763"],
    "Ong": ["68452"],
    "Orchard": ["68764"],
    "Ord": ["68862"],
    "Orleans": ["68966"],
    "Osceola": ["68651"],
    "Oshkosh": ["69154", "69190"],
    "Osmond": ["68765"],
    "Otoe": ["68417"],
    "Overton": ["68863"],
    "Oxford": ["68967"],
    "Page": ["68766"],
    "Palisade": ["69040"],
    "Palmer": ["68864"],
    "Palmyra": ["68418"],
    "Panama": ["68419"],
    "Papillion": ["68046", "68133"],
    "Parks": ["69041"],
    "Pawnee City": ["68420"],
    "Paxton": ["69155"],
    "Pender": ["68047"],
    "Peru": ["68421"],
    "Petersburg": ["68652"],
    "Phillips": ["68865"],
    "Pickrell": ["68422"],
    "Pierce": ["68767"],
    "Pilger": ["68768"],
    "Plainview": ["68769"],
    "Platte Center": ["68653"],
    "Plattsmouth": ["68048"],
    "Pleasant Dale": ["68423"],
    "Pleasanton": ["68866"],
    "Plymouth": ["68424"],
    "Polk": ["68654"],
    "Ponca": ["68770"],
    "Potter": ["69156"],
    "Prague": ["68050"],
    "Primrose": ["68655"],
    "Purdum": ["69157"],
    "Ragan": ["68969"],
    "Randolph": ["68771"],
    "Ravenna": ["68869"],
    "Raymond": ["68428"],
    "Red Cloud": ["68970"],
    "Republican City": ["68971"],
    "Reynolds": ["68429"],
    "Rising City": ["68658"],
    "Riverdale": ["68870"],
    "Riverton": ["68972"],
    "Roca": ["68430"],
    "Rockville": ["68871"],
    "Rogers": ["68659"],
    "Rosalie": ["68055"],
    "Roseland": ["68973"],
    "Royal": ["68773"],
    "Rulo": ["68431"],
    "Rushville": ["69360"],
    "Ruskin": ["68974"],
    "Saint Edward": ["68660"],
    "Saint Helena": ["68774"],
    "Saint Libory": ["68872"],
    "Saint Paul": ["68873"],
    "Salem": ["68433"],
    "Sargent": ["68874"],
    "Saronville": ["68975"],
    "Schuyler": ["68661"],
    "Scotia": ["68875"],
    "Scottsbluff": ["69361", "69363"],
    "Scribner": ["68057"],
    "Seneca": ["69161"],
    "Seward": ["68434"],
    "Shelby": ["68662"],
    "Shelton": ["68876"],
    "Shickley": ["68436"],
    "Shubert": ["68437"],
    "Sidney": ["69160", "69162"],
    "Silver Creek": ["68663"],
    "Smithfield": ["68976"],
    "Snyder": ["68664"],
    "South Bend": ["68058"],
    "South Sioux City": ["68776"],
    "Spalding": ["68665"],
    "Sparks": ["69220"],
    "Spencer": ["68777"],
    "Sprague": ["68438"],
    "Springfield": ["68059"],
    "Springview": ["68778"],
    "St Columbans": ["68056"],
    "Stamford": ["68977"],
    "Stanton": ["68779"],
    "Staplehurst": ["68439"],
    "Stapleton": ["69163"],
    "Steele City": ["68440"],
    "Steinauer": ["68441"],
    "Stella": ["68442"],
    "Sterling": ["68443"],
    "Stockville": ["69042"],
    "Strang": ["68444"],
    "Stratton": ["69043"],
    "Stromsburg": ["68666"],
    "Stuart": ["68780"],
    "Sumner": ["68878"],
    "Superior": ["68978"],
    "Surprise": ["68667"],
    "Sutherland": ["69165"],
    "Sutton": ["68979"],
    "Swanton": ["68445"],
    "Syracuse": ["68446"],
    "Table Rock": ["68447"],
    "Talmage": ["68448"],
    "Taylor": ["68879"],
    "Tecumseh": ["68450"],
    "Tekamah": ["68061"],
    "Thedford": ["69166"],
    "Thurston": ["68062"],
    "Tilden": ["68781"],
    "Tobias": ["68453"],
    "Trenton": ["69044"],
    "Trumbull": ["68980"],
    "Tryon": ["69167"],
    "Uehling": ["68063"],
    "Ulysses": ["68669"],
    "Unadilla": ["68454"],
    "Union": ["68455"],
    "Upland": ["68981"],
    "Utica": ["68456"],
    "Valentine": ["69201"],
    "Valley": ["68064"],
    "Valparaiso": ["68065"],
    "Venango": ["69168"],
    "Verdigre": ["68783"],
    "Verdon": ["68457"],
    "Virginia": ["68458"],
    "Waco": ["68460"],
    "Wahoo": ["68066"],
    "Wakefield": ["68784"],
    "Wallace": ["69169"],
    "Walthill": ["68067"],
    "Walton": ["68461"],
    "Washington": ["68068"],
    "Waterbury": ["68785"],
    "Waterloo": ["68069"],
    "Wauneta": ["69045"],
    "Wausa": ["68786"],
    "Waverly": ["68462"],
    "Wayne": ["68787"],
    "Weeping Water": ["68463"],
    "Wellfleet": ["69170"],
    "West Point": ["68788"],
    "Western": ["68464"],
    "Westerville": ["68881"],
    "Weston": ["68070"],
    "Whiteclay": ["69365"],
    "Whitman": ["69366"],
    "Whitney": ["69367"],
    "Wilber": ["68465"],
    "Wilcox": ["68982"],
    "Willow Island": ["69171"],
    "Wilsonville": ["69046"],
    "Winnebago": ["68071"],
    "Winnetoon": ["68789"],
    "Winside": ["68790"],
    "Winslow": ["68072"],
    "Wisner": ["68791"],
    "Wolbach": ["68882"],
    "Wood Lake": ["69221"],
    "Wood River": ["68883"],
    "Wymore": ["68466"],
    "Wynot": ["68792"],
    "York": ["68467"],
    "Yutan": ["68073"]
  },
  "NH": {
    "Acworth": ["03601"],
    "Alstead": ["03602"],
    "Alton": ["03809"],
    "Alton Bay": ["03810"],
    "Amherst": ["03031"],
    "Andover": ["03216"],
    "Antrim": ["03440"],
    "Ashland": ["03217"],
    "Ashuelot": ["03441"],
    "Atkinson": ["03811"],
    "Auburn": ["03032"],
    "Barnstead": ["03218"],
    "Barrington": ["03825"],
    "Bartlett": ["03812"],
    "Bath": ["03740"],
    "Bedford": ["03110"],
    "Belmont": ["03220"],
    "Bennington": ["03442"],
    "Berlin": ["03570"],
    "Bethlehem": ["03574"],
    "Bow": ["03304"],
    "Bradford": ["03221"],
    "Bretton Woods": ["03575"],
    "Bristol": ["03222"],
    "Brookline": ["03033"],
    "Campton": ["03223"],
    "Canaan": ["03741"],
    "Candia": ["03034"],
    "Canterbury": ["03224"],
    "Center Barnstead": ["03225"],
    "Center Conway": ["03813"],
    "Center Harbor": ["03226"],
    "Center Ossipee": ["03814"],
    "Center Sandwich": ["03227"],
    "Center Strafford": ["03815"],
    "Center Tuftonboro": ["03816"],
    "Charlestown": ["03603"],
    "Chester": ["03036"],
    "Chesterfield": ["03443"],
    "Chichester": ["03258"],
    "Chocorua": ["03817"],
    "Claremont": ["03743"],
    "Colebrook": ["03576"],
    "Concord": ["03301", "03302", "03303", "03305"],
    "Contoocook": ["03229"],
    "Conway": ["03818"],
    "Cornish": ["03745"],
    "Cornish Flat": ["03746"],
    "Danbury": ["03230"],
    "Danville": ["03819"],
    "Deerfield": ["03037"],
    "Derry": ["03038"],
    "Dover": ["03820", "03821", "03822"],
    "Drewsville": ["03604"],
    "Dublin": ["03444"],
    "Dunbarton": ["03046"],
    "Durham": ["03824"],
    "East Andover": ["03231"],
    "East Candia": ["03040"],
    "East Derry": ["03041"],
    "East Hampstead": ["03826"],
    "East Kingston": ["03827"],
    "East Wakefield": ["03830"],
    "Eaton Center": ["03832"],
    "Effingham": ["03882"],
    "Elkins": ["03233"],
    "Enfield": ["03748"],
    "Enfield Center": ["03749"],
    "Epping": ["03042"],
    "Epsom": ["03234"],
    "Errol": ["03579"],
    "Etna": ["03750"],
    "Exeter": ["03833"],
    "Farmington": ["03835"],
    "Fitzwilliam": ["03447"],
    "Francestown": ["03043"],
    "Franconia": ["03580"],
    "Franklin": ["03235"],
    "Freedom": ["03836"],
    "Fremont": ["03044"],
    "Georges Mills": ["03751"],
    "Gilford": ["03249"],
    "Gilmanton": ["03237"],
    "Gilmanton Iron Works": ["03837"],
    "Gilsum": ["03448"],
    "Glen": ["03838"],
    "Glencliff": ["03238"],
    "Goffstown": ["03045"],
    "Gorham": ["03581"],
    "Goshen": ["03752"],
    "Grafton": ["03240"],
    "Grantham": ["03753"],
    "Greenfield": ["03047"],
    "Greenland": ["03840"],
    "Greenville": ["03048"],
    "Groveton": ["03582"],
    "Guild": ["03754"],
    "Hampstead": ["03841"],
    "Hampton": ["03842", "03843"],
    "Hampton Falls": ["03844"],
    "Hancock": ["03449"],
    "Hanover": ["03755"],
    "Harrisville": ["03450"],
    "Haverhill": ["03765"],
    "Hebron": ["03241"],
    "Henniker": ["03242"],
    "Hill": ["03243"],
    "Hillsborough": ["03244"],
    "Hinsdale": ["03451"],
    "Holderness": ["03245"],
    "Hollis": ["03049"],
    "Hooksett": ["03106"],
    "Hudson": ["03051"],
    "Intervale": ["03845"],
    "Jackson": ["03846"],
    "Jaffrey": ["03452"],
    "Jefferson": ["03583"],
    "Kearsarge": ["03847"],
    "Keene": ["03431", "03435"],
    "Kingston": ["03848"],
    "Laconia": ["03246", "03247"],
    "Lancaster": ["03584"],
    "Lebanon": ["03756", "03766"],
    "Lee": ["03861"],
    "Lempster": ["03605"],
    "Lincoln": ["03251"],
    "Lisbon": ["03585"],
    "Litchfield": ["03052"],
    "Littleton": ["03561"],
    "Lochmere": ["03252"],
    "Londonderry": ["03053"],
    "Loudon": ["03307"],
    "Lyme": ["03768"],
    "Lyme Center": ["03769"],
    "Lyndeborough": ["03082"],
    "Madbury": ["03823"],
    "Madison": ["03849"],
    "Manchester": ["03101", "03102", "03103", "03104", "03105", "03107", "03108", "03109", "03111"],
    "Marlborough": ["03455"],
    "Marlow": ["03456"],
    "Melvin Village": ["03850"],
    "Meredith": ["03253"],
    "Meriden": ["03770"],
    "Merrimack": ["03054"],
    "Milan": ["03588"],
    "Milford": ["03055"],
    "Milton": ["03851"],
    "Milton Mills": ["03852"],
    "Mirror Lake": ["03853"],
    "Monroe": ["03771"],
    "Mont Vernon": ["03057"],
    "Moultonborough": ["03254"],
    "Mount Washington": ["03589"],
    "Nashua": ["03060", "03061", "03062", "03063", "03064"],
    "Nelson": ["03457"],
    "New Boston": ["03070"],
    "New Castle": ["03854"],
    "New Durham": ["03855"],
    "New Hampton": ["03256"],
    "New Ipswich": ["03071"],
    "New London": ["03257"],
    "Newbury": ["03255"],
    "Newfields": ["03856"],
    "Newington": ["03805"],
    "Newmarket": ["03857"],
    "Newport": ["03773"],
    "Newton": ["03858"],
    "Newton Junction": ["03859"],
    "North Conway": ["03860"],
    "North Hampton": ["03862"],
    "North Haverhill": ["03774"],
    "North Salem": ["03073"],
    "North Sandwich": ["03259"],
    "North Stratford": ["03590"],
    "North Sutton": ["03260"],
    "North Walpole": ["03609"],
    "North Woodstock": ["03262"],
    "Northwood": ["03261"],
    "Nottingham": ["03290"],
    "Orford": ["03777"],
    "Ossipee": ["03864"],
    "Pelham": ["03076"],
    "Peterborough": ["03458"],
    "Piermont": ["03779"],
    "Pike": ["03780"],
    "Pittsburg": ["03592"],
    "Pittsfield": ["03263"],
    "Plainfield": ["03781"],
    "Plaistow": ["03865"],
    "Plymouth": ["03264"],
    "Portsmouth": ["03801", "03802", "03803", "03804"],
    "Randolph": ["03593"],
    "Raymond": ["03077"],
    "Rindge": ["03461"],
    "Rochester": ["03839", "03866", "03867", "03868"],
    "Rollinsford": ["03869"],
    "Rumney": ["03266"],
    "Rye": ["03870"],
    "Rye Beach": ["03871"],
    "Salem": ["03079"],
    "Salisbury": ["03268"],
    "Sanbornton": ["03269"],
    "Sanbornville": ["03872"],
    "Sandown": ["03873"],
    "Seabrook": ["03874"],
    "Silver Lake": ["03875"],
    "Somersworth": ["03878"],
    "South Acworth": ["03607"],
    "South Newbury": ["03272"],
    "South Sutton": ["03273"],
    "South Tamworth": ["03883"],
    "Spofford": ["03462"],
    "Springfield": ["03284"],
    "Stinson Lake": ["03274"],
    "Stoddard": ["03464"],
    "Strafford": ["03884"],
    "Stratham": ["03885"],
    "Sugar Hill": ["03586"],
    "Sullivan": ["03445"],
    "Sunapee": ["03782"],
    "Suncook": ["03275"],
    "Swanzey": ["03446"],
    "Tamworth": ["03886"],
    "Temple": ["03084"],
    "Thornton": ["03285"],
    "Tilton": ["03276", "03298", "03299"],
    "Troy": ["03465"],
    "Twin Mountain": ["03595"],
    "Union": ["03887"],
    "Walpole": ["03608"],
    "Warner": ["03278"],
    "Warren": ["03279"],
    "Washington": ["03280"],
    "Waterville Valley": ["03215"],
    "Weare": ["03281"],
    "Wentworth": ["03282"],
    "West Chesterfield": ["03466"],
    "West Lebanon": ["03784"],
    "West Nottingham": ["03291"],
    "West Ossipee": ["03890"],
    "West Peterborough": ["03468"],
    "West Stewartstown": ["03597"],
    "West Swanzey": ["03469"],
    "Westmoreland": ["03467"],
    "Whitefield": ["03598"],
    "Wilmot": ["03287"],
    "Wilton": ["03086"],
    "Winchester": ["03470"],
    "Windham": ["03087"],
    "Winnisquam": ["03289"],
    "Wolfeboro": ["03894"],
    "Wolfeboro Falls": ["03896"],
    "Wonalancet": ["03897"],
    "Woodstock": ["03293"],
    "Woodsville": ["03785"]
  },
  "NJ": {
    "Absecon": ["08201", "08205"],
    "Adelphia": ["07710"],
    "Allamuchy": ["07820"],
    "Allendale": ["07401"],
    "Allenhurst": ["07711"],
    "Allentown": ["08501"],
    "Allenwood": ["08720"],
    "Alloway": ["08001"],
    "Alpine": ["07620"],
    "Andover": ["07821"],
    "Annandale": ["08801"],
    "Asbury": ["08802"],
    "Asbury Park": ["07712"],
    "Atco": ["08004"],
    "Atlantic City": ["08401", "08404", "08405"],
    "Atlantic Highlands": ["07716"],
    "Audubon": ["08106"],
    "Augusta": ["07822"],
    "Avalon": ["08202"],
    "Avenel": ["07001"],
    "Avon By The Sea": ["07717"],
    "Baptistown": ["08803"],
    "Barnegat": ["08005"],
    "Barnegat Light": ["08006"],
    "Barrington": ["08007"],
    "Basking Ridge": ["07920"],
    "Bayonne": ["07002"],
    "Bayville": ["08721"],
    "Beach Haven": ["08008"],
    "Beachwood": ["08722"],
    "Bedminster": ["07921"],
    "Belford": ["07718"],
    "Belle Mead": ["08502"],
    "Belleville": ["07109"],
    "Bellmawr": ["08031", "08099"],
    "Belmar": ["07715", "07719"],
    "Belvidere": ["07823"],
    "Bergenfield": ["07621"],
    "Berkeley Heights": ["07922"],
    "Berlin": ["08009"],
    "Bernardsville": ["07924"],
    "Beverly": ["08010"],
    "Birmingham": ["08011"],
    "Blackwood": ["08012"],
    "Blairstown": ["07825"],
    "Blawenburg": ["08504"],
    "Bloomfield": ["07003"],
    "Bloomingdale": ["07403"],
    "Bloomsbury": ["08804"],
    "Bogota": ["07603"],
    "Boonton": ["07005"],
    "Bordentown": ["08505"],
    "Bound Brook": ["08805"],
    "Bradley Beach": ["07720"],
    "Branchville": ["07826", "07890"],
    "Brick": ["08723", "08724"],
    "Bridgeport": ["08014"],
    "Bridgeton": ["08302"],
    "Bridgewater": ["08807"],
    "Brielle": ["08730"],
    "Brigantine": ["08203"],
    "Broadway": ["08808"],
    "Brookside": ["07926"],
    "Browns Mills": ["08015"],
    "Budd Lake": ["07828"],
    "Buena": ["08310"],
    "Burlington": ["08016"],
    "Butler": ["07405"],
    "Buttzville": ["07829"],
    "Caldwell": ["07006", "07007"],
    "Califon": ["07830"],
    "Camden": ["08101", "08102", "08103", "08104", "08105"],
    "Cape May": ["08204"],
    "Cape May Court House": ["08210"],
    "Cape May Point": ["08212"],
    "Carlstadt": ["07072"],
    "Carteret": ["07008"],
    "Cedar Brook": ["08018"],
    "Cedar Grove": ["07009"],
    "Cedar Knolls": ["07927"],
    "Cedarville": ["08311"],
    "Changewater": ["07831"],
    "Chatham": ["07928"],
    "Chatsworth": ["08019"],
    "Cherry Hill": ["08002", "08003", "08034"],
    "Chester": ["07930"],
    "Chesterfield": ["08515"],
    "Clark": ["07066"],
    "Clarksboro": ["08020"],
    "Clayton": ["08312"],
    "Clementon": ["08021"],
    "Cliffside Park": ["07010"],
    "Cliffwood": ["07721"],
    "Clifton": ["07011", "07012", "07013", "07014", "07015"],
    "Clinton": ["08809"],
    "Closter": ["07624"],
    "Collingswood": ["08108"],
    "Cologne": ["08213"],
    "Colonia": ["07067"],
    "Colts Neck": ["07722"],
    "Columbia": ["07832"],
    "Columbus": ["08022"],
    "Convent Station": ["07961"],
    "Cookstown": ["08511"],
    "Cranbury": ["08512"],
    "Cranford": ["07016"],
    "Cream Ridge": ["08514"],
    "Cresskill": ["07626"],
    "Dayton": ["08810"],
    "Deal": ["07723"],
    "Deepwater": ["08023"],
    "Deerfield Street": ["08313"],
    "Delaware": ["07833"],
    "Delmont": ["08314"],
    "Demarest": ["07627"],
    "Dennisville": ["08214"],
    "Denville": ["07834"],
    "Dividing Creek": ["08315"],
    "Dorchester": ["08316"],
    "Dorothy": ["08317"],
    "Dover": ["07801", "07802"],
    "Dumont": ["07628"],
    "Dunellen": ["08812"],
    "East Brunswick": ["08816"],
    "East Hanover": ["07936"],
    "East Orange": ["07017", "07018", "07019"],
    "East Rutherford": ["07073"],
    "Eatontown": ["07724", "07799"],
    "Edgewater": ["07020"],
    "Edison": ["08817", "08818", "08820", "08837", "08899"],
    "Egg Harbor City": ["08215"],
    "Egg Harbor Township": ["08234"],
    "Elizabeth": ["07201", "07202", "07207", "07208"],
    "Elizabethport": ["07206"],
    "Elmer": ["08318"],
    "Elmwood Park": ["07407"],
    "Elwood": ["08217"],
    "Emerson": ["07630"],
    "Englewood": ["07631"],
    "Englewood Cliffs": ["07632"],
    "Englishtown": ["07726"],
    "Essex Fells": ["07021"],
    "Estell Manor": ["08319"],
    "Ewan": ["08025"],
    "Fair Haven": ["07704"],
    "Fair Lawn": ["07410"],
    "Fairfield": ["07004"],
    "Fairton": ["08320"],
    "Fairview": ["07022"],
    "Fanwood": ["07023"],
    "Far Hills": ["07931"],
    "Farmingdale": ["07727"],
    "Flagtown": ["08821"],
    "Flanders": ["07836"],
    "Flemington": ["08822"],
    "Florence": ["08518"],
    "Florham Park": ["07932"],
    "Fords": ["08863"],
    "Forked River": ["08731"],
    "Fort Lee": ["07024"],
    "Fort Monmouth": ["07703"],
    "Fortescue": ["08321"],
    "Franklin": ["07416"],
    "Franklin Lakes": ["07417"],
    "Franklin Park": ["08823"],
    "Franklinville": ["08322"],
    "Freehold": ["07728"],
    "Frenchtown": ["08825"],
    "Garfield": ["07026"],
    "Garwood": ["07027"],
    "Gibbsboro": ["08026"],
    "Gibbstown": ["08027"],
    "Gillette": ["07933"],
    "Gladstone": ["07934"],
    "Glassboro": ["08028"],
    "Glasser": ["07837"],
    "Glen Gardner": ["08826"],
    "Glen Ridge": ["07028"],
    "Glen Rock": ["07452"],
    "Glendora": ["08029"],
    "Glenwood": ["07418"],
    "Gloucester City": ["08030"],
    "Goshen": ["08218"],
    "Great Meadows": ["07838"],
    "Green Creek": ["08219"],
    "Green Village": ["07935"],
    "Greendell": ["07839"],
    "Greenwich": ["08323"],
    "Grenloch": ["08032"],
    "Hackensack": ["07601", "07602"],
    "Hackettstown": ["07840"],
    "Haddon Heights": ["08035"],
    "Haddonfield": ["08033"],
    "Hainesport": ["08036"],
    "Haledon": ["07508", "07538"],
    "Hamburg": ["07419"],
    "Hammonton": ["08037"],
    "Hampton": ["08827"],
    "Hancocks Bridge": ["08038"],
    "Harrington Park": ["07640"],
    "Harrison": ["07029"],
    "Harrisonville": ["08039"],
    "Hasbrouck Heights": ["07604"],
    "Haskell": ["07420"],
    "Haworth": ["07641"],
    "Hawthorne": ["07506", "07507"],
    "Hazlet": ["07730"],
    "Heislerville": ["08324"],
    "Helmetta": ["08828"],
    "Hewitt": ["07421"],
    "Hibernia": ["07842"],
    "High Bridge": ["08829"],
    "Highland Lakes": ["07422"],
    "Highland Park": ["08904"],
    "Highlands": ["07732"],
    "Hightstown": ["08520"],
    "Hillsborough": ["08844"],
    "Hillsdale": ["07642"],
    "Hillside": ["07205"],
    "Ho Ho Kus": ["07423"],
    "Hoboken": ["07030"],
    "Holmdel": ["07733"],
    "Hopatcong": ["07843"],
    "Hope": ["07844"],
    "Hopewell": ["08525"],
    "Howell": ["07731"],
    "Imlaystown": ["08526"],
    "Ironia": ["07845"],
    "Irvington": ["07111"],
    "Iselin": ["08830"],
    "Island Heights": ["08732"],
    "Jackson": ["08527"],
    "Jersey City": ["07097", "07302", "07303", "07304", "07305", "07306", "07307", "07308", "07309", "07310", "07311", "07395", "07399"],
    "Jobstown": ["08041"],
    "Johnsonburg": ["07846"],
    "Joint Base Mdl": ["08640", "08641"],
    "Juliustown": ["08042"],
    "Keansburg": ["07734"],
    "Kearny": ["07032", "07099"],
    "Keasbey": ["08832"],
    "Kendall Park": ["08824"],
    "Kenilworth": ["07033"],
    "Kenvil": ["07847"],
    "Keyport": ["07735"],
    "Kingston": ["08528"],
    "Lafayette": ["07848"],
    "Lake Hiawatha": ["07034"],
    "Lake Hopatcong": ["07849"],
    "Lakehurst": ["08733"],
    "Lakewood": ["08701"],
    "Lambertville": ["08530"],
    "Landing": ["07850"],
    "Landisville": ["08326"],
    "Lanoka Harbor": ["08734"],
    "Lavallette": ["08735"],
    "Lawnside": ["08045"],
    "Lawrence Township": ["08648"],
    "Layton": ["07851"],
    "Lebanon": ["08833"],
    "Ledgewood": ["07852"],
    "Leeds Point": ["08220"],
    "Leesburg": ["08327"],
    "Leonardo": ["07737"],
    "Leonia": ["07605"],
    "Liberty Corner": ["07938"],
    "Lincoln Park": ["07035"],
    "Lincroft": ["07738"],
    "Linden": ["07036"],
    "Linwood": ["08221"],
    "Little Falls": ["07424"],
    "Little Ferry": ["07643"],
    "Little Silver": ["07739"],
    "Little York": ["08834"],
    "Livingston": ["07039"],
    "Lodi": ["07644"],
    "Long Branch": ["07740"],
    "Long Valley": ["07853"],
    "Longport": ["08403"],
    "Lumberton": ["08048"],
    "Lyndhurst": ["07071"],
    "Lyons": ["07939"],
    "Madison": ["07940"],
    "Magnolia": ["08049"],
    "Mahwah": ["07430", "07495"],
    "Malaga": ["08328"],
    "Manahawkin": ["08050"],
    "Manasquan": ["08736"],
    "Manchester Township": ["08759"],
    "Mantoloking": ["08738"],
    "Mantua": ["08051"],
    "Manville": ["08835"],
    "Maple Shade": ["08052"],
    "Maplewood": ["07040"],
    "Margate City": ["08402"],
    "Marlboro": ["07746"],
    "Marlton": ["08053"],
    "Marmora": ["08223"],
    "Martinsville": ["08836"],
    "Matawan": ["07747"],
    "Mauricetown": ["08329"],
    "Mays Landing": ["08330"],
    "Maywood": ["07607"],
    "Mc Afee": ["07428"],
    "Medford": ["08055"],
    "Mendham": ["07945"],
    "Merchantville": ["08109"],
    "Metuchen": ["08840"],
    "Mickleton": ["08056"],
    "Middlesex": ["08846"],
    "Middletown": ["07748"],
    "Middleville": ["07855"],
    "Midland Park": ["07432"],
    "Milford": ["08848"],
    "Millburn": ["07041"],
    "Millington": ["07946"],
    "Millstone Township": ["08510", "08535"],
    "Milltown": ["08850"],
    "Millville": ["08332"],
    "Milmay": ["08340"],
    "Mine Hill": ["07803"],
    "Minotola": ["08341"],
    "Mizpah": ["08342"],
    "Monmouth Beach": ["07750"],
    "Monmouth Junction": ["08852"],
    "Monroe Township": ["08831"],
    "Monroeville": ["08343"],
    "Montague": ["07827"],
    "Montclair": ["07042", "07043"],
    "Montvale": ["07645"],
    "Montville": ["07045"],
    "Moonachie": ["07074"],
    "Moorestown": ["08057"],
    "Morganville": ["07751"],
    "Morris Plains": ["07950"],
    "Morristown": ["07960", "07962", "07963"],
    "Mount Arlington": ["07856"],
    "Mount Ephraim": ["08059"],
    "Mount Freedom": ["07970"],
    "Mount Holly": ["08060"],
    "Mount Laurel": ["08054"],
    "Mount Royal": ["08061"],
    "Mount Tabor": ["07878"],
    "Mountain Lakes": ["07046"],
    "Mountainside": ["07092"],
    "Mullica Hill": ["08062"],
    "National Park": ["08063"],
    "Navesink": ["07752"],
    "Neptune": ["07753", "07754"],
    "Neshanic Station": ["08853"],
    "Netcong": ["07857"],
    "New Brunswick": ["08901", "08903", "08905", "08906", "08922", "08933", "08988", "08989"],
    "New Egypt": ["08533"],
    "New Gretna": ["08224"],
    "New Lisbon": ["08064"],
    "New Milford": ["07646"],
    "New Providence": ["07974"],
    "New Vernon": ["07976"],
    "Newark": ["07101", "07102", "07103", "07104", "07105", "07106", "07107", "07108", "07112", "07114", "07175", "07182", "07184", "07188", "07189", "07191", "07192", "07193", "07194", "07195", "07198", "07199"],
    "Newfield": ["08344"],
    "Newfoundland": ["07435"],
    "Newport": ["08345"],
    "Newton": ["07860"],
    "Newtonville": ["08346"],
    "Norma": ["08347"],
    "Normandy Beach": ["08739"],
    "North Arlington": ["07031"],
    "North Bergen": ["07047"],
    "North Brunswick": ["08902"],
    "Northfield": ["08225"],
    "Northvale": ["07647"],
    "Norwood": ["07648"],
    "Nutley": ["07110"],
    "Oak Ridge": ["07438"],
    "Oakhurst": ["07755"],
    "Oakland": ["07436"],
    "Oaklyn": ["08107"],
    "Ocean City": ["08226"],
    "Ocean Gate": ["08740"],
    "Ocean Grove": ["07756"],
    "Ocean View": ["08230"],
    "Oceanport": ["07757"],
    "Oceanville": ["08231"],
    "Ogdensburg": ["07439"],
    "Old Bridge": ["08857"],
    "Oldwick": ["08858"],
    "Oradell": ["07649"],
    "Orange": ["07050", "07051"],
    "Oxford": ["07863"],
    "Palisades Park": ["07650"],
    "Palmyra": ["08065"],
    "Paramus": ["07652", "07653"],
    "Park Ridge": ["07656"],
    "Parlin": ["08859"],
    "Parsippany": ["07054"],
    "Passaic": ["07055"],
    "Paterson": ["07501", "07502", "07503", "07504", "07505", "07509", "07510", "07513", "07514", "07522", "07524", "07533", "07543", "07544"],
    "Paulsboro": ["08066"],
    "Peapack": ["07977"],
    "Pedricktown": ["08067"],
    "Pemberton": ["08068"],
    "Pennington": ["08534"],
    "Penns Grove": ["08069"],
    "Pennsauken": ["08110"],
    "Pennsville": ["08070"],
    "Pequannock": ["07440"],
    "Perth Amboy": ["08861", "08862"],
    "Phillipsburg": ["08865"],
    "Picatinny Arsenal": ["07806"],
    "Pine Beach": ["08741"],
    "Pine Brook": ["07058"],
    "Piscataway": ["08854", "08855"],
    "Pitman": ["08071"],
    "Pittstown": ["08867"],
    "Plainfield": ["07060", "07061", "07062", "07063"],
    "Plainsboro": ["08536"],
    "Pleasantville": ["08232"],
    "Pluckemin": ["07978"],
    "Point Pleasant Beach": ["08742"],
    "Pomona": ["08240"],
    "Pompton Lakes": ["07442"],
    "Pompton Plains": ["07444"],
    "Port Elizabeth": ["08348"],
    "Port Monmouth": ["07758"],
    "Port Murray": ["07865"],
    "Port Norris": ["08349"],
    "Port Reading": ["07064"],
    "Port Republic": ["08241"],
    "Pottersville": ["07979"],
    "Princeton": ["08540", "08541", "08542", "08543", "08544"],
    "Princeton Junction": ["08550"],
    "Quakertown": ["08868"],
    "Quinton": ["08072"],
    "Rahway": ["07065"],
    "Ramsey": ["07446"],
    "Rancocas": ["08073"],
    "Randolph": ["07869"],
    "Raritan": ["08869"],
    "Readington": ["08870"],
    "Red Bank": ["07701", "07709"],
    "Richland": ["08350"],
    "Richwood": ["08074"],
    "Ridgefield": ["07657"],
    "Ridgefield Park": ["07660"],
    "Ridgewood": ["07450", "07451"],
    "Ringoes": ["08551"],
    "Ringwood": ["07456"],
    "Rio Grande": ["08242"],
    "River Edge": ["07661"],
    "Riverdale": ["07457"],
    "Riverside": ["08075"],
    "Riverton": ["08076", "08077"],
    "Robbinsville": ["08691"],
    "Rochelle Park": ["07662"],
    "Rockaway": ["07866"],
    "Rocky Hill": ["08553"],
    "Roebling": ["08554"],
    "Roosevelt": ["08555"],
    "Roseland": ["07068"],
    "Roselle": ["07203"],
    "Roselle Park": ["07204"],
    "Rosemont": ["08556"],
    "Rosenhayn": ["08352"],
    "Rumson": ["07760"],
    "Runnemede": ["08078"],
    "Rutherford": ["07070"],
    "Saddle Brook": ["07663"],
    "Saddle River": ["07458"],
    "Salem": ["08079"],
    "Sayreville": ["08871", "08872"],
    "Schooleys Mountain": ["07870"],
    "Scotch Plains": ["07076"],
    "Sea Girt": ["08750"],
    "Sea Isle City": ["08243"],
    "Seaside Heights": ["08751"],
    "Seaside Park": ["08752"],
    "Secaucus": ["07094", "07096"],
    "Sergeantsville": ["08557"],
    "Sewaren": ["07077"],
    "Sewell": ["08080"],
    "Shiloh": ["08353"],
    "Short Hills": ["07078"],
    "Shrewsbury": ["07702"],
    "Sicklerville": ["08081"],
    "Skillman": ["08558"],
    "Somerdale": ["08083"],
    "Somers Point": ["08244"],
    "Somerset": ["08873", "08875"],
    "Somerville": ["08876"],
    "South Amboy": ["08879"],
    "South Bound Brook": ["08880"],
    "South Dennis": ["08245"],
    "South Hackensack": ["07606"],
    "South Orange": ["07079"],
    "South Plainfield": ["07080"],
    "South River": ["08882"],
    "South Seaville": ["08246"],
    "Sparta": ["07871"],
    "Spotswood": ["08884"],
    "Spring Lake": ["07762"],
    "Springfield": ["07081"],
    "Stanhope": ["07874"],
    "Stanton": ["08885"],
    "Stewartsville": ["08886"],
    "Stillwater": ["07875"],
    "Stirling": ["07980"],
    "Stockholm": ["07460"],
    "Stockton": ["08559"],
    "Stone Harbor": ["08247"],
    "Stratford": ["08084"],
    "Strathmere": ["08248"],
    "Succasunna": ["07876"],
    "Summit": ["07901", "07902"],
    "Sussex": ["07461"],
    "Swartswood": ["07877"],
    "Swedesboro": ["08085"],
    "Teaneck": ["07666"],
    "Tenafly": ["07670"],
    "Tennent": ["07763"],
    "Teterboro": ["07608", "07699"],
    "Thorofare": ["08086"],
    "Three Bridges": ["08887"],
    "Titusville": ["08560"],
    "Toms River": ["08753", "08754", "08755", "08756", "08757"],
    "Totowa": ["07511", "07512"],
    "Towaco": ["07082"],
    "Township Of Washington": ["07676"],
    "Tranquility": ["07879"],
    "Trenton": ["08601", "08602", "08603", "08604", "08605", "08606", "08607", "08608", "08609", "08610", "08611", "08618", "08619", "08620", "08625", "08628", "08629", "08638", "08644", "08645", "08646", "08647", "08650", "08666", "08690", "08695"],
    "Tuckahoe": ["08250"],
    "Tuckerton": ["08087"],
    "Union": ["07083"],
    "Union City": ["07087"],
    "Vauxhall": ["07088"],
    "Ventnor City": ["08406"],
    "Vernon": ["07462"],
    "Verona": ["07044"],
    "Vienna": ["07880"],
    "Villas": ["08251"],
    "Vincentown": ["08088"],
    "Vineland": ["08360", "08361", "08362"],
    "Voorhees": ["08043"],
    "Waldwick": ["07463"],
    "Wallington": ["07057"],
    "Wallpack Center": ["07881"],
    "Wanaque": ["07465"],
    "Waretown": ["08758"],
    "Warren": ["07059"],
    "Washington": ["07882"],
    "Watchung": ["07069"],
    "Waterford Works": ["08089"],
    "Wayne": ["07470", "07474", "07477"],
    "Weehawken": ["07086"],
    "Wenonah": ["08090"],
    "West Berlin": ["08091"],
    "West Creek": ["08092"],
    "West Long Branch": ["07764"],
    "West Milford": ["07480"],
    "West New York": ["07093"],
    "West Orange": ["07052"],
    "Westfield": ["07090", "07091"],
    "Westville": ["08093"],
    "Westwood": ["07675"],
    "Wharton": ["07885"],
    "Whippany": ["07981", "07983", "07999"],
    "Whitehouse": ["08888"],
    "Whitehouse Station": ["08889"],
    "Whitesboro": ["08252"],
    "Wickatunk": ["07765"],
    "Wildwood": ["08260"],
    "Williamstown": ["08094"],
    "Willingboro": ["08046"],
    "Windsor": ["08561"],
    "Winslow": ["08095"],
    "Wood Ridge": ["07075"],
    "Woodbine": ["08270"],
    "Woodbridge": ["07095"],
    "Woodbury": ["08096"],
    "Woodbury Heights": ["08097"],
    "Woodcliff Lake": ["07677"],
    "Woodstown": ["08098"],
    "Wrightstown": ["08562"],
    "Wyckoff": ["07481"],
    "Zarephath": ["08890"]
  },
  "NM": {
    "Abiquiu": ["87510"],
    "Alamogordo": ["88310", "88311"],
    "Albuquerque": ["87101", "87102", "87103", "87104", "87105", "87106", "87107", "87108", "87109", "87110", "87111", "87112", "87113", "87114", "87115", "87116", "87119", "87120", "87121", "87122", "87123", "87125", "87131", "87151", "87153", "87154", "87158", "87165", "87176", "87181", "87184", "87185", "87187", "87190", "87191", "87192", "87193", "87194", "87195", "87196", "87197", "87198", "87199"],
    "Alcalde": ["87511"],
    "Algodones": ["87001"],
    "Alto": ["88312"],
    "Amalia": ["87512"],
    "Amistad": ["88410"],
    "Angel Fire": ["87710"],
    "Animas": ["88020"],
    "Anthony": ["88021"],
    "Anton Chico": ["87711"],
    "Aragon": ["87820"],
    "Arenas Valley": ["88022"],
    "Arrey": ["87930"],
    "Arroyo Hondo": ["87513"],
    "Arroyo Seco": ["87514"],
    "Artesia": ["88210", "88211"],
    "Aztec": ["87410"],
    "Bard": ["88411"],
    "Bayard": ["88023"],
    "Belen": ["87002"],
    "Bent": ["88314"],
    "Berino": ["88024"],
    "Bernalillo": ["87004"],
    "Blanco": ["87412"],
    "Bloomfield": ["87413"],
    "Bluewater": ["87005"],
    "Bosque": ["87006"],
    "Bosque Farms": ["87068"],
    "Brimhall": ["87310"],
    "Broadview": ["88112"],
    "Buckhorn": ["88025"],
    "Buena Vista": ["87712"],
    "Caballo": ["87931"],
    "Canjilon": ["87515"],
    "Cannon AFB": ["88103"],
    "Canones": ["87516"],
    "Capitan": ["88316"],
    "Caprock": ["88213"],
    "Capulin": ["88414"],
    "Carlsbad": ["88220", "88221"],
    "Carrizozo": ["88301"],
    "Carson": ["87517"],
    "Casa Blanca": ["87007"],
    "Causey": ["88113"],
    "Cebolla": ["87518"],
    "Cedar Crest": ["87008"],
    "Cedarvale": ["87009"],
    "Cerrillos": ["87010"],
    "Cerro": ["87519"],
    "Chacon": ["87713"],
    "Chama": ["87520"],
    "Chamberino": ["88027"],
    "Chamisal": ["87521"],
    "Chaparral": ["88081"],
    "Chimayo": ["87522"],
    "Church Rock": ["87311"],
    "Cimarron": ["87714"],
    "Claunch": ["87011"],
    "Clayton": ["88415"],
    "Cleveland": ["87715"],
    "Cliff": ["88028"],
    "Clines Corners": ["87070"],
    "Cloudcroft": ["88317"],
    "Clovis": ["88101", "88102"],
    "Cochiti Lake": ["87083"],
    "Cochiti Pueblo": ["87072"],
    "Columbus": ["88029"],
    "Conchas Dam": ["88416"],
    "Continental Divide": ["87312"],
    "Cordova": ["87523"],
    "Corona": ["88318"],
    "Corrales": ["87048"],
    "Costilla": ["87524"],
    "Counselor": ["87018"],
    "Coyote": ["87012"],
    "Crossroads": ["88114"],
    "Crownpoint": ["87313"],
    "Cuba": ["87013"],
    "Cubero": ["87014"],
    "Cuervo": ["88417"],
    "Datil": ["87821"],
    "Deming": ["88030", "88031"],
    "Derry": ["87933"],
    "Des Moines": ["88418"],
    "Dexter": ["88230"],
    "Dixon": ["87527"],
    "Dona Ana": ["88032"],
    "Dora": ["88115"],
    "Dulce": ["87528"],
    "Eagle Nest": ["87718"],
    "Edgewood": ["87015"],
    "El Prado": ["87529"],
    "El Rito": ["87530"],
    "Elephant Butte": ["87935"],
    "Elida": ["88116"],
    "Embudo": ["87531"],
    "Encino": ["88321"],
    "Espanola": ["87532", "87533"],
    "Estancia": ["87016"],
    "Eunice": ["88231"],
    "Fairacres": ["88033"],
    "Farmington": ["87401", "87402", "87499"],
    "Faywood": ["88034"],
    "Fence Lake": ["87315"],
    "Flora Vista": ["87415"],
    "Floyd": ["88118"],
    "Folsom": ["88419"],
    "Fort Bayard": ["88036"],
    "Fort Stanton": ["88323"],
    "Fort Sumner": ["88119"],
    "Fort Wingate": ["87316"],
    "Fruitland": ["87416"],
    "Gallina": ["87017"],
    "Gallup": ["87301", "87302", "87305"],
    "Gamerco": ["87317"],
    "Garfield": ["87936"],
    "Garita": ["88421"],
    "Gila": ["88038"],
    "Gladstone": ["88422"],
    "Glencoe": ["88324"],
    "Glenwood": ["88039"],
    "Glorieta": ["87535"],
    "Grady": ["88120"],
    "Grants": ["87020"],
    "Grenville": ["88424"],
    "Guadalupita": ["87722"],
    "Hachita": ["88040"],
    "Hagerman": ["88232"],
    "Hanover": ["88041"],
    "Hatch": ["87937"],
    "Hernandez": ["87537"],
    "High Rolls Mountain Park": ["88325"],
    "Hillsboro": ["88042"],
    "Hobbs": ["88240", "88241", "88242", "88244"],
    "Holloman Air Force Base": ["88330"],
    "Holman": ["87723"],
    "Hondo": ["88336"],
    "Hope": ["88250"],
    "House": ["88121"],
    "Hurley": ["88043"],
    "Ilfeld": ["87538"],
    "Isleta": ["87022"],
    "Jal": ["88252"],
    "Jamestown": ["87347"],
    "Jarales": ["87023"],
    "Jemez Pueblo": ["87024"],
    "Jemez Springs": ["87025"],
    "Kenna": ["88122"],
    "Kirtland": ["87417"],
    "Kirtland AFB": ["87117"],
    "La Jara": ["87027"],
    "La Joya": ["87028"],
    "La Loma": ["87724"],
    "La Luz": ["88337"],
    "La Madera": ["87539"],
    "La Mesa": ["88044"],
    "La Plata": ["87418"],
    "Laguna": ["87026"],
    "Lake Arthur": ["88253"],
    "Lakewood": ["88254"],
    "Lamy": ["87540"],
    "Las Cruces": ["88001", "88003", "88004", "88005", "88006", "88007", "88011", "88012", "88013"],
    "Las Vegas": ["87701"],
    "Lemitar": ["87823"],
    "Lincoln": ["88338"],
    "Lindrith": ["87029"],
    "Lingo": ["88123"],
    "Llano": ["87543"],
    "Loco Hills": ["88255"],
    "Logan": ["88426"],
    "Lordsburg": ["88045"],
    "Los Alamos": ["87544", "87545"],
    "Los Lunas": ["87031"],
    "Los Ojos": ["87551"],
    "Loving": ["88256"],
    "Lovington": ["88260"],
    "Luna": ["87824"],
    "Magdalena": ["87825"],
    "Malaga": ["88263"],
    "Maljamar": ["88264"],
    "Maxwell": ["87728"],
    "Mayhill": ["88339"],
    "Mcalister": ["88427"],
    "Mcdonald": ["88262"],
    "Mcintosh": ["87032"],
    "Medanales": ["87548"],
    "Melrose": ["88124"],
    "Mentmore": ["87319"],
    "Mescalero": ["88340"],
    "Mesilla": ["88046"],
    "Mesilla Park": ["88047"],
    "Mesquite": ["88048"],
    "Mexican Springs": ["87320"],
    "Miami": ["87729"],
    "Milan": ["87021"],
    "Mills": ["87730"],
    "Milnesand": ["88125"],
    "Mimbres": ["88049"],
    "Montezuma": ["87731"],
    "Monticello": ["87939"],
    "Monument": ["88265"],
    "Mora": ["87732"],
    "Moriarty": ["87035"],
    "Mosquero": ["87733"],
    "Mountainair": ["87036"],
    "Mule Creek": ["88051"],
    "Nageezi": ["87037"],
    "Nara Visa": ["88430"],
    "Navajo": ["87328"],
    "Navajo Dam": ["87419"],
    "New Laguna": ["87038"],
    "Newcomb": ["87455"],
    "Newkirk": ["88431"],
    "Nogal": ["88341"],
    "Ocate": ["87734"],
    "Ohkay Owingeh": ["87566"],
    "Ojo Caliente": ["87549"],
    "Ojo Feliz": ["87735"],
    "Organ": ["88052"],
    "Orogrande": ["88342"],
    "Paguate": ["87040"],
    "Pecos": ["87552"],
    "Pena Blanca": ["87041"],
    "Penasco": ["87553"],
    "Pep": ["88126"],
    "Peralta": ["87042"],
    "Petaca": ["87554"],
    "Picacho": ["88343"],
    "Pie Town": ["87827"],
    "Pinehill": ["87357"],
    "Pinon": ["88344"],
    "Pinos Altos": ["88053"],
    "Placitas": ["87043"],
    "Playas": ["88009"],
    "Polvadera": ["87828"],
    "Ponderosa": ["87044"],
    "Portales": ["88130"],
    "Prewitt": ["87045"],
    "Pueblo Of Acoma": ["87034"],
    "Quay": ["88433"],
    "Quemado": ["87829"],
    "Questa": ["87556"],
    "Radium Springs": ["88054"],
    "Rainsville": ["87736"],
    "Ramah": ["87321"],
    "Ranchos De Taos": ["87557"],
    "Raton": ["87740"],
    "Red River": ["87558"],
    "Redrock": ["88055"],
    "Regina": ["87046"],
    "Rehoboth": ["87322"],
    "Reserve": ["87830"],
    "Ribera": ["87560"],
    "Rincon": ["87940"],
    "Rio Rancho": ["87124", "87144", "87174"],
    "Rociada": ["87742"],
    "Rodeo": ["88056"],
    "Rogers": ["88132"],
    "Roswell": ["88201", "88202", "88203"],
    "Rowe": ["87562"],
    "Roy": ["87743"],
    "Ruidoso": ["88345", "88355"],
    "Ruidoso Downs": ["88346"],
    "Sacramento": ["88347"],
    "Saint Vrain": ["88133"],
    "Salem": ["87941"],
    "San Acacia": ["87831"],
    "San Antonio": ["87832"],
    "San Cristobal": ["87564"],
    "San Fidel": ["87049"],
    "San Jon": ["88434"],
    "San Jose": ["87565"],
    "San Miguel": ["88058"],
    "San Patricio": ["88348"],
    "San Rafael": ["87051"],
    "San Ysidro": ["87053"],
    "Sandia Park": ["87047"],
    "Sanostee": ["87461"],
    "Santa Clara": ["88026"],
    "Santa Cruz": ["87567"],
    "Santa Fe": ["87501", "87502", "87503", "87504", "87505", "87506", "87507", "87508", "87509", "87592", "87594"],
    "Santa Rosa": ["88435"],
    "Santa Teresa": ["88008"],
    "Santo Domingo Pueblo": ["87052"],
    "Sapello": ["87745"],
    "Sedan": ["88436"],
    "Serafina": ["87569"],
    "Sheep Springs": ["87364"],
    "Shiprock": ["87420"],
    "Silver City": ["88061", "88062"],
    "Smith Lake": ["87365"],
    "Socorro": ["87801"],
    "Solano": ["87746"],
    "Spaceport City": ["87654"],
    "Springer": ["87747"],
    "Stanley": ["87056"],
    "Sunland Park": ["88063"],
    "Sunspot": ["88349"],
    "Taiban": ["88134"],
    "Taos": ["87571"],
    "Taos Ski Valley": ["87525"],
    "Tatum": ["88267"],
    "Tererro": ["87573"],
    "Tesuque": ["87574"],
    "Texico": ["88135"],
    "Thoreau": ["87323"],
    "Tierra Amarilla": ["87575"],
    "Tijeras": ["87059"],
    "Timberon": ["88350"],
    "Tinnie": ["88351"],
    "Tohatchi": ["87325"],
    "Tome": ["87060"],
    "Torreon": ["87061"],
    "Trampas": ["87576"],
    "Trementina": ["88439"],
    "Tres Piedras": ["87577"],
    "Truchas": ["87578"],
    "Truth Or Consequences": ["87901"],
    "Tucumcari": ["88401"],
    "Tularosa": ["88352"],
    "Tyrone": ["88065"],
    "Ute Park": ["87749"],
    "Vadito": ["87579"],
    "Vado": ["88072"],
    "Valdez": ["87580"],
    "Vallecitos": ["87581"],
    "Valmora": ["87750"],
    "Vanderwagen": ["87326"],
    "Vaughn": ["88353"],
    "Veguita": ["87062"],
    "Velarde": ["87582"],
    "Villanueva": ["87583"],
    "Wagon Mound": ["87752"],
    "Waterflow": ["87421"],
    "Watrous": ["87753"],
    "Weed": ["88354"],
    "White Rock": ["87547"],
    "White Sands Missile Range": ["88002"],
    "Whites City": ["88268"],
    "Willard": ["87063"],
    "Williamsburg": ["87942"],
    "Winston": ["87943"],
    "Yatahey": ["87375"],
    "Yeso": ["88136"],
    "Youngsville": ["87064"],
    "Zuni": ["87327"]
  },
  "NV": {
    "Alamo": ["89001"],
    "Amargosa Valley": ["89020"],
    "Austin": ["89310"],
    "Baker": ["89311"],
    "Battle Mountain": ["89820"],
    "Beatty": ["89003"],
    "Blue Diamond": ["89004"],
    "Boulder City": ["89005", "89006"],
    "Bunkerville": ["89007"],
    "Cal Nev Ari": ["89039"],
    "Caliente": ["89008"],
    "Carlin": ["89822"],
    "Carson City": ["89701", "89702", "89703", "89705", "89706", "89711", "89712", "89713", "89714", "89721"],
    "Coyote Springs": ["89037", "89067"],
    "Crescent Valley": ["89821"],
    "Crystal Bay": ["89402"],
    "Dayton": ["89403"],
    "Deeth": ["89823"],
    "Denio": ["89404"],
    "Duckwater": ["89314"],
    "Dyer": ["89010"],
    "Elko": ["89801", "89802", "89803"],
    "Ely": ["89301", "89315"],
    "Empire": ["89405"],
    "Eureka": ["89316"],
    "Fallon": ["89406", "89407", "89496"],
    "Fernley": ["89408"],
    "Gabbs": ["89409"],
    "Gardnerville": ["89410", "89460"],
    "Genoa": ["89411"],
    "Gerlach": ["89412"],
    "Glenbrook": ["89413"],
    "Golconda": ["89414"],
    "Goldfield": ["89013"],
    "Halleck": ["89824"],
    "Hawthorne": ["89415"],
    "Henderson": ["89002", "89009", "89011", "89012", "89014", "89015", "89016", "89044", "89052", "89053", "89074", "89077"],
    "Hiko": ["89017"],
    "Imlay": ["89418"],
    "Incline Village": ["89450", "89451", "89452"],
    "Indian Springs": ["89018", "89070"],
    "Jackpot": ["89825"],
    "Jarbidge": ["89826"],
    "Jean": ["89019", "89026"],
    "Lamoille": ["89828"],
    "Las Vegas": ["89101", "89102", "89103", "89104", "89105", "89106", "89107", "89108", "89109", "89110", "89111", "89112", "89113", "89114", "89115", "89116", "89117", "89118", "89119", "89120", "89121", "89122", "89123", "89124", "89125", "89126", "89127", "89128", "89129", "89130", "89131", "89132", "89133", "89134", "89135", "89136", "89137", "89138", "89139", "89140", "89141", "89142", "89143", "89144", "89145", "89146", "89147", "89148", "89149", "89150", "89151", "89152", "89153", "89154", "89155", "89156", "89157", "89158", "89159", "89160", "89161", "89162", "89164", "89165", "89166", "89169", "89170", "89173", "89177", "89178", "89179", "89180", "89183", "89185", "89193", "89195", "89199"],
    "Laughlin": ["89028", "89029"],
    "Logandale": ["89021"],
    "Lovelock": ["89419"],
    "Lund": ["89317"],
    "Luning": ["89420"],
    "Manhattan": ["89022"],
    "Mc Dermitt": ["89421"],
    "Mc Gill": ["89318"],
    "Mercury": ["89023"],
    "Mesquite": ["89024", "89027", "89034"],
    "Mina": ["89422"],
    "Minden": ["89423"],
    "Moapa": ["89025"],
    "Montello": ["89830"],
    "Mountain City": ["89831"],
    "Nellis AFB": ["89191"],
    "Nixon": ["89424"],
    "North Las Vegas": ["89030", "89031", "89032", "89033", "89036", "89081", "89084", "89085", "89086", "89087"],
    "Orovada": ["89425"],
    "Overton": ["89040"],
    "Owyhee": ["89832"],
    "Pahrump": ["89041", "89048", "89060", "89061"],
    "Panaca": ["89042"],
    "Paradise Valley": ["89426"],
    "Pioche": ["89043"],
    "Reno": ["89501", "89502", "89503", "89504", "89505", "89506", "89507", "89508", "89509", "89510", "89511", "89512", "89513", "89515", "89519", "89520", "89521", "89523", "89533", "89555", "89557", "89570", "89595", "89599"],
    "Round Mountain": ["89045"],
    "Ruby Valley": ["89833"],
    "Ruth": ["89319"],
    "Schurz": ["89427"],
    "Searchlight": ["89046"],
    "Silver City": ["89428"],
    "Silver Springs": ["89429"],
    "Silverpeak": ["89047"],
    "Sloan": ["89054"],
    "Smith": ["89430"],
    "Sparks": ["89431", "89432", "89434", "89435", "89436", "89437", "89441"],
    "Spring Creek": ["89815"],
    "Stateline": ["89449"],
    "Sun Valley": ["89433"],
    "The Lakes": ["88901", "88905", "89163"],
    "Tonopah": ["89049"],
    "Tuscarora": ["89834"],
    "Valmy": ["89438"],
    "Verdi": ["89439"],
    "Virginia City": ["89440"],
    "Wadsworth": ["89442"],
    "Washoe Valley": ["89704"],
    "Wellington": ["89444"],
    "Wells": ["89835"],
    "West Wendover": ["89883"],
    "Winnemucca": ["89445", "89446"],
    "Yerington": ["89447"],
    "Zephyr Cove": ["89448"]
  },
  "NY": {
    "Accord": ["12404"],
    "Acra": ["12405"],
    "Adams": ["13605"],
    "Adams Basin": ["14410"],
    "Adams Center": ["13606"],
    "Addison": ["14801"],
    "Adirondack": ["12808"],
    "Afton": ["13730"],
    "Akron": ["14001"],
    "Albany": ["12201", "12202", "12203", "12204", "12205", "12206", "12207", "12208", "12209", "12210", "12211", "12212", "12214", "12220", "12222", "12223", "12224", "12225", "12226", "12227", "12228", "12229", "12230", "12231", "12232", "12233", "12234", "12235", "12236", "12237", "12238", "12239", "12240", "12241", "12242", "12243", "12244", "12245", "12246", "12247", "12248", "12249", "12250", "12252", "12255", "12256", "12257", "12260", "12261", "12288"],
    "Albertson": ["11507"],
    "Albion": ["14411"],
    "Alcove": ["12007"],
    "Alden": ["14004"],
    "Alder Creek": ["13301"],
    "Alexander": ["14005"],
    "Alexandria Bay": ["13607"],
    "Alfred": ["14802"],
    "Alfred Station": ["14803"],
    "Allegany": ["14706"],
    "Allentown": ["14707"],
    "Alma": ["14708"],
    "Almond": ["14804"],
    "Alpine": ["14805"],
    "Alplaus": ["12008"],
    "Altamont": ["12009"],
    "Altmar": ["13302"],
    "Alton": ["14413"],
    "Altona": ["12910"],
    "Amagansett": ["11930"],
    "Amawalk": ["10501"],
    "Amenia": ["12501"],
    "Amityville": ["11701", "11708"],
    "Amsterdam": ["12010"],
    "Ancram": ["12502"],
    "Ancramdale": ["12503"],
    "Andes": ["13731"],
    "Andover": ["14806"],
    "Angelica": ["14709"],
    "Angola": ["14006"],
    "Annandale On Hudson": ["12504"],
    "Antwerp": ["13608", "13671"],
    "Apalachin": ["13732"],
    "Appleton": ["14008"],
    "Apulia Station": ["13020"],
    "Aquebogue": ["11931"],
    "Arcade": ["14009"],
    "Arden": ["10910"],
    "Ardsley": ["10502"],
    "Ardsley On Hudson": ["10503"],
    "Argyle": ["12809"],
    "Arkport": ["14807"],
    "Arkville": ["12406"],
    "Armonk": ["10504"],
    "Arverne": ["11692"],
    "Ashland": ["12407"],
    "Ashville": ["14710"],
    "Astoria": ["11102", "11103", "11105", "11106"],
    "Athens": ["12015"],
    "Athol": ["12810"],
    "Athol Springs": ["14010"],
    "Atlanta": ["14808"],
    "Atlantic Beach": ["11509"],
    "Attica": ["14011"],
    "Au Sable Forks": ["12912"],
    "Auburn": ["13021", "13022", "13024"],
    "Auriesville": ["12016"],
    "Aurora": ["13026"],
    "Austerlitz": ["12017"],
    "Ava": ["13303"],
    "Averill Park": ["12018"],
    "Avoca": ["14809"],
    "Avon": ["14414"],
    "Babylon": ["11702"],
    "Bainbridge": ["13733"],
    "Bakers Mills": ["12811"],
    "Baldwin": ["11510"],
    "Baldwin Place": ["10505"],
    "Baldwinsville": ["13027"],
    "Ballston Lake": ["12019"],
    "Ballston Spa": ["12020"],
    "Bangall": ["12506"],
    "Barker": ["14012"],
    "Barneveld": ["13304"],
    "Barrytown": ["12507"],
    "Barryville": ["12719"],
    "Barton": ["13734"],
    "Basom": ["14013"],
    "Batavia": ["14020", "14021"],
    "Bath": ["14810"],
    "Bay Shore": ["11706"],
    "Bayport": ["11705"],
    "Bayside": ["11359", "11360", "11361"],
    "Bayville": ["11709"],
    "Beacon": ["12508"],
    "Bear Mountain": ["10911"],
    "Bearsville": ["12409"],
    "Beaver Dams": ["14812"],
    "Beaver Falls": ["13305"],
    "Bedford": ["10506"],
    "Bedford Hills": ["10507"],
    "Belfast": ["14711"],
    "Bellerose": ["11426"],
    "Belleville": ["13611"],
    "Bellmore": ["11710"],
    "Bellona": ["14415"],
    "Bellport": ["11713"],
    "Bellvale": ["10912"],
    "Belmont": ["14813"],
    "Bemus Point": ["14712"],
    "Bergen": ["14416"],
    "Berkshire": ["13736"],
    "Berlin": ["12022"],
    "Berne": ["12023"],
    "Bernhards Bay": ["13028"],
    "Bethel": ["12720"],
    "Bethpage": ["11714"],
    "Bible School Park": ["13737"],
    "Big Flats": ["14814"],
    "Big Indian": ["12410"],
    "Billings": ["12510"],
    "Binghamton": ["13901", "13902", "13903", "13904", "13905"],
    "Black Creek": ["14714"],
    "Black River": ["13612"],
    "Blauvelt": ["10913"],
    "Bliss": ["14024"],
    "Blodgett Mills": ["13738"],
    "Bloomfield": ["14469"],
    "Blooming Grove": ["10914"],
    "Bloomingburg": ["12721"],
    "Bloomingdale": ["12913"],
    "Bloomington": ["12411"],
    "Bloomville": ["13739"],
    "Blossvale": ["13308"],
    "Blue Mountain Lake": ["12812"],
    "Blue Point": ["11715"],
    "Bohemia": ["11716"],
    "Boiceville": ["12412"],
    "Bolivar": ["14715"],
    "Bolton Landing": ["12814"],
    "Bombay": ["12914"],
    "Boonville": ["13309"],
    "Boston": ["14025"],
    "Bouckville": ["13310"],
    "Bovina Center": ["13740"],
    "Bowmansville": ["14026"],
    "Bradford": ["14815"],
    "Brainard": ["12024"],
    "Brainardsville": ["12915"],
    "Branchport": ["14418"],
    "Brant": ["14027"],
    "Brant Lake": ["12815"],
    "Brantingham": ["13312"],
    "Brasher Falls": ["13613"],
    "Breesport": ["14816"],
    "Breezy Point": ["11697"],
    "Brentwood": ["11717"],
    "Brewerton": ["13029"],
    "Brewster": ["10509"],
    "Briarcliff Manor": ["10510"],
    "Bridgehampton": ["11932"],
    "Bridgeport": ["13030"],
    "Bridgewater": ["13313"],
    "Brier Hill": ["13614"],
    "Brightwaters": ["11718"],
    "Broadalbin": ["12025"],
    "Brockport": ["14420"],
    "Brocton": ["14716"],
    "Bronx": ["10451", "10452", "10453", "10454", "10455", "10456", "10457", "10458", "10459", "10460", "10461", "10462", "10463", "10464", "10465", "10466", "10467", "10468", "10469", "10470", "10471", "10472", "10473", "10474", "10475", "10499"],
    "Bronxville": ["10708"],
    "Brookfield": ["13314"],
    "Brookhaven": ["11719"],
    "Brooklyn": ["11201", "11202", "11203", "11204", "11205", "11206", "11207", "11208", "11209", "11210", "11211", "11212", "11213", "11214", "11215", "11216", "11217", "11218", "11219", "11220", "11221", "11222", "11223", "11224", "11225", "11226", "11228", "11229", "11230", "11231", "11232", "11233", "11234", "11235", "11236", "11237", "11238", "11239", "11240", "11241", "11242", "11243", "11244", "11245", "11247", "11248", "11249", "11251", "11252", "11254", "11255", "11256"],
    "Brooktondale": ["14817"],
    "Brownville": ["13615"],
    "Brushton": ["12916"],
    "Buchanan": ["10511"],
    "Buffalo": ["14201", "14202", "14203", "14204", "14205", "14206", "14207", "14208", "14209", "14210", "14211", "14212", "14213", "14214", "14215", "14216", "14217", "14218", "14219", "14220", "14221", "14222", "14223", "14224", "14225", "14226", "14227", "14228", "14231", "14233", "14240", "14241", "14260", "14261", "14263", "14264", "14265", "14267", "14269", "14270", "14272", "14273", "14276", "14280"],
    "Bullville": ["10915"],
    "Burdett": ["14818"],
    "Burke": ["12917"],
    "Burlingham": ["12722"],
    "Burlington Flats": ["13315"],
    "Burnt Hills": ["12027"],
    "Burt": ["14028"],
    "Buskirk": ["12028"],
    "Byron": ["14422"],
    "Cadyville": ["12918"],
    "Cairo": ["12413"],
    "Calcium": ["13616"],
    "Caledonia": ["14423"],
    "Callicoon": ["12723"],
    "Callicoon Center": ["12724"],
    "Calverton": ["11933"],
    "Cambria Heights": ["11411"],
    "Cambridge": ["12816"],
    "Camden": ["13316"],
    "Cameron": ["14819"],
    "Cameron Mills": ["14820"],
    "Camillus": ["13031"],
    "Campbell": ["14821"],
    "Campbell Hall": ["10916"],
    "Canaan": ["12029"],
    "Canajoharie": ["13317"],
    "Canandaigua": ["14424"],
    "Canaseraga": ["14822"],
    "Canastota": ["13032"],
    "Candor": ["13743"],
    "Caneadea": ["14717"],
    "Canisteo": ["14823"],
    "Canton": ["13617"],
    "Cape Vincent": ["13618"],
    "Carle Place": ["11514"],
    "Carlisle": ["12031"],
    "Carmel": ["10512"],
    "Caroga Lake": ["12032"],
    "Carthage": ["13619"],
    "Cassadaga": ["14718"],
    "Cassville": ["13318"],
    "Castile": ["14427"],
    "Castle Creek": ["13744"],
    "Castle Point": ["12511"],
    "Castleton On Hudson": ["12033"],
    "Castorland": ["13620"],
    "Cato": ["13033"],
    "Catskill": ["12414"],
    "Cattaraugus": ["14719"],
    "Cayuga": ["13034"],
    "Cayuta": ["14824"],
    "Cazenovia": ["13035"],
    "Cedarhurst": ["11516"],
    "Celoron": ["14720"],
    "Center Moriches": ["11934"],
    "Centereach": ["11720"],
    "Centerport": ["11721"],
    "Centerville": ["14029"],
    "Central Bridge": ["12035"],
    "Central Islip": ["11722"],
    "Central Square": ["13036"],
    "Central Valley": ["10917"],
    "Ceres": ["14721"],
    "Chadwicks": ["13319"],
    "Chaffee": ["14030"],
    "Champlain": ["12919"],
    "Chappaqua": ["10514"],
    "Charlotteville": ["12036"],
    "Chase Mills": ["13621"],
    "Chateaugay": ["12920"],
    "Chatham": ["12037"],
    "Chaumont": ["13622"],
    "Chautauqua": ["14722"],
    "Chazy": ["12921"],
    "Chelsea": ["12512"],
    "Chemung": ["14825"],
    "Chenango Bridge": ["13745"],
    "Chenango Forks": ["13746"],
    "Cherry Creek": ["14723"],
    "Cherry Plain": ["12040"],
    "Cherry Valley": ["13320"],
    "Chester": ["10918"],
    "Chestertown": ["12817"],
    "Chichester": ["12416"],
    "Childwold": ["12922"],
    "Chippewa Bay": ["13623"],
    "Chittenango": ["13037"],
    "Churchville": ["14428"],
    "Churubusco": ["12923"],
    "Cicero": ["13039"],
    "Cincinnatus": ["13040"],
    "Circleville": ["10919"],
    "Clarence": ["14031"],
    "Clarence Center": ["14032"],
    "Clarendon": ["14429"],
    "Clark Mills": ["13321"],
    "Clarkson": ["14430"],
    "Clarksville": ["12041"],
    "Claryville": ["12725"],
    "Claverack": ["12513"],
    "Clay": ["13041"],
    "Clayton": ["13624"],
    "Clayville": ["13322"],
    "Clemons": ["12819"],
    "Cleveland": ["13042"],
    "Cleverdale": ["12820"],
    "Clifton Park": ["12065"],
    "Clifton Springs": ["14432"],
    "Climax": ["12042"],
    "Clinton": ["13323"],
    "Clinton Corners": ["12514"],
    "Clintondale": ["12515"],
    "Clockville": ["13043"],
    "Clyde": ["14433"],
    "Clymer": ["14724"],
    "Cobleskill": ["12043"],
    "Cochecton": ["12726", "12727"],
    "Coeymans": ["12045"],
    "Coeymans Hollow": ["12046"],
    "Cohocton": ["14826"],
    "Cohoes": ["12047"],
    "Cold Brook": ["13324"],
    "Cold Spring": ["10516"],
    "Cold Spring Harbor": ["11724"],
    "Colden": ["14033"],
    "College Point": ["11356"],
    "Colliersville": ["13747"],
    "Collins": ["14034"],
    "Collins Center": ["14035"],
    "Colton": ["13625"],
    "Columbiaville": ["12050"],
    "Commack": ["11725"],
    "Comstock": ["12821"],
    "Conesus": ["14435"],
    "Conewango Valley": ["14726"],
    "Congers": ["10920"],
    "Conklin": ["13748"],
    "Connelly": ["12417"],
    "Constable": ["12926"],
    "Constableville": ["13325"],
    "Constantia": ["13044"],
    "Coopers Plains": ["14827"],
    "Cooperstown": ["13326"],
    "Copake": ["12516"],
    "Copake Falls": ["12517"],
    "Copenhagen": ["13626"],
    "Copiague": ["11726"],
    "Coram": ["11727"],
    "Corbettsville": ["13749"],
    "Corfu": ["14036"],
    "Corinth": ["12822"],
    "Corning": ["14830", "14831"],
    "Cornwall": ["12518"],
    "Cornwall On Hudson": ["12520"],
    "Cornwallville": ["12418"],
    "Corona": ["11368"],
    "Cortland": ["13045"],
    "Cortlandt Manor": ["10567"],
    "Cossayuna": ["12823"],
    "Cottekill": ["12419"],
    "Cowlesville": ["14037"],
    "Coxsackie": ["12051"],
    "Cragsmoor": ["12420"],
    "Cranberry Lake": ["12927"],
    "Craryville": ["12521"],
    "Crittenden": ["14038"],
    "Croghan": ["13327"],
    "Crompond": ["10517"],
    "Cropseyville": ["12052"],
    "Cross River": ["10518"],
    "Croton Falls": ["10519"],
    "Croton On Hudson": ["10520", "10521"],
    "Crown Point": ["12928"],
    "Cuba": ["14727"],
    "Cuddebackville": ["12729"],
    "Cutchogue": ["11935"],
    "Dale": ["14039"],
    "Dalton": ["14836"],
    "Dannemora": ["12929"],
    "Dansville": ["14437"],
    "Darien Center": ["14040"],
    "Davenport": ["13750"],
    "Davenport Center": ["13751"],
    "Dayton": ["14041"],
    "De Kalb Junction": ["13630"],
    "De Peyster": ["13633"],
    "De Ruyter": ["13052"],
    "Deansboro": ["13328"],
    "Deer Park": ["11729"],
    "Deer River": ["13627"],
    "Deferiet": ["13628"],
    "Delancey": ["13752"],
    "Delanson": ["12053"],
    "Delevan": ["14042"],
    "Delhi": ["13753"],
    "Delmar": ["12054"],
    "Delphi Falls": ["13051"],
    "Denmark": ["13631"],
    "Denver": ["12421"],
    "Depauville": ["13632"],
    "Depew": ["14043"],
    "Deposit": ["13754"],
    "Derby": ["14047"],
    "Dewittville": ["14728"],
    "Dexter": ["13634"],
    "Diamond Point": ["12824"],
    "Dickinson Center": ["12930"],
    "Dobbs Ferry": ["10522"],
    "Dolgeville": ["13329"],
    "Dormansville": ["12055"],
    "Dover Plains": ["12522"],
    "Downsville": ["13755"],
    "Dresden": ["14441"],
    "Dryden": ["13053"],
    "Duanesburg": ["12056"],
    "Dundee": ["14837"],
    "Dunkirk": ["14048"],
    "Durham": ["12422"],
    "Durhamville": ["13054"],
    "Eagle Bay": ["13331"],
    "Eagle Bridge": ["12057"],
    "Earlton": ["12058"],
    "Earlville": ["13332"],
    "East Amherst": ["14051"],
    "East Aurora": ["14052"],
    "East Berne": ["12059"],
    "East Bethany": ["14054"],
    "East Bloomfield": ["14443"],
    "East Branch": ["13756"],
    "East Chatham": ["12060"],
    "East Concord": ["14055"],
    "East Durham": ["12423"],
    "East Elmhurst": ["11369", "11370"],
    "East Greenbush": ["12061"],
    "East Hampton": ["11937"],
    "East Homer": ["13056"],
    "East Islip": ["11730"],
    "East Jewett": ["12424"],
    "East Marion": ["11939"],
    "East Meadow": ["11554"],
    "East Meredith": ["13757"],
    "East Moriches": ["11940"],
    "East Nassau": ["12062"],
    "East Northport": ["11731"],
    "East Norwich": ["11732"],
    "East Otto": ["14729"],
    "East Pembroke": ["14056"],
    "East Pharsalia": ["13758"],
    "East Quogue": ["11942"],
    "East Randolph": ["14730"],
    "East Rochester": ["14445"],
    "East Rockaway": ["11518"],
    "East Schodack": ["12063"],
    "East Setauket": ["11733"],
    "East Springfield": ["13333"],
    "East Syracuse": ["13057"],
    "East Williamson": ["14449"],
    "East Worcester": ["12064"],
    "Eastchester": ["10709"],
    "Eastport": ["11941"],
    "Eaton": ["13334"],
    "Eden": ["14057"],
    "Edmeston": ["13335"],
    "Edwards": ["13635"],
    "Elba": ["14058"],
    "Elbridge": ["13060"],
    "Eldred": ["12732"],
    "Elizabethtown": ["12932"],
    "Elizaville": ["12523"],
    "Elka Park": ["12427"],
    "Ellenburg": ["12933"],
    "Ellenburg Center": ["12934"],
    "Ellenburg Depot": ["12935"],
    "Ellenville": ["12428"],
    "Ellicottville": ["14731"],
    "Ellington": ["14732"],
    "Ellisburg": ["13636"],
    "Elma": ["14059"],
    "Elmhurst": ["11373", "11380"],
    "Elmira": ["14901", "14902", "14903", "14904", "14905", "14925"],
    "Elmont": ["11003"],
    "Elmsford": ["10523"],
    "Endicott": ["13760", "13761", "13763"],
    "Endwell": ["13762"],
    "Erieville": ["13061"],
    "Erin": ["14838"],
    "Esopus": ["12429"],
    "Esperance": ["12066"],
    "Essex": ["12936"],
    "Etna": ["13062"],
    "Evans Mills": ["13637"],
    "Fabius": ["13063"],
    "Fair Haven": ["13064"],
    "Fairport": ["14450"],
    "Falconer": ["14733"],
    "Fallsburg": ["12733"],
    "Fancher": ["14452"],
    "Far Rockaway": ["11690", "11691", "11693", "11695"],
    "Farmersville Station": ["14060"],
    "Farmingdale": ["11735", "11736", "11737", "11774"],
    "Farmington": ["14425"],
    "Farmingville": ["11738"],
    "Farnham": ["14061"],
    "Fayette": ["13065"],
    "Fayetteville": ["13066"],
    "Felts Mills": ["13638"],
    "Ferndale": ["12734"],
    "Feura Bush": ["12067"],
    "Fillmore": ["14735"],
    "Findley Lake": ["14736"],
    "Fine": ["13639"],
    "Fishers": ["14453"],
    "Fishers Island": ["06390"],
    "Fishers Landing": ["13641"],
    "Fishkill": ["12524"],
    "Fishs Eddy": ["13774"],
    "Fleischmanns": ["12430"],
    "Floral Park": ["11001", "11002", "11005"],
    "Florida": ["10921"],
    "Flushing": ["11351", "11352", "11354", "11355", "11358", "11367", "11371", "11381", "11390"],
    "Fly Creek": ["13337"],
    "Fonda": ["12068"],
    "Forest Hills": ["11375"],
    "Forestburgh": ["12777"],
    "Forestport": ["13338"],
    "Forestville": ["14062"],
    "Fort Ann": ["12827"],
    "Fort Covington": ["12937"],
    "Fort Drum": ["13602"],
    "Fort Edward": ["12828"],
    "Fort Hunter": ["12069"],
    "Fort Johnson": ["12070"],
    "Fort Montgomery": ["10922"],
    "Fort Plain": ["13339"],
    "Frankfort": ["13340"],
    "Franklin": ["13775"],
    "Franklin Springs": ["13341"],
    "Franklin Square": ["11010"],
    "Franklinville": ["14737"],
    "Fredonia": ["14063"],
    "Freedom": ["14065"],
    "Freehold": ["12431"],
    "Freeport": ["11520"],
    "Freeville": ["13068"],
    "Fremont Center": ["12736"],
    "Fresh Meadows": ["11365", "11366"],
    "Frewsburg": ["14738"],
    "Friendship": ["14739"],
    "Fulton": ["13069"],
    "Fultonham": ["12071"],
    "Fultonville": ["12072"],
    "Gabriels": ["12939"],
    "Gainesville": ["14066"],
    "Gallupville": ["12073"],
    "Galway": ["12074"],
    "Gansevoort": ["12831"],
    "Garden City": ["11530", "11531", "11535", "11536", "11599"],
    "Gardiner": ["12525"],
    "Garnerville": ["10923"],
    "Garrattsville": ["13342"],
    "Garrison": ["10524"],
    "Gasport": ["14067"],
    "Geneseo": ["14454"],
    "Geneva": ["14456"],
    "Genoa": ["13071"],
    "Georgetown": ["13072"],
    "Germantown": ["12526"],
    "Gerry": ["14740"],
    "Getzville": ["14068"],
    "Ghent": ["12075"],
    "Gilbertsville": ["13776"],
    "Gilboa": ["12076"],
    "Glasco": ["12432"],
    "Glen Aubrey": ["13777"],
    "Glen Cove": ["11542"],
    "Glen Head": ["11545"],
    "Glen Oaks": ["11004"],
    "Glen Spey": ["12737"],
    "Glen Wild": ["12738"],
    "Glenfield": ["13343"],
    "Glenford": ["12433"],
    "Glenham": ["12527"],
    "Glenmont": ["12077"],
    "Glens Falls": ["12801"],
    "Glenwood": ["14069"],
    "Glenwood Landing": ["11547"],
    "Gloversville": ["12078"],
    "Goldens Bridge": ["10526"],
    "Gorham": ["14461"],
    "Goshen": ["10924"],
    "Gouverneur": ["13642"],
    "Gowanda": ["14070"],
    "Grafton": ["12082"],
    "Grahamsville": ["12740"],
    "Grand Gorge": ["12434"],
    "Grand Island": ["14072"],
    "Granite Springs": ["10527"],
    "Granville": ["12832"],
    "Great Bend": ["13643"],
    "Great Neck": ["11020", "11021", "11022", "11023", "11024", "11025", "11026", "11027"],
    "Great River": ["11739"],
    "Great Valley": ["14741"],
    "Greene": ["13778"],
    "Greenfield Center": ["12833"],
    "Greenfield Park": ["12435"],
    "Greenhurst": ["14742"],
    "Greenlawn": ["11740"],
    "Greenport": ["11944"],
    "Greenvale": ["11548"],
    "Greenville": ["12083"],
    "Greenwich": ["12834"],
    "Greenwood": ["14839"],
    "Greenwood Lake": ["10925"],
    "Greig": ["13345"],
    "Groton": ["13073"],
    "Groveland": ["14462"],
    "Guilderland": ["12084"],
    "Guilderland Center": ["12085"],
    "Guilford": ["13780"],
    "Hadley": ["12835"],
    "Hagaman": ["12086"],
    "Hague": ["12836"],
    "Hailesboro": ["13645"],
    "Haines Falls": ["12436"],
    "Halcottsville": ["12438"],
    "Hall": ["14463"],
    "Hamburg": ["14075"],
    "Hamden": ["13782"],
    "Hamilton": ["13346"],
    "Hamlin": ["14464"],
    "Hammond": ["13646"],
    "Hammondsport": ["14840"],
    "Hampton": ["12837"],
    "Hampton Bays": ["11946"],
    "Hancock": ["13783"],
    "Hankins": ["12741"],
    "Hannacroix": ["12087"],
    "Hannawa Falls": ["13647"],
    "Hannibal": ["13074"],
    "Harford": ["13784"],
    "Harpersfield": ["13786"],
    "Harpursville": ["13787"],
    "Harriman": ["10926"],
    "Harris": ["12742"],
    "Harrison": ["10528"],
    "Harrisville": ["13648"],
    "Hartford": ["12838"],
    "Hartsdale": ["10530"],
    "Hartwick": ["13348"],
    "Hastings": ["13076"],
    "Hastings On Hudson": ["10706"],
    "Hauppauge": ["11788"],
    "Haverstraw": ["10927"],
    "Hawthorne": ["10532"],
    "Hector": ["14841"],
    "Helena": ["13649"],
    "Hemlock": ["14466"],
    "Hempstead": ["11549", "11550", "11551"],
    "Henderson": ["13650"],
    "Henderson Harbor": ["13651"],
    "Henrietta": ["14467"],
    "Hensonville": ["12439"],
    "Herkimer": ["13350"],
    "Hermon": ["13652"],
    "Heuvelton": ["13654"],
    "Hewlett": ["11557"],
    "Hicksville": ["11801", "11802", "11815", "11819", "11854", "11855"],
    "High Falls": ["12440"],
    "Highland": ["12528"],
    "Highland Falls": ["10928"],
    "Highland Lake": ["12743"],
    "Highland Mills": ["10930"],
    "Highmount": ["12441"],
    "Hillburn": ["10931"],
    "Hillsdale": ["12529"],
    "Hilton": ["14468"],
    "Himrod": ["14842"],
    "Hinckley": ["13352"],
    "Hinsdale": ["14743"],
    "Hobart": ["13788"],
    "Hoffmeister": ["13353"],
    "Hogansburg": ["13655"],
    "Holbrook": ["11741"],
    "Holland": ["14080"],
    "Holland Patent": ["13354"],
    "Holley": ["14470"],
    "Hollis": ["11423"],
    "Hollowville": ["12530"],
    "Holmes": ["12531"],
    "Holtsville": ["00501", "00544", "11742"],
    "Homer": ["13077"],
    "Honeoye": ["14471"],
    "Honeoye Falls": ["14472"],
    "Hoosick": ["12089"],
    "Hoosick Falls": ["12090"],
    "Hopewell Junction": ["12533"],
    "Hornell": ["14843"],
    "Horseheads": ["14845"],
    "Hortonville": ["12745"],
    "Houghton": ["14744"],
    "Howard Beach": ["11414"],
    "Howells": ["10932"],
    "Howes Cave": ["12092"],
    "Hubbardsville": ["13355"],
    "Hudson": ["12534"],
    "Hudson Falls": ["12839"],
    "Hughsonville": ["12537"],
    "Huguenot": ["12746"],
    "Huletts Landing": ["12841"],
    "Hume": ["14745"],
    "Hunt": ["14846"],
    "Hunter": ["12442"],
    "Huntington": ["11743"],
    "Huntington Station": ["11746", "11750"],
    "Hurley": ["12443"],
    "Hurleyville": ["12747"],
    "Hyde Park": ["12538"],
    "Ilion": ["13357"],
    "Indian Lake": ["12842"],
    "Inlet": ["13360"],
    "Interlaken": ["14847"],
    "Inwood": ["11096"],
    "Ionia": ["14475"],
    "Irving": ["14081"],
    "Irvington": ["10533"],
    "Island Park": ["11558"],
    "Islandia": ["11749"],
    "Islip": ["11751"],
    "Islip Terrace": ["11752"],
    "Ithaca": ["14850", "14851", "14852", "14853"],
    "Jackson Heights": ["11372"],
    "Jacksonville": ["14854"],
    "Jamaica": ["11405", "11424", "11425", "11430", "11431", "11432", "11433", "11434", "11435", "11436", "11437", "11439", "11451", "11499"],
    "Jamesport": ["11947"],
    "Jamestown": ["14701", "14702"],
    "Jamesville": ["13078"],
    "Jasper": ["14855"],
    "Java Center": ["14082"],
    "Java Village": ["14083"],
    "Jay": ["12941"],
    "Jefferson": ["12093"],
    "Jefferson Valley": ["10535"],
    "Jeffersonville": ["12748"],
    "Jericho": ["11753", "11853"],
    "Jewett": ["12444"],
    "Johnsburg": ["12843"],
    "Johnson": ["10933"],
    "Johnson City": ["13790"],
    "Johnsonville": ["12094"],
    "Johnstown": ["12095"],
    "Jordan": ["13080"],
    "Jordanville": ["13361"],
    "Kanona": ["14856"],
    "Katonah": ["10536"],
    "Kattskill Bay": ["12844"],
    "Kauneonga Lake": ["12749"],
    "Keene": ["12942"],
    "Keene Valley": ["12943"],
    "Keeseville": ["12911", "12924", "12944"],
    "Kendall": ["14476"],
    "Kennedy": ["14747"],
    "Kenoza Lake": ["12750"],
    "Kent": ["14477"],
    "Kerhonkson": ["12446"],
    "Keuka Park": ["14478"],
    "Kew Gardens": ["11415"],
    "Kiamesha Lake": ["12751"],
    "Kill Buck": ["14748"],
    "Killawog": ["13794"],
    "Kinderhook": ["12106"],
    "King Ferry": ["13081"],
    "Kings Park": ["11754"],
    "Kingston": ["12401", "12402"],
    "Kirkville": ["13082"],
    "Kirkwood": ["13795"],
    "Knowlesville": ["14479"],
    "Knox": ["12107"],
    "Knoxboro": ["13362"],
    "La Fargeville": ["13656"],
    "La Fayette": ["13084"],
    "Lacona": ["13083"],
    "Lagrangeville": ["12540"],
    "Lake Clear": ["12945"],
    "Lake George": ["12845"],
    "Lake Grove": ["11755"],
    "Lake Hill": ["12448"],
    "Lake Huntington": ["12752"],
    "Lake Katrine": ["12449"],
    "Lake Luzerne": ["12846"],
    "Lake Peekskill": ["10537"],
    "Lake Placid": ["12946"],
    "Lake Pleasant": ["12108"],
    "Lake View": ["14085"],
    "Lakemont": ["14857"],
    "Lakeville": ["14480"],
    "Lakewood": ["14750"],
    "Lancaster": ["14086"],
    "Lanesville": ["12450"],
    "Lansing": ["14882"],
    "Larchmont": ["10538"],
    "Latham": ["12110"],
    "Laurel": ["11948"],
    "Laurens": ["13796"],
    "Lawrence": ["11559"],
    "Lawrenceville": ["12949"],
    "Lawtons": ["14091"],
    "Le Roy": ["14482"],
    "Lee Center": ["13363"],
    "Leeds": ["12451"],
    "Leicester": ["14481"],
    "Leon": ["14751"],
    "Leonardsville": ["13364"],
    "Levittown": ["11756"],
    "Lewis": ["12950"],
    "Lewiston": ["14092"],
    "Lexington": ["12452"],
    "Liberty": ["12754"],
    "Lily Dale": ["14752"],
    "Lima": ["14485"],
    "Limerick": ["13657"],
    "Limestone": ["14753"],
    "Lincolndale": ["10540"],
    "Lindenhurst": ["11757"],
    "Lindley": ["14858"],
    "Linwood": ["14486"],
    "Lisbon": ["13658"],
    "Lisle": ["13797"],
    "Little Falls": ["13365"],
    "Little Genesee": ["14754"],
    "Little Neck": ["11362", "11363"],
    "Little Valley": ["14755"],
    "Little York": ["13087"],
    "Liverpool": ["13088", "13089", "13090"],
    "Livingston": ["12541"],
    "Livingston Manor": ["12758"],
    "Livonia": ["14487"],
    "Livonia Center": ["14488"],
    "Loch Sheldrake": ["12759"],
    "Locke": ["13092"],
    "Lockport": ["14094", "14095"],
    "Lockwood": ["14859"],
    "Locust Valley": ["11560"],
    "Lodi": ["14860"],
    "Long Beach": ["11561"],
    "Long Eddy": ["12760"],
    "Long Island City": ["11101", "11109", "11120"],
    "Long Lake": ["12847"],
    "Lorraine": ["13659"],
    "Lowman": ["14861"],
    "Lowville": ["13367"],
    "Lycoming": ["13093"],
    "Lynbrook": ["11563"],
    "Lyndonville": ["14098"],
    "Lyon Mountain": ["12952", "12955"],
    "Lyons": ["14489"],
    "Lyons Falls": ["13368"],
    "Macedon": ["14502"],
    "Machias": ["14101"],
    "Madison": ["13402"],
    "Madrid": ["13660"],
    "Mahopac": ["10541"],
    "Mahopac Falls": ["10542"],
    "Maine": ["13802"],
    "Malden Bridge": ["12115"],
    "Malden On Hudson": ["12453"],
    "Mallory": ["13103"],
    "Malone": ["12953"],
    "Malverne": ["11565"],
    "Mamaroneck": ["10543"],
    "Manchester": ["14504"],
    "Manhasset": ["11030"],
    "Manlius": ["13104"],
    "Mannsville": ["13661"],
    "Manorville": ["11949"],
    "Maple Springs": ["14756"],
    "Maple View": ["13107"],
    "Maplecrest": ["12454"],
    "Marathon": ["13803"],
    "Marcellus": ["13108"],
    "Marcy": ["13403"],
    "Margaretville": ["12455"],
    "Marietta": ["13110"],
    "Marilla": ["14102"],
    "Marion": ["14505"],
    "Marlboro": ["12542"],
    "Martinsburg": ["13404"],
    "Martville": ["13111"],
    "Maryknoll": ["10545"],
    "Maryland": ["12116"],
    "Masonville": ["13804"],
    "Maspeth": ["11378"],
    "Massapequa": ["11758"],
    "Massapequa Park": ["11762"],
    "Massena": ["13662"],
    "Mastic": ["11950"],
    "Mastic Beach": ["11951"],
    "Mattituck": ["11952"],
    "Maybrook": ["12543"],
    "Mayfield": ["12117"],
    "Mayville": ["14757"],
    "Mc Connellsville": ["13401"],
    "Mc Donough": ["13801"],
    "Mc Graw": ["13101"],
    "Mc Lean": ["13102"],
    "Mechanicville": ["12118"],
    "Mecklenburg": ["14863"],
    "Medford": ["11763"],
    "Medina": ["14103"],
    "Medusa": ["12120"],
    "Mellenville": ["12544"],
    "Melrose": ["12121"],
    "Melville": ["11747", "11760", "11773", "11775"],
    "Memphis": ["13112"],
    "Mendon": ["14506"],
    "Meridale": ["13806"],
    "Meridian": ["13113"],
    "Merrick": ["11566"],
    "Mexico": ["13114"],
    "Middle Falls": ["12848"],
    "Middle Granville": ["12849"],
    "Middle Grove": ["12850"],
    "Middle Island": ["11953"],
    "Middle Village": ["11379"],
    "Middleburgh": ["12122"],
    "Middleport": ["14105"],
    "Middlesex": ["14507"],
    "Middletown": ["10940", "10941", "10943"],
    "Middleville": ["13406"],
    "Milford": ["13807"],
    "Mill Neck": ["11765"],
    "Millbrook": ["12545"],
    "Miller Place": ["11764"],
    "Millerton": ["12546"],
    "Millport": ["14864"],
    "Millwood": ["10546"],
    "Milton": ["12547"],
    "Mineola": ["11501"],
    "Minerva": ["12851"],
    "Minetto": ["13115"],
    "Mineville": ["12956"],
    "Minoa": ["13116"],
    "Model City": ["14107"],
    "Modena": ["12548"],
    "Mohawk": ["13407"],
    "Mohegan Lake": ["10547"],
    "Moira": ["12957"],
    "Mongaup Valley": ["12762"],
    "Monroe": ["10949", "10950"],
    "Monsey": ["10952"],
    "Montauk": ["11954"],
    "Montezuma": ["13117"],
    "Montgomery": ["12549"],
    "Monticello": ["12701"],
    "Montour Falls": ["14865"],
    "Montrose": ["10548"],
    "Mooers": ["12958"],
    "Mooers Forks": ["12959"],
    "Moravia": ["13118"],
    "Moriah": ["12960"],
    "Moriah Center": ["12961"],
    "Moriches": ["11955"],
    "Morris": ["13808"],
    "Morrisonville": ["12962"],
    "Morristown": ["13664"],
    "Morrisville": ["13408"],
    "Morton": ["14508"],
    "Mottville": ["13119"],
    "Mount Kisco": ["10549"],
    "Mount Marion": ["12456"],
    "Mount Morris": ["14510"],
    "Mount Sinai": ["11766"],
    "Mount Tremper": ["12457"],
    "Mount Upton": ["13809"],
    "Mount Vernon": ["10550", "10551", "10552", "10553", "10557", "10558"],
    "Mount Vision": ["13810"],
    "Mountain Dale": ["12763"],
    "Mountainville": ["10953"],
    "Mumford": ["14511"],
    "Munnsville": ["13409"],
    "Nanuet": ["10954"],
    "Napanoch": ["12458"],
    "Naples": ["14512"],
    "Narrowsburg": ["12764"],
    "Nassau": ["12123"],
    "Natural Bridge": ["13665"],
    "Nedrow": ["13120"],
    "Nelliston": ["13410"],
    "Nesconset": ["11767"],
    "Neversink": ["12765"],
    "New Baltimore": ["12124"],
    "New Berlin": ["13411"],
    "New City": ["10956"],
    "New Hampton": ["10958"],
    "New Hartford": ["13413"],
    "New Haven": ["13121"],
    "New Hyde Park": ["11040", "11041", "11042", "11043", "11044", "11099"],
    "New Kingston": ["12459"],
    "New Lebanon": ["12125"],
    "New Lisbon": ["13415"],
    "New Milford": ["10959"],
    "New Paltz": ["12561"],
    "New Rochelle": ["10801", "10802", "10804", "10805"],
    "New Russia": ["12964"],
    "New Suffolk": ["11956"],
    "New Windsor": ["12553"],
    "New Woodstock": ["13122"],
    "New York": ["10001", "10002", "10003", "10004", "10005", "10006", "10007", "10008", "10009", "10010", "10011", "10012", "10013", "10014", "10015", "10016", "10017", "10018", "10019", "10020", "10021", "10022", "10023", "10024", "10025", "10026", "10027", "10028", "10029", "10030", "10031", "10032", "10033", "10034", "10035", "10036", "10037", "10038", "10039", "10040", "10041", "10043", "10044", "10045", "10046", "10047", "10048", "10055", "10060", "10065", "10069", "10072", "10075", "10079", "10080", "10081", "10082", "10087", "10090", "10094", "10095", "10096", "10098", "10099", "10101", "10102", "10103", "10104", "10105", "10106", "10107", "10108", "10109", "10110", "10111", "10112", "10113", "10114", "10115", "10116", "10117", "10118", "10119", "10120", "10121", "10122", "10123", "10124", "10125", "10126", "10128", "10129", "10130", "10131", "10132", "10133", "10138", "10149", "10150", "10151", "10152", "10153", "10154", "10155", "10156", "10157", "10158", "10159", "10160", "10161", "10162", "10163", "10164", "10165", "10166", "10167", "10168", "10169", "10170", "10171", "10172", "10173", "10174", "10175", "10176", "10177", "10178", "10179", "10184", "10185", "10196", "10197", "10199", "10200", "10203", "10211", "10212", "10213", "10242", "10249", "10256", "10257", "10258", "10259", "10260", "10261", "10265", "10268", "10269", "10270", "10271", "10272", "10273", "10274", "10275", "10276", "10277", "10278", "10279", "10280", "10281", "10282", "10285", "10286", "10292"],
    "New York Mills": ["13417"],
    "Newark": ["14513"],
    "Newark Valley": ["13811"],
    "Newburgh": ["12550", "12551", "12552", "12555"],
    "Newcomb": ["12852", "12879"],
    "Newfane": ["14108"],
    "Newfield": ["14867"],
    "Newport": ["13416"],
    "Newton Falls": ["13666"],
    "Newtonville": ["12128"],
    "Niagara Falls": ["14301", "14302", "14303", "14304", "14305"],
    "Niagara University": ["14109"],
    "Nichols": ["13812"],
    "Nicholville": ["12965"],
    "Nineveh": ["13813"],
    "Niobe": ["14758"],
    "Niverville": ["12130"],
    "Norfolk": ["13667"],
    "North Babylon": ["11703"],
    "North Bangor": ["12966"],
    "North Bay": ["13123"],
    "North Blenheim": ["12131"],
    "North Boston": ["14110"],
    "North Branch": ["12766"],
    "North Brookfield": ["13418"],
    "North Chatham": ["12132"],
    "North Chili": ["14514"],
    "North Collins": ["14111"],
    "North Creek": ["12853"],
    "North Evans": ["14112"],
    "North Granville": ["12854"],
    "North Greece": ["14515"],
    "North Hoosick": ["12133"],
    "North Hudson": ["12855"],
    "North Java": ["14113"],
    "North Lawrence": ["12967"],
    "North Norwich": ["13814"],
    "North Pitcher": ["13124"],
    "North River": ["12856"],
    "North Rose": ["14516"],
    "North Salem": ["10560"],
    "North Tonawanda": ["14120"],
    "Northport": ["11768"],
    "Northville": ["12134"],
    "Norwich": ["13815"],
    "Norwood": ["13668"],
    "Nunda": ["14517"],
    "Nyack": ["10960"],
    "Oak Hill": ["12460"],
    "Oakdale": ["11769"],
    "Oakfield": ["14125"],
    "Oakland Gardens": ["11364"],
    "Oaks Corners": ["14518"],
    "Obernburg": ["12767"],
    "Ocean Beach": ["11770"],
    "Oceanside": ["11572"],
    "Odessa": ["14869"],
    "Ogdensburg": ["13669"],
    "Olcott": ["14126"],
    "Old Bethpage": ["11804"],
    "Old Chatham": ["12136"],
    "Old Forge": ["13420"],
    "Old Westbury": ["11568"],
    "Olean": ["14760"],
    "Olivebridge": ["12461"],
    "Olmstedville": ["12857"],
    "Oneida": ["13421"],
    "Oneonta": ["13820"],
    "Ontario": ["14519"],
    "Ontario Center": ["14520"],
    "Orangeburg": ["10962"],
    "Orchard Park": ["14127"],
    "Orient": ["11957"],
    "Oriskany": ["13424"],
    "Oriskany Falls": ["13425"],
    "Orwell": ["13426"],
    "Ossining": ["10562"],
    "Oswegatchie": ["13670"],
    "Oswego": ["13126"],
    "Otego": ["13825"],
    "Otisville": ["10963"],
    "Otto": ["14766"],
    "Ouaquaga": ["13826"],
    "Ovid": ["14521"],
    "Owego": ["13827"],
    "Owls Head": ["12969"],
    "Oxford": ["13830"],
    "Oyster Bay": ["11771"],
    "Ozone Park": ["11416", "11417"],
    "Painted Post": ["14870"],
    "Palatine Bridge": ["13428"],
    "Palenville": ["12463"],
    "Palisades": ["10964"],
    "Palmyra": ["14522"],
    "Panama": ["14767"],
    "Paradox": ["12858"],
    "Parish": ["13131"],
    "Parishville": ["13672"],
    "Parksville": ["12768"],
    "Patchogue": ["11772"],
    "Patterson": ["12563"],
    "Pattersonville": ["12137"],
    "Paul Smiths": ["12970"],
    "Pavilion": ["14525"],
    "Pawling": ["12564"],
    "Pearl River": ["10965"],
    "Peconic": ["11958"],
    "Peekskill": ["10566"],
    "Pelham": ["10803"],
    "Penfield": ["14526"],
    "Penn Yan": ["14527"],
    "Pennellville": ["13132"],
    "Perkinsville": ["14529"],
    "Perry": ["14530"],
    "Perrysburg": ["14129"],
    "Peru": ["12972"],
    "Peterboro": ["13134"],
    "Petersburg": ["12138"],
    "Phelps": ["14532"],
    "Philadelphia": ["13673"],
    "Phillipsport": ["12769"],
    "Philmont": ["12565"],
    "Phoenicia": ["12464"],
    "Phoenix": ["13135"],
    "Piercefield": ["12973"],
    "Piermont": ["10968"],
    "Pierrepont Manor": ["13674"],
    "Piffard": ["14533"],
    "Pike": ["14130"],
    "Pine Bush": ["12566"],
    "Pine City": ["14871"],
    "Pine Hill": ["12465"],
    "Pine Island": ["10969"],
    "Pine Plains": ["12567"],
    "Pine Valley": ["14872"],
    "Piseco": ["12139"],
    "Pitcher": ["13136"],
    "Pittsford": ["14534"],
    "Plainview": ["11803"],
    "Plainville": ["13137"],
    "Plattekill": ["12568"],
    "Plattsburgh": ["12901", "12903"],
    "Pleasant Valley": ["12569"],
    "Pleasantville": ["10570", "10571", "10572"],
    "Plessis": ["13675"],
    "Plymouth": ["13832"],
    "Poestenkill": ["12140"],
    "Point Lookout": ["11569"],
    "Poland": ["13431"],
    "Pomona": ["10970"],
    "Pompey": ["13138"],
    "Pond Eddy": ["12770"],
    "Poplar Ridge": ["13139"],
    "Port Byron": ["13140"],
    "Port Chester": ["10573"],
    "Port Crane": ["13833"],
    "Port Ewen": ["12466"],
    "Port Gibson": ["14537"],
    "Port Henry": ["12974"],
    "Port Jefferson": ["11777"],
    "Port Jefferson Station": ["11776"],
    "Port Jervis": ["12771"],
    "Port Kent": ["12975"],
    "Port Leyden": ["13433"],
    "Port Washington": ["11050", "11051", "11052", "11053", "11054", "11055"],
    "Portageville": ["14536"],
    "Porter Corners": ["12859"],
    "Portland": ["14769"],
    "Portlandville": ["13834"],
    "Portville": ["14770"],
    "Potsdam": ["13676", "13699"],
    "Pottersville": ["12860"],
    "Poughkeepsie": ["12601", "12602", "12603", "12604"],
    "Poughquag": ["12570"],
    "Pound Ridge": ["10576"],
    "Prattsburgh": ["14873"],
    "Prattsville": ["12468"],
    "Preble": ["13141"],
    "Preston Hollow": ["12469"],
    "Prospect": ["13435"],
    "Pulaski": ["13142"],
    "Pulteney": ["14874"],
    "Pultneyville": ["14538"],
    "Purchase": ["10577"],
    "Purdys": ["10578"],
    "Purling": ["12470"],
    "Putnam Station": ["12861"],
    "Putnam Valley": ["10579"],
    "Pyrites": ["13677"],
    "Quaker Street": ["12141"],
    "Queens Village": ["11427", "11428", "11429"],
    "Queensbury": ["12804"],
    "Quogue": ["11959"],
    "Rainbow Lake": ["12976"],
    "Randolph": ["14772"],
    "Ransomville": ["14131"],
    "Raquette Lake": ["13436"],
    "Ravena": ["12143"],
    "Ray Brook": ["12977"],
    "Raymondville": ["13678"],
    "Reading Center": ["14876"],
    "Red Creek": ["13143"],
    "Red Hook": ["12571"],
    "Redfield": ["13437"],
    "Redford": ["12978"],
    "Redwood": ["13679"],
    "Rego Park": ["11374"],
    "Remsen": ["13438"],
    "Remsenburg": ["11960"],
    "Rensselaer": ["12144"],
    "Rensselaer Falls": ["13680"],
    "Rensselaerville": ["12147"],
    "Retsof": ["14539"],
    "Rexford": ["12148"],
    "Rexville": ["14877"],
    "Rhinebeck": ["12572"],
    "Rhinecliff": ["12574"],
    "Richburg": ["14774"],
    "Richfield Springs": ["13439"],
    "Richford": ["13835"],
    "Richland": ["13144"],
    "Richmond Hill": ["11418"],
    "Richmondville": ["12149"],
    "Richville": ["13681"],
    "Ridge": ["11961"],
    "Ridgewood": ["11385", "11386"],
    "Rifton": ["12471"],
    "Riparius": ["12862"],
    "Ripley": ["14775"],
    "Riverhead": ["11901"],
    "Rochester": ["14602", "14603", "14604", "14605", "14606", "14607", "14608", "14609", "14610", "14611", "14612", "14613", "14614", "14615", "14616", "14617", "14618", "14619", "14620", "14621", "14622", "14623", "14624", "14625", "14626", "14627", "14638", "14639", "14642", "14643", "14644", "14645", "14646", "14647", "14649", "14650", "14651", "14652", "14653", "14664", "14673", "14683", "14692", "14694"],
    "Rock City Falls": ["12863"],
    "Rock Hill": ["12775"],
    "Rock Stream": ["14878"],
    "Rock Tavern": ["12575"],
    "Rockaway Park": ["11694"],
    "Rockville Center": ["11592"],
    "Rockville Centre": ["11570", "11571"],
    "Rocky Point": ["11778"],
    "Rodman": ["13682"],
    "Rome": ["13440", "13441", "13442", "13449"],
    "Romulus": ["14541"],
    "Ronkonkoma": ["11779"],
    "Roosevelt": ["11575"],
    "Rooseveltown": ["13683"],
    "Roscoe": ["12776"],
    "Rose": ["14542"],
    "Roseboom": ["13450"],
    "Rosedale": ["11422"],
    "Rosendale": ["12472"],
    "Roslyn": ["11576"],
    "Roslyn Heights": ["11577"],
    "Rotterdam Junction": ["12150"],
    "Round Lake": ["12151"],
    "Round Top": ["12473"],
    "Rouses Point": ["12979"],
    "Roxbury": ["12474"],
    "Ruby": ["12475"],
    "Rush": ["14543"],
    "Rushford": ["14777"],
    "Rushville": ["14544"],
    "Russell": ["13684"],
    "Rye": ["10580"],
    "Sabael": ["12864"],
    "Sackets Harbor": ["13685"],
    "Sag Harbor": ["11963"],
    "Sagaponack": ["11962"],
    "Saint Albans": ["11412"],
    "Saint Bonaventure": ["14778"],
    "Saint James": ["11780"],
    "Saint Johnsville": ["13452"],
    "Saint Regis Falls": ["12980"],
    "Salamanca": ["14779"],
    "Salem": ["12865"],
    "Salisbury Center": ["13454"],
    "Salisbury Mills": ["12577"],
    "Salt Point": ["12578"],
    "Sanborn": ["14132"],
    "Sand Lake": ["12153"],
    "Sandusky": ["14133"],
    "Sandy Creek": ["13145"],
    "Sangerfield": ["13455"],
    "Saranac": ["12981"],
    "Saranac Lake": ["12983"],
    "Saratoga Springs": ["12866"],
    "Sardinia": ["14134"],
    "Saugerties": ["12477"],
    "Sauquoit": ["13456"],
    "Savannah": ["13146"],
    "Savona": ["14879"],
    "Sayville": ["11782"],
    "Scarsdale": ["10583"],
    "Schaghticoke": ["12154"],
    "Schenectady": ["12301", "12302", "12303", "12304", "12305", "12306", "12307", "12308", "12309", "12325", "12345"],
    "Schenevus": ["12155"],
    "Schodack Landing": ["12156"],
    "Schoharie": ["12157"],
    "Schroon Lake": ["12870"],
    "Schuyler Falls": ["12985"],
    "Schuyler Lake": ["13457"],
    "Schuylerville": ["12871"],
    "Scio": ["14880"],
    "Scipio Center": ["13147"],
    "Scottsburg": ["14545"],
    "Scottsville": ["14546"],
    "Sea Cliff": ["11579"],
    "Seaford": ["11783"],
    "Selden": ["11784"],
    "Selkirk": ["12158"],
    "Seneca Castle": ["14547"],
    "Seneca Falls": ["13148"],
    "Severance": ["12872"],
    "Shandaken": ["12480"],
    "Sharon Springs": ["13459"],
    "Shelter Island": ["11964"],
    "Shelter Island Heights": ["11965"],
    "Shenorock": ["10587"],
    "Sherburne": ["13460"],
    "Sheridan": ["14135"],
    "Sherman": ["14781"],
    "Sherrill": ["13461"],
    "Shinhopple": ["13837"],
    "Shirley": ["11967"],
    "Shokan": ["12481"],
    "Shoreham": ["11786"],
    "Shortsville": ["14548"],
    "Shrub Oak": ["10588"],
    "Shushan": ["12873"],
    "Sidney": ["13838"],
    "Sidney Center": ["13839"],
    "Silver Bay": ["12874"],
    "Silver Creek": ["14136"],
    "Silver Lake": ["14549"],
    "Silver Springs": ["14550"],
    "Sinclairville": ["14782"],
    "Skaneateles": ["13152"],
    "Skaneateles Falls": ["13153"],
    "Slate Hill": ["10973"],
    "Slaterville Springs": ["14881"],
    "Slingerlands": ["12159"],
    "Sloansville": ["12160"],
    "Sloatsburg": ["10974"],
    "Smallwood": ["12778"],
    "Smithboro": ["13840"],
    "Smithtown": ["11787"],
    "Smithville Flats": ["13841"],
    "Smyrna": ["13464"],
    "Sodus": ["14551"],
    "Sodus Point": ["14555"],
    "Solsville": ["13465"],
    "Somers": ["10589"],
    "Sonyea": ["14556"],
    "Sound Beach": ["11789"],
    "South Bethlehem": ["12161"],
    "South Butler": ["13154"],
    "South Byron": ["14557"],
    "South Cairo": ["12482"],
    "South Colton": ["13687"],
    "South Dayton": ["14138"],
    "South Fallsburg": ["12779"],
    "South Glens Falls": ["12803"],
    "South Jamesport": ["11970"],
    "South Kortright": ["13842"],
    "South Lima": ["14558"],
    "South New Berlin": ["13843"],
    "South Otselic": ["13155"],
    "South Ozone Park": ["11420"],
    "South Plymouth": ["13844"],
    "South Richmond Hill": ["11419"],
    "South Salem": ["10590"],
    "South Wales": ["14139"],
    "Southampton": ["11968", "11969"],
    "Southfields": ["10975"],
    "Southold": ["11971"],
    "Sparkill": ["10976"],
    "Sparrow Bush": ["12780"],
    "Speculator": ["12164"],
    "Spencer": ["14883"],
    "Spencerport": ["14559"],
    "Spencertown": ["12165"],
    "Speonk": ["11972"],
    "Sprakers": ["12166"],
    "Spring Brook": ["14140"],
    "Spring Glen": ["12483"],
    "Spring Valley": ["10977"],
    "Springfield Center": ["13468"],
    "Springfield Gardens": ["11413"],
    "Springville": ["14141"],
    "Springwater": ["14560"],
    "Staatsburg": ["12580"],
    "Stafford": ["14143"],
    "Stamford": ["12167"],
    "Stanfordville": ["12581"],
    "Stanley": ["14561"],
    "Star Lake": ["13690"],
    "Staten Island": ["10301", "10302", "10303", "10304", "10305", "10306", "10307", "10308", "10309", "10310", "10311", "10312", "10313", "10314"],
    "Steamburg": ["14783"],
    "Stella Niagara": ["14144"],
    "Stephentown": ["12168", "12169"],
    "Sterling": ["13156"],
    "Sterling Forest": ["10979"],
    "Stillwater": ["12170"],
    "Stittville": ["13469"],
    "Stockton": ["14784"],
    "Stone Ridge": ["12484"],
    "Stony Brook": ["11790", "11794"],
    "Stony Creek": ["12878"],
    "Stony Point": ["10980"],
    "Stormville": ["12582"],
    "Stottville": ["12172"],
    "Stow": ["14785"],
    "Stratford": ["13470"],
    "Strykersville": ["14145"],
    "Stuyvesant": ["12173"],
    "Stuyvesant Falls": ["12174"],
    "Suffern": ["10901"],
    "Sugar Loaf": ["10981"],
    "Summit": ["12175"],
    "Summitville": ["12781"],
    "Sunnyside": ["11104"],
    "Surprise": ["12176"],
    "Swain": ["14884"],
    "Swan Lake": ["12783"],
    "Sylvan Beach": ["13157"],
    "Syosset": ["11791"],
    "Syracuse": ["13201", "13202", "13203", "13204", "13205", "13206", "13207", "13208", "13209", "13210", "13211", "13212", "13214", "13215", "13217", "13218", "13219", "13220", "13221", "13224", "13225", "13235", "13244", "13250", "13251", "13252", "13261", "13290"],
    "Taberg": ["13471"],
    "Tallman": ["10982"],
    "Tannersville": ["12485"],
    "Tappan": ["10983"],
    "Tarrytown": ["10591"],
    "Thendara": ["13472"],
    "Theresa": ["13691"],
    "Thiells": ["10984"],
    "Thompson Ridge": ["10985"],
    "Thompsonville": ["12784"],
    "Thornwood": ["10594"],
    "Thousand Island Park": ["13692"],
    "Three Mile Bay": ["13693"],
    "Ticonderoga": ["12883"],
    "Tillson": ["12486"],
    "Tioga Center": ["13845"],
    "Tivoli": ["12583"],
    "Tomkins Cove": ["10986"],
    "Tonawanda": ["14150", "14151"],
    "Treadwell": ["13846"],
    "Tribes Hill": ["12177"],
    "Troupsburg": ["14885"],
    "Trout Creek": ["13847"],
    "Troy": ["12180", "12181", "12182", "12183"],
    "Trumansburg": ["14886"],
    "Truxton": ["13158"],
    "Tuckahoe": ["10707"],
    "Tully": ["13159"],
    "Tunnel": ["13848"],
    "Tupper Lake": ["12986"],
    "Turin": ["13473"],
    "Tuxedo Park": ["10987"],
    "Tyrone": ["14887"],
    "Ulster Park": ["12487"],
    "Unadilla": ["13849"],
    "Union Hill": ["14563"],
    "Union Springs": ["13160"],
    "Uniondale": ["11553", "11555", "11556"],
    "Unionville": ["10988"],
    "Upper Jay": ["12987"],
    "Upton": ["11973"],
    "Utica": ["13501", "13502", "13503", "13504", "13505", "13599"],
    "Vails Gate": ["12584"],
    "Valatie": ["12184"],
    "Valhalla": ["10595"],
    "Valley Cottage": ["10989"],
    "Valley Falls": ["12185"],
    "Valley Stream": ["11580", "11581", "11582"],
    "Van Buren Point": ["14166"],
    "Van Etten": ["14889"],
    "Van Hornesville": ["13475"],
    "Varysburg": ["14167"],
    "Verbank": ["12585"],
    "Vermontville": ["12989"],
    "Vernon": ["13476"],
    "Vernon Center": ["13477"],
    "Verona": ["13478"],
    "Verona Beach": ["13162"],
    "Verplanck": ["10596"],
    "Versailles": ["14168"],
    "Vestal": ["13850", "13851"],
    "Victor": ["14564"],
    "Victory Mills": ["12884"],
    "Voorheesville": ["12186"],
    "Waccabuc": ["10597"],
    "Waddington": ["13694"],
    "Wading River": ["11792"],
    "Wainscott": ["11975"],
    "Walden": ["12586"],
    "Wales Center": ["14169"],
    "Walker Valley": ["12588"],
    "Wallkill": ["12589"],
    "Walton": ["13856"],
    "Walworth": ["14568"],
    "Wampsville": ["13163"],
    "Wanakena": ["13695"],
    "Wantagh": ["11793"],
    "Wappingers Falls": ["12590"],
    "Warners": ["13164"],
    "Warnerville": ["12187"],
    "Warrensburg": ["12885"],
    "Warsaw": ["14569"],
    "Warwick": ["10990"],
    "Washington Mills": ["13479"],
    "Washingtonville": ["10992"],
    "Wassaic": ["12592"],
    "Water Mill": ["11976"],
    "Waterford": ["12188"],
    "Waterloo": ["13165"],
    "Waterport": ["14571"],
    "Watertown": ["13601", "13603"],
    "Waterville": ["13480"],
    "Watervliet": ["12189"],
    "Watkins Glen": ["14891"],
    "Waverly": ["14892"],
    "Wawarsing": ["12489"],
    "Wayland": ["14572"],
    "Wayne": ["14893"],
    "Webster": ["14580"],
    "Weedsport": ["13166"],
    "Wellesley Island": ["13640"],
    "Wells": ["12190"],
    "Wells Bridge": ["13859"],
    "Wellsburg": ["14894"],
    "Wellsville": ["14895"],
    "West Babylon": ["11704", "11707"],
    "West Bloomfield": ["14585"],
    "West Burlington": ["13482"],
    "West Camp": ["12490"],
    "West Chazy": ["12992"],
    "West Clarksville": ["14786"],
    "West Copake": ["12593"],
    "West Coxsackie": ["12192"],
    "West Davenport": ["13860"],
    "West Eaton": ["13484"],
    "West Edmeston": ["13485"],
    "West Falls": ["14170"],
    "West Fulton": ["12194"],
    "West Harrison": ["10604"],
    "West Haverstraw": ["10993"],
    "West Hempstead": ["11552"],
    "West Henrietta": ["14586"],
    "West Hurley": ["12491"],
    "West Islip": ["11795"],
    "West Kill": ["12492"],
    "West Lebanon": ["12195"],
    "West Leyden": ["13489"],
    "West Monroe": ["13167"],
    "West Nyack": ["10994"],
    "West Oneonta": ["13861"],
    "West Park": ["12493"],
    "West Point": ["10996", "10997"],
    "West Sand Lake": ["12196"],
    "West Sayville": ["11796"],
    "West Shokan": ["12494"],
    "West Stockholm": ["13696"],
    "West Valley": ["14171"],
    "West Winfield": ["13491"],
    "Westbrookville": ["12785"],
    "Westbury": ["11590", "11594", "11595", "11597"],
    "Westdale": ["13483"],
    "Westerlo": ["12193"],
    "Westernville": ["13486"],
    "Westfield": ["14787"],
    "Westford": ["13488"],
    "Westhampton": ["11977"],
    "Westhampton Beach": ["11978"],
    "Westmoreland": ["13490"],
    "Westons Mills": ["14788"],
    "Westport": ["12993"],
    "Westtown": ["10998"],
    "Wevertown": ["12886"],
    "Whippleville": ["12995"],
    "White Lake": ["12786"],
    "White Plains": ["10601", "10602", "10603", "10605", "10606", "10607", "10610"],
    "White Sulphur Springs": ["12787"],
    "Whitehall": ["12887"],
    "Whitesboro": ["13492"],
    "Whitestone": ["11357"],
    "Whitesville": ["14897"],
    "Whitney Point": ["13862"],
    "Willard": ["14588"],
    "Willet": ["13863"],
    "Williamson": ["14589"],
    "Williamstown": ["13493"],
    "Williston Park": ["11596"],
    "Willow": ["12495"],
    "Willsboro": ["12996"],
    "Willseyville": ["13864"],
    "Wilmington": ["12997"],
    "Wilson": ["14172"],
    "Windham": ["12496"],
    "Windsor": ["13865"],
    "Wingdale": ["12594"],
    "Winthrop": ["13697"],
    "Witherbee": ["12998"],
    "Wolcott": ["14590"],
    "Woodbourne": ["12788"],
    "Woodbury": ["11797"],
    "Woodgate": ["13494"],
    "Woodhaven": ["11421"],
    "Woodhull": ["14898"],
    "Woodmere": ["11598"],
    "Woodridge": ["12789"],
    "Woodside": ["11377"],
    "Woodstock": ["12498"],
    "Worcester": ["12197"],
    "Wurtsboro": ["12790"],
    "Wyandanch": ["11798"],
    "Wynantskill": ["12198"],
    "Wyoming": ["14591"],
    "Yaphank": ["11980"],
    "Yonkers": ["10701", "10702", "10703", "10704", "10705", "10710"],
    "York": ["14592"],
    "Yorkshire": ["14173"],
    "Yorktown Heights": ["10598"],
    "Yorkville": ["13495"],
    "Youngstown": ["14174"],
    "Youngsville": ["12791"],
    "Yulan": ["12792"]
  },
  "OH": {
    "Aberdeen": ["45101"],
    "Ada": ["45810"],
    "Adamsville": ["43802"],
    "Addyston": ["45001"],
    "Adelphi": ["43101"],
    "Adena": ["43901"],
    "Akron": ["44301", "44302", "44303", "44304", "44305", "44306", "44307", "44308", "44309", "44310", "44311", "44312", "44313", "44314", "44315", "44316", "44317", "44319", "44320", "44321", "44322", "44325", "44326", "44328", "44333", "44372", "44393", "44396", "44398", "44399"],
    "Albany": ["45710"],
    "Alexandria": ["43001"],
    "Alger": ["45812"],
    "Alledonia": ["43902"],
    "Alliance": ["44601"],
    "Alpha": ["45301"],
    "Alvada": ["44802"],
    "Alvordton": ["43501"],
    "Amanda": ["43102"],
    "Amelia": ["45102"],
    "Amesville": ["45711"],
    "Amherst": ["44001"],
    "Amlin": ["43002"],
    "Amsterdam": ["43903"],
    "Andover": ["44003"],
    "Anna": ["45302"],
    "Ansonia": ["45303"],
    "Antwerp": ["45813"],
    "Apple Creek": ["44606"],
    "Arcadia": ["44804"],
    "Arcanum": ["45304"],
    "Archbold": ["43502"],
    "Arlington": ["45814"],
    "Ashland": ["44805"],
    "Ashley": ["43003"],
    "Ashtabula": ["44004", "44005"],
    "Ashville": ["43103"],
    "Athens": ["45701"],
    "Attica": ["44807"],
    "Atwater": ["44201"],
    "Augusta": ["44607"],
    "Aurora": ["44202"],
    "Austinburg": ["44010"],
    "Ava": ["43711"],
    "Avon": ["44011"],
    "Avon Lake": ["44012"],
    "Bainbridge": ["45612"],
    "Bakersville": ["43803"],
    "Baltic": ["43804"],
    "Baltimore": ["43105"],
    "Bannock": ["43972"],
    "Barberton": ["44203"],
    "Barlow": ["45712"],
    "Barnesville": ["43713"],
    "Bartlett": ["45713"],
    "Barton": ["43905"],
    "Bascom": ["44809"],
    "Batavia": ["45103"],
    "Bath": ["44210"],
    "Bay Village": ["44140"],
    "Beach City": ["44608"],
    "Beachwood": ["44122"],
    "Beallsville": ["43716"],
    "Beaver": ["45613"],
    "Beaverdam": ["45808"],
    "Bedford": ["44146"],
    "Bellaire": ["43906"],
    "Bellbrook": ["45305"],
    "Belle Center": ["43310"],
    "Belle Valley": ["43717"],
    "Bellefontaine": ["43311"],
    "Bellevue": ["44811"],
    "Bellville": ["44813"],
    "Belmont": ["43718"],
    "Belmore": ["45815"],
    "Beloit": ["44609"],
    "Belpre": ["45714"],
    "Benton Ridge": ["45816"],
    "Bentonville": ["45105"],
    "Berea": ["44017"],
    "Bergholz": ["43908"],
    "Berkey": ["43504"],
    "Berlin": ["44610"],
    "Berlin Center": ["44401"],
    "Berlin Heights": ["44814"],
    "Bethel": ["45106"],
    "Bethesda": ["43719"],
    "Bettsville": ["44815"],
    "Beverly": ["45715"],
    "Bidwell": ["45614"],
    "Big Prairie": ["44611"],
    "Birmingham": ["44816"],
    "Blacklick": ["43004"],
    "Bladensburg": ["43005"],
    "Blaine": ["43909"],
    "Blakeslee": ["43505"],
    "Blanchester": ["45107"],
    "Blissfield": ["43805"],
    "Bloomdale": ["44817"],
    "Bloomingburg": ["43106"],
    "Bloomingdale": ["43910"],
    "Bloomville": ["44818"],
    "Blue Creek": ["45616"],
    "Blue Rock": ["43720"],
    "Bluffton": ["45817"],
    "Bolivar": ["44612"],
    "Botkins": ["45306"],
    "Bourneville": ["45617"],
    "Bowerston": ["44695"],
    "Bowersville": ["45307"],
    "Bowling Green": ["43402", "43403"],
    "Bradford": ["45308"],
    "Bradner": ["43406"],
    "Brady Lake": ["44211"],
    "Brecksville": ["44141"],
    "Bremen": ["43107"],
    "Brewster": ["44613"],
    "Brice": ["43109"],
    "Bridgeport": ["43912"],
    "Brilliant": ["43913"],
    "Brinkhaven": ["43006"],
    "Bristolville": ["44402"],
    "Broadview Heights": ["44147"],
    "Broadway": ["43007"],
    "Brookfield": ["44403"],
    "Brookpark": ["44142"],
    "Brookville": ["45309"],
    "Brownsville": ["43721"],
    "Brunswick": ["44212"],
    "Bryan": ["43506"],
    "Buchtel": ["45716"],
    "Buckeye Lake": ["43008"],
    "Buckland": ["45819"],
    "Bucyrus": ["44820"],
    "Buffalo": ["43722"],
    "Buford": ["45110"],
    "Burbank": ["44214"],
    "Burghill": ["44404"],
    "Burgoon": ["43407"],
    "Burkettsville": ["45310"],
    "Burton": ["44021"],
    "Butler": ["44822"],
    "Byesville": ["43723"],
    "Cable": ["43009"],
    "Cadiz": ["43907"],
    "Cairo": ["45820"],
    "Caldwell": ["43724"],
    "Caledonia": ["43314"],
    "Cambridge": ["43725"],
    "Camden": ["45311"],
    "Cameron": ["43914"],
    "Camp Dennison": ["45111"],
    "Campbell": ["44405"],
    "Canal Fulton": ["44614"],
    "Canal Winchester": ["43110"],
    "Canfield": ["44406"],
    "Canton": ["44701", "44702", "44703", "44704", "44705", "44706", "44707", "44708", "44709", "44710", "44711", "44714", "44718", "44721", "44735", "44750", "44767", "44799"],
    "Carbon Hill": ["43111"],
    "Carbondale": ["45717"],
    "Cardington": ["43315"],
    "Carey": ["43316"],
    "Carroll": ["43112"],
    "Carrollton": ["44615"],
    "Casstown": ["45312"],
    "Castalia": ["44824"],
    "Catawba": ["43010"],
    "Cecil": ["45821"],
    "Cedarville": ["45314"],
    "Celina": ["45822"],
    "Centerburg": ["43011"],
    "Chagrin Falls": ["44022", "44023"],
    "Chandlersville": ["43727"],
    "Chardon": ["44024"],
    "Charm": ["44617"],
    "Chatfield": ["44825"],
    "Chauncey": ["45719"],
    "Cherry Fork": ["45618"],
    "Chesapeake": ["45619"],
    "Cheshire": ["45620"],
    "Chester": ["45720"],
    "Chesterhill": ["43728"],
    "Chesterland": ["44026"],
    "Chesterville": ["43317"],
    "Chickasaw": ["45826"],
    "Chillicothe": ["45601"],
    "Chilo": ["45112"],
    "Chippewa Lake": ["44215"],
    "Christiansburg": ["45389"],
    "Cincinnati": ["45201", "45202", "45203", "45204", "45205", "45206", "45207", "45208", "45209", "45211", "45212", "45213", "45214", "45215", "45216", "45217", "45218", "45219", "45220", "45221", "45222", "45223", "45224", "45225", "45226", "45227", "45228", "45229", "45230", "45231", "45232", "45233", "45234", "45235", "45236", "45237", "45238", "45239", "45240", "45241", "45242", "45243", "45244", "45245", "45246", "45247", "45248", "45249", "45250", "45251", "45252", "45253", "45254", "45255", "45258", "45262", "45263", "45264", "45267", "45268", "45269", "45270", "45271", "45273", "45274", "45275", "45277", "45280", "45296", "45298", "45299", "45999"],
    "Circleville": ["43113"],
    "Clarington": ["43915"],
    "Clarksburg": ["43115"],
    "Clarksville": ["45113"],
    "Clay Center": ["43408"],
    "Clayton": ["45315"],
    "Cleveland": ["44101", "44102", "44103", "44104", "44105", "44106", "44108", "44109", "44110", "44111", "44112", "44113", "44114", "44115", "44118", "44119", "44120", "44121", "44124", "44125", "44126", "44127", "44128", "44129", "44130", "44134", "44135", "44143", "44144", "44178", "44181", "44185", "44188", "44189", "44190", "44191", "44192", "44193", "44194", "44195", "44197", "44198", "44199"],
    "Cleves": ["45002"],
    "Clifton": ["45316"],
    "Clinton": ["44216"],
    "Cloverdale": ["45827"],
    "Clyde": ["43410"],
    "Coal Run": ["45721"],
    "Coalton": ["45621"],
    "Coldwater": ["45828"],
    "Colerain": ["43916"],
    "College Corner": ["45003"],
    "Collins": ["44826"],
    "Collinsville": ["45004"],
    "Colton": ["43510"],
    "Columbia Station": ["44028"],
    "Columbiana": ["44408"],
    "Columbus": ["43085", "43201", "43202", "43203", "43204", "43205", "43206", "43207", "43209", "43210", "43211", "43212", "43213", "43214", "43215", "43216", "43217", "43218", "43219", "43220", "43221", "43222", "43223", "43224", "43226", "43227", "43228", "43229", "43230", "43231", "43232", "43234", "43235", "43236", "43240", "43251", "43260", "43265", "43266", "43268", "43270", "43271", "43272", "43279", "43287", "43291", "43299"],
    "Columbus Grove": ["45830"],
    "Commercial Point": ["43116"],
    "Conesville": ["43811"],
    "Conneaut": ["44030"],
    "Conover": ["45317"],
    "Continental": ["45831"],
    "Convoy": ["45832"],
    "Coolville": ["45723"],
    "Corning": ["43730"],
    "Cortland": ["44410"],
    "Coshocton": ["43812"],
    "Covington": ["45318"],
    "Creola": ["45622"],
    "Crestline": ["44827"],
    "Creston": ["44217"],
    "Crooksville": ["43731"],
    "Croton": ["43013"],
    "Crown City": ["45623"],
    "Cuba": ["45114"],
    "Cumberland": ["43732"],
    "Curtice": ["43412"],
    "Custar": ["43511"],
    "Cutler": ["45724"],
    "Cuyahoga Falls": ["44221", "44222", "44223"],
    "Cygnet": ["43413"],
    "Cynthiana": ["45624"],
    "Dalton": ["44618"],
    "Damascus": ["44619"],
    "Danville": ["43014"],
    "Dayton": ["45400", "45401", "45402", "45403", "45404", "45405", "45406", "45408", "45409", "45410", "45412", "45413", "45414", "45415", "45416", "45417", "45418", "45419", "45420", "45422", "45423", "45424", "45426", "45427", "45428", "45429", "45430", "45431", "45432", "45433", "45434", "45435", "45437", "45439", "45440", "45441", "45448", "45449", "45454", "45458", "45459", "45463", "45469", "45470", "45475", "45479", "45481", "45482", "45490"],
    "De Graff": ["43318"],
    "Decatur": ["45115"],
    "Deerfield": ["44411"],
    "Deersville": ["44693"],
    "Defiance": ["43512"],
    "Delaware": ["43015"],
    "Dellroy": ["44620"],
    "Delphos": ["45833"],
    "Delta": ["43515"],
    "Dennison": ["44621"],
    "Derby": ["43117"],
    "Derwent": ["43733"],
    "Deshler": ["43516"],
    "Dexter City": ["45727"],
    "Diamond": ["44412"],
    "Dillonvale": ["43917"],
    "Dola": ["45835"],
    "Donnelsville": ["45319"],
    "Dorset": ["44032"],
    "Dover": ["44622"],
    "Doylestown": ["44230"],
    "Dresden": ["43821"],
    "Dublin": ["43016", "43017"],
    "Dunbridge": ["43414"],
    "Duncan Falls": ["43734"],
    "Dundee": ["44624"],
    "Dunkirk": ["45836"],
    "Dupont": ["45837"],
    "East Canton": ["44730"],
    "East Claridon": ["44033"],
    "East Fultonham": ["43735"],
    "East Liberty": ["43319"],
    "East Liverpool": ["43920"],
    "East Palestine": ["44413"],
    "East Rochester": ["44625"],
    "East Sparta": ["44626"],
    "East Springfield": ["43925"],
    "Eastlake": ["44095", "44097"],
    "Eaton": ["45320"],
    "Edgerton": ["43517"],
    "Edison": ["43320"],
    "Edon": ["43518"],
    "Eldorado": ["45321"],
    "Elgin": ["45838"],
    "Elkton": ["44415"],
    "Ellsworth": ["44416"],
    "Elmore": ["43416"],
    "Elyria": ["44035", "44036"],
    "Empire": ["43926"],
    "Englewood": ["45322"],
    "Enon": ["45323"],
    "Etna": ["43018"],
    "Euclid": ["44117", "44123", "44132"],
    "Evansport": ["43519"],
    "Fairborn": ["45324"],
    "Fairfield": ["45014", "45018"],
    "Fairlawn": ["44334"],
    "Fairpoint": ["43927"],
    "Fairview": ["43736"],
    "Farmdale": ["44417"],
    "Farmer": ["43520"],
    "Farmersville": ["45325"],
    "Fayette": ["43521"],
    "Fayetteville": ["45118"],
    "Feesburg": ["45119"],
    "Felicity": ["45120"],
    "Findlay": ["45839", "45840"],
    "Flat Rock": ["44828"],
    "Fleming": ["45729"],
    "Fletcher": ["45326"],
    "Flushing": ["43977"],
    "Forest": ["45843"],
    "Fort Jennings": ["45844"],
    "Fort Loramie": ["45845"],
    "Fort Recovery": ["45846"],
    "Fostoria": ["44830"],
    "Fowler": ["44418"],
    "Frankfort": ["45628"],
    "Franklin": ["45005"],
    "Franklin Furnace": ["45629"],
    "Frazeysburg": ["43822"],
    "Fredericksburg": ["44627"],
    "Fredericktown": ["43019"],
    "Freeport": ["43973"],
    "Fremont": ["43420"],
    "Fresno": ["43824"],
    "Friendship": ["45630"],
    "Fulton": ["43321"],
    "Fultonham": ["43738"],
    "Galena": ["43021"],
    "Galion": ["44833"],
    "Gallipolis": ["45631"],
    "Galloway": ["43119"],
    "Gambier": ["43022"],
    "Garrettsville": ["44231"],
    "Gates Mills": ["44040"],
    "Geneva": ["44041"],
    "Genoa": ["43430"],
    "Georgetown": ["45121"],
    "Germantown": ["45327"],
    "Gettysburg": ["45328"],
    "Gibsonburg": ["43431"],
    "Girard": ["44420"],
    "Glandorf": ["45848"],
    "Glencoe": ["43928"],
    "Glenford": ["43739"],
    "Glenmont": ["44628"],
    "Glouster": ["45732"],
    "Gnadenhutten": ["44629"],
    "Gomer": ["45809"],
    "Goshen": ["45122"],
    "Grafton": ["44044"],
    "Grand Rapids": ["43522"],
    "Grand River": ["44045"],
    "Granville": ["43023"],
    "Gratiot": ["43740"],
    "Gratis": ["45330"],
    "Graysville": ["45734"],
    "Graytown": ["43432"],
    "Green": ["44232"],
    "Green Camp": ["43322"],
    "Green Springs": ["44836"],
    "Greenfield": ["45123"],
    "Greenford": ["44422"],
    "Greentown": ["44630"],
    "Greenville": ["45331"],
    "Greenwich": ["44837"],
    "Grelton": ["43523"],
    "Grove City": ["43123"],
    "Groveport": ["43125", "43195", "43196", "43198", "43199"],
    "Grover Hill": ["45849"],
    "Guysville": ["45735"],
    "Gypsum": ["43433"],
    "Hallsville": ["45633"],
    "Hamden": ["45634"],
    "Hamersville": ["45130"],
    "Hamilton": ["45011", "45012", "45013", "45015", "45025", "45026"],
    "Hamler": ["43524"],
    "Hammondsville": ["43930"],
    "Hannibal": ["43931"],
    "Hanoverton": ["44423"],
    "Harbor View": ["43434"],
    "Harlem Springs": ["44631"],
    "Harpster": ["43323"],
    "Harrisburg": ["43126"],
    "Harrison": ["45030"],
    "Harrisville": ["43974"],
    "Harrod": ["45850"],
    "Hartford": ["44424"],
    "Hartville": ["44632"],
    "Harveysburg": ["45032"],
    "Haskins": ["43525"],
    "Haverhill": ["45636"],
    "Haviland": ["45851"],
    "Haydenville": ["43127"],
    "Hayesville": ["44838"],
    "Heath": ["43056"],
    "Hebron": ["43025", "43098"],
    "Helena": ["43435"],
    "Hicksville": ["43526"],
    "Higginsport": ["45131"],
    "Highland": ["45132"],
    "Hilliard": ["43026"],
    "Hillsboro": ["45133"],
    "Hinckley": ["44233"],
    "Hiram": ["44234"],
    "Hockingport": ["45739"],
    "Holgate": ["43527"],
    "Holland": ["43528"],
    "Hollansburg": ["45332"],
    "Holloway": ["43985"],
    "Holmesville": ["44633"],
    "Homer": ["43027"],
    "Homerville": ["44235"],
    "Homeworth": ["44634"],
    "Hooven": ["45033"],
    "Hopedale": ["43976"],
    "Hopewell": ["43746"],
    "Houston": ["45333"],
    "Howard": ["43028"],
    "Hoytville": ["43529"],
    "Hubbard": ["44425"],
    "Hudson": ["44236", "44237"],
    "Huntsburg": ["44046"],
    "Huntsville": ["43324"],
    "Huron": ["44839"],
    "Iberia": ["43325"],
    "Independence": ["44131"],
    "Irondale": ["43932"],
    "Ironton": ["45638"],
    "Irwin": ["43029"],
    "Isle Saint George": ["43436"],
    "Jackson": ["45640"],
    "Jackson Center": ["45334"],
    "Jacksontown": ["43030"],
    "Jacksonville": ["45740"],
    "Jacobsburg": ["43933"],
    "Jamestown": ["45335"],
    "Jasper": ["45642"],
    "Jefferson": ["44047"],
    "Jeffersonville": ["43128"],
    "Jenera": ["45841"],
    "Jeromesville": ["44840"],
    "Jerry City": ["43437"],
    "Jerusalem": ["43747"],
    "Jewell": ["43530"],
    "Jewett": ["43986"],
    "Johnstown": ["43031"],
    "Junction City": ["43748"],
    "Kalida": ["45853"],
    "Kansas": ["44841"],
    "Keene": ["43828"],
    "Kelleys Island": ["43438"],
    "Kensington": ["44427"],
    "Kent": ["44240", "44242", "44243"],
    "Kenton": ["43326"],
    "Kerr": ["45643"],
    "Kettlersville": ["45336"],
    "Kidron": ["44636"],
    "Kilbourne": ["43032"],
    "Killbuck": ["44637"],
    "Kimbolton": ["43749"],
    "Kings Mills": ["45034"],
    "Kingston": ["45644"],
    "Kingsville": ["44048"],
    "Kinsman": ["44428"],
    "Kipling": ["43750"],
    "Kipton": ["44049"],
    "Kirby": ["43330"],
    "Kirkersville": ["43033"],
    "Kitts Hill": ["45645"],
    "Kunkle": ["43531"],
    "La Rue": ["43332"],
    "Lacarne": ["43439"],
    "Lafayette": ["45854"],
    "Lafferty": ["43951"],
    "Lagrange": ["44050"],
    "Laings": ["43752"],
    "Lake Milton": ["44429"],
    "Lakemore": ["44250"],
    "Lakeside Marblehead": ["43440"],
    "Lakeview": ["43331"],
    "Lakeville": ["44638"],
    "Lakewood": ["44107"],
    "Lancaster": ["43130"],
    "Langsville": ["45741"],
    "Lansing": ["43934"],
    "Latham": ["45646"],
    "Latty": ["45855"],
    "Laura": ["45337"],
    "Laurelville": ["43135"],
    "Leavittsburg": ["44430"],
    "Lebanon": ["45036"],
    "Lees Creek": ["45138"],
    "Leesburg": ["45135"],
    "Leesville": ["44639"],
    "Leetonia": ["44431"],
    "Leipsic": ["45856"],
    "Lemoyne": ["43441"],
    "Lewis Center": ["43035"],
    "Lewisburg": ["45338"],
    "Lewistown": ["43333"],
    "Lewisville": ["43754"],
    "Liberty Center": ["43532"],
    "Lima": ["45801", "45802", "45804", "45805", "45806", "45807"],
    "Limaville": ["44640"],
    "Lindsey": ["43442"],
    "Lisbon": ["44432"],
    "Litchfield": ["44253"],
    "Lithopolis": ["43136"],
    "Little Hocking": ["45742"],
    "Lockbourne": ["43137", "43194"],
    "Lodi": ["44254"],
    "Logan": ["43138"],
    "London": ["43140"],
    "Londonderry": ["45647"],
    "Long Bottom": ["45743"],
    "Lorain": ["44052", "44053", "44055"],
    "Lore City": ["43755"],
    "Loudonville": ["44842"],
    "Louisville": ["44641"],
    "Loveland": ["45140"],
    "Lowell": ["45744"],
    "Lowellville": ["44436"],
    "Lower Salem": ["45745"],
    "Lucas": ["44843"],
    "Lucasville": ["45648", "45699"],
    "Luckey": ["43443"],
    "Ludlow Falls": ["45339"],
    "Lynchburg": ["45142"],
    "Lynx": ["45650"],
    "Lyons": ["43533"],
    "Macedonia": ["44056"],
    "Macksburg": ["45746"],
    "Madison": ["44057"],
    "Magnetic Springs": ["43036"],
    "Magnolia": ["44643"],
    "Maineville": ["45039"],
    "Malaga": ["43757"],
    "Malinta": ["43535"],
    "Malta": ["43758"],
    "Malvern": ["44644"],
    "Manchester": ["45144"],
    "Mansfield": ["44901", "44902", "44903", "44904", "44905", "44906", "44907", "44999"],
    "Mantua": ["44255"],
    "Maple Heights": ["44137"],
    "Maplewood": ["45340"],
    "Marathon": ["45145"],
    "Marengo": ["43334"],
    "Maria Stein": ["45860"],
    "Marietta": ["45750"],
    "Marion": ["43301", "43302", "43306", "43307"],
    "Mark Center": ["43536"],
    "Marshallville": ["44645"],
    "Martel": ["43335"],
    "Martin": ["43445"],
    "Martins Ferry": ["43935"],
    "Martinsburg": ["43037"],
    "Martinsville": ["45146"],
    "Marysville": ["43040", "43041"],
    "Mason": ["45040"],
    "Massillon": ["44646", "44647", "44648"],
    "Masury": ["44438"],
    "Maumee": ["43537"],
    "Maximo": ["44650"],
    "Maynard": ["43937"],
    "Mc Arthur": ["45651"],
    "Mc Clure": ["43534"],
    "Mc Comb": ["45858"],
    "Mc Cutchenville": ["44844"],
    "Mc Dermott": ["45652"],
    "Mc Donald": ["44437"],
    "Mc Guffey": ["45859"],
    "Mcconnelsville": ["43756"],
    "Mechanicsburg": ["43044"],
    "Mechanicstown": ["44651"],
    "Medina": ["44256", "44258"],
    "Medway": ["45341"],
    "Melmore": ["44845"],
    "Melrose": ["45861"],
    "Mendon": ["45862"],
    "Mentor": ["44060", "44061"],
    "Mesopotamia": ["44439"],
    "Metamora": ["43540"],
    "Miamisburg": ["45342", "45343"],
    "Miamitown": ["45041"],
    "Miamiville": ["45147"],
    "Middle Bass": ["43446"],
    "Middle Point": ["45863"],
    "Middlebranch": ["44652"],
    "Middleburg": ["43336"],
    "Middlefield": ["44062"],
    "Middleport": ["45760"],
    "Middletown": ["45042", "45043", "45044"],
    "Midland": ["45148"],
    "Midvale": ["44653"],
    "Milan": ["44846"],
    "Milford": ["45150"],
    "Milford Center": ["43045"],
    "Millbury": ["43447"],
    "Milledgeville": ["43142"],
    "Miller City": ["45864"],
    "Millersburg": ["44654"],
    "Millersport": ["43046"],
    "Millfield": ["45761"],
    "Milton Center": ["43541"],
    "Mineral City": ["44656"],
    "Mineral Ridge": ["44440"],
    "Minerva": ["44657"],
    "Minford": ["45653"],
    "Mingo": ["43047"],
    "Mingo Junction": ["43938"],
    "Minster": ["45865"],
    "Mogadore": ["44260"],
    "Monclova": ["43542"],
    "Monroe": ["45050"],
    "Monroeville": ["44847"],
    "Montezuma": ["45866"],
    "Montpelier": ["43543"],
    "Montville": ["44064"],
    "Morral": ["43337"],
    "Morristown": ["43759"],
    "Morrow": ["45152"],
    "Moscow": ["45153"],
    "Mount Blanchard": ["45867"],
    "Mount Cory": ["45868"],
    "Mount Eaton": ["44659"],
    "Mount Gilead": ["43338"],
    "Mount Hope": ["44660"],
    "Mount Liberty": ["43048"],
    "Mount Orab": ["45154"],
    "Mount Perry": ["43760"],
    "Mount Pleasant": ["43939"],
    "Mount Saint Joseph": ["45051"],
    "Mount Sterling": ["43143"],
    "Mount Vernon": ["43050"],
    "Mount Victory": ["43340"],
    "Mowrystown": ["45155"],
    "Moxahala": ["43761"],
    "Munroe Falls": ["44262"],
    "Murray City": ["43144"],
    "Nankin": ["44848"],
    "Napoleon": ["43545"],
    "Nashport": ["43830"],
    "Nashville": ["44661"],
    "Navarre": ["44662"],
    "Neapolis": ["43547"],
    "Neffs": ["43940"],
    "Negley": ["44441"],
    "Nelsonville": ["45764"],
    "Nevada": ["44849"],
    "Neville": ["45156"],
    "New Albany": ["43054"],
    "New Athens": ["43981"],
    "New Bavaria": ["43548"],
    "New Bloomington": ["43341"],
    "New Bremen": ["45869"],
    "New Carlisle": ["45344"],
    "New Concord": ["43762"],
    "New Hampshire": ["45870"],
    "New Haven": ["44850"],
    "New Holland": ["43145"],
    "New Knoxville": ["45871"],
    "New Lebanon": ["45345"],
    "New Lexington": ["43764"],
    "New London": ["44851"],
    "New Madison": ["45346"],
    "New Marshfield": ["45766"],
    "New Matamoras": ["45767"],
    "New Middletown": ["44442"],
    "New Paris": ["45347"],
    "New Philadelphia": ["44663"],
    "New Plymouth": ["45654"],
    "New Richmond": ["45157"],
    "New Riegel": ["44853"],
    "New Rumley": ["43984"],
    "New Springfield": ["44443"],
    "New Straitsville": ["43766"],
    "New Vienna": ["45159"],
    "New Washington": ["44854"],
    "New Waterford": ["44445"],
    "New Weston": ["45348"],
    "Newark": ["43055", "43058", "43093"],
    "Newbury": ["44065"],
    "Newcomerstown": ["43832"],
    "Newport": ["45768"],
    "Newton Falls": ["44444"],
    "Newtonsville": ["45158"],
    "Ney": ["43549"],
    "Niles": ["44446"],
    "North Baltimore": ["45872"],
    "North Bend": ["45052"],
    "North Benton": ["44449"],
    "North Bloomfield": ["44450"],
    "North Canton": ["44720"],
    "North Fairfield": ["44855"],
    "North Georgetown": ["44665"],
    "North Hampton": ["45349"],
    "North Jackson": ["44451"],
    "North Kingsville": ["44068"],
    "North Lawrence": ["44666"],
    "North Lewisburg": ["43060"],
    "North Lima": ["44452"],
    "North Olmsted": ["44070"],
    "North Ridgeville": ["44039"],
    "North Robinson": ["44856"],
    "North Royalton": ["44133"],
    "North Star": ["45350"],
    "Northfield": ["44067"],
    "Northwood": ["43619"],
    "Norwalk": ["44857"],
    "Norwich": ["43767"],
    "Nova": ["44859"],
    "Novelty": ["44072", "44073"],
    "Oak Harbor": ["43449"],
    "Oak Hill": ["45656"],
    "Oakwood": ["45873"],
    "Oberlin": ["44074"],
    "Oceola": ["44860"],
    "Ohio City": ["45874"],
    "Okeana": ["45053"],
    "Okolona": ["43550"],
    "Old Fort": ["44861"],
    "Old Washington": ["43768"],
    "Olmsted Falls": ["44138"],
    "Ontario": ["44862"],
    "Orangeville": ["44453"],
    "Oregon": ["43616", "43618"],
    "Oregonia": ["45054"],
    "Orient": ["43146"],
    "Orrville": ["44667"],
    "Orwell": ["44076"],
    "Osgood": ["45351"],
    "Ostrander": ["43061"],
    "Ottawa": ["45875"],
    "Ottoville": ["45876"],
    "Otway": ["45657"],
    "Overpeck": ["45055"],
    "Owensville": ["45160"],
    "Oxford": ["45056"],
    "Painesville": ["44077"],
    "Palestine": ["45352"],
    "Pandora": ["45877"],
    "Paris": ["44669"],
    "Parkman": ["44080"],
    "Pataskala": ["43062"],
    "Patriot": ["45658"],
    "Paulding": ["45879"],
    "Payne": ["45880"],
    "Pedro": ["45659"],
    "Peebles": ["45660"],
    "Pemberton": ["45353"],
    "Pemberville": ["43450"],
    "Peninsula": ["44264"],
    "Perry": ["44081"],
    "Perrysburg": ["43551", "43552"],
    "Perrysville": ["44864"],
    "Petersburg": ["44454"],
    "Pettisville": ["43553"],
    "Phillipsburg": ["45354"],
    "Philo": ["43771"],
    "Pickerington": ["43147"],
    "Piedmont": ["43983"],
    "Pierpont": ["44082"],
    "Piketon": ["45661"],
    "Piney Fork": ["43941"],
    "Pioneer": ["43554"],
    "Piqua": ["45356"],
    "Pitsburg": ["45358"],
    "Plain City": ["43064"],
    "Plainfield": ["43836"],
    "Pleasant City": ["43772"],
    "Pleasant Hill": ["45359"],
    "Pleasant Plain": ["45162"],
    "Pleasantville": ["43148"],
    "Plymouth": ["44865"],
    "Polk": ["44866"],
    "Pomeroy": ["45769"],
    "Port Clinton": ["43452"],
    "Port Jefferson": ["45360"],
    "Port Washington": ["43837"],
    "Port William": ["45164"],
    "Portage": ["43451"],
    "Portland": ["45770"],
    "Portsmouth": ["45662"],
    "Potsdam": ["45361"],
    "Powell": ["43065"],
    "Powhatan Point": ["43942"],
    "Proctorville": ["45669"],
    "Prospect": ["43342"],
    "Put In Bay": ["43456"],
    "Quaker City": ["43773"],
    "Quincy": ["43343"],
    "Racine": ["45771"],
    "Radnor": ["43066"],
    "Randolph": ["44265"],
    "Rarden": ["45671"],
    "Ravenna": ["44266"],
    "Rawson": ["45881"],
    "Ray": ["45672"],
    "Rayland": ["43943"],
    "Raymond": ["43067"],
    "Reedsville": ["45772"],
    "Reesville": ["45166"],
    "Reno": ["45773"],
    "Republic": ["44867"],
    "Reynoldsburg": ["43068", "43069"],
    "Richfield": ["44286"],
    "Richmond": ["43944"],
    "Richmond Dale": ["45673"],
    "Richwood": ["43344"],
    "Ridgeville Corners": ["43555"],
    "Ridgeway": ["43345"],
    "Rio Grande": ["45674"],
    "Ripley": ["45167"],
    "Risingsun": ["43457"],
    "Rittman": ["44270"],
    "Robertsville": ["44670"],
    "Rock Camp": ["45675"],
    "Rock Creek": ["44084"],
    "Rockbridge": ["43149"],
    "Rockford": ["45882"],
    "Rocky Ridge": ["43458"],
    "Rocky River": ["44116"],
    "Rogers": ["44455"],
    "Rome": ["44085"],
    "Rootstown": ["44272"],
    "Roseville": ["43777"],
    "Rosewood": ["43070"],
    "Ross": ["45061"],
    "Rossburg": ["45362"],
    "Rossford": ["43460"],
    "Roundhead": ["43346"],
    "Rudolph": ["43462"],
    "Rushsylvania": ["43347"],
    "Rushville": ["43150"],
    "Russells Point": ["43348"],
    "Russellville": ["45168"],
    "Russia": ["45363"],
    "Rutland": ["45775"],
    "Sabina": ["45169"],
    "Saint Clairsville": ["43950"],
    "Saint Henry": ["45883"],
    "Saint Johns": ["45884"],
    "Saint Louisville": ["43071"],
    "Saint Marys": ["45885"],
    "Saint Paris": ["43072"],
    "Salem": ["44460"],
    "Salesville": ["43778"],
    "Salineville": ["43945"],
    "Sandusky": ["44870", "44871"],
    "Sandyville": ["44671"],
    "Sarahsville": ["43779"],
    "Sardinia": ["45171"],
    "Sardis": ["43946"],
    "Savannah": ["44874"],
    "Scio": ["43988"],
    "Scioto Furnace": ["45677"],
    "Scott": ["45886"],
    "Scottown": ["45678"],
    "Seaman": ["45679"],
    "Sebring": ["44672"],
    "Sedalia": ["43151"],
    "Senecaville": ["43780"],
    "Seven Mile": ["45062"],
    "Seville": ["44273"],
    "Shade": ["45776"],
    "Shadyside": ["43947"],
    "Shandon": ["45063"],
    "Sharon Center": ["44274"],
    "Sharpsburg": ["45777"],
    "Shauck": ["43349"],
    "Shawnee": ["43782"],
    "Sheffield Lake": ["44054"],
    "Shelby": ["44875"],
    "Sherrodsville": ["44675"],
    "Sherwood": ["43556"],
    "Shiloh": ["44878"],
    "Shreve": ["44676"],
    "Sidney": ["45365", "45367"],
    "Sinking Spring": ["45172"],
    "Smithfield": ["43948"],
    "Smithville": ["44677"],
    "Solon": ["44139"],
    "Somerdale": ["44678"],
    "Somerset": ["43783"],
    "Somerville": ["45064"],
    "South Bloomingville": ["43152"],
    "South Charleston": ["45368"],
    "South Lebanon": ["45065"],
    "South Point": ["45680"],
    "South Salem": ["45681"],
    "South Solon": ["43153"],
    "South Vienna": ["45369"],
    "South Webster": ["45682"],
    "Southington": ["44470"],
    "Sparta": ["43350"],
    "Spencer": ["44275"],
    "Spencerville": ["45887"],
    "Spring Valley": ["45370"],
    "Springboro": ["45066"],
    "Springfield": ["45501", "45502", "45503", "45504", "45505", "45506"],
    "Stafford": ["43786"],
    "Sterling": ["44276"],
    "Steubenville": ["43952", "43953"],
    "Stewart": ["45778"],
    "Stillwater": ["44679"],
    "Stockdale": ["45683"],
    "Stockport": ["43787"],
    "Stone Creek": ["43840"],
    "Stony Ridge": ["43463"],
    "Stout": ["45684"],
    "Stoutsville": ["43154"],
    "Stow": ["44224"],
    "Strasburg": ["44680"],
    "Stratton": ["43961"],
    "Streetsboro": ["44241"],
    "Strongsville": ["44136", "44149"],
    "Struthers": ["44471"],
    "Stryker": ["43557"],
    "Sugar Grove": ["43155"],
    "Sugarcreek": ["44681"],
    "Sullivan": ["44880"],
    "Sulphur Springs": ["44881"],
    "Summerfield": ["43788"],
    "Summit Station": ["43073"],
    "Summitville": ["43962"],
    "Sunbury": ["43074"],
    "Swanton": ["43558"],
    "Sycamore": ["44882"],
    "Sycamore Valley": ["43789"],
    "Sylvania": ["43560"],
    "Syracuse": ["45779"],
    "Tallmadge": ["44278"],
    "Tarlton": ["43156"],
    "Terrace Park": ["45174"],
    "The Plains": ["45780"],
    "Thompson": ["44086"],
    "Thornville": ["43076"],
    "Thurman": ["45685"],
    "Thurston": ["43157"],
    "Tiffin": ["44883"],
    "Tiltonsville": ["43963"],
    "Tipp City": ["45371"],
    "Tippecanoe": ["44699"],
    "Tiro": ["44887"],
    "Toledo": ["43601", "43603", "43604", "43605", "43606", "43607", "43608", "43609", "43610", "43611", "43612", "43613", "43614", "43615", "43617", "43620", "43623", "43635", "43652", "43654", "43656", "43657", "43659", "43660", "43661", "43666", "43667", "43681", "43682", "43697", "43699"],
    "Tontogany": ["43565"],
    "Toronto": ["43964"],
    "Tremont City": ["45372"],
    "Trenton": ["45067"],
    "Trimble": ["45782"],
    "Trinway": ["43842"],
    "Troy": ["45373", "45374"],
    "Tuppers Plains": ["45783"],
    "Tuscarawas": ["44682"],
    "Twinsburg": ["44087"],
    "Uhrichsville": ["44683"],
    "Union City": ["45390"],
    "Union Furnace": ["43158"],
    "Uniontown": ["44685"],
    "Unionville": ["44088"],
    "Unionville Center": ["43077"],
    "Uniopolis": ["45888"],
    "Upper Sandusky": ["43351"],
    "Urbana": ["43078"],
    "Utica": ["43080"],
    "Valley City": ["44280"],
    "Van Buren": ["45889"],
    "Van Wert": ["45891"],
    "Vandalia": ["45377"],
    "Vanlue": ["45890"],
    "Vaughnsville": ["45893"],
    "Venedocia": ["45894"],
    "Vermilion": ["44089"],
    "Verona": ["45378"],
    "Versailles": ["45380"],
    "Vickery": ["43464"],
    "Vienna": ["44473"],
    "Vincent": ["45784"],
    "Vinton": ["45686"],
    "Wadsworth": ["44281", "44282"],
    "Wakefield": ["45687"],
    "Wakeman": ["44889"],
    "Walbridge": ["43465"],
    "Waldo": ["43356"],
    "Walhonding": ["43843"],
    "Walnut Creek": ["44687"],
    "Wapakoneta": ["45895"],
    "Warnock": ["43967"],
    "Warren": ["44481", "44482", "44483", "44484", "44485", "44486", "44488"],
    "Warsaw": ["43844"],
    "Washington Court House": ["43160"],
    "Washingtonville": ["44490"],
    "Waterford": ["45786"],
    "Waterloo": ["45688"],
    "Watertown": ["45787"],
    "Waterville": ["43566"],
    "Wauseon": ["43567"],
    "Waverly": ["45690"],
    "Wayland": ["44285"],
    "Wayne": ["43466"],
    "Waynesburg": ["44688"],
    "Waynesfield": ["45896"],
    "Waynesville": ["45068"],
    "Wellington": ["44090"],
    "Wellston": ["45692"],
    "Wellsville": ["43968"],
    "West Alexandria": ["45381"],
    "West Chester": ["45069", "45071"],
    "West Elkton": ["45070"],
    "West Farmington": ["44491"],
    "West Jefferson": ["43162"],
    "West Lafayette": ["43845"],
    "West Liberty": ["43357"],
    "West Manchester": ["45382"],
    "West Mansfield": ["43358"],
    "West Millgrove": ["43467"],
    "West Milton": ["45383"],
    "West Point": ["44492"],
    "West Portsmouth": ["45663"],
    "West Rushville": ["43163"],
    "West Salem": ["44287"],
    "West Union": ["45693"],
    "West Unity": ["43570"],
    "Westerville": ["43081", "43082", "43086"],
    "Westfield Center": ["44251"],
    "Westlake": ["44145"],
    "Weston": ["43569"],
    "Westville": ["43083"],
    "Wharton": ["43359"],
    "Wheelersburg": ["45694"],
    "Whipple": ["45788"],
    "White Cottage": ["43791"],
    "Whitehouse": ["43571"],
    "Wickliffe": ["44092"],
    "Wilberforce": ["45384"],
    "Wilkesville": ["45695"],
    "Willard": ["44888", "44890"],
    "Williamsburg": ["45176"],
    "Williamsfield": ["44093"],
    "Williamsport": ["43164"],
    "Williamstown": ["45897"],
    "Williston": ["43468"],
    "Willoughby": ["44094", "44096"],
    "Willow Wood": ["45696"],
    "Willshire": ["45898"],
    "Wilmington": ["45177"],
    "Wilmot": ["44689"],
    "Winchester": ["45697"],
    "Windham": ["44288"],
    "Windsor": ["44099"],
    "Winesburg": ["44690"],
    "Wingett Run": ["45789"],
    "Winona": ["44493"],
    "Wolf Run": ["43970"],
    "Woodsfield": ["43793"],
    "Woodstock": ["43084"],
    "Woodville": ["43469"],
    "Wooster": ["44691"],
    "Wren": ["45899"],
    "Xenia": ["45385"],
    "Yellow Springs": ["45387"],
    "Yorkshire": ["45388"],
    "Yorkville": ["43971"],
    "Youngstown": ["44501", "44502", "44503", "44504", "44505", "44506", "44507", "44509", "44510", "44511", "44512", "44513", "44514", "44515", "44555"],
    "Zaleski": ["45698"],
    "Zanesfield": ["43360"],
    "Zanesville": ["43701", "43702"],
    "Zoar": ["44697"]
  },
  "OK": {
    "Achille": ["74720"],
    "Ada": ["74820", "74821"],
    "Adair": ["74330"],
    "Adams": ["73901"],
    "Addington": ["73520"],
    "Afton": ["74331"],
    "Agra": ["74824"],
    "Albany": ["74721"],
    "Albert": ["73001"],
    "Albion": ["74521"],
    "Alderson": ["74522"],
    "Alex": ["73002"],
    "Aline": ["73716"],
    "Allen": ["74825"],
    "Altus": ["73521", "73522"],
    "Altus AFB": ["73523"],
    "Alva": ["73717"],
    "Amber": ["73004"],
    "Ames": ["73718"],
    "Amorita": ["73719"],
    "Anadarko": ["73005"],
    "Antlers": ["74523"],
    "Apache": ["73006"],
    "Arapaho": ["73620"],
    "Arcadia": ["73007"],
    "Ardmore": ["73401", "73402", "73403", "73451", "73454"],
    "Arkoma": ["74901"],
    "Arnett": ["73832"],
    "Asher": ["74826"],
    "Atoka": ["74525", "74542"],
    "Atwood": ["74827"],
    "Avant": ["74001"],
    "Balko": ["73931"],
    "Barnsdall": ["74002"],
    "Bartlesville": ["74003", "74004", "74005", "74006"],
    "Battiest": ["74722"],
    "Beaver": ["73932"],
    "Beggs": ["74421"],
    "Bennington": ["74723"],
    "Bessie": ["73622"],
    "Bethany": ["73008"],
    "Bethel": ["74724"],
    "Big Cabin": ["74332"],
    "Billings": ["74630"],
    "Binger": ["73009"],
    "Bison": ["73720"],
    "Bixby": ["74008"],
    "Blackwell": ["74631"],
    "Blair": ["73526"],
    "Blanchard": ["73010"],
    "Blanco": ["74528"],
    "Blocker": ["74529"],
    "Bluejacket": ["74333"],
    "Boise City": ["73933"],
    "Bokchito": ["74726"],
    "Bokoshe": ["74930"],
    "Boley": ["74829"],
    "Boswell": ["74727"],
    "Bowlegs": ["74830"],
    "Boynton": ["74422"],
    "Bradley": ["73011"],
    "Braggs": ["74423", "74439"],
    "Braman": ["74632"],
    "Bristow": ["74010"],
    "Broken Arrow": ["74011", "74012", "74013", "74014"],
    "Broken Bow": ["74728"],
    "Bromide": ["74530"],
    "Buffalo": ["73834"],
    "Bunch": ["74931"],
    "Burbank": ["74633"],
    "Burlington": ["73722"],
    "Burneyville": ["73430"],
    "Burns Flat": ["73624"],
    "Butler": ["73625"],
    "Byars": ["74831"],
    "Cache": ["73527"],
    "Caddo": ["74729"],
    "Calera": ["74730"],
    "Calumet": ["73014"],
    "Calvin": ["74531"],
    "Camargo": ["73835"],
    "Cameron": ["74932"],
    "Canadian": ["74425"],
    "Caney": ["74533"],
    "Canton": ["73724"],
    "Canute": ["73626"],
    "Cardin": ["74335"],
    "Carmen": ["73726"],
    "Carnegie": ["73015"],
    "Carney": ["74832"],
    "Carrier": ["73727"],
    "Carter": ["73627"],
    "Cartwright": ["74731"],
    "Cashion": ["73016"],
    "Castle": ["74833"],
    "Catoosa": ["74015"],
    "Cement": ["73017"],
    "Centrahoma": ["74534"],
    "Chandler": ["74834"],
    "Chattanooga": ["73528"],
    "Checotah": ["74426"],
    "Chelsea": ["74016"],
    "Cherokee": ["73728"],
    "Chester": ["73838"],
    "Cheyenne": ["73628"],
    "Chickasha": ["73018", "73023"],
    "Choctaw": ["73020"],
    "Chouteau": ["74337"],
    "Claremore": ["74017", "74018", "74019"],
    "Clarita": ["74535"],
    "Clayton": ["74536"],
    "Cleo Springs": ["73729"],
    "Cleveland": ["74020"],
    "Clinton": ["73601"],
    "Coalgate": ["74538"],
    "Colbert": ["74733"],
    "Colcord": ["74338"],
    "Coleman": ["73432"],
    "Collinsville": ["74021"],
    "Colony": ["73021"],
    "Comanche": ["73529"],
    "Commerce": ["74339"],
    "Concho": ["73022"],
    "Connerville": ["74836"],
    "Cookson": ["74427"],
    "Copan": ["74022"],
    "Cordell": ["73632"],
    "Corn": ["73024"],
    "Council Hill": ["74428"],
    "Countyline": ["73425"],
    "Covington": ["73730"],
    "Coweta": ["74429"],
    "Coyle": ["73027"],
    "Crawford": ["73638"],
    "Crescent": ["73028"],
    "Cromwell": ["74837"],
    "Crowder": ["74430"],
    "Cushing": ["74023"],
    "Custer City": ["73639"],
    "Cyril": ["73029"],
    "Dacoma": ["73731"],
    "Daisy": ["74540"],
    "Davenport": ["74026"],
    "Davidson": ["73530"],
    "Davis": ["73030", "73039"],
    "Deer Creek": ["74636"],
    "Delaware": ["74027"],
    "Depew": ["74028"],
    "Devol": ["73531"],
    "Dewar": ["74431"],
    "Dewey": ["74029"],
    "Dibble": ["73031"],
    "Dill City": ["73641"],
    "Disney": ["74340"],
    "Dougherty": ["73032"],
    "Douglas": ["73733"],
    "Dover": ["73734"],
    "Drummond": ["73735"],
    "Drumright": ["74030"],
    "Duke": ["73532"],
    "Duncan": ["73533", "73534", "73536"],
    "Durant": ["74701", "74702"],
    "Durham": ["73642"],
    "Dustin": ["74839"],
    "Eagletown": ["74734"],
    "Eakly": ["73033"],
    "Earlsboro": ["74840"],
    "Edmond": ["73003", "73012", "73013", "73025", "73034", "73083"],
    "El Reno": ["73036"],
    "Eldorado": ["73537"],
    "Elgin": ["73538"],
    "Elk City": ["73644", "73648"],
    "Elmer": ["73539"],
    "Elmore City": ["73433"],
    "Enid": ["73701", "73702", "73703", "73705", "73706"],
    "Erick": ["73645"],
    "Eucha": ["74342"],
    "Eufaula": ["74432"],
    "Fairfax": ["74637"],
    "Fairland": ["74343"],
    "Fairmont": ["73736"],
    "Fairview": ["73737"],
    "Fanshawe": ["74935"],
    "Fargo": ["73840"],
    "Faxon": ["73540"],
    "Fay": ["73646"],
    "Felt": ["73937"],
    "Finley": ["74543"],
    "Fittstown": ["74842"],
    "Fitzhugh": ["74843"],
    "Fletcher": ["73541"],
    "Forgan": ["73938"],
    "Fort Cobb": ["73038"],
    "Fort Gibson": ["74434"],
    "Fort Sill": ["73503"],
    "Fort Supply": ["73841"],
    "Fort Towson": ["74735"],
    "Foss": ["73647"],
    "Foster": ["73434"],
    "Fox": ["73435"],
    "Foyil": ["74031"],
    "Francis": ["74844"],
    "Frederick": ["73542"],
    "Freedom": ["73842"],
    "Gage": ["73843"],
    "Gans": ["74936"],
    "Garber": ["73738"],
    "Garvin": ["74736"],
    "Gate": ["73844"],
    "Geary": ["73040"],
    "Gene Autry": ["73436"],
    "Geronimo": ["73543"],
    "Glencoe": ["74032"],
    "Glenpool": ["74033"],
    "Golden": ["74737"],
    "Goltry": ["73739"],
    "Goodwell": ["73939"],
    "Gore": ["74435"],
    "Gotebo": ["73041"],
    "Gould": ["73544"],
    "Gowen": ["74545"],
    "Gracemont": ["73042"],
    "Graham": ["73437"],
    "Grandfield": ["73546"],
    "Granite": ["73547"],
    "Grant": ["74738"],
    "Greenfield": ["73043"],
    "Grove": ["74344", "74345"],
    "Guthrie": ["73044"],
    "Guymon": ["73942"],
    "Haileyville": ["74546"],
    "Hallett": ["74034"],
    "Hammon": ["73650"],
    "Hanna": ["74845"],
    "Hardesty": ["73944"],
    "Harrah": ["73045"],
    "Hartshorne": ["74547"],
    "Haskell": ["74436"],
    "Hastings": ["73548"],
    "Haworth": ["74740"],
    "Headrick": ["73549"],
    "Healdton": ["73438"],
    "Heavener": ["74937"],
    "Helena": ["73741"],
    "Hendrix": ["74741"],
    "Hennepin": ["73444"],
    "Hennessey": ["73742"],
    "Henryetta": ["74437"],
    "Hillsdale": ["73743"],
    "Hinton": ["73047"],
    "Hitchcock": ["73744"],
    "Hitchita": ["74438"],
    "Hobart": ["73651"],
    "Hodgen": ["74939"],
    "Holdenville": ["74848"],
    "Hollis": ["73550"],
    "Hollister": ["73551"],
    "Hominy": ["74035"],
    "Honobia": ["74549"],
    "Hooker": ["73945"],
    "Hopeton": ["73746"],
    "Howe": ["74940"],
    "Hoyt": ["74440"],
    "Hugo": ["74743"],
    "Hulbert": ["74441"],
    "Hunter": ["74640"],
    "Hydro": ["73048"],
    "Idabel": ["74745"],
    "Indiahoma": ["73552"],
    "Indianola": ["74442"],
    "Inola": ["74036"],
    "Isabella": ["73747"],
    "Jay": ["74346"],
    "Jenks": ["74037"],
    "Jennings": ["74038"],
    "Jet": ["73749"],
    "Jones": ["73049"],
    "Kansas": ["74347"],
    "Kaw City": ["74641"],
    "Kellyville": ["74039"],
    "Kemp": ["74747"],
    "Kenefic": ["74748"],
    "Kenton": ["73946"],
    "Keota": ["74941"],
    "Ketchum": ["74349"],
    "Keyes": ["73947"],
    "Kiefer": ["74041"],
    "Kingfisher": ["73750"],
    "Kingston": ["73439"],
    "Kinta": ["74552"],
    "Kiowa": ["74553"],
    "Konawa": ["74849"],
    "Krebs": ["74554"],
    "Kremlin": ["73753"],
    "Lahoma": ["73754"],
    "Lamar": ["74850"],
    "Lamont": ["74643"],
    "Lane": ["74555"],
    "Langley": ["74350"],
    "Langston": ["73050"],
    "Laverne": ["73848"],
    "Lawton": ["73501", "73502", "73505", "73506", "73507"],
    "Lebanon": ["73440"],
    "Leedey": ["73654"],
    "Leflore": ["74942"],
    "Lehigh": ["74556"],
    "Lenapah": ["74042"],
    "Leon": ["73441"],
    "Leonard": ["74043"],
    "Lequire": ["74943"],
    "Lexington": ["73051"],
    "Lindsay": ["73052"],
    "Loco": ["73442"],
    "Locust Grove": ["74352"],
    "Lone Grove": ["73443"],
    "Lone Wolf": ["73655"],
    "Longdale": ["73755"],
    "Lookeba": ["73053"],
    "Loveland": ["73553"],
    "Loyal": ["73756"],
    "Lucien": ["73757"],
    "Luther": ["73054"],
    "Macomb": ["74852"],
    "Madill": ["73446"],
    "Manchester": ["73758"],
    "Mangum": ["73554"],
    "Manitou": ["73555"],
    "Mannford": ["74044"],
    "Mannsville": ["73447"],
    "Maramec": ["74045"],
    "Marble City": ["74945"],
    "Marietta": ["73448"],
    "Marland": ["74644"],
    "Marlow": ["73055"],
    "Marshall": ["73056"],
    "Martha": ["73556"],
    "Maud": ["74854"],
    "May": ["73851"],
    "Maysville": ["73057"],
    "Mcalester": ["74501", "74502"],
    "Mccurtain": ["74944"],
    "Mcloud": ["74851"],
    "Mead": ["73449"],
    "Medford": ["73759"],
    "Medicine Park": ["73557"],
    "Meeker": ["74855"],
    "Meers": ["73558"],
    "Meno": ["73760"],
    "Meridian": ["73058"],
    "Miami": ["74354", "74355"],
    "Milburn": ["73450"],
    "Milfay": ["74046"],
    "Mill Creek": ["74856"],
    "Millerton": ["74750"],
    "Minco": ["73059"],
    "Moffett": ["74946"],
    "Monroe": ["74947"],
    "Moodys": ["74444"],
    "Mooreland": ["73852"],
    "Morris": ["74445"],
    "Morrison": ["73061"],
    "Mounds": ["74047"],
    "Mountain Park": ["73559"],
    "Mountain View": ["73062"],
    "Moyers": ["74557"],
    "Muldrow": ["74948"],
    "Mulhall": ["73063"],
    "Muse": ["74949"],
    "Muskogee": ["74401", "74402", "74403"],
    "Mustang": ["73064"],
    "Mutual": ["73853"],
    "Nardin": ["74646"],
    "Nash": ["73761"],
    "Nashoba": ["74558"],
    "Newalla": ["74857"],
    "Newcastle": ["73065"],
    "Newkirk": ["74647"],
    "Nicoma Park": ["73066"],
    "Ninnekah": ["73067"],
    "Noble": ["73068"],
    "Norman": ["73019", "73026", "73069", "73070", "73071", "73072"],
    "North Miami": ["74358"],
    "Nowata": ["74048"],
    "Oakhurst": ["74050"],
    "Oaks": ["74359"],
    "Oakwood": ["73658"],
    "Ochelata": ["74051"],
    "Oilton": ["74052"],
    "Okarche": ["73762"],
    "Okay": ["74446"],
    "Okeene": ["73763"],
    "Okemah": ["74859"],
    "Oklahoma City": ["73101", "73102", "73103", "73104", "73105", "73106", "73107", "73108", "73109", "73110", "73111", "73112", "73113", "73114", "73115", "73116", "73117", "73118", "73119", "73120", "73121", "73122", "73123", "73124", "73125", "73126", "73127", "73128", "73129", "73130", "73131", "73132", "73134", "73135", "73136", "73137", "73139", "73140", "73141", "73142", "73143", "73144", "73145", "73146", "73147", "73148", "73149", "73150", "73151", "73152", "73153", "73154", "73155", "73156", "73157", "73159", "73160", "73162", "73163", "73164", "73165", "73167", "73169", "73170", "73172", "73173", "73178", "73179", "73184", "73185", "73189", "73190", "73193", "73194", "73195", "73196", "73197", "73198", "73199"],
    "Okmulgee": ["74447"],
    "Oktaha": ["74450"],
    "Olustee": ["73560"],
    "Omega": ["73764"],
    "Oologah": ["74053"],
    "Orlando": ["73073"],
    "Osage": ["74054"],
    "Oscar": ["73561"],
    "Overbrook": ["73453"],
    "Owasso": ["74055"],
    "Paden": ["74860"],
    "Panama": ["74951"],
    "Panola": ["74559"],
    "Paoli": ["73074"],
    "Park Hill": ["74451"],
    "Pauls Valley": ["73075"],
    "Pawhuska": ["74056"],
    "Pawnee": ["74058"],
    "Peggs": ["74452"],
    "Perkins": ["74059"],
    "Perry": ["73077"],
    "Picher": ["74360"],
    "Pickens": ["74752"],
    "Piedmont": ["73078"],
    "Pittsburg": ["74560"],
    "Platter": ["74753"],
    "Pocasset": ["73079"],
    "Pocola": ["74902"],
    "Ponca City": ["74601", "74602", "74604"],
    "Pond Creek": ["73766"],
    "Porter": ["74454"],
    "Porum": ["74455"],
    "Poteau": ["74953"],
    "Prague": ["74864"],
    "Preston": ["74456"],
    "Proctor": ["74457"],
    "Prue": ["74060"],
    "Pryor": ["74361", "74362"],
    "Purcell": ["73080"],
    "Putnam": ["73659"],
    "Quapaw": ["74363"],
    "Quinton": ["74561"],
    "Ralston": ["74650"],
    "Ramona": ["74061"],
    "Randlett": ["73562"],
    "Ratliff City": ["73481"],
    "Rattan": ["74562"],
    "Ravia": ["73455"],
    "Red Oak": ["74563"],
    "Red Rock": ["74651"],
    "Redbird": ["74458"],
    "Rentiesville": ["74459"],
    "Reydon": ["73660"],
    "Ringling": ["73456"],
    "Ringold": ["74754"],
    "Ringwood": ["73768"],
    "Ripley": ["74062"],
    "Rocky": ["73661"],
    "Roff": ["74865"],
    "Roland": ["74954"],
    "Roosevelt": ["73564"],
    "Rose": ["74364"],
    "Rosston": ["73855"],
    "Rufe": ["74755"],
    "Rush Springs": ["73082"],
    "Ryan": ["73565"],
    "S Coffeyville": ["74072"],
    "Saint Louis": ["74866"],
    "Salina": ["74365"],
    "Sallisaw": ["74955"],
    "Sand Springs": ["74063"],
    "Sapulpa": ["74066", "74067"],
    "Sasakwa": ["74867"],
    "Savanna": ["74565"],
    "Sawyer": ["74756"],
    "Sayre": ["73662"],
    "Schulter": ["74460"],
    "Seiling": ["73663"],
    "Seminole": ["74818", "74868"],
    "Sentinel": ["73664"],
    "Shady Point": ["74956"],
    "Shamrock": ["74068"],
    "Sharon": ["73857"],
    "Shattuck": ["73858"],
    "Shawnee": ["74801", "74802", "74804"],
    "Shidler": ["74652"],
    "Skiatook": ["74070"],
    "Slick": ["74071"],
    "Smithville": ["74957"],
    "Snow": ["74567"],
    "Snyder": ["73566"],
    "Soper": ["74759"],
    "Southard": ["73770"],
    "Sparks": ["74869"],
    "Spavinaw": ["74366"],
    "Spencer": ["73084"],
    "Spencerville": ["74760"],
    "Sperry": ["74073"],
    "Spiro": ["74959"],
    "Springer": ["73458"],
    "Sterling": ["73567"],
    "Stidham": ["74461"],
    "Stigler": ["74462"],
    "Stillwater": ["74074", "74075", "74076", "74077", "74078"],
    "Stilwell": ["74960"],
    "Stonewall": ["74871"],
    "Strang": ["74367"],
    "Stratford": ["74872"],
    "Stringtown": ["74569"],
    "Stroud": ["74079"],
    "Stuart": ["74570"],
    "Sulphur": ["73086"],
    "Sweetwater": ["73666"],
    "Swink": ["74761"],
    "Taft": ["74463"],
    "Tahlequah": ["74464", "74465"],
    "Talala": ["74080"],
    "Talihina": ["74571"],
    "Taloga": ["73667"],
    "Tatums": ["73487"],
    "Tecumseh": ["74873"],
    "Temple": ["73568"],
    "Terlton": ["74081"],
    "Terral": ["73569"],
    "Texhoma": ["73949"],
    "Texola": ["73668"],
    "Thackerville": ["73459"],
    "Thomas": ["73669"],
    "Tipton": ["73570"],
    "Tishomingo": ["73460"],
    "Tonkawa": ["74653"],
    "Tryon": ["74875"],
    "Tulsa": ["74101", "74102", "74103", "74104", "74105", "74106", "74107", "74108", "74110", "74112", "74114", "74115", "74116", "74117", "74119", "74120", "74121", "74126", "74127", "74128", "74129", "74130", "74131", "74132", "74133", "74134", "74135", "74136", "74137", "74141", "74145", "74146", "74147", "74148", "74149", "74150", "74152", "74153", "74155", "74156", "74157", "74158", "74159", "74169", "74170", "74171", "74172", "74182", "74183", "74184", "74186", "74187", "74189", "74192", "74193", "74194"],
    "Tupelo": ["74572"],
    "Turpin": ["73950"],
    "Tuskahoma": ["74574"],
    "Tussy": ["73488"],
    "Tuttle": ["73089"],
    "Twin Oaks": ["74368"],
    "Tyrone": ["73951"],
    "Union City": ["73090"],
    "Valliant": ["74764"],
    "Velma": ["73491"],
    "Vera": ["74082"],
    "Verden": ["73092"],
    "Vian": ["74962"],
    "Vici": ["73859"],
    "Vinita": ["74301"],
    "Vinson": ["73571"],
    "Wagoner": ["74467", "74477"],
    "Wainwright": ["74468"],
    "Wakita": ["73771"],
    "Walters": ["73572"],
    "Wanette": ["74878"],
    "Wann": ["74083"],
    "Wapanucka": ["73461"],
    "Wardville": ["74576"],
    "Warner": ["74469"],
    "Washington": ["73093"],
    "Washita": ["73094"],
    "Watonga": ["73772"],
    "Watson": ["74963"],
    "Watts": ["74964"],
    "Waukomis": ["73773"],
    "Waurika": ["73573"],
    "Wayne": ["73095"],
    "Waynoka": ["73860"],
    "Weatherford": ["73096"],
    "Webbers Falls": ["74470"],
    "Welch": ["74369"],
    "Weleetka": ["74880"],
    "Welling": ["74471"],
    "Wellston": ["74881"],
    "Westville": ["74965"],
    "Wetumka": ["74883"],
    "Wewoka": ["74884"],
    "Wheatland": ["73097"],
    "Whitefield": ["74472"],
    "Whitesboro": ["74577"],
    "Wilburton": ["74578"],
    "Willow": ["73673"],
    "Wilson": ["73463"],
    "Wister": ["74966"],
    "Woodward": ["73801", "73802"],
    "Wright City": ["74766"],
    "Wyandotte": ["74370"],
    "Wynnewood": ["73098"],
    "Wynona": ["74084"],
    "Yale": ["74085"],
    "Yukon": ["73085", "73099"]
  },
  "OR": {
    "Adams": ["97810"],
    "Adel": ["97620"],
    "Adrian": ["97901"],
    "Agness": ["97406"],
    "Albany": ["97321", "97322"],
    "Allegany": ["97407"],
    "Alsea": ["97324"],
    "Alvadore": ["97409"],
    "Amity": ["97101"],
    "Antelope": ["97001"],
    "Arch Cape": ["97102"],
    "Arlington": ["97812"],
    "Arock": ["97902"],
    "Ashland": ["97520"],
    "Ashwood": ["97711"],
    "Astoria": ["97103"],
    "Athena": ["97813"],
    "Aumsville": ["97325"],
    "Aurora": ["97002"],
    "Azalea": ["97410"],
    "Baker City": ["97814"],
    "Bandon": ["97411"],
    "Banks": ["97106"],
    "Bates": ["97817"],
    "Bay City": ["97107"],
    "Beatty": ["97621"],
    "Beaver": ["97108"],
    "Beavercreek": ["97004"],
    "Beaverton": ["97003", "97005", "97006", "97007", "97008", "97075", "97076", "97077", "97078", "97079"],
    "Bend": ["97701", "97702", "97703", "97707", "97708", "97709"],
    "Blachly": ["97412"],
    "Blodgett": ["97326"],
    "Blue River": ["97413"],
    "Bly": ["97622"],
    "Boardman": ["97818"],
    "Bonanza": ["97623"],
    "Boring": ["97009"],
    "Bridal Veil": ["97010"],
    "Bridgeport": ["97819"],
    "Brightwood": ["97011"],
    "Broadbent": ["97414"],
    "Brogan": ["97903"],
    "Brookings": ["97415"],
    "Brothers": ["97712"],
    "Brownsville": ["97327"],
    "Burns": ["97720"],
    "Butte Falls": ["97522"],
    "Buxton": ["97109"],
    "Camas Valley": ["97416"],
    "Camp Sherman": ["97730"],
    "Canby": ["97013"],
    "Cannon Beach": ["97110"],
    "Canyon City": ["97820"],
    "Canyonville": ["97417"],
    "Carlton": ["97111"],
    "Cascade Locks": ["97014"],
    "Cascadia": ["97329"],
    "Cave Junction": ["97523"],
    "Central Point": ["97502"],
    "Chemult": ["97731"],
    "Cheshire": ["97419"],
    "Chiloquin": ["97624"],
    "Christmas Valley": ["97641"],
    "Clackamas": ["97015"],
    "Clatskanie": ["97016"],
    "Cloverdale": ["97112"],
    "Colton": ["97017"],
    "Columbia City": ["97018"],
    "Condon": ["97823"],
    "Coos Bay": ["97420"],
    "Coquille": ["97423"],
    "Corbett": ["97019"],
    "Cornelius": ["97113"],
    "Corvallis": ["97330", "97331", "97333", "97339"],
    "Cottage Grove": ["97424", "97472"],
    "Cove": ["97824"],
    "Crabtree": ["97335"],
    "Crane": ["97732"],
    "Crater Lake": ["97604"],
    "Crawfordsville": ["97336"],
    "Crescent": ["97733"],
    "Crescent Lake": ["97425"],
    "Creswell": ["97426"],
    "Culp Creek": ["97427"],
    "Culver": ["97734"],
    "Curtin": ["97428"],
    "Dairy": ["97625"],
    "Dallas": ["97338"],
    "Damascus": ["97089"],
    "Days Creek": ["97429"],
    "Dayton": ["97114"],
    "Dayville": ["97825"],
    "Deadwood": ["97430"],
    "Deer Island": ["97054"],
    "Depoe Bay": ["97341"],
    "Detroit": ["97342"],
    "Dexter": ["97431"],
    "Diamond": ["97722"],
    "Dillard": ["97432"],
    "Donald": ["97020"],
    "Dorena": ["97434"],
    "Drain": ["97435"],
    "Drewsey": ["97904"],
    "Dufur": ["97021"],
    "Dundee": ["97115"],
    "Durkee": ["97905"],
    "Eagle Creek": ["97022"],
    "Eagle Point": ["97524"],
    "Echo": ["97826"],
    "Eddyville": ["97343"],
    "Elgin": ["97827"],
    "Elkton": ["97436"],
    "Elmira": ["97437"],
    "Enterprise": ["97828"],
    "Estacada": ["97023"],
    "Eugene": ["97401", "97402", "97403", "97404", "97405", "97408", "97440"],
    "Fairview": ["97024"],
    "Fall Creek": ["97438"],
    "Falls City": ["97344"],
    "Fields": ["97710"],
    "Florence": ["97439"],
    "Forest Grove": ["97116"],
    "Fort Klamath": ["97626"],
    "Fort Rock": ["97735"],
    "Fossil": ["97830"],
    "Foster": ["97345"],
    "Frenchglen": ["97736"],
    "Gales Creek": ["97117"],
    "Gardiner": ["97441"],
    "Garibaldi": ["97118"],
    "Gaston": ["97119"],
    "Gates": ["97346"],
    "Gervais": ["97026"],
    "Gilchrist": ["97737"],
    "Gladstone": ["97027"],
    "Glendale": ["97442"],
    "Gleneden Beach": ["97388"],
    "Glide": ["97443"],
    "Gold Beach": ["97444"],
    "Gold Hill": ["97525"],
    "Government Camp": ["97028"],
    "Grand Ronde": ["97347"],
    "Grants Pass": ["97526", "97527", "97528"],
    "Grass Valley": ["97029"],
    "Gresham": ["97030", "97080"],
    "Haines": ["97833"],
    "Halfway": ["97834"],
    "Halsey": ["97348"],
    "Hammond": ["97121"],
    "Happy Valley": ["97086"],
    "Harper": ["97906"],
    "Harrisburg": ["97446"],
    "Hebo": ["97122"],
    "Helix": ["97835"],
    "Heppner": ["97836"],
    "Hereford": ["97837"],
    "Hermiston": ["97838"],
    "Hillsboro": ["97123", "97124", "97129"],
    "Hines": ["97738"],
    "Hood River": ["97031"],
    "Hubbard": ["97032"],
    "Huntington": ["97907"],
    "Idanha": ["97350"],
    "Idleyld Park": ["97447"],
    "Imbler": ["97841"],
    "Imnaha": ["97842"],
    "Independence": ["97351"],
    "Ione": ["97843"],
    "Ironside": ["97908"],
    "Irrigon": ["97844"],
    "Jacksonville": ["97530"],
    "Jamieson": ["97909"],
    "Jefferson": ["97352"],
    "John Day": ["97845"],
    "Jordan Valley": ["97910"],
    "Joseph": ["97846"],
    "Junction City": ["97448"],
    "Juntura": ["97911"],
    "Keizer": ["97307"],
    "Keno": ["97627"],
    "Kent": ["97033"],
    "Kerby": ["97531"],
    "Kimberly": ["97848"],
    "Klamath Falls": ["97601", "97602", "97603"],
    "La Grande": ["97850"],
    "La Pine": ["97739"],
    "Lafayette": ["97127"],
    "Lake Oswego": ["97034", "97035"],
    "Lakeside": ["97449"],
    "Lakeview": ["97630"],
    "Langlois": ["97450"],
    "Lebanon": ["97355"],
    "Lexington": ["97839"],
    "Lincoln City": ["97367"],
    "Logsden": ["97357"],
    "Long Creek": ["97856"],
    "Lorane": ["97451"],
    "Lostine": ["97857"],
    "Lowell": ["97452"],
    "Lyons": ["97358"],
    "Madras": ["97741"],
    "Malin": ["97632"],
    "Manning": ["97125"],
    "Manzanita": ["97130"],
    "Mapleton": ["97453"],
    "Marcola": ["97454"],
    "Marylhurst": ["97036"],
    "Maupin": ["97037"],
    "Mcminnville": ["97128"],
    "Meacham": ["97859"],
    "Medford": ["97501", "97504"],
    "Mehama": ["97384"],
    "Merlin": ["97532"],
    "Merrill": ["97633"],
    "Midland": ["97634"],
    "Mikkalo": ["97861"],
    "Mill City": ["97360"],
    "Milton Freewater": ["97862"],
    "Mitchell": ["97750"],
    "Molalla": ["97038"],
    "Monmouth": ["97361"],
    "Monroe": ["97456"],
    "Monument": ["97864"],
    "Moro": ["97039"],
    "Mosier": ["97040"],
    "Mount Angel": ["97362"],
    "Mount Hood Parkdale": ["97041"],
    "Mount Vernon": ["97865"],
    "Mulino": ["97042"],
    "Murphy": ["97533"],
    "Myrtle Creek": ["97457"],
    "Myrtle Point": ["97458"],
    "Nehalem": ["97131"],
    "Neotsu": ["97364"],
    "Neskowin": ["97149"],
    "Netarts": ["97143"],
    "New Pine Creek": ["97635"],
    "Newberg": ["97132"],
    "Newport": ["97365"],
    "North Bend": ["97459"],
    "North Plains": ["97133"],
    "North Powder": ["97867"],
    "Noti": ["97461"],
    "Nyssa": ["97913"],
    "O Brien": ["97534"],
    "Oakland": ["97462"],
    "Oakridge": ["97463"],
    "Oceanside": ["97134"],
    "Odell": ["97044"],
    "Ontario": ["97914"],
    "Ophir": ["97464"],
    "Oregon City": ["97045"],
    "Otis": ["97368"],
    "Otter Rock": ["97369"],
    "Oxbow": ["97840"],
    "Pacific City": ["97135"],
    "Paisley": ["97636"],
    "Paulina": ["97751"],
    "Pendleton": ["97801"],
    "Philomath": ["97370"],
    "Phoenix": ["97535"],
    "Pilot Rock": ["97868"],
    "Pleasant Hill": ["97455"],
    "Plush": ["97637"],
    "Port Orford": ["97465"],
    "Portland": ["97201", "97202", "97203", "97204", "97205", "97206", "97207", "97208", "97209", "97210", "97211", "97212", "97213", "97214", "97215", "97216", "97217", "97218", "97219", "97220", "97221", "97222", "97223", "97224", "97225", "97227", "97228", "97229", "97230", "97231", "97232", "97233", "97236", "97238", "97239", "97240", "97242", "97250", "97251", "97252", "97253", "97254", "97255", "97256", "97258", "97259", "97266", "97267", "97268", "97269", "97271", "97272", "97280", "97281", "97282", "97283", "97286", "97290", "97291", "97292", "97293", "97294", "97296", "97298", "97299"],
    "Post": ["97752"],
    "Powell Butte": ["97753"],
    "Powers": ["97466"],
    "Prairie City": ["97869"],
    "Princeton": ["97721"],
    "Prineville": ["97754"],
    "Prospect": ["97536"],
    "Rainier": ["97048"],
    "Redmond": ["97756"],
    "Reedsport": ["97467"],
    "Rhododendron": ["97049"],
    "Richland": ["97870"],
    "Rickreall": ["97371"],
    "Riddle": ["97469"],
    "Riley": ["97758"],
    "Riverside": ["97917"],
    "Rockaway Beach": ["97136"],
    "Rogue River": ["97537"],
    "Rose Lodge": ["97372"],
    "Roseburg": ["97470", "97471"],
    "Rufus": ["97050"],
    "Saint Benedict": ["97373"],
    "Saint Helens": ["97051"],
    "Saint Paul": ["97137"],
    "Salem": ["97301", "97302", "97303", "97304", "97305", "97306", "97308", "97309", "97310", "97311", "97312", "97313", "97314", "97317"],
    "Sandy": ["97055"],
    "Scappoose": ["97056"],
    "Scio": ["97374"],
    "Scotts Mills": ["97375"],
    "Scottsburg": ["97473"],
    "Seal Rock": ["97376"],
    "Seaside": ["97138"],
    "Selma": ["97538"],
    "Seneca": ["97873"],
    "Shady Cove": ["97539"],
    "Shaniko": ["97057"],
    "Shedd": ["97377"],
    "Sheridan": ["97378"],
    "Sherwood": ["97140"],
    "Siletz": ["97380"],
    "Silver Lake": ["97638"],
    "Silverton": ["97381"],
    "Sisters": ["97759"],
    "Sixes": ["97476"],
    "South Beach": ["97366"],
    "Sprague River": ["97639"],
    "Spray": ["97874"],
    "Springfield": ["97475", "97477", "97478"],
    "Stanfield": ["97875"],
    "Stayton": ["97383"],
    "Sublimity": ["97385"],
    "Summer Lake": ["97640"],
    "Summerville": ["97876"],
    "Sumpter": ["97877"],
    "Sutherlin": ["97479"],
    "Sweet Home": ["97386"],
    "Swisshome": ["97480"],
    "Talent": ["97540"],
    "Tangent": ["97389"],
    "Tenmile": ["97481"],
    "Terrebonne": ["97760"],
    "The Dalles": ["97058"],
    "Thurston": ["97482"],
    "Tidewater": ["97390"],
    "Tillamook": ["97141"],
    "Tiller": ["97484"],
    "Timber": ["97144"],
    "Toledo": ["97391"],
    "Tolovana Park": ["97145"],
    "Trail": ["97541"],
    "Troutdale": ["97060"],
    "Tualatin": ["97062"],
    "Turner": ["97392"],
    "Tygh Valley": ["97063"],
    "Ukiah": ["97880"],
    "Umatilla": ["97882"],
    "Umpqua": ["97486"],
    "Union": ["97883"],
    "Unity": ["97884"],
    "Vale": ["97918"],
    "Veneta": ["97487"],
    "Vernonia": ["97064"],
    "Vida": ["97488"],
    "Waldport": ["97394"],
    "Wallowa": ["97885"],
    "Walterville": ["97489"],
    "Walton": ["97490"],
    "Warm Springs": ["97761"],
    "Warren": ["97053"],
    "Warrenton": ["97146"],
    "Wasco": ["97065"],
    "Wedderburn": ["97491"],
    "Welches": ["97067"],
    "West Linn": ["97068"],
    "Westfall": ["97920"],
    "Westfir": ["97492"],
    "Westlake": ["97493"],
    "Weston": ["97886"],
    "Wheeler": ["97147"],
    "White City": ["97503"],
    "Wilbur": ["97494"],
    "Wilderville": ["97543"],
    "Willamina": ["97396"],
    "Williams": ["97544"],
    "Wilsonville": ["97070"],
    "Winchester": ["97495"],
    "Winston": ["97496"],
    "Wolf Creek": ["97497"],
    "Woodburn": ["97071"],
    "Yachats": ["97498"],
    "Yamhill": ["97148"],
    "Yoncalla": ["97499"]
  },
  "PA": {
    "Aaronsburg": ["16820"],
    "Abbottstown": ["17301"],
    "Abington": ["19001"],
    "Ackermanville": ["18010"],
    "Acme": ["15610"],
    "Acosta": ["15520"],
    "Adah": ["15410"],
    "Adamsburg": ["15611"],
    "Adamstown": ["19501"],
    "Adamsville": ["16110"],
    "Addison": ["15411"],
    "Adrian": ["16210"],
    "Airville": ["17302"],
    "Akron": ["17501"],
    "Alba": ["16910"],
    "Albion": ["16401", "16475"],
    "Albrightsville": ["18210"],
    "Alburtis": ["18011"],
    "Aleppo": ["15310"],
    "Alexandria": ["16611"],
    "Aliquippa": ["15001"],
    "Allenport": ["15412"],
    "Allensville": ["17002"],
    "Allentown": ["18101", "18102", "18103", "18104", "18105", "18106", "18109", "18175", "18195"],
    "Allenwood": ["17810"],
    "Allison": ["15413"],
    "Allison Park": ["15101"],
    "Allport": ["16821"],
    "Altoona": ["16601", "16602", "16603"],
    "Alum Bank": ["15521"],
    "Alverda": ["15710"],
    "Alverton": ["15612"],
    "Amberson": ["17210"],
    "Ambler": ["19002"],
    "Ambridge": ["15003"],
    "Amity": ["15311"],
    "Analomink": ["18320"],
    "Andreas": ["18211"],
    "Anita": ["15711"],
    "Annville": ["17003"],
    "Antes Fort": ["17720"],
    "Apollo": ["15613"],
    "Aquashicola": ["18012"],
    "Arcadia": ["15712"],
    "Archbald": ["18403"],
    "Arcola": ["19420"],
    "Ardara": ["15615"],
    "Ardmore": ["19003"],
    "Arendtsville": ["17303"],
    "Aristes": ["17920"],
    "Armagh": ["15920"],
    "Armbrust": ["15616"],
    "Arnot": ["16911"],
    "Arona": ["15617"],
    "Artemas": ["17211"],
    "Ashfield": ["18212"],
    "Ashland": ["17921"],
    "Ashville": ["16613"],
    "Aspers": ["17304"],
    "Aston": ["19014"],
    "Atglen": ["19310"],
    "Athens": ["18810"],
    "Atlantic": ["16111"],
    "Atlasburg": ["15004"],
    "Auburn": ["17922"],
    "Audubon": ["19407"],
    "Aultman": ["15713"],
    "Austin": ["16720"],
    "Avella": ["15312"],
    "Avis": ["17721"],
    "Avondale": ["19311"],
    "Avonmore": ["15618"],
    "Baden": ["15005"],
    "Bainbridge": ["17502"],
    "Bairdford": ["15006"],
    "Bakerstown": ["15007"],
    "Bala Cynwyd": ["19004"],
    "Bally": ["19503"],
    "Bangor": ["18013"],
    "Barnesville": ["18214"],
    "Bart": ["17503"],
    "Barto": ["19504"],
    "Bartonsville": ["18321"],
    "Bath": ["18014"],
    "Bausman": ["17504"],
    "Beach Haven": ["18601"],
    "Beach Lake": ["18405"],
    "Beallsville": ["15313"],
    "Bear Creek": ["18602"],
    "Bear Lake": ["16402"],
    "Beaver": ["15009"],
    "Beaver Falls": ["15010"],
    "Beaver Meadows": ["18216"],
    "Beaver Springs": ["17812", "17843"],
    "Beaverdale": ["15921"],
    "Beavertown": ["17813"],
    "Beccaria": ["16616"],
    "Bechtelsville": ["19505"],
    "Bedford": ["15522"],
    "Bedminster": ["18910"],
    "Beech Creek": ["16822"],
    "Belle Vernon": ["15012"],
    "Bellefonte": ["16823"],
    "Belleville": ["17004"],
    "Bellwood": ["16617"],
    "Belsano": ["15922"],
    "Bendersville": ["17306"],
    "Benezett": ["15821"],
    "Bensalem": ["19020"],
    "Bentleyville": ["15314"],
    "Benton": ["17814"],
    "Berlin": ["15530"],
    "Bernville": ["19506"],
    "Berrysburg": ["17005"],
    "Berwick": ["18603"],
    "Berwyn": ["19312"],
    "Bessemer": ["16112"],
    "Bethel": ["19507"],
    "Bethel Park": ["15102"],
    "Bethlehem": ["18015", "18016", "18017", "18018", "18020", "18025"],
    "Beyer": ["16211"],
    "Big Cove Tannery": ["17212"],
    "Big Run": ["15715"],
    "Bigler": ["16825"],
    "Biglerville": ["17307"],
    "Birchrunville": ["19421"],
    "Bird In Hand": ["17505"],
    "Birdsboro": ["19508"],
    "Black Lick": ["15716"],
    "Blain": ["17006"],
    "Blairs Mills": ["17213"],
    "Blairsville": ["15717"],
    "Blakeslee": ["18610"],
    "Blanchard": ["16826"],
    "Blandburg": ["16619"],
    "Blandon": ["19510"],
    "Blooming Glen": ["18911"],
    "Bloomsburg": ["17815"],
    "Blossburg": ["16912"],
    "Blue Ball": ["17506"],
    "Blue Bell": ["19422", "19424"],
    "Blue Ridge Summit": ["17214"],
    "Boalsburg": ["16827"],
    "Bobtown": ["15315"],
    "Boiling Springs": ["17007"],
    "Bolivar": ["15923"],
    "Boswell": ["15531"],
    "Bovard": ["15619"],
    "Bowers": ["19511"],
    "Bowmansdale": ["17008"],
    "Bowmanstown": ["18030"],
    "Bowmansville": ["17507"],
    "Boyers": ["16016", "16017", "16018", "16020"],
    "Boyertown": ["19512"],
    "Boynton": ["15532"],
    "Brackenridge": ["15014"],
    "Brackney": ["18812"],
    "Braddock": ["15104"],
    "Bradenville": ["15620"],
    "Bradford": ["16701"],
    "Bradfordwoods": ["15015"],
    "Branchdale": ["17923"],
    "Branchton": ["16021"],
    "Brandamore": ["19316"],
    "Brandy Camp": ["15822"],
    "Brave": ["15316"],
    "Breezewood": ["15533"],
    "Breinigsville": ["18031"],
    "Bridgeport": ["19405"],
    "Bridgeville": ["15017"],
    "Brier Hill": ["15415"],
    "Brisbin": ["16620"],
    "Bristol": ["19007"],
    "Broad Top": ["16621"],
    "Brockport": ["15823"],
    "Brockton": ["17925"],
    "Brockway": ["15824"],
    "Brodheadsville": ["18322"],
    "Brogue": ["17309"],
    "Brookhaven": ["19015"],
    "Brooklyn": ["18813"],
    "Brookville": ["15825"],
    "Broomall": ["19008"],
    "Brownfield": ["15416"],
    "Brownstown": ["17508"],
    "Brownsville": ["15417"],
    "Bruin": ["16022"],
    "Brush Valley": ["15720"],
    "Bryn Athyn": ["19009"],
    "Bryn Mawr": ["19010"],
    "Buck Hill Falls": ["18323"],
    "Buckingham": ["18912"],
    "Buena Vista": ["15018"],
    "Buffalo Mills": ["15534"],
    "Bulger": ["15019"],
    "Bunola": ["15020"],
    "Burgettstown": ["15021"],
    "Burlington": ["18814"],
    "Burnham": ["17009"],
    "Burnside": ["15721"],
    "Burnt Cabins": ["17215"],
    "Bushkill": ["18324"],
    "Butler": ["16001", "16002", "16003"],
    "Byrnedale": ["15827"],
    "Cabot": ["16023"],
    "Cadogan": ["16212"],
    "Cairnbrook": ["15924"],
    "California": ["15419"],
    "Callensburg": ["16213"],
    "Callery": ["16024"],
    "Calumet": ["15621"],
    "Calvin": ["16622"],
    "Cambra": ["18611"],
    "Cambridge Springs": ["16403"],
    "Cammal": ["17723"],
    "Camp Hill": ["17001", "17011", "17012", "17089"],
    "Campbelltown": ["17010"],
    "Camptown": ["18815"],
    "Canadensis": ["18325"],
    "Canonsburg": ["15317"],
    "Canton": ["17724"],
    "Carbondale": ["18407"],
    "Cardale": ["15420"],
    "Carlisle": ["17013", "17015"],
    "Carlton": ["16311"],
    "Carmichaels": ["15320"],
    "Carnegie": ["15106"],
    "Carrolltown": ["15722"],
    "Carversville": ["18913"],
    "Cashtown": ["17310"],
    "Cassandra": ["15925"],
    "Cassville": ["16623"],
    "Castanea": ["17726"],
    "Catasauqua": ["18032"],
    "Catawissa": ["17820"],
    "Cecil": ["15321"],
    "Cedar Run": ["17727"],
    "Cedars": ["19423"],
    "Center Valley": ["18034"],
    "Centerport": ["19516"],
    "Centerville": ["16404"],
    "Central City": ["15926"],
    "Centre Hall": ["16828"],
    "Chadds Ford": ["19317"],
    "Chalfont": ["18914"],
    "Chalk Hill": ["15421"],
    "Chambersburg": ["17201", "17202"],
    "Chambersville": ["15723"],
    "Champion": ["15622"],
    "Chandlers Valley": ["16312"],
    "Charleroi": ["15022"],
    "Chatham": ["19318"],
    "Cheltenham": ["19012"],
    "Cherry Tree": ["15724"],
    "Cherryville": ["18035"],
    "Chest Springs": ["16624"],
    "Chester": ["19013", "19016"],
    "Chester Heights": ["19017"],
    "Chester Springs": ["19425"],
    "Chestnut Ridge": ["15422"],
    "Cheswick": ["15024"],
    "Cheyney": ["19319"],
    "Chicora": ["16025"],
    "Chinchilla": ["18410"],
    "Christiana": ["17509"],
    "Clairton": ["15025"],
    "Clarence": ["16829"],
    "Clarendon": ["16313"],
    "Claridge": ["15623"],
    "Clarington": ["15828"],
    "Clarion": ["16214"],
    "Clark": ["16113"],
    "Clarks Mills": ["16114"],
    "Clarks Summit": ["18411"],
    "Clarksburg": ["15725"],
    "Clarksville": ["15322"],
    "Claysburg": ["16625"],
    "Claysville": ["15323"],
    "Clearfield": ["16830"],
    "Clearville": ["15535"],
    "Clifford": ["18413"],
    "Clifton Heights": ["19018"],
    "Clinton": ["15026"],
    "Clintonville": ["16372"],
    "Clune": ["15727"],
    "Clymer": ["15728"],
    "Coal Center": ["15423"],
    "Coal Township": ["17866"],
    "Coaldale": ["18218"],
    "Coalport": ["16627"],
    "Coatesville": ["19320"],
    "Coburn": ["16832"],
    "Cochranton": ["16314"],
    "Cochranville": ["19330"],
    "Cocolamus": ["17014"],
    "Codorus": ["17311"],
    "Cogan Station": ["17728"],
    "Cokeburg": ["15324"],
    "Collegeville": ["19426"],
    "Colmar": ["18915"],
    "Columbia": ["17512"],
    "Columbia Cross Roads": ["16914"],
    "Columbus": ["16405"],
    "Colver": ["15927"],
    "Commodore": ["15729"],
    "Concord": ["17217"],
    "Concordville": ["19331", "19339", "19340"],
    "Conestoga": ["17516"],
    "Confluence": ["15424"],
    "Conneaut Lake": ["16316"],
    "Conneautville": ["16406"],
    "Connellsville": ["15425"],
    "Connoquenessing": ["16027"],
    "Conshohocken": ["19428", "19429"],
    "Conway": ["15027"],
    "Conyngham": ["18219"],
    "Cooksburg": ["16217"],
    "Coolspring": ["15730"],
    "Coopersburg": ["18036"],
    "Cooperstown": ["16317"],
    "Coplay": ["18037"],
    "Coral": ["15731"],
    "Coraopolis": ["15108"],
    "Cornwall": ["17016"],
    "Corry": ["16407"],
    "Corsica": ["15829"],
    "Coudersport": ["16915"],
    "Coulters": ["15028"],
    "Coupon": ["16629"],
    "Covington": ["16917"],
    "Cowanesque": ["16918"],
    "Cowansville": ["16218"],
    "Crabtree": ["15624"],
    "Craley": ["17312"],
    "Cranberry": ["16319"],
    "Cranberry Township": ["16066"],
    "Cranesville": ["16410"],
    "Creamery": ["19430"],
    "Creekside": ["15732"],
    "Creighton": ["15030"],
    "Crescent": ["15046"],
    "Cresco": ["18326"],
    "Cresson": ["16630", "16699"],
    "Cressona": ["17929"],
    "Crosby": ["16724"],
    "Cross Fork": ["17729"],
    "Crown": ["16220"],
    "Croydon": ["19021"],
    "Crucible": ["15325"],
    "Crum Lynne": ["19022"],
    "Crystal Spring": ["15536"],
    "Cuddy": ["15031"],
    "Cumbola": ["17930"],
    "Curllsville": ["16221"],
    "Curryville": ["16631"],
    "Curtisville": ["15032"],
    "Curwensville": ["16833"],
    "Custer City": ["16725"],
    "Cyclone": ["16726"],
    "Dagus Mines": ["15831"],
    "Daisytown": ["15427"],
    "Dallas": ["18612", "18690"],
    "Dallastown": ["17313"],
    "Dalmatia": ["17017"],
    "Dalton": ["18414"],
    "Damascus": ["18415"],
    "Danboro": ["18916"],
    "Danielsville": ["18038"],
    "Danville": ["17821", "17822"],
    "Darby": ["19023"],
    "Darlington": ["16115"],
    "Darragh": ["15625"],
    "Dauphin": ["17018"],
    "Davidsville": ["15928"],
    "Dawson": ["15428"],
    "Dayton": ["16222"],
    "De Lancey": ["15733"],
    "De Young": ["16728"],
    "Defiance": ["16633"],
    "Delano": ["18220"],
    "Delaware Water Gap": ["18327"],
    "Delmont": ["15626"],
    "Delta": ["17314"],
    "Denbo": ["15429"],
    "Denver": ["17517"],
    "Derrick City": ["16727"],
    "Derry": ["15627"],
    "Devault": ["19432"],
    "Devon": ["19333"],
    "Dewart": ["17730"],
    "Dickerson Run": ["15430"],
    "Dilliner": ["15327"],
    "Dillsburg": ["17019"],
    "Dilltown": ["15929"],
    "Dimock": ["18816"],
    "Dingmans Ferry": ["18328"],
    "Distant": ["16223"],
    "Dixonville": ["15734"],
    "Donegal": ["15628"],
    "Donora": ["15033"],
    "Dornsife": ["17823"],
    "Douglassville": ["19518"],
    "Dover": ["17315"],
    "Downingtown": ["19335"],
    "Doylesburg": ["17219"],
    "Doylestown": ["18901", "18902"],
    "Dravosburg": ["15034"],
    "Dresher": ["19025"],
    "Drexel Hill": ["19026"],
    "Drifting": ["16834"],
    "Drifton": ["18221"],
    "Driftwood": ["15832"],
    "Drumore": ["17518"],
    "Drums": ["18222"],
    "Dry Run": ["17220"],
    "Du Bois": ["15801"],
    "Dublin": ["18917"],
    "Dudley": ["16634"],
    "Duke Center": ["16729"],
    "Dunbar": ["15431"],
    "Duncannon": ["17020"],
    "Duncansville": ["16635"],
    "Dunlevy": ["15432"],
    "Dunlo": ["15930"],
    "Duquesne": ["15110"],
    "Durham": ["18039"],
    "Duryea": ["18642"],
    "Dushore": ["18614"],
    "Dysart": ["16636"],
    "Eagles Mere": ["17731"],
    "Eagleville": ["19408", "19415"],
    "Earlington": ["18918"],
    "Earlville": ["19519"],
    "East Berlin": ["17316"],
    "East Brady": ["16028"],
    "East Butler": ["16029"],
    "East Earl": ["17519"],
    "East Freedom": ["16637"],
    "East Greenville": ["18041"],
    "East Hickory": ["16321"],
    "East Mc Keesport": ["15035"],
    "East Millsboro": ["15433"],
    "East Petersburg": ["17520"],
    "East Pittsburgh": ["15112"],
    "East Prospect": ["17317"],
    "East Smethport": ["16730"],
    "East Smithfield": ["18817"],
    "East Springfield": ["16411"],
    "East Stroudsburg": ["18301", "18302"],
    "East Texas": ["18046"],
    "East Vandergrift": ["15629"],
    "East Waterford": ["17021"],
    "Easton": ["18040", "18042", "18043", "18044", "18045"],
    "Eau Claire": ["16030"],
    "Ebensburg": ["15931"],
    "Ebervale": ["18223"],
    "Edgemont": ["19028"],
    "Edinboro": ["16412", "16444"],
    "Edinburg": ["16116"],
    "Effort": ["18330"],
    "Eighty Four": ["15330"],
    "Elco": ["15434"],
    "Elderton": ["15736"],
    "Eldred": ["16731"],
    "Elgin": ["16413"],
    "Elizabeth": ["15037"],
    "Elizabethtown": ["17022"],
    "Elizabethville": ["17023"],
    "Elkins Park": ["19027"],
    "Elkland": ["16920"],
    "Elliottsburg": ["17024"],
    "Ellsworth": ["15331"],
    "Ellwood City": ["16117"],
    "Elm": ["17521"],
    "Elmhurst": ["18416"],
    "Elmora": ["15737"],
    "Elrama": ["15038"],
    "Elton": ["15934"],
    "Elverson": ["19520"],
    "Elysburg": ["17824"],
    "Emeigh": ["15738"],
    "Emigsville": ["17318"],
    "Emlenton": ["16373"],
    "Emmaus": ["18049", "18098", "18099"],
    "Emporium": ["15834"],
    "Endeavor": ["16322"],
    "Enola": ["17025"],
    "Enon Valley": ["16120"],
    "Entriken": ["16638"],
    "Ephrata": ["17522"],
    "Equinunk": ["18417"],
    "Erie": ["16501", "16502", "16503", "16504", "16505", "16506", "16507", "16508", "16509", "16510", "16511", "16512", "16514", "16515", "16522", "16530", "16531", "16532", "16533", "16534", "16538", "16541", "16544", "16546", "16550", "16553", "16554", "16563", "16565"],
    "Ernest": ["15739"],
    "Erwinna": ["18920"],
    "Essington": ["19029"],
    "Etters": ["17319"],
    "Evans City": ["16033"],
    "Everett": ["15537"],
    "Everson": ["15631"],
    "Export": ["15632"],
    "Exton": ["19341"],
    "Factoryville": ["18419"],
    "Fairbank": ["15435"],
    "Fairchance": ["15436"],
    "Fairfield": ["17320"],
    "Fairhope": ["15538"],
    "Fairless Hills": ["19030"],
    "Fairmount City": ["16224"],
    "Fairview": ["16415"],
    "Fairview Village": ["19409"],
    "Fallentimber": ["16639"],
    "Falls": ["18615"],
    "Falls Creek": ["15840"],
    "Fannettsburg": ["17221"],
    "Farmington": ["15437"],
    "Farrell": ["16121"],
    "Fawn Grove": ["17321"],
    "Fayette City": ["15438"],
    "Fayetteville": ["17222"],
    "Feasterville Trevose": ["19053"],
    "Felton": ["17322"],
    "Fenelton": ["16034"],
    "Ferndale": ["18921"],
    "Finleyville": ["15332"],
    "Fisher": ["16225"],
    "Fishertown": ["15539"],
    "Fleetville": ["18420"],
    "Fleetwood": ["19522"],
    "Fleming": ["16835"],
    "Flicksville": ["18050"],
    "Flinton": ["16640"],
    "Flourtown": ["19031"],
    "Fogelsville": ["18051"],
    "Folcroft": ["19032"],
    "Folsom": ["19033"],
    "Fombell": ["16123"],
    "Forbes Road": ["15633"],
    "Force": ["15841"],
    "Ford City": ["16226"],
    "Ford Cliff": ["16228"],
    "Forest City": ["18421"],
    "Forest Grove": ["18922"],
    "Forestville": ["16035"],
    "Forksville": ["18616"],
    "Fort Hill": ["15540"],
    "Fort Littleton": ["17223"],
    "Fort Loudon": ["17224"],
    "Fort Washington": ["19034", "19048", "19049"],
    "Fountainville": ["18923"],
    "Foxburg": ["16036"],
    "Frackville": ["17931", "17932"],
    "Franconia": ["18924"],
    "Franklin": ["16323"],
    "Franklintown": ["17323"],
    "Frederick": ["19435"],
    "Fredericksburg": ["17026"],
    "Fredericktown": ["15333"],
    "Fredonia": ["16124"],
    "Freeburg": ["17827"],
    "Freedom": ["15042"],
    "Freeland": ["18224"],
    "Freeport": ["16229"],
    "Frenchville": ["16836"],
    "Friedens": ["15541"],
    "Friedensburg": ["17933"],
    "Friendsville": ["18818"],
    "Frostburg": ["15740"],
    "Fryburg": ["16326"],
    "Furlong": ["18925"],
    "Gaines": ["16921"],
    "Galeton": ["16922"],
    "Gallitzin": ["16641"],
    "Gans": ["15439"],
    "Gap": ["17527"],
    "Garards Fort": ["15334"],
    "Gardenville": ["18926"],
    "Gardners": ["17324"],
    "Garland": ["16416"],
    "Garnet Valley": ["19060"],
    "Garrett": ["15542"],
    "Gastonville": ["15336"],
    "Geigertown": ["19523"],
    "Genesee": ["16923", "16941"],
    "Georgetown": ["15043"],
    "Germansville": ["18053"],
    "Gettysburg": ["17325", "17326"],
    "Gibbon Glade": ["15440"],
    "Gibson": ["18820"],
    "Gibsonia": ["15044"],
    "Gifford": ["16732"],
    "Gilbert": ["18331"],
    "Gilberton": ["17934"],
    "Gilbertsville": ["19525"],
    "Gillett": ["16925"],
    "Gipsy": ["15741"],
    "Girard": ["16417"],
    "Girardville": ["17935"],
    "Gladwyne": ["19035"],
    "Glasgow": ["16644"],
    "Glassport": ["15045"],
    "Glen Campbell": ["15742"],
    "Glen Hope": ["16645"],
    "Glen Lyon": ["18617"],
    "Glen Mills": ["19342"],
    "Glen Richey": ["16837"],
    "Glen Riddle Lima": ["19037"],
    "Glen Rock": ["17327"],
    "Glenmoore": ["19343"],
    "Glenolden": ["19036"],
    "Glenshaw": ["15116"],
    "Glenside": ["19038"],
    "Glenville": ["17329"],
    "Goodville": ["17528"],
    "Gordon": ["17936"],
    "Gordonville": ["17529"],
    "Gouldsboro": ["18424"],
    "Gradyville": ["19039"],
    "Grampian": ["16838"],
    "Grand Valley": ["16420"],
    "Grantham": ["17027"],
    "Grantville": ["17028"],
    "Granville": ["17029"],
    "Granville Summit": ["16926"],
    "Grapeville": ["15634"],
    "Grassflat": ["16839"],
    "Gratz": ["17030"],
    "Gray": ["15544"],
    "Graysville": ["15337"],
    "Great Bend": ["18821"],
    "Greeley": ["18425"],
    "Green Lane": ["18054"],
    "Greencastle": ["17225"],
    "Greenock": ["15047"],
    "Greensboro": ["15338"],
    "Greensburg": ["15601", "15605", "15606"],
    "Greentown": ["18426"],
    "Greenville": ["16125"],
    "Grindstone": ["15442"],
    "Grove City": ["16127"],
    "Grover": ["17735"],
    "Guys Mills": ["16327"],
    "Gwynedd": ["19436"],
    "Gwynedd Valley": ["19437"],
    "Hadley": ["16130"],
    "Halifax": ["17032"],
    "Hallstead": ["18822"],
    "Hamburg": ["19526"],
    "Hamilton": ["15744"],
    "Hamlin": ["18427"],
    "Hannastown": ["15635"],
    "Hanover": ["17331", "17332", "17333", "17334", "17335"],
    "Harborcreek": ["16421"],
    "Harford": ["18823"],
    "Harleigh": ["18225"],
    "Harleysville": ["19438", "19441"],
    "Harmonsburg": ["16422"],
    "Harmony": ["16037"],
    "Harrisburg": ["17101", "17102", "17103", "17104", "17105", "17106", "17107", "17108", "17109", "17110", "17111", "17112", "17113", "17120", "17121", "17122", "17123", "17124", "17125", "17126", "17127", "17128", "17129", "17130", "17140", "17177"],
    "Harrison City": ["15636"],
    "Harrison Valley": ["16927"],
    "Harrisonville": ["17228"],
    "Harrisville": ["16038"],
    "Hartleton": ["17829"],
    "Hartstown": ["16131"],
    "Harveys Lake": ["18618"],
    "Harwick": ["15049"],
    "Hastings": ["16646"],
    "Hatboro": ["19040"],
    "Hatfield": ["19440"],
    "Haverford": ["19041"],
    "Havertown": ["19083"],
    "Hawk Run": ["16840"],
    "Hawley": ["18428"],
    "Hawthorn": ["16230"],
    "Hazel Hurst": ["16733"],
    "Hazleton": ["18201", "18202"],
    "Hegins": ["17938"],
    "Heilwood": ["15745"],
    "Hellertown": ["18055"],
    "Hendersonville": ["15339"],
    "Henryville": ["18332"],
    "Hereford": ["18056"],
    "Herman": ["16039"],
    "Herminie": ["15637"],
    "Hermitage": ["16148"],
    "Herndon": ["17830"],
    "Herrick Center": ["18430"],
    "Hershey": ["17033"],
    "Hesston": ["16647"],
    "Hibbs": ["15443"],
    "Hickory": ["15340"],
    "Hidden Valley": ["15502"],
    "Highspire": ["17034"],
    "Hiller": ["15444"],
    "Hilliards": ["16040"],
    "Hillsdale": ["15746"],
    "Hillsgrove": ["18619"],
    "Hillsville": ["16132"],
    "Hilltown": ["18927"],
    "Holbrook": ["15341"],
    "Holicong": ["18928"],
    "Hollidaysburg": ["16648"],
    "Hollsopple": ["15935"],
    "Holmes": ["19043", "19098"],
    "Holtwood": ["17532"],
    "Home": ["15747"],
    "Homer City": ["15748"],
    "Homestead": ["15120"],
    "Honesdale": ["18431"],
    "Honey Brook": ["19344"],
    "Honey Grove": ["17035"],
    "Hookstown": ["15050"],
    "Hooversville": ["15936"],
    "Hop Bottom": ["18824"],
    "Hopeland": ["17533"],
    "Hopewell": ["16650"],
    "Hopwood": ["15445"],
    "Horsham": ["19044"],
    "Hostetter": ["15638"],
    "Houston": ["15342"],
    "Houtzdale": ["16651", "16698"],
    "Howard": ["16841"],
    "Hughesville": ["17737"],
    "Hummels Wharf": ["17831"],
    "Hummelstown": ["17036"],
    "Hunker": ["15639"],
    "Hunlock Creek": ["18621"],
    "Huntingdon": ["16652", "16654"],
    "Huntingdon Valley": ["19006"],
    "Huntington Mills": ["18622"],
    "Hustontown": ["17229"],
    "Hutchinson": ["15640"],
    "Hyde": ["16843"],
    "Hyde Park": ["15641"],
    "Hydetown": ["16328"],
    "Hyndman": ["15545"],
    "Ickesburg": ["17037"],
    "Idaville": ["17337"],
    "Imler": ["16655"],
    "Immaculata": ["19345"],
    "Imperial": ["15126"],
    "Indian Head": ["15446"],
    "Indiana": ["15701", "15705"],
    "Indianola": ["15051"],
    "Industry": ["15052"],
    "Ingomar": ["15127"],
    "Intercourse": ["17534"],
    "Irvine": ["16329"],
    "Irvona": ["16656"],
    "Irwin": ["15642"],
    "Isabella": ["15447"],
    "Jackson": ["18825"],
    "Jackson Center": ["16133"],
    "Jacobs Creek": ["15448"],
    "James City": ["16734"],
    "James Creek": ["16657"],
    "Jamestown": ["16134"],
    "Jamison": ["18929"],
    "Jeannette": ["15644"],
    "Jefferson": ["15344"],
    "Jenkintown": ["19046"],
    "Jenners": ["15546"],
    "Jennerstown": ["15547"],
    "Jermyn": ["18433"],
    "Jerome": ["15937"],
    "Jersey Mills": ["17739"],
    "Jersey Shore": ["17740"],
    "Jessup": ["18434"],
    "Jim Thorpe": ["18229"],
    "Joffre": ["15053"],
    "Johnsonburg": ["15845"],
    "Johnstown": ["15901", "15902", "15904", "15905", "15906", "15907", "15909", "15915"],
    "Jones Mills": ["15646"],
    "Jonestown": ["17038"],
    "Josephine": ["15750"],
    "Julian": ["16844"],
    "Junedale": ["18230"],
    "Kane": ["16735"],
    "Kantner": ["15548"],
    "Karns City": ["16041"],
    "Karthaus": ["16845"],
    "Keisterville": ["15449"],
    "Kelayres": ["18231"],
    "Kelton": ["19346"],
    "Kemblesville": ["19347"],
    "Kempton": ["19529"],
    "Kennerdell": ["16374"],
    "Kennett Square": ["19348"],
    "Kent": ["15752"],
    "Kersey": ["15846"],
    "Kimberton": ["19442"],
    "King Of Prussia": ["19406", "19487"],
    "Kingsley": ["18826"],
    "Kingston": ["18704"],
    "Kintnersville": ["18930"],
    "Kinzers": ["17535"],
    "Kirkwood": ["17536"],
    "Kittanning": ["16201", "16215"],
    "Kleinfeltersville": ["17039"],
    "Klingerstown": ["17941"],
    "Knox": ["16232"],
    "Knox Dale": ["15847"],
    "Knoxville": ["16928"],
    "Koppel": ["16136"],
    "Kossuth": ["16331"],
    "Kreamer": ["17833"],
    "Kresgeville": ["18333"],
    "Kulpmont": ["17834"],
    "Kulpsville": ["19443"],
    "Kunkletown": ["18058"],
    "Kutztown": ["19530"],
    "Kylertown": ["16847"],
    "La Belle": ["15450"],
    "La Jose": ["15753"],
    "La Plume": ["18440"],
    "Laceyville": ["18623"],
    "Lackawaxen": ["18435"],
    "Lafayette Hill": ["19444"],
    "Lahaska": ["18931"],
    "Lairdsville": ["17742"],
    "Lake Ariel": ["18436"],
    "Lake City": ["16423"],
    "Lake Como": ["18437"],
    "Lake Harmony": ["18624"],
    "Lake Lynn": ["15451"],
    "Lake Winola": ["18625"],
    "Lakeville": ["18438"],
    "Lakewood": ["18439"],
    "Lamar": ["16848"],
    "Lamartine": ["16375"],
    "Lampeter": ["17537"],
    "Lancaster": ["17573", "17601", "17602", "17603", "17604", "17605", "17606", "17607", "17608", "17611", "17622", "17699"],
    "Landenberg": ["19350"],
    "Landingville": ["17942"],
    "Landisburg": ["17040"],
    "Landisville": ["17538"],
    "Lanesboro": ["18827"],
    "Langeloth": ["15054"],
    "Langhorne": ["19047"],
    "Lansdale": ["19446"],
    "Lansdowne": ["19050"],
    "Lanse": ["16849"],
    "Lansford": ["18232"],
    "Laporte": ["18626"],
    "Larimer": ["15647"],
    "Latrobe": ["15650"],
    "Lattimer Mines": ["18234"],
    "Laughlintown": ["15655"],
    "Laurelton": ["17835"],
    "Laurys Station": ["18059"],
    "Lavelle": ["17943"],
    "Lawn": ["17041"],
    "Lawrence": ["15055"],
    "Lawrenceville": ["16929"],
    "Lawton": ["18828"],
    "Le Raysville": ["18829"],
    "Lebanon": ["17042", "17046", "17091"],
    "Leck Kill": ["17836"],
    "Leckrone": ["15454"],
    "Lecontes Mills": ["16850"],
    "Lederach": ["19450"],
    "Leechburg": ["15656"],
    "Leeper": ["16233"],
    "Leesport": ["19533"],
    "Leetsdale": ["15056"],
    "Lehigh Valley": ["18001", "18002", "18003"],
    "Lehighton": ["18235"],
    "Lehman": ["18627"],
    "Leisenring": ["15455"],
    "Lemasters": ["17231"],
    "Lemont": ["16851"],
    "Lemont Furnace": ["15456"],
    "Lemoyne": ["17043"],
    "Lenhartsville": ["19534"],
    "Lenni": ["19052"],
    "Lenoxville": ["18441"],
    "Leola": ["17540"],
    "Levittown": ["19054", "19055", "19056", "19057", "19058"],
    "Lewis Run": ["16738"],
    "Lewisberry": ["17339"],
    "Lewisburg": ["17837"],
    "Lewistown": ["17044"],
    "Lewisville": ["19351"],
    "Liberty": ["16930"],
    "Lickingville": ["16332"],
    "Lightstreet": ["17839"],
    "Ligonier": ["15658"],
    "Lilly": ["15938"],
    "Limekiln": ["19535"],
    "Limeport": ["18060"],
    "Limestone": ["16234"],
    "Lincoln University": ["19352"],
    "Linden": ["17744"],
    "Line Lexington": ["18932"],
    "Linesville": ["16424"],
    "Lionville": ["19353"],
    "Listie": ["15549"],
    "Lititz": ["17543"],
    "Little Meadows": ["18830"],
    "Littlestown": ["17340"],
    "Liverpool": ["17045"],
    "Llewellyn": ["17944"],
    "Lock Haven": ["17745"],
    "Locust Gap": ["17840"],
    "Locustdale": ["17945"],
    "Loganton": ["17747"],
    "Loganville": ["17342"],
    "Long Pond": ["18334"],
    "Lopez": ["18628"],
    "Loretto": ["15940"],
    "Lost Creek": ["17946"],
    "Lowber": ["15660"],
    "Loyalhanna": ["15661"],
    "Loysburg": ["16659"],
    "Loysville": ["17047"],
    "Lucernemines": ["15754"],
    "Lucinda": ["16235"],
    "Ludlow": ["16333"],
    "Lumberville": ["18933"],
    "Lurgan": ["17232"],
    "Luthersburg": ["15848"],
    "Luxor": ["15662"],
    "Luzerne": ["18709"],
    "Lykens": ["17048"],
    "Lyndell": ["19354"],
    "Lyndora": ["16045"],
    "Lyon Station": ["19536"],
    "Mackeyville": ["17750"],
    "Macungie": ["18062"],
    "Madera": ["16661"],
    "Madison": ["15663"],
    "Madisonburg": ["16852"],
    "Mahaffey": ["15757"],
    "Mahanoy City": ["17948"],
    "Mahanoy Plane": ["17949"],
    "Mainesburg": ["16932"],
    "Mainland": ["19451"],
    "Malvern": ["19355"],
    "Mammoth": ["15664"],
    "Manchester": ["17345"],
    "Manheim": ["17545"],
    "Manns Choice": ["15550"],
    "Manor": ["15665"],
    "Manorville": ["16238"],
    "Mansfield": ["16933"],
    "Mapleton Depot": ["17052"],
    "Mar Lin": ["17951"],
    "Marble": ["16334"],
    "Marchand": ["15758"],
    "Marcus Hook": ["19061"],
    "Marianna": ["15345"],
    "Marienville": ["16239"],
    "Marietta": ["17547"],
    "Marion": ["17235"],
    "Marion Center": ["15759"],
    "Marion Heights": ["17832"],
    "Markleton": ["15551"],
    "Markleysburg": ["15459"],
    "Mars": ["16046"],
    "Marshalls Creek": ["18335"],
    "Marsteller": ["15760"],
    "Martin": ["15460"],
    "Martindale": ["17549"],
    "Martins Creek": ["18063"],
    "Martinsburg": ["16662"],
    "Mary D": ["17952"],
    "Marysville": ["17053"],
    "Masontown": ["15461"],
    "Matamoras": ["18336"],
    "Mather": ["15346"],
    "Mattawana": ["17054"],
    "Maxatawny": ["19538"],
    "Mayport": ["16240"],
    "Maytown": ["17550"],
    "Mc Alisterville": ["17049"],
    "Mc Clellandtown": ["15458"],
    "Mc Clure": ["17841"],
    "Mc Connellsburg": ["17233"],
    "Mc Connellstown": ["16660"],
    "Mc Donald": ["15057"],
    "Mc Elhattan": ["17748"],
    "Mc Ewensville": ["17749"],
    "Mc Grann": ["16236"],
    "Mc Intyre": ["15756"],
    "Mc Kean": ["16426"],
    "Mc Kees Rocks": ["15136"],
    "Mc Knightstown": ["17343"],
    "Mc Sherrystown": ["17344"],
    "Mc Veytown": ["17051"],
    "Mcadoo": ["18237"],
    "Mckeesport": ["15131", "15132", "15133", "15134", "15135"],
    "Meadow Lands": ["15347"],
    "Meadville": ["16335", "16388"],
    "Mechanicsburg": ["17050", "17055"],
    "Mechanicsville": ["18934"],
    "Media": ["19063", "19065", "19091"],
    "Mehoopany": ["18629"],
    "Melcroft": ["15462"],
    "Mendenhall": ["19357"],
    "Mentcle": ["15761"],
    "Mercer": ["16137"],
    "Mercersburg": ["17236"],
    "Merion Station": ["19066"],
    "Merrittstown": ["15463"],
    "Mertztown": ["19539"],
    "Meshoppen": ["18630"],
    "Mexico": ["17056"],
    "Meyersdale": ["15552"],
    "Middleburg": ["17842"],
    "Middlebury Center": ["16935"],
    "Middleport": ["17953"],
    "Middletown": ["17057"],
    "Midland": ["15059"],
    "Midway": ["15060"],
    "Mifflin": ["17058"],
    "Mifflinburg": ["17844"],
    "Mifflintown": ["17059"],
    "Mifflinville": ["18631"],
    "Milan": ["18831"],
    "Milanville": ["18443"],
    "Mildred": ["18632"],
    "Milesburg": ["16853"],
    "Milford": ["18337"],
    "Milford Square": ["18935"],
    "Mill Creek": ["17060"],
    "Mill Hall": ["17751"],
    "Mill Run": ["15464"],
    "Mill Village": ["16427"],
    "Millersburg": ["17061"],
    "Millerstown": ["17062"],
    "Millersville": ["17551"],
    "Millerton": ["16936"],
    "Millheim": ["16854"],
    "Millmont": ["17845"],
    "Millrift": ["18340"],
    "Mills": ["16937"],
    "Millsboro": ["15348"],
    "Millville": ["17846"],
    "Milnesville": ["18239"],
    "Milroy": ["17063"],
    "Milton": ["17847"],
    "Mineral Point": ["15942"],
    "Mineral Springs": ["16855"],
    "Minersville": ["17954"],
    "Mingoville": ["16856"],
    "Minisink Hills": ["18341"],
    "Modena": ["19358"],
    "Mohnton": ["19540"],
    "Mohrsville": ["19541"],
    "Monaca": ["15061"],
    "Monessen": ["15062"],
    "Monocacy Station": ["19542"],
    "Monongahela": ["15063"],
    "Monroeton": ["18832"],
    "Monroeville": ["15146"],
    "Mont Alto": ["17237"],
    "Mont Clare": ["19453"],
    "Montandon": ["17850"],
    "Montgomery": ["17752"],
    "Montgomeryville": ["18936"],
    "Montoursville": ["17754"],
    "Montrose": ["18801"],
    "Moosic": ["18507"],
    "Morann": ["16663"],
    "Morgan": ["15064"],
    "Morgantown": ["19543"],
    "Morris": ["16938"],
    "Morris Run": ["16939"],
    "Morrisdale": ["16858"],
    "Morrisville": ["19067"],
    "Morton": ["19070"],
    "Moscow": ["18444"],
    "Moshannon": ["16859"],
    "Mount Aetna": ["19544"],
    "Mount Bethel": ["18343"],
    "Mount Braddock": ["15465"],
    "Mount Carmel": ["17851"],
    "Mount Gretna": ["17064"],
    "Mount Holly Springs": ["17065"],
    "Mount Jewett": ["16740"],
    "Mount Joy": ["17552"],
    "Mount Morris": ["15349"],
    "Mount Pleasant": ["15666"],
    "Mount Pleasant Mills": ["17853"],
    "Mount Pocono": ["18344"],
    "Mount Union": ["17066"],
    "Mount Wolf": ["17347"],
    "Mountain Top": ["18707"],
    "Mountainhome": ["18342"],
    "Mountville": ["17554"],
    "Muir": ["17957"],
    "Muncy": ["17756"],
    "Muncy Valley": ["17758"],
    "Munson": ["16860"],
    "Murrysville": ["15668"],
    "Muse": ["15350"],
    "Myerstown": ["17067"],
    "Nanticoke": ["18634"],
    "Nanty Glo": ["15943"],
    "Narberth": ["19072"],
    "Narvon": ["17555"],
    "Natrona Heights": ["15065"],
    "Nazareth": ["18064"],
    "Needmore": ["17238"],
    "Neelyton": ["17239"],
    "Neffs": ["18065"],
    "Nelson": ["16940"],
    "Nemacolin": ["15351"],
    "Nescopeck": ["18635"],
    "Nesquehoning": ["18240"],
    "New Albany": ["18833"],
    "New Alexandria": ["15670"],
    "New Baltimore": ["15553"],
    "New Bedford": ["16140"],
    "New Berlin": ["17855"],
    "New Berlinville": ["19545"],
    "New Bethlehem": ["16242"],
    "New Bloomfield": ["17068"],
    "New Brighton": ["15066"],
    "New Buffalo": ["17069"],
    "New Castle": ["16101", "16102", "16103", "16105", "16107", "16108"],
    "New Columbia": ["17856"],
    "New Cumberland": ["17070"],
    "New Derry": ["15671"],
    "New Eagle": ["15067"],
    "New Enterprise": ["16664"],
    "New Florence": ["15944"],
    "New Freedom": ["17349"],
    "New Freeport": ["15352"],
    "New Galilee": ["16141"],
    "New Geneva": ["15467"],
    "New Germantown": ["17071"],
    "New Holland": ["17557"],
    "New Hope": ["18938"],
    "New Kensington": ["15068", "15069"],
    "New Kingstown": ["17072"],
    "New London": ["19360"],
    "New Milford": ["18834"],
    "New Millport": ["16861"],
    "New Oxford": ["17350"],
    "New Paris": ["15554"],
    "New Park": ["17352"],
    "New Philadelphia": ["17959"],
    "New Providence": ["17560"],
    "New Ringgold": ["17960"],
    "New Salem": ["15468"],
    "New Stanton": ["15672"],
    "New Tripoli": ["18066"],
    "New Wilmington": ["16142", "16172"],
    "Newburg": ["17240"],
    "Newell": ["15466"],
    "Newfoundland": ["18445"],
    "Newmanstown": ["17073"],
    "Newport": ["17074"],
    "Newry": ["16665"],
    "Newton Hamilton": ["17075"],
    "Newtown": ["18940"],
    "Newtown Square": ["19073"],
    "Newville": ["17241"],
    "Nicholson": ["18446"],
    "Nicktown": ["15762"],
    "Nineveh": ["15353"],
    "Normalville": ["15469"],
    "Norristown": ["19401", "19403", "19404", "19488", "19489"],
    "North Apollo": ["15673"],
    "North Bend": ["17738", "17760"],
    "North East": ["16428"],
    "North Springfield": ["16430"],
    "North Versailles": ["15137"],
    "North Wales": ["19454", "19455"],
    "North Washington": ["16048"],
    "Northampton": ["18067"],
    "Northern Cambria": ["15714"],
    "Northpoint": ["15763"],
    "Northumberland": ["17857"],
    "Norvelt": ["15674"],
    "Norwood": ["19074"],
    "Nottingham": ["19362"],
    "Noxen": ["18636"],
    "Nu Mine": ["16244"],
    "Numidia": ["17858"],
    "Nuremberg": ["18241"],
    "Oak Ridge": ["16245"],
    "Oakdale": ["15071"],
    "Oakland Mills": ["17076"],
    "Oakmont": ["15139"],
    "Oaks": ["19456"],
    "Ohiopyle": ["15470"],
    "Oil City": ["16301"],
    "Olanta": ["16863"],
    "Old Forge": ["18518"],
    "Old Zionsville": ["18068"],
    "Oley": ["19547"],
    "Oliveburg": ["15764"],
    "Oliver": ["15472"],
    "Olyphant": ["18447", "18448"],
    "Oneida": ["18242"],
    "Ono": ["17077"],
    "Orangeville": ["17859"],
    "Orbisonia": ["17243"],
    "Orefield": ["18069"],
    "Oreland": ["19075"],
    "Orrstown": ["17244"],
    "Orrtanna": ["17353"],
    "Orson": ["18449"],
    "Orviston": ["16864"],
    "Orwigsburg": ["17961"],
    "Osceola": ["16942"],
    "Osceola Mills": ["16666"],
    "Osterburg": ["16667"],
    "Ottsville": ["18942"],
    "Oxford": ["19363"],
    "Palm": ["18070"],
    "Palmerton": ["18071"],
    "Palmyra": ["17078"],
    "Paoli": ["19301"],
    "Paradise": ["17562"],
    "Parker": ["16049"],
    "Parker Ford": ["19457"],
    "Parkesburg": ["19365"],
    "Parkhill": ["15945"],
    "Parryville": ["18244"],
    "Patton": ["16668"],
    "Paupack": ["18451"],
    "Paxinos": ["17860"],
    "Paxtonville": ["17861"],
    "Peach Bottom": ["17563"],
    "Peach Glen": ["17375"],
    "Peckville": ["18452"],
    "Pen Argyl": ["18072"],
    "Penfield": ["15849"],
    "Penn": ["15675"],
    "Penn Run": ["15765"],
    "Penns Creek": ["17862"],
    "Penns Park": ["18943"],
    "Pennsburg": ["18073"],
    "Pennsylvania Furnace": ["16865"],
    "Penryn": ["17564"],
    "Pequea": ["17565"],
    "Perkasie": ["18944"],
    "Perkiomenville": ["18074"],
    "Perryopolis": ["15473"],
    "Petersburg": ["16669"],
    "Petrolia": ["16050"],
    "Philadelphia": ["19019", "19092", "19093", "19099", "19101", "19102", "19103", "19104", "19105", "19106", "19107", "19108", "19109", "19110", "19111", "19112", "19113", "19114", "19115", "19116", "19118", "19119", "19120", "19121", "19122", "19123", "19124", "19125", "19126", "19127", "19128", "19129", "19130", "19131", "19132", "19133", "19134", "19135", "19136", "19137", "19138", "19139", "19140", "19141", "19142", "19143", "19144", "19145", "19146", "19147", "19148", "19149", "19150", "19151", "19152", "19153", "19154", "19155", "19160", "19161", "19162", "19170", "19171", "19172", "19173", "19175", "19176", "19177", "19178", "19179", "19181", "19182", "19183", "19184", "19185", "19187", "19188", "19190", "19191", "19192", "19193", "19194", "19195", "19196", "19197", "19244", "19255"],
    "Philipsburg": ["16866"],
    "Phoenixville": ["19460"],
    "Picture Rocks": ["17762"],
    "Pillow": ["17080"],
    "Pine Forge": ["19548"],
    "Pine Grove": ["17963"],
    "Pine Grove Mills": ["16868"],
    "Pineville": ["18946"],
    "Pipersville": ["18947"],
    "Pitcairn": ["15140"],
    "Pitman": ["17964"],
    "Pittsburgh": ["15201", "15202", "15203", "15204", "15205", "15206", "15207", "15208", "15209", "15210", "15211", "15212", "15213", "15214", "15215", "15216", "15217", "15218", "15219", "15220", "15221", "15222", "15223", "15224", "15225", "15226", "15227", "15228", "15229", "15230", "15231", "15232", "15233", "15234", "15235", "15236", "15237", "15238", "15239", "15240", "15241", "15242", "15243", "15244", "15250", "15251", "15252", "15253", "15254", "15255", "15257", "15258", "15259", "15260", "15261", "15262", "15263", "15264", "15265", "15266", "15267", "15268", "15270", "15272", "15273", "15274", "15275", "15276", "15277", "15278", "15279", "15281", "15282", "15283", "15285", "15286", "15288", "15289", "15290", "15295"],
    "Pittsfield": ["16340"],
    "Pittston": ["18640", "18641", "18643"],
    "Plainfield": ["17081"],
    "Pleasant Hall": ["17246"],
    "Pleasant Mount": ["18453"],
    "Pleasant Unity": ["15676"],
    "Pleasantville": ["16341"],
    "Plumsteadville": ["18949"],
    "Plumville": ["16246"],
    "Plymouth": ["18651"],
    "Plymouth Meeting": ["19462"],
    "Pocono Lake": ["18347"],
    "Pocono Lake Preserve": ["18348"],
    "Pocono Manor": ["18349"],
    "Pocono Pines": ["18350"],
    "Pocono Summit": ["18346"],
    "Pocopson": ["19366"],
    "Point Marion": ["15474"],
    "Point Pleasant": ["18950"],
    "Polk": ["16342"],
    "Pomeroy": ["19367"],
    "Port Allegany": ["16743"],
    "Port Carbon": ["17965"],
    "Port Clinton": ["19549"],
    "Port Matilda": ["16870"],
    "Port Royal": ["17082"],
    "Port Trevorton": ["17864"],
    "Portage": ["15946"],
    "Porters Sideling": ["17354"],
    "Portersville": ["16051"],
    "Portland": ["18351"],
    "Pottersdale": ["16871"],
    "Potts Grove": ["17865"],
    "Pottstown": ["19464", "19465"],
    "Pottsville": ["17901"],
    "Poyntelle": ["18454"],
    "Presto": ["15142"],
    "Preston Park": ["18455"],
    "Pricedale": ["15072"],
    "Prompton": ["18456"],
    "Prospect": ["16052"],
    "Prospect Park": ["19076"],
    "Prosperity": ["15329"],
    "Pulaski": ["16143"],
    "Punxsutawney": ["15767"],
    "Quakake": ["18245"],
    "Quakertown": ["18951"],
    "Quarryville": ["17566"],
    "Quecreek": ["15555"],
    "Queen": ["16670"],
    "Quentin": ["17083"],
    "Quincy": ["17247"],
    "Railroad": ["17355"],
    "Ralston": ["17763"],
    "Ramey": ["16671"],
    "Ransom": ["18653"],
    "Ravine": ["17966"],
    "Reading": ["19601", "19602", "19603", "19604", "19605", "19606", "19607", "19608", "19609", "19610", "19611", "19612", "19640"],
    "Reamstown": ["17567"],
    "Rebersburg": ["16872"],
    "Rebuck": ["17867"],
    "Rector": ["15677"],
    "Red Hill": ["18076"],
    "Red Lion": ["17356"],
    "Reeders": ["18352"],
    "Reedsville": ["17084"],
    "Refton": ["17568"],
    "Rehrersburg": ["19550"],
    "Reinholds": ["17569"],
    "Renfrew": ["16053"],
    "Reno": ["16343"],
    "Renovo": ["17764"],
    "Republic": ["15475"],
    "Revere": ["18953"],
    "Revloc": ["15948"],
    "Rew": ["16744"],
    "Rexmont": ["17085"],
    "Reynoldsville": ["15851"],
    "Rheems": ["17570"],
    "Rices Landing": ["15357"],
    "Riceville": ["16432"],
    "Richboro": ["18954"],
    "Richeyville": ["15358"],
    "Richfield": ["17086"],
    "Richland": ["17087"],
    "Richlandtown": ["18955"],
    "Riddlesburg": ["16672"],
    "Ridgway": ["15853"],
    "Ridley Park": ["19078"],
    "Riegelsville": ["18077"],
    "Rillton": ["15678"],
    "Rimersburg": ["16248"],
    "Ringgold": ["15770"],
    "Ringtown": ["17967"],
    "Riverside": ["17868"],
    "Rixford": ["16745"],
    "Roaring Branch": ["17765"],
    "Roaring Spring": ["16673"],
    "Robertsdale": ["16674"],
    "Robesonia": ["19551"],
    "Robinson": ["15949"],
    "Rochester": ["15074"],
    "Rochester Mills": ["15771"],
    "Rock Glen": ["18246"],
    "Rockhill Furnace": ["17249"],
    "Rockton": ["15856"],
    "Rockwood": ["15557"],
    "Rogersville": ["15359"],
    "Rome": ["18837"],
    "Ronco": ["15476"],
    "Ronks": ["17572"],
    "Roscoe": ["15477"],
    "Rossiter": ["15772"],
    "Rossville": ["17358"],
    "Roulette": ["16746"],
    "Rouseville": ["16344"],
    "Rouzerville": ["17250"],
    "Rowland": ["18457"],
    "Roxbury": ["17251"],
    "Royersford": ["19468"],
    "Ruffs Dale": ["15679"],
    "Rural Ridge": ["15075"],
    "Rural Valley": ["16249"],
    "Rushland": ["18956"],
    "Russell": ["16345"],
    "Russellton": ["15076"],
    "Sabinsville": ["16943"],
    "Sacramento": ["17968"],
    "Sadsburyville": ["19369"],
    "Saegertown": ["16433"],
    "Sagamore": ["16250"],
    "Saint Benedict": ["15773"],
    "Saint Boniface": ["16675"],
    "Saint Clair": ["17970"],
    "Saint Johns": ["18247"],
    "Saint Marys": ["15857"],
    "Saint Michael": ["15951"],
    "Saint Peters": ["19470"],
    "Saint Petersburg": ["16054"],
    "Saint Thomas": ["17252"],
    "Salford": ["18957"],
    "Salfordville": ["18958"],
    "Salina": ["15680"],
    "Salisbury": ["15558"],
    "Salix": ["15952"],
    "Salona": ["17767"],
    "Saltillo": ["17253"],
    "Saltsburg": ["15681"],
    "Sandy Lake": ["16145"],
    "Sandy Ridge": ["16677"],
    "Sarver": ["16055"],
    "Sassamansville": ["19472"],
    "Saxonburg": ["16056"],
    "Saxton": ["16678"],
    "Saylorsburg": ["18353"],
    "Sayre": ["18840"],
    "Scenery Hill": ["15360"],
    "Schaefferstown": ["17088"],
    "Schellsburg": ["15559"],
    "Schenley": ["15682"],
    "Schnecksville": ["18078"],
    "Schuylkill Haven": ["17972"],
    "Schwenksville": ["19473"],
    "Sciota": ["18354"],
    "Scotland": ["17254"],
    "Scotrun": ["18355"],
    "Scottdale": ["15683"],
    "Scranton": ["18501", "18502", "18503", "18504", "18505", "18508", "18509", "18510", "18512", "18514", "18515", "18519", "18522", "18540", "18577"],
    "Seanor": ["15953"],
    "Selinsgrove": ["17870"],
    "Sellersville": ["18960"],
    "Seltzer": ["17974"],
    "Seminole": ["16253"],
    "Seneca": ["16346"],
    "Seven Valleys": ["17360"],
    "Seward": ["15954"],
    "Sewickley": ["15143"],
    "Shade Gap": ["17255"],
    "Shady Grove": ["17256"],
    "Shamokin": ["17872"],
    "Shamokin Dam": ["17876"],
    "Shanksville": ["15560"],
    "Sharon": ["16146"],
    "Sharon Hill": ["19079"],
    "Sharpsville": ["16150"],
    "Shartlesville": ["19554"],
    "Shavertown": ["18708"],
    "Shawanese": ["18654"],
    "Shawnee On Delaware": ["18356"],
    "Shawville": ["16873"],
    "Sheakleyville": ["16151"],
    "Sheffield": ["16347"],
    "Shelocta": ["15774"],
    "Shenandoah": ["17976"],
    "Sheppton": ["18248"],
    "Shermans Dale": ["17090"],
    "Shickshinny": ["18655"],
    "Shinglehouse": ["16748"],
    "Shippensburg": ["17257"],
    "Shippenville": ["16254"],
    "Shippingport": ["15077"],
    "Shirleysburg": ["17260"],
    "Shoemakersville": ["19555"],
    "Shohola": ["18458"],
    "Shrewsbury": ["17361"],
    "Shunk": ["17768"],
    "Sidman": ["15955"],
    "Sigel": ["15860"],
    "Silver Spring": ["17575"],
    "Silverdale": ["18962"],
    "Sinnamahoning": ["15861"],
    "Sipesville": ["15561"],
    "Six Mile Run": ["16679"],
    "Skippack": ["19474"],
    "Skytop": ["18357"],
    "Slate Run": ["17769"],
    "Slatedale": ["18079"],
    "Slatington": ["18080"],
    "Slickville": ["15684"],
    "Sligo": ["16255"],
    "Slippery Rock": ["16057"],
    "Slovan": ["15078"],
    "Smethport": ["16749"],
    "Smicksburg": ["16256"],
    "Smithfield": ["15478"],
    "Smithmill": ["16680"],
    "Smithton": ["15479"],
    "Smock": ["15480"],
    "Smokerun": ["16681"],
    "Smoketown": ["17576"],
    "Snow Shoe": ["16874"],
    "Snydersburg": ["16257"],
    "Snydertown": ["17877"],
    "Solebury": ["18963"],
    "Somerset": ["15501", "15510"],
    "Souderton": ["18964"],
    "South Canaan": ["18459"],
    "South Fork": ["15956"],
    "South Gibson": ["18842"],
    "South Heights": ["15081"],
    "South Montrose": ["18843"],
    "South Mountain": ["17261"],
    "South Park": ["15129"],
    "South Sterling": ["18460"],
    "Southampton": ["18966"],
    "Southeastern": ["19397", "19398", "19399"],
    "Southview": ["15361"],
    "Southwest": ["15685"],
    "Spangler": ["15775"],
    "Spartansburg": ["16434"],
    "Spinnerstown": ["18968"],
    "Spraggs": ["15362"],
    "Sprankle Mills": ["15776"],
    "Spring Church": ["15686"],
    "Spring City": ["19475"],
    "Spring Creek": ["16436"],
    "Spring Glen": ["17978"],
    "Spring Grove": ["17362"],
    "Spring House": ["19477"],
    "Spring Mills": ["16875"],
    "Spring Mount": ["19478"],
    "Spring Run": ["17262"],
    "Springboro": ["16435"],
    "Springdale": ["15144"],
    "Springfield": ["19064"],
    "Springs": ["15562"],
    "Springtown": ["18081"],
    "Springville": ["18844"],
    "Sproul": ["16682"],
    "Spruce Creek": ["16683"],
    "Stahlstown": ["15687"],
    "Star Junction": ["15482"],
    "Starford": ["15777"],
    "Starlight": ["18461"],
    "Starrucca": ["18462"],
    "State College": ["16801", "16803", "16804", "16805"],
    "State Line": ["17263"],
    "Sterling": ["18463"],
    "Stevens": ["17578"],
    "Stevensville": ["18845"],
    "Stewartstown": ["17363"],
    "Stillwater": ["17878"],
    "Stockdale": ["15483"],
    "Stockertown": ["18083"],
    "Stoneboro": ["16153"],
    "Stoystown": ["15563"],
    "Strabane": ["15363"],
    "Strasburg": ["17579"],
    "Strattanville": ["16258"],
    "Strausstown": ["19559"],
    "Strongstown": ["15957"],
    "Stroudsburg": ["18360"],
    "Stump Creek": ["15863"],
    "Sturgeon": ["15082"],
    "Sugar Grove": ["16350"],
    "Sugar Run": ["18846"],
    "Sugarloaf": ["18249"],
    "Summerdale": ["17093"],
    "Summerhill": ["15958"],
    "Summerville": ["15864"],
    "Summit Hill": ["18250"],
    "Summit Station": ["17979"],
    "Sumneytown": ["18084"],
    "Sunbury": ["17801"],
    "Suplee": ["19371"],
    "Susquehanna": ["18847"],
    "Sutersville": ["15083"],
    "Swarthmore": ["19081"],
    "Sweet Valley": ["18656"],
    "Swengel": ["17880"],
    "Swiftwater": ["18370"],
    "Sybertsville": ["18251"],
    "Sycamore": ["15364"],
    "Sykesville": ["15865"],
    "Sylvania": ["16945"],
    "Tafton": ["18464"],
    "Talmage": ["17580"],
    "Tamaqua": ["18252"],
    "Tamiment": ["18371"],
    "Tannersville": ["18372"],
    "Tarentum": ["15084"],
    "Tarrs": ["15688"],
    "Tatamy": ["18085"],
    "Taylor": ["18517"],
    "Taylorstown": ["15365"],
    "Telford": ["18969"],
    "Temple": ["19560"],
    "Templeton": ["16259"],
    "Terre Hill": ["17581"],
    "Thomasville": ["17364"],
    "Thompson": ["18465"],
    "Thompsontown": ["17094"],
    "Thorndale": ["19372"],
    "Thornton": ["19373"],
    "Three Springs": ["17264"],
    "Tidioute": ["16351"],
    "Timblin": ["15778"],
    "Tioga": ["16946"],
    "Tiona": ["16352"],
    "Tionesta": ["16353"],
    "Tipton": ["16684"],
    "Tire Hill": ["15959"],
    "Titusville": ["16354"],
    "Tobyhanna": ["18466"],
    "Todd": ["16685"],
    "Topton": ["19562"],
    "Torrance": ["15779"],
    "Toughkenamon": ["19374"],
    "Towanda": ["18848"],
    "Tower City": ["17980"],
    "Townville": ["16360"],
    "Trafford": ["15085"],
    "Transfer": ["16154"],
    "Treichlers": ["18086"],
    "Tremont": ["17981"],
    "Tresckow": ["18254"],
    "Trevorton": ["17881"],
    "Trexlertown": ["18087"],
    "Trout Run": ["17771"],
    "Troutville": ["15866"],
    "Troxelville": ["17882"],
    "Troy": ["16947"],
    "Trumbauersville": ["18970"],
    "Tunkhannock": ["18657"],
    "Turbotville": ["17772"],
    "Turkey City": ["16058"],
    "Turtle Creek": ["15145"],
    "Turtlepoint": ["16750"],
    "Tuscarora": ["17982"],
    "Twin Rocks": ["15960"],
    "Tyler Hill": ["18469"],
    "Tylersburg": ["16361"],
    "Tylersport": ["18971"],
    "Tylersville": ["17773"],
    "Tyrone": ["16686"],
    "Uledi": ["15484"],
    "Ulster": ["18850"],
    "Ulysses": ["16948"],
    "Union City": ["16438"],
    "Union Dale": ["18470"],
    "Uniontown": ["15401"],
    "Unionville": ["19375"],
    "United": ["15689"],
    "Unity House": ["18373"],
    "Unityville": ["17774"],
    "University Park": ["16802"],
    "Upper Black Eddy": ["18972"],
    "Upper Darby": ["19082"],
    "Upperstrasburg": ["17265"],
    "Ursina": ["15485"],
    "Utica": ["16362"],
    "Uwchland": ["19480"],
    "Valencia": ["16059"],
    "Valier": ["15780"],
    "Valley Forge": ["19481", "19482", "19483", "19484", "19485", "19493", "19494", "19495", "19496"],
    "Valley View": ["17983"],
    "Van Voorhis": ["15366"],
    "Vanderbilt": ["15486"],
    "Vandergrift": ["15690"],
    "Venango": ["16440"],
    "Venetia": ["15367"],
    "Venus": ["16364"],
    "Verona": ["15147"],
    "Vestaburg": ["15368"],
    "Vicksburg": ["17883"],
    "Villa Maria": ["16155"],
    "Villanova": ["19085"],
    "Vintondale": ["15961"],
    "Virginville": ["19564"],
    "Volant": ["16156"],
    "Vowinckel": ["16260"],
    "Wagontown": ["19376"],
    "Wallaceton": ["16876"],
    "Wallingford": ["19086"],
    "Walnut Bottom": ["17266"],
    "Walnutport": ["18088"],
    "Walston": ["15781"],
    "Waltersburg": ["15488"],
    "Wampum": ["16157"],
    "Wapwallopen": ["18660"],
    "Warfordsburg": ["17267"],
    "Warminster": ["18974", "18991"],
    "Warren": ["16365", "16366", "16367", "16368", "16369"],
    "Warren Center": ["18851"],
    "Warrendale": ["15086", "15095", "15096"],
    "Warrington": ["18976"],
    "Warriors Mark": ["16877"],
    "Washington": ["15301"],
    "Washington Boro": ["17582"],
    "Washington Crossing": ["18977"],
    "Washingtonville": ["17884"],
    "Waterfall": ["16689"],
    "Waterford": ["16441"],
    "Waterville": ["17776"],
    "Watsontown": ["17777"],
    "Wattsburg": ["16442"],
    "Waverly": ["18471"],
    "Waymart": ["18472"],
    "Wayne": ["19080", "19087", "19088", "19089"],
    "Waynesboro": ["17268"],
    "Waynesburg": ["15370"],
    "Weatherly": ["18255"],
    "Webster": ["15087"],
    "Weedville": ["15868"],
    "Weikert": ["17885"],
    "Wellersburg": ["15564"],
    "Wells Tannery": ["16691"],
    "Wellsboro": ["16901"],
    "Wellsville": ["17365"],
    "Wendel": ["15691"],
    "Wernersville": ["19565"],
    "West Alexander": ["15376"],
    "West Chester": ["19380", "19381", "19382", "19383", "19388"],
    "West Decatur": ["16878"],
    "West Elizabeth": ["15088"],
    "West Finley": ["15377"],
    "West Grove": ["19390"],
    "West Hickory": ["16370"],
    "West Lebanon": ["15783"],
    "West Leisenring": ["15489"],
    "West Middlesex": ["16159"],
    "West Middletown": ["15379"],
    "West Mifflin": ["15122", "15123"],
    "West Milton": ["17886"],
    "West Newton": ["15089"],
    "West Pittsburg": ["16160"],
    "West Point": ["19486"],
    "West Salisbury": ["15565"],
    "West Springfield": ["16443"],
    "West Sunbury": ["16061"],
    "West Willow": ["17583"],
    "Westfield": ["16950"],
    "Westland": ["15378"],
    "Westmoreland City": ["15692"],
    "Weston": ["18256"],
    "Westover": ["16692"],
    "Westport": ["17778"],
    "Westtown": ["19395"],
    "Wexford": ["15090"],
    "Wheatland": ["16161"],
    "White": ["15490"],
    "White Deer": ["17887"],
    "White Haven": ["18661"],
    "White Mills": ["18473"],
    "Whitehall": ["18052"],
    "Whitney": ["15693"],
    "Wickhaven": ["15492"],
    "Wiconisco": ["17097"],
    "Widnoon": ["16261"],
    "Wilburton": ["17888"],
    "Wilcox": ["15870"],
    "Wildwood": ["15091"],
    "Wilkes Barre": ["18701", "18702", "18703", "18705", "18706", "18710", "18711", "18762", "18764", "18765", "18766", "18767", "18769", "18773"],
    "Williamsburg": ["16693"],
    "Williamson": ["17270"],
    "Williamsport": ["17701", "17702", "17703", "17705"],
    "Williamstown": ["17098"],
    "Willow Grove": ["19090"],
    "Willow Hill": ["17271"],
    "Willow Street": ["17584"],
    "Wilmerding": ["15148"],
    "Wilmore": ["15962"],
    "Winburne": ["16879"],
    "Wind Gap": ["18091"],
    "Wind Ridge": ["15380"],
    "Windber": ["15963"],
    "Windsor": ["17366"],
    "Winfield": ["17889"],
    "Witmer": ["17585"],
    "Womelsdorf": ["19567"],
    "Wood": ["16694"],
    "Woodbury": ["16695"],
    "Woodland": ["16881"],
    "Woodlyn": ["19094"],
    "Woodward": ["16882"],
    "Woolrich": ["17779"],
    "Worcester": ["19490"],
    "Worthington": ["16262"],
    "Worthville": ["15784"],
    "Woxall": ["18979"],
    "Wrightsville": ["17368"],
    "Wyalusing": ["18853"],
    "Wyano": ["15695"],
    "Wycombe": ["18980"],
    "Wyncote": ["19095"],
    "Wynnewood": ["19096"],
    "Wyoming": ["18644"],
    "Wysox": ["18854"],
    "Yatesboro": ["16263"],
    "Yeagertown": ["17099"],
    "York": ["17401", "17402", "17403", "17404", "17405", "17406", "17407", "17408", "17415"],
    "York Haven": ["17370"],
    "York New Salem": ["17371"],
    "York Springs": ["17372"],
    "Youngstown": ["15696"],
    "Youngsville": ["16371"],
    "Youngwood": ["15697"],
    "Yukon": ["15698"],
    "Zelienople": ["16063"],
    "Zieglerville": ["19492"],
    "Zion Grove": ["17985"],
    "Zionhill": ["18981"],
    "Zionsville": ["18092"],
    "Zullinger": ["17272"]
  },
  "RI": {
    "Adamsville": ["02801"],
    "Albion": ["02802"],
    "Ashaway": ["02804"],
    "Barrington": ["02806"],
    "Block Island": ["02807"],
    "Bradford": ["02808"],
    "Bristol": ["02809"],
    "Carolina": ["02812"],
    "Central Falls": ["02863"],
    "Charlestown": ["02813"],
    "Chepachet": ["02814"],
    "Clayville": ["02815"],
    "Coventry": ["02816"],
    "Cranston": ["02910", "02920", "02921"],
    "Cumberland": ["02864"],
    "East Greenwich": ["02818"],
    "East Providence": ["02914"],
    "Exeter": ["02822"],
    "Fiskeville": ["02823"],
    "Forestdale": ["02824"],
    "Foster": ["02825"],
    "Glendale": ["02826"],
    "Greene": ["02827"],
    "Greenville": ["02828"],
    "Harmony": ["02829"],
    "Harrisville": ["02830"],
    "Hope": ["02831"],
    "Hope Valley": ["02832"],
    "Hopkinton": ["02833"],
    "Jamestown": ["02835"],
    "Johnston": ["02919"],
    "Kenyon": ["02836"],
    "Kingston": ["02881"],
    "Lincoln": ["02865"],
    "Little Compton": ["02837"],
    "Manville": ["02838"],
    "Mapleville": ["02839"],
    "Middletown": ["02842"],
    "Narragansett": ["02882"],
    "Newport": ["02840", "02841"],
    "North Kingstown": ["02852", "02854"],
    "North Providence": ["02911"],
    "North Scituate": ["02857"],
    "North Smithfield": ["02896"],
    "Oakland": ["02858"],
    "Pascoag": ["02859"],
    "Pawtucket": ["02860", "02861", "02862"],
    "Peace Dale": ["02883"],
    "Portsmouth": ["02871"],
    "Providence": ["02901", "02902", "02903", "02904", "02905", "02906", "02907", "02908", "02909", "02912", "02918", "02940"],
    "Prudence Island": ["02872"],
    "Riverside": ["02915"],
    "Rockville": ["02873"],
    "Rumford": ["02916"],
    "Saunderstown": ["02874"],
    "Shannock": ["02875"],
    "Slatersville": ["02876"],
    "Slocum": ["02877"],
    "Smithfield": ["02917"],
    "Tiverton": ["02878"],
    "Wakefield": ["02879", "02880"],
    "Warren": ["02885"],
    "Warwick": ["02886", "02887", "02888", "02889"],
    "West Greenwich": ["02817"],
    "West Kingston": ["02892"],
    "West Warwick": ["02893"],
    "Westerly": ["02891"],
    "Wood River Junction": ["02894"],
    "Woonsocket": ["02895"],
    "Wyoming": ["02898"]
  },
  "SC": {
    "Abbeville": ["29620"],
    "Adams Run": ["29426"],
    "Aiken": ["29801", "29802", "29803", "29804", "29805", "29808"],
    "Alcolu": ["29001"],
    "Allendale": ["29810"],
    "Anderson": ["29621", "29622", "29623", "29624", "29625", "29626"],
    "Andrews": ["29510"],
    "Arcadia": ["29320"],
    "Awendaw": ["29429"],
    "Aynor": ["29511"],
    "Ballentine": ["29002"],
    "Bamberg": ["29003"],
    "Barnwell": ["29812"],
    "Batesburg": ["29006"],
    "Bath": ["29816"],
    "Beaufort": ["29901", "29902", "29903", "29904", "29906", "29907"],
    "Beech Island": ["29842"],
    "Belton": ["29627"],
    "Bennettsville": ["29512"],
    "Bethera": ["29430"],
    "Bethune": ["29009"],
    "Bishopville": ["29010"],
    "Blacksburg": ["29702"],
    "Blackstock": ["29014"],
    "Blackville": ["29817"],
    "Blair": ["29015"],
    "Blenheim": ["29516"],
    "Bluffton": ["29910"],
    "Blythewood": ["29016"],
    "Boiling Springs": ["29316", "29318"],
    "Bonneau": ["29431"],
    "Bowling Green": ["29703"],
    "Bowman": ["29018"],
    "Bradley": ["29819"],
    "Branchville": ["29432"],
    "Brunson": ["29911"],
    "Buffalo": ["29321"],
    "Cades": ["29518"],
    "Calhoun Falls": ["29628"],
    "Camden": ["29020", "29021"],
    "Cameron": ["29030"],
    "Campobello": ["29322"],
    "Canadys": ["29433"],
    "Carlisle": ["29031"],
    "Cassatt": ["29032"],
    "Catawba": ["29704"],
    "Cayce": ["29033"],
    "Centenary": ["29519"],
    "Central": ["29630"],
    "Chapin": ["29036"],
    "Chappells": ["29037"],
    "Charleston": ["29401", "29402", "29403", "29406", "29407", "29409", "29412", "29413", "29414", "29416", "29417", "29422", "29423", "29424", "29425", "29492"],
    "Charleston AFB": ["29404"],
    "Cheraw": ["29520"],
    "Chesnee": ["29323"],
    "Chester": ["29706"],
    "Chesterfield": ["29709"],
    "Clarks Hill": ["29821"],
    "Clearwater": ["29822"],
    "Clemson": ["29631", "29632", "29633", "29634"],
    "Cleveland": ["29635"],
    "Clifton": ["29324"],
    "Clinton": ["29325"],
    "Clio": ["29525"],
    "Clover": ["29710"],
    "Columbia": ["29201", "29202", "29203", "29204", "29205", "29206", "29207", "29208", "29209", "29210", "29211", "29212", "29214", "29215", "29216", "29217", "29218", "29219", "29220", "29221", "29222", "29223", "29224", "29225", "29226", "29227", "29228", "29229", "29230", "29240", "29250", "29260", "29290", "29292"],
    "Conestee": ["29636"],
    "Converse": ["29329"],
    "Conway": ["29526", "29527", "29528"],
    "Coosawhatchie": ["29912"],
    "Cope": ["29038"],
    "Cordesville": ["29434"],
    "Cordova": ["29039"],
    "Cottageville": ["29435"],
    "Coward": ["29530"],
    "Cowpens": ["29330"],
    "Crocketville": ["29913"],
    "Cross": ["29436"],
    "Cross Anchor": ["29331"],
    "Cross Hill": ["29332"],
    "Dale": ["29914"],
    "Dalzell": ["29040"],
    "Darlington": ["29532", "29540"],
    "Daufuskie Island": ["29915"],
    "Davis Station": ["29041"],
    "Denmark": ["29042"],
    "Dillon": ["29536"],
    "Donalds": ["29638"],
    "Dorchester": ["29437"],
    "Drayton": ["29333"],
    "Due West": ["29639"],
    "Duncan": ["29334", "29390", "29391"],
    "Early Branch": ["29916"],
    "Easley": ["29640", "29641", "29642"],
    "Eastover": ["29044"],
    "Edgefield": ["29824"],
    "Edgemoor": ["29712"],
    "Edisto Island": ["29438"],
    "Effingham": ["29541"],
    "Ehrhardt": ["29081"],
    "Elgin": ["29045"],
    "Elko": ["29826"],
    "Elliott": ["29046"],
    "Elloree": ["29047"],
    "Enoree": ["29335"],
    "Estill": ["29918"],
    "Eutawville": ["29048"],
    "Fair Play": ["29643"],
    "Fairfax": ["29827"],
    "Fairforest": ["29336"],
    "Fingerville": ["29338"],
    "Florence": ["29501", "29502", "29503", "29504", "29505", "29506"],
    "Folly Beach": ["29439"],
    "Fork": ["29543"],
    "Fort Lawn": ["29714"],
    "Fort Mill": ["29707", "29708", "29715", "29716"],
    "Fountain Inn": ["29644"],
    "Furman": ["29921"],
    "Gable": ["29051"],
    "Gadsden": ["29052"],
    "Gaffney": ["29340", "29341", "29342"],
    "Galivants Ferry": ["29544"],
    "Garnett": ["29922"],
    "Gaston": ["29053"],
    "Georgetown": ["29440", "29442"],
    "Gifford": ["29923"],
    "Gilbert": ["29054"],
    "Glendale": ["29346"],
    "Gloverville": ["29828"],
    "Goose Creek": ["29445"],
    "Gramling": ["29348"],
    "Graniteville": ["29829"],
    "Gray Court": ["29645"],
    "Great Falls": ["29055"],
    "Greeleyville": ["29056"],
    "Green Pond": ["29446"],
    "Green Sea": ["29545"],
    "Greenville": ["29601", "29602", "29603", "29604", "29605", "29606", "29607", "29608", "29609", "29610", "29611", "29612", "29613", "29614", "29615", "29616", "29617", "29698"],
    "Greenwood": ["29646", "29647", "29648", "29649"],
    "Greer": ["29650", "29651", "29652"],
    "Gresham": ["29546"],
    "Grover": ["29447"],
    "Hamer": ["29547"],
    "Hampton": ["29924"],
    "Hanahan": ["29410"],
    "Hardeeville": ["29927"],
    "Harleyville": ["29448"],
    "Hartsville": ["29550", "29551"],
    "Heath Springs": ["29058"],
    "Hemingway": ["29554"],
    "Hickory Grove": ["29717"],
    "Hilda": ["29813"],
    "Hilton Head Island": ["29925", "29926", "29928", "29938"],
    "Hodges": ["29653", "29695"],
    "Holly Hill": ["29059"],
    "Hollywood": ["29449"],
    "Honea Path": ["29654"],
    "Hopkins": ["29061"],
    "Horatio": ["29062"],
    "Huger": ["29450"],
    "Inman": ["29349"],
    "Irmo": ["29063"],
    "Islandton": ["29929"],
    "Isle Of Palms": ["29451"],
    "Iva": ["29655"],
    "Jackson": ["29831"],
    "Jacksonboro": ["29452"],
    "Jamestown": ["29453"],
    "Jefferson": ["29718"],
    "Jenkinsville": ["29065"],
    "Joanna": ["29351"],
    "Johns Island": ["29455", "29457"],
    "Johnsonville": ["29555"],
    "Johnston": ["29832"],
    "Jonesville": ["29353", "29395"],
    "Kershaw": ["29067"],
    "Kinards": ["29355"],
    "Kingstree": ["29556"],
    "La France": ["29656"],
    "Ladson": ["29456"],
    "Lake City": ["29560"],
    "Lake View": ["29563"],
    "Lamar": ["29069"],
    "Lancaster": ["29720", "29721", "29722"],
    "Lando": ["29724"],
    "Landrum": ["29356"],
    "Lane": ["29564"],
    "Langley": ["29834"],
    "Latta": ["29565"],
    "Laurens": ["29360"],
    "Leesville": ["29070"],
    "Lexington": ["29071", "29072", "29073"],
    "Liberty": ["29657"],
    "Liberty Hill": ["29074"],
    "Little Mountain": ["29075"],
    "Little River": ["29566"],
    "Little Rock": ["29567"],
    "Lobeco": ["29931"],
    "Lockhart": ["29364"],
    "Lodge": ["29082"],
    "Long Creek": ["29658"],
    "Longs": ["29568"],
    "Loris": ["29569"],
    "Lowndesville": ["29659"],
    "Lugoff": ["29078"],
    "Luray": ["29932"],
    "Lydia": ["29079"],
    "Lyman": ["29365"],
    "Lynchburg": ["29080"],
    "Manning": ["29102"],
    "Marietta": ["29661"],
    "Marion": ["29571"],
    "Martin": ["29836"],
    "Mauldin": ["29662"],
    "Mayesville": ["29104"],
    "Mayo": ["29368"],
    "Mc Bee": ["29101"],
    "Mc Clellanville": ["29458"],
    "Mc Coll": ["29570"],
    "Mc Connells": ["29726"],
    "Mc Cormick": ["29835", "29899"],
    "Miley": ["29933"],
    "Minturn": ["29573"],
    "Modoc": ["29838"],
    "Moncks Corner": ["29461"],
    "Monetta": ["29105"],
    "Montmorenci": ["29839"],
    "Moore": ["29369"],
    "Mount Carmel": ["29840"],
    "Mount Croghan": ["29727"],
    "Mount Pleasant": ["29464", "29465", "29466"],
    "Mountain Rest": ["29664"],
    "Mountville": ["29370"],
    "Mullins": ["29574"],
    "Murrells Inlet": ["29576"],
    "Myrtle Beach": ["29572", "29575", "29577", "29578", "29579", "29587", "29588"],
    "Neeses": ["29107"],
    "Nesmith": ["29580"],
    "New Ellenton": ["29809"],
    "New Zion": ["29111"],
    "Newberry": ["29108"],
    "Newry": ["29665"],
    "Nichols": ["29581"],
    "Ninety Six": ["29666"],
    "Norris": ["29667"],
    "North": ["29112"],
    "North Augusta": ["29841", "29860", "29861"],
    "North Charleston": ["29405", "29415", "29418", "29419", "29420"],
    "North Myrtle Beach": ["29582", "29597", "29598"],
    "Norway": ["29113"],
    "Okatie": ["29909"],
    "Olanta": ["29114"],
    "Olar": ["29843"],
    "Orangeburg": ["29115", "29116", "29117", "29118"],
    "Pacolet": ["29372"],
    "Pacolet Mills": ["29373"],
    "Pageland": ["29728"],
    "Pamplico": ["29583"],
    "Parksville": ["29844"],
    "Parris Island": ["29905"],
    "Patrick": ["29584"],
    "Pauline": ["29374"],
    "Pawleys Island": ["29585"],
    "Peak": ["29122"],
    "Pelion": ["29123"],
    "Pelzer": ["29669"],
    "Pendleton": ["29670"],
    "Pickens": ["29671"],
    "Piedmont": ["29673"],
    "Pineland": ["29934"],
    "Pineville": ["29468"],
    "Pinewood": ["29125"],
    "Pinopolis": ["29469"],
    "Plum Branch": ["29845"],
    "Pomaria": ["29126"],
    "Port Royal": ["29935"],
    "Prosperity": ["29127"],
    "Rains": ["29589"],
    "Ravenel": ["29470"],
    "Reevesville": ["29471"],
    "Reidville": ["29375"],
    "Rembert": ["29128"],
    "Richburg": ["29729"],
    "Richland": ["29675"],
    "Ridge Spring": ["29129"],
    "Ridgeland": ["29936"],
    "Ridgeville": ["29472"],
    "Ridgeway": ["29130"],
    "Rion": ["29132"],
    "Rock Hill": ["29730", "29731", "29732", "29733", "29734"],
    "Roebuck": ["29376"],
    "Round O": ["29474"],
    "Rowesville": ["29133"],
    "Ruby": ["29741"],
    "Ruffin": ["29475"],
    "Russellville": ["29476"],
    "Saint George": ["29477"],
    "Saint Helena Island": ["29920"],
    "Saint Matthews": ["29135"],
    "Saint Stephen": ["29479"],
    "Salem": ["29676"],
    "Salley": ["29137"],
    "Salters": ["29590"],
    "Saluda": ["29138"],
    "Sandy Springs": ["29677"],
    "Santee": ["29142"],
    "Sardinia": ["29143"],
    "Scotia": ["29939"],
    "Scranton": ["29591"],
    "Seabrook": ["29940"],
    "Sellers": ["29592"],
    "Seneca": ["29672", "29678", "29679"],
    "Sharon": ["29742"],
    "Shaw AFB": ["29152"],
    "Sheldon": ["29941"],
    "Silverstreet": ["29145"],
    "Simpsonville": ["29680", "29681"],
    "Six Mile": ["29682"],
    "Slater": ["29683"],
    "Smoaks": ["29481"],
    "Smyrna": ["29743"],
    "Society Hill": ["29593"],
    "Spartanburg": ["29301", "29302", "29303", "29304", "29305", "29306", "29307", "29319"],
    "Springfield": ["29146"],
    "Starr": ["29684"],
    "Startex": ["29377"],
    "State Park": ["29147"],
    "Sullivans Island": ["29482"],
    "Summerton": ["29148"],
    "Summerville": ["29483", "29484", "29485", "29486"],
    "Sumter": ["29150", "29151", "29153", "29154"],
    "Sunset": ["29685"],
    "Swansea": ["29160"],
    "Sycamore": ["29846"],
    "Tamassee": ["29686"],
    "Tatum": ["29594"],
    "Taylors": ["29687"],
    "Tigerville": ["29688"],
    "Tillman": ["29943"],
    "Timmonsville": ["29161"],
    "Townville": ["29689"],
    "Travelers Rest": ["29690"],
    "Trenton": ["29847"],
    "Troy": ["29848"],
    "Turbeville": ["29162"],
    "Ulmer": ["29849"],
    "Una": ["29378"],
    "Union": ["29379"],
    "Van Wyck": ["29744"],
    "Vance": ["29163"],
    "Varnville": ["29944"],
    "Vaucluse": ["29850"],
    "Wadmalaw Island": ["29487"],
    "Wagener": ["29164"],
    "Walhalla": ["29691"],
    "Wallace": ["29596"],
    "Walterboro": ["29488"],
    "Ward": ["29166"],
    "Ware Shoals": ["29692"],
    "Warrenville": ["29851"],
    "Waterloo": ["29384"],
    "Wedgefield": ["29168"],
    "Wellford": ["29385"],
    "West Columbia": ["29169", "29170", "29171", "29172"],
    "West Union": ["29696"],
    "Westminster": ["29693"],
    "Westville": ["29175"],
    "White Rock": ["29177"],
    "White Stone": ["29386"],
    "Whitmire": ["29178"],
    "Williams": ["29493"],
    "Williamston": ["29697"],
    "Williston": ["29853"],
    "Windsor": ["29856"],
    "Winnsboro": ["29180"],
    "Woodruff": ["29388"],
    "Yemassee": ["29945"],
    "York": ["29745"]
  },
  "SD": {
    "Aberdeen": ["57401", "57402"],
    "Agar": ["57520"],
    "Akaska": ["57420"],
    "Alcester": ["57001"],
    "Alexandria": ["57311"],
    "Allen": ["57714"],
    "Alpena": ["57312"],
    "Amherst": ["57421"],
    "Andover": ["57422"],
    "Arlington": ["57212"],
    "Armour": ["57313"],
    "Artesian": ["57314"],
    "Ashton": ["57424"],
    "Astoria": ["57213"],
    "Aurora": ["57002"],
    "Avon": ["57315"],
    "Badger": ["57214"],
    "Baltic": ["57003"],
    "Barnard": ["57426"],
    "Batesland": ["57716"],
    "Bath": ["57427"],
    "Belle Fourche": ["57717"],
    "Belvidere": ["57521"],
    "Beresford": ["57004"],
    "Big Stone City": ["57216"],
    "Bison": ["57620"],
    "Black Hawk": ["57718"],
    "Blunt": ["57522"],
    "Bonesteel": ["57317"],
    "Bowdle": ["57428"],
    "Box Elder": ["57719"],
    "Bradley": ["57217"],
    "Brandon": ["57005"],
    "Brandt": ["57218"],
    "Brentford": ["57429"],
    "Bridgewater": ["57319"],
    "Bristol": ["57219"],
    "Britton": ["57430"],
    "Brookings": ["57006", "57007"],
    "Bruce": ["57220"],
    "Bryant": ["57221"],
    "Buffalo": ["57720"],
    "Buffalo Gap": ["57722"],
    "Bullhead": ["57621"],
    "Burbank": ["57010"],
    "Burke": ["57523"],
    "Camp Crook": ["57724"],
    "Canistota": ["57012"],
    "Canova": ["57321"],
    "Canton": ["57013"],
    "Caputa": ["57725"],
    "Carpenter": ["57322"],
    "Carthage": ["57323"],
    "Castlewood": ["57223"],
    "Cavour": ["57324"],
    "Centerville": ["57014"],
    "Chamberlain": ["57325", "57326"],
    "Chancellor": ["57015"],
    "Cherry Creek": ["57622"],
    "Chester": ["57016"],
    "Claire City": ["57224"],
    "Claremont": ["57432"],
    "Clark": ["57225"],
    "Clear Lake": ["57226"],
    "Colman": ["57017"],
    "Colome": ["57528"],
    "Colton": ["57018"],
    "Columbia": ["57433"],
    "Conde": ["57434"],
    "Corona": ["57227"],
    "Corsica": ["57328"],
    "Cresbard": ["57435"],
    "Crooks": ["57020"],
    "Custer": ["57730"],
    "Dallas": ["57529"],
    "Dante": ["57329"],
    "Davis": ["57021"],
    "De Smet": ["57231"],
    "Deadwood": ["57732"],
    "Dell Rapids": ["57022"],
    "Delmont": ["57330"],
    "Dimock": ["57331"],
    "Doland": ["57436"],
    "Draper": ["57531"],
    "Dupree": ["57623"],
    "Eagle Butte": ["57625"],
    "Eden": ["57232"],
    "Edgemont": ["57735"],
    "Egan": ["57024"],
    "Elk Point": ["57025"],
    "Elkton": ["57026"],
    "Ellsworth AFB": ["57706"],
    "Emery": ["57332"],
    "Enning": ["57737"],
    "Erwin": ["57233"],
    "Estelline": ["57234"],
    "Ethan": ["57334"],
    "Eureka": ["57437"],
    "Fairburn": ["57738"],
    "Fairfax": ["57335"],
    "Fairview": ["57027"],
    "Faith": ["57626"],
    "Faulkton": ["57438"],
    "Fedora": ["57337"],
    "Ferney": ["57439"],
    "Flandreau": ["57028"],
    "Florence": ["57235"],
    "Fort Meade": ["57741"],
    "Fort Pierre": ["57532"],
    "Fort Thompson": ["57339"],
    "Frankfort": ["57440"],
    "Frederick": ["57441"],
    "Freeman": ["57029"],
    "Fulton": ["57340"],
    "Gann Valley": ["57341"],
    "Garden City": ["57236"],
    "Garretson": ["57030"],
    "Gary": ["57237"],
    "Gayville": ["57031"],
    "Geddes": ["57342"],
    "Gettysburg": ["57442"],
    "Glencross": ["57630"],
    "Glenham": ["57631"],
    "Goodwin": ["57238"],
    "Gregory": ["57533"],
    "Grenville": ["57239"],
    "Groton": ["57445"],
    "Hamill": ["57534"],
    "Harrisburg": ["57032"],
    "Harrison": ["57344"],
    "Harrold": ["57536"],
    "Hartford": ["57033"],
    "Hayes": ["57537"],
    "Hayti": ["57241"],
    "Hazel": ["57242"],
    "Hecla": ["57446"],
    "Henry": ["57243"],
    "Hermosa": ["57744"],
    "Herreid": ["57632"],
    "Herrick": ["57538"],
    "Highmore": ["57345"],
    "Hill City": ["57745"],
    "Hitchcock": ["57348"],
    "Holabird": ["57540"],
    "Hosmer": ["57448"],
    "Hot Springs": ["57747"],
    "Houghton": ["57449"],
    "Hoven": ["57450"],
    "Howard": ["57349"],
    "Howes": ["57748"],
    "Hudson": ["57034"],
    "Humboldt": ["57035"],
    "Hurley": ["57036"],
    "Huron": ["57350", "57399"],
    "Ideal": ["57541"],
    "Interior": ["57750"],
    "Ipswich": ["57451"],
    "Irene": ["57037"],
    "Iroquois": ["57353"],
    "Isabel": ["57633"],
    "Java": ["57452"],
    "Jefferson": ["57038"],
    "Kadoka": ["57543"],
    "Kaylor": ["57354"],
    "Keldron": ["57634"],
    "Kennebec": ["57544"],
    "Keystone": ["57751"],
    "Kimball": ["57355"],
    "Kranzburg": ["57245"],
    "Kyle": ["57752"],
    "Labolt": ["57246"],
    "Lake Andes": ["57356"],
    "Lake City": ["57247"],
    "Lake Norden": ["57248"],
    "Lake Preston": ["57249"],
    "Lane": ["57358"],
    "Langford": ["57454"],
    "Lantry": ["57636"],
    "Lead": ["57754"],
    "Lebanon": ["57455"],
    "Lemmon": ["57638"],
    "Lennox": ["57039"],
    "Leola": ["57456"],
    "Lesterville": ["57040"],
    "Letcher": ["57359"],
    "Little Eagle": ["57639"],
    "Lodgepole": ["57640"],
    "Long Lake": ["57457"],
    "Long Valley": ["57547"],
    "Lower Brule": ["57548"],
    "Ludlow": ["57755"],
    "Lyons": ["57041"],
    "Madison": ["57042"],
    "Manderson": ["57756"],
    "Mansfield": ["57460"],
    "Marion": ["57043"],
    "Martin": ["57551"],
    "Marty": ["57361"],
    "Marvin": ["57251"],
    "Mc Intosh": ["57641"],
    "Mc Laughlin": ["57642"],
    "Meadow": ["57644"],
    "Mellette": ["57461"],
    "Menno": ["57045"],
    "Midland": ["57552"],
    "Milbank": ["57252", "57253"],
    "Milesville": ["57553"],
    "Miller": ["57362"],
    "Mission": ["57555"],
    "Mission Hill": ["57046"],
    "Mitchell": ["57301"],
    "Mobridge": ["57601"],
    "Monroe": ["57047"],
    "Montrose": ["57048"],
    "Morristown": ["57645"],
    "Mound City": ["57646"],
    "Mount Vernon": ["57363"],
    "Mud Butte": ["57758"],
    "Murdo": ["57559"],
    "Nemo": ["57759"],
    "New Effington": ["57255"],
    "New Holland": ["57364"],
    "New Underwood": ["57761"],
    "Newell": ["57760"],
    "Nisland": ["57762"],
    "Norris": ["57560"],
    "North Sioux City": ["57049"],
    "Northville": ["57465"],
    "Nunda": ["57050"],
    "Oacoma": ["57365"],
    "Oelrichs": ["57763"],
    "Oglala": ["57764"],
    "Okaton": ["57562"],
    "Okreek": ["57563"],
    "Oldham": ["57051"],
    "Olivet": ["57052"],
    "Onaka": ["57466"],
    "Onida": ["57564"],
    "Oral": ["57766"],
    "Orient": ["57467"],
    "Ortley": ["57256"],
    "Owanka": ["57767"],
    "Parker": ["57053"],
    "Parkston": ["57366"],
    "Parmelee": ["57566"],
    "Peever": ["57257"],
    "Philip": ["57567"],
    "Pickstown": ["57367"],
    "Piedmont": ["57769"],
    "Pierpont": ["57468"],
    "Pierre": ["57501"],
    "Pine Ridge": ["57770"],
    "Plankinton": ["57368"],
    "Platte": ["57369"],
    "Pollock": ["57648"],
    "Porcupine": ["57772"],
    "Prairie City": ["57649"],
    "Presho": ["57568"],
    "Pringle": ["57773"],
    "Pukwana": ["57370"],
    "Quinn": ["57775"],
    "Ralph": ["57650"],
    "Ramona": ["57054"],
    "Rapid City": ["57701", "57702", "57703", "57709"],
    "Raymond": ["57258"],
    "Redfield": ["57469"],
    "Redig": ["57776"],
    "Ree Heights": ["57371"],
    "Reliance": ["57569"],
    "Renner": ["57055"],
    "Reva": ["57651"],
    "Revillo": ["57259"],
    "Ridgeview": ["57652"],
    "Rockham": ["57470"],
    "Roscoe": ["57471"],
    "Rosebud": ["57570"],
    "Rosholt": ["57260"],
    "Roslyn": ["57261"],
    "Rowena": ["57056"],
    "Rutland": ["57057"],
    "Saint Charles": ["57571"],
    "Saint Francis": ["57572"],
    "Saint Lawrence": ["57373"],
    "Saint Onge": ["57779"],
    "Salem": ["57058"],
    "Scenic": ["57780"],
    "Scotland": ["57059"],
    "Selby": ["57472"],
    "Seneca": ["57473"],
    "Sinai": ["57061"],
    "Sioux Falls": ["57101", "57103", "57104", "57105", "57106", "57107", "57108", "57109", "57110", "57117", "57118", "57186", "57188", "57189", "57192", "57193", "57194", "57195", "57196", "57197", "57198"],
    "Sisseton": ["57262"],
    "Smithwick": ["57782"],
    "South Shore": ["57263"],
    "Spearfish": ["57783", "57799"],
    "Spencer": ["57374"],
    "Springfield": ["57062"],
    "Stephan": ["57346"],
    "Stickney": ["57375"],
    "Stockholm": ["57264"],
    "Strandburg": ["57265"],
    "Stratford": ["57474"],
    "Sturgis": ["57785"],
    "Summit": ["57266"],
    "Tabor": ["57063"],
    "Tea": ["57064"],
    "Timber Lake": ["57656"],
    "Tolstoy": ["57475"],
    "Toronto": ["57268"],
    "Trail City": ["57657"],
    "Trent": ["57065"],
    "Tripp": ["57376"],
    "Tulare": ["57476"],
    "Turton": ["57477"],
    "Tuthill": ["57574"],
    "Twin Brooks": ["57269"],
    "Tyndall": ["57066"],
    "Union Center": ["57787"],
    "Utica": ["57067"],
    "Vale": ["57788"],
    "Valley Springs": ["57068"],
    "Veblen": ["57270"],
    "Vermillion": ["57069"],
    "Viborg": ["57070"],
    "Vienna": ["57271"],
    "Virgil": ["57379"],
    "Vivian": ["57576"],
    "Volga": ["57071"],
    "Volin": ["57072"],
    "Wagner": ["57380"],
    "Wakonda": ["57073"],
    "Wakpala": ["57658"],
    "Walker": ["57659"],
    "Wall": ["57790"],
    "Wallace": ["57272"],
    "Wanblee": ["57577"],
    "Warner": ["57479"],
    "Wasta": ["57791"],
    "Watauga": ["57660"],
    "Watertown": ["57201"],
    "Waubay": ["57273"],
    "Webster": ["57274"],
    "Wentworth": ["57075"],
    "Wessington": ["57381"],
    "Wessington Springs": ["57382"],
    "Westport": ["57481"],
    "White": ["57276"],
    "White Lake": ["57383"],
    "White Owl": ["57792"],
    "White River": ["57579"],
    "Whitehorse": ["57661"],
    "Whitewood": ["57793"],
    "Willow Lake": ["57278"],
    "Wilmot": ["57279"],
    "Winfred": ["57076"],
    "Winner": ["57580"],
    "Witten": ["57584"],
    "Wolsey": ["57384"],
    "Wood": ["57585"],
    "Woonsocket": ["57385"],
    "Worthing": ["57077"],
    "Wounded Knee": ["57794"],
    "Yale": ["57386"],
    "Yankton": ["57078", "57079"]
  },
  "TN": {
    "Adams": ["37010"],
    "Adamsville": ["38310"],
    "Afton": ["37616"],
    "Alamo": ["38001"],
    "Alcoa": ["37701"],
    "Alexandria": ["37012"],
    "Allardt": ["38504"],
    "Allons": ["38541"],
    "Allred": ["38542"],
    "Alpine": ["38543"],
    "Altamont": ["37301"],
    "Andersonville": ["37705"],
    "Antioch": ["37011", "37013"],
    "Apison": ["37302"],
    "Ardmore": ["38449"],
    "Arlington": ["38002"],
    "Arnold AFB": ["37389"],
    "Arrington": ["37014"],
    "Arthur": ["37707"],
    "Ashland City": ["37015"],
    "Athens": ["37303", "37371"],
    "Atoka": ["38004"],
    "Atwood": ["38220"],
    "Auburntown": ["37016"],
    "Bakewell": ["37304"],
    "Bath Springs": ["38311"],
    "Baxter": ["38544"],
    "Bean Station": ["37708"],
    "Beech Bluff": ["38313"],
    "Beechgrove": ["37018"],
    "Beersheba Springs": ["37305"],
    "Belfast": ["37019"],
    "Bell Buckle": ["37020"],
    "Bells": ["38006"],
    "Belvidere": ["37306"],
    "Benton": ["37307"],
    "Bethel Springs": ["38315"],
    "Bethpage": ["37022"],
    "Big Rock": ["37023"],
    "Big Sandy": ["38221"],
    "Birchwood": ["37308"],
    "Blaine": ["37709"],
    "Bloomington Springs": ["38545"],
    "Blountville": ["37617"],
    "Bluff City": ["37618"],
    "Bogota": ["38007"],
    "Bolivar": ["38008"],
    "Bon Aqua": ["37025"],
    "Braden": ["38010"],
    "Bradford": ["38316"],
    "Bradyville": ["37026"],
    "Brentwood": ["37024", "37027"],
    "Briceville": ["37710"],
    "Brighton": ["38011"],
    "Bristol": ["37620", "37621", "37625"],
    "Brownsville": ["38012"],
    "Bruceton": ["38317"],
    "Brunswick": ["38014"],
    "Brush Creek": ["38547"],
    "Buchanan": ["38222"],
    "Buena Vista": ["38318"],
    "Buffalo Valley": ["38548"],
    "Bulls Gap": ["37711"],
    "Bumpus Mills": ["37028"],
    "Burlison": ["38015"],
    "Burns": ["37029"],
    "Butler": ["37640"],
    "Bybee": ["37713"],
    "Byrdstown": ["38549"],
    "Calhoun": ["37309"],
    "Camden": ["38320"],
    "Campaign": ["38550"],
    "Carthage": ["37030"],
    "Caryville": ["37714"],
    "Castalian Springs": ["37031"],
    "Cedar Grove": ["38321"],
    "Cedar Hill": ["37032"],
    "Celina": ["38551"],
    "Centerville": ["37033"],
    "Chapel Hill": ["37034"],
    "Chapmansboro": ["37035"],
    "Charleston": ["37310"],
    "Charlotte": ["37036"],
    "Chattanooga": ["37401", "37402", "37403", "37404", "37405", "37406", "37407", "37408", "37409", "37410", "37411", "37412", "37414", "37415", "37416", "37419", "37421", "37422", "37424", "37450"],
    "Chestnut Mound": ["38552"],
    "Chewalla": ["38393"],
    "Christiana": ["37037"],
    "Chuckey": ["37641"],
    "Church Hill": ["37642"],
    "Clairfield": ["37715"],
    "Clarkrange": ["38553"],
    "Clarksburg": ["38324"],
    "Clarksville": ["37040", "37041", "37042", "37043", "37044"],
    "Cleveland": ["37311", "37312", "37320", "37323", "37364"],
    "Clifton": ["38425"],
    "Clinton": ["37716", "37717"],
    "Coalfield": ["37719"],
    "Coalmont": ["37313"],
    "Coker Creek": ["37314"],
    "College Grove": ["37046"],
    "Collegedale": ["37315"],
    "Collierville": ["38017", "38027"],
    "Collinwood": ["38450"],
    "Columbia": ["38401", "38402"],
    "Como": ["38223"],
    "Conasauga": ["37316"],
    "Cookeville": ["38501", "38502", "38503", "38505", "38506"],
    "Copperhill": ["37317"],
    "Cordova": ["38016", "38018", "38088"],
    "Cornersville": ["37047"],
    "Corryton": ["37721"],
    "Cosby": ["37722"],
    "Cottage Grove": ["38224"],
    "Cottontown": ["37048"],
    "Counce": ["38326"],
    "Covington": ["38019"],
    "Cowan": ["37318"],
    "Crab Orchard": ["37723"],
    "Crawford": ["38554"],
    "Crockett Mills": ["38021"],
    "Cross Plains": ["37049"],
    "Crossville": ["38555", "38557", "38558", "38571", "38572"],
    "Crump": ["38327"],
    "Culleoka": ["38451"],
    "Cumberland City": ["37050"],
    "Cumberland Furnace": ["37051"],
    "Cumberland Gap": ["37724"],
    "Cunningham": ["37052"],
    "Cypress Inn": ["38452"],
    "Dandridge": ["37725"],
    "Darden": ["38328"],
    "Dayton": ["37321"],
    "Decatur": ["37322"],
    "Decaturville": ["38329"],
    "Decherd": ["37324"],
    "Deer Lodge": ["37726"],
    "Del Rio": ["37727"],
    "Delano": ["37325"],
    "Dellrose": ["38453"],
    "Denmark": ["38391"],
    "Dickson": ["37055", "37056"],
    "Dixon Springs": ["37057"],
    "Dover": ["37058"],
    "Dowelltown": ["37059"],
    "Doyle": ["38559"],
    "Dresden": ["38225"],
    "Drummonds": ["38023"],
    "Duck River": ["38454"],
    "Ducktown": ["37326"],
    "Duff": ["37729"],
    "Dukedom": ["38226"],
    "Dunlap": ["37327"],
    "Dyer": ["38330"],
    "Dyersburg": ["38024", "38025"],
    "Eads": ["38028"],
    "Eagan": ["37730"],
    "Eagleville": ["37060"],
    "Eaton": ["38331"],
    "Eidson": ["37731"],
    "Elbridge": ["38227"],
    "Elgin": ["37732"],
    "Elizabethton": ["37643", "37644"],
    "Elkton": ["38455"],
    "Ellendale": ["38029"],
    "Elmwood": ["38560"],
    "Elora": ["37328"],
    "Englewood": ["37329"],
    "Enville": ["38332"],
    "Erin": ["37061"],
    "Erwin": ["37650"],
    "Estill Springs": ["37330"],
    "Ethridge": ["38456"],
    "Etowah": ["37331"],
    "Eva": ["38333"],
    "Evensville": ["37332"],
    "Fairview": ["37062"],
    "Fall Branch": ["37656"],
    "Farner": ["37333"],
    "Farragut": ["37934"],
    "Fayetteville": ["37334"],
    "Finger": ["38334"],
    "Finley": ["38030"],
    "Five Points": ["38457"],
    "Flag Pond": ["37657"],
    "Flintville": ["37335"],
    "Fosterville": ["37063"],
    "Frankewing": ["38459"],
    "Franklin": ["37064", "37065", "37067", "37068", "37069"],
    "Friendship": ["38034"],
    "Friendsville": ["37737"],
    "Fruitvale": ["38336"],
    "Gadsden": ["38337"],
    "Gainesboro": ["38562"],
    "Gallatin": ["37066"],
    "Gallaway": ["38036"],
    "Gates": ["38037"],
    "Gatlinburg": ["37738"],
    "Georgetown": ["37336"],
    "Germantown": ["38138", "38139", "38183"],
    "Gibson": ["38338"],
    "Gladeville": ["37071"],
    "Gleason": ["38229"],
    "Goodlettsville": ["37070", "37072"],
    "Goodspring": ["38460"],
    "Gordonsville": ["38563"],
    "Grand Junction": ["38039"],
    "Grandview": ["37337"],
    "Granville": ["38564"],
    "Graysville": ["37338"],
    "Greenback": ["37742"],
    "Greenbrier": ["37073"],
    "Greeneville": ["37743", "37744", "37745"],
    "Greenfield": ["38230"],
    "Grimsley": ["38565"],
    "Gruetli Laager": ["37339"],
    "Guild": ["37340"],
    "Guys": ["38339"],
    "Halls": ["38040"],
    "Hampshire": ["38461"],
    "Hampton": ["37658"],
    "Harriman": ["37748"],
    "Harrison": ["37341"],
    "Harrogate": ["37752"],
    "Hartford": ["37753"],
    "Hartsville": ["37074"],
    "Heiskell": ["37754"],
    "Helenwood": ["37755"],
    "Henderson": ["38340"],
    "Hendersonville": ["37075", "37077"],
    "Henning": ["38041"],
    "Henry": ["38231"],
    "Hermitage": ["37076"],
    "Hickman": ["38567"],
    "Hickory Valley": ["38042"],
    "Hilham": ["38568"],
    "Hillsboro": ["37342"],
    "Hixson": ["37343"],
    "Hohenwald": ["38462"],
    "Holladay": ["38341"],
    "Hollow Rock": ["38342"],
    "Hornbeak": ["38232"],
    "Hornsby": ["38044"],
    "Humboldt": ["38343"],
    "Huntingdon": ["38344"],
    "Huntland": ["37345"],
    "Huntsville": ["37756"],
    "Huron": ["38345"],
    "Hurricane Mills": ["37078"],
    "Idlewild": ["38346"],
    "Indian Mound": ["37079"],
    "Iron City": ["38463"],
    "Jacks Creek": ["38347"],
    "Jacksboro": ["37757"],
    "Jackson": ["38301", "38302", "38303", "38305", "38308", "38314"],
    "Jamestown": ["38556"],
    "Jasper": ["37347"],
    "Jefferson City": ["37760"],
    "Jellico": ["37762"],
    "Joelton": ["37080"],
    "Johnson City": ["37601", "37602", "37604", "37605", "37614", "37615"],
    "Jonesborough": ["37659"],
    "Kelso": ["37348"],
    "Kenton": ["38233"],
    "Kingsport": ["37660", "37662", "37663", "37664", "37665", "37669"],
    "Kingston": ["37763"],
    "Kingston Springs": ["37082"],
    "Knoxville": ["37901", "37902", "37909", "37912", "37914", "37915", "37916", "37917", "37918", "37919", "37920", "37921", "37922", "37923", "37924", "37927", "37928", "37929", "37930", "37931", "37932", "37933", "37938", "37939", "37940", "37950", "37990", "37995", "37996", "37997", "37998"],
    "Kodak": ["37764"],
    "Kyles Ford": ["37765"],
    "La Follette": ["37766"],
    "La Grange": ["38046"],
    "La Vergne": ["37086", "37089"],
    "Laconia": ["38045"],
    "Lafayette": ["37083"],
    "Lancaster": ["38569"],
    "Lancing": ["37770"],
    "Lascassas": ["37085"],
    "Laurel Bloomery": ["37680"],
    "Lavinia": ["38348"],
    "Lawrenceburg": ["38464"],
    "Lebanon": ["37087", "37088", "37090"],
    "Lenoir City": ["37771", "37772"],
    "Lenox": ["38047"],
    "Leoma": ["38468"],
    "Lewisburg": ["37091"],
    "Lexington": ["38351"],
    "Liberty": ["37095"],
    "Limestone": ["37681"],
    "Linden": ["37096"],
    "Livingston": ["38570"],
    "Lobelville": ["37097"],
    "Lone Mountain": ["37773"],
    "Lookout Mountain": ["37350"],
    "Loretto": ["38469"],
    "Loudon": ["37774"],
    "Louisville": ["37777"],
    "Lowland": ["37778"],
    "Lupton City": ["37351"],
    "Luray": ["38352"],
    "Luttrell": ["37779"],
    "Lutts": ["38471"],
    "Lyles": ["37098"],
    "Lynchburg": ["37352"],
    "Lynnville": ["38472"],
    "Macon": ["38048"],
    "Madison": ["37115", "37116"],
    "Madisonville": ["37354"],
    "Manchester": ["37349", "37355"],
    "Mansfield": ["38236"],
    "Martin": ["38237", "38238"],
    "Maryville": ["37801", "37802", "37803", "37804"],
    "Mascot": ["37806"],
    "Mason": ["38049"],
    "Maury City": ["38050"],
    "Maynardville": ["37807"],
    "Mc Donald": ["37353"],
    "Mc Ewen": ["37101"],
    "Mc Kenzie": ["38201"],
    "Mc Lemoresville": ["38235"],
    "Mcminnville": ["37110", "37111"],
    "Medina": ["38355"],
    "Medon": ["38356"],
    "Memphis": ["37501", "37544", "38101", "38103", "38104", "38105", "38106", "38107", "38108", "38109", "38110", "38111", "38112", "38113", "38114", "38115", "38116", "38117", "38118", "38119", "38120", "38122", "38124", "38125", "38126", "38127", "38128", "38130", "38131", "38132", "38133", "38134", "38135", "38136", "38137", "38141", "38142", "38145", "38147", "38148", "38150", "38151", "38152", "38157", "38159", "38161", "38163", "38165", "38166", "38167", "38168", "38173", "38174", "38175", "38177", "38181", "38182", "38184", "38186", "38187", "38188", "38190", "38193", "38194", "38197"],
    "Mercer": ["38392"],
    "Michie": ["38357"],
    "Middleton": ["38052"],
    "Midway": ["37809"],
    "Milan": ["38358"],
    "Milledgeville": ["38359"],
    "Milligan College": ["37682"],
    "Millington": ["38053", "38054", "38055", "38083"],
    "Milton": ["37118"],
    "Minor Hill": ["38473"],
    "Mitchellville": ["37119"],
    "Mohawk": ["37810"],
    "Monroe": ["38573"],
    "Monteagle": ["37356"],
    "Monterey": ["38574"],
    "Mooresburg": ["37811"],
    "Morris Chapel": ["38361"],
    "Morrison": ["37357"],
    "Morristown": ["37813", "37814", "37815", "37816"],
    "Moscow": ["38057"],
    "Mosheim": ["37818"],
    "Moss": ["38575"],
    "Mount Carmel": ["37645"],
    "Mount Juliet": ["37121", "37122"],
    "Mount Pleasant": ["38474"],
    "Mountain City": ["37683"],
    "Mountain Home": ["37684"],
    "Mulberry": ["37359"],
    "Munford": ["38058"],
    "Murfreesboro": ["37127", "37128", "37129", "37130", "37131", "37132", "37133"],
    "Nashville": ["37201", "37202", "37203", "37204", "37205", "37206", "37207", "37208", "37209", "37210", "37211", "37212", "37213", "37214", "37215", "37216", "37217", "37218", "37219", "37220", "37221", "37222", "37224", "37227", "37228", "37229", "37230", "37232", "37234", "37235", "37236", "37237", "37238", "37240", "37241", "37242", "37243", "37244", "37245", "37246", "37247", "37248", "37249", "37250"],
    "New Johnsonville": ["37134"],
    "New Market": ["37820"],
    "New Tazewell": ["37824", "37825"],
    "Newbern": ["38059"],
    "Newcomb": ["37819"],
    "Newport": ["37821", "37822"],
    "Niota": ["37826"],
    "Nolensville": ["37135"],
    "Norene": ["37136"],
    "Normandy": ["37360"],
    "Norris": ["37828"],
    "Nunnelly": ["37137"],
    "Oak Ridge": ["37830", "37831"],
    "Oakdale": ["37829"],
    "Oakfield": ["38362"],
    "Oakland": ["38060"],
    "Obion": ["38240"],
    "Ocoee": ["37361"],
    "Old Fort": ["37362"],
    "Old Hickory": ["37138"],
    "Olivehill": ["38475"],
    "Oliver Springs": ["37840"],
    "Oneida": ["37841"],
    "Only": ["37140"],
    "Ooltewah": ["37363"],
    "Orlinda": ["37141"],
    "Pall Mall": ["38577"],
    "Palmer": ["37365"],
    "Palmersville": ["38241"],
    "Palmyra": ["37142"],
    "Paris": ["38242"],
    "Parrottsville": ["37843"],
    "Parsons": ["38363"],
    "Pegram": ["37143"],
    "Pelham": ["37366"],
    "Petersburg": ["37144"],
    "Petros": ["37845"],
    "Philadelphia": ["37846"],
    "Pickwick Dam": ["38365"],
    "Pigeon Forge": ["37863", "37868"],
    "Pikeville": ["37367"],
    "Piney Flats": ["37686", "37699"],
    "Pinson": ["38366"],
    "Pioneer": ["37847"],
    "Pleasant Hill": ["38578"],
    "Pleasant Shade": ["37145"],
    "Pleasant View": ["37146"],
    "Pocahontas": ["38061"],
    "Portland": ["37148"],
    "Powder Springs": ["37848"],
    "Powell": ["37849"],
    "Primm Springs": ["38476"],
    "Prospect": ["38477"],
    "Pruden": ["37851"],
    "Pulaski": ["38478"],
    "Puryear": ["38251"],
    "Quebeck": ["38579"],
    "Ramer": ["38367"],
    "Readyville": ["37149"],
    "Reagan": ["38368"],
    "Red Boiling Springs": ["37150"],
    "Reliance": ["37369"],
    "Riceville": ["37370"],
    "Rickman": ["38580"],
    "Riddleton": ["37151"],
    "Ridgely": ["38080"],
    "Ridgetop": ["37152"],
    "Ripley": ["38063"],
    "Rives": ["38253"],
    "Roan Mountain": ["37687"],
    "Robbins": ["37852"],
    "Rock Island": ["38581"],
    "Rockford": ["37853"],
    "Rockvale": ["37153"],
    "Rockwood": ["37854"],
    "Rocky Top": ["37769"],
    "Rogersville": ["37857"],
    "Rossville": ["38066"],
    "Rugby": ["37733"],
    "Russellville": ["37860"],
    "Rutherford": ["38369"],
    "Rutledge": ["37861"],
    "Saint Joseph": ["38481"],
    "Sale Creek": ["37373"],
    "Saltillo": ["38370"],
    "Samburg": ["38254"],
    "Santa Fe": ["38482"],
    "Sardis": ["38371"],
    "Saulsbury": ["38067"],
    "Savannah": ["38372"],
    "Scotts Hill": ["38374"],
    "Selmer": ["38375"],
    "Sequatchie": ["37374"],
    "Sevierville": ["37862", "37864", "37876"],
    "Sewanee": ["37375", "37383"],
    "Seymour": ["37865"],
    "Shady Valley": ["37688"],
    "Sharon": ["38255"],
    "Sharps Chapel": ["37866"],
    "Shawanee": ["37867"],
    "Shelbyville": ["37160", "37161", "37162"],
    "Sherwood": ["37376"],
    "Shiloh": ["38376"],
    "Signal Mountain": ["37377"],
    "Silerton": ["38377"],
    "Silver Point": ["38582"],
    "Slayden": ["37165"],
    "Smartt": ["37378"],
    "Smithville": ["37166"],
    "Smyrna": ["37167"],
    "Sneedville": ["37869"],
    "Soddy Daisy": ["37379", "37384"],
    "Somerville": ["38068"],
    "South Fulton": ["38257"],
    "South Pittsburg": ["37380"],
    "Southside": ["37171"],
    "Sparta": ["38583"],
    "Speedwell": ["37870"],
    "Spencer": ["38585"],
    "Spring City": ["37381"],
    "Spring Creek": ["38378"],
    "Spring Hill": ["37174"],
    "Springfield": ["37172"],
    "Springville": ["38256"],
    "Stanton": ["38069"],
    "Stantonville": ["38379"],
    "Stewart": ["37175"],
    "Strawberry Plains": ["37871"],
    "Sugar Tree": ["38380"],
    "Summertown": ["38483"],
    "Summitville": ["37382"],
    "Sunbright": ["37872"],
    "Surgoinsville": ["37873"],
    "Sweetwater": ["37874"],
    "Taft": ["38488"],
    "Talbott": ["37877"],
    "Tallassee": ["37878"],
    "Tazewell": ["37879"],
    "Telford": ["37690"],
    "Tellico Plains": ["37385"],
    "Ten Mile": ["37880"],
    "Tennessee Ridge": ["37178"],
    "Thompsons Station": ["37179"],
    "Thorn Hill": ["37881"],
    "Tigrett": ["38070"],
    "Tipton": ["38071"],
    "Tiptonville": ["38079"],
    "Toone": ["38381"],
    "Townsend": ["37882"],
    "Tracy City": ["37387"],
    "Trade": ["37691"],
    "Trenton": ["38382"],
    "Trezevant": ["38258"],
    "Trimble": ["38259"],
    "Troy": ["38260"],
    "Tullahoma": ["37388"],
    "Turtletown": ["37391"],
    "Unicoi": ["37692"],
    "Union City": ["38261", "38281"],
    "Unionville": ["37180"],
    "Vanleer": ["37181"],
    "Viola": ["37394"],
    "Vonore": ["37885"],
    "Walland": ["37886"],
    "Walling": ["38587"],
    "Wartburg": ["37887"],
    "Wartrace": ["37183"],
    "Washburn": ["37888"],
    "Watauga": ["37694"],
    "Watertown": ["37184"],
    "Waverly": ["37185"],
    "Waynesboro": ["38485"],
    "Westmoreland": ["37186"],
    "Westpoint": ["38486"],
    "Westport": ["38387"],
    "White Bluff": ["37187"],
    "White House": ["37188"],
    "White Pine": ["37890"],
    "Whites Creek": ["37189"],
    "Whitesburg": ["37891"],
    "Whiteside": ["37396"],
    "Whiteville": ["38075"],
    "Whitleyville": ["38588"],
    "Whitwell": ["37397"],
    "Wilder": ["38589"],
    "Wildersville": ["38388"],
    "Williamsport": ["38487"],
    "Williston": ["38076"],
    "Winchester": ["37398"],
    "Winfield": ["37892"],
    "Woodbury": ["37190"],
    "Woodland Mills": ["38271"],
    "Woodlawn": ["37191"],
    "Wynnburg": ["38077"],
    "Yorkville": ["38389"],
    "Yuma": ["38390"]
  },
  "TX": {
    "Abbott": ["76621"],
    "Abernathy": ["79311"],
    "Abilene": ["79601", "79602", "79603", "79604", "79605", "79606", "79608", "79697", "79698", "79699"],
    "Ace": ["77326"],
    "Ackerly": ["79713"],
    "Addison": ["75001"],
    "Adkins": ["78101"],
    "Adrian": ["79001"],
    "Afton": ["79220"],
    "Agua Dulce": ["78330"],
    "Aiken": ["79221"],
    "Alamo": ["78516"],
    "Alanreed": ["79002"],
    "Alba": ["75410"],
    "Albany": ["76430"],
    "Aledo": ["76008"],
    "Alice": ["78332", "78333"],
    "Alief": ["77411"],
    "Allen": ["75002", "75013"],
    "Alleyton": ["78935"],
    "Allison": ["79003"],
    "Alpine": ["79830", "79831", "79832"],
    "Altair": ["77412"],
    "Alto": ["75925"],
    "Alvarado": ["76009"],
    "Alvin": ["77511", "77512"],
    "Alvord": ["76225"],
    "Amarillo": ["79101", "79102", "79103", "79104", "79105", "79106", "79107", "79108", "79109", "79110", "79111", "79114", "79116", "79117", "79118", "79119", "79120", "79121", "79124", "79159", "79166", "79168", "79172", "79174", "79178", "79185", "79187", "79189"],
    "Amherst": ["79312"],
    "Anahuac": ["77514"],
    "Anderson": ["77830"],
    "Andrews": ["79714"],
    "Angleton": ["77515", "77516"],
    "Anna": ["75409"],
    "Annona": ["75550"],
    "Anson": ["79501"],
    "Anthony": ["79821"],
    "Anton": ["79313"],
    "Apple Springs": ["75926"],
    "Aquilla": ["76622"],
    "Aransas Pass": ["78335", "78336"],
    "Archer City": ["76351"],
    "Argyle": ["76226"],
    "Arlington": ["76001", "76002", "76003", "76004", "76005", "76006", "76007", "76010", "76011", "76012", "76013", "76014", "76015", "76016", "76017", "76018", "76019", "76094", "76096"],
    "Armstrong": ["78338"],
    "Arp": ["75750"],
    "Art": ["76820"],
    "Artesia Wells": ["78001"],
    "Arthur City": ["75411"],
    "Asherton": ["78827"],
    "Aspermont": ["79502"],
    "Atascosa": ["78002"],
    "Athens": ["75751", "75752"],
    "Atlanta": ["75551"],
    "Aubrey": ["76227"],
    "Austin": ["73301", "73344", "78701", "78702", "78703", "78704", "78705", "78708", "78709", "78710", "78711", "78712", "78713", "78714", "78715", "78716", "78717", "78718", "78719", "78720", "78721", "78722", "78723", "78724", "78725", "78726", "78727", "78728", "78729", "78730", "78731", "78732", "78733", "78734", "78735", "78736", "78737", "78738", "78739", "78741", "78742", "78744", "78745", "78746", "78747", "78748", "78749", "78750", "78751", "78752", "78753", "78754", "78755", "78756", "78757", "78758", "78759", "78760", "78761", "78762", "78763", "78764", "78765", "78766", "78767", "78768", "78769", "78772", "78773", "78774", "78778", "78779", "78780", "78781", "78783", "78785", "78786", "78788", "78789", "78798", "78799"],
    "Austwell": ["77950"],
    "Avalon": ["76623"],
    "Avery": ["75554"],
    "Avinger": ["75630"],
    "Avoca": ["79503"],
    "Axtell": ["76624"],
    "Azle": ["76020", "76098"],
    "Bacliff": ["77518"],
    "Bagwell": ["75412"],
    "Bailey": ["75413"],
    "Baird": ["79504"],
    "Balch Springs": ["75180"],
    "Ballinger": ["76821"],
    "Balmorhea": ["79718"],
    "Bandera": ["78003"],
    "Bangs": ["76823"],
    "Banquete": ["78339"],
    "Bardwell": ["75101"],
    "Barker": ["77413"],
    "Barksdale": ["78828"],
    "Barnhart": ["76930"],
    "Barry": ["75102"],
    "Barstow": ["79719"],
    "Bartlett": ["76511"],
    "Bastrop": ["78602"],
    "Batesville": ["78829"],
    "Batson": ["77519"],
    "Bay City": ["77404", "77414"],
    "Bayside": ["78340"],
    "Baytown": ["77520", "77521", "77522", "77523"],
    "Beasley": ["77417"],
    "Beaumont": ["77701", "77702", "77703", "77704", "77705", "77706", "77707", "77708", "77709", "77710", "77713", "77720", "77725", "77726"],
    "Beckville": ["75631"],
    "Bedford": ["76021", "76022", "76095"],
    "Bedias": ["77831"],
    "Beeville": ["78102", "78104"],
    "Bellaire": ["77401", "77402"],
    "Bellevue": ["76228"],
    "Bells": ["75414"],
    "Bellville": ["77418"],
    "Belmont": ["78604"],
    "Belton": ["76513"],
    "Ben Bolt": ["78342"],
    "Ben Franklin": ["75415"],
    "Ben Wheeler": ["75754"],
    "Benavides": ["78341"],
    "Bend": ["76824"],
    "Benjamin": ["79505"],
    "Berclair": ["78107"],
    "Bergheim": ["78004"],
    "Bertram": ["78605"],
    "Big Bend National Park": ["79834"],
    "Big Lake": ["76932"],
    "Big Sandy": ["75755", "75797"],
    "Big Spring": ["79720", "79721"],
    "Big Wells": ["78830"],
    "Bigfoot": ["78005"],
    "Bishop": ["78343"],
    "Bivins": ["75555"],
    "Blackwell": ["79506"],
    "Blanco": ["78606"],
    "Blanket": ["76432"],
    "Bledsoe": ["79314"],
    "Bleiblerville": ["78931"],
    "Blessing": ["77419"],
    "Bloomburg": ["75556"],
    "Blooming Grove": ["76626"],
    "Bloomington": ["77951"],
    "Blossom": ["75416"],
    "Blue Ridge": ["75424"],
    "Bluegrove": ["76352"],
    "Bluff Dale": ["76433"],
    "Bluffton": ["78607"],
    "Blum": ["76627"],
    "Boerne": ["78006", "78015"],
    "Bogata": ["75417"],
    "Boling": ["77420"],
    "Bon Wier": ["75928"],
    "Bonham": ["75418"],
    "Booker": ["79005"],
    "Borger": ["79007", "79008"],
    "Bovina": ["79009"],
    "Bowie": ["76230"],
    "Boyd": ["76023"],
    "Boys Ranch": ["79010"],
    "Brackettville": ["78832"],
    "Brady": ["76825"],
    "Brandon": ["76628"],
    "Brashear": ["75420"],
    "Brazoria": ["77422"],
    "Breckenridge": ["76424"],
    "Bremond": ["76629"],
    "Brenham": ["77833", "77834"],
    "Bridge City": ["77611"],
    "Bridgeport": ["76426"],
    "Briggs": ["78608"],
    "Briscoe": ["79011"],
    "Broaddus": ["75929"],
    "Bronson": ["75930"],
    "Bronte": ["76933"],
    "Brookeland": ["75931"],
    "Brookesmith": ["76827"],
    "Brookshire": ["77423"],
    "Brookston": ["75421"],
    "Brownfield": ["79316"],
    "Brownsboro": ["75756"],
    "Brownsville": ["78520", "78521", "78522", "78523", "78526"],
    "Brownwood": ["76801", "76804"],
    "Bruceville": ["76630"],
    "Bruni": ["78344"],
    "Bryan": ["77801", "77802", "77803", "77805", "77806", "77807", "77808"],
    "Bryson": ["76427"],
    "Buchanan Dam": ["78609"],
    "Buckholts": ["76518"],
    "Buda": ["78610"],
    "Buffalo": ["75831"],
    "Buffalo Gap": ["79508"],
    "Bula": ["79320"],
    "Bullard": ["75757"],
    "Bulverde": ["78163"],
    "Buna": ["77612"],
    "Burkburnett": ["76354"],
    "Burkett": ["76828"],
    "Burkeville": ["75932"],
    "Burleson": ["76028", "76097"],
    "Burlington": ["76519"],
    "Burnet": ["78611"],
    "Burton": ["77835"],
    "Bushland": ["79012"],
    "Byers": ["76357"],
    "Bynum": ["76631"],
    "Cactus": ["79013"],
    "Caddo": ["76429"],
    "Caddo Mills": ["75135"],
    "Caldwell": ["77836"],
    "Call": ["75933"],
    "Calliham": ["78007"],
    "Calvert": ["77837"],
    "Camden": ["75934"],
    "Cameron": ["76520"],
    "Camp Wood": ["78833"],
    "Campbell": ["75422"],
    "Campbellton": ["78008"],
    "Canadian": ["79014"],
    "Canton": ["75103"],
    "Canutillo": ["79835"],
    "Canyon": ["79015", "79016"],
    "Canyon Lake": ["78133"],
    "Carbon": ["76435"],
    "Carlsbad": ["76934"],
    "Carlton": ["76436"],
    "Carmine": ["78932"],
    "Carrizo Springs": ["78834"],
    "Carrollton": ["75006", "75007", "75010", "75011"],
    "Carthage": ["75633"],
    "Cason": ["75636"],
    "Castell": ["76831"],
    "Castroville": ["78009"],
    "Cat Spring": ["78933"],
    "Catarina": ["78836"],
    "Cayuga": ["75832"],
    "Cedar Creek": ["78612"],
    "Cedar Hill": ["75104", "75106"],
    "Cedar Lane": ["77415"],
    "Cedar Park": ["78613", "78630"],
    "Cee Vee": ["79223"],
    "Celeste": ["75423"],
    "Celina": ["75009"],
    "Center": ["75935"],
    "Center Point": ["78010"],
    "Centerville": ["75833"],
    "Centralia": ["75834"],
    "Chandler": ["75758"],
    "Channelview": ["77530"],
    "Channing": ["79018"],
    "Chapman Ranch": ["78347"],
    "Chappell Hill": ["77426"],
    "Charlotte": ["78011"],
    "Chatfield": ["75105"],
    "Cherokee": ["76832"],
    "Chester": ["75936"],
    "Chico": ["76431"],
    "Chicota": ["75425"],
    "Childress": ["79201"],
    "Chillicothe": ["79225"],
    "Chilton": ["76632"],
    "China": ["77613"],
    "China Spring": ["76633"],
    "Chireno": ["75937"],
    "Chriesman": ["77838"],
    "Christine": ["78012"],
    "Christoval": ["76935"],
    "Cibolo": ["78108"],
    "Cisco": ["76437"],
    "Clarendon": ["79226"],
    "Clarksville": ["75426"],
    "Claude": ["79019"],
    "Clayton": ["75637"],
    "Cleburne": ["76031", "76033"],
    "Cleveland": ["77327", "77328"],
    "Clifton": ["76634"],
    "Clint": ["79836"],
    "Clute": ["77531"],
    "Clyde": ["79510"],
    "Coahoma": ["79511"],
    "Coldspring": ["77331"],
    "Coleman": ["76834"],
    "College Station": ["77840", "77841", "77842", "77843", "77844", "77845"],
    "Collegeport": ["77428"],
    "Colleyville": ["76034"],
    "Collinsville": ["76233"],
    "Colmesneil": ["75938"],
    "Colorado City": ["79512"],
    "Columbus": ["78934"],
    "Comanche": ["76442"],
    "Combes": ["78535"],
    "Comfort": ["78013"],
    "Commerce": ["75428", "75429"],
    "Como": ["75431"],
    "Comstock": ["78837"],
    "Concan": ["78838"],
    "Concepcion": ["78349"],
    "Concord": ["77850"],
    "Conroe": ["77301", "77302", "77303", "77304", "77305", "77306", "77384", "77385"],
    "Converse": ["78109"],
    "Cookville": ["75558"],
    "Coolidge": ["76635"],
    "Cooper": ["75432"],
    "Copeville": ["75121"],
    "Coppell": ["75019", "75099"],
    "Copperas Cove": ["76522"],
    "Corpus Christi": ["78401", "78402", "78403", "78404", "78405", "78406", "78407", "78408", "78409", "78410", "78411", "78412", "78413", "78414", "78415", "78416", "78417", "78418", "78419", "78426", "78427", "78460", "78461", "78463", "78465", "78466", "78467", "78468", "78469", "78470", "78471", "78472", "78473", "78474", "78475", "78476", "78477", "78478", "78480"],
    "Corrigan": ["75939"],
    "Corsicana": ["75109", "75110", "75151"],
    "Cost": ["78614"],
    "Cotton Center": ["79021"],
    "Cotulla": ["78014"],
    "Coupland": ["78615"],
    "Covington": ["76636"],
    "Coyanosa": ["79730"],
    "Crandall": ["75114"],
    "Crane": ["79731"],
    "Cranfills Gap": ["76637"],
    "Crawford": ["76638"],
    "Cresson": ["76035"],
    "Crockett": ["75835"],
    "Crosby": ["77532"],
    "Crosbyton": ["79322"],
    "Cross Plains": ["76443"],
    "Crowell": ["79227"],
    "Crowley": ["76036"],
    "Crystal City": ["78839"],
    "Cuero": ["77954"],
    "Cumby": ["75433"],
    "Cuney": ["75759"],
    "Cunningham": ["75434"],
    "Cushing": ["75760"],
    "Cypress": ["77410", "77429", "77433"],
    "D Hanis": ["78850"],
    "Daingerfield": ["75638"],
    "Daisetta": ["77533"],
    "Dale": ["78616"],
    "Dalhart": ["79022"],
    "Dallardsville": ["77332"],
    "Dallas": ["75201", "75202", "75203", "75204", "75205", "75206", "75207", "75208", "75209", "75210", "75211", "75212", "75214", "75215", "75216", "75217", "75218", "75219", "75220", "75221", "75222", "75223", "75224", "75225", "75226", "75227", "75228", "75229", "75230", "75231", "75232", "75233", "75234", "75235", "75236", "75237", "75238", "75240", "75241", "75242", "75243", "75244", "75245", "75246", "75247", "75248", "75249", "75250", "75251", "75252", "75253", "75254", "75258", "75260", "75261", "75262", "75263", "75264", "75265", "75266", "75267", "75270", "75275", "75277", "75283", "75284", "75285", "75286", "75287", "75301", "75303", "75310", "75312", "75313", "75315", "75320", "75323", "75326", "75334", "75336", "75339", "75340", "75342", "75343", "75344", "75353", "75354", "75355", "75356", "75357", "75358", "75359", "75360", "75363", "75364", "75367", "75368", "75370", "75371", "75372", "75373", "75374", "75376", "75378", "75379", "75380", "75381", "75382", "75386", "75387", "75388", "75389", "75390", "75391", "75392", "75393", "75394", "75395", "75396", "75397", "75398"],
    "Damon": ["77430"],
    "Danbury": ["77534"],
    "Danciger": ["77431"],
    "Danevang": ["77432"],
    "Darrouzett": ["79024"],
    "Davilla": ["76523"],
    "Dawn": ["79025"],
    "Dawson": ["76639"],
    "Dayton": ["77535"],
    "De Berry": ["75639"],
    "De Kalb": ["75559"],
    "De Leon": ["76444"],
    "Deanville": ["77852"],
    "Decatur": ["76234"],
    "Deer Park": ["77536"],
    "Del Rio": ["78840", "78841", "78842", "78847"],
    "Del Valle": ["78617"],
    "Dell City": ["79837"],
    "Delmita": ["78536"],
    "Denison": ["75020", "75021"],
    "Dennis": ["76439"],
    "Denton": ["76201", "76202", "76203", "76204", "76205", "76206", "76207", "76208", "76209", "76210"],
    "Denver City": ["79323"],
    "Deport": ["75435"],
    "Desdemona": ["76445"],
    "Desoto": ["75115", "75123"],
    "Detroit": ["75436"],
    "Devers": ["77538"],
    "Devine": ["78016"],
    "Deweyville": ["77614"],
    "Diana": ["75640"],
    "Diboll": ["75941"],
    "Dickens": ["79229"],
    "Dickinson": ["77539"],
    "Dike": ["75437"],
    "Dilley": ["78017"],
    "Dime Box": ["77853"],
    "Dimmitt": ["79027"],
    "Dinero": ["78350"],
    "Dobbin": ["77333"],
    "Dodd City": ["75438"],
    "Dodge": ["77334"],
    "Dodson": ["79230"],
    "Donie": ["75838"],
    "Donna": ["78537"],
    "Doole": ["76836"],
    "Doss": ["78618"],
    "Doucette": ["75942"],
    "Dougherty": ["79231"],
    "Douglass": ["75943"],
    "Douglassville": ["75560"],
    "Driftwood": ["78619"],
    "Dripping Springs": ["78620"],
    "Driscoll": ["78351"],
    "Dryden": ["78851"],
    "Dublin": ["76446"],
    "Dumas": ["79029"],
    "Duncanville": ["75116", "75137", "75138"],
    "Dunn": ["79516"],
    "Dyess AFB": ["79607"],
    "Eagle Lake": ["77434"],
    "Eagle Pass": ["78852", "78853"],
    "Early": ["76802", "76803"],
    "Earth": ["79031"],
    "East Bernard": ["77435"],
    "Eastland": ["76448"],
    "Easton": ["75641"],
    "Ecleto": ["78111"],
    "Ector": ["75439"],
    "Edcouch": ["78538"],
    "Eddy": ["76524"],
    "Eden": ["76837"],
    "Edgewood": ["75117"],
    "Edinburg": ["78539", "78540", "78541", "78542"],
    "Edmonson": ["79032"],
    "Edna": ["77957"],
    "Edroy": ["78352"],
    "Egypt": ["77436"],
    "El Campo": ["77437"],
    "El Indio": ["78860"],
    "El Paso": ["79901", "79902", "79903", "79904", "79905", "79906", "79907", "79908", "79910", "79911", "79912", "79913", "79914", "79915", "79917", "79920", "79922", "79923", "79924", "79925", "79926", "79927", "79928", "79929", "79930", "79931", "79932", "79934", "79935", "79936", "79937", "79938", "79940", "79941", "79942", "79943", "79944", "79945", "79946", "79947", "79948", "79949", "79950", "79951", "79952", "79953", "79954", "79955", "79958", "79960", "79961", "79968", "79976", "79978", "79980", "79990", "79995", "79996", "79997", "79998", "79999", "88510", "88511", "88512", "88513", "88514", "88515", "88516", "88517", "88518", "88519", "88520", "88521", "88523", "88524", "88525", "88526", "88527", "88528", "88529", "88530", "88531", "88532", "88533", "88534", "88535", "88536", "88538", "88539", "88540", "88541", "88542", "88543", "88544", "88545", "88546", "88547", "88548", "88549", "88550", "88553", "88554", "88555", "88556", "88557", "88558", "88559", "88560", "88561", "88562", "88563", "88565", "88566", "88567", "88568", "88569", "88570", "88571", "88572", "88573", "88574", "88575", "88576", "88577", "88578", "88579", "88580", "88581", "88582", "88583", "88584", "88585", "88586", "88587", "88588", "88589", "88590", "88595"],
    "Eldorado": ["76936"],
    "Electra": ["76360"],
    "Elgin": ["78621"],
    "Elkhart": ["75839"],
    "Ellinger": ["78938"],
    "Elm Mott": ["76640"],
    "Elmaton": ["77440"],
    "Elmendorf": ["78112"],
    "Elmo": ["75118"],
    "Elsa": ["78543"],
    "Elysian Fields": ["75642"],
    "Emory": ["75440"],
    "Encinal": ["78019"],
    "Encino": ["78353"],
    "Energy": ["76452"],
    "Enloe": ["75441"],
    "Ennis": ["75119", "75120"],
    "Enochs": ["79324"],
    "Eola": ["76937"],
    "Era": ["76238"],
    "Estelline": ["79233"],
    "Etoile": ["75944"],
    "Euless": ["76039", "76040"],
    "Eustace": ["75124"],
    "Evadale": ["77615"],
    "Evant": ["76525"],
    "Fabens": ["79838"],
    "Fairfield": ["75840"],
    "Falcon Heights": ["78545"],
    "Falfurrias": ["78355"],
    "Falls City": ["78113"],
    "Fannin": ["77960"],
    "Farmersville": ["75442"],
    "Farnsworth": ["79033"],
    "Farwell": ["79325"],
    "Fate": ["75132"],
    "Fayetteville": ["78940"],
    "Fentress": ["78622"],
    "Ferris": ["75125"],
    "Fieldton": ["79326"],
    "Fischer": ["78623"],
    "Flat": ["76526"],
    "Flatonia": ["78941"],
    "Flint": ["75762"],
    "Flomot": ["79234"],
    "Florence": ["76527"],
    "Floresville": ["78114"],
    "Flower Mound": ["75022", "75027", "75028"],
    "Floydada": ["79235"],
    "Fluvanna": ["79517"],
    "Flynn": ["77855"],
    "Follett": ["79034"],
    "Forestburg": ["76239"],
    "Forney": ["75126"],
    "Forreston": ["76041"],
    "Forsan": ["79733"],
    "Fort Bliss": ["79916", "79918"],
    "Fort Davis": ["79734"],
    "Fort Hancock": ["79839"],
    "Fort Hood": ["76544"],
    "Fort Mc Kavett": ["76841"],
    "Fort Stockton": ["79735"],
    "Fort Worth": ["76101", "76102", "76103", "76104", "76105", "76106", "76107", "76108", "76109", "76110", "76111", "76112", "76113", "76114", "76115", "76116", "76118", "76119", "76120", "76121", "76122", "76123", "76124", "76126", "76129", "76130", "76131", "76132", "76133", "76134", "76135", "76136", "76137", "76140", "76147", "76148", "76150", "76155", "76161", "76162", "76163", "76164", "76166", "76177", "76179", "76181", "76185", "76190", "76191", "76192", "76193", "76195", "76196", "76197", "76198", "76199"],
    "Fowlerton": ["78021"],
    "Francitas": ["77961"],
    "Franklin": ["77856"],
    "Frankston": ["75763"],
    "Fred": ["77616"],
    "Fredericksburg": ["78624"],
    "Fredonia": ["76842"],
    "Freeport": ["77541", "77542"],
    "Freer": ["78357"],
    "Fresno": ["77545"],
    "Friendswood": ["77546", "77549"],
    "Friona": ["79035"],
    "Frisco": ["75033", "75034", "75035", "75036"],
    "Fritch": ["79036"],
    "Frost": ["76641"],
    "Fruitvale": ["75127"],
    "Fulshear": ["77441"],
    "Fulton": ["78358"],
    "Gail": ["79738"],
    "Gainesville": ["76240", "76241"],
    "Galena Park": ["77547"],
    "Gallatin": ["75764"],
    "Galveston": ["77550", "77551", "77552", "77553", "77554", "77555"],
    "Ganado": ["77962"],
    "Garciasville": ["78547"],
    "Garden City": ["79739"],
    "Gardendale": ["79758"],
    "Garland": ["75040", "75041", "75042", "75043", "75044", "75045", "75046", "75047", "75049"],
    "Garrison": ["75946"],
    "Garwood": ["77442"],
    "Gary": ["75643"],
    "Gatesville": ["76528", "76596", "76597", "76598", "76599"],
    "Gause": ["77857"],
    "George West": ["78022"],
    "Georgetown": ["78626", "78627", "78628", "78633"],
    "Geronimo": ["78115"],
    "Giddings": ["78942"],
    "Gilchrist": ["77617"],
    "Gillett": ["78116"],
    "Gilmer": ["75644", "75645"],
    "Girard": ["79518"],
    "Girvin": ["79740"],
    "Gladewater": ["75647"],
    "Glen Flora": ["77443"],
    "Glen Rose": ["76043"],
    "Glidden": ["78943"],
    "Gober": ["75443"],
    "Godley": ["76044"],
    "Golden": ["75444"],
    "Goldsboro": ["79519"],
    "Goldsmith": ["79741"],
    "Goldthwaite": ["76844"],
    "Goliad": ["77963"],
    "Gonzales": ["78629"],
    "Goodfellow AFB": ["76908"],
    "Goodrich": ["77335"],
    "Gordon": ["76453"],
    "Gordonville": ["76245"],
    "Goree": ["76363"],
    "Gorman": ["76454"],
    "Gouldbusk": ["76845"],
    "Graford": ["76449"],
    "Graham": ["76450"],
    "Granbury": ["76048", "76049"],
    "Grand Prairie": ["75050", "75051", "75052", "75053", "75054"],
    "Grand Saline": ["75140"],
    "Grandfalls": ["79742"],
    "Grandview": ["76050"],
    "Granger": ["76530"],
    "Grapeland": ["75844"],
    "Grapevine": ["76051", "76099"],
    "Greenville": ["75401", "75402", "75403", "75404"],
    "Greenwood": ["76246"],
    "Gregory": ["78359"],
    "Groesbeck": ["76642"],
    "Groom": ["79039"],
    "Groves": ["77619"],
    "Groveton": ["75845"],
    "Grulla": ["78548"],
    "Gruver": ["79040"],
    "Guerra": ["78360"],
    "Gunter": ["75058"],
    "Gustine": ["76455"],
    "Guthrie": ["79236"],
    "Guy": ["77444"],
    "Hale Center": ["79041"],
    "Hallettsville": ["77964"],
    "Hallsville": ["75650"],
    "Haltom City": ["76117"],
    "Hamilton": ["76531"],
    "Hamlin": ["79520"],
    "Hamshire": ["77622"],
    "Hankamer": ["77560"],
    "Happy": ["79042"],
    "Hardin": ["77561"],
    "Hargill": ["78549"],
    "Harker Heights": ["76548"],
    "Harleton": ["75651"],
    "Harlingen": ["78550", "78551", "78552", "78553"],
    "Harper": ["78631"],
    "Harrold": ["76364"],
    "Hart": ["79043"],
    "Hartley": ["79044"],
    "Harwood": ["78632"],
    "Haskell": ["79521"],
    "Haslet": ["76052"],
    "Hawkins": ["75765"],
    "Hawley": ["79525"],
    "Hearne": ["77859"],
    "Hebbronville": ["78361"],
    "Hedley": ["79237"],
    "Heidenheimer": ["76533"],
    "Helotes": ["78023"],
    "Hemphill": ["75948"],
    "Hempstead": ["77445"],
    "Henderson": ["75652", "75653", "75654"],
    "Henrietta": ["76365"],
    "Hereford": ["79045"],
    "Hermleigh": ["79526"],
    "Hewitt": ["76643"],
    "Hext": ["76848"],
    "Hico": ["76457"],
    "Hidalgo": ["78557"],
    "Higgins": ["79046"],
    "High Island": ["77623"],
    "Highlands": ["77562"],
    "Hillister": ["77624"],
    "Hillsboro": ["76645"],
    "Hitchcock": ["77563"],
    "Hobson": ["78117"],
    "Hochheim": ["77967"],
    "Hockley": ["77447"],
    "Holland": ["76534"],
    "Holliday": ["76366"],
    "Hondo": ["78861"],
    "Honey Grove": ["75446"],
    "Hooks": ["75561"],
    "Horseshoe Bay": ["78657"],
    "Houston": ["77001", "77002", "77003", "77004", "77005", "77006", "77007", "77008", "77009", "77010", "77011", "77012", "77013", "77014", "77015", "77016", "77017", "77018", "77019", "77020", "77021", "77022", "77023", "77024", "77025", "77026", "77027", "77028", "77029", "77030", "77031", "77032", "77033", "77034", "77035", "77036", "77037", "77038", "77039", "77040", "77041", "77042", "77043", "77044", "77045", "77046", "77047", "77048", "77049", "77050", "77051", "77052", "77053", "77054", "77055", "77056", "77057", "77058", "77059", "77060", "77061", "77062", "77063", "77064", "77065", "77066", "77067", "77068", "77069", "77070", "77071", "77072", "77073", "77074", "77075", "77076", "77077", "77078", "77079", "77080", "77081", "77082", "77083", "77084", "77085", "77086", "77087", "77088", "77089", "77090", "77091", "77092", "77093", "77094", "77095", "77096", "77097", "77098", "77099", "77201", "77202", "77203", "77204", "77205", "77206", "77207", "77208", "77209", "77210", "77212", "77213", "77215", "77216", "77217", "77218", "77219", "77220", "77221", "77222", "77223", "77224", "77225", "77226", "77227", "77228", "77229", "77230", "77231", "77233", "77234", "77235", "77236", "77237", "77238", "77240", "77241", "77242", "77243", "77244", "77245", "77246", "77247", "77248", "77249", "77250", "77251", "77252", "77253", "77254", "77255", "77256", "77257", "77258", "77259", "77260", "77261", "77262", "77263", "77265", "77266", "77267", "77268", "77269", "77270", "77271", "77272", "77273", "77274", "77275", "77276", "77277", "77278", "77279", "77280", "77282", "77284", "77285", "77286", "77287", "77288", "77289", "77290", "77291", "77292", "77293", "77294", "77296", "77297", "77298", "77299"],
    "Howe": ["75459"],
    "Hubbard": ["76648"],
    "Huffman": ["77336"],
    "Hufsmith": ["77337"],
    "Hughes Springs": ["75656"],
    "Hull": ["77564"],
    "Humble": ["77338", "77346", "77347", "77396"],
    "Hungerford": ["77448"],
    "Hunt": ["78024"],
    "Huntington": ["75949"],
    "Huntsville": ["77320", "77340", "77341", "77342", "77343", "77344", "77348", "77349"],
    "Hurst": ["76053", "76054"],
    "Hutchins": ["75141"],
    "Hutto": ["78634"],
    "Hye": ["78635"],
    "Idalou": ["79329"],
    "Imperial": ["79743"],
    "Industry": ["78944"],
    "Inez": ["77968"],
    "Ingleside": ["78362"],
    "Ingram": ["78025"],
    "Iola": ["77861"],
    "Iowa Park": ["76367"],
    "Ira": ["79527"],
    "Iraan": ["79744"],
    "Iredell": ["76649"],
    "Irene": ["76650"],
    "Irving": ["75014", "75015", "75016", "75017", "75037", "75038", "75039", "75059", "75060", "75061", "75062", "75063", "75064"],
    "Italy": ["76651"],
    "Itasca": ["76055"],
    "Ivanhoe": ["75447"],
    "Jacksboro": ["76458"],
    "Jacksonville": ["75766"],
    "Jarrell": ["76537"],
    "Jasper": ["75951"],
    "Jayton": ["79528"],
    "Jbsa Ft Sam Houston": ["78234"],
    "Jbsa Lackland": ["78236"],
    "Jbsa Randolph": ["78150"],
    "Jefferson": ["75657"],
    "Jermyn": ["76459"],
    "Jewett": ["75846"],
    "Joaquin": ["75954"],
    "Johnson City": ["78636"],
    "Joinerville": ["75658"],
    "Jonesboro": ["76538"],
    "Jonesville": ["75659"],
    "Josephine": ["75164"],
    "Joshua": ["76058"],
    "Jourdanton": ["78026"],
    "Judson": ["75660"],
    "Junction": ["76849"],
    "Justiceburg": ["79330"],
    "Justin": ["76247"],
    "Kamay": ["76369"],
    "Karnack": ["75661"],
    "Karnes City": ["78118"],
    "Katy": ["77449", "77450", "77491", "77492", "77493", "77494"],
    "Kaufman": ["75142"],
    "Keene": ["76059"],
    "Keller": ["76244", "76248"],
    "Kemah": ["77565"],
    "Kemp": ["75143"],
    "Kempner": ["76539"],
    "Kendalia": ["78027"],
    "Kendleton": ["77451"],
    "Kenedy": ["78119"],
    "Kennard": ["75847"],
    "Kennedale": ["76060"],
    "Kenney": ["77452"],
    "Kerens": ["75144"],
    "Kermit": ["79745"],
    "Kerrick": ["79051"],
    "Kerrville": ["78028", "78029"],
    "Kildare": ["75562"],
    "Kilgore": ["75662", "75663"],
    "Killeen": ["76540", "76541", "76542", "76543", "76545", "76546", "76547", "76549"],
    "Kingsbury": ["78638"],
    "Kingsland": ["78639"],
    "Kingsville": ["78363", "78364"],
    "Kingwood": ["77325", "77339", "77345"],
    "Kirbyville": ["75956"],
    "Kirvin": ["75848"],
    "Klondike": ["75448"],
    "Knickerbocker": ["76939"],
    "Knippa": ["78870"],
    "Knott": ["79748"],
    "Knox City": ["79529"],
    "Kopperl": ["76652"],
    "Kosse": ["76653"],
    "Kountze": ["77625"],
    "Kress": ["79052"],
    "Krum": ["76249"],
    "Kurten": ["77862"],
    "Kyle": ["78640"],
    "La Blanca": ["78558"],
    "La Coste": ["78039"],
    "La Feria": ["78559"],
    "La Grange": ["78945"],
    "La Joya": ["78560"],
    "La Marque": ["77568"],
    "La Porte": ["77571", "77572"],
    "La Pryor": ["78872"],
    "La Salle": ["77969"],
    "La Vernia": ["78121"],
    "La Villa": ["78562"],
    "La Ward": ["77970"],
    "Ladonia": ["75449"],
    "Laguna Park": ["76644"],
    "Laird Hill": ["75666"],
    "Lake Creek": ["75450"],
    "Lake Dallas": ["75065"],
    "Lake Jackson": ["77566"],
    "Lakeview": ["79239"],
    "Lamesa": ["79331"],
    "Lampasas": ["76550"],
    "Lancaster": ["75134", "75146"],
    "Lane City": ["77453"],
    "Laneville": ["75667"],
    "Langtry": ["78871"],
    "Laredo": ["78040", "78041", "78042", "78043", "78044", "78045", "78046", "78049"],
    "Larue": ["75770"],
    "Lasara": ["78561"],
    "Latexo": ["75849"],
    "Laughlin AFB": ["78843"],
    "Lavon": ["75166"],
    "Lawn": ["79530"],
    "Lazbuddie": ["79053"],
    "League City": ["77573", "77574"],
    "Leakey": ["78873"],
    "Leander": ["78641", "78645", "78646"],
    "Ledbetter": ["78946"],
    "Leesburg": ["75451"],
    "Leesville": ["78122"],
    "Lefors": ["79054"],
    "Leggett": ["77350"],
    "Lelia Lake": ["79240"],
    "Leming": ["78050"],
    "Lenorah": ["79749"],
    "Leona": ["75850"],
    "Leonard": ["75452"],
    "Leroy": ["76654"],
    "Levelland": ["79336", "79338"],
    "Lewisville": ["75029", "75057", "75067", "75077"],
    "Lexington": ["78947"],
    "Liberty": ["77575"],
    "Liberty Hill": ["78642"],
    "Lillian": ["76061"],
    "Lincoln": ["78948"],
    "Lindale": ["75771"],
    "Linden": ["75563"],
    "Lindsay": ["76250"],
    "Lingleville": ["76461"],
    "Linn": ["78563"],
    "Lipan": ["76462"],
    "Lipscomb": ["79056"],
    "Lissie": ["77454"],
    "Little Elm": ["75068"],
    "Little River Academy": ["76554"],
    "Littlefield": ["79339"],
    "Liverpool": ["77577"],
    "Livingston": ["77351", "77399"],
    "Llano": ["78643"],
    "Lockhart": ["78644"],
    "Lockney": ["79241"],
    "Lodi": ["75564"],
    "Lohn": ["76852"],
    "Lolita": ["77971"],
    "Lometa": ["76853"],
    "London": ["76854"],
    "Lone Oak": ["75453"],
    "Lone Star": ["75668"],
    "Long Branch": ["75669"],
    "Longview": ["75601", "75602", "75603", "75604", "75605", "75606", "75607", "75608", "75615"],
    "Loop": ["79342"],
    "Lopeno": ["78564"],
    "Loraine": ["79532"],
    "Lorena": ["76655"],
    "Lorenzo": ["79343"],
    "Los Ebanos": ["78565"],
    "Los Fresnos": ["78566"],
    "Los Indios": ["78567"],
    "Lott": ["76656"],
    "Louise": ["77455"],
    "Lovelady": ["75851"],
    "Loving": ["76460"],
    "Lowake": ["76855"],
    "Lozano": ["78568"],
    "Lubbock": ["79401", "79402", "79403", "79404", "79405", "79406", "79407", "79408", "79409", "79410", "79411", "79412", "79413", "79414", "79415", "79416", "79423", "79424", "79430", "79452", "79453", "79457", "79464", "79490", "79491", "79493", "79499"],
    "Lueders": ["79533"],
    "Lufkin": ["75901", "75902", "75903", "75904", "75915"],
    "Luling": ["78648"],
    "Lumberton": ["77657"],
    "Lyford": ["78569"],
    "Lyons": ["77863"],
    "Lytle": ["78052"],
    "Mabank": ["75147", "75156"],
    "Macdona": ["78054"],
    "Madisonville": ["77864"],
    "Magnolia": ["77353", "77354", "77355"],
    "Malakoff": ["75148"],
    "Malone": ["76660"],
    "Manchaca": ["78652"],
    "Manor": ["78653"],
    "Mansfield": ["76063"],
    "Manvel": ["77578"],
    "Maple": ["79344"],
    "Marathon": ["79842"],
    "Marble Falls": ["78654"],
    "Marfa": ["79843"],
    "Marietta": ["75566"],
    "Marion": ["78124"],
    "Markham": ["77456"],
    "Marlin": ["76661"],
    "Marquez": ["77865"],
    "Marshall": ["75670", "75671", "75672"],
    "Mart": ["76664"],
    "Martindale": ["78655"],
    "Martinsville": ["75958"],
    "Maryneal": ["79535"],
    "Mason": ["76856"],
    "Masterson": ["79058"],
    "Matador": ["79244"],
    "Matagorda": ["77457"],
    "Mathis": ["78368"],
    "Maud": ["75567"],
    "Mauriceville": ["77626"],
    "Maxwell": ["78656"],
    "May": ["76857"],
    "Maydelle": ["75772"],
    "Maypearl": ["76064"],
    "Mc Camey": ["79752"],
    "Mc Caulley": ["79534"],
    "Mc Dade": ["78650"],
    "Mc Gregor": ["76657"],
    "Mc Leod": ["75565"],
    "Mc Neil": ["78651"],
    "Mc Queeney": ["78123"],
    "Mcadoo": ["79243"],
    "Mcallen": ["78501", "78502", "78503", "78504", "78505"],
    "Mcfaddin": ["77973"],
    "Mckinney": ["75069", "75070", "75071", "75072"],
    "Mclean": ["79057"],
    "Meadow": ["79345"],
    "Medina": ["78055"],
    "Megargel": ["76370"],
    "Melissa": ["75454"],
    "Melvin": ["76858"],
    "Memphis": ["79245"],
    "Menard": ["76859"],
    "Mentone": ["79754"],
    "Mercedes": ["78570"],
    "Mereta": ["76940"],
    "Meridian": ["76665"],
    "Merit": ["75458"],
    "Merkel": ["79536"],
    "Mertens": ["76666"],
    "Mertzon": ["76941"],
    "Mesquite": ["75149", "75150", "75181", "75185", "75187"],
    "Mexia": ["76667"],
    "Meyersville": ["77974"],
    "Miami": ["79059"],
    "Mico": ["78056"],
    "Midfield": ["77458"],
    "Midkiff": ["79755"],
    "Midland": ["79701", "79702", "79703", "79704", "79705", "79706", "79707", "79708", "79710", "79711", "79712"],
    "Midlothian": ["76065"],
    "Midway": ["75852"],
    "Milam": ["75959"],
    "Milano": ["76556"],
    "Miles": ["76861"],
    "Milford": ["76670"],
    "Millersview": ["76862"],
    "Millican": ["77866"],
    "Millsap": ["76066"],
    "Minden": ["75680"],
    "Mineola": ["75773"],
    "Mineral": ["78125"],
    "Mineral Wells": ["76067", "76068"],
    "Mingus": ["76463"],
    "Mirando City": ["78369"],
    "Mission": ["78572", "78573", "78574"],
    "Missouri City": ["77459", "77489"],
    "Mobeetie": ["79061"],
    "Monahans": ["79756"],
    "Mont Belvieu": ["77580"],
    "Montague": ["76251"],
    "Montalba": ["75853"],
    "Montgomery": ["77316", "77356"],
    "Moody": ["76557"],
    "Moore": ["78057"],
    "Moran": ["76464"],
    "Morgan": ["76671"],
    "Morgan Mill": ["76465"],
    "Morse": ["79062"],
    "Morton": ["79346"],
    "Moscow": ["75960"],
    "Moulton": ["77975"],
    "Mound": ["76558"],
    "Mount Calm": ["76673"],
    "Mount Enterprise": ["75681"],
    "Mount Pleasant": ["75455", "75456"],
    "Mount Vernon": ["75457"],
    "Mountain Home": ["78058"],
    "Muenster": ["76252"],
    "Muldoon": ["78949"],
    "Muleshoe": ["79347"],
    "Mullin": ["76864"],
    "Mumford": ["77867"],
    "Munday": ["76371"],
    "Murchison": ["75778"],
    "Myra": ["76253"],
    "Nacogdoches": ["75961", "75962", "75963", "75964", "75965"],
    "Nada": ["77460"],
    "Naples": ["75568"],
    "Nash": ["75569"],
    "Natalia": ["78059"],
    "Naval Air Station Jrb": ["76127"],
    "Navasota": ["77868", "77869"],
    "Nazareth": ["79063"],
    "Neches": ["75779"],
    "Nederland": ["77627"],
    "Needville": ["77461"],
    "Nemo": ["76070"],
    "Nevada": ["75173"],
    "New Baden": ["77870"],
    "New Boston": ["75570"],
    "New Braunfels": ["78130", "78131", "78132", "78135"],
    "New Caney": ["77357"],
    "New Deal": ["79350"],
    "New Home": ["79383"],
    "New London": ["75682"],
    "New Summerfield": ["75780"],
    "New Ulm": ["78950"],
    "New Waverly": ["77358"],
    "Newark": ["76071"],
    "Newcastle": ["76372"],
    "Newton": ["75966"],
    "Nixon": ["78140"],
    "Nocona": ["76255"],
    "Nolan": ["79537"],
    "Nolanville": ["76559"],
    "Nome": ["77629"],
    "Nordheim": ["78141"],
    "Normangee": ["77871"],
    "Normanna": ["78142"],
    "North Houston": ["77315"],
    "North Richland Hills": ["76180", "76182"],
    "North Zulch": ["77872"],
    "Norton": ["76865"],
    "Notrees": ["79759"],
    "Novice": ["79538"],
    "Nursery": ["77976"],
    "O Brien": ["79539"],
    "Oakhurst": ["77359"],
    "Oakland": ["78951"],
    "Oakville": ["78060"],
    "Oakwood": ["75855"],
    "Odell": ["79247"],
    "Odem": ["78370"],
    "Odessa": ["79760", "79761", "79762", "79763", "79764", "79765", "79766", "79768", "79769"],
    "Odonnell": ["79351"],
    "Oglesby": ["76561"],
    "Oilton": ["78371"],
    "Oklaunion": ["76373"],
    "Old Glory": ["79540"],
    "Old Ocean": ["77463"],
    "Olden": ["76466"],
    "Olmito": ["78575"],
    "Olney": ["76374"],
    "Olton": ["79064"],
    "Omaha": ["75571"],
    "Onalaska": ["77360"],
    "Orange": ["77630", "77631", "77632"],
    "Orange Grove": ["78372"],
    "Orangefield": ["77639"],
    "Orchard": ["77464"],
    "Ore City": ["75683"],
    "Orla": ["79770"],
    "Ottine": ["78658"],
    "Ovalo": ["79541"],
    "Overton": ["75684"],
    "Ozona": ["76943"],
    "Paducah": ["79248"],
    "Paige": ["78659"],
    "Paint Rock": ["76866"],
    "Palacios": ["77465"],
    "Palestine": ["75801", "75802", "75803", "75882"],
    "Palmer": ["75152"],
    "Palo Pinto": ["76484"],
    "Paluxy": ["76467"],
    "Pampa": ["79065", "79066"],
    "Pandora": ["78143"],
    "Panhandle": ["79068"],
    "Panna Maria": ["78144"],
    "Panola": ["75685"],
    "Paradise": ["76073"],
    "Paris": ["75460", "75461", "75462"],
    "Pasadena": ["77501", "77502", "77503", "77504", "77505", "77506", "77507", "77508"],
    "Pattison": ["77466"],
    "Pattonville": ["75468"],
    "Pawnee": ["78145"],
    "Pearland": ["77581", "77584", "77588"],
    "Pearsall": ["78061"],
    "Peaster": ["76485"],
    "Pecan Gap": ["75469"],
    "Pecos": ["79772"],
    "Peggy": ["78062"],
    "Pendleton": ["76564"],
    "Penelope": ["76676"],
    "Penitas": ["78576"],
    "Pennington": ["75856"],
    "Penwell": ["79776"],
    "Pep": ["79353"],
    "Perrin": ["76486"],
    "Perryton": ["79070"],
    "Petersburg": ["79250"],
    "Petrolia": ["76377"],
    "Pettus": ["78146"],
    "Petty": ["75470"],
    "Pflugerville": ["78660", "78691"],
    "Pharr": ["78577"],
    "Pickton": ["75471"],
    "Pierce": ["77467"],
    "Pilot Point": ["76258"],
    "Pinehurst": ["77362"],
    "Pineland": ["75968"],
    "Pipe Creek": ["78063"],
    "Pittsburg": ["75686"],
    "Placedo": ["77977"],
    "Plains": ["79355"],
    "Plainview": ["79072", "79073"],
    "Plano": ["75023", "75024", "75025", "75026", "75074", "75075", "75086", "75093", "75094"],
    "Plantersville": ["77363"],
    "Pleasanton": ["78064"],
    "Pledger": ["77468"],
    "Plum": ["78952"],
    "Point": ["75472"],
    "Point Comfort": ["77978"],
    "Pointblank": ["77364"],
    "Pollok": ["75969"],
    "Ponder": ["76259"],
    "Pontotoc": ["76869"],
    "Poolville": ["76487"],
    "Port Aransas": ["78373"],
    "Port Arthur": ["77640", "77641", "77642", "77643"],
    "Port Bolivar": ["77650"],
    "Port Isabel": ["78578"],
    "Port Lavaca": ["77979"],
    "Port Mansfield": ["78598"],
    "Port Neches": ["77651"],
    "Port O Connor": ["77982"],
    "Porter": ["77365"],
    "Portland": ["78374"],
    "Post": ["79356"],
    "Poteet": ["78065"],
    "Poth": ["78147"],
    "Pottsboro": ["75076"],
    "Pottsville": ["76565"],
    "Powderly": ["75473"],
    "Powell": ["75153"],
    "Poynor": ["75782"],
    "Prairie Hill": ["76678"],
    "Prairie Lea": ["78661"],
    "Prairie View": ["77446"],
    "Premont": ["78375"],
    "Presidio": ["79845"],
    "Price": ["75687"],
    "Priddy": ["76870"],
    "Princeton": ["75407"],
    "Proctor": ["76468"],
    "Progreso": ["78579"],
    "Prosper": ["75078"],
    "Purdon": ["76679"],
    "Purmela": ["76566"],
    "Putnam": ["76469"],
    "Pyote": ["79777"],
    "Quail": ["79251"],
    "Quanah": ["79252"],
    "Queen City": ["75572"],
    "Quemado": ["78877"],
    "Quinlan": ["75474"],
    "Quitaque": ["79255"],
    "Quitman": ["75783"],
    "Rainbow": ["76077"],
    "Ralls": ["79357"],
    "Randolph": ["75475"],
    "Ranger": ["76470"],
    "Rankin": ["79778"],
    "Ransom Canyon": ["79366"],
    "Ratcliff": ["75858"],
    "Ravenna": ["75476"],
    "Raymondville": ["78580"],
    "Raywood": ["77582"],
    "Reagan": ["76680"],
    "Realitos": ["78376"],
    "Red Oak": ["75154"],
    "Red Rock": ["78662"],
    "Redford": ["79846"],
    "Redwater": ["75573"],
    "Refugio": ["78377"],
    "Reklaw": ["75784"],
    "Rhome": ["76078"],
    "Rice": ["75155"],
    "Richards": ["77873"],
    "Richardson": ["75080", "75081", "75082", "75083", "75085"],
    "Richland": ["76681"],
    "Richland Springs": ["76871"],
    "Richmond": ["77406", "77407", "77469"],
    "Riesel": ["76682"],
    "Ringgold": ["76261"],
    "Rio Frio": ["78879"],
    "Rio Grande City": ["78582"],
    "Rio Hondo": ["78583"],
    "Rio Medina": ["78066"],
    "Rio Vista": ["76093"],
    "Rising Star": ["76471"],
    "Riverside": ["77367"],
    "Riviera": ["78379"],
    "Roanoke": ["76262", "76299"],
    "Roans Prairie": ["77875"],
    "Roaring Springs": ["79256"],
    "Robert Lee": ["76945"],
    "Robstown": ["78380"],
    "Roby": ["79543"],
    "Rochelle": ["76872"],
    "Rochester": ["79544"],
    "Rock Island": ["77470"],
    "Rockdale": ["76567"],
    "Rockport": ["78381", "78382"],
    "Rocksprings": ["78880"],
    "Rockwall": ["75032", "75087"],
    "Rockwood": ["76873"],
    "Rogers": ["76569"],
    "Roma": ["78584"],
    "Romayor": ["77368"],
    "Roosevelt": ["76874"],
    "Ropesville": ["79358"],
    "Rosanky": ["78953"],
    "Roscoe": ["79545"],
    "Rosebud": ["76570"],
    "Rosenberg": ["77471"],
    "Rosharon": ["77583"],
    "Ross": ["76684"],
    "Rosser": ["75157"],
    "Rosston": ["76263"],
    "Rotan": ["79546"],
    "Round Mountain": ["78663"],
    "Round Rock": ["78664", "78665", "78680", "78681", "78682", "78683"],
    "Round Top": ["78954"],
    "Rowena": ["76875"],
    "Rowlett": ["75030", "75088", "75089"],
    "Roxton": ["75477"],
    "Royse City": ["75189"],
    "Rule": ["79547", "79548"],
    "Runge": ["78151"],
    "Rusk": ["75785"],
    "Rye": ["77369"],
    "Sabinal": ["78881"],
    "Sabine Pass": ["77655"],
    "Sachse": ["75048"],
    "Sacul": ["75788"],
    "Sadler": ["76264"],
    "Saint Hedwig": ["78152"],
    "Saint Jo": ["76265"],
    "Salado": ["76571"],
    "Salineno": ["78585"],
    "Salt Flat": ["79847"],
    "Saltillo": ["75478"],
    "Samnorwood": ["79077"],
    "San Angelo": ["76901", "76902", "76903", "76904", "76905", "76906", "76909"],
    "San Antonio": ["78201", "78202", "78203", "78204", "78205", "78206", "78207", "78208", "78209", "78210", "78211", "78212", "78213", "78214", "78215", "78216", "78217", "78218", "78219", "78220", "78221", "78222", "78223", "78224", "78225", "78226", "78227", "78228", "78229", "78230", "78231", "78232", "78233", "78235", "78237", "78238", "78239", "78240", "78241", "78242", "78243", "78244", "78245", "78246", "78247", "78248", "78249", "78250", "78251", "78252", "78253", "78254", "78255", "78256", "78257", "78258", "78259", "78260", "78261", "78262", "78263", "78264", "78265", "78266", "78268", "78269", "78270", "78275", "78278", "78279", "78280", "78283", "78284", "78285", "78286", "78287", "78288", "78289", "78291", "78292", "78293", "78294", "78295", "78296", "78297", "78298", "78299"],
    "San Augustine": ["75972"],
    "San Benito": ["78586"],
    "San Diego": ["78384"],
    "San Elizario": ["79849"],
    "San Felipe": ["77473"],
    "San Isidro": ["78588"],
    "San Juan": ["78589"],
    "San Marcos": ["78666", "78667"],
    "San Perlita": ["78590"],
    "San Saba": ["76877"],
    "San Ygnacio": ["78067"],
    "Sanderson": ["79848"],
    "Sandia": ["78383"],
    "Sanford": ["79078"],
    "Sanger": ["76266"],
    "Santa Anna": ["76878"],
    "Santa Elena": ["78591"],
    "Santa Fe": ["77510", "77517"],
    "Santa Maria": ["78592"],
    "Santa Rosa": ["78593"],
    "Santo": ["76472"],
    "Saragosa": ["79780"],
    "Saratoga": ["77585"],
    "Sarita": ["78385"],
    "Satin": ["76685"],
    "Savoy": ["75479"],
    "Schertz": ["78154"],
    "Schulenburg": ["78956"],
    "Schwertner": ["76573"],
    "Scotland": ["76379"],
    "Scottsville": ["75688"],
    "Scroggins": ["75480"],
    "Scurry": ["75158"],
    "Seabrook": ["77586"],
    "Seadrift": ["77983"],
    "Seagoville": ["75159"],
    "Seagraves": ["79359"],
    "Sealy": ["77474"],
    "Sebastian": ["78594"],
    "Seguin": ["78155", "78156"],
    "Selman City": ["75689"],
    "Seminole": ["79360"],
    "Seymour": ["76380"],
    "Shallowater": ["79363"],
    "Shamrock": ["79079"],
    "Sheffield": ["79781"],
    "Shelbyville": ["75973"],
    "Shepherd": ["77371"],
    "Sheppard AFB": ["76311"],
    "Sheridan": ["77475"],
    "Sherman": ["75090", "75091", "75092"],
    "Shiner": ["77984"],
    "Shiro": ["77876"],
    "Sidney": ["76474"],
    "Sierra Blanca": ["79851"],
    "Silsbee": ["77656"],
    "Silver": ["76949"],
    "Silverton": ["79257"],
    "Simms": ["75574"],
    "Simonton": ["77476"],
    "Sinton": ["78387"],
    "Skellytown": ["79080"],
    "Skidmore": ["78389"],
    "Slaton": ["79364"],
    "Slidell": ["76267"],
    "Smiley": ["78159"],
    "Smithville": ["78957"],
    "Smyer": ["79367"],
    "Snook": ["77878"],
    "Snyder": ["79549", "79550"],
    "Somerset": ["78069"],
    "Somerville": ["77879"],
    "Sonora": ["76950"],
    "Sour Lake": ["77659"],
    "South Bend": ["76481"],
    "South Houston": ["77587"],
    "South Padre Island": ["78597"],
    "South Plains": ["79258"],
    "Southlake": ["76092"],
    "Southmayd": ["76268"],
    "Spade": ["79369"],
    "Spearman": ["79081"],
    "Spicewood": ["78669"],
    "Splendora": ["77372"],
    "Spring": ["77373", "77379", "77380", "77381", "77382", "77383", "77386", "77387", "77388", "77389", "77391", "77393"],
    "Spring Branch": ["78070"],
    "Springlake": ["79082"],
    "Springtown": ["76082"],
    "Spur": ["79370"],
    "Spurger": ["77660"],
    "Stafford": ["77477", "77497"],
    "Stamford": ["79553"],
    "Stanton": ["79782"],
    "Staples": ["78670"],
    "Star": ["76880"],
    "Stephenville": ["76401", "76402"],
    "Sterling City": ["76951"],
    "Stinnett": ["79083"],
    "Stockdale": ["78160"],
    "Stonewall": ["78671"],
    "Stowell": ["77661"],
    "Stratford": ["79084"],
    "Strawn": ["76475"],
    "Streetman": ["75859"],
    "Sublime": ["77986"],
    "Sudan": ["79371"],
    "Sugar Land": ["77478", "77479", "77487", "77496", "77498"],
    "Sullivan City": ["78595"],
    "Sulphur Bluff": ["75481"],
    "Sulphur Springs": ["75482", "75483"],
    "Summerfield": ["79085"],
    "Sumner": ["75486"],
    "Sundown": ["79372"],
    "Sunnyvale": ["75182"],
    "Sunray": ["79086"],
    "Sunset": ["76270"],
    "Sutherland Springs": ["78161"],
    "Sweeny": ["77480"],
    "Sweet Home": ["77987"],
    "Sweetwater": ["79556"],
    "Sylvester": ["79560"],
    "Taft": ["78390"],
    "Tahoka": ["79373"],
    "Talco": ["75487"],
    "Talpa": ["76882"],
    "Tarpley": ["78883"],
    "Tarzan": ["79783"],
    "Tatum": ["75691"],
    "Taylor": ["76574"],
    "Teague": ["75860"],
    "Tehuacana": ["76686"],
    "Telegraph": ["76883"],
    "Telephone": ["75488"],
    "Telferner": ["77988"],
    "Tell": ["79259"],
    "Temple": ["76501", "76502", "76503", "76504", "76505", "76508"],
    "Tenaha": ["75974"],
    "Tennessee Colony": ["75861", "75880", "75884", "75886"],
    "Tennyson": ["76953"],
    "Terlingua": ["79852"],
    "Terrell": ["75160", "75161"],
    "Texarkana": ["75501", "75503", "75504", "75505", "75507", "75599"],
    "Texas City": ["77590", "77591", "77592"],
    "Texhoma": ["73960"],
    "Texline": ["79087"],
    "The Colony": ["75056"],
    "Thicket": ["77374"],
    "Thomaston": ["77989"],
    "Thompsons": ["77481"],
    "Thorndale": ["76577"],
    "Thornton": ["76687"],
    "Thrall": ["76578"],
    "Three Rivers": ["78071"],
    "Throckmorton": ["76483"],
    "Tilden": ["78072"],
    "Timpson": ["75975"],
    "Tioga": ["76271"],
    "Tivoli": ["77990"],
    "Tokio": ["79376"],
    "Tolar": ["76476"],
    "Tom Bean": ["75489"],
    "Tomball": ["77375", "77377"],
    "Tornillo": ["79853"],
    "Tow": ["78672"],
    "Toyah": ["79785"],
    "Toyahvale": ["79786"],
    "Trent": ["79561"],
    "Trenton": ["75490"],
    "Trinidad": ["75163"],
    "Trinity": ["75862"],
    "Troup": ["75789"],
    "Troy": ["76579"],
    "Tuleta": ["78162"],
    "Tulia": ["79088"],
    "Turkey": ["79261"],
    "Tuscola": ["79562"],
    "Tye": ["79563"],
    "Tyler": ["75701", "75702", "75703", "75704", "75705", "75706", "75707", "75708", "75709", "75710", "75711", "75712", "75713", "75798", "75799"],
    "Tynan": ["78391"],
    "Umbarger": ["79091"],
    "Universal City": ["78148"],
    "Utopia": ["78884"],
    "Uvalde": ["78801", "78802"],
    "Valentine": ["79854"],
    "Valera": ["76884"],
    "Valley Mills": ["76689"],
    "Valley Spring": ["76885"],
    "Valley View": ["76272"],
    "Van": ["75790"],
    "Van Alstyne": ["75495"],
    "Van Horn": ["79855"],
    "Van Vleck": ["77482"],
    "Vancourt": ["76955"],
    "Vanderbilt": ["77991"],
    "Vanderpool": ["78885"],
    "Vega": ["79092"],
    "Venus": ["76084"],
    "Veribest": ["76886"],
    "Vernon": ["76384", "76385"],
    "Victoria": ["77901", "77902", "77903", "77904", "77905"],
    "Vidor": ["77662", "77670"],
    "Village Mills": ["77663"],
    "Voca": ["76887"],
    "Von Ormy": ["78073"],
    "Voss": ["76888"],
    "Votaw": ["77376"],
    "Waco": ["76701", "76702", "76703", "76704", "76705", "76706", "76707", "76708", "76710", "76711", "76714", "76715", "76716", "76795", "76797", "76798", "76799"],
    "Wadsworth": ["77483"],
    "Waelder": ["78959"],
    "Waka": ["79093"],
    "Walburg": ["78673"],
    "Wall": ["76957"],
    "Waller": ["77484"],
    "Wallis": ["77485"],
    "Wallisville": ["77597"],
    "Walnut Springs": ["76690"],
    "Warda": ["78960"],
    "Waring": ["78074"],
    "Warren": ["77664"],
    "Warrenton": ["78961"],
    "Washington": ["77880"],
    "Waskom": ["75692"],
    "Water Valley": ["76958"],
    "Waxahachie": ["75165", "75167", "75168"],
    "Wayside": ["79094"],
    "Weatherford": ["76085", "76086", "76087", "76088"],
    "Webster": ["77598"],
    "Weesatche": ["77993"],
    "Weimar": ["78962"],
    "Weinert": ["76388"],
    "Weir": ["78674"],
    "Welch": ["79377"],
    "Wellborn": ["77881"],
    "Wellington": ["79095"],
    "Wellman": ["79378"],
    "Wells": ["75976"],
    "Weslaco": ["78596", "78599"],
    "West": ["76691"],
    "West Columbia": ["77486"],
    "West Point": ["78963"],
    "Westbrook": ["79565"],
    "Westhoff": ["77994"],
    "Westminster": ["75485"],
    "Weston": ["75097"],
    "Wharton": ["77488"],
    "Wheeler": ["79096"],
    "Wheelock": ["77882"],
    "White Deer": ["79097"],
    "White Oak": ["75693"],
    "Whiteface": ["79379"],
    "Whitehouse": ["75791"],
    "Whitesboro": ["76273"],
    "Whitewright": ["75491"],
    "Whitharral": ["79380"],
    "Whitney": ["76692"],
    "Whitsett": ["78075"],
    "Whitt": ["76490"],
    "Wichita Falls": ["76301", "76302", "76305", "76306", "76307", "76308", "76309", "76310"],
    "Wickett": ["79788"],
    "Wiergate": ["75977"],
    "Wildorado": ["79098"],
    "Willis": ["77318", "77378"],
    "Willow City": ["78675"],
    "Wills Point": ["75169"],
    "Wilmer": ["75172"],
    "Wilson": ["79381"],
    "Wimberley": ["78676"],
    "Windom": ["75492"],
    "Windthorst": ["76389"],
    "Winfield": ["75493"],
    "Wingate": ["79566"],
    "Wink": ["79789"],
    "Winnie": ["77665"],
    "Winnsboro": ["75494"],
    "Winona": ["75792"],
    "Winters": ["79567"],
    "Woden": ["75978"],
    "Wolfe City": ["75496"],
    "Wolfforth": ["79382"],
    "Woodlake": ["75865"],
    "Woodlawn": ["75694"],
    "Woodsboro": ["78393"],
    "Woodson": ["76491"],
    "Woodville": ["75979", "75990"],
    "Woodway": ["76712"],
    "Wortham": ["76693"],
    "Wrightsboro": ["78677"],
    "Wylie": ["75098"],
    "Yancey": ["78886"],
    "Yantis": ["75497"],
    "Yoakum": ["77995"],
    "Yorktown": ["78164"],
    "Zapata": ["78076"],
    "Zavalla": ["75980"],
    "Zephyr": ["76890"]
  },
  "UT": {
    "Alpine": ["84004"],
    "Altamont": ["84001"],
    "Alton": ["84710"],
    "Altonah": ["84002"],
    "American Fork": ["84003"],
    "Aneth": ["84510"],
    "Annabella": ["84711"],
    "Antimony": ["84712"],
    "Aurora": ["84620"],
    "Axtell": ["84621"],
    "Bear River City": ["84301"],
    "Beaver": ["84713"],
    "Beryl": ["84714"],
    "Bicknell": ["84715"],
    "Bingham Canyon": ["84006"],
    "Blanding": ["84511"],
    "Bluebell": ["84007"],
    "Bluff": ["84512"],
    "Bonanza": ["84008"],
    "Boulder": ["84716"],
    "Bountiful": ["84010", "84011"],
    "Brian Head": ["84719"],
    "Brigham City": ["84302"],
    "Bryce": ["84764"],
    "Bryce Canyon": ["84717"],
    "Cache Junction": ["84304"],
    "Cannonville": ["84718"],
    "Castle Dale": ["84513"],
    "Cedar City": ["84720", "84721"],
    "Cedar Valley": ["84013"],
    "Centerfield": ["84622"],
    "Centerville": ["84014"],
    "Central": ["84722"],
    "Chester": ["84623"],
    "Circleville": ["84723"],
    "Cisco": ["84515"],
    "Clarkston": ["84305"],
    "Clawson": ["84516"],
    "Clearfield": ["84015", "84016", "84089"],
    "Cleveland": ["84518"],
    "Coalville": ["84017"],
    "Collinston": ["84306"],
    "Corinne": ["84307"],
    "Cornish": ["84308"],
    "Croydon": ["84018"],
    "Dammeron Valley": ["84783"],
    "Delta": ["84624"],
    "Deweyville": ["84309"],
    "Draper": ["84020"],
    "Duchesne": ["84021"],
    "Duck Creek Village": ["84762"],
    "Dugway": ["84022"],
    "Dutch John": ["84023"],
    "Eagle Mountain": ["84005"],
    "East Carbon": ["84520"],
    "Echo": ["84024"],
    "Eden": ["84310"],
    "Elberta": ["84626"],
    "Elmo": ["84521"],
    "Elsinore": ["84724"],
    "Emery": ["84522"],
    "Enterprise": ["84725"],
    "Ephraim": ["84627"],
    "Escalante": ["84726"],
    "Eureka": ["84628"],
    "Fairview": ["84629"],
    "Farmington": ["84025"],
    "Fayette": ["84630"],
    "Ferron": ["84523"],
    "Fielding": ["84311"],
    "Fillmore": ["84631"],
    "Fort Duchesne": ["84026"],
    "Fountain Green": ["84632"],
    "Fruitland": ["84027"],
    "Garden City": ["84028"],
    "Garland": ["84312"],
    "Garrison": ["84728"],
    "Glendale": ["84729"],
    "Glenwood": ["84730"],
    "Goshen": ["84633"],
    "Grantsville": ["84029"],
    "Green River": ["84525"],
    "Greenville": ["84731"],
    "Greenwich": ["84732"],
    "Grouse Creek": ["84313"],
    "Gunlock": ["84733"],
    "Gunnison": ["84634"],
    "Hanksville": ["84734"],
    "Hanna": ["84031"],
    "Hatch": ["84735"],
    "Heber City": ["84032"],
    "Helper": ["84526"],
    "Henefer": ["84033"],
    "Henrieville": ["84736"],
    "Herriman": ["84096"],
    "Hildale": ["84784"],
    "Hill AFB": ["84056"],
    "Hinckley": ["84635"],
    "Holden": ["84636"],
    "Honeyville": ["84314"],
    "Hooper": ["84315"],
    "Howell": ["84316"],
    "Huntington": ["84528"],
    "Huntsville": ["84317"],
    "Hurricane": ["84737"],
    "Hyde Park": ["84318"],
    "Hyrum": ["84319"],
    "Ibapah": ["84034"],
    "Ivins": ["84738"],
    "Jensen": ["84035"],
    "Joseph": ["84739"],
    "Junction": ["84740"],
    "Kamas": ["84036"],
    "Kanab": ["84741"],
    "Kanarraville": ["84742"],
    "Kanosh": ["84637"],
    "Kaysville": ["84037"],
    "Kenilworth": ["84529"],
    "Kingston": ["84743"],
    "Koosharem": ["84744"],
    "La Sal": ["84530"],
    "La Verkin": ["84745"],
    "Lake Powell": ["84533"],
    "Laketown": ["84038"],
    "Lapoint": ["84039"],
    "Layton": ["84040", "84041"],
    "Leamington": ["84638"],
    "Leeds": ["84746"],
    "Lehi": ["84043"],
    "Levan": ["84639"],
    "Lewiston": ["84320"],
    "Lindon": ["84042"],
    "Loa": ["84747"],
    "Logan": ["84321", "84322", "84323", "84341"],
    "Lyman": ["84749"],
    "Lynndyl": ["84640"],
    "Magna": ["84044"],
    "Manila": ["84046"],
    "Manti": ["84642"],
    "Mantua": ["84324"],
    "Mapleton": ["84664"],
    "Marysvale": ["84750"],
    "Mayfield": ["84643"],
    "Meadow": ["84644"],
    "Mendon": ["84325"],
    "Mexican Hat": ["84531"],
    "Midvale": ["84047"],
    "Midway": ["84049"],
    "Milford": ["84751"],
    "Millville": ["84326"],
    "Minersville": ["84752"],
    "Moab": ["84532"],
    "Modena": ["84753"],
    "Mona": ["84645"],
    "Monroe": ["84754"],
    "Montezuma Creek": ["84534"],
    "Monticello": ["84535"],
    "Monument Valley": ["84536"],
    "Morgan": ["84050"],
    "Moroni": ["84646"],
    "Mount Carmel": ["84755"],
    "Mount Pleasant": ["84647"],
    "Mountain Home": ["84051"],
    "Myton": ["84052"],
    "Neola": ["84053"],
    "Nephi": ["84648"],
    "New Harmony": ["84757"],
    "Newcastle": ["84756"],
    "Newton": ["84327"],
    "North Salt Lake": ["84054"],
    "Oak City": ["84649"],
    "Oakley": ["84055"],
    "Ogden": ["84201", "84244", "84401", "84402", "84403", "84404", "84405", "84407", "84408", "84409", "84412", "84414", "84415"],
    "Orangeville": ["84537"],
    "Orderville": ["84758"],
    "Orem": ["84057", "84058", "84097"],
    "Panguitch": ["84759"],
    "Paradise": ["84328"],
    "Paragonah": ["84760"],
    "Park City": ["84060", "84068", "84098"],
    "Park Valley": ["84329"],
    "Parowan": ["84761"],
    "Payson": ["84651"],
    "Peoa": ["84061"],
    "Pine Valley": ["84781"],
    "Pleasant Grove": ["84062"],
    "Plymouth": ["84330"],
    "Portage": ["84331"],
    "Price": ["84501"],
    "Providence": ["84332"],
    "Provo": ["84601", "84602", "84603", "84604", "84605", "84606"],
    "Randlett": ["84063"],
    "Randolph": ["84064"],
    "Redmond": ["84652"],
    "Richfield": ["84701"],
    "Richmond": ["84333"],
    "Riverside": ["84334"],
    "Riverton": ["84065"],
    "Rockville": ["84763"],
    "Roosevelt": ["84066"],
    "Roy": ["84067"],
    "Rush Valley": ["84069"],
    "Saint George": ["84770", "84771", "84790", "84791"],
    "Salem": ["84653"],
    "Salina": ["84654"],
    "Salt Lake City": ["84101", "84102", "84103", "84104", "84105", "84106", "84107", "84108", "84109", "84110", "84111", "84112", "84113", "84114", "84115", "84116", "84117", "84118", "84121", "84122", "84123", "84124", "84125", "84126", "84127", "84129", "84130", "84131", "84132", "84133", "84134", "84136", "84138", "84139", "84141", "84143", "84144", "84145", "84147", "84148", "84150", "84151", "84152", "84157", "84158", "84165", "84170", "84171", "84180", "84184", "84189", "84190", "84199"],
    "Sandy": ["84070", "84090", "84091", "84092", "84093", "84094"],
    "Santa Clara": ["84765"],
    "Santaquin": ["84655"],
    "Saratoga Springs": ["84045"],
    "Scipio": ["84656"],
    "Sevier": ["84766"],
    "Sigurd": ["84657"],
    "Smithfield": ["84335"],
    "Snowville": ["84336"],
    "South Jordan": ["84009", "84095"],
    "Spanish Fork": ["84660"],
    "Spring City": ["84662"],
    "Springdale": ["84767"],
    "Springville": ["84663"],
    "Sterling": ["84665"],
    "Stockton": ["84071"],
    "Summit": ["84772"],
    "Sunnyside": ["84539"],
    "Syracuse": ["84075"],
    "Tabiona": ["84072"],
    "Talmage": ["84073"],
    "Teasdale": ["84773"],
    "Thompson": ["84540"],
    "Tooele": ["84074"],
    "Toquerville": ["84774"],
    "Torrey": ["84775"],
    "Tremonton": ["84337"],
    "Trenton": ["84338"],
    "Tridell": ["84076"],
    "Tropic": ["84776"],
    "Vernal": ["84078", "84079"],
    "Vernon": ["84080"],
    "Veyo": ["84782"],
    "Vineyard": ["84059"],
    "Virgin": ["84779"],
    "Wales": ["84667"],
    "Wallsburg": ["84082"],
    "Washington": ["84780"],
    "Wellington": ["84542"],
    "Wellsville": ["84339"],
    "Wendover": ["84083"],
    "West Jordan": ["84081", "84084", "84088"],
    "West Valley City": ["84119", "84120", "84128"],
    "Whiterocks": ["84085"],
    "Willard": ["84340"],
    "Woodruff": ["84086"],
    "Woods Cross": ["84087"]
  },
  "VA": {
    "Abingdon": ["24210", "24211", "24212"],
    "Accomac": ["23301"],
    "Achilles": ["23001"],
    "Afton": ["22920"],
    "Alberta": ["23821"],
    "Aldie": ["20105"],
    "Alexandria": ["22301", "22302", "22303", "22304", "22305", "22306", "22307", "22308", "22309", "22310", "22311", "22312", "22313", "22314", "22315", "22320", "22321", "22331", "22332", "22333", "22334", "22336", "22350"],
    "Altavista": ["24517"],
    "Alton": ["24520"],
    "Amelia Court House": ["23002"],
    "Amherst": ["24521"],
    "Amissville": ["20106"],
    "Ammon": ["23822"],
    "Amonate": ["24601"],
    "Andover": ["24215"],
    "Annandale": ["22003"],
    "Appalachia": ["24216"],
    "Appomattox": ["24522"],
    "Ararat": ["24053"],
    "Arcola": ["20107"],
    "Ark": ["23003"],
    "Arlington": ["22201", "22202", "22203", "22204", "22205", "22206", "22207", "22209", "22210", "22212", "22213", "22214", "22215", "22216", "22217", "22218", "22219", "22222", "22223", "22225", "22226", "22227", "22229", "22230", "22234", "22240", "22241", "22242", "22243", "22244", "22245", "22246"],
    "Aroda": ["22709"],
    "Arrington": ["22922"],
    "Arvonia": ["23004"],
    "Ashburn": ["20146", "20147", "20148", "20149", "22093"],
    "Ashland": ["23005"],
    "Assawoman": ["23302"],
    "Atkins": ["24311"],
    "Atlantic": ["23303"],
    "Augusta Springs": ["24411"],
    "Austinville": ["24312"],
    "Axton": ["24054"],
    "Aylett": ["23009"],
    "Bacova": ["24412"],
    "Banco": ["22711"],
    "Bandy": ["24602"],
    "Barboursville": ["22923"],
    "Barhamsville": ["23011"],
    "Barren Springs": ["24313"],
    "Baskerville": ["23915"],
    "Bassett": ["24055"],
    "Bastian": ["24314"],
    "Basye": ["22810"],
    "Batesville": ["22924"],
    "Battery Park": ["23304"],
    "Bealeton": ["22712"],
    "Beaumont": ["23014"],
    "Beaverdam": ["23015"],
    "Bedford": ["24523"],
    "Bee": ["24217"],
    "Belle Haven": ["23306"],
    "Belspring": ["24058"],
    "Ben Hur": ["24218"],
    "Bena": ["23018"],
    "Bent Mountain": ["24059"],
    "Bentonville": ["22610"],
    "Bergton": ["22811"],
    "Berryville": ["22611"],
    "Big Island": ["24526"],
    "Big Rock": ["24603"],
    "Big Stone Gap": ["24219"],
    "Birchleaf": ["24220"],
    "Birdsnest": ["23307"],
    "Bishop": ["24604"],
    "Blacksburg": ["24060", "24061", "24062", "24063"],
    "Blackstone": ["23824", "23825"],
    "Blackwater": ["24221"],
    "Blairs": ["24527"],
    "Bland": ["24315"],
    "Bloxom": ["23308"],
    "Blue Grass": ["24413"],
    "Blue Ridge": ["24064"],
    "Bluefield": ["24605"],
    "Bluemont": ["20135"],
    "Bohannon": ["23021"],
    "Boissevain": ["24606"],
    "Boones Mill": ["24065"],
    "Boston": ["22713"],
    "Bowling Green": ["22427", "22428"],
    "Boyce": ["22620"],
    "Boydton": ["23917"],
    "Boykins": ["23827"],
    "Bracey": ["23919"],
    "Branchville": ["23828"],
    "Brandy Station": ["22714"],
    "Breaks": ["24607"],
    "Bremo Bluff": ["23022"],
    "Bridgewater": ["22812"],
    "Brightwood": ["22715"],
    "Bristol": ["24201", "24202", "24203", "24205", "24209"],
    "Bristow": ["20136"],
    "Broad Run": ["20137"],
    "Broadford": ["24316"],
    "Broadway": ["22815"],
    "Brodnax": ["23920"],
    "Brooke": ["22430"],
    "Brookneal": ["24528"],
    "Brownsburg": ["24415"],
    "Brucetown": ["22622"],
    "Bruington": ["23023"],
    "Buchanan": ["24066"],
    "Buckingham": ["23921"],
    "Buena Vista": ["24416"],
    "Buffalo Junction": ["24529"],
    "Bumpass": ["23024"],
    "Burgess": ["22432"],
    "Burke": ["22009", "22015"],
    "Burkes Garden": ["24608"],
    "Burkeville": ["23922"],
    "Burr Hill": ["22433"],
    "Callands": ["24530"],
    "Callao": ["22435"],
    "Callaway": ["24067"],
    "Calverton": ["20138"],
    "Cana": ["24317"],
    "Cape Charles": ["23310"],
    "Capeville": ["23313"],
    "Capron": ["23829"],
    "Cardinal": ["23025"],
    "Caret": ["22436"],
    "Carrollton": ["23314"],
    "Carrsville": ["23315"],
    "Carson": ["23830"],
    "Cartersville": ["23027"],
    "Casanova": ["20139"],
    "Cascade": ["24069"],
    "Castleton": ["22716"],
    "Castlewood": ["24224"],
    "Catawba": ["24070"],
    "Catharpin": ["20143"],
    "Catlett": ["20119"],
    "Cedar Bluff": ["24609"],
    "Center Cross": ["22437"],
    "Centreville": ["20120", "20121", "20122"],
    "Ceres": ["24318"],
    "Champlain": ["22438"],
    "Chantilly": ["20151", "20152", "20153"],
    "Charles City": ["23030"],
    "Charlotte Court House": ["23923"],
    "Charlottesville": ["22901", "22902", "22903", "22904", "22905", "22906", "22907", "22908", "22909", "22910", "22911"],
    "Chase City": ["23924"],
    "Chatham": ["24531"],
    "Check": ["24072"],
    "Cheriton": ["23316"],
    "Chesapeake": ["23320", "23321", "23322", "23323", "23324", "23325", "23326", "23327", "23328"],
    "Chester": ["23831", "23836"],
    "Chester Gap": ["22623"],
    "Chesterfield": ["23832", "23838"],
    "Chilhowie": ["24319"],
    "Chincoteague Island": ["23336"],
    "Christchurch": ["23031"],
    "Christiansburg": ["24068", "24073"],
    "Church Road": ["23833"],
    "Church View": ["23032"],
    "Churchville": ["24421"],
    "Claremont": ["23899"],
    "Clarksville": ["23927"],
    "Claudville": ["24076"],
    "Clear Brook": ["22624"],
    "Cleveland": ["24225"],
    "Clifford": ["24533"],
    "Clifton": ["20124"],
    "Clifton Forge": ["24422"],
    "Clinchco": ["24226"],
    "Clintwood": ["24228"],
    "Clover": ["24534"],
    "Cloverdale": ["24077"],
    "Cluster Springs": ["24535"],
    "Cobbs Creek": ["23035"],
    "Coeburn": ["24230"],
    "Coleman Falls": ["24536"],
    "Coles Point": ["22442"],
    "Collinsville": ["24078"],
    "Colonial Beach": ["22443"],
    "Colonial Heights": ["23834"],
    "Columbia": ["23038"],
    "Concord": ["24538"],
    "Copper Hill": ["24079"],
    "Corbin": ["22446"],
    "Courtland": ["23837"],
    "Covesville": ["22931"],
    "Covington": ["24426"],
    "Craddockville": ["23341"],
    "Craigsville": ["24430"],
    "Crewe": ["23930"],
    "Criders": ["22820"],
    "Crimora": ["24431"],
    "Cripple Creek": ["24322"],
    "Critz": ["24082"],
    "Crockett": ["24323"],
    "Cross Junction": ["22625"],
    "Crozet": ["22932"],
    "Crozier": ["23039"],
    "Crystal Hill": ["24539"],
    "Cullen": ["23934"],
    "Culpeper": ["22701"],
    "Cumberland": ["23040"],
    "Dahlgren": ["22448"],
    "Daleville": ["24083"],
    "Damascus": ["24236"],
    "Dante": ["24237"],
    "Danville": ["24540", "24541", "24543", "24544"],
    "Davenport": ["24239"],
    "Davis Wharf": ["23345"],
    "Dayton": ["22821"],
    "Deerfield": ["24432"],
    "Delaplane": ["20144"],
    "Deltaville": ["23043"],
    "Dendron": ["23839"],
    "Dewitt": ["23840"],
    "Dhs": ["20598"],
    "Diggs": ["23045"],
    "Dillwyn": ["23936"],
    "Dinwiddie": ["23841"],
    "Disputanta": ["23842"],
    "Doe Hill": ["24433"],
    "Dogue": ["22451"],
    "Dolphin": ["23843"],
    "Doran": ["24612"],
    "Doswell": ["23047"],
    "Drakes Branch": ["23937"],
    "Draper": ["24324"],
    "Drewryville": ["23844"],
    "Dry Fork": ["24549"],
    "Dryden": ["24243"],
    "Dublin": ["24084"],
    "Duffield": ["24244"],
    "Dugspur": ["24325"],
    "Dulles": ["20101", "20102", "20103", "20104", "20189", "20199"],
    "Dumfries": ["22025", "22026"],
    "Dundas": ["23938"],
    "Dungannon": ["24245"],
    "Dunn Loring": ["22027"],
    "Dunnsville": ["22454"],
    "Dutton": ["23050"],
    "Dyke": ["22935"],
    "Eagle Rock": ["24085"],
    "Earlysville": ["22936"],
    "East Stone Gap": ["24246"],
    "Eastville": ["23347"],
    "Ebony": ["23845"],
    "Edinburg": ["22824"],
    "Edwardsville": ["22456"],
    "Eggleston": ["24086"],
    "Elberon": ["23846"],
    "Elk Creek": ["24326"],
    "Elkton": ["22827"],
    "Elkwood": ["22718"],
    "Elliston": ["24087"],
    "Emory": ["24327"],
    "Emporia": ["23847"],
    "Esmont": ["22937"],
    "Etlan": ["22719"],
    "Evergreen": ["23939"],
    "Evington": ["24550"],
    "Ewing": ["24248"],
    "Exmore": ["23350"],
    "Faber": ["22938"],
    "Fairfax": ["22030", "22031", "22032", "22033", "22034", "22035", "22036", "22037", "22038"],
    "Fairfax Station": ["22039"],
    "Fairfield": ["24435"],
    "Falls Church": ["22040", "22041", "22042", "22043", "22044", "22046", "22047"],
    "Falls Mills": ["24613"],
    "Fancy Gap": ["24328"],
    "Farmville": ["23901", "23909"],
    "Farnham": ["22460"],
    "Ferrum": ["24088"],
    "Fieldale": ["24089"],
    "Fincastle": ["24090"],
    "Fishers Hill": ["22626"],
    "Fishersville": ["22939"],
    "Flint Hill": ["22627"],
    "Floyd": ["24091"],
    "Ford": ["23850"],
    "Forest": ["24551"],
    "Fork Union": ["23055"],
    "Fort Belvoir": ["22060"],
    "Fort Blackmore": ["24250"],
    "Fort Defiance": ["24437"],
    "Fort Eustis": ["23604"],
    "Fort Lee": ["23801"],
    "Fort Mitchell": ["23941"],
    "Fort Monroe": ["23651"],
    "Fort Myer": ["22211"],
    "Fort Valley": ["22652"],
    "Foster": ["23056"],
    "Franklin": ["23851"],
    "Franktown": ["23354"],
    "Fredericksburg": ["22401", "22402", "22403", "22404", "22405", "22406", "22407", "22408", "22412"],
    "Free Union": ["22940"],
    "Freeman": ["23856"],
    "Fries": ["24330"],
    "Front Royal": ["22630"],
    "Fulks Run": ["22830"],
    "Gainesville": ["20155", "20156"],
    "Galax": ["24333"],
    "Garrisonville": ["22463"],
    "Gasburg": ["23857"],
    "Gate City": ["24251"],
    "Glade Hill": ["24092"],
    "Glade Spring": ["24340"],
    "Gladstone": ["24553"],
    "Gladys": ["24554"],
    "Glasgow": ["24555"],
    "Glen Allen": ["23058", "23059", "23060"],
    "Glen Lyn": ["24093"],
    "Glen Wilton": ["24438"],
    "Gloucester": ["23061"],
    "Gloucester Point": ["23062"],
    "Goldvein": ["22720"],
    "Goochland": ["23063"],
    "Goode": ["24556"],
    "Goodview": ["24095"],
    "Gordonsville": ["22942"],
    "Gore": ["22637"],
    "Goshen": ["24439"],
    "Graves Mill": ["22721"],
    "Great Falls": ["22066"],
    "Green Bay": ["23942"],
    "Greenbackville": ["23356"],
    "Greenbush": ["23357"],
    "Greenville": ["24440"],
    "Greenway": ["22067"],
    "Greenwood": ["22943"],
    "Gretna": ["24557"],
    "Grimstead": ["23064"],
    "Grottoes": ["24441"],
    "Grundy": ["24614"],
    "Gum Spring": ["23065"],
    "Gwynn": ["23066"],
    "Hacksneck": ["23358"],
    "Hadensville": ["23067"],
    "Hague": ["22469"],
    "Halifax": ["24558"],
    "Hallieford": ["23068"],
    "Hallwood": ["23359"],
    "Hamilton": ["20158", "20159"],
    "Hampden Sydney": ["23943"],
    "Hampton": ["23630", "23661", "23663", "23664", "23665", "23666", "23667", "23668", "23669", "23670", "23681"],
    "Hanover": ["23069"],
    "Harborton": ["23389"],
    "Hardy": ["24101"],
    "Hardyville": ["23070"],
    "Harrisonburg": ["22801", "22802", "22803", "22807"],
    "Hartfield": ["23071"],
    "Hartwood": ["22471"],
    "Hayes": ["23072"],
    "Haymarket": ["20168", "20169"],
    "Haynesville": ["22472"],
    "Haysi": ["24256"],
    "Haywood": ["22722"],
    "Head Waters": ["24442"],
    "Heathsville": ["22473"],
    "Henrico": ["23075", "23228", "23229", "23231", "23233", "23238", "23242", "23255", "23273", "23288", "23294"],
    "Henry": ["24102"],
    "Herndon": ["20170", "20171", "20172", "20192", "22092", "22095"],
    "Hillsville": ["24343"],
    "Hiltons": ["24258"],
    "Hinton": ["22831"],
    "Hiwassee": ["24347"],
    "Honaker": ["24260"],
    "Hood": ["22723"],
    "Hopewell": ["23860"],
    "Horntown": ["23395"],
    "Horsepen": ["24619"],
    "Hot Springs": ["24445"],
    "Howardsville": ["24562"],
    "Huddleston": ["24104"],
    "Hudgins": ["23076"],
    "Hume": ["22639"],
    "Huntly": ["22640"],
    "Hurley": ["24620"],
    "Hurt": ["24563"],
    "Hustle": ["22476"],
    "Independence": ["24348"],
    "Indian Valley": ["24105"],
    "Iron Gate": ["24448"],
    "Irvington": ["22480"],
    "Isle Of Wight": ["23397"],
    "Ivanhoe": ["24350"],
    "Ivor": ["23866"],
    "Ivy": ["22945"],
    "Jamaica": ["23079"],
    "Jamestown": ["23081"],
    "Jamesville": ["23398"],
    "Jarratt": ["23867", "23870"],
    "Java": ["24565"],
    "Jeffersonton": ["22724"],
    "Jenkins Bridge": ["23399"],
    "Jersey": ["22481"],
    "Jetersville": ["23083"],
    "Jewell Ridge": ["24622"],
    "Jonesville": ["24263"],
    "Keeling": ["24566"],
    "Keen Mountain": ["24624"],
    "Keene": ["22946"],
    "Keezletown": ["22832"],
    "Keller": ["23401"],
    "Kenbridge": ["23944"],
    "Kents Store": ["23084"],
    "Keokee": ["24265"],
    "Keswick": ["22947"],
    "Keysville": ["23947"],
    "Kilmarnock": ["22482"],
    "King And Queen Court House": ["23085"],
    "King George": ["22485"],
    "King William": ["23086"],
    "Kinsale": ["22488"],
    "La Crosse": ["23950"],
    "Lacey Spring": ["22833"],
    "Lackey": ["23694"],
    "Ladysmith": ["22501"],
    "Lambsburg": ["24351"],
    "Lancaster": ["22503"],
    "Laneview": ["22504"],
    "Lanexa": ["23089"],
    "Laurel Fork": ["24352"],
    "Lawrenceville": ["23868"],
    "Lebanon": ["24266"],
    "Leesburg": ["20175", "20176", "20177", "20178"],
    "Leon": ["22725"],
    "Lexington": ["24450"],
    "Lightfoot": ["23090"],
    "Lignum": ["22726"],
    "Lincoln": ["20160"],
    "Linden": ["22642"],
    "Linville": ["22834"],
    "Little Plymouth": ["23091"],
    "Lively": ["22507"],
    "Locust Dale": ["22948"],
    "Locust Grove": ["22508"],
    "Locust Hill": ["23092"],
    "Locustville": ["23404"],
    "Long Island": ["24569"],
    "Loretto": ["22509"],
    "Lorton": ["22079", "22199"],
    "Lottsburg": ["22511"],
    "Louisa": ["23093"],
    "Lovettsville": ["20180"],
    "Lovingston": ["22949"],
    "Low Moor": ["24457"],
    "Lowry": ["24570"],
    "Lunenburg": ["23952"],
    "Luray": ["22835"],
    "Lynch Station": ["24571"],
    "Lynchburg": ["24501", "24502", "24503", "24504", "24505", "24506", "24512", "24513", "24514", "24515"],
    "Lyndhurst": ["22952"],
    "Machipongo": ["23405"],
    "Macon": ["23101"],
    "Madison": ["22727"],
    "Madison Heights": ["24572"],
    "Maidens": ["23102"],
    "Manakin Sabot": ["23103"],
    "Manassas": ["20108", "20109", "20110", "20111", "20112", "20113"],
    "Mannboro": ["23105"],
    "Manquin": ["23106"],
    "Mappsville": ["23407"],
    "Marion": ["24354"],
    "Marionville": ["23408"],
    "Markham": ["22643"],
    "Marshall": ["20115", "20116"],
    "Martinsville": ["24112", "24113", "24114", "24115"],
    "Maryus": ["23107"],
    "Mascot": ["23108"],
    "Mathews": ["23109"],
    "Mattaponi": ["23110"],
    "Maurertown": ["22644"],
    "Mavisdale": ["24627"],
    "Max Meadows": ["24360"],
    "Maxie": ["24628"],
    "Mc Clure": ["24269"],
    "Mc Coy": ["24111"],
    "Mc Dowell": ["24458"],
    "Mc Gaheysville": ["22840"],
    "Mc Kenney": ["23872"],
    "Mc Lean": ["22101", "22102", "22106", "22107", "22108", "22109"],
    "Meadows Of Dan": ["24120"],
    "Meadowview": ["24361"],
    "Mears": ["23409"],
    "Mechanicsville": ["23111", "23116"],
    "Meherrin": ["23954"],
    "Melfa": ["23410"],
    "Mendota": ["24270"],
    "Meredithville": ["23873"],
    "Merrifield": ["22081", "22082", "22116", "22118", "22119", "22120"],
    "Merry Point": ["22513"],
    "Middlebrook": ["24459"],
    "Middleburg": ["20117", "20118"],
    "Middletown": ["22645", "22649"],
    "Midland": ["22728"],
    "Midlothian": ["23112", "23113", "23114"],
    "Milford": ["22514"],
    "Millboro": ["24460"],
    "Millers Tavern": ["23115"],
    "Millwood": ["22646"],
    "Mineral": ["23117"],
    "Mint Spring": ["24463"],
    "Mitchells": ["22729"],
    "Modest Town": ["23412"],
    "Mollusk": ["22517"],
    "Moneta": ["24121"],
    "Monroe": ["24574"],
    "Montebello": ["24464"],
    "Monterey": ["24465"],
    "Montpelier": ["23192"],
    "Montpelier Station": ["22957"],
    "Montross": ["22520"],
    "Montvale": ["24122"],
    "Moon": ["23119"],
    "Morattico": ["22523"],
    "Moseley": ["23120"],
    "Mount Crawford": ["22841"],
    "Mount Holly": ["22524"],
    "Mount Jackson": ["22842"],
    "Mount Sidney": ["24467"],
    "Mount Solon": ["22843"],
    "Mount Vernon": ["22121"],
    "Mouth Of Wilson": ["24363"],
    "Mustoe": ["24468"],
    "Narrows": ["24124"],
    "Naruna": ["24576"],
    "Nassawadox": ["23413"],
    "Nathalie": ["24577"],
    "Natural Bridge": ["24578"],
    "Natural Bridge Station": ["24579"],
    "Nellysford": ["22958"],
    "Nelson": ["24580"],
    "Nelsonia": ["23414"],
    "New Canton": ["23123"],
    "New Castle": ["24127"],
    "New Church": ["23415"],
    "New Hope": ["24469"],
    "New Kent": ["23124"],
    "New Market": ["22844"],
    "New Point": ["23125"],
    "New River": ["24129"],
    "Newbern": ["24126"],
    "Newington": ["22122"],
    "Newport": ["24128"],
    "Newport News": ["23601", "23602", "23603", "23605", "23606", "23607", "23608", "23609", "23612", "23628"],
    "Newsoms": ["23874"],
    "Newtown": ["23126"],
    "Nickelsville": ["24271"],
    "Ninde": ["22526"],
    "Nokesville": ["20181", "20182"],
    "Nora": ["24272"],
    "Norfolk": ["23501", "23502", "23503", "23504", "23505", "23506", "23507", "23508", "23509", "23510", "23511", "23512", "23513", "23514", "23515", "23517", "23518", "23519", "23520", "23521", "23523", "23529", "23541", "23551"],
    "Norge": ["23127"],
    "North": ["23128"],
    "North Garden": ["22959"],
    "North Tazewell": ["24630"],
    "Norton": ["24273"],
    "Norwood": ["24581"],
    "Nottoway": ["23955"],
    "Nuttsville": ["22528"],
    "Oak Hall": ["23396", "23416"],
    "Oakpark": ["22730"],
    "Oakton": ["22124"],
    "Oakwood": ["24631"],
    "Occoquan": ["22125"],
    "Oilville": ["23129"],
    "Oldhams": ["22529"],
    "Onancock": ["23417"],
    "Onemo": ["23130"],
    "Onley": ["23418"],
    "Ophelia": ["22530"],
    "Orange": ["22960"],
    "Ordinary": ["23131"],
    "Oriskany": ["24130"],
    "Orkney Springs": ["22845"],
    "Orlean": ["20128"],
    "Oyster": ["23419"],
    "Paeonian Springs": ["20129"],
    "Paint Bank": ["24131"],
    "Painter": ["23420"],
    "Palmyra": ["22963"],
    "Pamplin": ["23958"],
    "Paris": ["20130"],
    "Parksley": ["23421"],
    "Parrott": ["24132"],
    "Partlow": ["22534"],
    "Patrick Springs": ["24133"],
    "Pearisburg": ["24134"],
    "Pembroke": ["24136"],
    "Penhook": ["24137"],
    "Penn Laird": ["22846"],
    "Pennington Gap": ["24277"],
    "Petersburg": ["23803", "23804", "23805"],
    "Phenix": ["23959"],
    "Philomont": ["20131"],
    "Pilgrims Knob": ["24634"],
    "Pilot": ["24138"],
    "Piney River": ["22964"],
    "Pittsville": ["24139"],
    "Pleasant Valley": ["22848"],
    "Pocahontas": ["24635"],
    "Poquoson": ["23662"],
    "Port Haywood": ["23138"],
    "Port Republic": ["24471"],
    "Port Royal": ["22535"],
    "Portsmouth": ["23701", "23702", "23703", "23704", "23705", "23707", "23708", "23709"],
    "Pound": ["24279"],
    "Pounding Mill": ["24637"],
    "Powhatan": ["23139"],
    "Pratts": ["22731"],
    "Prince George": ["23875"],
    "Prospect": ["23960"],
    "Providence Forge": ["23140"],
    "Pulaski": ["24301"],
    "Pungoteague": ["23422"],
    "Purcellville": ["20132", "20134"],
    "Quantico": ["22134", "22135"],
    "Quicksburg": ["22847"],
    "Quinby": ["23423"],
    "Quinque": ["22965"],
    "Quinton": ["23141"],
    "Radford": ["24141", "24142", "24143"],
    "Radiant": ["22732"],
    "Randolph": ["23962"],
    "Raphine": ["24472"],
    "Rapidan": ["22733"],
    "Rappahannock Academy": ["22538"],
    "Raven": ["24639"],
    "Rawlings": ["23876"],
    "Rectortown": ["20140"],
    "Red Ash": ["24640"],
    "Red House": ["23963"],
    "Red Oak": ["23964"],
    "Redwood": ["24146"],
    "Reedville": ["22539"],
    "Remington": ["22734"],
    "Rescue": ["23424"],
    "Reston": ["20190", "20191", "20193", "20194", "20195", "20196", "22096"],
    "Reva": ["22735"],
    "Rhoadesville": ["22542"],
    "Rice": ["23966"],
    "Rich Creek": ["24147"],
    "Richardsville": ["22736"],
    "Richlands": ["24641"],
    "Richmond": ["23173", "23218", "23219", "23220", "23221", "23222", "23223", "23224", "23225", "23226", "23227", "23230", "23232", "23234", "23235", "23236", "23237", "23240", "23241", "23249", "23250", "23260", "23261", "23269", "23274", "23276", "23278", "23279", "23282", "23284", "23285", "23286", "23289", "23290", "23291", "23292", "23293", "23295", "23297", "23298"],
    "Ridgeway": ["24148"],
    "Rileyville": ["22650"],
    "Riner": ["24149"],
    "Ringgold": ["24586"],
    "Ripplemead": ["24150"],
    "Rixeyville": ["22737"],
    "Roanoke": ["24001", "24002", "24003", "24004", "24005", "24006", "24007", "24008", "24009", "24010", "24011", "24012", "24013", "24014", "24015", "24016", "24017", "24018", "24019", "24020", "24022", "24023", "24024", "24025", "24026", "24027", "24028", "24029", "24030", "24031", "24032", "24033", "24034", "24035", "24036", "24037", "24038", "24040", "24042", "24043", "24044", "24045", "24048", "24050", "24155", "24157"],
    "Rochelle": ["22738"],
    "Rockbridge Baths": ["24473"],
    "Rockville": ["23146"],
    "Rocky Gap": ["24366"],
    "Rocky Mount": ["24151"],
    "Rollins Fork": ["22544"],
    "Rose Hill": ["24281"],
    "Rosedale": ["24280"],
    "Roseland": ["22967"],
    "Round Hill": ["20141", "20142"],
    "Rowe": ["24646"],
    "Ruby": ["22545"],
    "Ruckersville": ["22968"],
    "Rural Retreat": ["24368"],
    "Rustburg": ["24588"],
    "Ruther Glen": ["22546"],
    "Ruthville": ["23147"],
    "Saint Charles": ["24282"],
    "Saint Paul": ["24283"],
    "Saint Stephens Church": ["23148"],
    "Salem": ["24153"],
    "Saltville": ["24370"],
    "Saluda": ["23149"],
    "Sandston": ["23150"],
    "Sandy Hook": ["23153"],
    "Sandy Level": ["24161"],
    "Sandy Point": ["22577"],
    "Sanford": ["23426"],
    "Saxe": ["23967"],
    "Saxis": ["23427"],
    "Schley": ["23154"],
    "Schuyler": ["22969"],
    "Scottsburg": ["24589"],
    "Scottsville": ["24590"],
    "Seaford": ["23696"],
    "Sealston": ["22547"],
    "Seaview": ["23429"],
    "Sedley": ["23878"],
    "Selma": ["24474"],
    "Severn": ["23155"],
    "Shacklefords": ["23156"],
    "Sharps": ["22548"],
    "Shawsville": ["24162"],
    "Shenandoah": ["22849"],
    "Shipman": ["22971"],
    "Shortt Gap": ["24647"],
    "Singers Glen": ["22850"],
    "Skippers": ["23879"],
    "Skipwith": ["23968"],
    "Smithfield": ["23430", "23431"],
    "Somerset": ["22972"],
    "Somerville": ["22739"],
    "South Boston": ["24592"],
    "South Hill": ["23970"],
    "Sparta": ["22552"],
    "Speedwell": ["24374"],
    "Spencer": ["24165"],
    "Sperryville": ["22740"],
    "Spotsylvania": ["22551", "22553"],
    "Spout Spring": ["24593"],
    "Spring Grove": ["23881"],
    "Springfield": ["22150", "22151", "22152", "22153", "22156", "22158", "22159", "22160", "22161"],
    "Stafford": ["22554", "22555", "22556"],
    "Staffordsville": ["24167"],
    "Stanardsville": ["22973"],
    "Stanley": ["22851"],
    "Stanleytown": ["24168"],
    "Star Tannery": ["22654"],
    "State Farm": ["23160"],
    "Staunton": ["24401", "24402"],
    "Steeles Tavern": ["24476"],
    "Stephens City": ["22655"],
    "Stephenson": ["22656"],
    "Sterling": ["20163", "20164", "20165", "20166", "20167"],
    "Stevensburg": ["22741"],
    "Stevensville": ["23161"],
    "Stony Creek": ["23882"],
    "Strasburg": ["22641", "22657"],
    "Stratford": ["22558"],
    "Stuart": ["24171"],
    "Stuarts Draft": ["24477"],
    "Studley": ["23162"],
    "Suffolk": ["23432", "23433", "23434", "23435", "23436", "23437", "23438", "23439"],
    "Sugar Grove": ["24375"],
    "Sumerduck": ["22742"],
    "Surry": ["23883"],
    "Susan": ["23163"],
    "Sussex": ["23884"],
    "Sutherland": ["23885"],
    "Sutherlin": ["24594"],
    "Sweet Briar": ["24595"],
    "Swoope": ["24479"],
    "Swords Creek": ["24649"],
    "Syria": ["22743"],
    "Tangier": ["23440"],
    "Tannersville": ["24377"],
    "Tappahannock": ["22560"],
    "Tasley": ["23441"],
    "Tazewell": ["24651"],
    "Temperanceville": ["23442"],
    "Thaxton": ["24174"],
    "The Plains": ["20198"],
    "Thornburg": ["22565"],
    "Timberville": ["22853"],
    "Toano": ["23168"],
    "Toms Brook": ["22660"],
    "Topping": ["23169"],
    "Townsend": ["23443"],
    "Trevilians": ["23170"],
    "Triangle": ["22172"],
    "Troutdale": ["24378"],
    "Troutville": ["24175"],
    "Troy": ["22974"],
    "Tyro": ["22976"],
    "Union Hall": ["24176"],
    "Unionville": ["22567"],
    "Upperville": ["20184", "20185"],
    "Urbanna": ["23175"],
    "Valentines": ["23887"],
    "Vansant": ["24656"],
    "Vernon Hill": ["24597"],
    "Verona": ["24482"],
    "Vesta": ["24177"],
    "Vesuvius": ["24483"],
    "Victoria": ["23974"],
    "Vienna": ["22180", "22181", "22182", "22183", "22184", "22185"],
    "Viewtown": ["22746"],
    "Village": ["22570"],
    "Villamont": ["24178"],
    "Vinton": ["24179"],
    "Virgilina": ["24598"],
    "Virginia Beach": ["23450", "23451", "23452", "23453", "23454", "23455", "23456", "23457", "23458", "23459", "23460", "23461", "23462", "23463", "23464", "23465", "23466", "23467", "23471", "23479"],
    "Virginia State University": ["23806"],
    "Wachapreague": ["23480"],
    "Wake": ["23176"],
    "Wakefield": ["23888"],
    "Walkerton": ["23177"],
    "Wallops Island": ["23337"],
    "Wardtown": ["23482"],
    "Ware Neck": ["23178"],
    "Warfield": ["23889"],
    "Warm Springs": ["24484"],
    "Warrenton": ["20186", "20187", "20188"],
    "Warsaw": ["22572"],
    "Washington": ["22747"],
    "Water View": ["23180"],
    "Waterford": ["20197"],
    "Wattsville": ["23483"],
    "Waverly": ["23890", "23891"],
    "Waynesboro": ["22980"],
    "Weber City": ["24290"],
    "Weems": ["22576"],
    "West Augusta": ["24485"],
    "West Mclean": ["22103"],
    "West Point": ["23181"],
    "Weyers Cave": ["24486"],
    "White Hall": ["22987"],
    "White Marsh": ["23183"],
    "White Plains": ["23893"],
    "White Post": ["22663"],
    "White Stone": ["22578"],
    "Whitetop": ["24292"],
    "Whitewood": ["24657"],
    "Wicomico": ["23184"],
    "Wicomico Church": ["22579"],
    "Williamsburg": ["23185", "23186", "23187", "23188"],
    "Williamsville": ["24487"],
    "Willis": ["24380"],
    "Willis Wharf": ["23486"],
    "Wilsons": ["23894"],
    "Winchester": ["22601", "22602", "22603", "22604"],
    "Windsor": ["23487"],
    "Wingina": ["24599"],
    "Wirtz": ["24184"],
    "Wise": ["24293"],
    "Withams": ["23488"],
    "Wolford": ["24658"],
    "Wolftown": ["22748"],
    "Woodberry Forest": ["22989"],
    "Woodbridge": ["22191", "22192", "22193", "22194", "22195"],
    "Woodford": ["22580"],
    "Woodlawn": ["24381"],
    "Woods Cross Roads": ["23190"],
    "Woodstock": ["22664"],
    "Woodville": ["22749"],
    "Woolwine": ["24185"],
    "Wylliesburg": ["23976"],
    "Wytheville": ["24382"],
    "Yale": ["23897"],
    "Yorktown": ["23690", "23691", "23692", "23693"],
    "Zacata": ["22581"],
    "Zuni": ["23898"]
  },
  "VT": {
    "Adamant": ["05640"],
    "Albany": ["05820"],
    "Alburgh": ["05440"],
    "Arlington": ["05250"],
    "Ascutney": ["05030"],
    "Averill": ["05901"],
    "Bakersfield": ["05441"],
    "Barnard": ["05031"],
    "Barnet": ["05821"],
    "Barre": ["05641"],
    "Barton": ["05822", "05875"],
    "Beebe Plain": ["05823"],
    "Beecher Falls": ["05902"],
    "Bellows Falls": ["05101"],
    "Belmont": ["05730"],
    "Belvidere Center": ["05442"],
    "Bennington": ["05201"],
    "Benson": ["05731"],
    "Bethel": ["05032"],
    "Bomoseen": ["05732"],
    "Bondville": ["05340"],
    "Bradford": ["05033"],
    "Brandon": ["05733"],
    "Brattleboro": ["05301", "05302", "05303", "05304"],
    "Bridgewater": ["05034"],
    "Bridgewater Corners": ["05035"],
    "Bridport": ["05734"],
    "Bristol": ["05443"],
    "Brookfield": ["05036"],
    "Brownsville": ["05037"],
    "Burlington": ["05401", "05402", "05405", "05406", "05408"],
    "Cabot": ["05647"],
    "Calais": ["05648"],
    "Cambridge": ["05444"],
    "Cambridgeport": ["05141"],
    "Canaan": ["05903"],
    "Castleton": ["05735"],
    "Cavendish": ["05142"],
    "Center Rutland": ["05736"],
    "Charlotte": ["05445"],
    "Chelsea": ["05038"],
    "Chester": ["05143"],
    "Chester Depot": ["05144"],
    "Chittenden": ["05737"],
    "Colchester": ["05439", "05446", "05449"],
    "Concord": ["05824"],
    "Corinth": ["05039"],
    "Coventry": ["05825"],
    "Craftsbury": ["05826"],
    "Craftsbury Common": ["05827"],
    "Cuttingsville": ["05738"],
    "Danby": ["05739"],
    "Danville": ["05828"],
    "Derby": ["05829"],
    "Derby Line": ["05830"],
    "Dorset": ["05251"],
    "East Arlington": ["05252"],
    "East Barre": ["05649"],
    "East Berkshire": ["05447"],
    "East Burke": ["05832"],
    "East Calais": ["05650"],
    "East Charleston": ["05833"],
    "East Corinth": ["05040"],
    "East Dorset": ["05253"],
    "East Dover": ["05341"],
    "East Fairfield": ["05448"],
    "East Hardwick": ["05836"],
    "East Haven": ["05837"],
    "East Middlebury": ["05740"],
    "East Montpelier": ["05651"],
    "East Poultney": ["05741"],
    "East Randolph": ["05041"],
    "East Ryegate": ["05042"],
    "East Saint Johnsbury": ["05838"],
    "East Thetford": ["05043"],
    "East Wallingford": ["05742"],
    "Eden": ["05652"],
    "Eden Mills": ["05653"],
    "Enosburg Falls": ["05450"],
    "Essex": ["05451"],
    "Essex Junction": ["05452", "05453", "05479"],
    "Fair Haven": ["05743"],
    "Fairfax": ["05454"],
    "Fairfield": ["05455"],
    "Fairlee": ["05045"],
    "Ferrisburgh": ["05456"],
    "Florence": ["05744"],
    "Forest Dale": ["05745"],
    "Franklin": ["05457"],
    "Gaysville": ["05746"],
    "Gilman": ["05904"],
    "Glover": ["05839"],
    "Grafton": ["05146"],
    "Granby": ["05840"],
    "Grand Isle": ["05458"],
    "Graniteville": ["05654"],
    "Granville": ["05747"],
    "Greensboro": ["05841"],
    "Greensboro Bend": ["05842"],
    "Groton": ["05046"],
    "Guildhall": ["05905"],
    "Hancock": ["05748"],
    "Hardwick": ["05843"],
    "Hartford": ["05047"],
    "Hartland": ["05048"],
    "Hartland Four Corners": ["05049"],
    "Highgate Center": ["05459"],
    "Highgate Springs": ["05460"],
    "Hinesburg": ["05461"],
    "Huntington": ["05462"],
    "Hyde Park": ["05655"],
    "Hydeville": ["05750"],
    "Irasburg": ["05845"],
    "Island Pond": ["05846"],
    "Isle La Motte": ["05463"],
    "Jacksonville": ["05342"],
    "Jamaica": ["05343"],
    "Jeffersonville": ["05464"],
    "Jericho": ["05465"],
    "Johnson": ["05656"],
    "Jonesville": ["05466"],
    "Killington": ["05751"],
    "Lake Elmore": ["05657"],
    "Londonderry": ["05148"],
    "Lowell": ["05847"],
    "Lower Waterford": ["05848"],
    "Ludlow": ["05149"],
    "Lunenburg": ["05906"],
    "Lyndon": ["05849"],
    "Lyndon Center": ["05850"],
    "Lyndonville": ["05851"],
    "Manchester": ["05254"],
    "Manchester Center": ["05255"],
    "Marlboro": ["05344"],
    "Marshfield": ["05658"],
    "Mc Indoe Falls": ["05050"],
    "Middlebury": ["05753"],
    "Middletown Springs": ["05757"],
    "Milton": ["05468"],
    "Monkton": ["05469"],
    "Montgomery": ["05470"],
    "Montgomery Center": ["05471"],
    "Montpelier": ["05601", "05602", "05603", "05604", "05609", "05620", "05633"],
    "Moretown": ["05660"],
    "Morgan": ["05853"],
    "Morrisville": ["05661"],
    "Moscow": ["05662"],
    "Mount Holly": ["05758"],
    "New Haven": ["05472"],
    "Newbury": ["05051"],
    "Newfane": ["05345"],
    "Newport": ["05855"],
    "Newport Center": ["05857"],
    "North Bennington": ["05257"],
    "North Clarendon": ["05759"],
    "North Concord": ["05858"],
    "North Ferrisburgh": ["05473"],
    "North Hartland": ["05052"],
    "North Hero": ["05474"],
    "North Hyde Park": ["05665"],
    "North Montpelier": ["05666"],
    "North Pomfret": ["05053"],
    "North Pownal": ["05260"],
    "North Springfield": ["05150"],
    "North Thetford": ["05054"],
    "North Troy": ["05859"],
    "Northfield": ["05663"],
    "Northfield Falls": ["05664"],
    "Norton": ["05907"],
    "Norwich": ["05055"],
    "Orleans": ["05860"],
    "Orwell": ["05760"],
    "Passumpsic": ["05861"],
    "Pawlet": ["05761"],
    "Peacham": ["05862"],
    "Perkinsville": ["05151"],
    "Peru": ["05152"],
    "Pittsfield": ["05762"],
    "Pittsford": ["05763"],
    "Plainfield": ["05667"],
    "Plymouth": ["05056"],
    "Post Mills": ["05058"],
    "Poultney": ["05764"],
    "Pownal": ["05261"],
    "Proctor": ["05765"],
    "Proctorsville": ["05153"],
    "Putney": ["05346"],
    "Quechee": ["05059"],
    "Randolph": ["05060"],
    "Randolph Center": ["05061"],
    "Reading": ["05062"],
    "Readsboro": ["05350"],
    "Richford": ["05476"],
    "Richmond": ["05477"],
    "Ripton": ["05766"],
    "Rochester": ["05767"],
    "Roxbury": ["05669"],
    "Rupert": ["05768"],
    "Rutland": ["05701", "05702"],
    "Saint Albans": ["05478"],
    "Saint Albans Bay": ["05481"],
    "Saint Johnsbury": ["05819"],
    "Saint Johnsbury Center": ["05863"],
    "Salisbury": ["05769"],
    "Saxtons River": ["05154"],
    "Shaftsbury": ["05262"],
    "Sharon": ["05065"],
    "Sheffield": ["05866"],
    "Shelburne": ["05482"],
    "Sheldon": ["05483"],
    "Sheldon Springs": ["05485"],
    "Shoreham": ["05770"],
    "South Barre": ["05670"],
    "South Burlington": ["05403", "05407"],
    "South Hero": ["05486"],
    "South Londonderry": ["05155"],
    "South Newfane": ["05351"],
    "South Pomfret": ["05067"],
    "South Royalton": ["05068"],
    "South Ryegate": ["05069"],
    "South Strafford": ["05070"],
    "South Woodstock": ["05071"],
    "Springfield": ["05156"],
    "Stamford": ["05352"],
    "Starksboro": ["05487"],
    "Stockbridge": ["05772"],
    "Stowe": ["05672"],
    "Strafford": ["05072"],
    "Sutton": ["05867"],
    "Swanton": ["05488"],
    "Taftsville": ["05073"],
    "Thetford": ["05074"],
    "Thetford Center": ["05075"],
    "Topsham": ["05076"],
    "Townshend": ["05353"],
    "Troy": ["05868"],
    "Tunbridge": ["05077"],
    "Underhill": ["05489"],
    "Underhill Center": ["05490"],
    "Vergennes": ["05491"],
    "Vernon": ["05354"],
    "Vershire": ["05079"],
    "Waitsfield": ["05673"],
    "Wallingford": ["05773"],
    "Wardsboro": ["05355"],
    "Warren": ["05674"],
    "Washington": ["05675"],
    "Waterbury": ["05671", "05676"],
    "Waterbury Center": ["05677"],
    "Waterville": ["05492"],
    "Websterville": ["05678"],
    "Wells": ["05774"],
    "Wells River": ["05081"],
    "West Burke": ["05871"],
    "West Charleston": ["05872"],
    "West Danville": ["05873"],
    "West Dover": ["05356"],
    "West Dummerston": ["05357"],
    "West Fairlee": ["05083"],
    "West Halifax": ["05358"],
    "West Hartford": ["05084"],
    "West Newbury": ["05085"],
    "West Pawlet": ["05775"],
    "West Rupert": ["05776"],
    "West Rutland": ["05777"],
    "West Topsham": ["05086"],
    "West Townshend": ["05359"],
    "West Wardsboro": ["05360"],
    "Westfield": ["05874"],
    "Westford": ["05494"],
    "Westminster": ["05158"],
    "Westminster Station": ["05159"],
    "Weston": ["05161"],
    "White River Junction": ["05001", "05009"],
    "Whiting": ["05778"],
    "Whitingham": ["05361"],
    "Wilder": ["05088"],
    "Williamstown": ["05679"],
    "Williamsville": ["05362"],
    "Williston": ["05495"],
    "Wilmington": ["05363"],
    "Windsor": ["05089"],
    "Winooski": ["05404"],
    "Wolcott": ["05680"],
    "Woodbury": ["05681"],
    "Woodstock": ["05091"],
    "Worcester": ["05682"]
  },
  "WA": {
    "Aberdeen": ["98520"],
    "Acme": ["98220"],
    "Addy": ["99101"],
    "Adna": ["98522"],
    "Airway Heights": ["99001"],
    "Albion": ["99102"],
    "Allyn": ["98524"],
    "Almira": ["99103"],
    "Amanda Park": ["98526"],
    "Amboy": ["98601"],
    "Anacortes": ["98221"],
    "Anatone": ["99401"],
    "Anderson Island": ["98303"],
    "Appleton": ["98602"],
    "Ardenvoir": ["98811"],
    "Ariel": ["98603"],
    "Arlington": ["98223"],
    "Ashford": ["98304"],
    "Asotin": ["99402"],
    "Auburn": ["98001", "98002", "98071", "98092"],
    "Bainbridge Island": ["98110"],
    "Baring": ["98224"],
    "Battle Ground": ["98604"],
    "Bay Center": ["98527"],
    "Beaver": ["98305"],
    "Belfair": ["98528"],
    "Bellevue": ["98004", "98005", "98006", "98007", "98008", "98009", "98015"],
    "Bellingham": ["98225", "98226", "98227", "98228", "98229"],
    "Belmont": ["99104"],
    "Benge": ["99105"],
    "Benton City": ["99320"],
    "Beverly": ["99321"],
    "Bickleton": ["99322"],
    "Bingen": ["98605"],
    "Black Diamond": ["98010"],
    "Blaine": ["98230", "98231"],
    "Blakely Island": ["98222"],
    "Bonney Lake": ["98391"],
    "Bothell": ["98011", "98012", "98021", "98041"],
    "Bow": ["98232"],
    "Boyds": ["99107"],
    "Bremerton": ["98310", "98311", "98312", "98314", "98337"],
    "Brewster": ["98812"],
    "Bridgeport": ["98813"],
    "Brinnon": ["98320"],
    "Brownstown": ["98920"],
    "Brush Prairie": ["98606"],
    "Buckley": ["98321"],
    "Bucoda": ["98530"],
    "Buena": ["98921"],
    "Burbank": ["99323"],
    "Burley": ["98322"],
    "Burlington": ["98233"],
    "Burton": ["98013"],
    "Camano Island": ["98282"],
    "Camas": ["98607"],
    "Camp Murray": ["98430"],
    "Carbonado": ["98323"],
    "Carlsborg": ["98324"],
    "Carlton": ["98814"],
    "Carnation": ["98014"],
    "Carrolls": ["98609"],
    "Carson": ["98610"],
    "Cashmere": ["98815"],
    "Castle Rock": ["98611"],
    "Cathlamet": ["98612"],
    "Centerville": ["98613"],
    "Centralia": ["98531"],
    "Chattaroy": ["99003"],
    "Chehalis": ["98532"],
    "Chelan": ["98816"],
    "Chelan Falls": ["98817"],
    "Cheney": ["99004"],
    "Chewelah": ["99109"],
    "Chimacum": ["98325"],
    "Chinook": ["98614"],
    "Cinebar": ["98533"],
    "Clallam Bay": ["98326"],
    "Clarkston": ["99403"],
    "Clayton": ["99110"],
    "Cle Elum": ["98922"],
    "Clearlake": ["98235"],
    "Clinton": ["98236"],
    "Colbert": ["99005"],
    "Colfax": ["99111"],
    "College Place": ["99324"],
    "Colton": ["99113"],
    "Colville": ["99114"],
    "Conconully": ["98819"],
    "Concrete": ["98237"],
    "Connell": ["99326"],
    "Conway": ["98238"],
    "Copalis Beach": ["98535"],
    "Copalis Crossing": ["98536"],
    "Cosmopolis": ["98537"],
    "Cougar": ["98616"],
    "Coulee City": ["99115"],
    "Coulee Dam": ["99116"],
    "Coupeville": ["98239"],
    "Cowiche": ["98923"],
    "Creston": ["99117"],
    "Curlew": ["99118"],
    "Curtis": ["98538"],
    "Cusick": ["99119"],
    "Custer": ["98240"],
    "Dallesport": ["98617"],
    "Danville": ["99121"],
    "Darrington": ["98241"],
    "Davenport": ["99122"],
    "Dayton": ["99328"],
    "Deer Harbor": ["98243"],
    "Deer Park": ["99006"],
    "Deming": ["98244"],
    "Dixie": ["99329"],
    "Doty": ["98539"],
    "Dryden": ["98821"],
    "Dupont": ["98327"],
    "Duvall": ["98019"],
    "East Olympia": ["98540"],
    "East Wenatchee": ["98802"],
    "Easton": ["98925"],
    "Eastsound": ["98245"],
    "Eatonville": ["98328"],
    "Edmonds": ["98020", "98026"],
    "Edwall": ["99008"],
    "Elbe": ["98330"],
    "Electric City": ["99123"],
    "Elk": ["99009"],
    "Ellensburg": ["98926"],
    "Elma": ["98541"],
    "Elmer City": ["99124"],
    "Eltopia": ["99330"],
    "Endicott": ["99125"],
    "Entiat": ["98822"],
    "Enumclaw": ["98022"],
    "Ephrata": ["98823"],
    "Ethel": ["98542"],
    "Evans": ["99126"],
    "Everett": ["98201", "98203", "98204", "98205", "98206", "98207", "98208", "98213"],
    "Everson": ["98247"],
    "Fairchild Air Force Base": ["99011"],
    "Fairfield": ["99012"],
    "Fall City": ["98024"],
    "Farmington": ["99128"],
    "Federal Way": ["98003", "98023", "98063", "98093"],
    "Ferndale": ["98248"],
    "Fife": ["98424"],
    "Ford": ["99013"],
    "Forks": ["98331"],
    "Four Lakes": ["99014"],
    "Fox Island": ["98333"],
    "Freeland": ["98249"],
    "Friday Harbor": ["98250"],
    "Fruitland": ["99129"],
    "Galvin": ["98544"],
    "Garfield": ["99130"],
    "George": ["98824"],
    "Gifford": ["99131"],
    "Gig Harbor": ["98329", "98332", "98335"],
    "Glenoma": ["98336"],
    "Glenwood": ["98619"],
    "Gold Bar": ["98251"],
    "Goldendale": ["98620"],
    "Graham": ["98338"],
    "Grand Coulee": ["99133"],
    "Grandview": ["98930"],
    "Granger": ["98932"],
    "Granite Falls": ["98252"],
    "Grapeview": ["98546"],
    "Grayland": ["98547"],
    "Grays River": ["98621"],
    "Greenacres": ["99016"],
    "Greenbank": ["98253"],
    "Hamilton": ["98255"],
    "Hansville": ["98340"],
    "Harrah": ["98933"],
    "Harrington": ["99134"],
    "Hartline": ["99135"],
    "Hay": ["99136"],
    "Heisson": ["98622"],
    "Hobart": ["98025"],
    "Hoodsport": ["98548"],
    "Hooper": ["99333"],
    "Hoquiam": ["98550"],
    "Humptulips": ["98552"],
    "Hunters": ["99137"],
    "Husum": ["98623"],
    "Ilwaco": ["98624"],
    "Inchelium": ["99138"],
    "Index": ["98256"],
    "Indianola": ["98342"],
    "Ione": ["99139"],
    "Issaquah": ["98027", "98029"],
    "Joyce": ["98343"],
    "Kahlotus": ["99335"],
    "Kalama": ["98625"],
    "Kapowsin": ["98344"],
    "Keller": ["99140"],
    "Kelso": ["98626"],
    "Kenmore": ["98028"],
    "Kennewick": ["99336", "99337", "99338"],
    "Kent": ["98030", "98031", "98032", "98035", "98042", "98064", "98089"],
    "Kettle Falls": ["99141"],
    "Keyport": ["98345"],
    "Kingston": ["98346"],
    "Kirkland": ["98033", "98034", "98083"],
    "Kittitas": ["98934"],
    "Klickitat": ["98628"],
    "La Center": ["98629"],
    "La Conner": ["98257"],
    "La Grande": ["98348"],
    "La Push": ["98350"],
    "Lacey": ["98503", "98509"],
    "Lacrosse": ["99143"],
    "Lake Stevens": ["98258"],
    "Lakebay": ["98349"],
    "Lakewood": ["98439", "98496", "98497", "98498", "98499"],
    "Lamona": ["99144"],
    "Lamont": ["99017"],
    "Langley": ["98260"],
    "Latah": ["99018"],
    "Laurier": ["99146"],
    "Leavenworth": ["98826"],
    "Lebam": ["98554"],
    "Liberty Lake": ["99019"],
    "Lilliwaup": ["98555"],
    "Lincoln": ["99147"],
    "Lind": ["99341"],
    "Littlerock": ["98556"],
    "Long Beach": ["98631"],
    "Longbranch": ["98351"],
    "Longmire": ["98397"],
    "Longview": ["98632"],
    "Loomis": ["98827"],
    "Loon Lake": ["99148"],
    "Lopez Island": ["98261"],
    "Lummi Island": ["98262"],
    "Lyle": ["98635"],
    "Lyman": ["98263"],
    "Lynden": ["98264"],
    "Lynnwood": ["98036", "98037", "98046", "98087"],
    "Mabton": ["98935"],
    "Malaga": ["98828"],
    "Malden": ["99149"],
    "Malo": ["99150"],
    "Malone": ["98559"],
    "Malott": ["98829"],
    "Manchester": ["98353"],
    "Mansfield": ["98830"],
    "Manson": ["98831"],
    "Maple Falls": ["98266"],
    "Maple Valley": ["98038"],
    "Marblemount": ["98267"],
    "Marcus": ["99151"],
    "Marlin": ["98832"],
    "Marshall": ["99020"],
    "Marysville": ["98270", "98271"],
    "Matlock": ["98560"],
    "Mattawa": ["99349"],
    "Mazama": ["98833"],
    "Mcchord AFB": ["98438"],
    "Mccleary": ["98557"],
    "Mckenna": ["98558"],
    "Mead": ["99021"],
    "Medical Lake": ["99022"],
    "Medina": ["98039"],
    "Menlo": ["98561"],
    "Mercer Island": ["98040"],
    "Mesa": ["99343"],
    "Metaline": ["99152"],
    "Metaline Falls": ["99153"],
    "Methow": ["98834"],
    "Mica": ["99023"],
    "Mill Creek": ["98082"],
    "Milton": ["98354"],
    "Mineral": ["98355"],
    "Moclips": ["98562"],
    "Mohler": ["99154"],
    "Monitor": ["98836"],
    "Monroe": ["98272"],
    "Montesano": ["98563"],
    "Morton": ["98356"],
    "Moses Lake": ["98837"],
    "Mossyrock": ["98564"],
    "Mount Vernon": ["98273", "98274"],
    "Mountlake Terrace": ["98043"],
    "Moxee": ["98936"],
    "Mukilteo": ["98275"],
    "Naches": ["98929", "98937"],
    "Nahcotta": ["98637"],
    "Napavine": ["98565"],
    "Naselle": ["98638"],
    "Neah Bay": ["98357"],
    "Neilton": ["98566"],
    "Nespelem": ["99155"],
    "Newman Lake": ["99025"],
    "Newport": ["99156"],
    "Nine Mile Falls": ["99026"],
    "Nooksack": ["98276"],
    "Nordland": ["98358"],
    "North Bend": ["98045"],
    "North Bonneville": ["98639"],
    "North Lakewood": ["98259"],
    "Northport": ["99157"],
    "Oak Harbor": ["98277", "98278"],
    "Oakesdale": ["99158"],
    "Oakville": ["98568"],
    "Ocean Park": ["98640"],
    "Ocean Shores": ["98569"],
    "Odessa": ["99159"],
    "Okanogan": ["98840"],
    "Olalla": ["98359"],
    "Olga": ["98279"],
    "Olympia": ["98501", "98502", "98504", "98505", "98506", "98507", "98508", "98512", "98513", "98516", "98599"],
    "Omak": ["98841"],
    "Onalaska": ["98570"],
    "Orcas": ["98280"],
    "Orient": ["99160"],
    "Orondo": ["98843"],
    "Oroville": ["98844"],
    "Orting": ["98360"],
    "Othello": ["99344"],
    "Otis Orchards": ["99027"],
    "Outlook": ["98938"],
    "Oysterville": ["98641"],
    "Pacific": ["98047"],
    "Pacific Beach": ["98571"],
    "Packwood": ["98361"],
    "Palisades": ["98845"],
    "Palouse": ["99161"],
    "Paradise Inn": ["98398"],
    "Parker": ["98939"],
    "Pasco": ["99301", "99302"],
    "Pateros": ["98846"],
    "Paterson": ["99345"],
    "Pe Ell": ["98572"],
    "Peshastin": ["98847"],
    "Plymouth": ["99346"],
    "Point Roberts": ["98281"],
    "Pomeroy": ["99347"],
    "Port Angeles": ["98362", "98363"],
    "Port Gamble": ["98364"],
    "Port Hadlock": ["98339"],
    "Port Ludlow": ["98365"],
    "Port Orchard": ["98366", "98367"],
    "Port Townsend": ["98368"],
    "Poulsbo": ["98370"],
    "Prescott": ["99348"],
    "Preston": ["98050"],
    "Prosser": ["99350"],
    "Pullman": ["99163", "99164", "99165"],
    "Puyallup": ["98371", "98372", "98373", "98374", "98375"],
    "Quilcene": ["98376"],
    "Quinault": ["98575"],
    "Quincy": ["98848"],
    "Rainier": ["98576"],
    "Randle": ["98377"],
    "Ravensdale": ["98051"],
    "Raymond": ["98577"],
    "Reardan": ["99029"],
    "Redmond": ["98052", "98053", "98073"],
    "Redondo": ["98054"],
    "Renton": ["98055", "98056", "98057", "98058", "98059"],
    "Republic": ["99166"],
    "Retsil": ["98378"],
    "Rice": ["99167"],
    "Richland": ["99352", "99354"],
    "Ridgefield": ["98642"],
    "Ritzville": ["99169"],
    "Riverside": ["98849"],
    "Rochester": ["98579"],
    "Rock Island": ["98850"],
    "Rockford": ["99030"],
    "Rockport": ["98283"],
    "Rollingbay": ["98061"],
    "Ronald": ["98940"],
    "Roosevelt": ["99356"],
    "Rosalia": ["99170"],
    "Rosburg": ["98643"],
    "Roslyn": ["98941"],
    "Roy": ["98580"],
    "Royal City": ["99357"],
    "Ryderwood": ["98581"],
    "Saint John": ["99171"],
    "Salkum": ["98582"],
    "Sammamish": ["98074", "98075"],
    "Satsop": ["98583"],
    "Seabeck": ["98380"],
    "Seahurst": ["98062"],
    "Seattle": ["98101", "98102", "98103", "98104", "98105", "98106", "98107", "98108", "98109", "98111", "98112", "98113", "98114", "98115", "98116", "98117", "98118", "98119", "98121", "98122", "98124", "98125", "98126", "98127", "98129", "98131", "98132", "98133", "98134", "98136", "98138", "98139", "98141", "98144", "98145", "98146", "98148", "98151", "98154", "98155", "98158", "98160", "98161", "98164", "98165", "98166", "98168", "98170", "98171", "98174", "98175", "98177", "98178", "98181", "98184", "98185", "98188", "98189", "98190", "98191", "98194", "98195", "98198", "98199"],
    "Seaview": ["98644"],
    "Sedro Woolley": ["98284"],
    "Sekiu": ["98381"],
    "Selah": ["98942"],
    "Sequim": ["98382"],
    "Shaw Island": ["98286"],
    "Shelton": ["98584"],
    "Silvana": ["98287"],
    "Silver Creek": ["98585"],
    "Silverdale": ["98315", "98383"],
    "Silverlake": ["98645"],
    "Skamokawa": ["98647"],
    "Skykomish": ["98288"],
    "Snohomish": ["98290", "98291", "98296"],
    "Snoqualmie": ["98065"],
    "Snoqualmie Pass": ["98068"],
    "Soap Lake": ["98851"],
    "South Bend": ["98586"],
    "South Cle Elum": ["98943"],
    "South Colby": ["98384"],
    "South Prairie": ["98385"],
    "Southworth": ["98386"],
    "Spanaway": ["98387"],
    "Spangle": ["99031"],
    "Spokane": ["99201", "99202", "99203", "99204", "99205", "99206", "99207", "99208", "99209", "99210", "99211", "99212", "99213", "99214", "99215", "99216", "99217", "99218", "99219", "99220", "99223", "99224", "99228", "99251", "99252", "99256", "99258", "99260", "99299"],
    "Sprague": ["99032"],
    "Springdale": ["99173"],
    "Stanwood": ["98292"],
    "Starbuck": ["99359"],
    "Startup": ["98293"],
    "Stehekin": ["98852"],
    "Steilacoom": ["98388"],
    "Steptoe": ["99174"],
    "Stevenson": ["98648"],
    "Stratford": ["98853"],
    "Sultan": ["98294"],
    "Sumas": ["98295"],
    "Sumner": ["98352", "98390"],
    "Sunnyside": ["98944"],
    "Suquamish": ["98392"],
    "Tacoma": ["98401", "98402", "98403", "98404", "98405", "98406", "98407", "98408", "98409", "98411", "98412", "98413", "98415", "98416", "98417", "98418", "98419", "98421", "98422", "98431", "98433", "98442", "98443", "98444", "98445", "98446", "98447", "98448", "98450", "98455", "98460", "98464", "98465", "98466", "98471", "98477", "98481", "98490", "98492", "98493"],
    "Taholah": ["98587"],
    "Tahuya": ["98588"],
    "Tekoa": ["99033"],
    "Tenino": ["98589"],
    "Thornton": ["99176"],
    "Thorp": ["98946"],
    "Tieton": ["98947"],
    "Tokeland": ["98590"],
    "Toledo": ["98591"],
    "Tonasket": ["98855"],
    "Toppenish": ["98948"],
    "Touchet": ["99360"],
    "Toutle": ["98649"],
    "Tracyton": ["98393"],
    "Trout Lake": ["98650"],
    "Tumtum": ["99034"],
    "Tumwater": ["98511"],
    "Twisp": ["98856"],
    "Underwood": ["98651"],
    "Union": ["98592"],
    "Uniontown": ["99179"],
    "University Place": ["98467"],
    "Usk": ["99180"],
    "Vader": ["98593"],
    "Valley": ["99181"],
    "Valleyford": ["99036"],
    "Vancouver": ["98660", "98661", "98662", "98663", "98664", "98665", "98666", "98667", "98668", "98682", "98683", "98684", "98685", "98686", "98687"],
    "Vantage": ["98950"],
    "Vashon": ["98070"],
    "Vaughn": ["98394"],
    "Veradale": ["99037"],
    "Wahkiacus": ["98670"],
    "Waitsburg": ["99361"],
    "Waldron": ["98297"],
    "Walla Walla": ["99362"],
    "Wallula": ["99363"],
    "Wapato": ["98951"],
    "Warden": ["98857"],
    "Washougal": ["98671"],
    "Washtucna": ["99371"],
    "Waterville": ["98858"],
    "Wauconda": ["98859"],
    "Wauna": ["98395"],
    "Waverly": ["99039"],
    "Wellpinit": ["99040"],
    "Wenatchee": ["98801", "98807"],
    "West Richland": ["99353"],
    "Westport": ["98595"],
    "White Salmon": ["98672"],
    "White Swan": ["98952"],
    "Wilbur": ["99185"],
    "Wilkeson": ["98396"],
    "Wilson Creek": ["98860"],
    "Winlock": ["98596"],
    "Winthrop": ["98862"],
    "Wishram": ["98673"],
    "Woodinville": ["98072", "98077"],
    "Woodland": ["98674"],
    "Yacolt": ["98675"],
    "Yakima": ["98901", "98902", "98903", "98904", "98907", "98908", "98909"],
    "Yelm": ["98597"],
    "Zillah": ["98953"]
  },
  "WI": {
    "Abbotsford": ["54405"],
    "Abrams": ["54101"],
    "Adams": ["53910"],
    "Adell": ["53001"],
    "Afton": ["53501"],
    "Albany": ["53502"],
    "Algoma": ["54201"],
    "Allenton": ["53002"],
    "Alma": ["54610"],
    "Alma Center": ["54611"],
    "Almena": ["54805"],
    "Almond": ["54909"],
    "Altoona": ["54720"],
    "Amberg": ["54102"],
    "Amery": ["54001"],
    "Amherst": ["54406"],
    "Amherst Junction": ["54407"],
    "Aniwa": ["54408"],
    "Antigo": ["54409"],
    "Appleton": ["54911", "54912", "54913", "54914", "54915", "54919"],
    "Arcadia": ["54612"],
    "Arena": ["53503"],
    "Argonne": ["54511"],
    "Argyle": ["53504"],
    "Arkansaw": ["54721"],
    "Arkdale": ["54613"],
    "Arlington": ["53911"],
    "Armstrong Creek": ["54103"],
    "Arpin": ["54410"],
    "Ashippun": ["53003"],
    "Ashland": ["54806"],
    "Athelstane": ["54104"],
    "Athens": ["54411"],
    "Auburndale": ["54412"],
    "Augusta": ["54722"],
    "Avalon": ["53505"],
    "Avoca": ["53506"],
    "Babcock": ["54413"],
    "Bagley": ["53801"],
    "Baileys Harbor": ["54202"],
    "Baldwin": ["54002"],
    "Balsam Lake": ["54810"],
    "Bancroft": ["54921"],
    "Bangor": ["54614"],
    "Baraboo": ["53913"],
    "Barneveld": ["53507"],
    "Barron": ["54812"],
    "Barronett": ["54813"],
    "Bassett": ["53101"],
    "Bay City": ["54723"],
    "Bayfield": ["54814"],
    "Bear Creek": ["54922"],
    "Beaver Dam": ["53916"],
    "Beetown": ["53802"],
    "Beldenville": ["54003"],
    "Belgium": ["53004"],
    "Belleville": ["53508"],
    "Belmont": ["53510"],
    "Beloit": ["53511", "53512"],
    "Benet Lake": ["53102"],
    "Benoit": ["54816"],
    "Benton": ["53803"],
    "Berlin": ["54923"],
    "Big Bend": ["53103"],
    "Big Falls": ["54926"],
    "Birchwood": ["54817"],
    "Birnamwood": ["54414"],
    "Black Creek": ["54106"],
    "Black Earth": ["53515"],
    "Black River Falls": ["54615"],
    "Blair": ["54616"],
    "Blanchardville": ["53516"],
    "Blenker": ["54415"],
    "Bloomer": ["54724"],
    "Bloomington": ["53804"],
    "Blue Mounds": ["53517"],
    "Blue River": ["53518"],
    "Bonduel": ["54107"],
    "Boscobel": ["53805"],
    "Boulder Junction": ["54512"],
    "Bowler": ["54416"],
    "Boyceville": ["54725"],
    "Boyd": ["54726"],
    "Brandon": ["53919"],
    "Brantwood": ["54513"],
    "Briggsville": ["53920"],
    "Brill": ["54818"],
    "Brillion": ["54110"],
    "Bristol": ["53104"],
    "Brodhead": ["53520"],
    "Brokaw": ["54417"],
    "Brookfield": ["53005", "53008", "53045"],
    "Brooklyn": ["53521"],
    "Brownsville": ["53006"],
    "Browntown": ["53522"],
    "Bruce": ["54819"],
    "Brule": ["54820"],
    "Brussels": ["54204"],
    "Bryant": ["54418"],
    "Burlington": ["53105"],
    "Burnett": ["53922"],
    "Butler": ["53007"],
    "Butte Des Morts": ["54927"],
    "Butternut": ["54514"],
    "Cable": ["54821"],
    "Cadott": ["54727"],
    "Caledonia": ["53108"],
    "Cambria": ["53923"],
    "Cambridge": ["53523"],
    "Cameron": ["54822"],
    "Camp Douglas": ["54618"],
    "Camp Lake": ["53109"],
    "Campbellsport": ["53010"],
    "Caroline": ["54928"],
    "Cascade": ["53011"],
    "Casco": ["54205"],
    "Cashton": ["54619"],
    "Cassville": ["53806"],
    "Cataract": ["54620"],
    "Catawba": ["54515"],
    "Cazenovia": ["53924"],
    "Cecil": ["54111"],
    "Cedar Grove": ["53013"],
    "Cedarburg": ["53012"],
    "Centuria": ["54824"],
    "Chaseburg": ["54621"],
    "Chetek": ["54728"],
    "Chili": ["54420"],
    "Chilton": ["53014"],
    "Chippewa Falls": ["54729", "54774"],
    "Clam Lake": ["54517"],
    "Clayton": ["54004"],
    "Clear Lake": ["54005"],
    "Cleveland": ["53015"],
    "Clinton": ["53525"],
    "Clintonville": ["54929"],
    "Clyman": ["53016"],
    "Cobb": ["53526"],
    "Cochrane": ["54622"],
    "Colby": ["54421"],
    "Coleman": ["54112"],
    "Colfax": ["54730"],
    "Colgate": ["53017"],
    "Collins": ["54207"],
    "Coloma": ["54930"],
    "Columbus": ["53925"],
    "Combined Locks": ["54113"],
    "Comstock": ["54826"],
    "Conover": ["54519"],
    "Conrath": ["54731"],
    "Coon Valley": ["54623"],
    "Cornell": ["54732"],
    "Cornucopia": ["54827"],
    "Cottage Grove": ["53527"],
    "Couderay": ["54828"],
    "Crandon": ["54520"],
    "Crivitz": ["54114"],
    "Cross Plains": ["53528"],
    "Cuba City": ["53807"],
    "Cudahy": ["53110"],
    "Cumberland": ["54829"],
    "Curtiss": ["54422"],
    "Cushing": ["54006"],
    "Custer": ["54423"],
    "Dale": ["54931"],
    "Dallas": ["54733"],
    "Dalton": ["53926"],
    "Danbury": ["54830"],
    "Dane": ["53529"],
    "Darien": ["53114"],
    "Darlington": ["53530"],
    "De Pere": ["54115"],
    "De Soto": ["54624"],
    "Deer Park": ["54007"],
    "Deerbrook": ["54424"],
    "Deerfield": ["53531"],
    "Deforest": ["53532"],
    "Delafield": ["53018"],
    "Delavan": ["53115"],
    "Dellwood": ["53927"],
    "Denmark": ["54208"],
    "Dickeyville": ["53808"],
    "Dodge": ["54625"],
    "Dodgeville": ["53533", "53595"],
    "Dorchester": ["54425"],
    "Dousman": ["53118"],
    "Downing": ["54734"],
    "Downsville": ["54735"],
    "Doylestown": ["53928"],
    "Dresser": ["54009"],
    "Drummond": ["54832"],
    "Dunbar": ["54119"],
    "Durand": ["54736"],
    "Eagle": ["53119"],
    "Eagle River": ["54521"],
    "East Ellsworth": ["54010"],
    "East Troy": ["53120"],
    "Eastman": ["54626"],
    "Eau Claire": ["54701", "54702", "54703"],
    "Eau Galle": ["54737"],
    "Eden": ["53019"],
    "Edgar": ["54426"],
    "Edgerton": ["53534"],
    "Edgewater": ["54834"],
    "Edmund": ["53535"],
    "Egg Harbor": ["54209"],
    "Eland": ["54427"],
    "Elcho": ["54428"],
    "Elderon": ["54429"],
    "Eldorado": ["54932"],
    "Eleva": ["54738"],
    "Elk Mound": ["54739"],
    "Elkhart Lake": ["53020"],
    "Elkhorn": ["53121"],
    "Ellison Bay": ["54210"],
    "Ellsworth": ["54011"],
    "Elm Grove": ["53122"],
    "Elmwood": ["54740"],
    "Elroy": ["53929"],
    "Elton": ["54430"],
    "Embarrass": ["54933"],
    "Endeavor": ["53930"],
    "Ephraim": ["54211"],
    "Ettrick": ["54627"],
    "Eureka": ["54934"],
    "Evansville": ["53536"],
    "Exeland": ["54835"],
    "Fairchild": ["54741"],
    "Fairwater": ["53931"],
    "Fall Creek": ["54742"],
    "Fall River": ["53932"],
    "Fence": ["54120"],
    "Fennimore": ["53809"],
    "Ferryville": ["54628"],
    "Fifield": ["54524"],
    "Fish Creek": ["54212"],
    "Florence": ["54121"],
    "Fond Du Lac": ["54935", "54936", "54937"],
    "Fontana": ["53125"],
    "Footville": ["53537"],
    "Forest Junction": ["54123"],
    "Forestville": ["54213"],
    "Fort Atkinson": ["53538"],
    "Fountain City": ["54629"],
    "Fox Lake": ["53933"],
    "Foxboro": ["54836"],
    "Francis Creek": ["54214"],
    "Franklin": ["53132"],
    "Franksville": ["53126"],
    "Frederic": ["54837"],
    "Fredonia": ["53021"],
    "Freedom": ["54131"],
    "Fremont": ["54940"],
    "Friendship": ["53934"],
    "Friesland": ["53935"],
    "Galesville": ["54630"],
    "Galloway": ["54432"],
    "Gays Mills": ["54631"],
    "Genesee Depot": ["53127"],
    "Genoa": ["54632"],
    "Genoa City": ["53128"],
    "Germantown": ["53022"],
    "Gile": ["54525"],
    "Gillett": ["54124"],
    "Gilman": ["54433"],
    "Gilmanton": ["54743"],
    "Gleason": ["54435"],
    "Glen Flora": ["54526"],
    "Glen Haven": ["53810"],
    "Glenbeulah": ["53023"],
    "Glenwood City": ["54013"],
    "Glidden": ["54527"],
    "Goodman": ["54125"],
    "Gordon": ["54838"],
    "Gotham": ["53540"],
    "Grafton": ["53024"],
    "Grand Marsh": ["53936"],
    "Grand View": ["54839"],
    "Granton": ["54436"],
    "Grantsburg": ["54840"],
    "Gratiot": ["53541"],
    "Green Bay": ["54301", "54302", "54303", "54304", "54305", "54306", "54307", "54308", "54311", "54313", "54324", "54344"],
    "Green Lake": ["54941"],
    "Green Valley": ["54127"],
    "Greenbush": ["53026"],
    "Greendale": ["53129"],
    "Greenleaf": ["54126"],
    "Greenville": ["54942"],
    "Greenwood": ["54437"],
    "Gresham": ["54128"],
    "Hager City": ["54014"],
    "Hales Corners": ["53130"],
    "Hammond": ["54015"],
    "Hancock": ["54943"],
    "Hannibal": ["54439"],
    "Hanover": ["53542"],
    "Harshaw": ["54529"],
    "Hartford": ["53027"],
    "Hartland": ["53029"],
    "Hatley": ["54440"],
    "Haugen": ["54841"],
    "Hawkins": ["54530"],
    "Hawthorne": ["54842"],
    "Hayward": ["54843"],
    "Hazel Green": ["53811"],
    "Hazelhurst": ["54531"],
    "Heafford Junction": ["54532"],
    "Helenville": ["53137"],
    "Herbster": ["54844"],
    "Hertel": ["54845"],
    "Hewitt": ["54441"],
    "High Bridge": ["54846"],
    "Highland": ["53543"],
    "Hilbert": ["54129"],
    "Hillpoint": ["53937"],
    "Hillsboro": ["54634"],
    "Hingham": ["53031"],
    "Hixton": ["54635"],
    "Holcombe": ["54745"],
    "Hollandale": ["53544"],
    "Holmen": ["54636"],
    "Honey Creek": ["53138"],
    "Horicon": ["53032"],
    "Hortonville": ["54944"],
    "Houlton": ["54082"],
    "Hubertus": ["53033"],
    "Hudson": ["54016"],
    "Humbird": ["54746"],
    "Hurley": ["54534"],
    "Hustisford": ["53034"],
    "Hustler": ["54637"],
    "Independence": ["54747"],
    "Iola": ["54945", "54990"],
    "Irma": ["54442"],
    "Iron Belt": ["54536"],
    "Iron Ridge": ["53035"],
    "Iron River": ["54847"],
    "Ixonia": ["53036"],
    "Jackson": ["53037"],
    "Janesville": ["53545", "53546", "53547", "53548"],
    "Jefferson": ["53549"],
    "Jim Falls": ["54748"],
    "Johnson Creek": ["53038"],
    "Juda": ["53550"],
    "Jump River": ["54434"],
    "Junction City": ["54443"],
    "Juneau": ["53039"],
    "Kansasville": ["53139"],
    "Kaukauna": ["54130"],
    "Kellnersville": ["54215"],
    "Kendall": ["54638"],
    "Kennan": ["54537"],
    "Kenosha": ["53140", "53141", "53142", "53143", "53144"],
    "Keshena": ["54135"],
    "Kewaskum": ["53040"],
    "Kewaunee": ["54216"],
    "Kiel": ["53042"],
    "Kieler": ["53812"],
    "Kimberly": ["54136"],
    "King": ["54946"],
    "Kingston": ["53939"],
    "Knapp": ["54749"],
    "Kohler": ["53044"],
    "Krakow": ["54137"],
    "La Crosse": ["54601", "54602", "54603"],
    "La Farge": ["54639"],
    "La Pointe": ["54850"],
    "La Valle": ["53941"],
    "Lac Du Flambeau": ["54538"],
    "Ladysmith": ["54848"],
    "Lake Delton": ["53940"],
    "Lake Geneva": ["53147"],
    "Lake Mills": ["53551"],
    "Lake Nebagamon": ["54849"],
    "Lake Tomahawk": ["54539"],
    "Lakewood": ["54138"],
    "Lancaster": ["53813"],
    "Land O Lakes": ["54540"],
    "Lannon": ["53046"],
    "Laona": ["54541"],
    "Larsen": ["54947"],
    "Lebanon": ["53047"],
    "Lena": ["54139"],
    "Leopolis": ["54948"],
    "Lime Ridge": ["53942"],
    "Linden": ["53553"],
    "Little Chute": ["54140"],
    "Little Suamico": ["54141"],
    "Livingston": ["53554"],
    "Lodi": ["53555"],
    "Loganville": ["53943"],
    "Lomira": ["53048"],
    "Lone Rock": ["53556"],
    "Long Lake": ["54542"],
    "Lowell": ["53557"],
    "Loyal": ["54446"],
    "Lublin": ["54447"],
    "Luck": ["54853"],
    "Luxemburg": ["54217"],
    "Lyndon Station": ["53944"],
    "Lynxville": ["54640"],
    "Lyons": ["53148"],
    "Madison": ["53701", "53702", "53703", "53704", "53705", "53706", "53707", "53708", "53711", "53713", "53714", "53715", "53716", "53717", "53718", "53719", "53725", "53726", "53744", "53774", "53777", "53778", "53779", "53782", "53783", "53784", "53785", "53786", "53788", "53789", "53790", "53791", "53792", "53793", "53794"],
    "Maiden Rock": ["54750"],
    "Malone": ["53049"],
    "Manawa": ["54949"],
    "Manitowish Waters": ["54545"],
    "Manitowoc": ["54220", "54221"],
    "Maple": ["54854"],
    "Maplewood": ["54226"],
    "Marathon": ["54448"],
    "Marengo": ["54855"],
    "Maribel": ["54227"],
    "Marinette": ["54143"],
    "Marion": ["54950"],
    "Markesan": ["53946"],
    "Marquette": ["53947"],
    "Marshall": ["53559"],
    "Marshfield": ["54404", "54449", "54472"],
    "Mason": ["54856"],
    "Mather": ["54641"],
    "Mattoon": ["54450"],
    "Mauston": ["53948"],
    "Mayville": ["53050"],
    "Mazomanie": ["53560"],
    "Mc Naughton": ["54543"],
    "Mcfarland": ["53558"],
    "Medford": ["54451"],
    "Mellen": ["54546"],
    "Melrose": ["54642"],
    "Menasha": ["54952"],
    "Menomonee Falls": ["53051", "53052"],
    "Menomonie": ["54751"],
    "Mequon": ["53092", "53097"],
    "Mercer": ["54547"],
    "Merrill": ["54452"],
    "Merrillan": ["54754"],
    "Merrimac": ["53561"],
    "Merton": ["53056"],
    "Middleton": ["53562"],
    "Mikana": ["54857"],
    "Milladore": ["54454"],
    "Millston": ["54643"],
    "Milltown": ["54858"],
    "Milton": ["53563"],
    "Milwaukee": ["53201", "53202", "53203", "53204", "53205", "53206", "53207", "53208", "53209", "53210", "53211", "53212", "53213", "53214", "53215", "53216", "53217", "53218", "53219", "53220", "53221", "53222", "53223", "53224", "53225", "53226", "53227", "53228", "53233", "53234", "53237", "53244", "53259", "53263", "53267", "53268", "53274", "53278", "53288", "53290", "53293", "53295"],
    "Mindoro": ["54644"],
    "Mineral Point": ["53565"],
    "Minocqua": ["54548"],
    "Minong": ["54859"],
    "Mishicot": ["54228"],
    "Mondovi": ["54755"],
    "Monroe": ["53566"],
    "Montello": ["53949"],
    "Montfort": ["53569"],
    "Monticello": ["53570"],
    "Montreal": ["54550"],
    "Morrisonville": ["53571"],
    "Mosinee": ["54455"],
    "Mount Calvary": ["53057"],
    "Mount Hope": ["53816"],
    "Mount Horeb": ["53572"],
    "Mount Sterling": ["54645"],
    "Mountain": ["54149"],
    "Mukwonago": ["53149"],
    "Muscoda": ["53573"],
    "Muskego": ["53150"],
    "Nashotah": ["53058"],
    "Necedah": ["54646"],
    "Neenah": ["54956", "54957"],
    "Neillsville": ["54456"],
    "Nekoosa": ["54457"],
    "Nelson": ["54756"],
    "Nelsonville": ["54458"],
    "Neopit": ["54150"],
    "Neosho": ["53059"],
    "Neshkoro": ["54960"],
    "New Auburn": ["54757"],
    "New Berlin": ["53146", "53151"],
    "New Franken": ["54229"],
    "New Glarus": ["53574"],
    "New Holstein": ["53061", "53062"],
    "New Lisbon": ["53950"],
    "New London": ["54961"],
    "New Munster": ["53152"],
    "New Richmond": ["54017"],
    "Newburg": ["53060"],
    "Newton": ["53063"],
    "Niagara": ["54151"],
    "Nichols": ["54152"],
    "North Freedom": ["53951"],
    "North Lake": ["53064"],
    "North Prairie": ["53153"],
    "Norwalk": ["54648"],
    "Oak Creek": ["53154"],
    "Oakdale": ["54649"],
    "Oakfield": ["53065"],
    "Oconomowoc": ["53066"],
    "Oconto": ["54153"],
    "Oconto Falls": ["54154"],
    "Odanah": ["54861"],
    "Ogdensburg": ["54962"],
    "Ogema": ["54459"],
    "Ojibwa": ["54862"],
    "Okauchee": ["53069"],
    "Omro": ["54963"],
    "Onalaska": ["54650"],
    "Oneida": ["54155"],
    "Ontario": ["54651"],
    "Oostburg": ["53070"],
    "Oregon": ["53575"],
    "Orfordville": ["53576"],
    "Osceola": ["54020"],
    "Oshkosh": ["54901", "54902", "54903", "54904", "54906"],
    "Osseo": ["54758"],
    "Owen": ["54460"],
    "Oxford": ["53952"],
    "Packwaukee": ["53953"],
    "Palmyra": ["53156"],
    "Pardeeville": ["53954"],
    "Park Falls": ["54552"],
    "Patch Grove": ["53817"],
    "Pearson": ["54462"],
    "Pelican Lake": ["54463"],
    "Pell Lake": ["53157"],
    "Pembine": ["54156"],
    "Pepin": ["54759"],
    "Peshtigo": ["54157"],
    "Pewaukee": ["53072"],
    "Phelps": ["54554"],
    "Phillips": ["54555"],
    "Phlox": ["54464"],
    "Pickerel": ["54465"],
    "Pickett": ["54964"],
    "Pigeon Falls": ["54760"],
    "Pine River": ["54965"],
    "Pittsville": ["54466"],
    "Plain": ["53577"],
    "Plainfield": ["54966"],
    "Platteville": ["53818"],
    "Pleasant Prairie": ["53158"],
    "Plover": ["54467"],
    "Plum City": ["54761"],
    "Plymouth": ["53073"],
    "Poplar": ["54864"],
    "Port Edwards": ["54469"],
    "Port Washington": ["53074"],
    "Port Wing": ["54865"],
    "Portage": ["53901"],
    "Porterfield": ["54159"],
    "Potosi": ["53820"],
    "Potter": ["54160"],
    "Pound": ["54161"],
    "Powers Lake": ["53159"],
    "Poy Sippi": ["54967"],
    "Poynette": ["53955"],
    "Prairie Du Chien": ["53821"],
    "Prairie Du Sac": ["53578"],
    "Prairie Farm": ["54762"],
    "Prentice": ["54556"],
    "Prescott": ["54021"],
    "Presque Isle": ["54557"],
    "Princeton": ["54968"],
    "Pulaski": ["54162"],
    "Racine": ["53401", "53402", "53403", "53404", "53405", "53406", "53407", "53408"],
    "Radisson": ["54867"],
    "Randolph": ["53956", "53957"],
    "Random Lake": ["53075"],
    "Readfield": ["54969"],
    "Readstown": ["54652"],
    "Redgranite": ["54970"],
    "Reedsburg": ["53958", "53959"],
    "Reedsville": ["54230"],
    "Reeseville": ["53579"],
    "Rewey": ["53580"],
    "Rhinelander": ["54501"],
    "Rib Lake": ["54470"],
    "Rice Lake": ["54868"],
    "Richfield": ["53076"],
    "Richland Center": ["53581"],
    "Ridgeland": ["54763"],
    "Ridgeway": ["53582"],
    "Ringle": ["54471"],
    "Rio": ["53960"],
    "Ripon": ["54971"],
    "River Falls": ["54022"],
    "Roberts": ["54023"],
    "Rochester": ["53167"],
    "Rock Falls": ["54764"],
    "Rock Springs": ["53961"],
    "Rockland": ["54653"],
    "Rosendale": ["54974"],
    "Rosholt": ["54473"],
    "Rothschild": ["54474"],
    "Rubicon": ["53078"],
    "Rudolph": ["54475"],
    "Saint Cloud": ["53079"],
    "Saint Croix Falls": ["54024"],
    "Saint Francis": ["53235"],
    "Saint Germain": ["54558"],
    "Saint Nazianz": ["54232"],
    "Salem": ["53168"],
    "Sand Creek": ["54765"],
    "Sarona": ["54870"],
    "Sauk City": ["53583"],
    "Saukville": ["53080"],
    "Saxeville": ["54976"],
    "Saxon": ["54559"],
    "Sayner": ["54560"],
    "Scandinavia": ["54977"],
    "Schofield": ["54476"],
    "Seneca": ["54654"],
    "Sextonville": ["53584"],
    "Seymour": ["54165"],
    "Sharon": ["53585"],
    "Shawano": ["54166"],
    "Sheboygan": ["53081", "53082", "53083"],
    "Sheboygan Falls": ["53085"],
    "Sheldon": ["54766"],
    "Shell Lake": ["54871"],
    "Sherwood": ["54169"],
    "Shiocton": ["54170"],
    "Shullsburg": ["53586"],
    "Silver Lake": ["53170", "53199"],
    "Sinsinawa": ["53824"],
    "Siren": ["54872"],
    "Sister Bay": ["54234"],
    "Slinger": ["53086"],
    "Sobieski": ["54171"],
    "Soldiers Grove": ["54655"],
    "Solon Springs": ["54873"],
    "Somers": ["53171"],
    "Somerset": ["54025"],
    "South Milwaukee": ["53172"],
    "South Range": ["54874"],
    "South Wayne": ["53587"],
    "Sparta": ["54656"],
    "Spencer": ["54479"],
    "Spooner": ["54801"],
    "Spring Green": ["53588"],
    "Spring Valley": ["54767"],
    "Springbrook": ["54875"],
    "Springfield": ["53176"],
    "Stanley": ["54768"],
    "Star Lake": ["54561"],
    "Star Prairie": ["54026"],
    "Stetsonville": ["54480"],
    "Steuben": ["54657"],
    "Stevens Point": ["54481", "54482", "54492"],
    "Stitzer": ["53825"],
    "Stockbridge": ["53088"],
    "Stockholm": ["54769"],
    "Stoddard": ["54658"],
    "Stone Lake": ["54876"],
    "Stoughton": ["53589"],
    "Stratford": ["54484"],
    "Strum": ["54770"],
    "Sturgeon Bay": ["54235"],
    "Sturtevant": ["53177"],
    "Suamico": ["54173"],
    "Sullivan": ["53178"],
    "Summit Lake": ["54485"],
    "Sun Prairie": ["53590", "53596"],
    "Superior": ["54880"],
    "Suring": ["54174"],
    "Sussex": ["53089"],
    "Taylor": ["54659"],
    "Theresa": ["53091"],
    "Thorp": ["54771"],
    "Three Lakes": ["54562"],
    "Tigerton": ["54486"],
    "Tilleda": ["54978"],
    "Tisch Mills": ["54240"],
    "Tomah": ["54660"],
    "Tomahawk": ["54487"],
    "Tony": ["54563"],
    "Townsend": ["54175"],
    "Trego": ["54888"],
    "Trempealeau": ["54661"],
    "Trevor": ["53179"],
    "Tripoli": ["54564"],
    "Tunnel City": ["54662"],
    "Turtle Lake": ["54889"],
    "Twin Lakes": ["53181"],
    "Two Rivers": ["54241"],
    "Union Center": ["53962"],
    "Union Grove": ["53182"],
    "Unity": ["54488"],
    "Upson": ["54565"],
    "Valders": ["54245"],
    "Van Dyne": ["54979"],
    "Verona": ["53593"],
    "Vesper": ["54489"],
    "Viola": ["54664"],
    "Viroqua": ["54665"],
    "Wabeno": ["54566"],
    "Waldo": ["53093"],
    "Wales": ["53183"],
    "Walworth": ["53184"],
    "Warrens": ["54666"],
    "Wascott": ["54890"],
    "Washburn": ["54891"],
    "Washington Island": ["54246"],
    "Waterford": ["53185"],
    "Waterloo": ["53594"],
    "Watertown": ["53094", "53098"],
    "Waukau": ["54980"],
    "Waukesha": ["53186", "53187", "53188", "53189"],
    "Waunakee": ["53597"],
    "Waupaca": ["54981"],
    "Waupun": ["53963"],
    "Wausau": ["54401", "54402", "54403"],
    "Wausaukee": ["54177"],
    "Wautoma": ["54982"],
    "Wauzeka": ["53826"],
    "Webster": ["54893"],
    "West Bend": ["53090", "53095"],
    "West Salem": ["54669"],
    "Westboro": ["54490"],
    "Westby": ["54667"],
    "Westfield": ["53964"],
    "Weyauwega": ["54983"],
    "Weyerhaeuser": ["54895"],
    "Wheeler": ["54772"],
    "White Lake": ["54491"],
    "Whitehall": ["54773"],
    "Whitelaw": ["54247"],
    "Whitewater": ["53190"],
    "Wild Rose": ["54984"],
    "Willard": ["54493"],
    "Williams Bay": ["53191"],
    "Wilmot": ["53192"],
    "Wilson": ["54027"],
    "Wilton": ["54670"],
    "Windsor": ["53598"],
    "Winnebago": ["54985"],
    "Winneconne": ["54986"],
    "Winter": ["54896"],
    "Wisconsin Dells": ["53965"],
    "Wisconsin Rapids": ["54494", "54495"],
    "Withee": ["54498"],
    "Wittenberg": ["54499"],
    "Wonewoc": ["53968"],
    "Woodford": ["53599"],
    "Woodland": ["53099"],
    "Woodman": ["53827"],
    "Woodruff": ["54568"],
    "Woodville": ["54028"],
    "Woodworth": ["53194"],
    "Wrightstown": ["54180"],
    "Wyocena": ["53969"],
    "Zachow": ["54182"],
    "Zenda": ["53195"]
  },
  "WV": {
    "Accoville": ["25606"],
    "Adrian": ["26210"],
    "Advent": ["25231"],
    "Albright": ["26519"],
    "Alderson": ["24910"],
    "Alkol": ["25501"],
    "Allen Junction": ["25810"],
    "Alloy": ["25002"],
    "Alma": ["26320"],
    "Alum Bridge": ["26321"],
    "Alum Creek": ["25003"],
    "Amherstdale": ["25607"],
    "Amigo": ["25811"],
    "Amma": ["25005"],
    "Anawalt": ["24808"],
    "Anmoore": ["26323"],
    "Ansted": ["25812"],
    "Apple Grove": ["25502"],
    "Arbovale": ["24915"],
    "Arnett": ["25007"],
    "Arnoldsburg": ["25234"],
    "Arthurdale": ["26520"],
    "Artie": ["25008"],
    "Asbury": ["24916"],
    "Ashford": ["25009"],
    "Ashton": ["25503"],
    "Athens": ["24712"],
    "Auburn": ["26325"],
    "Augusta": ["26704"],
    "Aurora": ["26705"],
    "Avondale": ["24811"],
    "Baisden": ["25608"],
    "Baker": ["26801"],
    "Bakerton": ["25410"],
    "Ballard": ["24918"],
    "Bancroft": ["25011"],
    "Barboursville": ["25504"],
    "Barrackville": ["26559"],
    "Bartley": ["24813"],
    "Bartow": ["24920"],
    "Baxter": ["26560"],
    "Bayard": ["26707"],
    "Beaver": ["25813"],
    "Beckley": ["25801", "25802", "25926"],
    "Beech Bottom": ["26030"],
    "Beeson": ["24714"],
    "Belington": ["26250"],
    "Belle": ["25015"],
    "Belleville": ["26133"],
    "Belmont": ["26134"],
    "Belva": ["26656"],
    "Benwood": ["26031"],
    "Berea": ["26327"],
    "Bergoo": ["26298"],
    "Berkeley Springs": ["25411"],
    "Berwind": ["24815"],
    "Bethany": ["26032"],
    "Beverly": ["26253"],
    "Bickmore": ["25019"],
    "Big Bend": ["26136"],
    "Big Creek": ["25505"],
    "Big Run": ["26561"],
    "Big Sandy": ["24816"],
    "Big Springs": ["26137"],
    "Bim": ["25021"],
    "Birch River": ["26610"],
    "Blacksville": ["26521"],
    "Blair": ["25022"],
    "Bloomery": ["26817"],
    "Bloomingrose": ["25024"],
    "Blount": ["25025"],
    "Blue Creek": ["25026"],
    "Bluefield": ["24701"],
    "Bob White": ["25028"],
    "Bolt": ["25817"],
    "Bomont": ["25030"],
    "Boomer": ["25031"],
    "Borderland": ["25665"],
    "Bowden": ["26254"],
    "Bradley": ["25818"],
    "Bradshaw": ["24817"],
    "Bramwell": ["24715"],
    "Branchland": ["25506"],
    "Brandywine": ["26802"],
    "Breeden": ["25666"],
    "Brenton": ["24818"],
    "Bretz": ["26524"],
    "Bridgeport": ["26330"],
    "Brohard": ["26138"],
    "Bruceton Mills": ["26525"],
    "Bruno": ["25611"],
    "Buckeye": ["24924"],
    "Buckhannon": ["26201"],
    "Bud": ["24716"],
    "Buffalo": ["25033"],
    "Bunker Hill": ["25413"],
    "Burlington": ["26710"],
    "Burnsville": ["26335"],
    "Burton": ["26562"],
    "Cabin Creek": ["25035"],
    "Cabins": ["26855"],
    "Cairo": ["26337"],
    "Caldwell": ["24925"],
    "Calvin": ["26660"],
    "Camden": ["26338"],
    "Camden On Gauley": ["26208"],
    "Cameron": ["26033"],
    "Camp Creek": ["25820"],
    "Cannelton": ["25036"],
    "Canvas": ["26662"],
    "Capon Bridge": ["26711"],
    "Capon Springs": ["26823"],
    "Carolina": ["26563"],
    "Cass": ["24927"],
    "Cassville": ["26527"],
    "Cedar Grove": ["25039"],
    "Cedarville": ["26611"],
    "Center Point": ["26339"],
    "Ceredo": ["25507"],
    "Chapmanville": ["25508"],
    "Charles Town": ["25414"],
    "Charleston": ["25301", "25302", "25304", "25305", "25306", "25311", "25312", "25313", "25314", "25315", "25317", "25320", "25321", "25322", "25323", "25324", "25325", "25326", "25327", "25328", "25329", "25330", "25331", "25332", "25333", "25334", "25335", "25336", "25337", "25338", "25339", "25350", "25356", "25357", "25358", "25360", "25361", "25362", "25364", "25365", "25375", "25387", "25389", "25392", "25396"],
    "Charlton Heights": ["25040"],
    "Charmco": ["25958"],
    "Chattaroy": ["25667"],
    "Chauncey": ["25612"],
    "Chester": ["26034"],
    "Chloe": ["25235"],
    "Circleville": ["26804"],
    "Clarksburg": ["26301", "26302", "26306"],
    "Clay": ["25043"],
    "Clear Creek": ["25044"],
    "Clear Fork": ["24822"],
    "Clendenin": ["25045"],
    "Cleveland": ["26215"],
    "Clothier": ["25047"],
    "Coal City": ["25823"],
    "Coal Mountain": ["24823"],
    "Coalton": ["26257"],
    "Colcord": ["25048"],
    "Colfax": ["26566"],
    "Colliers": ["26035"],
    "Comfort": ["25049"],
    "Cool Ridge": ["25825"],
    "Copen": ["26615"],
    "Cora": ["25614"],
    "Corinne": ["25826"],
    "Costa": ["25051"],
    "Cottageville": ["25239"],
    "Covel": ["24719"],
    "Cowen": ["26206"],
    "Coxs Mills": ["26342"],
    "Crab Orchard": ["25827"],
    "Craigsville": ["26205"],
    "Crawford": ["26343"],
    "Crawley": ["24931"],
    "Creston": ["26141"],
    "Crum": ["25669"],
    "Cucumber": ["24826"],
    "Culloden": ["25510"],
    "Cyclone": ["24827"],
    "Dailey": ["26259"],
    "Dallas": ["26036"],
    "Danese": ["25831"],
    "Daniels": ["25832"],
    "Danville": ["25053"],
    "Davin": ["25617"],
    "Davis": ["26260"],
    "Davisville": ["26142"],
    "Davy": ["24828"],
    "Dawes": ["25054"],
    "Deep Water": ["25057"],
    "Delbarton": ["25670"],
    "Dellslow": ["26531"],
    "Delray": ["26714"],
    "Diana": ["26217"],
    "Dille": ["26617"],
    "Dingess": ["25671"],
    "Dixie": ["25059"],
    "Dorothy": ["25060"],
    "Dothan": ["25833"],
    "Drennen": ["26667"],
    "Dry Creek": ["25062"],
    "Drybranch": ["25061"],
    "Dryfork": ["26263"],
    "Duck": ["25063"],
    "Dunbar": ["25064"],
    "Dunlow": ["25511"],
    "Dunmore": ["24934"],
    "Durbin": ["26264"],
    "East Bank": ["25067"],
    "East Lynn": ["25512"],
    "Eccles": ["25836"],
    "Eckman": ["24829"],
    "Edgarton": ["25672"],
    "Edmond": ["25837"],
    "Eglon": ["26716"],
    "Elbert": ["24830"],
    "Eleanor": ["25070"],
    "Elizabeth": ["26143"],
    "Elk Garden": ["26717"],
    "Elkhorn": ["24831"],
    "Elkins": ["26241"],
    "Elkview": ["25071"],
    "Ellamore": ["26267"],
    "Ellenboro": ["26346"],
    "Elton": ["25965"],
    "Enterprise": ["26568"],
    "Erbacon": ["26203"],
    "Eskdale": ["25075"],
    "Ethel": ["25076"],
    "Evans": ["25241"],
    "Exchange": ["26619"],
    "Fairdale": ["25839"],
    "Fairlea": ["24902"],
    "Fairmont": ["26554", "26555"],
    "Fairview": ["26570"],
    "Falling Rock": ["25079"],
    "Falling Waters": ["25419"],
    "Fanrock": ["24834"],
    "Farmington": ["26571"],
    "Fayetteville": ["25840"],
    "Fenwick": ["26202"],
    "Fisher": ["26818"],
    "Flat Top": ["25841"],
    "Flatwoods": ["26621"],
    "Flemington": ["26347"],
    "Follansbee": ["26037"],
    "Folsom": ["26348"],
    "Forest Hill": ["24935"],
    "Fort Ashby": ["26719"],
    "Fort Gay": ["25514"],
    "Foster": ["25081"],
    "Four States": ["26572"],
    "Frametown": ["26623"],
    "Frankford": ["24938"],
    "Franklin": ["26807"],
    "Fraziers Bottom": ["25082"],
    "Freeman": ["24724"],
    "French Creek": ["26218"],
    "Frenchton": ["26219"],
    "Friendly": ["26146"],
    "Gallagher": ["25083"],
    "Gallipolis Ferry": ["25515"],
    "Galloway": ["26349"],
    "Gandeeville": ["25243"],
    "Gap Mills": ["24941"],
    "Gary": ["24836"],
    "Gassaway": ["26624"],
    "Gauley Bridge": ["25085"],
    "Gay": ["25244"],
    "Genoa": ["25517"],
    "Gerrardstown": ["25420"],
    "Ghent": ["25843"],
    "Gilbert": ["25621"],
    "Gilboa": ["26671"],
    "Given": ["25245"],
    "Glady": ["26268"],
    "Glasgow": ["25086"],
    "Glen": ["25088"],
    "Glen Dale": ["26038"],
    "Glen Daniel": ["25844"],
    "Glen Easton": ["26039"],
    "Glen Ferris": ["25090"],
    "Glen Fork": ["25845"],
    "Glen Jean": ["25846"],
    "Glen Rogers": ["25848"],
    "Glen White": ["25849"],
    "Glengary": ["25421"],
    "Glenville": ["26351"],
    "Glenwood": ["25520"],
    "Gordon": ["25093"],
    "Gormania": ["26720"],
    "Grafton": ["26354"],
    "Grant Town": ["26574"],
    "Grantsville": ["26147"],
    "Granville": ["26534"],
    "Grassy Meadows": ["24943"],
    "Great Cacapon": ["25422"],
    "Green Bank": ["24944"],
    "Green Spring": ["26722"],
    "Green Sulphur Springs": ["25966"],
    "Greenville": ["24945"],
    "Griffithsville": ["25521"],
    "Gypsy": ["26361"],
    "Hacker Valley": ["26222"],
    "Halltown": ["25423"],
    "Hambleton": ["26269"],
    "Hamlin": ["25523"],
    "Handley": ["25102"],
    "Hanover": ["24839"],
    "Hansford": ["25103"],
    "Harman": ["26270"],
    "Harper": ["25851"],
    "Harpers Ferry": ["25425"],
    "Harrisville": ["26362"],
    "Hartford": ["25247"],
    "Harts": ["25524"],
    "Haywood": ["26366"],
    "Heaters": ["26627"],
    "Hedgesville": ["25427"],
    "Helen": ["25853"],
    "Helvetia": ["26224"],
    "Hemphill": ["24842"],
    "Henderson": ["25106"],
    "Hendricks": ["26271"],
    "Henlawson": ["25624"],
    "Hensley": ["24843"],
    "Hepzibah": ["26369"],
    "Herndon": ["24726"],
    "Hernshaw": ["25107"],
    "Hewett": ["25108"],
    "Hiawatha": ["24729"],
    "Hico": ["25854"],
    "High View": ["26808"],
    "Hillsboro": ["24946"],
    "Hilltop": ["25855"],
    "Hinton": ["25951"],
    "Holden": ["25625"],
    "Hometown": ["25109"],
    "Horner": ["26372"],
    "Hugheston": ["25110"],
    "Hundred": ["26575"],
    "Huntington": ["25701", "25702", "25703", "25704", "25705", "25706", "25707", "25708", "25709", "25710", "25711", "25712", "25713", "25714", "25715", "25716", "25717", "25718", "25719", "25720", "25721", "25722", "25723", "25724", "25725", "25726", "25727", "25728", "25729", "25755", "25770", "25771", "25772", "25773", "25774", "25775", "25776", "25777", "25778", "25779"],
    "Hurricane": ["25526"],
    "Huttonsville": ["26273"],
    "Iaeger": ["24844"],
    "Idamay": ["26576"],
    "Ikes Fork": ["24845"],
    "Independence": ["26374"],
    "Indore": ["25111"],
    "Institute": ["25112"],
    "Inwood": ["25428"],
    "Ireland": ["26376"],
    "Isaban": ["24846"],
    "Itmann": ["24847"],
    "Ivydale": ["25113"],
    "Jacksonburg": ["26377"],
    "Jane Lew": ["26378"],
    "Jeffrey": ["25114"],
    "Jenkinjones": ["24848"],
    "Jesse": ["24849"],
    "Jolo": ["24850"],
    "Josephine": ["25857"],
    "Julian": ["25529"],
    "Jumping Branch": ["25969"],
    "Junior": ["26275"],
    "Justice": ["24851"],
    "Kanawha Falls": ["25115"],
    "Kanawha Head": ["26228"],
    "Kearneysville": ["25430"],
    "Kegley": ["24731"],
    "Kellysville": ["24732"],
    "Kenna": ["25248"],
    "Kenova": ["25530"],
    "Kerens": ["26276"],
    "Kermit": ["25674"],
    "Keslers Cross Lanes": ["26675"],
    "Keyser": ["26726"],
    "Kiahsville": ["25534"],
    "Kimball": ["24853"],
    "Kimberly": ["25118"],
    "Kincaid": ["25119"],
    "Kingmont": ["26578"],
    "Kingwood": ["26537"],
    "Kistler": ["25628"],
    "Kopperston": ["24854"],
    "Kyle": ["24855"],
    "Lahmansville": ["26731"],
    "Lake": ["25121"],
    "Lanark": ["25860"],
    "Lansing": ["25862"],
    "Lashmeet": ["24733"],
    "Lavalette": ["25535"],
    "Layland": ["25864"],
    "Le Roy": ["25252"],
    "Left Hand": ["25251"],
    "Leivasy": ["26676"],
    "Lenore": ["25676"],
    "Leon": ["25123"],
    "Lerona": ["25971"],
    "Lesage": ["25537"],
    "Leslie": ["25972"],
    "Lester": ["25865"],
    "Letart": ["25253"],
    "Levels": ["25431"],
    "Lewisburg": ["24901"],
    "Liberty": ["25124"],
    "Lindside": ["24951"],
    "Linn": ["26384"],
    "Little Birch": ["26629"],
    "Littleton": ["26581"],
    "Lizemores": ["25125"],
    "Lochgelly": ["25866"],
    "Logan": ["25601"],
    "London": ["25126"],
    "Lookout": ["25868"],
    "Looneyville": ["25259"],
    "Lorado": ["25630"],
    "Lorentz": ["26229"],
    "Lost City": ["26810"],
    "Lost Creek": ["26385"],
    "Lumberport": ["26386"],
    "Lyburn": ["25632"],
    "Lynco": ["24857"],
    "Maben": ["25870"],
    "Mabie": ["26278"],
    "Mabscott": ["25871"],
    "Mac Arthur": ["25873"],
    "Macfarlan": ["26148"],
    "Madison": ["25130"],
    "Maidsville": ["26541"],
    "Mallory": ["25634"],
    "Mammoth": ["25132"],
    "Man": ["25635"],
    "Mannington": ["26582"],
    "Marianna": ["24859"],
    "Marlinton": ["24954"],
    "Martinsburg": ["25401", "25402", "25403", "25404", "25405", "25429"],
    "Mason": ["25260"],
    "Masontown": ["26542"],
    "Matewan": ["25678"],
    "Matheny": ["24860"],
    "Mathias": ["26812"],
    "Matoaka": ["24736"],
    "Maxwelton": ["24957"],
    "Maybeury": ["24861"],
    "Maysel": ["25133"],
    "Maysville": ["26833"],
    "Mc Graws": ["25875"],
    "Mcmechen": ["26040"],
    "Meadow Bridge": ["25976"],
    "Meadow Creek": ["25977"],
    "Meadowbrook": ["26404"],
    "Metz": ["26585"],
    "Miami": ["25134"],
    "Middlebourne": ["26149"],
    "Midkiff": ["25540"],
    "Midway": ["25878"],
    "Milam": ["26838"],
    "Mill Creek": ["26280"],
    "Millstone": ["25261"],
    "Millville": ["25432"],
    "Millwood": ["25262"],
    "Milton": ["25541"],
    "Minden": ["25879"],
    "Mineral Wells": ["26120", "26121", "26150"],
    "Moatsville": ["26405"],
    "Mohawk": ["24862"],
    "Montana Mines": ["26586"],
    "Montcalm": ["24737"],
    "Monterville": ["26282"],
    "Montgomery": ["25136"],
    "Montrose": ["26283"],
    "Moorefield": ["26836"],
    "Morgantown": ["26501", "26502", "26504", "26505", "26506", "26507", "26508"],
    "Moundsville": ["26041"],
    "Mount Alto": ["25264"],
    "Mount Carbon": ["25139"],
    "Mount Clare": ["26408"],
    "Mount Gay": ["25637"],
    "Mount Hope": ["25880", "25888"],
    "Mount Lookout": ["26678"],
    "Mount Nebo": ["26679"],
    "Mount Olive": ["25185"],
    "Mount Storm": ["26739"],
    "Mount Zion": ["26151"],
    "Mullens": ["25882"],
    "Munday": ["26152"],
    "Myra": ["25544"],
    "Nallen": ["26680"],
    "Naoma": ["25140"],
    "Napier": ["26631"],
    "Naugatuck": ["25685"],
    "Nebo": ["25141"],
    "Nellis": ["25142"],
    "Nemours": ["24738"],
    "Nettie": ["26681"],
    "New Creek": ["26743"],
    "New Cumberland": ["26047"],
    "New Haven": ["25265"],
    "New Manchester": ["26056"],
    "New Martinsville": ["26155"],
    "New Milton": ["26411"],
    "New Richmond": ["24867"],
    "Newburg": ["26410"],
    "Newell": ["26050"],
    "Newhall": ["24866"],
    "Newton": ["25266"],
    "Newtown": ["25686"],
    "Nimitz": ["25978"],
    "Nitro": ["25143"],
    "Normantown": ["25267"],
    "North Matewan": ["25688"],
    "North Spring": ["24869"],
    "Northfork": ["24868"],
    "Norton": ["26285"],
    "Oak Hill": ["25901"],
    "Oceana": ["24870"],
    "Odd": ["25902"],
    "Old Fields": ["26845"],
    "Omar": ["25638"],
    "Ona": ["25545"],
    "Onego": ["26886"],
    "Orgas": ["25148"],
    "Orlando": ["26412"],
    "Orma": ["25268"],
    "Osage": ["26543"],
    "Ottawa": ["25149"],
    "Paden City": ["26159"],
    "Page": ["25152"],
    "Pageton": ["24871"],
    "Palestine": ["26160"],
    "Panther": ["24872"],
    "Parkersburg": ["26101", "26102", "26103", "26104", "26106"],
    "Parsons": ["26287"],
    "Paw Paw": ["25434"],
    "Pax": ["25904"],
    "Paynesville": ["24873"],
    "Peach Creek": ["25639"],
    "Pecks Mill": ["25547"],
    "Pence Springs": ["24962"],
    "Pennsboro": ["26415"],
    "Pentress": ["26544"],
    "Petersburg": ["26847"],
    "Peterstown": ["24963"],
    "Petroleum": ["26161"],
    "Peytona": ["25154"],
    "Philippi": ["26416"],
    "Pickens": ["26230"],
    "Piedmont": ["26750"],
    "Pinch": ["25156"],
    "Pine Grove": ["26419"],
    "Pineville": ["24874"],
    "Piney View": ["25906"],
    "Pipestem": ["25979"],
    "Poca": ["25159"],
    "Point Pleasant": ["25550"],
    "Points": ["25437"],
    "Pond Gap": ["25160"],
    "Pool": ["26684"],
    "Porters Falls": ["26162"],
    "Powellton": ["25161"],
    "Pratt": ["25162"],
    "Premier": ["24878"],
    "Prichard": ["25555"],
    "Prince": ["25907"],
    "Princeton": ["24739", "24740"],
    "Princewick": ["25908"],
    "Procious": ["25164"],
    "Proctor": ["26055"],
    "Prosperity": ["25909"],
    "Pullman": ["26421"],
    "Purgitsville": ["26852"],
    "Pursglove": ["26546"],
    "Quinwood": ["25981"],
    "Rachel": ["26587"],
    "Racine": ["25165"],
    "Ragland": ["25690"],
    "Rainelle": ["25962"],
    "Raleigh": ["25911"],
    "Ranger": ["25557"],
    "Ranson": ["25438"],
    "Ravencliff": ["25913"],
    "Ravenswood": ["26164"],
    "Rawl": ["25691"],
    "Raysal": ["24879"],
    "Reader": ["26167"],
    "Red Creek": ["26289"],
    "Red House": ["25168"],
    "Red Jacket": ["25692"],
    "Reedsville": ["26547"],
    "Reedy": ["25270"],
    "Renick": ["24966"],
    "Reynoldsville": ["26422"],
    "Rhodell": ["25915"],
    "Richwood": ["26261"],
    "Ridgeley": ["26753"],
    "Ridgeview": ["25169"],
    "Ridgeway": ["25440"],
    "Rio": ["26755"],
    "Ripley": ["25271"],
    "Rippon": ["25441"],
    "Riverton": ["26814"],
    "Rivesville": ["26588"],
    "Robson": ["25173"],
    "Rock": ["24747"],
    "Rock Cave": ["26234"],
    "Rock Creek": ["25174"],
    "Rock View": ["24880"],
    "Rockport": ["26169"],
    "Roderfield": ["24881"],
    "Romney": ["26757"],
    "Ronceverte": ["24970"],
    "Rosedale": ["26636"],
    "Rosemont": ["26424"],
    "Rowlesburg": ["26425"],
    "Rupert": ["25984"],
    "Sabine": ["25916"],
    "Saint Albans": ["25177"],
    "Saint Marys": ["26170"],
    "Salem": ["26426"],
    "Salt Rock": ["25559"],
    "Sand Fork": ["26430"],
    "Sandstone": ["25985"],
    "Sandyville": ["25275"],
    "Sarah Ann": ["25644"],
    "Saulsville": ["25876"],
    "Saxon": ["25180"],
    "Scarbro": ["25917"],
    "Scott Depot": ["25560"],
    "Secondcreek": ["24974"],
    "Selbyville": ["26236"],
    "Seneca Rocks": ["26884"],
    "Seth": ["25181"],
    "Shady Spring": ["25918"],
    "Shanks": ["26761"],
    "Sharples": ["25183"],
    "Shenandoah Junction": ["25442"],
    "Shepherdstown": ["25443"],
    "Shinnston": ["26431"],
    "Shirley": ["26434"],
    "Shoals": ["25562"],
    "Shock": ["26638"],
    "Short Creek": ["26058"],
    "Simon": ["24882"],
    "Simpson": ["26435"],
    "Sinks Grove": ["24976"],
    "Sistersville": ["26175"],
    "Skelton": ["25919"],
    "Slab Fork": ["25920"],
    "Slanesville": ["25444"],
    "Slatyfork": ["26291"],
    "Smithburg": ["26436"],
    "Smithers": ["25186"],
    "Smithfield": ["26437"],
    "Smithville": ["26178"],
    "Smoot": ["24977"],
    "Snowshoe": ["26209"],
    "Sod": ["25564"],
    "Sophia": ["25921"],
    "South Charleston": ["25303", "25309"],
    "Southside": ["25187"],
    "Spanishburg": ["25922"],
    "Spelter": ["26438"],
    "Spencer": ["25276"],
    "Spring Dale": ["25986"],
    "Springfield": ["26763"],
    "Spurlockville": ["25565"],
    "Squire": ["24884"],
    "Stanaford": ["25927"],
    "Stephenson": ["25928"],
    "Stollings": ["25646"],
    "Sugar Grove": ["26815"],
    "Sumerco": ["25567"],
    "Summersville": ["26651"],
    "Summit Point": ["25446"],
    "Surveyor": ["25932"],
    "Sutton": ["26601"],
    "Swiss": ["26690"],
    "Switchback": ["24887"],
    "Switzer": ["25647"],
    "Sylvester": ["25193"],
    "Tad": ["25201"],
    "Talcott": ["24981"],
    "Tallmansville": ["26237"],
    "Teays": ["25569"],
    "Terra Alta": ["26764"],
    "Thomas": ["26292"],
    "Thornton": ["26440"],
    "Thorpe": ["24888"],
    "Thurmond": ["25936"],
    "Tioga": ["26691"],
    "Tornado": ["25202"],
    "Triadelphia": ["26059"],
    "Troy": ["26443"],
    "Tunnelton": ["26444"],
    "Turtle Creek": ["25203"],
    "Twilight": ["25204"],
    "Uneeda": ["25205"],
    "Union": ["24983"],
    "Upper Tract": ["26866"],
    "Upperglade": ["26266"],
    "Valley Bend": ["26293"],
    "Valley Grove": ["26060"],
    "Valley Head": ["26294"],
    "Van": ["25206"],
    "Varney": ["25696"],
    "Verdunville": ["25649"],
    "Verner": ["25650"],
    "Victor": ["25938"],
    "Vienna": ["26105"],
    "Volga": ["26238"],
    "Waiteville": ["24984"],
    "Walker": ["26180"],
    "Walkersville": ["26447"],
    "Wallace": ["26448"],
    "Wallback": ["25285"],
    "Walton": ["25286"],
    "Wana": ["26590"],
    "War": ["24892"],
    "Wardensville": ["26851"],
    "Warriormine": ["24894"],
    "Washington": ["26181"],
    "Waverly": ["26184"],
    "Wayne": ["25570"],
    "Wayside": ["24985"],
    "Webster Springs": ["26288"],
    "Weirton": ["26062"],
    "Welch": ["24801"],
    "Wellsburg": ["26070"],
    "West Columbia": ["25287"],
    "West Hamlin": ["25571"],
    "West Liberty": ["26074"],
    "West Milford": ["26451"],
    "West Union": ["26456"],
    "Weston": ["26452"],
    "Wharncliffe": ["25651"],
    "Wharton": ["25208"],
    "Wheeling": ["26003"],
    "White Oak": ["25989"],
    "White Sulphur Springs": ["24961", "24986"],
    "Whitesville": ["25209"],
    "Whitman": ["25652"],
    "Whitmer": ["26296"],
    "Widen": ["25211"],
    "Wilcoe": ["24895"],
    "Wiley Ford": ["26767"],
    "Wilkinson": ["25653"],
    "Williamsburg": ["24991"],
    "Williamson": ["25661"],
    "Williamstown": ["26187"],
    "Wilsonburg": ["26461"],
    "Wilsondale": ["25699"],
    "Windsor Heights": ["26075"],
    "Winfield": ["25213"],
    "Winifrede": ["25214"],
    "Winona": ["25942"],
    "Wolfcreek": ["24993"],
    "Wolfe": ["24751"],
    "Woodville": ["25572"],
    "Worthington": ["26591"],
    "Wyatt": ["26463"],
    "Wyco": ["25943"],
    "Wyoming": ["24898"],
    "Yawkey": ["25573"],
    "Yellow Spring": ["26865"],
    "Yolyn": ["25654"]
  },
  "WY": {
    "Afton": ["83110"],
    "Aladdin": ["82710"],
    "Albin": ["82050"],
    "Alcova": ["82620"],
    "Alpine": ["83128"],
    "Alta": ["83414"],
    "Alva": ["82711"],
    "Arapahoe": ["82510"],
    "Arminto": ["82630"],
    "Arvada": ["82831"],
    "Auburn": ["83111"],
    "Baggs": ["82321"],
    "Bairoil": ["82322"],
    "Banner": ["82832"],
    "Basin": ["82410"],
    "Bedford": ["83112"],
    "Beulah": ["82712"],
    "Big Horn": ["82833"],
    "Big Piney": ["83113"],
    "Bondurant": ["82922"],
    "Bosler": ["82051"],
    "Boulder": ["82923"],
    "Buffalo": ["82834"],
    "Buford": ["82052"],
    "Burlington": ["82411"],
    "Burns": ["82053"],
    "Byron": ["82412"],
    "Carpenter": ["82054"],
    "Casper": ["82601", "82602", "82604", "82605", "82609"],
    "Centennial": ["82055"],
    "Cheyenne": ["82001", "82002", "82003", "82006", "82007", "82008", "82009", "82010"],
    "Chugwater": ["82210"],
    "Clearmont": ["82835"],
    "Cody": ["82414"],
    "Cokeville": ["83114"],
    "Cora": ["82925"],
    "Cowley": ["82420"],
    "Crowheart": ["82512"],
    "Daniel": ["83115"],
    "Dayton": ["82836"],
    "Deaver": ["82421"],
    "Devils Tower": ["82714"],
    "Diamondville": ["83116"],
    "Dixon": ["82323"],
    "Douglas": ["82633"],
    "Dubois": ["82513"],
    "Edgerton": ["82635"],
    "Elk Mountain": ["82324"],
    "Emblem": ["82422"],
    "Encampment": ["82325"],
    "Etna": ["83118"],
    "Evanston": ["82930", "82931"],
    "Evansville": ["82636"],
    "Fairview": ["83119"],
    "Farson": ["82932"],
    "Fe Warren AFB": ["82005"],
    "Fort Bridger": ["82933"],
    "Fort Laramie": ["82212"],
    "Fort Washakie": ["82514"],
    "Four Corners": ["82715"],
    "Frannie": ["82423"],
    "Freedom": ["83120"],
    "Frontier": ["83121"],
    "Garrett": ["82058"],
    "Gillette": ["82716", "82717", "82718"],
    "Glendo": ["82213"],
    "Glenrock": ["82637"],
    "Granger": ["82934"],
    "Granite Canon": ["82059"],
    "Green River": ["82935"],
    "Greybull": ["82426"],
    "Grover": ["83122"],
    "Guernsey": ["82214"],
    "Hanna": ["82327"],
    "Hartville": ["82215"],
    "Hawk Springs": ["82217"],
    "Hiland": ["82638"],
    "Hillsdale": ["82060"],
    "Horse Creek": ["82061"],
    "Hudson": ["82515"],
    "Hulett": ["82720"],
    "Huntley": ["82218"],
    "Hyattville": ["82428"],
    "Jackson": ["83001", "83002"],
    "Jay Em": ["82219"],
    "Jeffrey City": ["82310"],
    "Jelm": ["82063"],
    "Kaycee": ["82639"],
    "Kelly": ["83011"],
    "Kemmerer": ["83101"],
    "Kinnear": ["82516"],
    "Kirby": ["82430"],
    "La Barge": ["83123"],
    "Lagrange": ["82221"],
    "Lance Creek": ["82222"],
    "Lander": ["82520"],
    "Laramie": ["82070", "82071", "82072", "82073"],
    "Leiter": ["82837"],
    "Linch": ["82640"],
    "Lingle": ["82223"],
    "Little America": ["82929"],
    "Lonetree": ["82936"],
    "Lost Springs": ["82224"],
    "Lovell": ["82431"],
    "Lusk": ["82225"],
    "Lyman": ["82937"],
    "Lysite": ["82642"],
    "Manderson": ["82432"],
    "Manville": ["82227"],
    "Mc Kinnon": ["82938"],
    "Medicine Bow": ["82329"],
    "Meeteetse": ["82433"],
    "Meriden": ["82081"],
    "Midwest": ["82643"],
    "Mills": ["82644"],
    "Moorcroft": ["82721"],
    "Moose": ["83012"],
    "Moran": ["83013"],
    "Mountain View": ["82939"],
    "Natrona": ["82646"],
    "Newcastle": ["82701"],
    "Opal": ["83124"],
    "Osage": ["82723"],
    "Otto": ["82434"],
    "Parkman": ["82838"],
    "Pavillion": ["82523"],
    "Pine Bluffs": ["82082"],
    "Pinedale": ["82941"],
    "Point Of Rocks": ["82942"],
    "Powder River": ["82648"],
    "Powell": ["82435"],
    "Ralston": ["82440"],
    "Ranchester": ["82839"],
    "Rawlins": ["82301"],
    "Recluse": ["82725"],
    "Reliance": ["82943"],
    "Riverton": ["82501"],
    "Robertson": ["82944"],
    "Rock River": ["82083"],
    "Rock Springs": ["82901", "82902"],
    "Rozet": ["82727"],
    "Saddlestring": ["82840"],
    "Saint Stephens": ["82524"],
    "Saratoga": ["82331"],
    "Savery": ["82332"],
    "Shawnee": ["82229"],
    "Shell": ["82441"],
    "Sheridan": ["82801"],
    "Shirley Basin": ["82615"],
    "Shoshoni": ["82649"],
    "Sinclair": ["82334"],
    "Smoot": ["83126"],
    "Story": ["82842"],
    "Sundance": ["82729"],
    "Superior": ["82945"],
    "Ten Sleep": ["82442"],
    "Teton Village": ["83025"],
    "Thayne": ["83127"],
    "Thermopolis": ["82443"],
    "Tie Siding": ["82084"],
    "Torrington": ["82240"],
    "Upton": ["82730"],
    "Van Tassell": ["82242"],
    "Veteran": ["82243"],
    "Walcott": ["82335"],
    "Wamsutter": ["82336"],
    "Wapiti": ["82450"],
    "Weston": ["82731"],
    "Wheatland": ["82201"],
    "Wilson": ["83014"],
    "Wolf": ["82844"],
    "Worland": ["82401"],
    "Wright": ["82732"],
    "Wyarno": ["82845"],
    "Yellowstone National Park": ["82190"],
    "Yoder": ["82244"]
  },
};
